import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import RepPortal, { SHARED_INVOICES, SHARED_MATERIAL_ORDERS } from './RepPortal';
import { emailSignup, emailMaterialOrder, emailWelcome, emailBroadcast, emailOrderPlaced, emailOrderCompleted, emailRepOrderNotify, emailRepAssigned, emailRepChanged, emailOrderShipped, emailPaymentReminder, emailPaymentOverdue, emailNewTrainingVideo } from './email';
import { ShopCertification, AdminCertificationTab } from './CertPortal';
import { signIn, signUp, signOut, onAuthStateChange, getProfile, getAllProfiles, approveUser, rejectUser, updateProfile, saveProfileMetadata, setRepCommissionRate, getRepCommissionRates, savePortalOrder, getAllPortalOrders, updatePortalOrderShipping, subscribePortalOrders, saveCustomerAssignment, getCustomerAssignment, getAllCustomerAssignments, savePortalProducts, getPortalProducts, subscribePortalProducts, getWarehouseStock, getWarehouseStockChecked, getInventoryMovementsChecked, getAllPortalOrdersChecked, assignInventoryToRep, returnInventoryFromRep, adjustRepInventory, adjustWarehouseStock, subscribeToInventoryChanges, sendPasswordReset, updatePassword, supabase, changeAccountRole, listRepCommissionPayments, markInvoicesCommissionPaid, unmarkInvoiceCommissionPaid, subscribeRepCommissionPayments, listRepRouteCustomers, upsertRepRouteCustomer, deactivateRepRouteCustomer, subscribeRepRouteCustomers, listShopVisits, subscribeShopVisits, listMaterialOrders, upsertMaterialOrder, subscribeMaterialOrders, markMaterialOrderShipped, getPortalSettings, savePortalSettings, listAllRepRouteCustomers, subscribeAllRepRouteCustomers, listInventoryRequests, approveInventoryRequest, rejectInventoryRequest, subscribeInventoryRequests, listInvoiceVoidRequests, approveInvoiceVoidRequest, rejectInvoiceVoidRequest, subscribeInvoiceVoidRequests, listTrainingVideos, upsertTrainingVideo, deleteTrainingVideo, subscribeTrainingVideos, listAdminAlertLog, claimAdminAlert, softDeleteProfile, softPauseProfile, restoreProfile, insertOrderRemoval } from './supabase';
import { useOrderRemovals, useAdminVisibleInvoices, applyLocalRemovalEvent } from "./adminOrderRemovals";
import { listAdjustmentRequests, approveAdjustmentRequest, rejectAdjustmentRequest, subscribeAdjustmentRequests, isAdjustmentRequestApplied, listCommissionPaidInvoiceIds } from "./supabase";
import { diffItems, parseItems as parseInvItems, statusClass, applyInProgressByFields, buildProposedItems, recomputeTotal, extrasFromInvoice } from "./invoiceAdjustments";
import { invoiceDiscountFields, formatPct } from "./invoiceDiscount";
import { performAdminAdjust, notifyRepInvoiceChanged, commissionSentenceForRep, repEmailSentence } from "./adminAdjust";
import { preflightCorrectionState, isLegacyPaid } from "./commissionPreflight";
import { adminAdjustBlockReason, expandCatalogForPicker, commissionEffect } from "./adminAdjustPure";
import { validateVoidReason, isInvoiceRemoved, snapshotForRefund, refundPlan, cancelledWithoutRefundRecord } from "./orderRemovals";
import { performAdminVoid, voidedInDb as adminVoidedInDb, voidLocalOnly } from "./adminVoid";
import { recordCorrectionAfterAction } from "./commissionAfterAction";
import { listRemittances, subscribeRemittances, getActiveRemittanceForInvoiceStrict } from "./supabase";
import { REMIT_PAID_VIA, isRepInvoice, methodLabel, remittancePill, remittancePaidLabel, matchesRemitFilter, ORDERS_REMIT_FILTERS, activeRemittanceMap, activeRemittanceIds, voidRemittanceGate, overlayRemittanceState, requestRemittanceWarning, gateAckKey } from "./repRemittances";
import { useRemittanceList, useActiveRemittance, RemittanceSummaryLine, RemitBadge, PayoutRemitGate, payoutRemitGate, RepRemittanceSection } from "./remittanceUi";
import { createFetchGate, createDebounced, subscribeLocalRemittanceChange } from "./remittanceSync";
import SHARED_SETTINGS from './sharedSettings';
import SHARED_VISITS from './sharedVisits';
import SHARED_REP_PROFILES from './sharedRepProfiles';
import ChangeLoginEmail from './ChangeLoginEmail';
import PORTAL_SETTINGS, { PORTAL_DEFAULTS } from './portalSettings';
import ImageUploader from './ImageUploader';
import ProductVideo from './ProductVideo';
import { uploadAvatar } from './imageUpload';
import SHARED_CUSTOMER_PROFILES from './sharedCustomerProfiles';
import SHARED_REP_CUSTOMERS from './sharedRepCustomers';
import SHARED_PRODUCTS from "./sharedProducts";
import { repInventoryRows, inventoryTotals, dedupeInvoicesById, normSku, REP_LEDGER_TYPES, createOwnerResolver, unattributedInvoices, buildRepIdentity, overlayRepProfiles, mergeFreshInvoices, freshInvoiceChanges, flattenCatalogForPicker, indexCatalog } from "./inventoryMath";
import { inventoryCatalog } from "./inventoryCatalog";
import { createRefreshCoordinator, attachFreshness } from "./refreshCoordinator";
import { filterRepInvoices, computeRepMetrics, computeCustomerMetrics, collectRepCustomerNames, groupInvoicesByMonth, deriveInvoiceDisplayStatus, displayStatusLabel, displayStatusPillStyle, partitionPeriodByPaidInvoices, batchizeRepInvoices } from "./repMetrics";
import { useCommissionLedger, CorrectionsCard, CorrectionsPayoutSection, CorrectionOnlyModal, CorrectionScanCard, describePayoutResult, runCommissionPayout, currentAdminIdentity } from "./commissionLedgerUi";
import { repCorrectionSummary, adminCorrectionTotals, frozenBatchLines, correctionOnlySettlements, settlementBatches, fmtSignedMoney } from "./commissionCorrectionsView";
import { findNeededCorrections, computeCorrection } from "./commissionCorrections";
import { checkUndoAllowed, undoScopeFromRows } from "./commissionPayout";
import { listCorrections, listCommissionPaymentsPaged, listPendingRequestsForInvoiceStrict } from "./supabase";
import ErrorBoundary from "./ErrorBoundary";
import { canOfferDelete, isBlockedStatus, normStatus, editSaveGuard, pickerBlockedRepEmailSet, pickerBlockedRepNameSet } from "./accountLifecycle";
import { deactivateRepRouteCustomerStrict, fetchFreshProfile } from './supabase';
import { AdminCreateInvoiceModal } from "./adminInvoiceUi";
import { isEligibleDealerAccount, HOUSE_REP_LABEL, displayRepStamp, isInvoiceOfDealer, isMadeByRep, isMadeByOfficeOrRep } from "./adminInvoicePure";
import { repNameKnown, deriveAccountStatus, lifecycleFieldsFromProfile, mergeLiveOverride, inactiveRepAccounts, inactiveRepEmailSet, inactiveRepNameSet, inactiveRepStatusMap, dealerHasInactiveRep, dealerInactiveRepStatus, buildArchive, mergeArchiveWithSnapshot, resolveRepIdByName, lifecycleBlockReason, canOfferLifecycle } from "./accountLifecycle";
// legacy-seed-ref — catalogSeed is the ONE-TIME migration source and the reference
// fallback for a handful of demo/showcase surfaces (home featured cards, cart
// demo, public catalog category labels). Live admin data lives in Supabase only.
// See src/seeds/catalogSeed.js for the rules on reading from this module.
import { PRODUCTS, ALL_PRODUCTS, KITS } from './seeds/catalogSeed';

const C = {
  navy:"#0B1F3A",navyMid:"#12305A",blue:"#1560BD",blueMid:"#1A73E8",
  blueLight:"#E8F0FE",teal:"#0D7A5F",tealLight:"#E0F4EE",
  amber:"#B45309",amberLight:"#FEF3C7",red:"#B91C1C",redLight:"#FEE2E2",
  ink:"#0F172A",inkMid:"#334155",inkLight:"#64748B",
  green:"#059669",greenLight:"#D1FAE5",
  purple:"#7C3AED",purpleLight:"#EDE9FE",
  border:"#E2E8F0",surface:"#F8FAFC",white:"#FFFFFF",
  tealBg:"rgba(13,122,95,0.12)",
};

const S = {
  app:{ fontFamily:"'DM Sans',system-ui,sans-serif", background:C.surface, minHeight:"100vh", color:C.ink },
  shell:{ display:"grid", gridTemplateColumns:"220px 1fr", minHeight:"100vh" },
  sidebar:{ background:C.navy, display:"flex", flexDirection:"column" },
  sidebarLogo:{ padding:"22px 18px 16px", borderBottom:"1px solid rgba(255,255,255,0.08)" },
  navItem:{ display:"flex", alignItems:"center", gap:9, padding:"8px 18px", fontSize:13, color:"rgba(255,255,255,0.6)", cursor:"pointer", borderLeft:"3px solid transparent" },
  navActive:{ color:C.white, background:"rgba(255,255,255,0.08)", borderLeft:`3px solid ${C.blueMid}` },
  navDiv:{ height:1, background:"rgba(255,255,255,0.08)", margin:"4px 0" },
  catLabel:{ fontSize:10, color:"rgba(255,255,255,0.3)", padding:"10px 18px 4px", letterSpacing:"0.06em", textTransform:"uppercase" },
  prodLink:{ display:"flex", alignItems:"center", gap:8, padding:"6px 18px 6px 28px", fontSize:12, color:"rgba(255,255,255,0.55)", cursor:"pointer" },
  prodLinkActive:{ color:C.white, background:"rgba(255,255,255,0.07)", fontWeight:500 },
  sideFooter:{ marginTop:"auto", padding:"14px 16px", borderTop:"1px solid rgba(255,255,255,0.08)" },
  main:{ display:"flex", flexDirection:"column", overflow:"hidden" },
  topbar:{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"0 24px", height:54, display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0 },
  content:{ flex:1, overflowY:"auto", padding:24 },
  card:{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, overflow:"hidden", marginBottom:16 },
  cardHdr:{ padding:"13px 18px", borderBottom:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" },
  cardTitle:{ fontSize:13, fontWeight:600, color:C.ink },
  metrics:{ display:"grid", gridTemplateColumns:"repeat(5,minmax(0,1fr))", gap:12, marginBottom:16 },
  metric:{ background:C.white, border:`1px solid ${C.border}`, borderRadius:10, padding:"14px 16px" },
  mLabel:{ fontSize:11, color:C.inkLight, marginBottom:4 },
  mValue:{ fontSize:20, fontWeight:600, color:C.ink },
  mSub:{ fontSize:11, color:C.inkLight, marginTop:2 },
  twoCol:{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 },
  threeCol:{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12 },
  fg:{ marginBottom:14 },
  label:{ display:"block", fontSize:12, fontWeight:500, color:C.inkMid, marginBottom:5 },
  input:{ width:"100%", padding:"9px 12px", border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, color:C.ink, background:C.white, outline:"none", boxSizing:"border-box" },
  select:{ width:"100%", padding:"9px 12px", border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, color:C.ink, background:C.white, outline:"none", boxSizing:"border-box" },
  btnPrimary:{ background:C.blue, color:C.white, border:"none", padding:"10px 20px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer" },
  btnSecondary:{ background:"transparent", color:C.ink, border:`1px solid ${C.border}`, padding:"9px 16px", borderRadius:8, fontSize:13, cursor:"pointer" },
  btnSmall:{ background:C.blueLight, color:C.blue, border:"none", padding:"5px 11px", borderRadius:6, fontSize:11, fontWeight:500, cursor:"pointer" },
  btnGhost:{ background:"none", border:"none", color:C.blue, fontSize:12, cursor:"pointer", padding:0 },
  pillBlue:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:"#EFF6FF", color:"#1D4ED8" },
  pillGreen:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.tealLight, color:C.teal },
  pillAmber:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.amberLight, color:C.amber },
  pillRed:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.redLight, color:C.red },
  pillGray:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:"#F3F4F6", color:"#374151" },
  pillPurple:{ fontSize:10, fontWeight:500, padding:"2px 8px", borderRadius:8, background:C.purpleLight, color:C.purple },
  btnSuccess:{ background:C.teal, color:C.white, border:"none", padding:"10px 20px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer" },
  btnDanger:{ background:C.red, color:C.white, border:"none", padding:"10px 20px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer" },
  modal:{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 },
  modalBox:{ background:C.white, borderRadius:14, padding:"28px 32px", width:520, maxHeight:"85vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" },
  qtyCtrl:{ display:"flex", alignItems:"center", border:`1px solid ${C.border}`, borderRadius:7, overflow:"hidden" },
  qtyBtn:{ width:28, height:28, background:C.surface, border:"none", cursor:"pointer", fontSize:15, color:C.ink, display:"flex", alignItems:"center", justifyContent:"center" },
  qtyVal:{ width:32, textAlign:"center", fontSize:13, fontWeight:500, background:C.white, borderLeft:`1px solid ${C.border}`, borderRight:`1px solid ${C.border}`, height:28, lineHeight:"28px", color:C.ink },
  signupPage:{ minHeight:"100vh", display:"flex", background:`linear-gradient(135deg,${C.navy} 0%,${C.navyMid} 60%,#1a3a6b 100%)` },
  signupLeft:{ flex:"0 0 400px", display:"flex", flexDirection:"column", justifyContent:"center", padding:"48px 48px" },
  signupRight:{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:32 },
  signupForm:{ background:C.white, borderRadius:16, padding:"36px 40px", width:"100%", maxWidth:520 },
  secLabel:{ fontSize:11, fontWeight:600, color:C.inkLight, textTransform:"uppercase", letterSpacing:"0.06em", margin:"20px 0 10px", paddingBottom:6, borderBottom:`1px solid ${C.border}` },
  checkoutGrid:{ display:"grid", gridTemplateColumns:"1fr 320px", gap:20 },
  summaryBox:{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, padding:"18px 20px" },
};

// PRODUCTS / ALL_PRODUCTS / KITS are imported from ./seeds/catalogSeed at
// the top of this file. The hardcoded arrays were removed on 2026-04-15 to
// end the deploy-wipes-admin-edits bug. Live catalog data is in Supabase.

const CAT_LABELS = { fuel:"Fuel & engine", emissions:"Emissions & DPF", cleaning:"Cleaning & maintenance", steering:"Steering & transmission", accessories:"Accessories" };
// NOTE: SHARED_PRODUCTS is no longer seeded from hardcoded arrays at module
// load. The admin AppShell hydrates it from Supabase (portal_products) after
// auth. Seeding at module load caused the 800ms debounced save to overwrite
// Supabase with hardcoded defaults on every fresh load — which deleted admin
// edits on every deploy. That bug is permanently retired.

const ALL_TERMS = [
  {id:"cc",   label:"Credit card",         desc:"Visa, Mastercard, Amex — processed via Square"},
  {id:"ach",  label:"ACH / bank transfer", desc:"Direct bank transfer — no processing fees"},
  {id:"net15",label:"Net 15 terms",        desc:"Invoice due in 15 days"},
  {id:"net30",label:"Net 30 terms",        desc:"Invoice due in 30 days"},
  {id:"net60",label:"Net 60 terms",        desc:"Invoice due in 60 days — for established accounts"},
  {id:"check",label:"Check by mail",       desc:"Mail a paper check — invoice stays pending until funds clear"},
  {id:"wire", label:"Wire transfer",       desc:"For large orders over $5,000 — requires admin confirmation"},
];

// ── Terms normalizer ──
// profiles.terms (Supabase) and customer_settings.terms are sometimes stored
// as an array (new schema), sometimes as a JSON string '["cc","ach"]', and
// sometimes as a single string like "cc" or a CSV "cc,ach". Admin's
// Accounts list calls `ac.terms.join(", ")` and the edit modal calls
// `editData.terms.includes(...)` — any non-array value crashes the render
// and unmounts the whole admin tree (white screen — reproduced by a
// worker's laptop whose account profile had `terms: "cc"` stored as a
// string in Supabase).
//
// This helper normalizes every shape we've seen into an array. Returns
// null for empty/unparseable input so the caller can fall back to its
// own default (the existing `|| ["cc"]` pattern). NOT writing back to
// Supabase from here — next time admin saves the account the normalized
// array version goes back via saveCustomerAssignment, cleaning the data
// forward without touching every row at rest.
const _toTermsArray = (v) => {
  if (Array.isArray(v)) return v;
  if (v == null || v === "") return null;
  if (typeof v === "string") {
    const s = v.trim();
    if (!s) return null;
    if (s.startsWith("[")) {
      try { const a = JSON.parse(s); if (Array.isArray(a)) return a; } catch(e) {}
    }
    return s.split(",").map(x => x.trim()).filter(Boolean);
  }
  return null;
};

const INIT_ACCOUNTS = [
  {id:1,company:"Apex Car Care LLC",      contact:"John Smith",  email:"john@apexcarcare.com",    phone:"619-555-0100",ein:"82-1234567",address:"1234 Industrial Blvd, San Diego CA 92101",  tier:"distributor",status:"approved",rep:"Marcus T.",creditLimit:10000,creditUsed:1450,terms:["cc","ach","net30","net60"],joined:"Mar 1, 2025"},
  {id:2,company:"FastLane Auto Parts",    contact:"Maria Reyes", email:"maria@fastlane.com",       phone:"623-555-0200",ein:"74-9876543",address:"500 Commerce Ave, Phoenix AZ 85001",        tier:"dealer",     status:"approved",rep:"Marcus T.",creditLimit:5000, creditUsed:0,   terms:["cc","ach","net15"],        joined:"Mar 18, 2025"},
  {id:3,company:"Desert Diesel Service",  contact:"Tom Bradley", email:"tom@desertdiesel.com",     phone:"520-555-0300",ein:"91-3456789",address:"88 Truck Route, Tucson AZ 85701",            tier:"distributor",status:"pending", rep:"",          creditLimit:0,    creditUsed:0,   terms:["cc"],                      joined:"Apr 8, 2025"},
  {id:4,company:"Pacific Fleet Mgmt",     contact:"Amy Chen",    email:"amy@pacificfleet.com",     phone:"858-555-0400",ein:"55-6543210",address:"2200 Harbor Dr, Long Beach CA 90802",        tier:"enterprise", status:"pending", rep:"",          creditLimit:0,    creditUsed:0,   terms:["cc"],                      joined:"Apr 9, 2025"},
  {id:5,company:"Westside Repair Center", contact:"Dave Kim",    email:"dave@westsiderepair.com",  phone:"661-555-0300",ein:"33-7890123",address:"77 Main St, Bakersfield CA 93301",           tier:"dealer",     status:"approved",rep:"Sarah L.",  creditLimit:3000, creditUsed:520, terms:["cc","ach","net30"],        joined:"Feb 14, 2025"},
];

// ── Company info reader (mirrors RepPortal getMpcInfo) ──
const MPC_INFO_DEFAULT = {
  name:"MotorPower Care Inc.", address:"1234 Commerce Blvd, Suite 200",
  city:"San Diego, CA 92101", email:"info@mpcare.com",
  phone:"(619) 555-0100", website:"www.mpcare.com", taxId:"82-4567890",
  bankName:"", bankRouting:"", bankAccount:"",
  bankAccountName:"MotorPower Care Inc.", bankSwift:"", bankAddress:"",
  wireNote:"",
  checkPayee:"MotorPower Care Inc.", checkAddress:"",
  paypalEmail:"", zelleEmail:"",
};
function getMpcInfo() {
  try {
    const s = localStorage.getItem("mpcare_company_info");
    if(s) {
      const d = JSON.parse(s);
      return {
        name: d.name || MPC_INFO_DEFAULT.name,
        address: d.address || MPC_INFO_DEFAULT.address,
        city: [d.city, d.state, d.zip].filter(Boolean).join(", ") || MPC_INFO_DEFAULT.city,
        email: d.email || MPC_INFO_DEFAULT.email,
        phone: d.phone || MPC_INFO_DEFAULT.phone,
        website: d.website || MPC_INFO_DEFAULT.website,
        taxId: d.taxId || MPC_INFO_DEFAULT.taxId,
        logo: d.logo || "",
        invoiceNotes: d.invoiceNotes || "",
        invoicePrefix: d.invoicePrefix || "INV",
        bankName: d.bankName || "", bankRouting: d.bankRouting || "",
        bankAccount: d.bankAccount || "", paypalEmail: d.paypalEmail || "",
        zelleEmail: d.zelleEmail || "",
        // Wire transfer instructions (editable in admin Settings)
        bankAccountName: d.bankAccountName || d.name || MPC_INFO_DEFAULT.name,
        bankSwift: d.bankSwift || "",
        bankAddress: d.bankAddress || "",
        wireNote: d.wireNote || "",
        checkPayee: d.checkPayee || d.name || MPC_INFO_DEFAULT.name,
        checkAddress: d.checkAddress || "",
      };
    }
  } catch(e) {}
  return MPC_INFO_DEFAULT;
}

const RECENT_ORDERS = [
  {id:"#ORD-4821",date:"Apr 7, 2025", amount:980, status:"transit",items:"DPF purge filter ×12, Fuel system cleaner ×24",account:"Apex Car Care LLC"},
  {id:"#ORD-4790",date:"Mar 28, 2025",amount:1240,status:"done",  items:"Catalytic converter cleaner ×24, Engine flush ×12",account:"Apex Car Care LLC"},
  {id:"#ORD-4755",date:"Mar 15, 2025",amount:760, status:"done",  items:"DPF foam cleaner ×12, Diesel power cleaner ×12",account:"FastLane Auto Parts"},
  {id:"#ORD-4731",date:"Mar 2, 2025", amount:520, status:"done",  items:"Octane booster ×16, Induction cleaner ×12",account:"Apex Car Care LLC"},
  {id:"#ORD-4680",date:"Feb 18, 2025",amount:1890,status:"done",  items:"Wiper blades ×48, Floor mats ×20, Fuel system cleaner ×36",account:"Westside Repair Center"},
];

const StatusLabel = ({s}) => {
  const map = {transit:[S.pillBlue,"In transit"],done:[S.pillGreen,"Delivered"],pending:[S.pillAmber,"Processing"],confirmed:[{fontSize:10,fontWeight:500,padding:"2px 8px",borderRadius:8,background:"#DBEAFE",color:"#1E40AF"},"Confirmed"],shipped:[S.pillBlue,"Shipped"],cancelled:[S.pillRed,"Cancelled"]};
  const [style,label] = map[s]||[S.pillGray,s];
  return <span style={style}>{label}</span>;
};

// Unified invoice / order status pill (Paid / Pending / Shipped / Overdue /
// Cancelled) — SINGLE SOURCE OF TRUTH rendered identically across admin,
// rep, and customer portals. Accepts the raw invoice object so the helper
// can inspect payment + shipping + dueDate in one pass.
const InvoicePill = ({inv}) => {
  const code = deriveInvoiceDisplayStatus(inv);
  return <span style={displayStatusPillStyle(code)}>{displayStatusLabel(code)}</span>;
};

// ── PAYMENT REMINDER / OVERDUE HELPERS ───────────────────────────────────────
// Extract Net-X days from a terms label; non-Net terms (card/ACH/wire) return
// null so we don't send reminders for invoices that weren't supposed to be paid
// later. Keeps the reminder/overdue logic focused on the outstanding Net bucket.
const getNetDays = (terms) => {
  if(!terms) return null;
  const m = String(terms).match(/net\s*(\d+)/i);
  return m ? parseInt(m[1],10) : null;
};
const getInvoiceDueDate = (inv) => {
  if(inv?.dueDate){ const d = new Date(inv.dueDate); return isNaN(d)?null:d; }
  const days = getNetDays(inv?.paymentTerms);
  if(days==null || !inv?.date) return null;
  const d = new Date(inv.date);
  if(isNaN(d)) return null;
  d.setDate(d.getDate()+days);
  return d;
};
const isDueTomorrow = (inv) => {
  const due = getInvoiceDueDate(inv);
  if(!due) return false;
  const t = new Date(); t.setHours(0,0,0,0);
  const tomorrow = new Date(t); tomorrow.setDate(t.getDate()+1);
  const d = new Date(due); d.setHours(0,0,0,0);
  return d.getTime()===tomorrow.getTime();
};
const daysOverdue = (inv) => {
  // Cancelled/paid invoices aren't overdue.
  if(!inv || inv.status==="paid" || inv.status==="cancelled") return 0;
  const due = getInvoiceDueDate(inv);
  if(!due) return 0;
  const t = new Date(); t.setHours(0,0,0,0);
  const d = new Date(due); d.setHours(0,0,0,0);
  const diff = Math.floor((t.getTime()-d.getTime())/86400000);
  return diff>0 ? diff : 0;
};
const isOverdue = (inv) => daysOverdue(inv) > 0;
// Fires a payment-reminder email for any outstanding Net-X invoice whose
// due date is tomorrow. Dedup via public.admin_alert_log (migration 0024)
// so an invoice is only reminded once GLOBALLY, cross-device. Prior to
// migration 0024 this deduped via the per-browser localStorage key
// `mpcare_reminded_invoices` and would re-fire whenever admin signed in
// from a new browser.
//
// Async: awaits claimAdminAlert per invoice (race-safe atomic upsert on
// (invoice_id, alert_type)). Only the "winner" admin actually sends the
// email — every concurrent admin session sees ON CONFLICT DO NOTHING and
// skips. If Supabase is unreachable, claimAdminAlert returns false →
// this admin skips the send (fail-safe against duplicates).
//
// resolveEmail(inv) → email string (falsy skips).
// sentBy is a display string (admin email) written to the audit log.
const sendDueTomorrowReminders = async (invoices, resolveEmail, sentBy) => {
  if(!Array.isArray(invoices) || invoices.length===0) return;
  for (const inv of invoices) {
    if(!inv || inv.status==="paid" || inv.status==="cancelled") continue;
    if(!isDueTomorrow(inv)) continue;
    const email = typeof resolveEmail==="function" ? resolveEmail(inv) : resolveEmail;
    if(!email) continue;
    // eslint-disable-next-line no-await-in-loop
    const claimed = await claimAdminAlert({
      invoiceId: inv.id,
      alertType: 'due_tomorrow',
      sentBy: sentBy || ""
    });
    if (!claimed) continue;
    const due = getInvoiceDueDate(inv);
    emailPaymentReminder({
      customerName: inv.customer || "Customer",
      customerEmail: email,
      invoiceId: inv.id,
      total: Number(inv.total||0).toFixed(2),
      dueDate: due ? due.toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
      paymentTerms: inv.paymentTerms || ""
    });
  }
};
// Fires an overdue-payment admin alert for any invoice past due that we
// haven't already flagged. In-portal UI is the primary surface; email
// just ensures we're notified out-of-band too. resolveAccount(inv) →
// account record. sentBy is the admin email written to the audit log.
//
// Same migration-0024 dedupe as sendDueTomorrowReminders above. Each
// invoice's alert_type='overdue' row can only be inserted once — race
// between multiple admin browsers is resolved atomically by the UNIQUE
// (invoice_id, alert_type) constraint.
const sendOverdueAdminAlerts = async (invoices, resolveAccount, sentBy) => {
  if(!Array.isArray(invoices) || invoices.length===0) return;
  for (const inv of invoices) {
    if(!inv || inv.status==="paid" || inv.status==="cancelled") continue;
    const late = daysOverdue(inv);
    if(late <= 0) continue;
    // eslint-disable-next-line no-await-in-loop
    const claimed = await claimAdminAlert({
      invoiceId: inv.id,
      alertType: 'overdue',
      sentBy: sentBy || ""
    });
    if (!claimed) continue;
    const ac = typeof resolveAccount==="function" ? resolveAccount(inv) : null;
    const due = getInvoiceDueDate(inv);
    emailPaymentOverdue({
      customerName: inv.customer || ac?.company || "Customer",
      customerEmail: ac?.email || "",
      customerPhone: ac?.phone || "",
      invoiceId: inv.id,
      total: Number(inv.total||0).toFixed(2),
      dueDate: due ? due.toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
      paymentTerms: inv.paymentTerms || "",
      daysOverdue: late,
      rep: displayRepStamp(inv.rep || ac?.rep || "")
    });
  }
};

// Backfill + grace-seed the admin_alert_log on admin mount so the user
// stops receiving duplicate overdue emails after migration 0024. Two
// phases run once per mount, both idempotent:
//
//   PHASE 1 — LOCALSTORAGE BACKFILL: any invoice ids still living in
//   the pre-migration localStorage keys `mpcare_overdue_alerts` and
//   `mpcare_reminded_invoices` are upserted into admin_alert_log so an
//   admin whose local dedupe never made it to Supabase doesn't re-fire
//   those emails from another browser.
//
//   PHASE 2 — GRACE SEED (first-run only): if the Supabase log is
//   completely empty (no admin has run this backfill yet), we also
//   silently claim every currently-overdue invoice from SHARED_INVOICES
//   with sent_by='grace_seed_migration_0024'. This means: the CURRENT
//   burst of already-past-due invoices is treated as "already alerted"
//   for the entire org, going forward. Only NEW invoices that go overdue
//   AFTER this seed will trigger an email. This is exactly what the user
//   asked for: no more duplicates for existing overdue invoices, but
//   future ones still fire once.
//
//   After phase 2, the log has entries → subsequent mounts (this admin
//   or any other admin, any device) skip the grace-seed → the normal
//   send flow correctly alerts on new overdue invoices only.
//
// Legacy localStorage keys are LEFT UNTOUCHED per CLAUDE.md — nothing
// existing is modified or deleted. They just become dormant references.
const backfillAdminAlertLog = async (invoices, sentBy) => {
  try {
    // Fetch existing log once so we can decide whether to grace-seed
    // AND skip localStorage backfills for entries that are already in
    // the log (fewer redundant Supabase round-trips).
    const existing = await listAdminAlertLog({});
    const overdueLogSet  = new Set(existing.filter(r => r.alert_type === 'overdue').map(r => String(r.invoice_id)));
    const reminderLogSet = new Set(existing.filter(r => r.alert_type === 'due_tomorrow').map(r => String(r.invoice_id)));
    const isFirstRunPostMigration = existing.length === 0;

    // PHASE 1: localStorage → Supabase
    let overdueLocal = [];
    let reminderLocal = [];
    try { overdueLocal = JSON.parse(localStorage.getItem("mpcare_overdue_alerts") || "[]"); } catch(e) {}
    try { reminderLocal = JSON.parse(localStorage.getItem("mpcare_reminded_invoices") || "[]"); } catch(e) {}
    if (!Array.isArray(overdueLocal))  overdueLocal  = [];
    if (!Array.isArray(reminderLocal)) reminderLocal = [];
    let backfilledOverdue = 0, backfilledReminder = 0;
    for (const id of overdueLocal) {
      const key = String(id||"");
      if (!key || overdueLogSet.has(key)) continue;
      // eslint-disable-next-line no-await-in-loop
      await claimAdminAlert({ invoiceId: key, alertType: 'overdue', sentBy: sentBy || 'backfill_localstorage' });
      overdueLogSet.add(key);
      backfilledOverdue++;
    }
    for (const id of reminderLocal) {
      const key = String(id||"");
      if (!key || reminderLogSet.has(key)) continue;
      // eslint-disable-next-line no-await-in-loop
      await claimAdminAlert({ invoiceId: key, alertType: 'due_tomorrow', sentBy: sentBy || 'backfill_localstorage' });
      reminderLogSet.add(key);
      backfilledReminder++;
    }

    // PHASE 2: Grace-seed (first-run only). Silences the initial burst of
    // already-past-due invoices so no admin, on any device, gets emailed
    // about invoices they've already been alerted about. Only NEW overdue
    // invoices going forward will fire.
    let graceSeeded = 0;
    if (isFirstRunPostMigration && Array.isArray(invoices) && invoices.length > 0) {
      for (const inv of invoices) {
        if (!inv || inv.status === 'paid' || inv.status === 'cancelled') continue;
        const late = daysOverdue(inv);
        if (late <= 0) continue;
        const key = String(inv.id || "");
        if (!key || overdueLogSet.has(key)) continue;
        // eslint-disable-next-line no-await-in-loop
        await claimAdminAlert({ invoiceId: key, alertType: 'overdue', sentBy: 'grace_seed_migration_0024' });
        overdueLogSet.add(key);
        graceSeeded++;
      }
    }

    if (backfilledOverdue > 0 || backfilledReminder > 0 || graceSeeded > 0) {
      console.info(
        "[backfillAdminAlertLog] localStorage-backfilled", backfilledOverdue, "overdue +",
        backfilledReminder, "due_tomorrow; grace-seeded", graceSeeded,
        "currently-overdue invoices (first run:", isFirstRunPostMigration, ")"
      );
    }
  } catch (e) {
    console.warn("[backfillAdminAlertLog] failed:", e?.message || e);
  }
};

// ── ADMIN INVOICE VIEWER MODAL ───────────────────────────────────────────────
// onStatusChange is optional — when provided the modal gains a bottom action
// bar that lets admin:
//   • confirm a customer's pending wire/check (flips payment_pending → paid)
//   • reject a pending payment that never arrived (→ outstanding)
//   • record an offline payment on any outstanding invoice (→ paid)
// Parent is responsible for refreshing its own invoice list after the change.
export function AdminInvoiceModal({inv: invProp, onClose, onStatusChange, topSlot}) {   // exported for the render tests only
  const [showMarkPaid, setShowMarkPaid] = useState(false);
  const [markPaidMethod, setMarkPaidMethod] = useState("");
  const [markPaidRef, setMarkPaidRef] = useState("");
  // Re-render when the shared cache changes (a rep remittance mark / reverse updates it in place).
  const [, bumpShared] = useState(0);
  useEffect(()=>SHARED_INVOICES.subscribe(()=>bumpShared(n=>n+1)),[]);
  // The DB state of the rep remittance (active row) drives the violet pill and the paid text.
  const modalRemit = useActiveRemittance(invProp);
  if(!invProp) return null;
  // Payment state follows the live cache object when a rep remittance is involved (see overlayRemittanceState).
  const inv = overlayRemittanceState(invProp, SHARED_INVOICES.getAll().find(i=>i.id===invProp.id));
  const mpc = getMpcInfo();
  const cust = inv.customerInfo || {};
  const hasItems = Array.isArray(inv.items);
  const itemsSum   = hasItems ? inv.items.reduce((s,i)=>s+((i.price||0)*(i.qty||0)),0) : 0;
  const storedTotal = Number(inv.total||inv.amount||0);
  // Persisted breakdown (when present). New invoices carry these as explicit
  // lines so the dealer sees discount / shipping separately; legacy invoices
  // just have `total`.
  const invDiscount = inv.discount || null;
  const invShipping = inv.shipping || null;
  const discountAmt = Number(invDiscount?.amount || 0);
  const shippingAmt = Number(invShipping?.amount || 0);
  // Authoritative total — what the customer actually paid / owes. When the
  // breakdown fields are present we can reconstruct the sub-amounts; when
  // they're not (legacy), we still show the stored total as the source of
  // truth. 2-cent tolerance absorbs rounding.
  const authoritativeTotal = storedTotal > 0 ? storedTotal : itemsSum;
  // Reconciliation: expected total = items-sum − discount + shipping. When
  // that doesn't match `storedTotal` by more than 2 cents, surface a banner
  // so admin + dealer see the data-quality issue rather than a silently
  // wrong number. Legacy invoices without discount/shipping fields just
  // compare items-sum to storedTotal.
  const expectedFromItems = itemsSum - discountAmt + shippingAmt;
  const reconciliationMismatch = hasItems && storedTotal > 0 && Math.abs(expectedFromItems - storedTotal) > 0.02;
  // Subtotal displayed in the totals block — pre-discount sum of line items.
  // If items don't sum (legacy mispriced invoices), fall back to the stored
  // total so the dealer still sees a sensible subtotal.
  const subtotal = hasItems ? itemsSum : authoritativeTotal;
  const today = inv.date||new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});
  const isPaid = inv.status==="paid"||inv.status==="done";
  const isPending = inv.status==="payment_pending";
  const isCancelled = inv.status==="cancelled";
  // Unified 4-value pill for the modal header. Same code path as the
  // InvoicePill list rows so admin + dealer + rep all see one label.
  const _displayCode = deriveInvoiceDisplayStatus(inv);
  const _displayStyle = displayStatusPillStyle(_displayCode);
  const statusLabel = displayStatusLabel(_displayCode);
  // Rep remittance: the database row wins; the cache flag is only a fallback while the read is loading / failed.
  const remitActive = !!modalRemit.rem || (modalRemit.ok!==true && inv.paidVia===REMIT_PAID_VIA);
  const remitPill = remittancePill({method: modalRemit.rem ? modalRemit.rem.method : inv.remittanceMethod});
  const remitLabel = modalRemit.rem ? remittancePaidLabel(modalRemit.rem) : (inv.remittanceMethod ? `Received via sales rep (${methodLabel(inv.remittanceMethod)})` : "Received via sales rep");
  const remitPaidOnly = remitActive && inv.paidVia===REMIT_PAID_VIA && !inv.remittanceKeptPayment;

  // Handler for the confirm / reject / manual-mark-paid buttons. Calls the
  // shared store directly and then notifies the parent so its list refreshes.
  const confirmPayment = (method, ref) => {
    const details = ref ? {transactionId: ref} : undefined;
    SHARED_INVOICES.markPaid(inv.id, method || inv.pendingMethod || "Manual", details);
    if(onStatusChange) onStatusChange();
    onClose && onClose();
  };
  const rejectPayment = () => {
    if(!window.confirm(`Clear pending payment for ${inv.id}? The invoice will return to Outstanding so ${inv.customer||"the customer"} can retry.`)) return;
    SHARED_INVOICES.clearPendingPayment(inv.id, "Admin: payment not received");
    if(onStatusChange) onStatusChange();
    onClose && onClose();
  };

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:"20px 8px",overflowY:"auto"}}>
      <div style={{background:C.white,width:"min(700px,100%)",boxSizing:"border-box",borderRadius:12,overflowX:"auto",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{background:"#1E293B",padding:"12px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8,position:"sticky",top:0,zIndex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",minWidth:0}}>
            <span style={{color:C.white,fontSize:13,fontWeight:500}}>Invoice {inv.id}</span>
            <span style={{..._displayStyle,padding:"4px 12px",borderRadius:20,fontSize:11}}>{statusLabel}</span>
            {remitActive && !isCancelled && <span style={{...remitPill.style,padding:"4px 12px",borderRadius:20}}>{remitPill.label}</span>}
          </div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>window.print()} style={{background:"rgba(255,255,255,0.1)",border:"none",color:C.white,padding:"6px 14px",borderRadius:6,fontSize:12,cursor:"pointer"}}>Print / Save PDF</button>
            <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:22,cursor:"pointer",lineHeight:1}}>×</button>
          </div>
        </div>
        {topSlot && <div style={{padding:"16px clamp(16px,6vw,48px) 0"}}>{topSlot}</div>}
        <div style={{padding:"40px clamp(16px,6vw,48px)",fontFamily:"'DM Sans',system-ui,sans-serif"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:16,marginBottom:32}}>
            <div>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
                {mpc.logo?<img src={mpc.logo} alt={mpc.name} style={{maxHeight:56,objectFit:"contain"}} onError={e=>{e.target.style.display="none"}}/>:<img src="/mpc-logo.png" alt="MotorPower Care" style={{width:56,height:56,objectFit:"contain"}}/>}
                <div style={{fontSize:22,fontWeight:700,color:C.navy}}>{mpc.name}</div>
              </div>
              <div style={{fontSize:12,color:C.inkLight,lineHeight:1.9}}>{mpc.address}<br/>{mpc.city}<br/>{mpc.phone}<br/>{mpc.email}<br/>{mpc.website}</div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:34,fontWeight:700,color:C.navy,marginBottom:6}}>INVOICE</div>
              <div style={{fontSize:13,color:C.inkLight,lineHeight:1.9}}>
                <strong style={{color:C.ink}}>Invoice #:</strong> {inv.id}<br/>
                <strong style={{color:C.ink}}>Date:</strong> {today}<br/>
                <strong style={{color:C.ink}}>Terms:</strong> {inv.paymentTerms||"Net 30"}
                {inv.adjustedAt&&!isNaN(new Date(inv.adjustedAt).getTime())&&<><br/><span style={{fontSize:11,color:C.inkLight}}>Adjusted on {new Date(inv.adjustedAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"})}</span></>}
              </div>
              <div style={{marginTop:8,display:"inline-block",background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:6,padding:"4px 10px",fontSize:11,fontWeight:600,color:"#1D4ED8"}}>Tax Exempt — For Resale</div>
            </div>
          </div>
          <div style={{height:2,background:`linear-gradient(to right,${C.navy},${C.blue})`,borderRadius:2,marginBottom:28}}/>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(200px,100%),1fr))",gap:24,marginBottom:28}}>
            <div>
              <div style={{fontSize:10,fontWeight:700,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>Bill to</div>
              <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:2}}>{inv.customer||inv.account||"—"}</div>
              <div style={{fontSize:12,color:C.inkLight,lineHeight:1.9}}>{cust.address||""}<br/>{cust.city||""}<br/>{cust.phone||""}<br/>{cust.email||""}</div>
              {cust.resaleLicense&&<div style={{marginTop:6,fontSize:11,color:C.inkMid}}><strong>Resale License:</strong> {cust.resaleLicense}</div>}
            </div>
            <div>
              <div style={{fontSize:10,fontWeight:700,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>From</div>
              <div style={{fontSize:12,color:C.inkMid,lineHeight:1.9}}>
                <strong style={{color:C.ink}}>Seller:</strong> {mpc.name}<br/>
                <strong style={{color:C.ink}}>Tax ID:</strong> {mpc.taxId}<br/>
                {inv.rep&&<><strong style={{color:C.ink}}>Rep:</strong> {displayRepStamp(inv.rep)}<br/></>}
                {mpc.phone&&<><strong style={{color:C.ink}}>Phone:</strong> {mpc.phone}</>}
              </div>
            </div>
          </div>
          {hasItems?(
            <>
              <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflowX:"auto",marginBottom:24}}>
                <div style={{display:"grid",gridTemplateColumns:"32px 80px 1fr 60px 80px 90px",background:C.navy,padding:"10px 16px",gap:8,minWidth:460}}>
                  {["#","SKU","Description","Qty","Price","Total"].map(h=>(
                    <div key={h} style={{fontSize:11,fontWeight:600,color:C.white,textAlign:["Qty","Price","Total"].includes(h)?"right":"left"}}>{h}</div>
                  ))}
                </div>
                {inv.items.map((item,i)=>{
                  const caseSize = Math.max(1, Number(item.case)||1);
                  const linePrice = Number(item.price)||0;
                  const unitPrice = caseSize > 1 ? linePrice / caseSize : null;
                  return (
                  <div key={i} style={{display:"grid",gridTemplateColumns:"32px 80px 1fr 60px 80px 90px",gap:8,padding:"11px 16px",minWidth:460,borderTop:`1px solid ${C.border}`,background:i%2===0?C.white:C.surface}}>
                    <div style={{fontSize:12,color:C.inkLight}}>{i+1}</div>
                    <div style={{fontSize:11,fontWeight:600,color:C.blue,fontFamily:"monospace"}}>{item.sku}</div>
                    <div style={{fontSize:12,fontWeight:500,color:C.ink}}>{item.name}</div>
                    <div style={{fontSize:12,color:C.ink,textAlign:"right"}}>{item.qty}</div>
                    <div style={{fontSize:12,color:C.ink,textAlign:"right"}}>
                      ${linePrice.toFixed(2)}
                      {unitPrice != null && (
                        <div style={{fontSize:9,color:C.inkLight,fontWeight:400,marginTop:2}}>
                          ${unitPrice.toFixed(2)}/unit · case of {caseSize}
                        </div>
                      )}
                    </div>
                    <div style={{fontSize:12,fontWeight:500,color:C.ink,textAlign:"right"}}>${(linePrice*(Number(item.qty)||0)).toFixed(2)}</div>
                  </div>
                  );
                })}
              </div>
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:24}}>
                <div style={{width:"min(300px,100%)"}}>
                  {/* Reconciliation banner — legacy invoices whose items don't
                      foot to the stored total after accounting for recorded
                      discount + shipping. New invoices reconcile cleanly. */}
                  {reconciliationMismatch && (
                    <div style={{fontSize:11,padding:"6px 8px",borderRadius:6,background:"#FEF3C7",color:"#92400E",border:"1px solid #FCD34D",marginBottom:6,lineHeight:1.4}}>
                      Line items + recorded adjustments sum to <strong>${expectedFromItems.toFixed(2)}</strong>; this invoice was charged <strong>${storedTotal.toFixed(2)}</strong>. Total due reflects the charged amount.
                    </div>
                  )}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}><span style={{color:C.inkMid}}>Subtotal</span><span style={{fontWeight:500}}>${subtotal.toFixed(2)}</span></div>
                  {invDiscount && discountAmt > 0 && (
                    <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                      <span style={{color:C.teal}}>{invDiscount.label || "Discount"}{invDiscount.pct ? ` (${invDiscount.pct}%)` : ""}</span>
                      <span style={{color:C.teal,fontWeight:500}}>−${discountAmt.toFixed(2)}</span>
                    </div>
                  )}
                  {invShipping && shippingAmt > 0 && (
                    <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                      <span style={{color:C.inkMid}}>Shipping{invShipping.label ? ` (${invShipping.label})` : ""}</span>
                      <span style={{fontWeight:500}}>${shippingAmt.toFixed(2)}</span>
                    </div>
                  )}
                  {invShipping && shippingAmt === 0 && (
                    <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                      <span style={{color:C.inkMid}}>Shipping{invShipping.label ? ` (${invShipping.label})` : ""}</span>
                      <span style={{color:C.teal,fontWeight:500}}>FREE</span>
                    </div>
                  )}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}><span style={{color:C.inkMid}}>Tax</span><span style={{color:C.teal,fontWeight:500}}>$0.00 — Tax exempt</span></div>
                  <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",fontSize:16,fontWeight:700,color:C.navy}}><span>Total due</span><span>${authoritativeTotal.toFixed(2)}</span></div>
                </div>
              </div>
            </>
          ):(
            <div style={{marginBottom:24}}>
              <div style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"14px 18px",marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:6}}>Items</div>
                <div style={{fontSize:13,color:C.inkMid}}>{typeof inv.items==="string"?inv.items:"—"}</div>
              </div>
              <div style={{display:"flex",justifyContent:"flex-end"}}>
                <div style={{fontSize:16,fontWeight:700,color:C.navy}}>Total: ${Number(inv.total||inv.amount||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
              </div>
            </div>
          )}
          {inv.notes&&<div style={{background:C.surface,borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12,color:C.inkMid}}><strong>Notes:</strong> {inv.notes}</div>}
          <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"12px 16px",marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:"#1D4ED8",marginBottom:4}}>TAX EXEMPTION NOTICE</div>
            <div style={{fontSize:11,color:"#1E40AF",lineHeight:1.6}}>This sale is exempt from sales tax. Purchaser holds a valid resale certificate: {cust.resaleLicense||"on file"}. Seller tax ID: {mpc.taxId}. For wholesale/resale purposes only.</div>
          </div>
          {(mpc.bankName||mpc.paypalEmail||mpc.zelleEmail)&&(
            <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:11,color:C.inkMid}}>
              <strong style={{color:C.ink}}>Payment information</strong><br/>
              {mpc.bankName&&<span>Bank: {mpc.bankName}{mpc.bankRouting?` | Routing: ${mpc.bankRouting}`:""}{mpc.bankAccount?` | Acct: ${mpc.bankAccount}`:""}<br/></span>}
              {mpc.paypalEmail&&<span>PayPal: {mpc.paypalEmail}<br/></span>}
              {mpc.zelleEmail&&<span>Zelle: {mpc.zelleEmail}<br/></span>}
            </div>
          )}
          <div style={{borderTop:`1px solid ${C.border}`,paddingTop:14,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div style={{fontSize:11,color:C.inkLight,minWidth:0,overflowWrap:"anywhere"}}>{mpc.invoiceNotes||"Thank you for your business"} — {mpc.name}</div>
            <div style={{fontSize:11,color:C.inkLight,minWidth:0,overflowWrap:"anywhere"}}>{mpc.email}</div>
          </div>
        </div>

        {/* Paid to us by the sales rep (rep-created invoices; loads its own fresh state). */}
        <RepRemittanceSection key={inv.id} inv={inv}/>

        {/* ── Admin status-change action bar (non-print) ────────────────────
            Hidden when onStatusChange isn't provided so legacy callers still
            get a read-only modal. Also hidden on print via .no-print class. */}
        {onStatusChange && !isCancelled && (
          <div className="no-print" style={{background:C.surface,borderTop:`1px solid ${C.border}`,padding:"16px clamp(16px,6vw,48px)"}}>
            {isPending && (
              <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"12px 14px",marginBottom:12}}>
                <div style={{fontSize:13,fontWeight:600,color:"#92400E",marginBottom:4}}>
                  Customer reported {inv.pendingMethod || "payment"} — awaiting your confirmation
                </div>
                <div style={{fontSize:12,color:"#92400E"}}>
                  {inv.pendingDate ? `Reported on ${inv.pendingDate}. ` : ""}
                  Once you've verified funds arrived in your account, confirm below to close out the invoice. If the payment never arrived, clear the pending flag to return the invoice to Outstanding.
                </div>
              </div>
            )}
            {isPaid && (
              <div style={{background:"#DCFCE7",border:"1px solid #86EFAC",borderRadius:8,padding:"12px 14px",fontSize:12,color:"#166534"}}>
                {remitPaidOnly
                  ? <>{remitLabel}. Not paid by the shop directly.</>
                  : <>Paid{inv.paidDate?` on ${inv.paidDate}`:""}{inv.paidMethod?` via ${inv.paidMethod}`:""}.{remitActive && <> Also received from the sales rep: {remitLabel.replace(/^Received via sales rep:? ?/,"")}.</>}</>}
                {inv.transactionId && <span> Reference: <strong>{inv.transactionId}</strong>.</span>}
              </div>
            )}
            {!showMarkPaid && !isPaid && (
              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                {isPending && (
                  <>
                    <button
                      style={{...S.btnPrimary,background:C.teal}}
                      onClick={()=>confirmPayment(inv.pendingMethod || "Manual")}
                    >
                      ✓ Confirm {inv.pendingMethod ? inv.pendingMethod.toLowerCase() : "payment"} received
                    </button>
                    <button style={S.btnSecondary} onClick={rejectPayment}>
                      Clear pending (not received)
                    </button>
                  </>
                )}
                <button
                  style={isPending ? S.btnSecondary : {...S.btnPrimary,background:C.teal}}
                  onClick={()=>{setMarkPaidMethod(inv.pendingMethod||"Wire transfer");setMarkPaidRef("");setShowMarkPaid(true);}}
                >
                  Record offline payment…
                </button>
              </div>
            )}
            {showMarkPaid && !isPaid && (
              <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"14px 16px"}}>
                <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>Record payment received</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(160px,100%),1fr))",gap:12,marginBottom:10}}>
                  <div>
                    <label style={{...S.label,display:"block",marginBottom:4}}>Payment method</label>
                    <select style={S.select} value={markPaidMethod} onChange={e=>setMarkPaidMethod(e.target.value)}>
                      <option>Wire transfer</option>
                      <option>Check</option>
                      <option>ACH</option>
                      <option>Credit card</option>
                      <option>Cash</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div>
                    <label style={{...S.label,display:"block",marginBottom:4}}>Reference / transaction # (optional)</label>
                    <input style={S.input} value={markPaidRef} onChange={e=>setMarkPaidRef(e.target.value)} placeholder="e.g. Wire confirmation #"/>
                  </div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={S.btnSecondary} onClick={()=>setShowMarkPaid(false)}>Cancel</button>
                  <button
                    style={{...S.btnPrimary,background:C.teal}}
                    onClick={()=>confirmPayment(markPaidMethod, markPaidRef)}
                  >
                    ✓ Mark as paid
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── SIGNUP ────────────────────────────────────────────────────────────────────
function SignupPage({onSubmit, initialRole}) {
  const [step,setStep]=useState(1);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const [signupRole,setSignupRole]=useState(initialRole||"customer");
  const [f,setF]=useState({company:"",ein:"",address:"",city:"",state:"",zip:"",firstName:"",lastName:"",email:"",phone:"",tier:"dealer",password:"",repName:"",territory:""});
  // Per-field error flags drive red borders + per-field hints. Cleared on edit.
  const [fieldErrs,setFieldErrs]=useState({});
  const set=(k,v)=>{ setF(p=>({...p,[k]:v})); setFieldErrs(e=>{ if(!e[k]) return e; const {[k]:_, ...rest}=e; return rest; }); setError(""); };
  const [acctCode,setAcctCode]=useState("");
  // Admin-editable signup copy (blurb + tier descriptions). Re-renders if
  // admin saves while the page is open.
  const [portalContent, setPortalContent] = useState(() => PORTAL_SETTINGS.get());
  useEffect(() => PORTAL_SETTINGS.subscribe(setPortalContent), []);

  // Pick input style: plain or red based on fieldErrs.
  const inpStyle = (key) => fieldErrs[key]
    ? { ...S.input, borderColor:"#EF4444", background:"#FEF2F2" }
    : S.input;

  const handleSignup = async () => {
    // Collect every missing/invalid required field in one pass so the user
    // sees ALL the red fields at once instead of fixing them one at a time.
    const miss = {};
    if(!f.firstName.trim()) miss.firstName = true;
    if(!f.lastName.trim())  miss.lastName  = true;
    if(!f.email.trim())     miss.email     = true;
    else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim())) { miss.email = true; }
    if(!f.password)         miss.password  = true;
    else if(f.password.length < 6) { miss.password = true; }
    if(!f.phone.trim())     miss.phone     = true;
    if(signupRole==="customer") {
      if(!f.company.trim()) miss.company = true;
      if(!f.ein.trim())     miss.ein     = true;
      if(!f.address.trim()) miss.address = true;
      if(!f.city.trim())    miss.city    = true;
      if(!f.state.trim())   miss.state   = true;
      if(!f.zip.trim())     miss.zip     = true;
    } else {
      if(!f.territory.trim()) miss.territory = true;
    }
    if(Object.keys(miss).length > 0) {
      setFieldErrs(miss);
      const pwShort = !miss.password ? false : (!!f.password && f.password.length < 6);
      const emailBad = !miss.email ? false : (!!f.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim()));
      setError(
        emailBad ? "That email doesn't look right. Use format name@company.com." :
        pwShort  ? "Password must be at least 6 characters." :
                   "Fill in the fields highlighted in red."
      );
      return;
    }
    setFieldErrs({});
    setLoading(true); setError("");
    try {
      // Check for duplicate email before signup
      const existingProfiles = await getAllProfiles();
      const emailLower = f.email.trim().toLowerCase();
      if(existingProfiles.some(p => (p.email||"").toLowerCase() === emailLower)) {
        setFieldErrs({email:true});
        setError("An account already exists with this email. Use a different email or sign in instead.");
        setLoading(false); return;
      }
      const isRep = signupRole==="rep";
      const prefix = isRep ? "REP" : f.company.replace(/[^A-Za-z0-9]/g,"").substring(0,4).toUpperCase();
      const code = "MPC-"+prefix+"-"+Date.now().toString(36).slice(-5).toUpperCase();
      const fullAddress = isRep ? f.territory : [f.address,f.city,f.state,f.zip].filter(Boolean).join(", ");
      const signupResult = await signUp({
        email: f.email.trim(),
        password: f.password,
        fullName: `${f.firstName} ${f.lastName}`,
        role: isRep ? "rep" : "customer",
        company: isRep ? "" : f.company,
        phone: f.phone,
        ein: isRep ? "" : f.ein,
        address: fullAddress,
        tier: isRep ? "rep" : f.tier,
        refCode: code
      });
      // Save all metadata to profiles table so admin sees phone/EIN/address/company
      const userId = signupResult?.user?.id;
      if (userId) {
        try {
          const res = await saveProfileMetadata(userId, {
            full_name: `${f.firstName} ${f.lastName}`,
            email: f.email.trim(),
            role: isRep ? "rep" : "customer",
            company: isRep ? "" : f.company,
            phone: f.phone,
            ein: isRep ? "" : f.ein,
            address: fullAddress,
            tier: isRep ? "rep" : f.tier,
            ref_code: code,
            rep: isRep ? "" : (f.repName || ""),
            approved: false
          });
          // If the profiles table is missing columns, saveProfileMetadata
          // returns missingFields so we can surface a loud admin warning.
          // Customer still sees success — their auth row is created and the
          // ref code is stashed in customer_settings. Admin just needs to run
          // migration 0007 to see the full profile.
          if(res && Array.isArray(res.missingFields) && res.missingFields.length > 0) {
            console.warn(`[SignupPage] profile partially saved — missing columns: ${res.missingFields.join(', ')}. Ask an admin to run migration 0007_profiles_columns.sql.`);
          }
        } catch (metaErr) { console.warn("Profile metadata save:", metaErr?.message || metaErr); }
        // Always mirror ref code to the customer_settings store so it survives even when
        // the profiles table is missing a ref_code column. This is what makes admin search
        // by ref code work reliably cross-device.
        try { await saveCustomerAssignment(userId, { refCode: code }); } catch (e) { /* best-effort */ }
      }
      setAcctCode(code);
      setStep(2);
      emailSignup({company:isRep?`${f.firstName} ${f.lastName} (Sales Rep)`:f.company, contact:`${f.firstName} ${f.lastName}`, email:f.email, tier:isRep?"Sales Rep":f.tier, phone:f.phone, address:fullAddress});
    } catch(err) {
      // Map common Supabase errors to friendly copy + per-field highlight.
      const raw = err?.message || "";
      if(/already.*registered|user.*already|duplicate/i.test(raw)) {
        setFieldErrs({email:true});
        setError("An account already exists with this email. Use a different email or sign in instead.");
      } else if(/invalid.*email|email.*invalid/i.test(raw)) {
        setFieldErrs({email:true});
        setError("That email address is not valid. Check for typos.");
      } else if(/password/i.test(raw)) {
        setFieldErrs({password:true});
        setError(raw);
      } else if(/rate limit|too many/i.test(raw)) {
        setError("Too many signup attempts. Wait a minute and try again.");
      } else {
        setError(raw || "Signup failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  if(step===2) return (
    <div style={S.signupPage}>
      <div style={S.signupLeft}>
        <img src="/mpc-logo.png" alt="MotorPower Care" style={{width:80,height:"auto",marginBottom:20,objectFit:"contain"}}/>
        <div style={{fontSize:32,fontWeight:700,color:C.white,lineHeight:1.2,marginBottom:16}}>Your application<br/>is submitted.</div>
        <div style={{fontSize:14,color:"rgba(255,255,255,0.6)",lineHeight:1.7}}>{signupRole==="rep"?"We review every sales rep application before granting portal access. You'll hear from us within 1 business day.":"Our team verifies every wholesale account before granting access. You'll hear from us within 1 business day."}</div>
      </div>
      <div style={S.signupRight}>
        <div style={S.signupForm}>
          <div style={{width:56,height:56,borderRadius:"50%",background:C.tealLight,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12l6 6L20 6" stroke={C.teal} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <div style={{fontSize:20,fontWeight:600,color:C.ink,marginBottom:6}}>Application received</div>
          <div style={{fontSize:13,color:C.inkLight,marginBottom:8}}>Submitted for <strong style={{color:C.ink}}>{signupRole==="rep"?`${f.firstName} ${f.lastName}`:f.company||"your company"}</strong></div>
          <div style={{background:C.tealLight,border:`1px solid ${C.teal}`,borderRadius:8,padding:"14px 16px",marginBottom:16,textAlign:"center"}}>
            <div style={{fontSize:11,fontWeight:600,color:C.teal,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:4}}>Your Account Reference Code</div>
            <div style={{fontSize:22,fontWeight:700,color:C.ink,letterSpacing:"0.04em",fontFamily:"monospace"}}>{acctCode}</div>
            <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>Save this code — you'll need it when contacting us</div>
          </div>
          <div style={{background:"#F0F4FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:600,color:"#1E40AF",marginBottom:6}}>{signupRole==="rep"?"Next step: Verification":"Next step: Send your documents"}</div>
            <div style={{fontSize:12,color:"#3B82F6",lineHeight:1.6}}>
              {signupRole==="rep"?<>Please email the following to <strong>info@mpcare.com</strong>:<br/>• Government-issued ID<br/>• Resume or sales experience summary<br/><br/><strong>Use this subject line:</strong></>:<>Please email the following to <strong>info@mpcare.com</strong>:<br/>• Resale certificate<br/>• EIN or company registration documents<br/><br/><strong>Use this subject line:</strong></>}
            </div>
            <div style={{background:"#fff",border:"1px solid #BFDBFE",borderRadius:6,padding:"8px 10px",marginTop:6,fontSize:12,color:C.ink,fontFamily:"monospace"}}>
              Account Docs — {acctCode} — {f.company||"Company Name"}
            </div>
          </div>
          <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:8,padding:"12px 14px",fontSize:13,color:C.amber,marginBottom:20}}>
            <strong>Pending review</strong> — We'll verify your documents and contact you at <strong>{f.email||"your email"}</strong> within 1 business day.
          </div>
          <button style={{...S.btnPrimary,width:"100%"}} onClick={onSubmit}>Back to sign in →</button>
        </div>
      </div>
    </div>
  );
  return (
    <div style={S.signupPage}>
      <div style={S.signupLeft}>
        <img src="/mpc-logo.png" alt="MotorPower Care" style={{width:80,height:"auto",marginBottom:20,objectFit:"contain"}}/>
        <div style={{fontSize:32,fontWeight:700,color:C.white,lineHeight:1.2,marginBottom:16}}>{signupRole==="rep"?"Join our<br/>sales team":"Join our wholesale<br/>network"}</div>
        <div style={{fontSize:14,color:"rgba(255,255,255,0.6)",lineHeight:1.7,marginBottom:32}}>{signupRole==="rep"?"Earn commission on every sale. Get your own portal with inventory, invoices, route planning, and more.":"Distributor pricing, bulk discounts, and a dedicated sales rep — all from one platform."}</div>
        {signupRole==="rep"?[["Commission","Earn 6-8% commission on every sale"],["Territory","Manage your own route and customer base"],["Tools","Access inventory, invoicing, training, and tool lending"]].map(([t,d])=>(
          <div key={t} style={{padding:"11px 14px",borderRadius:10,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:600,color:C.white,marginBottom:2}}>{t}</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.5)"}}>{d}</div>
          </div>
        )):[["Dealer",portalContent.tierDealer],["Distributor",portalContent.tierDistributor],["Enterprise",portalContent.tierEnterprise]].map(([t,d])=>(
          <div key={t} style={{padding:"11px 14px",borderRadius:10,background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:600,color:C.white,marginBottom:2}}>{t}</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.5)"}}>{d}</div>
          </div>
        ))}
        <div style={{marginTop:24,fontSize:13,color:"rgba(255,255,255,0.45)"}}>Already approved? <span style={{color:"rgba(100,160,255,0.9)",cursor:"pointer"}} onClick={onSubmit}>Sign in →</span></div>
      </div>
      <div style={S.signupRight}>
        <div style={S.signupForm}>
          <div style={{fontSize:24,fontWeight:700,color:C.ink,marginBottom:6}}>Create your account</div>
          <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>Reviewed within 1 business day.</div>

          {/* Role toggle */}
          <div style={{display:"flex",gap:0,marginBottom:20,border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden"}}>
            <button onClick={()=>setSignupRole("customer")} style={{flex:1,padding:"10px",border:"none",fontSize:13,fontWeight:600,cursor:"pointer",background:signupRole==="customer"?C.blue:"#F8FAFC",color:signupRole==="customer"?"#fff":C.inkMid,transition:"all 0.15s"}}>Customer / Distributor</button>
            <button onClick={()=>setSignupRole("rep")} style={{flex:1,padding:"10px",border:"none",borderLeft:`1px solid ${C.border}`,fontSize:13,fontWeight:600,cursor:"pointer",background:signupRole==="rep"?C.teal:"#F8FAFC",color:signupRole==="rep"?"#fff":C.inkMid,transition:"all 0.15s"}}>Sales Representative</button>
          </div>

          {signupRole==="customer"?(<>
          <div style={S.secLabel}>Business information</div>
          <div style={S.fg}><label style={S.label}>Company name *</label><input style={inpStyle("company")} value={f.company} onChange={e=>set("company",e.target.value)} placeholder="Apex Car Care LLC"/></div>
          <div style={S.twoCol}>
            <div style={S.fg}><label style={S.label}>EIN (Tax ID) *</label><input style={inpStyle("ein")} value={f.ein} onChange={e=>set("ein",e.target.value)} placeholder="XX-XXXXXXX"/></div>
            <div style={S.fg}><label style={S.label}>Account type *</label><select style={S.select} value={f.tier} onChange={e=>set("tier",e.target.value)}><option value="dealer">Dealer</option><option value="distributor">Distributor</option><option value="enterprise">Enterprise</option></select></div>
          </div>
          <div style={S.fg}><label style={S.label}>Business address *</label><input style={inpStyle("address")} value={f.address} onChange={e=>set("address",e.target.value)} placeholder="1234 Industrial Blvd, Suite 100"/></div>
          <div style={S.threeCol}>
            <div style={S.fg}><label style={S.label}>City *</label><input style={inpStyle("city")} value={f.city} onChange={e=>set("city",e.target.value)} placeholder="San Diego"/></div>
            <div style={S.fg}><label style={S.label}>State *</label><input style={inpStyle("state")} value={f.state} onChange={e=>set("state",e.target.value)} placeholder="CA"/></div>
            <div style={S.fg}><label style={S.label}>ZIP *</label><input style={inpStyle("zip")} value={f.zip} onChange={e=>set("zip",e.target.value)} placeholder="92101"/></div>
          </div>
          </>):(<>
          <div style={S.secLabel}>Rep information</div>
          <div style={S.fg}><label style={S.label}>Territory / region *</label><input style={inpStyle("territory")} value={f.territory} onChange={e=>set("territory",e.target.value)} placeholder="e.g. Southern California, Phoenix metro"/></div>
          </>)}

          <div style={S.secLabel}>{signupRole==="rep"?"Personal information":"Contact person"}</div>
          <div style={S.twoCol}>
            <div style={S.fg}><label style={S.label}>First name *</label><input style={inpStyle("firstName")} value={f.firstName} onChange={e=>set("firstName",e.target.value)} placeholder={signupRole==="rep"?"Marcus":"John"}/></div>
            <div style={S.fg}><label style={S.label}>Last name *</label><input style={inpStyle("lastName")} value={f.lastName} onChange={e=>set("lastName",e.target.value)} placeholder={signupRole==="rep"?"Thompson":"Smith"}/></div>
          </div>
          <div style={S.twoCol}>
            <div style={S.fg}><label style={S.label}>{signupRole==="rep"?"Email *":"Business email *"}</label><input style={inpStyle("email")} type="email" value={f.email} onChange={e=>set("email",e.target.value)} placeholder={signupRole==="rep"?"marcus@email.com":"john@apexcarcare.com"}/></div>
            <div style={S.fg}><label style={S.label}>Phone *</label><input style={inpStyle("phone")} value={f.phone} onChange={e=>set("phone",e.target.value)} placeholder="(619) 555-0100"/></div>
          </div>
          <div style={S.fg}><label style={S.label}>Password * <span style={{fontWeight:400,color:C.inkLight}}>(at least 6 characters)</span></label><input style={inpStyle("password")} type="password" value={f.password} onChange={e=>set("password",e.target.value)} placeholder="Create a password"/></div>
          {signupRole==="customer"&&(<>
          <div style={S.secLabel}>Sales representative (optional)</div>
          <div style={S.fg}><label style={S.label}>Assigned sales rep name</label><input style={S.input} value={f.repName} onChange={e=>set("repName",e.target.value)} placeholder="e.g. Marcus T. (leave blank if none)"/></div>
          </>)}
          <div style={{background:signupRole==="rep"?C.tealLight:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:signupRole==="rep"?C.teal:"#1D4ED8",marginBottom:18}}>{signupRole==="rep"?portalContent.signupBlurbRep:portalContent.signupBlurbCustomer}</div>
          {error&&<div style={{background:"#FEE2E2",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#B91C1C",marginBottom:10}}>{error}</div>}
          <button style={{...S.btnPrimary,width:"100%",padding:"12px 20px",fontSize:14,opacity:loading?0.7:1}} onClick={handleSignup} disabled={loading}>{loading?"Submitting...":"Submit application →"}</button>
        </div>
      </div>
    </div>
  );
}

// ── SIDEBAR ───────────────────────────────────────────────────────────────────
function Sidebar({page,setPage,activeProd,setActiveProd,cartCount,assignedRep}) {
  return (
    <div style={S.sidebar}>
      <div style={S.sidebarLogo}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <img src="/mpc-logo.png" alt="MPC" style={{width:36,height:36,objectFit:"contain"}}/>
          <div>
            <div style={{fontSize:14,fontWeight:600,color:C.white}}>MotorPower Care</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",marginTop:1}}>Wholesale portal</div>
          </div>
        </div>
      </div>
      <div style={{padding:"10px 0"}}>
        {[["dashboard","Dashboard"],["orders","My orders"],["cart",`Cart${cartCount>0?` (${cartCount})`:""}` ],["invoices","Invoices"]].map(([key,label])=>(
          <div key={key} style={{...S.navItem,...(page===key?S.navActive:{})}} onClick={()=>setPage(key)}>{label}</div>
        ))}
      </div>
      <div style={S.navDiv}/>
      <div style={{padding:"8px 0 4px"}}>
        <div style={S.catLabel}>Shop resources</div>
        {[["cust-training","Training & demos"],["cust-marketing","Marketing materials"],["cust-tools","Tool lending"],["cust-team","My team & certification"]].map(([key,label])=>(
          <div key={key} style={{...S.navItem,...(page===key?S.navActive:{})}} onClick={()=>setPage(key)}>{label}</div>
        ))}
      </div>
      <div style={S.navDiv}/>
      <div style={{padding:"8px 0 4px"}}>
        <div style={S.catLabel}>Catalog</div>
        <div style={{...S.navItem,...(page==="catalog"?S.navActive:{})}} onClick={()=>setPage("catalog")}>
          <span style={{fontSize:15}}>◫</span> Products
        </div>
      </div>
      <div style={S.navDiv}/>
      <div style={S.sideFooter}>
        {assignedRep&&assignedRep.name?(
          <div style={{background:"rgba(255,255,255,0.06)",borderRadius:8,padding:"10px 12px"}}>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:3}}>Your sales rep</div>
            <div style={{fontSize:12,fontWeight:500,color:C.white}}>{assignedRep.name}</div>
            {assignedRep.phone&&<div style={{fontSize:11,color:"rgba(100,160,255,0.85)",marginTop:2}}>{assignedRep.phone}</div>}
            {assignedRep.email&&<div style={{fontSize:11,color:"rgba(100,160,255,0.85)",marginTop:1}}>{assignedRep.email}</div>}
          </div>
        ):(
          <div style={{background:"rgba(255,255,255,0.06)",borderRadius:8,padding:"10px 12px"}}>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.35)",marginBottom:3}}>Your sales rep</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.35)",fontStyle:"italic"}}>Not yet assigned</div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── DASHBOARD ─────────────────────────────────────────────────────────────────
function Dashboard({setPage,setActiveProd,onAddToCart,cart,isDemo,customerName,creditLimit=0,customerTier="",userId=""}) {
  const dashCart = cart || [];
  const dashCartTotal = dashCart.reduce((s,i)=>s+(i.lineTotal||0),0);
  const dashShipCfg = SHARED_SETTINGS.getShipping();
  const dashFreeGap = dashShipCfg.enableFreeShipping ? Math.max(0, dashShipCfg.freeThreshold - dashCartTotal) : 0;
  const dashFreePct = dashShipCfg.enableFreeShipping ? Math.min(100, Math.round(dashCartTotal/dashShipCfg.freeThreshold*100)) : 0;
  // Live catalog — all product reads on the dashboard go through this so admin
  // price/SKU edits in Supabase appear here without a reload.
  const [liveProducts, setLiveProducts] = useState(() => SHARED_PRODUCTS.getActive());
  useEffect(() => SHARED_PRODUCTS.subscribe(({products}) => setLiveProducts(products)), []);
  // Live invoices for THIS customer — powers every stat card + Recent orders.
  // Subscribing keeps the dashboard fresh when a rep creates an invoice or
  // admin updates status, same pattern other portal views use.
  const [sharedInvoices, setSharedInvoices] = useState(() => SHARED_INVOICES.getAll());
  useEffect(() => SHARED_INVOICES.subscribe(setSharedInvoices), []);
  // Filter invoices to this customer. Match by id (userId or user_id on the
  // invoice, captured at order/invoice time) OR by company name for legacy
  // rep-created invoices that predate stable id stamping.
  const myInvoices = useMemo(() => {
    const normName = (customerName||"").trim().toLowerCase();
    return (sharedInvoices || []).filter(inv => {
      if (!inv || inv.status === "cancelled") return false;
      const invId = inv.userId || inv.user_id || "";
      if (invId && userId && invId === userId) return true;
      if (normName && String(inv.customer||"").trim().toLowerCase() === normName) return true;
      return false;
    });
  }, [sharedInvoices, customerName, userId]);
  // Metrics derived from the filtered invoice list.
  const stats = useMemo(() => {
    const now = new Date();
    const thisMonth = now.getMonth(), thisYear = now.getFullYear();
    let monthRev = 0, yearRev = 0, outstanding = 0;
    const openOrders = [];
    const outstandingList = [];
    myInvoices.forEach(inv => {
      const total = Number(inv.total) || 0;
      const isPaid = inv.status === "paid" || inv.status === "done";
      const d = inv.sharedAt ? new Date(inv.sharedAt) : (inv.date ? new Date(inv.date) : null);
      if (d && !isNaN(d)) {
        if (d.getFullYear() === thisYear) yearRev += total;
        if (d.getFullYear() === thisYear && d.getMonth() === thisMonth) monthRev += total;
      } else {
        // Unknown-date invoices still count toward YTD by default.
        yearRev += total;
      }
      if (!isPaid) {
        outstanding += total;
        outstandingList.push(inv);
      }
      // "Open" = not paid AND not delivered/cancelled (still in the fulfilment pipeline)
      if (!isPaid && inv.shippingStatus !== "delivered" && inv.shippingStatus !== "cancelled") {
        openOrders.push(inv);
      }
    });
    const creditAvail = Math.max(0, (Number(creditLimit)||0) - outstanding);
    return { monthRev, yearRev, openOrders, outstanding, outstandingList, creditAvail };
  }, [myInvoices, creditLimit]);
  // Default quick-reorder rows: pick the 3 most-bought SKUs from this
  // customer's history, falling back to the first 3 active catalog items if
  // they have no orders yet. No hardcoded SKUs — admin can add/remove
  // products and the defaults still make sense.
  const defaultQrRows = useMemo(() => {
    const skuCounts = {};
    myInvoices.forEach(inv => (inv.items||[]).forEach(it => {
      if (it?.sku) skuCounts[it.sku] = (skuCounts[it.sku] || 0) + (Number(it.qty)||0);
    }));
    const sortedSkus = Object.entries(skuCounts).sort((a,b)=>b[1]-a[1]).slice(0,3).map(([sku])=>sku);
    if (sortedSkus.length > 0) return sortedSkus.map(sku => ({ sku, qty: 1 }));
    return (liveProducts || []).slice(0, 3).map(p => ({ sku: p.sku, qty: 1 }));
  }, [myInvoices, liveProducts]);
  const [qrRows,setQrRows]=useState(defaultQrRows);
  // If the user had no history on first load but the catalog hydrates later,
  // seed the rows from the now-populated catalog. Only fires once, never
  // overwrites user edits.
  const seededRef = useRef(false);
  useEffect(() => {
    if (!seededRef.current && qrRows.every(r => !r.sku) && defaultQrRows.length > 0) {
      setQrRows(defaultQrRows);
      seededRef.current = true;
    }
  }, [defaultQrRows, qrRows]);
  const [qrResult,setQrResult]=useState(null);
  const [qrMsg,setQrMsg]=useState("");
  const addQrRow=()=>setQrRows(r=>[...r,{sku:"",qty:1}]);
  const calcQr=()=>{
    const results=qrRows.filter(r=>r.sku).map(r=>{
      const p=liveProducts.find(x=>x.sku===r.sku);
      if(!p) return {sku:r.sku,name:"Not found",qty:r.qty,total:0};
      return {sku:r.sku,name:p.name,qty:r.qty,unitPrice:p.price,caseQty:p.case,total:p.price*p.case*r.qty,product:p};
    });
    const grandTotal=results.reduce((s,r)=>s+r.total,0);
    setQrResult({items:results,total:grandTotal});
  };
  // Make Quick reorder actually re-order — adds every priced row to the
  // cart, then takes the user straight to Cart so they can checkout. Skips
  // any "Not found" rows so bad SKUs don't break the add.
  const addQrToCart=()=>{
    if (!qrResult) calcQr();
    const rows = (qrResult?.items || []).filter(r => r.product && r.total > 0);
    if (rows.length === 0) {
      setQrMsg("Enter valid SKUs first — Calculate pricing to verify.");
      setTimeout(()=>setQrMsg(""), 3000);
      return;
    }
    rows.forEach(r => onAddToCart(r.product, r.qty, "full"));
    setQrMsg(`Added ${rows.length} item${rows.length===1?"":"s"} to cart.`);
    setTimeout(()=>setQrMsg(""), 2500);
  };
  const pasteSkus=async()=>{
    try{const txt=await navigator.clipboard.readText();const lines=txt.split(/[\n,;]+/).map(s=>s.trim()).filter(Boolean);
      const newRows=lines.map(l=>{const parts=l.split(/\s+/);return{sku:parts[0]||"",qty:parseInt(parts[1])||1};});
      if(newRows.length>0){setQrRows(newRows);setQrResult(null);}
    }catch(e){/* clipboard access denied */}
  };
  return (
    <div style={S.content}>
      <div style={S.metrics}>
        {(isDemo ? [
          {l:"This month",v:"$4,820",s:"↑ 12% vs last month",up:true,pg:"orders"},
          {l:"This year",v:"$38,450",s:"↑ 18% vs 2024",up:true,pg:"orders"},
          {l:"Open orders",v:"3",s:"2 in transit",pg:"orders"},
          {l:"Credit available",v:"$6,200",s:"Net 30 terms",pg:"invoices"},
          {l:"Outstanding",v:"$1,450",s:"Due in 14 days",warn:true,pg:"invoices"}
        ] : [
          {l:"This month",     v:`$${stats.monthRev.toFixed(2)}`,    s: stats.monthRev>0 ? `${myInvoices.filter(i=>{const d=i.sharedAt?new Date(i.sharedAt):(i.date?new Date(i.date):null);return d&&!isNaN(d)&&d.getMonth()===new Date().getMonth()&&d.getFullYear()===new Date().getFullYear();}).length} invoice${stats.monthRev>0?"s":""} this month` : "Place your first order", pg:"orders"},
          {l:"This year",      v:`$${stats.yearRev.toFixed(2)}`,     s: myInvoices.length>0 ? `${myInvoices.length} invoice${myInvoices.length===1?"":"s"} total` : "—", pg:"orders"},
          {l:"Open orders",    v:`${stats.openOrders.length}`,       s: stats.openOrders.length>0 ? `${stats.openOrders.filter(o=>o.shippingStatus==="shipped").length} shipped, ${stats.openOrders.filter(o=>!o.shippingStatus||o.shippingStatus==="pending").length} processing` : "—", pg:"orders"},
          {l:"Credit available", v:`$${stats.creditAvail.toFixed(2)}`, s: creditLimit>0 ? `of $${Number(creditLimit).toFixed(2)} limit${customerTier?` · ${customerTier}`:""}` : "Contact MPCare to set credit", pg:"invoices"},
          {l:"Outstanding",    v:`$${stats.outstanding.toFixed(2)}`, s: stats.outstanding>0 ? `${stats.outstandingList.length} unpaid invoice${stats.outstandingList.length===1?"":"s"}` : "No balance", warn: stats.outstanding>0, pg:"invoices"}
        ]).map(m=>(
          <div key={m.l} style={{...S.metric,...(m.warn?{borderTop:`3px solid ${C.amber}`}:{}),cursor:"pointer"}} onClick={()=>setPage(m.pg)}>
            <div style={S.mLabel}>{m.l}</div>
            <div style={S.mValue}>{m.v}</div>
            <div style={{...S.mSub,...(m.up?{color:C.teal}:{}),...(m.warn?{color:C.amber}:{})}}>{m.s}</div>
          </div>
        ))}
      </div>
      {dashShipCfg.enableFreeShipping && (
        <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 18px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <div style={{fontSize:13,fontWeight:500,color:C.ink,marginBottom:6}}>Free shipping threshold</div>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:220,height:6,background:C.border,borderRadius:3,overflow:"hidden"}}><div style={{width:dashFreePct+"%",height:"100%",background:dashFreeGap===0?C.teal:C.blue,borderRadius:3,transition:"width 0.3s"}}/></div>
              <span style={{fontSize:12,color:C.inkLight}}>
                {dashFreeGap===0 ? <strong style={{color:C.teal}}>Free shipping unlocked!</strong> : <>${dashCartTotal.toFixed(0)} of ${dashShipCfg.freeThreshold} — add <strong style={{color:C.teal}}>${dashFreeGap.toFixed(2)}</strong> for free shipping</>}
              </span>
            </div>
          </div>
          <button style={S.btnPrimary} onClick={()=>setPage("cart")}>View cart →</button>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"1fr 300px",gap:16}}>
        <div style={S.card}>
          <div style={S.cardHdr}><span style={S.cardTitle}>Recent orders</span><span style={{fontSize:12,color:C.blue,cursor:"pointer"}} onClick={()=>setPage("orders")}>View all</span></div>
          {isDemo ? RECENT_ORDERS.slice(0,4).map(o=>(
            <div key={o.id} style={{display:"grid",gridTemplateColumns:"76px 1fr 68px 90px 56px",alignItems:"center",gap:8,padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
              <span style={{fontWeight:600,color:C.ink}}>{o.id}</span>
              <span style={{color:C.inkLight}}>{o.date}</span>
              <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${o.amount.toLocaleString()}</span>
              <StatusLabel s={o.status}/>
              <span style={{fontSize:11,color:C.blue,cursor:"pointer",textAlign:"right"}} onClick={()=>setPage("orders")}>Reorder</span>
            </div>
          )) : (myInvoices.length === 0 ? (
            <div style={{padding:"24px 18px",textAlign:"center",color:C.inkLight,fontSize:13}}>No orders yet — <span style={{color:C.blue,cursor:"pointer"}} onClick={()=>setPage("catalog")}>browse products</span> to place your first order.</div>
          ) : (
            [...myInvoices]
              .sort((a,b)=>{ const da=a.sharedAt?new Date(a.sharedAt):(a.date?new Date(a.date):new Date(0)); const db=b.sharedAt?new Date(b.sharedAt):(b.date?new Date(b.date):new Date(0)); return db - da; })
              .slice(0,4)
              .map(o=>{
                const isPaid = o.status==="paid" || o.status==="done";
                return (
                  <div key={o.id} style={{display:"grid",gridTemplateColumns:"84px 1fr 80px 96px 70px",alignItems:"center",gap:8,padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                    <span style={{fontWeight:600,color:C.ink,fontFamily:"monospace",fontSize:11}}>{o.id}</span>
                    <span style={{color:C.inkLight}}>{o.date||""}</span>
                    <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${(Number(o.total)||0).toFixed(2)}</span>
                    <InvoicePill inv={o}/>
                    <span style={{fontSize:11,color:C.blue,cursor:"pointer",textAlign:"right"}} onClick={()=>setPage(isPaid?"orders":"invoices")}>View</span>
                  </div>
                );
              })
          ))}
        </div>
        <div style={S.card}>
          <div style={S.cardHdr}><span style={S.cardTitle}>Quick reorder</span><button style={S.btnGhost} onClick={pasteSkus}>Paste SKUs</button></div>
          <div style={{padding:"14px 18px"}}>
            {qrRows.map((r,i)=>(
              <div key={i} style={{display:"flex",gap:8,marginBottom:6}}>
                <input value={r.sku} onChange={e=>{const v=e.target.value;setQrRows(rows=>rows.map((rr,j)=>j===i?{...rr,sku:v}:rr));setQrResult(null);}} placeholder="SKU" style={{...S.input,flex:1,fontSize:12,padding:"7px 10px"}}/>
                <input value={r.qty} type="number" min="1" onChange={e=>{const v=parseInt(e.target.value)||1;setQrRows(rows=>rows.map((rr,j)=>j===i?{...rr,qty:v}:rr));setQrResult(null);}} style={{...S.input,width:52,fontSize:12,padding:"7px 10px"}}/>
                {qrRows.length>1&&<button onClick={()=>setQrRows(rows=>rows.filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:C.inkLight,cursor:"pointer",fontSize:14}}>×</button>}
              </div>
            ))}
            <button style={S.btnGhost} onClick={addQrRow}>+ Add row</button>
            <div style={{marginTop:10,display:"flex",gap:6,flexWrap:"wrap"}}>
              <button style={{...S.btnSecondary,fontSize:12,padding:"7px 14px"}} onClick={calcQr}>Calculate pricing</button>
              {qrResult && qrResult.items.some(r=>r.product && r.total>0) && (
                <button style={{...S.btnPrimary,fontSize:12,padding:"7px 14px"}} onClick={addQrToCart}>Add all to cart →</button>
              )}
            </div>
            {qrMsg && <div style={{marginTop:8,fontSize:11,color:qrMsg.startsWith("Added")?C.green:C.red}}>{qrMsg}</div>}
            {qrResult&&(
              <div style={{marginTop:10,borderTop:`1px solid ${C.border}`,paddingTop:10}}>
                {qrResult.items.map((item,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"3px 0",color:item.name==="Not found"?C.red:C.ink}}>
                    <span>[{item.sku}] {item.name} ×{item.qty}{item.caseQty?` (${item.caseQty}/case)`:""}</span>
                    <span style={{fontWeight:600}}>{item.total>0?`$${item.total.toFixed(2)}`:"—"}</span>
                  </div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,fontWeight:600,marginTop:6,paddingTop:6,borderTop:`1px solid ${C.border}`,color:C.ink}}>
                  <span>Total</span><span>${qrResult.total.toFixed(2)}</span>
                </div>
              </div>
            )}
          </div>
          {dashShipCfg.enableFreeShipping&&dashFreeGap>0&&<div style={{margin:"0 18px 14px",background:C.tealLight,borderRadius:8,padding:"8px 12px",fontSize:12,color:C.teal,border:`1px solid #9FE1CB`}}>Add ${dashFreeGap.toFixed(2)} more for free shipping</div>}
          {dashShipCfg.enableFreeShipping&&dashFreeGap===0&&<div style={{margin:"0 18px 14px",background:C.tealLight,borderRadius:8,padding:"8px 12px",fontSize:12,color:C.teal,border:`1px solid #9FE1CB`}}>Free shipping unlocked!</div>}
        </div>
      </div>
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Featured products — distributor pricing</span><button style={S.btnGhost} onClick={()=>setPage("catalog")}>Browse all</button></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)"}}>
          {(()=>{
            // Look up the four featured SKUs from the live (Supabase-backed) catalog so
            // admin price/name edits show up here. Fall back to the first 4 active
            // products if admin deleted any of the originals.
            const wantSkus=["7001","808","7000","8101"];
            const featured=wantSkus.map(sku=>liveProducts.find(p=>p.sku===sku)).filter(Boolean);
            return featured.length===4?featured:liveProducts.slice(0,4);
          })().map((p,i)=>(
            <div key={p.sku} style={{padding:"14px 18px",borderRight:i<3?`1px solid ${C.border}`:"none",cursor:"pointer",transition:"background 0.15s"}} onClick={()=>{setActiveProd(p);setPage("product");}} onMouseEnter={e=>e.currentTarget.style.background=C.surface} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:8}}>
                <ProductImage sku={p.sku} name={p.name} color={CAT_COLORS[p.category]||C.navy} size={44} imageUrl={p.imageUrl}/>
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontSize:10,color:C.inkLight,textTransform:"uppercase",marginBottom:4}}>SKU {p.sku}</div>
                  <div style={{fontSize:13,fontWeight:600,color:C.ink}}>{p.name}</div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div><div style={{fontSize:14,fontWeight:600,color:C.ink}}>${p.price.toFixed(2)}/unit</div><div style={{fontSize:11,color:C.inkLight}}>Case of {p.case}</div></div>
                <button style={S.btnSmall} onClick={(e)=>{e.stopPropagation();onAddToCart(p,1,"full")}}>+ Cart</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── MIX & MATCH PRODUCT PICKER ─────────────────────────────────────────────
// Searchable dropdown for mix-and-match: shows admin-edited products + kits, SKU first, with search
function MixProductPicker({value, onChange}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  // Use admin-edited active products + kits from shared store (not hardcoded ALL_PRODUCTS)
  const allItems = [...SHARED_PRODUCTS.getActive(), ...SHARED_PRODUCTS.getActiveKits().map(k=>({...k,isKit:true}))];
  const selected = allItems.find(p => p.sku === value);
  const q = search.toLowerCase();
  const filtered = q ? allItems.filter(p => p.sku.toLowerCase().includes(q) || p.name.toLowerCase().includes(q)) : allItems;
  return (
    <div style={{flex:1,position:"relative"}}>
      <input
        style={{...S.input,fontSize:11,padding:"6px 8px",width:"100%",boxSizing:"border-box"}}
        value={open ? search : (selected ? `[${selected.sku}] ${selected.name}` : "")}
        placeholder="Search SKU or product name…"
        onFocus={() => { setOpen(true); setSearch(""); }}
        onChange={e => { setSearch(e.target.value); if(!open) setOpen(true); }}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
      />
      {open && (
        <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:999,background:"#fff",border:`1px solid ${C.border}`,borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",maxHeight:240,overflowY:"auto",marginTop:2}}>
          {filtered.length === 0 && <div style={{padding:12,fontSize:11,color:C.inkLight,textAlign:"center"}}>No products found</div>}
          {filtered.map(p => (
            <div key={p.sku} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 10px",cursor:"pointer",borderBottom:`1px solid ${C.surface}`,transition:"background 0.1s"}}
              onMouseDown={e => e.preventDefault()}
              onMouseEnter={e => e.currentTarget.style.background=C.blueLight}
              onMouseLeave={e => e.currentTarget.style.background="transparent"}
              onClick={() => { onChange(p.sku); setOpen(false); setSearch(""); }}>
              <div style={{display:"flex",alignItems:"center",gap:6,minWidth:0,overflow:"hidden"}}>
                <span style={{fontWeight:600,color:C.blue,fontFamily:"monospace",fontSize:11,flexShrink:0}}>{p.sku}</span>
                <span style={{color:C.ink,fontSize:11,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.name}</span>
                {p.isKit && <span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:4,background:"#EDE9FE",color:"#7C3AED",flexShrink:0}}>KIT</span>}
              </div>
              <span style={{fontSize:11,color:C.inkLight,flexShrink:0,marginLeft:8}}>${p.price.toFixed(2)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── PRODUCT DETAIL ────────────────────────────────────────────────────────────
function ProductDetail({product:p,onAddToCart,onSelectProduct}) {
  const [qty,setQty]=useState(1);
  const [orderMode,setOrderMode]=useState("full");
  const [mixItems,setMixItems]=useState([{sku:p?.sku||"",qty:p?Math.floor(p.case/2):6}]);
  // Live catalog — related products + category label read from SHARED_PRODUCTS
  // so admin edits propagate. Hook must stay before the early return below.
  const [liveProducts, setLiveProducts] = useState(() => SHARED_PRODUCTS.getActive());
  useEffect(() => SHARED_PRODUCTS.subscribe(({products}) => setLiveProducts(products)), []);
  // PR-V2A: variation matrix state. variationQtys is keyed by variation SKU
  // and stores the case count the customer wants for each. Resets whenever
  // the active product changes so case counts don't leak between products.
  const variations = Array.isArray(p?.variations) ? p.variations : [];
  const hasVariations = variations.length > 0;
  const [variationQtys, setVariationQtys] = useState({});
  useEffect(() => { setVariationQtys({}); }, [p?.sku]);
  if(!p) return <div style={{...S.content,display:"flex",alignItems:"center",justifyContent:"center",color:C.inkLight}}>Select a product from the sidebar</div>;
  const halfCase=Math.ceil(p.case/2);
  const unitPrice=qty>=20?p.price*0.81:qty>=6?p.price*0.90:p.price;
  // Variation totals for the matrix: line per variation = price * case * qty.
  // Volume tier discounts (6+/20+) are deliberately NOT applied per-variation
  // in V2A. If admin wants cross-variation volume pricing later that's a
  // polish follow-up.
  const variationTotal = hasVariations
    ? variations.reduce((s, v) => {
        const cases = Number(variationQtys[v.sku]) || 0;
        return s + (Number(v.price) || 0) * (Number(p.case) || 0) * cases;
      }, 0)
    : 0;
  const variationTotalCases = hasVariations
    ? variations.reduce((s, v) => s + (Number(variationQtys[v.sku]) || 0), 0)
    : 0;
  const addAllVariationsToCart = () => {
    const rows = variations
      .map(v => ({ sku: v.sku, label: v.label || "", price: Number(v.price) || 0, qty: Number(variationQtys[v.sku]) || 0 }))
      .filter(r => r.qty > 0);
    if (rows.length === 0) return;
    onAddToCart(p, 0, "variation-batch", rows);
    setVariationQtys({});
  };
  const tagColor={blue:{background:C.blueLight,color:"#1D4ED8"},green:{background:C.tealLight,color:C.teal},amber:{background:C.amberLight,color:C.amber}};
  const addMixRow=()=>setMixItems(m=>[...m,{sku:"",qty:6}]);
  const setMixRow=(i,k,v)=>setMixItems(m=>m.map((r,ri)=>ri===i?{...r,[k]:v}:r));
  const removeMixRow=(i)=>setMixItems(m=>m.filter((_,ri)=>ri!==i));
  // Use admin-edited products + kits for mix total (not hardcoded ALL_PRODUCTS)
  const mixAllItems=[...SHARED_PRODUCTS.getActive(),...SHARED_PRODUCTS.getActiveKits()];
  const mixTotal=mixItems.reduce((s,r)=>{const prod=mixAllItems.find(x=>x.sku===r.sku);return s+(prod?prod.price*r.qty:0);},0);
  const catColor = CAT_COLORS[p.category] || C.navy;
  return (
    <div style={S.content}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 250px",gap:24,marginBottom:16}}>
        <div style={{display:"flex",gap:18,alignItems:"flex-start"}}>
          <ProductImage sku={p.sku} name={p.name} color={catColor} size={140} imageUrl={p.imageUrl}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:11,fontWeight:600,padding:"3px 9px",borderRadius:8,background:C.blueLight,color:"#1D4ED8",display:"inline-block",marginBottom:10}}>
              {CAT_LABELS[p.category] ?? ""}
            </div>
            <div style={{fontSize:22,fontWeight:700,color:C.ink,marginBottom:6,lineHeight:1.2}}>{p.name}</div>
            <div style={{fontSize:12,color:C.inkLight,marginBottom:12}}>SKU {p.sku} &nbsp;·&nbsp; Full case: {p.case} units &nbsp;·&nbsp; Half case: {halfCase} units</div>
            <div style={{fontSize:13,color:C.inkMid,lineHeight:1.65,maxWidth:500}}>{p.desc}</div>
          </div>
        </div>
        <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:12,padding:18}}>
          {/* PR-V2A: when product has variations, replace the Full/Half/Mix
              ordering UI with a per-variation matrix. Each row carries an
              independent qty input and the customer adds all selected
              variations to cart in a single click. Products without
              variations render the existing UI unchanged. */}
          {hasVariations ? (
            <div>
              <div style={{fontSize:11,fontWeight:600,color:C.inkLight,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.04em"}}>Choose sizes / models</div>
              <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",marginBottom:12}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 60px 70px 70px",gap:6,padding:"7px 10px",background:C.surface,fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.04em",borderBottom:`1px solid ${C.border}`}}>
                  <span>Size / Model</span><span style={{textAlign:"right"}}>Stock</span><span style={{textAlign:"right"}}>$/unit</span><span style={{textAlign:"center"}}>Cases</span>
                </div>
                {variations.map(v => {
                  const stock = Number(v.stock) || 0;
                  const price = Number(v.price) || 0;
                  const currentQty = Number(variationQtys[v.sku]) || 0;
                  return (
                    <div key={v.sku} style={{display:"grid",gridTemplateColumns:"1fr 60px 70px 70px",gap:6,padding:"8px 10px",alignItems:"center",fontSize:12,borderBottom:`1px solid ${C.border}`}}>
                      <div>
                        <div style={{fontWeight:600,color:C.ink}}>{v.label || v.sku}</div>
                        <div style={{fontSize:10,color:C.inkLight,fontFamily:"monospace"}}>{v.sku}</div>
                      </div>
                      <div style={{textAlign:"right",color:stock>0?C.teal:C.red,fontWeight:500}}>{stock}</div>
                      <div style={{textAlign:"right",color:C.ink,fontWeight:500}}>${price.toFixed(2)}</div>
                      <input
                        type="number"
                        min="0"
                        value={currentQty || ""}
                        onChange={e=>{
                          const n = parseInt(e.target.value) || 0;
                          setVariationQtys(q => ({...q, [v.sku]: n < 0 ? 0 : n}));
                        }}
                        placeholder="0"
                        style={{...S.input,width:"100%",fontSize:12,padding:"6px 8px",textAlign:"center"}}
                      />
                    </div>
                  );
                })}
              </div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,fontSize:13}}>
                <span style={{color:C.inkLight}}>{variationTotalCases} case{variationTotalCases===1?"":"s"} ({variationTotalCases * (Number(p.case)||0)} units)</span>
                <span style={{fontWeight:700,color:C.ink}}>Total: ${variationTotal.toFixed(2)}</span>
              </div>
              <button
                style={{...S.btnPrimary,width:"100%",opacity:variationTotalCases>0?1:0.5,cursor:variationTotalCases>0?"pointer":"not-allowed"}}
                disabled={variationTotalCases===0}
                onClick={addAllVariationsToCart}
              >Add all to cart</button>
              <div style={{fontSize:10,color:C.inkLight,marginTop:6,lineHeight:1.5,fontStyle:"italic"}}>
                Each size adds as a separate cart line. Enter the case count for any sizes you want, then click Add all.
              </div>
            </div>
          ) : (
            <>
          <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>Your distributor price</div>
          <div style={{fontSize:22,fontWeight:700,color:C.ink,marginBottom:12}}>${unitPrice.toFixed(2)}/unit</div>
          {/* order mode tabs */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",marginBottom:14}}>
            {[["full","Full case"],["half","Half case"],["mix","Mix & match"]].map(([mode,label])=>(
              <div key={mode} onClick={()=>setOrderMode(mode)} style={{padding:"7px 4px",textAlign:"center",fontSize:11,fontWeight:500,cursor:"pointer",background:orderMode===mode?C.navy:C.white,color:orderMode===mode?C.white:C.inkMid,borderRight:mode!=="mix"?`1px solid ${C.border}`:"none",transition:"all 0.15s"}}>{label}</div>
            ))}
          </div>
          {orderMode==="full" && (
            <div>
              <div style={{fontSize:11,color:C.inkLight,marginBottom:8}}>Volume pricing</div>
              {[["1–5 cases",p.price,""],["6–20 cases",p.price*0.90,"save 10%"],["20+ cases",p.price*0.81,"save 19%"]].map(([label,pr,save])=>(
                <div key={label} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"4px 0",borderBottom:`1px solid ${C.border}`}}>
                  <span style={{color:C.inkLight}}>{label}</span>
                  <span style={{fontWeight:500,color:C.ink}}>${pr.toFixed(2)} <span style={{color:C.teal,fontSize:10}}>{save}</span></span>
                </div>
              ))}
              <div style={{display:"flex",alignItems:"center",gap:8,margin:"12px 0 10px"}}>
                <div style={S.qtyCtrl}>
                  <button style={S.qtyBtn} onClick={()=>setQty(q=>Math.max(1,q-1))}>−</button>
                  <div style={S.qtyVal}>{qty}</div>
                  <button style={S.qtyBtn} onClick={()=>setQty(q=>q+1)}>+</button>
                </div>
                <span style={{fontSize:11,color:C.inkLight}}>cases · {p.case*qty} units · <strong style={{color:C.ink}}>${(unitPrice*p.case*qty).toFixed(2)}</strong></span>
              </div>
              <button style={{...S.btnPrimary,width:"100%"}} onClick={()=>onAddToCart(p,qty,"full")}>Add {qty} case{qty>1?"s":""} to cart</button>
            </div>
          )}
          {orderMode==="half" && (
            <div>
              <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:8,padding:"9px 12px",fontSize:12,color:C.amber,marginBottom:12}}>Half case = {halfCase} units. Regular per-unit price applies.</div>
              <div style={{fontSize:16,fontWeight:700,color:C.ink,marginBottom:12}}>${(p.price*halfCase).toFixed(2)} <span style={{fontSize:12,fontWeight:400,color:C.inkLight}}>({halfCase} units @ ${p.price.toFixed(2)}/unit)</span></div>
              <button style={{...S.btnPrimary,width:"100%"}} onClick={()=>onAddToCart(p,1,"half")}>Add half case to cart</button>
            </div>
          )}
          {orderMode==="mix" && (
            <div>
              <div style={{background:C.blueLight,borderRadius:8,padding:"9px 12px",fontSize:12,color:"#1D4ED8",marginBottom:12}}>Build your own case from different products. Regular per-unit pricing applies.</div>
              {mixItems.map((row,i)=>(
                <div key={i} style={{display:"flex",gap:6,alignItems:"center",marginBottom:7}}>
                  <MixProductPicker value={row.sku} onChange={sku=>setMixRow(i,"sku",sku)}/>
                  <input type="number" min="1" value={row.qty} onChange={e=>setMixRow(i,"qty",parseInt(e.target.value)||1)} style={{...S.input,width:52,fontSize:12,padding:"6px 8px"}}/>
                  {mixItems.length>1 && <button onClick={()=>removeMixRow(i)} style={{background:"none",border:"none",color:C.inkLight,cursor:"pointer",fontSize:18}}>×</button>}
                </div>
              ))}
              <button style={S.btnGhost} onClick={addMixRow}>+ Add product</button>
              <div style={{marginTop:10,fontSize:14,fontWeight:600,color:C.ink}}>Total: ${mixTotal.toFixed(2)}</div>
              <button style={{...S.btnPrimary,width:"100%",marginTop:10}} onClick={()=>onAddToCart(p,1,"mix",mixItems)}>Add mix to cart</button>
            </div>
          )}
          <div style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:C.teal,marginTop:10}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:C.teal}}/>{p.stock} units in stock
          </div>
            </>
          )}
        </div>
      </div>
      {/* Product video — admin-optional. Hidden unless videoUrl is set. */}
      {p.videoUrl && (
        <div style={{...S.card,padding:0,overflow:"hidden"}}>
          <div style={S.cardHdr}><span style={S.cardTitle}>See it in action</span></div>
          <div style={{padding:"14px 18px"}}>
            <ProductVideo url={p.videoUrl} title={p.name} accent={catColor}/>
          </div>
        </div>
      )}
      {/* How it works */}
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>How it works</span></div>
        <div style={{padding:"14px 18px",display:"grid",gridTemplateColumns:"repeat(4,minmax(0,1fr))",gap:10}}>
          {p.how.map((txt,i)=>(
            <div key={i} style={{background:C.surface,borderRadius:8,padding:12}}>
              <div style={{fontSize:11,fontWeight:600,color:C.blue,marginBottom:5}}>Step {i+1}</div>
              <div style={{fontSize:12,color:C.ink,lineHeight:1.5}}>{txt}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Benefits */}
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Key benefits</span></div>
        <div style={{padding:"14px 18px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {p.benefits.map((b,i)=>(
            <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"10px 12px",background:C.surface,borderRadius:8}}>
              <div style={{width:28,height:28,borderRadius:8,background:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 8l4 4 8-8" stroke={C.blue} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <div style={{fontSize:13,color:C.ink}}>{b}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Compatible */}
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Compatible vehicles</span></div>
        <div style={{padding:"14px 18px",display:"flex",flexWrap:"wrap",gap:8}}>
          {p.compatible.map(v=><div key={v} style={{fontSize:11,padding:"4px 10px",borderRadius:8,border:`1px solid ${C.border}`,color:C.inkMid,background:C.surface}}>{v}</div>)}
        </div>
      </div>
      {/* Sell tips */}
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>How to sell this to your customers</span></div>
        <div style={{padding:"14px 18px"}}>
          {p.tips.map((t,i)=>(
            <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"10px 12px",background:C.surface,borderRadius:8,marginBottom:8}}>
              <div style={{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:6,whiteSpace:"nowrap",marginTop:1,flexShrink:0,...tagColor[t.col]}}>{t.tag}</div>
              <div style={{fontSize:13,color:C.ink,lineHeight:1.6}}>{t.text}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Related */}
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Frequently bought together</span></div>
        <div style={{padding:"14px 18px",display:"grid",gridTemplateColumns:"repeat(3,minmax(0,1fr))",gap:10}}>
          {liveProducts.filter(x=>x.sku!==p.sku).slice(0,3).map(rel=>(
            <div key={rel.sku} onClick={()=>onSelectProduct&&onSelectProduct(rel)} style={{background:C.surface,borderRadius:8,padding:12,cursor:"pointer",border:`1px solid ${C.border}`,transition:"box-shadow 0.15s"}} onMouseEnter={e=>e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.08)"} onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
              <div style={{fontSize:10,color:C.inkLight,textTransform:"uppercase",marginBottom:3}}>SKU {rel.sku}</div>
              <div style={{fontSize:13,fontWeight:600,color:C.ink}}>{rel.name}</div>
              <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>${rel.price.toFixed(2)}/unit · Case of {rel.case}</div>
              <div style={{fontSize:11,color:C.blue,marginTop:6}}>View product →</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── CART ──────────────────────────────────────────────────────────────────────
function Cart({cart,setCart,setPage}) {
  // Universal quantity updater — works for full case, half case, and mix modes
  const updateQty = (id, newQty) => {
    if(newQty < 1) return;
    setCart(c => c.map(item => {
      if(item.id !== id) return item;
      if(item.mode === "full") {
        const unitPrice = newQty >= 20 ? item.price * 0.81 : newQty >= 6 ? item.price * 0.90 : item.price;
        return {...item, qty: newQty, units: item.case * newQty, lineTotal: unitPrice * item.case * newQty};
      }
      if(item.mode === "half") {
        const halfCase = Math.ceil(item.case / 2);
        return {...item, qty: newQty, units: halfCase * newQty, lineTotal: item.price * halfCase * newQty};
      }
      // Mix: adjust overall multiplier (each mix set × newQty)
      if(item.mode === "mix" && item.mixItems) {
        const baseUnits = item.mixItems.reduce((s,r) => s + r.qty, 0);
        const allProds = [...SHARED_PRODUCTS.getActive(), ...SHARED_PRODUCTS.getActiveKits()];
        const baseTotal = item.mixItems.reduce((s,r) => { const p = allProds.find(x=>x.sku===r.sku); return s + (p ? p.price * r.qty : 0); }, 0);
        return {...item, qty: newQty, units: baseUnits * newQty, lineTotal: baseTotal * newQty};
      }
      return item;
    }));
  };
  const remove = (id) => setCart(c => c.filter(i => i.id !== id));
  const subtotal = cart.reduce((s,i) => s + i.lineTotal, 0);
  const shipCfg = SHARED_SETTINGS.getShipping();
  const shipping = SHARED_SETTINGS.calcShipping(subtotal);
  const freeGap = SHARED_SETTINGS.freeShippingGap(subtotal);
  const total = subtotal + shipping;
  const itemCount = cart.reduce((s,i) => s + (i.units || 0), 0);

  if(!cart.length) return (
    <div style={{...S.content,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:400}}>
      <div style={{width:64,height:64,borderRadius:"50%",background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:16}}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0" stroke={C.inkLight} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </div>
      <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:4}}>Your cart is empty</div>
      <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>Add products from our catalog to get started</div>
      <button style={S.btnPrimary} onClick={()=>setPage("catalog")}>Browse products</button>
    </div>
  );

  return (
    <div style={S.content}>
      {/* Page header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <div style={{fontSize:18,fontWeight:600,color:C.ink}}>Shopping cart</div>
          <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>{cart.length} product{cart.length>1?"s":""} · {itemCount} total units</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button style={{...S.btnPrimary,padding:"8px 16px",fontSize:12}} onClick={()=>setPage("catalog")}>+ Add more products</button>
          <button style={{...S.btnGhost,padding:"8px 12px",fontSize:12,color:C.red}} onClick={()=>setCart([])}>Clear cart</button>
        </div>
      </div>

      <div style={S.checkoutGrid}>
        {/* Cart items */}
        <div>
          {/* Table header */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 100px 130px 100px 32px",gap:12,padding:"10px 18px",background:C.navy,borderRadius:"10px 10px 0 0",fontSize:11,fontWeight:600,color:C.white}}>
            <span>Product</span>
            <span style={{textAlign:"center"}}>Unit price</span>
            <span style={{textAlign:"center"}}>Quantity</span>
            <span style={{textAlign:"right"}}>Total</span>
            <span></span>
          </div>

          {/* Cart item rows */}
          <div style={{background:C.white,border:`1px solid ${C.border}`,borderTop:"none",borderRadius:"0 0 10px 10px",overflow:"hidden"}}>
            {cart.map((item, idx) => {
              const unitPrice = item.mode === "full"
                ? (item.qty >= 20 ? item.price * 0.81 : item.qty >= 6 ? item.price * 0.90 : item.price)
                : item.price;
              const caseLabel = item.mode === "full" ? `${item.case} units/case` : item.mode === "half" ? `${Math.ceil(item.case/2)} units/half` : `${item.mixItems?.reduce((s,r)=>s+r.qty,0)||item.units} units/set`;
              const priceTier = item.mode === "full" ? (item.qty >= 20 ? "19% off" : item.qty >= 6 ? "10% off" : "") : "";

              return (
                <div key={item.id} style={{display:"grid",gridTemplateColumns:"1fr 100px 130px 100px 32px",gap:12,padding:"16px 18px",borderBottom:idx<cart.length-1?`1px solid ${C.border}`:"none",alignItems:"center",background:idx%2===0?C.white:C.surface}}>
                  {/* Product info */}
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                      <span style={{fontSize:14,fontWeight:600,color:C.ink}}>{item.name}</span>
                      {item.mode==="half"&&<span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:5,background:C.amberLight,color:C.amber}}>Half case</span>}
                      {item.mode==="mix"&&<span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:5,background:C.blueLight,color:"#1D4ED8"}}>Mix & match</span>}
                      {item.mode==="full"&&<span style={{fontSize:9,fontWeight:600,padding:"2px 7px",borderRadius:5,background:C.tealLight,color:C.teal}}>Full case</span>}
                    </div>
                    <div style={{fontSize:11,color:C.inkLight}}>
                      <span style={{fontFamily:"monospace",fontWeight:600,color:C.blue}}>SKU {item.sku}</span>
                      <span style={{margin:"0 6px",color:C.border}}>|</span>
                      <span>{caseLabel}</span>
                      <span style={{margin:"0 6px",color:C.border}}>|</span>
                      <span>{item.units} units</span>
                    </div>
                    {/* Mix breakdown */}
                    {item.mode==="mix"&&item.mixItems&&(
                      <div style={{marginTop:6,padding:"6px 10px",background:idx%2===0?C.surface:C.white,borderRadius:6,border:`1px solid ${C.border}`}}>
                        {item.mixItems.map((r,i)=>{
                          const allProds=[...SHARED_PRODUCTS.getActive(),...SHARED_PRODUCTS.getActiveKits()];
                          const prod=allProds.find(x=>x.sku===r.sku);
                          return prod?<div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"2px 0",color:C.inkMid}}>
                            <span><span style={{fontFamily:"monospace",fontWeight:600,color:C.blue,fontSize:10}}>{prod.sku}</span> {prod.name}</span>
                            <span style={{color:C.ink,fontWeight:500}}>{r.qty} × ${prod.price.toFixed(2)}</span>
                          </div>:null;
                        })}
                      </div>
                    )}
                  </div>

                  {/* Unit price */}
                  <div style={{textAlign:"center"}}>
                    <div style={{fontSize:14,fontWeight:600,color:C.ink}}>${unitPrice.toFixed(2)}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>per unit</div>
                    {priceTier&&<div style={{fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:4,background:C.tealLight,color:C.teal,display:"inline-block",marginTop:2}}>{priceTier}</div>}
                  </div>

                  {/* Quantity controls */}
                  <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                    <div style={{display:"flex",alignItems:"center",border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",background:C.white}}>
                      <button onClick={()=>updateQty(item.id,item.qty-1)} style={{width:32,height:32,background:C.surface,border:"none",cursor:"pointer",fontSize:16,color:C.ink,display:"flex",alignItems:"center",justifyContent:"center",transition:"background 0.1s"}} onMouseEnter={e=>e.currentTarget.style.background=C.border} onMouseLeave={e=>e.currentTarget.style.background=C.surface}>−</button>
                      <input type="number" min="1" value={item.qty} onChange={e=>{const v=parseInt(e.target.value);if(v>0)updateQty(item.id,v);}} style={{width:44,textAlign:"center",fontSize:13,fontWeight:600,background:C.white,border:"none",borderLeft:`1px solid ${C.border}`,borderRight:`1px solid ${C.border}`,height:32,color:C.ink,outline:"none"}}/>
                      <button onClick={()=>updateQty(item.id,item.qty+1)} style={{width:32,height:32,background:C.surface,border:"none",cursor:"pointer",fontSize:16,color:C.ink,display:"flex",alignItems:"center",justifyContent:"center",transition:"background 0.1s"}} onMouseEnter={e=>e.currentTarget.style.background=C.border} onMouseLeave={e=>e.currentTarget.style.background=C.surface}>+</button>
                    </div>
                    <div style={{fontSize:10,color:C.inkLight}}>
                      {item.mode==="full"?`${item.qty} case${item.qty>1?"s":""}`:item.mode==="half"?`${item.qty} half${item.qty>1?"s":""}`:item.qty>1?`${item.qty} sets`:"1 set"}
                    </div>
                  </div>

                  {/* Line total */}
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:16,fontWeight:700,color:C.ink}}>${item.lineTotal.toFixed(2)}</div>
                  </div>

                  {/* Remove button */}
                  <button onClick={()=>remove(item.id)} style={{background:"none",border:"none",color:C.inkLight,cursor:"pointer",fontSize:18,padding:0,lineHeight:1,display:"flex",alignItems:"center",justifyContent:"center",width:24,height:24,borderRadius:6,transition:"all 0.15s"}}
                    onMouseEnter={e=>{e.currentTarget.style.background=C.redLight;e.currentTarget.style.color=C.red;}}
                    onMouseLeave={e=>{e.currentTarget.style.background="none";e.currentTarget.style.color=C.inkLight;}}>
                    ×
                  </button>
                </div>
              );
            })}
          </div>

          {/* Volume pricing tip */}
          {cart.some(i=>i.mode==="full"&&i.qty<6)&&(
            <div style={{background:C.tealBg,border:`1px solid ${C.teal}30`,borderRadius:10,padding:"12px 16px",marginTop:12,display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:C.tealLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:14}}>%</div>
              <div>
                <div style={{fontSize:12,fontWeight:600,color:C.teal}}>Volume discount available</div>
                <div style={{fontSize:11,color:C.inkMid}}>Order 6+ cases of any product for 10% off, or 20+ cases for 19% off per unit.</div>
              </div>
            </div>
          )}
        </div>

        {/* Order summary sidebar */}
        <div>
          <div style={S.summaryBox}>
            <div style={{fontSize:14,fontWeight:600,color:C.ink,marginBottom:14}}>Order summary</div>
            {cart.map(i=>(
              <div key={i.id} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"5px 0",borderBottom:`1px solid ${C.surface}`}}>
                <div style={{color:C.inkMid,flex:1,minWidth:0}}>
                  <div style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{i.name}</div>
                  <div style={{fontSize:10,color:C.inkLight}}>{i.units} units × ${(i.lineTotal/i.units).toFixed(2)}</div>
                </div>
                <span style={{fontWeight:500,color:C.ink,flexShrink:0,marginLeft:8}}>${i.lineTotal.toFixed(2)}</span>
              </div>
            ))}
            <div style={{height:1,background:C.border,margin:"12px 0"}}/>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:C.inkMid,padding:"4px 0"}}><span>Subtotal ({itemCount} units)</span><span style={{fontWeight:500,color:C.ink}}>${subtotal.toFixed(2)}</span></div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:13,padding:"4px 0"}}><span style={{color:C.inkMid}}>Shipping</span><span style={{color:shipping===0?C.teal:C.ink,fontWeight:500}}>{shipping===0?"FREE":`$${shipping.toFixed(2)}`}</span></div>
            {shipping>0&&freeGap>0&&shipCfg.enableFreeShipping&&(
              <div style={{background:C.amberLight,borderRadius:7,padding:"8px 10px",fontSize:11,color:C.amber,margin:"8px 0",display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:14}}>%</span>
                <span>Add <strong>${freeGap.toFixed(2)}</strong> more for free shipping</span>
              </div>
            )}
            <div style={{height:1,background:C.border,margin:"12px 0"}}/>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:18,fontWeight:700,color:C.ink,marginBottom:16}}><span>Total</span><span>${total.toFixed(2)}</span></div>
            <button style={{...S.btnPrimary,width:"100%",padding:"13px",fontSize:14,fontWeight:600}} onClick={()=>setPage("checkout")}>Proceed to checkout →</button>
            <button style={{...S.btnSecondary,width:"100%",padding:"11px",marginTop:8,fontSize:12}} onClick={()=>setPage("catalog")}>Continue shopping</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── CHECKOUT ──────────────────────────────────────────────────────────────────
// Default approved terms when admin hasn't customized them — all methods available
const CUSTOMER_APPROVED_TERMS_DEFAULT=["cc","ach","net30","net60"];

// Current customer's account discount (set by admin — synced via SHARED_SETTINGS)
// No discount by default. Earlier versions of this file set a 5% fallback
// "for the Apex Car Care LLC demo" which silently applied on every account
// whose admin-configured discount was 0 / unset — charging the dealer less
// than the rep sold at. Money bug. Discounts must ALWAYS come from the
// admin's explicit Configure-account entry; never from a hardcoded default.
const CUSTOMER_DISCOUNT_DEFAULT = 0;

function Checkout({cart,setPage,setCart,customerDiscount,salesRep,customerName,customerEmail,repEmail,userId,customerProfile,approvedTerms}) {
  // Strict numeric coercion — `customerDiscount` can be undefined (prop not
  // passed yet), null, "" (empty admin input), "5", 5, etc. Only a positive
  // number counts as a real discount; anything else is 0.
  const parsedDiscount = Number(customerDiscount);
  const activeDiscount = Number.isFinite(parsedDiscount) && parsedDiscount > 0 ? parsedDiscount : 0;
  // Use customer's approved terms from admin; fall back to defaults if not set yet
  const customerTerms = Array.isArray(approvedTerms) && approvedTerms.length>0 ? approvedTerms : CUSTOMER_APPROVED_TERMS_DEFAULT;
  const [step,setStep]=useState(1);
  // Cross-device sync warning — set by placeOrder when the Supabase write to
  // portal_orders fails but localStorage succeeded. Displays a non-blocking
  // banner at the top of the checkout confirmation screen so the dealer sees
  // that their order is saved locally but cloud sync is pending. Banner stays
  // until dealer dismisses it manually — they have to acknowledge that admin
  // and their rep may not see the order until retry.
  const [syncWarning, setSyncWarning] = useState("");
  // Default payMethod to first approved term, preferring "net30" if available.
  // This ensures a CC-only customer doesn't start on a forbidden invoice term.
  const [payMethod,setPayMethod]=useState(()=>customerTerms.includes("net30")?"net30":customerTerms[0]);
  // If admin changes approved terms and current selection is no longer allowed, snap to a valid one.
  useEffect(()=>{
    if(!customerTerms.includes(payMethod)) setPayMethod(customerTerms[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[customerTerms.join(",")]);
  const subtotal=cart.reduce((s,i)=>s+i.lineTotal,0);

  // FIX: Shipping form initialized from actual profile data — not hardcoded Apex demo values
  // Parse contact name into first/last; parse combined address into street/city/state/zip
  const [shipForm, setShipForm] = useState(()=>{
    const cp = customerProfile || {};
    const contactParts = (cp.contact || "").trim().split(/\s+/);
    const firstName = contactParts[0] || "";
    const lastName = contactParts.slice(1).join(" ") || "";
    // Address may be combined "1234 Main St, San Diego CA 92101" — parse if city/state/zip not set
    let street = cp.address || "", city = cp.city || "", state = cp.state || "", zip = cp.zip || "";
    if(street && !city && !state && !zip) {
      const parts = street.split(",").map(s=>s.trim());
      if(parts.length >= 2) {
        street = parts[0];
        const rest = parts.slice(1).join(", ").trim();
        const m = rest.match(/^(.+?)\s+([A-Z]{2})\s+(\d{5}(?:-\d{4})?)$/i);
        if(m) { city=m[1]; state=m[2]; zip=m[3]; }
        else { city=rest; }
      }
    }
    return { firstName, lastName, company: customerName || "", address: street, city, state, zip };
  });
  const discountAmt = activeDiscount>0 ? subtotal*(activeDiscount/100) : 0;
  const discountedSubtotal = subtotal - discountAmt;
  const shipCfg=SHARED_SETTINGS.getShipping();
  // Shipping method: "standard" | "expedited" | "ltl". LTL is calculated later.
  const [shipMethod,setShipMethod]=useState("standard");
  const standardCost=SHARED_SETTINGS.calcShipping(discountedSubtotal);
  const shipping=shipMethod==="expedited"?shipCfg.expeditedRate:shipMethod==="ltl"?0:standardCost;
  const shippingLabel=shipMethod==="expedited"?(shipCfg.expeditedLabel||"Express 2-day"):shipMethod==="ltl"?"LTL freight":(shipCfg.standardLabel||"Standard ground");
  const freeGap=SHARED_SETTINGS.freeShippingGap(discountedSubtotal);
  const total=discountedSubtotal+shipping;
  const availableTerms=ALL_TERMS.filter(t=>customerTerms.includes(t.id));

  // ── Square Web Payments SDK ─────────────────────────────────────
  // App ID & Location ID are public values (not secrets) — hardcoded directly to avoid env var issues
  const SQUARE_APP_ID="sandbox-sq0idb-ekjDW43m2q2S3n4dNIqFSQ";
  const SQUARE_LOC_ID="LVEAYA21A7HEK";
  const [squareReady,setSquareReady]=useState(false);
  const [paymentProcessing,setPaymentProcessing]=useState(false);
  const [paymentError,setPaymentError]=useState("");
  const squareCardRef=useRef(null);
  const squarePaymentsRef=useRef(null); // shared payments instance for card + ACH

  // Initialize Square payments instance + card element when CC is selected
  useEffect(()=>{
    if((payMethod!=="cc"&&payMethod!=="ach")||step!==2) return;
    let cancelled=false;
    setSquareReady(false);
    setPaymentError("");
    const initSquare=async()=>{
      // Wait for Square SDK
      let tries=0;
      while(!window.Square&&tries<50){await new Promise(r=>setTimeout(r,200));tries++;}
      if(cancelled) return;
      if(!window.Square){
        setPaymentError("Payment form could not load. Please refresh the page and try again.");
        return;
      }
      try{
        // Create or reuse payments instance
        if(!squarePaymentsRef.current){
          const payments=window.Square.payments(SQUARE_APP_ID,SQUARE_LOC_ID);
          squarePaymentsRef.current=(payments&&typeof payments.then==="function")?await payments:payments;
        }
        if(cancelled) return;
        // For credit card: attach card form
        if(payMethod==="cc"){
          let el=document.getElementById("square-card-container");
          let domTries=0;
          while(!el&&domTries<20){await new Promise(r=>setTimeout(r,150));el=document.getElementById("square-card-container");domTries++;}
          if(cancelled||!el) return;
          if(squareCardRef.current){try{await squareCardRef.current.destroy();}catch(e){}squareCardRef.current=null;}
          const card=await squarePaymentsRef.current.card();
          if(cancelled) return;
          await card.attach("#square-card-container");
          squareCardRef.current=card;
        }
        // ACH doesn't need a DOM element — it opens a modal on tokenize
        setSquareReady(true);
        setPaymentError("");
      }catch(e){
        console.error("Square init error:",e);
        setPaymentError("Failed to load payment form: "+(e.message||"Unknown error")+". Please refresh and try again.");
      }
    };
    const timer=setTimeout(initSquare,200);
    return()=>{cancelled=true;clearTimeout(timer);if(squareCardRef.current){try{squareCardRef.current.destroy();}catch(e){}squareCardRef.current=null;setSquareReady(false);}};
  },[payMethod,step,SQUARE_APP_ID,SQUARE_LOC_ID]);

  // Process credit card payment through Square
  const processSquarePayment=async(orderId)=>{
    if(!squareCardRef.current){setPaymentError("Card form not ready. Please wait and try again.");return false;}
    setPaymentProcessing(true);setPaymentError("");
    try{
      const tokenResult=await squareCardRef.current.tokenize();
      if(tokenResult.status!=="OK"){
        setPaymentError(tokenResult.errors?.[0]?.message||"Card verification failed. Please check your details.");
        setPaymentProcessing(false);return false;
      }
      const res=await fetch("/api/process-payment",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({sourceId:tokenResult.token,amount:Math.round(total*100),currency:"USD",orderId,customerName:customerName||"Customer",customerEmail:customerEmail||""})
      });
      const json=await res.json();
      if(!res.ok){setPaymentError(json.error||"Payment declined. Please try a different card.");setPaymentProcessing(false);return false;}
      setPaymentProcessing(false);
      return {paymentId:json.paymentId,receiptUrl:json.receiptUrl};
    }catch(e){setPaymentError("Payment failed: "+e.message);setPaymentProcessing(false);return false;}
  };

  // Process ACH bank transfer payment through Square
  const processSquareACH=async(orderId)=>{
    if(!squarePaymentsRef.current){setPaymentError("Payment system not ready. Please wait and try again.");return false;}
    setPaymentProcessing(true);setPaymentError("");
    try{
      const ach=await squarePaymentsRef.current.ach();
      const tokenResult=await ach.tokenize({
        accountHolderName:customerName||"Customer",
        intent:"CHARGE",
        total:{amount:Math.round(total*100),currencyCode:"USD"},
        redirectURI:window.location.origin+"/checkout",
      });
      if(tokenResult.status!=="OK"){
        setPaymentError(tokenResult.errors?.[0]?.message||"Bank verification failed. Please try again.");
        setPaymentProcessing(false);return false;
      }
      const res=await fetch("/api/process-payment",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({sourceId:tokenResult.token,amount:Math.round(total*100),currency:"USD",orderId,customerName:customerName||"Customer",customerEmail:customerEmail||"",sourceType:"ach"})
      });
      const json=await res.json();
      if(!res.ok){setPaymentError(json.error||"Bank transfer declined. Please try again.");setPaymentProcessing(false);return false;}
      setPaymentProcessing(false);
      return {paymentId:json.paymentId,receiptUrl:json.receiptUrl};
    }catch(e){
      // User closed the ACH modal — not an error
      if(e.message&&e.message.includes("canceled")){setPaymentProcessing(false);return false;}
      setPaymentError("Bank transfer failed: "+e.message);setPaymentProcessing(false);return false;
    }
  };

  // Place order — handles both CC (Square) and non-CC (invoice) methods
  const placeOrder=async()=>{
    // Collision-resistant id — see the invId comment below for why this
    // matters (silently dropped orders, not just a cosmetic ID clash).
    const orderId=`ORD-${String(Date.now()).slice(-6)}${Math.random().toString(36).slice(2,8).toUpperCase()}`;
    // If credit card or ACH, process payment first
    if(payMethod==="cc"){
      const payResult=await processSquarePayment(orderId);
      if(!payResult) return;
    }
    if(payMethod==="ach"){
      const payResult=await processSquareACH(orderId);
      if(!payResult) return;
    }
    // Collision-resistant id. Previously `Date.now()` sliced to the last
    // 5 digits (100,000 values, cycling every ~100s). savePortalOrder's
    // idempotency guard (supabase.js) looks up an existing row by
    // invoice_ref BEFORE inserting — added to stop network-retry
    // duplicates — and if ANY row already has that invoice_ref (even a
    // genuinely different invoice that happened to collide), it returns
    // the EXISTING row and skips the insert entirely. The new order's
    // real data is then never written to portal_orders at all — no
    // error, no banner, because savePortalOrder still resolves to a
    // (wrong) row so the caller's `if (!supabaseRow)` failure check never
    // fires. This is the exact mechanism behind a rep's confirmed sale
    // going missing from every other device's view.
    //
    // Fix: 6 timestamp digits (rough chronological sort only, not
    // entropy) + 6 random base-36 characters — the randomness is what
    // actually matters, since two submits CAN land in the same
    // millisecond in a live multi-user system. Verified empirically: a
    // 2-char random suffix collided in >25% of 200,000 rapid-fire calls
    // in a tight loop; 6 chars produced zero collisions under the same
    // (deliberately worse-than-realistic) test.
    const invId=`INV-${String(Date.now()).slice(-6)}${Math.random().toString(36).slice(2,8).toUpperCase()}`;
    // Serialize cart items with the EFFECTIVE per-line price, not the base
    // catalog price. Reason: `i.lineTotal` already incorporates
    //   (a) the case-size multiplier (`item.case × item.qty`)
    //   (b) tier discount (0.81 at qty≥20, 0.90 at qty≥6)
    //   (c) mix-kit component prices (when mode === "mix")
    // If we stored the raw `i.price` (base catalog piece-price), the invoice
    // PDF — which renders qty × price — would display a different total
    // than the money actually collected. That mismatch is the bug INV-21221
    // hit: items stored with $9.60 × 10 = $96 while inv.total = $492.48.
    // Storing the effective unit price here keeps sum(items) === inv.total
    // by construction for every new invoice. `basePrice`, `units`, `case`,
    // and `mode` are kept as audit-trail metadata — no display code reads
    // them yet, but downstream audits can reconcile against them later.
    const items = cart.map(i => {
      const qty = Number(i.qty) || 1;
      const lt = Number(i.lineTotal) || 0;
      const effectivePrice = lt > 0 && qty > 0 ? lt / qty : Number(i.price) || 0;
      const baseItem = {
        sku: i.sku || "—",
        name: i.name,
        qty,
        price: effectivePrice,
        basePrice: Number(i.price) || 0,
        units: Number(i.units) || qty,
        case: Number(i.case) || 1,
        mode: i.mode || "full",
      };
      // PR-V2A: carry variation context onto the invoice item when present
      // so future inventory reconciliation / rep portal display can
      // identify variation lines without string-parsing the name. Absent
      // for non-variation items — JSON serialization drops undefined keys.
      if (i.parentSku) baseItem.parentSku = i.parentSku;
      if (i.variationLabel) baseItem.variationLabel = i.variationLabel;
      return baseItem;
    });
    const inv={
      id:invId,orderId,date:new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}),
      customer:customerName||"Customer",customerEmail:customerEmail||"",userId:userId||"",
      items,
      // Persist subtotal / discount / shipping so the invoice PDF can render
      // them as explicit lines instead of silently folding them into the
      // total. Subtotal is sum(items) pre-discount; discount captures the
      // admin-configured % and $ amount so the dealer sees exactly what was
      // taken off; shipping line itemizes the delivery charge.
      subtotal,
      discount: activeDiscount > 0 ? { pct: activeDiscount, amount: discountAmt, label: "Special discount" } : null,
      shipping: shipping > 0 ? { amount: shipping, label: shippingLabel || "Shipping" } : null,
      total,status:(payMethod==="cc"||payMethod==="ach")?"paid":"outstanding",paymentTerms:availableTerms.find(t=>t.id===payMethod)?.label||"Net 30",
      rep:salesRep||"",source:"portal_order"
    };
    // Rule Zero (CLAUDE.md "READ THIS SECOND"): Supabase-first write. Await
    // portal_orders insert BEFORE mirroring to localStorage. If Supabase
    // accepts, the mirror proceeds normally. If it rejects, we still mirror
    // so the dealer doesn't lose the order they just placed, but surface the
    // sync-pending state so they (and downstream views like admin + rep
    // commission tabs) know cross-device visibility is delayed until retry.
    let supabaseRow = null;
    try {
      supabaseRow = await savePortalOrder({
        orderId, invoiceId:invId, userId:userId||"", customer:customerName||"Customer",
        customerEmail:customerEmail||"", total, status:inv.status,
        paymentTerms:inv.paymentTerms, rep:salesRep||"",
        items:inv.items, source:"portal_order"
      });
    } catch(e) {
      console.warn("[Checkout placeOrder] portal_orders sync threw, will retry on next portal mount:", e?.message||e);
      supabaseRow = null;
    }
    // localStorage mirror — always runs. Matches the same pattern as
    // RepPortal.createInvoice so both invoice-creation sites fail the same way
    // (loudly) and recover the same way (via the admin / rep / customer
    // syncPortalOrders hydration on next mount).
    SHARED_INVOICES.add({ ...inv, _supabasePending: !supabaseRow });
    emailOrderCompleted({customerName:customerName||"Customer",customerEmail:customerEmail||"",orderId,total:total.toFixed(2),items:cart.map(i=>({name:i.name,qty:i.qty||1}))});
    emailOrderPlaced({customerName:customerName||"Customer",customerEmail:customerEmail||"",orderId,total:total.toFixed(2),items:cart.map(i=>({name:i.name,qty:i.qty||1})),shippingMethod:"Standard",repName:salesRep||""});
    if(salesRep&&repEmail) emailRepOrderNotify({repName:salesRep,repEmail,customerName:customerName||"Customer",customerCompany:customerName||"",orderId,total:total.toFixed(2),items:cart.map(i=>({name:i.name,qty:i.qty||1}))});
    if (!supabaseRow) setSyncWarning(`Order ${orderId} saved on this device but cloud sync is pending. Will retry automatically.`);
    setStep(3);
  };

  if(step===3) return (
    <div style={S.content}>
      {syncWarning && (
        <div style={{margin:"0 auto 16px", maxWidth:600, padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
          <div style={{flex:1, textAlign:"left"}}>
            <strong>{syncWarning}</strong>{" "}
            Your rep and our team won't see it on their devices until sync succeeds.
          </div>
          <button
            onClick={() => setSyncWarning("")}
            style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:"pointer"}}
          >Dismiss</button>
        </div>
      )}
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:"60vh",textAlign:"center"}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:C.tealLight,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:18}}>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M4 14l7 7L24 7" stroke={C.teal} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <div style={{fontSize:26,fontWeight:700,color:C.ink,marginBottom:8}}>Order placed!</div>
        <div style={{fontSize:14,color:C.inkLight,marginBottom:28}}>Order confirmed. Confirmation sent to your email.{salesRep&&<span> · Your rep: <strong>{salesRep}</strong></span>}</div>
        <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:12,padding:"18px 24px",minWidth:300,marginBottom:24}}>
          {cart.map(i=>(
            <div key={i.id} style={{display:"flex",justifyContent:"space-between",fontSize:13,padding:"4px 0",borderBottom:`1px solid ${C.border}`}}>
              <span style={{color:C.inkMid}}>{i.name}{i.mode==="half"?" (half)":i.mode==="mix"?" (mix)":` ×${i.qty}`}</span>
              <span style={{fontWeight:500,color:C.ink}}>${i.lineTotal.toFixed(2)}</span>
            </div>
          ))}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:15,fontWeight:600,color:C.ink,marginTop:10}}><span>Total</span><span>${total.toFixed(2)}</span></div>
          <div style={{fontSize:12,color:C.inkLight,marginTop:6}}>Payment: {availableTerms.find(t=>t.id===payMethod)?.label}</div>
        </div>
        <div style={{display:"flex",gap:10}}>
          <button style={S.btnSecondary} onClick={()=>{setCart([]);setPage("orders");}}>View orders</button>
          <button style={S.btnPrimary} onClick={()=>{setCart([]);setPage("dashboard");}}>Back to dashboard</button>
        </div>
      </div>
    </div>
  );
  return (
    <div style={S.content}>
      <div style={{display:"flex",gap:10,marginBottom:20}}>
        {["Shipping","Payment","Confirm"].map((s,i)=>(
          <div key={s} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:500,color:step>i+1?C.teal:step===i+1?C.ink:C.inkLight}}>
            <div style={{width:22,height:22,borderRadius:"50%",background:step>i+1?C.teal:step===i+1?C.navy:C.border,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600,color:step>=i+1?C.white:C.inkLight}}>
              {step>i+1?"✓":i+1}
            </div>
            {s}{i<2&&<span style={{color:C.border,margin:"0 4px"}}>—</span>}
          </div>
        ))}
      </div>
      <div style={S.checkoutGrid}>
        <div>
          {step===1&&(
            <div style={S.card}>
              <div style={S.cardHdr}><span style={S.cardTitle}>Shipping address</span></div>
              <div style={{padding:"16px 18px"}}>
                <div style={S.twoCol}>
                  <div style={S.fg}><label style={S.label}>First name</label><input style={S.input} value={shipForm.firstName} onChange={e=>setShipForm(f=>({...f,firstName:e.target.value}))} placeholder="First name"/></div>
                  <div style={S.fg}><label style={S.label}>Last name</label><input style={S.input} value={shipForm.lastName} onChange={e=>setShipForm(f=>({...f,lastName:e.target.value}))} placeholder="Last name"/></div>
                </div>
                <div style={S.fg}><label style={S.label}>Company</label><input style={S.input} value={shipForm.company} onChange={e=>setShipForm(f=>({...f,company:e.target.value}))} placeholder="Company name"/></div>
                <div style={S.fg}><label style={S.label}>Address</label><input style={S.input} value={shipForm.address} onChange={e=>setShipForm(f=>({...f,address:e.target.value}))} placeholder="Street address"/></div>
                <div style={S.threeCol}>
                  <div style={S.fg}><label style={S.label}>City</label><input style={S.input} value={shipForm.city} onChange={e=>setShipForm(f=>({...f,city:e.target.value}))} placeholder="City"/></div>
                  <div style={S.fg}><label style={S.label}>State</label><input style={S.input} value={shipForm.state} onChange={e=>setShipForm(f=>({...f,state:e.target.value}))} placeholder="State"/></div>
                  <div style={S.fg}><label style={S.label}>ZIP</label><input style={S.input} value={shipForm.zip} onChange={e=>setShipForm(f=>({...f,zip:e.target.value}))} placeholder="ZIP code"/></div>
                </div>
                <div style={S.fg}><label style={S.label}>Shipping method</label>
                  <select style={S.select} value={shipMethod} onChange={e=>setShipMethod(e.target.value)}>
                    <option value="standard">{shipCfg.standardLabel||"Standard ground"} {shipCfg.enableFreeShipping?`(FREE over $${shipCfg.freeThreshold})`:`— $${shipCfg.flatRate.toFixed(2)}`}</option>
                    <option value="expedited">{shipCfg.expeditedLabel||"Express 2-day"} — ${shipCfg.expeditedRate.toFixed(2)}</option>
                    <option value="ltl">LTL freight — calculated</option>
                  </select>
                </div>
                <button style={S.btnPrimary} onClick={()=>setStep(2)}>Continue to payment →</button>
              </div>
            </div>
          )}
          {step===2&&(
            <div style={S.card}>
              <div style={S.cardHdr}><span style={S.cardTitle}>Payment method</span></div>
              <div style={{padding:"16px 18px"}}>
                <div style={{background:C.tealLight,border:`1px solid #9FE1CB`,borderRadius:8,padding:"9px 12px",fontSize:12,color:C.teal,marginBottom:14}}>
                  Showing payment options approved for your account. Contact your rep to request additional terms.
                </div>
                {availableTerms.map(t=>(
                  <div key={t.id} onClick={()=>setPayMethod(t.id)} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"12px 14px",borderRadius:8,border:`1px solid ${payMethod===t.id?C.blue:C.border}`,background:payMethod===t.id?C.blueLight:C.white,cursor:"pointer",marginBottom:8}}>
                    <div style={{width:16,height:16,borderRadius:"50%",border:`2px solid ${payMethod===t.id?C.blue:C.border}`,background:payMethod===t.id?C.blue:C.white,display:"flex",alignItems:"center",justifyContent:"center",marginTop:1,flexShrink:0}}>
                      {payMethod===t.id&&<div style={{width:6,height:6,borderRadius:"50%",background:C.white}}/>}
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{t.label}</div>
                      <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{t.desc}</div>
                    </div>
                  </div>
                ))}
                {payMethod==="cc"&&(
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12,fontWeight:500,color:C.ink,marginBottom:8}}>Enter your card details</div>
                    {!squareReady&&!paymentError&&<div style={{display:"flex",alignItems:"center",justifyContent:"center",height:100,color:C.inkLight,fontSize:12,background:C.surface,borderRadius:8,border:`1px dashed ${C.border}`,marginBottom:8}}>
                      <span>Loading secure payment form…</span>
                    </div>}
                    {paymentError&&<div style={{background:C.redLight,color:C.red,borderRadius:8,padding:"10px 14px",fontSize:12,marginBottom:8}}>{paymentError}</div>}
                    <div id="square-card-container" style={{minHeight:89,border:squareReady?"none":`1px solid ${C.border}`,borderRadius:8,padding:squareReady?0:4,background:squareReady?"transparent":C.white}}></div>
                    <div style={{display:"flex",alignItems:"center",gap:6,marginTop:8,fontSize:11,color:C.inkLight}}>
                      <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 1a4 4 0 0 0-4 4v3H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1V5a4 4 0 0 0-4-4zm2 7H6V5a2 2 0 1 1 4 0v3z" fill="#64748B"/></svg>
                      Secured by Square — your card details are encrypted end-to-end
                    </div>
                  </div>
                )}
                {payMethod==="ach"&&(
                  <div style={{marginTop:12}}>
                    <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"14px 16px",marginBottom:8}}>
                      <div style={{fontSize:12,fontWeight:500,color:C.ink,marginBottom:6}}>How ACH bank transfer works</div>
                      <div style={{fontSize:11,color:C.inkMid,lineHeight:1.5}}>
                        1. Click "Place order" below<br/>
                        2. A secure bank authorization window will open (powered by Square)<br/>
                        3. Enter your bank account details and authorize the transfer<br/>
                        4. The payment is processed directly — no processing fees
                      </div>
                    </div>
                    {paymentError&&<div style={{background:C.redLight,color:C.red,borderRadius:8,padding:"10px 14px",fontSize:12,marginBottom:8}}>{paymentError}</div>}
                    {!squareReady&&!paymentError&&<div style={{display:"flex",alignItems:"center",justifyContent:"center",height:50,color:C.inkLight,fontSize:12}}>Initializing secure bank transfer…</div>}
                    <div style={{display:"flex",alignItems:"center",gap:6,marginTop:4,fontSize:11,color:C.inkLight}}>
                      <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 1a4 4 0 0 0-4 4v3H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1V5a4 4 0 0 0-4-4zm2 7H6V5a2 2 0 1 1 4 0v3z" fill="#64748B"/></svg>
                      Secured by Square — bank details are encrypted and never stored on our servers
                    </div>
                  </div>
                )}
                <div style={{display:"flex",gap:10,marginTop:8}}>
                  <button style={S.btnSecondary} onClick={()=>setStep(1)}>← Back</button>
                  <button style={{...S.btnPrimary,opacity:paymentProcessing?0.6:1}} disabled={paymentProcessing} onClick={placeOrder}>
                    {paymentProcessing?"Processing payment...":"Place order →"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div style={S.summaryBox}>
          <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:12}}>Order summary</div>
          {cart.map(i=>(
            <div key={i.id} style={{display:"flex",justifyContent:"space-between",fontSize:12,color:C.inkMid,padding:"3px 0"}}>
              <span>{i.name}{i.mode==="half"?" (half)":i.mode==="mix"?" (mix)":` ×${i.qty}`}</span><span>${i.lineTotal.toFixed(2)}</span>
            </div>
          ))}
          <div style={{height:1,background:C.border,margin:"10px 0"}}/>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:C.inkMid,padding:"3px 0"}}><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
          {activeDiscount>0&&(
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"3px 0"}}>
              <span style={{color:C.teal,fontWeight:500}}>Special discount ({activeDiscount}%)</span>
              <span style={{color:C.teal,fontWeight:500}}>−${discountAmt.toFixed(2)}</span>
            </div>
          )}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"3px 0"}}><span style={{color:C.inkMid}}>Shipping ({shippingLabel})</span><span style={{color:shipping===0&&shipMethod!=="ltl"?C.teal:C.ink}}>{shipMethod==="ltl"?"Calculated":shipping===0?"FREE":`$${shipping.toFixed(2)}`}</span></div>
          {shipMethod==="standard"&&shipping>0&&freeGap>0&&shipCfg.enableFreeShipping&&<div style={{background:C.amberLight,borderRadius:7,padding:"5px 8px",fontSize:10,color:C.amber,margin:"4px 0"}}>Add ${freeGap.toFixed(2)} more for free shipping</div>}
          <div style={{height:1,background:C.border,margin:"10px 0"}}/>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:15,fontWeight:600,color:C.ink}}><span>Total</span><span>${total.toFixed(2)}</span></div>
          {payMethod&&<div style={{fontSize:12,color:C.inkLight,marginTop:6}}>Payment: {availableTerms.find(t=>t.id===payMethod)?.label}</div>}
        </div>
      </div>
    </div>
  );
}

// ── ORDERS ────────────────────────────────────────────────────────────────────
function Orders({setPage,isDemo,customerName,userId,onViewInvoice}) {
  // STRICT TENANT FILTER: a dealer must ONLY see orders that belong to *this* dealer.
  // Match-by-name on inv.customer/o.accountName is the primary key (rep-created and
  // portal_order both stamp the customer's company there). userId is an extra safety net
  // for the dealer's own portal-checkout orders (which also stamp inv.userId).
  const isMine = (inv) => {
    if(!customerName) return false;
    if(inv.userId && userId && inv.userId === userId) return true;
    return (inv.customer || "") === customerName;
  };
  const isMineMat = (o) => {
    if(!customerName) return false;
    if(o.userId && userId && o.userId === userId) return true;
    return (o.accountName || "") === customerName;
  };

  // Subscribe to material orders for *this* customer only
  const [matOrders, setMatOrders] = useState(()=>SHARED_MATERIAL_ORDERS.getAll().filter(isMineMat));
  // Subscribe to ALL invoices for this customer — both portal-checkout (source="portal_order")
  // AND rep-created on this dealer's behalf (repCreated:true, customer===dealer name).
  const [myInvoices, setMyInvoices] = useState(()=>SHARED_INVOICES.getAll().filter(isMine));

  useEffect(()=>{
    const unsub1 = SHARED_MATERIAL_ORDERS.subscribe((all)=>setMatOrders(all.filter(isMineMat)));
    const unsub2 = SHARED_INVOICES.subscribe((all)=>setMyInvoices(all.filter(isMine)));
    return ()=>{unsub1();unsub2();};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[customerName, userId]);

  // Cross-device sync: pull portal_orders from Supabase on mount + on focus
  // and merge any rows (or shipping updates) that are missing from the local
  // SHARED_INVOICES. Without this, if admin adds tracking in their browser,
  // the dealer on a different browser never sees it — SHARED_INVOICES is
  // localStorage-only. Same polling contract as the rep portal uses; we skip
  // the interval here (customer views are typically short-lived; focus-based
  // refresh is enough).
  useEffect(()=>{
    if(!customerName && !userId) return;
    let mounted = true;
    const syncFromDb = async () => {
      try {
        const fetchStartedAt = Date.now();   // a revert is skipped for adjustments newer than this
        const rows = await getAllPortalOrders();
        if(!mounted || !rows || rows.length === 0) return;
        const mineRows = rows.filter(r => {
          if(userId && r.user_id === userId) return true;
          if((r.customer||"") === customerName) return true;
          return false;
        });
        if(mineRows.length === 0) return;
        const existing = SHARED_INVOICES.getAll();
        const existingById = new Map(existing.map(i => [i.id, i]));
        const existingByOrderId = new Map(existing.filter(i=>i.orderId).map(i => [i.orderId, i]));
        mineRows.forEach(r => {
          const invId   = r.invoice_ref || r.invoice_id || r.order_ref || r.order_id || r.id;
          const orderId = r.order_ref   || r.order_id   || r.id;
          const match   = existingById.get(invId) || existingByOrderId.get(orderId);
          const shippingPatch = {};
          if(r.tracking        != null) shippingPatch.tracking        = r.tracking;
          if(r.carrier         != null) shippingPatch.carrier         = r.carrier;
          if(r.shipped_date    != null) shippingPatch.shippedDate     = r.shipped_date;
          if(r.delivered_date  != null) shippingPatch.deliveredDate   = r.delivered_date;
          if(r.shipping_status != null) shippingPatch.shippingStatus  = r.shipping_status;
          if(r.shipping_notes  != null) shippingPatch.notes           = r.shipping_notes;
          if(match){
            // Only patch if any shipping field actually differs — otherwise
            // we'd fire a useless subscriber emit and rerender.
            const changed = Object.entries(shippingPatch).some(([k,v]) => match[k] !== v);
            if(changed && Object.keys(shippingPatch).length) {
              SHARED_INVOICES.updateShipping(match.id, shippingPatch);
            }
          } else {
            // Row is in DB but not in localStorage — add it so the dealer
            // sees the order even on a fresh browser. Applies, e.g., when a
            // rep placed the order on the dealer's behalf from their own
            // browser.
            let items = [];
            try { items = typeof r.items === "string" ? JSON.parse(r.items) : (r.items || []); } catch(e) {}
            SHARED_INVOICES.add({
              id: invId, orderId,
              date: r.created_at ? new Date(r.created_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
              customer: r.customer || customerName || "Customer", items,
              userId: r.user_id || "",
              customerEmail: r.customer_email || "",
              total: r.total || 0, status: r.status || "outstanding",
              paymentTerms: r.payment_terms || "", rep: r.rep || "",
              source: r.source || "portal_order", fromDb: true,
              ...shippingPatch,
              // Account discount (0034): {} for a row without one, so older invoices are exactly as before.
              ...invoiceDiscountFields(r),
            });
          }
        });
        // Forward-only: a DB status of 'cancelled' flips the cached invoice to
        // cancelled. Never touches paid / shipping / items (see applyServerState).
        SHARED_INVOICES.applyServerState(mineRows, { allowRevert: true, fetchStartedAt }); // getAllPortalOrders batch: newest per invoice
      } catch(e) { console.warn("Customer Orders: portal_orders sync failed:", e?.message || e); }
    };
    syncFromDb();
    const onFocus = () => { syncFromDb(); };
    window.addEventListener("focus", onFocus);
    return ()=>{ mounted = false; window.removeEventListener("focus", onFocus); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[customerName, userId]);

  // ── Author label: who placed the order? ───────────────────────────────────
  // Source of truth on every invoice: source="portal_order" → dealer-self-checkout;
  // repCreated:true → sales rep created (rep name stamped in inv.rep).
  const authorOf = (inv) => {
    // An invoice the office created for this dealer (admin Create invoice): not placed by the dealer, not by a rep.
    if(inv.source === "admin_invoice") return { kind:"admin", label:"Issued by MotorPower Care" };
    if(inv.source === "portal_order") return { kind:"you", label:"Placed by you" };
    if(inv.repCreated) return { kind:"rep", label:`Placed by ${displayRepStamp(inv.rep)||"sales rep"}` };
    return { kind:"unknown", label:"" };
  };

  // Convert material orders to order-row format
  const materialRows = matOrders.map(o=>({
    id:`#${o.id}`, date:o.date||new Date(o.placedAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}),
    items:o.items.map(i=>`${i.name} ×${i.qty}`).join(", "),
    amount:o.total||0, status:o.status==="shipped"?"done":"pending", isMaterial:true,
    placedBy: o.source==="rep" ? `Placed by ${o.rep||"sales rep"}` : "Placed by you",
    placedByKind: o.source==="rep" ? "rep" : "you"
  }));

  // Convert invoices (portal-checkout + rep-created for this dealer) to order-row format.
  // Include shipping fields so the dealer can see tracking + status updates
  // that admin sets from the Admin → All orders → Ship Now flow. Status is
  // derived from the full invoice by the unified helper at render time, so
  // here we just carry the invoice through on _invoice.
  const checkoutRows = myInvoices.map(inv=>{
    const a = authorOf(inv);
    return {
      id:`#${inv.orderId||inv.id}`, date:inv.date,
      items:(inv.items||[]).map(i=>`${i.name} ×${i.qty}`).join(", "),
      amount:inv.total||0, isCheckout:true,
      invoiceId:inv.id, placedBy:a.label, placedByKind:a.kind,
      tracking:inv.tracking||"", carrier:inv.carrier||"",
      shippedDate:inv.shippedDate||"", deliveredDate:inv.deliveredDate||"",
      shippingStatus:inv.shippingStatus||"",
      _invoice: inv,
    };
  });

  // Only show demo RECENT_ORDERS for the demo user, AND only entries belonging to this demo dealer.
  const demoOrders = isDemo ? RECENT_ORDERS.filter(o=>!o.account || o.account===customerName).map(o=>({...o, placedBy:"Placed by you", placedByKind:"you"})) : [];
  const allOrders = [...checkoutRows, ...materialRows, ...demoOrders];

  // Carrier → track URL (same mapping admin uses). Inline here so the
  // customer Orders page doesn't have to reach into AdminOrdersTab.
  const trackUrlFor = (carrier,tracking) => {
    if(!tracking) return null;
    if(carrier==="UPS") return `https://www.ups.com/track?tracknum=${tracking}`;
    if(carrier==="FedEx"||carrier==="FedEx Freight") return `https://www.fedex.com/fedextrack/?trknbr=${tracking}`;
    if(carrier==="USPS") return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}`;
    return null;
  };

  return (
    <div style={S.content}>
      <div style={S.card}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Order history</span>
          <div style={{display:"flex",gap:8}}>
            <select style={{...S.select,width:"auto",fontSize:12,padding:"5px 10px"}}><option>All statuses</option><option>In transit</option><option>Delivered</option><option>Processing</option></select>
            <input style={{...S.input,width:180,fontSize:12,padding:"5px 10px"}} placeholder="Search orders..."/>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"80px 110px 1fr 72px 110px 130px 56px 60px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Order</span><span>Date</span><span>Items</span><span>Amount</span><span>Status</span><span>Placed by</span><span></span><span></span>
        </div>
        {allOrders.length===0?(
          <div style={{padding:"32px 18px",textAlign:"center",color:C.inkLight,fontSize:13}}>No orders yet — <span style={{color:C.blue,cursor:"pointer"}} onClick={()=>setPage&&setPage("catalog")}>browse products</span> to place your first order.</div>
        ):allOrders.map(o=>{
          const placedByPill = o.placedByKind==="rep"
            ? {fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:8,background:"#EEF2FF",color:"#4338CA"}
            : {fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:8,background:C.tealLight,color:C.teal};
          const trackUrl = trackUrlFor(o.carrier,o.tracking);
          const hasTracking = !!o.tracking;
          return (
            <div key={o.id} style={{borderBottom:`1px solid ${C.border}`}}>
              <div style={{display:"grid",gridTemplateColumns:"80px 110px 1fr 72px 110px 130px 56px 60px",alignItems:"center",gap:8,padding:"11px 18px",fontSize:12}}>
                <span style={{fontWeight:600,color:C.ink}}>{o.id}</span>
                <span style={{color:C.inkLight}}>{o.date}</span>
                <span style={{color:C.inkMid}}>{o.items}{o.isMaterial?<span style={{...S.pillGreen,marginLeft:6}}>Material</span>:""}</span>
                <span style={{fontWeight:600,color:C.ink}}>{o.amount===0?"FREE":`$${o.amount.toLocaleString()}`}</span>
                {/* Unified invoice pill when this row has a backing invoice
                    (checkout + field-invoice rows). Material + demo rows
                    still use the legacy StatusLabel since they don't have
                    the full invoice fields the helper reads. */}
                {o._invoice ? <InvoicePill inv={o._invoice}/> : <StatusLabel s={o.status}/>}
                <span style={placedByPill} title={o.placedBy||""}>{o.placedByKind==="rep" ? (o.placedBy||"By rep") : o.placedByKind==="admin" ? "By MotorPower Care" : "By you"}</span>
                <span style={{fontSize:11,color:C.blue,cursor:"pointer"}} onClick={()=>setPage&&setPage("catalog")}>Reorder</span>
                <span style={{fontSize:11,color:C.blue,cursor:"pointer"}} onClick={()=>{if(o.invoiceId&&onViewInvoice)onViewInvoice(o.invoiceId);else if(setPage)setPage("invoices");}}>Invoice</span>
              </div>
              {/* Tracking strip — only shown when admin has added tracking to
                  this order. Clickable carrier link opens the carrier's
                  tracking page in a new tab. Shipped / delivered dates
                  come straight from SHARED_INVOICES. */}
              {hasTracking && (
                <div style={{padding:"0 18px 10px 98px",display:"flex",gap:14,alignItems:"center",flexWrap:"wrap",fontSize:11,color:C.inkMid}}>
                  <span style={{fontWeight:500,color:C.ink}}>📦 {o.carrier||"Shipment"}</span>
                  {trackUrl
                    ? <a href={trackUrl} target="_blank" rel="noreferrer" style={{color:C.blue,textDecoration:"none",fontWeight:500}}>Track {o.tracking} ↗</a>
                    : <span>Tracking #: <span style={{color:C.ink,fontWeight:500}}>{o.tracking}</span></span>}
                  {o.shippedDate && <span>Shipped {o.shippedDate}</span>}
                  {o.deliveredDate && <span style={{color:C.teal,fontWeight:600}}>✓ Delivered {o.deliveredDate}</span>}
                  {!o.deliveredDate && o.shippingStatus==="shipped" && <span style={{color:C.amber,fontWeight:500}}>In transit</span>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── CUSTOMER INVOICE CENTER ───────────────────────────────────────────────────
// approvedTerms: array of payment-method ids this customer is allowed to use
//   (set by admin per-account). Drives which options show up in the Pay
//   invoice modal dropdown — if admin didn't approve "wire", wire does not
//   appear here. Falls back to CUSTOMER_APPROVED_TERMS_DEFAULT when missing
//   so demo / not-yet-loaded profiles aren't locked out.
export function Invoices({isDemo,customerName,userId="",highlightId,onClearHighlight,customerProfile,approvedTerms}) {   // exported for the render tests only
  const allowedTerms = Array.isArray(approvedTerms) && approvedTerms.length>0 ? approvedTerms : CUSTOMER_APPROVED_TERMS_DEFAULT;
  // For the Pay invoice modal we care about the "direct pay now" methods only —
  // net15/30/60 are credit-extension terms, not something the customer picks
  // when paying. Map approved terms → dropdown options.
  const canCC    = allowedTerms.includes("cc");
  const canACH   = allowedTerms.includes("ach");
  const canCheck = allowedTerms.includes("check");
  const canWire  = allowedTerms.includes("wire");
  // If a customer has zero pay-now methods (only net terms), we still show CC
  // so they have some way to pay an invoice that's come due. Admin can always
  // add check/wire/ach in the account settings if needed.
  const availablePayMethods = [
    canCC    && {id:"cc",    label:"Credit card"},
    canACH   && {id:"ach",   label:"ACH / Bank transfer"},
    canCheck && {id:"check", label:"Check"},
    canWire  && {id:"wire",  label:"Wire transfer"},
  ].filter(Boolean);
  const fallbackMethods = availablePayMethods.length>0 ? availablePayMethods : [{id:"cc",label:"Credit card"}];
  // Pull admin's editable wire / check instructions
  const mpcInfo = getMpcInfo();

  const [sharedInvoices, setSharedInvoices] = useState(()=>SHARED_INVOICES.getAll());
  const [payingId, setPayingId] = useState(null);
  const [payMethod, setPayMethod] = useState(()=>fallbackMethods[0].id);
  const [viewInv, setViewInv] = useState(null);

  // If admin removes the method the customer had selected, snap back to an allowed one
  useEffect(()=>{
    if(!fallbackMethods.some(m=>m.id===payMethod)) setPayMethod(fallbackMethods[0].id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[fallbackMethods.map(m=>m.id).join(",")]);

  // ── Pay-now flow ──────────────────────────────────────────────────────────
  // FIX: the prior flow just called markPaid() without any processing, which
  // meant any customer could mark an invoice paid by clicking a button. We
  // now run card/ACH through Square Web Payments SDK + /api/process-payment,
  // and route check/wire to markPendingConfirmation() so accounting can
  // confirm funds before flipping to paid.
  const [payStep, setPayStep] = useState("method"); // method | details | processing | success | failed
  const [payError, setPayError] = useState("");
  const [payResult, setPayResult] = useState(null);
  const [squareReady, setSquareReady] = useState(false);
  const invSquareCardRef = useRef(null);
  const invSquarePaymentsRef = useRef(null);
  const INV_SQUARE_APP_ID = "sandbox-sq0idb-ekjDW43m2q2S3n4dNIqFSQ";
  const INV_SQUARE_LOC_ID = "LVEAYA21A7HEK";

  const resetPay = () => {
    setPayingId(null); setPayMethod("cc"); setPayStep("method");
    setPayError(""); setPayResult(null); setSquareReady(false);
    if (invSquareCardRef.current) { try{invSquareCardRef.current.destroy();}catch(e){} invSquareCardRef.current = null; }
  };

  // Auto-open highlighted invoice from Orders page
  useEffect(()=>{
    if(highlightId){
      const match=SHARED_INVOICES.getAll().find(i=>i.id===highlightId);
      if(match) setViewInv(match);
      if(onClearHighlight) onClearHighlight();
    }
  },[highlightId,onClearHighlight]);

  // Subscribe to real-time updates from rep portal
  useEffect(()=>{
    const unsub = SHARED_INVOICES.subscribe(setSharedInvoices);
    return unsub;
  },[]);

  // Initialize Square card form when CC is selected + we're at the details step
  useEffect(()=>{
    if(payStep!=="details" || payMethod!=="cc" || !payingId) return;
    let cancelled=false;
    setSquareReady(false);
    const initSquare=async()=>{
      let tries=0;
      while(!window.Square&&tries<50){await new Promise(r=>setTimeout(r,200));tries++;}
      if(cancelled) return;
      if(!window.Square){ setPayError("Payment form could not load. Please refresh the page."); return; }
      try{
        if(!invSquarePaymentsRef.current){
          const payments=window.Square.payments(INV_SQUARE_APP_ID,INV_SQUARE_LOC_ID);
          invSquarePaymentsRef.current=(payments&&typeof payments.then==="function")?await payments:payments;
        }
        if(cancelled) return;
        let el=document.getElementById("inv-square-card-container");
        let domTries=0;
        while(!el&&domTries<20){await new Promise(r=>setTimeout(r,150));el=document.getElementById("inv-square-card-container");domTries++;}
        if(cancelled||!el) return;
        if(invSquareCardRef.current){try{await invSquareCardRef.current.destroy();}catch(e){}invSquareCardRef.current=null;}
        const card=await invSquarePaymentsRef.current.card();
        if(cancelled) return;
        await card.attach("#inv-square-card-container");
        invSquareCardRef.current=card;
        setSquareReady(true);
        setPayError("");
      }catch(e){
        console.error("Square init error:",e);
        setPayError("Failed to load payment form: "+(e.message||"Unknown error"));
      }
    };
    const timer=setTimeout(initSquare,200);
    return()=>{cancelled=true;clearTimeout(timer);if(invSquareCardRef.current){try{invSquareCardRef.current.destroy();}catch(e){}invSquareCardRef.current=null;setSquareReady(false);}};
  },[payStep,payMethod,payingId]);

  // Demo historical invoices
  const HIST = [
    {id:"INV-291",date:"Mar 28, 2025",total:1240,status:"outstanding",customer:"Apex Car Care LLC",items:[{sku:"7001",name:"Catalytic converter cleaner",qty:24,price:28.50},{sku:"8012",name:"Engine flush",qty:12,price:32.17}],repCreated:false,paymentTerms:"Net 30",dueDate:"Apr 27, 2025"},
    {id:"INV-290",date:"Mar 15, 2025",total:760, status:"paid",customer:"Apex Car Care LLC",items:[{sku:"9003",name:"DPF foam cleaner",qty:12,price:35.00},{sku:"8005",name:"Diesel power cleaner",qty:12,price:28.33}],repCreated:false,paymentTerms:"Net 30",paidDate:"Apr 5, 2025",paidMethod:"ACH"},
    {id:"INV-289",date:"Mar 2, 2025", total:520, status:"paid",customer:"Apex Car Care LLC",items:[{sku:"6002",name:"Octane booster",qty:16,price:18.75},{sku:"7004",name:"Induction cleaner",qty:12,price:18.33}],repCreated:false,paymentTerms:"Net 30",paidDate:"Mar 28, 2025",paidMethod:"Credit card"},
  ];

  // Only show demo historical invoices for demo user; filter shared invoices by actual customer name
  const demoHist = isDemo ? HIST : [];
  // By exact company name (as always). An invoice the office created is also tied to the dealer by account id (so it
  // shows even if the company name was edited since); the id match is limited to office invoices, so no older rep or
  // portal invoice newly appears, counts toward Outstanding, or shows in the "new invoices" banner.
  const myShared = sharedInvoices.filter(i=>isInvoiceOfDealer(i,customerName,userId));
  const allInvoices = [...myShared, ...demoHist];
  // Cancelled invoices are dead — don't count them as outstanding.
  const outstanding = allInvoices.filter(i=>i.status!=="paid" && i.status!=="cancelled");
  const totalOwed = outstanding.reduce((s,i)=>s+i.total,0);
  // Only invoices the office or the sales rep made are "new invoices from ..."; the dealer's own checkout orders are never in the banner.
  // "Made by the rep" is the app's one rule (isRepCreatedInvoice): it also covers a rep invoice this device hydrated from portal_orders
  // (source rep_invoice, INV-F id, no repCreated flag). The banner, its wording, the row tint and Mark seen all use the same two predicates.
  const newFromRep = myShared.filter(i=>!i.customerSeen && isMadeByOfficeOrRep(i));
  // Wording follows the sources actually present: office invoices are from MotorPower Care, rep-created ones from the
  // sales rep. A dealer's own portal orders are neither, so they never add "your sales rep" next to an office invoice.
  const newFromOffice = newFromRep.filter(i=>i.source==="admin_invoice").length;
  const newFromSalesRep = newFromRep.filter(isMadeByRep).length;
  const newFromWhom = newFromOffice===0 ? "your sales rep" : newFromSalesRep===0 ? "MotorPower Care" : "MotorPower Care and your sales rep";

  // FIX (2026-04-20): "Invoices this month" previously used
  //   .includes("Apr") || .includes("2025")
  // on the date string — hardcoded to April 2025, and the OR ran over the
  // whole date string so ANY invoice in 2025 matched. "Paid this year"
  // summed every paid invoice regardless of year. Replaced both with
  // proper date parsing against the current month / year.
  const _statsNow = new Date();
  const _curYear = _statsNow.getFullYear();
  const _curMonth = _statsNow.getMonth();
  const _curMonthLabel = _statsNow.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  const _invoiceDate = (inv) => {
    if (!inv) return null;
    if (inv.sharedAt) { const d = new Date(inv.sharedAt); if (!isNaN(d.getTime())) return d; }
    if (inv.date)     { const d = new Date(inv.date);     if (!isNaN(d.getTime())) return d; }
    return null;
  };
  const _isThisMonth = (inv) => {
    const d = _invoiceDate(inv);
    return d != null && d.getFullYear() === _curYear && d.getMonth() === _curMonth;
  };
  const _isThisYear = (inv) => {
    const d = _invoiceDate(inv);
    return d != null && d.getFullYear() === _curYear;
  };
  const invoicesThisMonth = allInvoices.filter(_isThisMonth);
  const paidThisYear     = allInvoices.filter(i => (i.status === "paid" || i.status === "done") && _isThisYear(i));
  const paidThisYearTotal = paidThisYear.reduce((s,i) => s + (Number(i.total) || 0), 0);

  const currentInv = payingId ? allInvoices.find(i=>i.id===payingId) : null;

  // Authoritative total for the pay modal. Mirrors the LegalInvoiceModal
  // fallback at App.js:2756-2765 so the pay screen never silently shows
  // $0.00 (and never silently charges $0) when the invoice has real items
  // but a stale / mis-synced `total` field.
  //
  // Why this is defensive, not a rewrite:
  //   The stored `total` field on SHARED_INVOICES / portal_orders is left
  //   untouched. We only DERIVE a display + charge amount that prefers the
  //   stored value when present (> 0) and falls back to sum(items) when it
  //   isn't. Legitimate $0 invoices (full comps, free material orders) still
  //   render and charge as $0 because their items × price is also 0 — so
  //   nobody gets surprise-charged for what was meant to be free.
  //
  //   This unblocks dealers whose rep-created invoice landed in Supabase
  //   with a stale local `total` cache (the 4× INV-F290 duplicate hydrate
  //   race documented in PR-2 / sibling commit) without modifying any
  //   existing portal_orders row. PR-2 closes the root cause; this PR
  //   makes the symptom non-blocking.
  const currentInvItemsSum = currentInv && Array.isArray(currentInv.items)
    ? currentInv.items.reduce((s,i) => s + (Number(i.price)||0) * (Number(i.qty)||0), 0)
    : 0;
  const currentInvStoredTotal = Number(currentInv?.total) || 0;
  const currentInvTotal = currentInvStoredTotal > 0 ? currentInvStoredTotal : currentInvItemsSum;

  // Run the payment through Square + our API. On success record Square's
  // paymentId so the later refund flow can target it; on error, show inline.
  const processPayment = async () => {
    if(!currentInv) return;
    setPayStep("processing"); setPayError("");
    try{
      let sourceId = null;
      if(payMethod==="cc"){
        if(!invSquareCardRef.current){ setPayError("Card form not ready."); setPayStep("failed"); return; }
        const tokenResult = await invSquareCardRef.current.tokenize();
        if(tokenResult.status!=="OK"){ setPayError(tokenResult.errors?.[0]?.message||"Card verification failed."); setPayStep("failed"); return; }
        sourceId = tokenResult.token;
      } else if(payMethod==="ach"){
        if(!invSquarePaymentsRef.current){ setPayError("Payment system not ready."); setPayStep("failed"); return; }
        try {
          const ach = await invSquarePaymentsRef.current.ach({ redirectURI: window.location.href, transactionId: currentInv.id });
          const tokenResult = await ach.tokenize({
            accountHolderName: customerProfile?.contact || customerName || "Customer",
            intent: "CHARGE",
            amount: currentInvTotal.toFixed(2),
            currency: "USD",
          });
          if(tokenResult.status!=="OK"){ setPayError(tokenResult.errors?.[0]?.message||"Bank authorization failed."); setPayStep("failed"); return; }
          sourceId = tokenResult.token;
        } catch(err){
          setPayError("ACH authorization failed: "+(err.message||"Unknown error")); setPayStep("failed"); return;
        }
      }
      const res = await fetch("/api/process-payment",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          sourceId,
          amount: Math.round(currentInvTotal * 100), // cents
          currency: "USD",
          orderId: currentInv.id,
          customerName: customerName || currentInv.customer,
          customerEmail: customerProfile?.email || "",
          sourceType: payMethod==="ach" ? "ach" : "card",
        })
      });
      const json = await res.json();
      if(!res.ok || !json.success){
        setPayError(json.error || "Payment failed");
        setPayStep("failed");
        return;
      }
      SHARED_INVOICES.markPaid(currentInv.id, payMethod==="cc"?"Credit card":"ACH", {
        paymentId: json.paymentId,
        status: json.status,
        receiptUrl: json.receiptUrl,
      });
      setSharedInvoices(SHARED_INVOICES.getAll());
      setPayResult({ method: payMethod==="cc"?"Credit card":"ACH", paymentId: json.paymentId, receiptUrl: json.receiptUrl });
      setPayStep("success");
    } catch(e){
      setPayError(e.message || "Network error");
      setPayStep("failed");
    }
  };

  // Check/wire don't run through Square — customer is telling us they're
  // mailing / wiring money. Mark pending and let admin flip to paid on receipt.
  const confirmManualPayment = () => {
    if(!currentInv) return;
    const label = payMethod==="check" ? "Check" : "Wire transfer";
    SHARED_INVOICES.markPendingConfirmation(currentInv.id, label);
    setSharedInvoices(SHARED_INVOICES.getAll());
    setPayResult({ method: label, pending: true });
    setPayStep("success");
  };

  return (
    <div style={S.content}>
      {/* Pay invoice modal — step-based flow */}
      {payingId && currentInv && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:460,maxHeight:"92vh",overflowY:"auto"}}>
            <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>
              {payStep==="success" ? (payResult?.pending ? "Payment pending confirmation" : "Payment received") : "Pay invoice"}
            </div>
            <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>
              {currentInv.id} · <strong style={{color:C.ink}}>${currentInvTotal.toFixed(2)}</strong>
              {currentInv.paymentTerms && <span style={{color:C.inkLight}}> · {currentInv.paymentTerms}</span>}
            </div>

            {payStep==="method" && (
              <>
                <div style={S.fg}><label style={S.label}>Payment method</label>
                  {/* Only render payment methods the admin approved for this
                      customer. If none are approved we fall back to CC so
                      they still have a way to pay outstanding invoices. */}
                  <select style={S.select} value={payMethod} onChange={e=>setPayMethod(e.target.value)}>
                    {fallbackMethods.map(m=><option key={m.id} value={m.id}>{m.label}</option>)}
                  </select>
                  {availablePayMethods.length<4 && (
                    <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>
                      Only the methods approved on your account are shown. Contact your rep to enable additional payment methods.
                    </div>
                  )}
                </div>
                <div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:16}}>
                  {payMethod==="cc"&&"Enter your card on the next screen. Processed securely via Square."}
                  {payMethod==="ach"&&"You'll authorize your bank in the next step via Plaid/Square."}
                  {payMethod==="check"&&"Mail a check to MotorPower Care. Invoice will be marked pending until funds clear."}
                  {payMethod==="wire"&&"We'll show wire instructions and mark the invoice pending until funds arrive."}
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={resetPay}>Cancel</button>
                  <button style={{...S.btnPrimary,flex:1}} onClick={()=>{setPayError("");setPayStep("details");}}>Continue →</button>
                </div>
              </>
            )}

            {payStep==="details" && payMethod==="cc" && (
              <>
                <div style={S.fg}><label style={S.label}>Card details</label>
                  <div id="inv-square-card-container" style={{minHeight:90,background:C.white,border:`1px solid ${C.border}`,borderRadius:8,padding:10}}/>
                  {!squareReady && !payError && <div style={{fontSize:11,color:C.inkLight,marginTop:6}}>Loading secure card form…</div>}
                </div>
                {payError && <div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#B91C1C",marginBottom:12}}>{payError}</div>}
                <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",fontSize:11,color:C.inkLight,marginBottom:16}}>
                  You will be charged ${currentInvTotal.toFixed(2)}. Card details are transmitted securely to Square.
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={()=>setPayStep("method")}>← Back</button>
                  <button style={{...S.btnPrimary,flex:1,opacity:squareReady?1:0.5}} onClick={processPayment} disabled={!squareReady}>Pay ${currentInvTotal.toFixed(2)}</button>
                </div>
              </>
            )}

            {payStep==="details" && payMethod==="ach" && (
              <>
                <div style={{background:C.blueLight,borderRadius:8,padding:"12px 14px",fontSize:12,color:"#1D4ED8",marginBottom:16}}>
                  Click "Authorize" to securely connect your bank via Plaid. ACH transfers settle in 3–5 business days. You will be debited <strong>${currentInvTotal.toFixed(2)}</strong>.
                </div>
                {payError && <div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#B91C1C",marginBottom:12}}>{payError}</div>}
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={()=>setPayStep("method")}>← Back</button>
                  <button style={{...S.btnPrimary,flex:1}} onClick={processPayment}>Authorize ${currentInvTotal.toFixed(2)}</button>
                </div>
              </>
            )}

            {payStep==="details" && payMethod==="check" && (()=>{
              // Resolve check-payment instructions from admin Settings. Falls
              // back to company address if admin didn't set a separate mailing
              // address for checks.
              const payee = mpcInfo.checkPayee || mpcInfo.name || "MotorPower Care Inc.";
              const mailAddress = (mpcInfo.checkAddress && mpcInfo.checkAddress.trim())
                ? mpcInfo.checkAddress
                : `${mpcInfo.address||""}\n${mpcInfo.city||""}`;
              return (
              <>
                <div style={{background:C.surface,borderRadius:8,padding:"14px 16px",fontSize:13,color:C.ink,marginBottom:16,lineHeight:1.6}}>
                  <div style={{fontWeight:600,marginBottom:8}}>Mail check to:</div>
                  <div style={{fontWeight:500,marginBottom:4}}>{payee}</div>
                  <div style={{whiteSpace:"pre-line"}}>{mailAddress}</div>
                  <div style={{fontSize:12,color:C.inkLight,marginTop:10}}>Make payable to <strong>"{payee}"</strong> and include invoice <strong>{currentInv.id}</strong> in the memo. Your invoice will stay in Payment Pending until we record receipt.</div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={()=>setPayStep("method")}>← Back</button>
                  <button style={{...S.btnPrimary,flex:1}} onClick={confirmManualPayment}>I've mailed the check</button>
                </div>
              </>
            );})()}

            {payStep==="details" && payMethod==="wire" && (()=>{
              // Wire instructions are fully editable in admin Settings — we
              // only render fields that have a value so the modal stays clean
              // for customers whose admin hasn't filled in every field yet.
              const accountName = mpcInfo.bankAccountName || mpcInfo.name || "MotorPower Care Inc.";
              const adminEmail = mpcInfo.email || "info@mpcare.com";
              const accountDisplay = mpcInfo.bankAccount
                ? mpcInfo.bankAccount
                : `available from accounting — email ${adminEmail}`;
              const hasWireDetails = mpcInfo.bankName || mpcInfo.bankRouting || mpcInfo.bankAccount;
              return (
              <>
                <div style={{background:C.surface,borderRadius:8,padding:"14px 16px",fontSize:13,color:C.ink,marginBottom:16,lineHeight:1.7}}>
                  <div style={{fontWeight:600,marginBottom:8}}>Wire to:</div>
                  {hasWireDetails ? (
                    <>
                      {mpcInfo.bankName    && <><strong>Bank:</strong> {mpcInfo.bankName}<br/></>}
                      <strong>Account name:</strong> {accountName}<br/>
                      {mpcInfo.bankRouting && <><strong>Routing (ABA):</strong> {mpcInfo.bankRouting}<br/></>}
                      <strong>Account:</strong> {accountDisplay}<br/>
                      {mpcInfo.bankSwift   && <><strong>SWIFT:</strong> {mpcInfo.bankSwift}<br/></>}
                      {mpcInfo.bankAddress && <><strong>Bank address:</strong> {mpcInfo.bankAddress}<br/></>}
                      <strong>Reference:</strong> {currentInv.id}<br/>
                    </>
                  ) : (
                    <>
                      <strong>Account name:</strong> {accountName}<br/>
                      <strong>Reference:</strong> {currentInv.id}<br/>
                      <div style={{fontSize:12,color:C.amber,marginTop:6}}>Our banking details aren't configured yet — please email <strong>{adminEmail}</strong> to receive wire instructions.</div>
                    </>
                  )}
                  {mpcInfo.wireNote && <div style={{fontSize:12,color:C.inkMid,marginTop:10,fontStyle:"italic",whiteSpace:"pre-line"}}>{mpcInfo.wireNote}</div>}
                  <div style={{fontSize:12,color:C.inkLight,marginTop:8}}>Invoice will stay in Payment Pending until we confirm receipt of funds.</div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={()=>setPayStep("method")}>← Back</button>
                  <button style={{...S.btnPrimary,flex:1}} onClick={confirmManualPayment}>I've initiated the wire</button>
                </div>
              </>
            );})()}

            {payStep==="processing" && (
              <div style={{padding:"24px 0",textAlign:"center"}}>
                <div style={{fontSize:14,color:C.inkMid,marginBottom:12}}>Processing your payment...</div>
                <div style={{fontSize:11,color:C.inkLight}}>Do not close this window.</div>
              </div>
            )}

            {payStep==="failed" && (
              <>
                <div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"12px 14px",fontSize:13,color:"#991B1B",marginBottom:16}}>
                  <div style={{fontWeight:600,marginBottom:4}}>Payment failed</div>
                  <div style={{fontSize:12}}>{payError||"Please try again or use a different payment method."}</div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button style={{...S.btnSecondary,flex:1}} onClick={resetPay}>Cancel</button>
                  <button style={{...S.btnPrimary,flex:1}} onClick={()=>setPayStep("details")}>Try again</button>
                </div>
              </>
            )}

            {payStep==="success" && (
              <>
                <div style={{background:payResult?.pending?"#FEF3C7":"#DCFCE7",border:`1px solid ${payResult?.pending?"#FCD34D":"#86EFAC"}`,borderRadius:8,padding:"14px 16px",fontSize:13,color:payResult?.pending?"#B45309":"#166534",marginBottom:16}}>
                  <div style={{fontWeight:600,marginBottom:4}}>
                    {payResult?.pending ? "Thanks — we're waiting for the funds" : "Payment successful"}
                  </div>
                  <div style={{fontSize:12}}>
                    {payResult?.pending
                      ? <>We've marked {currentInv.id} as payment pending. It will flip to Paid once we confirm receipt.</>
                      : <>We charged <strong>${currentInvTotal.toFixed(2)}</strong> via {payResult?.method}. A receipt has been sent to your account email.</>}
                  </div>
                  {payResult?.paymentId && <div style={{fontSize:11,marginTop:6,color:C.inkLight}}>Payment ID: {payResult.paymentId}</div>}
                  {payResult?.receiptUrl && <div style={{fontSize:11,marginTop:4}}><a href={payResult.receiptUrl} target="_blank" rel="noopener noreferrer" style={{color:C.blue}}>View receipt ↗</a></div>}
                </div>
                <button style={{...S.btnPrimary,width:"100%"}} onClick={resetPay}>Close</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* New invoice notification banner */}
      {newFromRep.length>0 && (
        <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:10,padding:"12px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:C.amber}}>{newFromRep.length} new invoice{newFromRep.length>1?"s":""} from {newFromWhom}</div>
            <div style={{fontSize:12,color:C.amber,marginTop:1}}>
              {newFromRep.map(i=>`${i.id} — $${i.total?.toFixed(2)}`).join(" · ")}
            </div>
          </div>
          <button style={{...S.btnSmall,background:C.amberLight,color:C.amber,border:`1px solid ${C.amber}`}}
            onClick={()=>newFromRep.forEach(i=>SHARED_INVOICES.markSeen(i.id))}>
            Mark seen
          </button>
        </div>
      )}

      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[
          {l:"Outstanding balance",v:`$${totalOwed.toFixed(2)}`,warn:totalOwed>0,s:outstanding.length>0?`${outstanding.length} invoice${outstanding.length>1?"s":""}`:null},
          {l:"Invoices this month",v:invoicesThisMonth.length,s:_curMonthLabel},
          {l:"Paid this year",v:`$${paidThisYearTotal.toFixed(2)}`,s:`${paidThisYear.length} invoice${paidThisYear.length===1?"":"s"} in ${_curYear}`},
          {l:"Rep-created invoices",v:allInvoices.filter(i=>i.repCreated).length,s:"From field visits"},
        ].map(m=>(
          <div key={m.l} style={{...S.metric,...(m.warn?{borderTop:`3px solid ${C.amber}`}:{})}}>
            <div style={S.mLabel}>{m.l}</div>
            <div style={{...S.mValue,...(m.warn?{color:C.amber}:{})}}>{m.v}</div>
            {m.s&&<div style={{...S.mSub,...(m.warn?{color:C.amber}:{})}}>{m.s}</div>}
          </div>
        ))}
      </div>

      {/* Invoice table */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <span style={S.cardTitle}>All invoices</span>
          <span style={{fontSize:11,color:C.inkLight}}>Rep-created invoices appear here automatically</span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 80px 110px 100px 80px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Invoice</span><span>Date</span><span>Items / Details</span><span style={{textAlign:"right"}}>Amount</span><span>Status</span><span>Source</span><span></span>
        </div>
        {allInvoices.map(inv=>(
          <div key={inv.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 80px 110px 100px 80px",alignItems:"center",gap:8,padding:"12px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,background:isMadeByOfficeOrRep(inv)&&!inv.customerSeen?"#FFFBEB":C.white}}>
            <span style={{fontWeight:600,color:C.blue,cursor:"pointer"}} onClick={()=>setViewInv(inv)}>{inv.id}</span>
            <span style={{color:C.inkLight}}>{inv.date}</span>
            <span style={{color:C.inkMid,fontSize:11}}>
              {Array.isArray(inv.items)?inv.items.map(i=>`[${i.sku}] ${i.name} ×${i.qty}`).join(", "):typeof inv.items==="string"?inv.items:"—"}
            </span>
            <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${inv.total?.toFixed(2)}</span>
            <div>
              {/* Unified 4-value pill (Paid / Pending / Shipped / Overdue /
                  Cancelled) — renders identically for customer, rep, and
                  admin via deriveInvoiceDisplayStatus. Secondary caption
                  keeps the per-status detail (paid date, due date, pending
                  method) so the dealer still sees context. */}
              <InvoicePill inv={inv}/>
              {inv.status==="cancelled"       && <div style={{fontSize:10,color:C.red,marginTop:2}}>{inv.cancelReason||""}{inv.cancelledDate?` · ${inv.cancelledDate}`:""}</div>}
              {inv.status==="paid"            && <div style={{fontSize:10,color:C.inkLight,marginTop:2}}>{inv.paidDate} · {inv.paidMethod}{inv.paidLast4?` ··${inv.paidLast4}`:""}</div>}
              {inv.status==="payment_pending" && <div style={{fontSize:10,color:C.amber,marginTop:2}}>{inv.pendingMethod||""} · awaiting confirmation</div>}
              {(inv.status==="outstanding"||inv.status==="pending") && inv.dueDate && <div style={{fontSize:10,color:C.amber,marginTop:2}}>Due {inv.dueDate}</div>}
            </div>
            <span style={{fontSize:11}}>
              {inv.source==="admin_invoice"
                ? <span style={{...S.pillBlue}}>MotorPower Care invoice</span>
                : inv.repCreated
                ? <span style={{...S.pillBlue}}>Field invoice</span>
                : <span style={{...S.pillGray||{fontSize:10,padding:"2px 8px",borderRadius:8,background:C.surface,color:C.inkLight}}}>Portal order</span>
              }
            </span>
            {inv.status==="cancelled" || inv.status==="paid" || inv.status==="payment_pending"
              ? <span style={{fontSize:11,cursor:"pointer",color:C.blue}} onClick={()=>setViewInv(inv)}>View</span>
              : <button style={S.btnPrimary} onClick={()=>{setPayingId(inv.id);setPayStep("method");setPayMethod("cc");setPayError("");setPayResult(null);isMadeByOfficeOrRep(inv)&&SHARED_INVOICES.markSeen(inv.id);}}>Pay now</button>
            }
          </div>
        ))}
        {allInvoices.length===0&&(
          <div style={{padding:"24px",textAlign:"center",color:C.inkLight,fontSize:13}}>No invoices yet</div>
        )}
      </div>

      {/* Invoice detail modal — professional format matching admin/rep invoice view */}
      {viewInv&&(()=>{
        const mpc = getMpcInfo();
        const cp = customerProfile || {};
        const hasItems = Array.isArray(viewInv.items);
        // Same reconciliation logic as AdminInvoiceModal. Subtotal = items
        // pre-discount sum. Discount + shipping shown as explicit lines when
        // persisted on the invoice. Legacy invoices without those fields
        // still render correctly — just no discount/shipping rows, and the
        // reconciliation banner surfaces any mismatch.
        const itemsSum = hasItems ? viewInv.items.reduce((s,i)=>s+((i.price||0)*(i.qty||0)),0) : 0;
        const storedTotal = Number(viewInv.total||0);
        const invDiscount = viewInv.discount || null;
        const invShipping = viewInv.shipping || null;
        const discountAmt = Number(invDiscount?.amount || 0);
        const shippingAmt = Number(invShipping?.amount || 0);
        const authoritativeTotal = storedTotal > 0 ? storedTotal : itemsSum;
        const subtotal = hasItems ? itemsSum : authoritativeTotal;
        const expectedFromItems = itemsSum - discountAmt + shippingAmt;
        const reconciliationMismatch = hasItems && storedTotal > 0 && Math.abs(expectedFromItems - storedTotal) > 0.02;
        const isPaid = viewInv.status==="paid"||viewInv.status==="done";
        const today = viewInv.date||new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});
        const custAddr = [cp.address, [cp.city, cp.state, cp.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
        return (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:"20px 0",overflowY:"auto"}} onClick={()=>setViewInv(null)}>
          <div id="invoice-print-area" style={{background:C.white,width:700,borderRadius:12,overflow:"hidden",maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            {/* Dark header bar with status badge */}
            <div style={{background:"#1E293B",padding:"12px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <span style={{color:C.white,fontSize:13,fontWeight:500}}>Invoice {viewInv.id}</span>
                {(() => {
                  // Unified 4-value pill in the modal header — same
                  // deriveInvoiceDisplayStatus the list rows and admin use,
                  // just rendered a touch larger for the modal context.
                  const code = deriveInvoiceDisplayStatus(viewInv);
                  const style = displayStatusPillStyle(code);
                  return <span style={{...style,padding:"4px 12px",borderRadius:20,fontSize:11}}>{displayStatusLabel(code)}</span>;
                })()}
              </div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>window.print()} style={{background:"rgba(255,255,255,0.1)",border:"none",color:C.white,padding:"6px 14px",borderRadius:6,fontSize:12,cursor:"pointer"}}>Print / Save PDF</button>
                <button onClick={()=>setViewInv(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:22,cursor:"pointer",lineHeight:1}}>x</button>
              </div>
            </div>

            <div style={{padding:"40px 48px",fontFamily:"'DM Sans',system-ui,sans-serif"}}>
              {/* Cancellation info banner */}
              {viewInv.status==="cancelled" && (
                <div style={{background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:10,padding:"14px 16px",marginBottom:18}}>
                  <div style={{fontSize:13,fontWeight:600,color:"#B91C1C",marginBottom:4}}>
                    This order was cancelled{viewInv.cancelledDate?` on ${viewInv.cancelledDate}`:""}
                  </div>
                  {viewInv.cancelReason && <div style={{fontSize:12,color:"#B91C1C",marginBottom:viewInv.cancelNote?4:0}}>Reason: {viewInv.cancelReason}</div>}
                  {viewInv.cancelNote && <div style={{fontSize:12,color:"#991B1B",marginBottom:4}}>Note: {viewInv.cancelNote}</div>}
                  {viewInv.refundStatus==="refunded" && (
                    <div style={{fontSize:12,color:"#166534",marginTop:6,fontWeight:500}}>
                      Refund of ${Number(viewInv.total||0).toFixed(2)} was issued to your {viewInv.refundMethod||"card"}{viewInv.refundLast4?` ending in ${viewInv.refundLast4}`:""}.
                    </div>
                  )}
                  {viewInv.refundStatus==="manual" && (
                    <div style={{fontSize:12,color:"#B45309",marginTop:6}}>
                      We will contact you to arrange a refund.
                    </div>
                  )}
                  {viewInv.refundStatus==="failed" && (
                    <div style={{fontSize:12,color:"#B45309",marginTop:6}}>
                      Automated refund was not processed. Our team will reach out to arrange your refund manually.
                    </div>
                  )}
                  {viewInv.refundStatus==="not_applicable" && (
                    <div style={{fontSize:12,color:"#991B1B",marginTop:6}}>
                      No payment had been made, so no refund is needed.
                    </div>
                  )}
                </div>
              )}
              {/* Company header with logo */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:32}}>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
                    {mpc.logo?<img src={mpc.logo} alt={mpc.name} style={{maxHeight:56,objectFit:"contain"}} onError={e=>{e.target.style.display="none"}}/>:<img src="/mpc-logo.png" alt="MotorPower Care" style={{width:56,height:56,objectFit:"contain"}}/>}
                    <div style={{fontSize:22,fontWeight:700,color:C.navy}}>{mpc.name}</div>
                  </div>
                  <div style={{fontSize:12,color:C.inkLight,lineHeight:1.9}}>{mpc.address}<br/>{mpc.city}<br/>{mpc.phone}<br/>{mpc.email}<br/>{mpc.website}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:34,fontWeight:700,color:C.navy,marginBottom:6}}>INVOICE</div>
                  <div style={{fontSize:13,color:C.inkLight,lineHeight:1.9}}>
                    <strong style={{color:C.ink}}>Invoice #:</strong> {viewInv.id}<br/>
                    <strong style={{color:C.ink}}>Date:</strong> {today}<br/>
                    <strong style={{color:C.ink}}>Terms:</strong> {viewInv.paymentTerms||"Net 30"}
                  </div>
                  <div style={{marginTop:8,display:"inline-block",background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:6,padding:"4px 10px",fontSize:11,fontWeight:600,color:"#1D4ED8"}}>Tax Exempt — For Resale</div>
                </div>
              </div>

              {/* Navy gradient divider */}
              <div style={{height:2,background:`linear-gradient(to right,${C.navy},${C.blue})`,borderRadius:2,marginBottom:28}}/>

              {/* Bill to / From section */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24,marginBottom:28}}>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>Bill to</div>
                  <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:2}}>{viewInv.customer||customerName||"—"}</div>
                  <div style={{fontSize:12,color:C.inkLight,lineHeight:1.9}}>
                    {custAddr||""}{custAddr?<br/>:null}
                    {cp.phone||""}{cp.phone?<br/>:null}
                    {cp.email||viewInv.customerEmail||""}
                  </div>
                  {cp.ein&&<div style={{marginTop:6,fontSize:11,color:C.inkMid}}><strong>EIN / Tax ID:</strong> {cp.ein}</div>}
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>From</div>
                  <div style={{fontSize:12,color:C.inkMid,lineHeight:1.9}}>
                    <strong style={{color:C.ink}}>Seller:</strong> {mpc.name}<br/>
                    <strong style={{color:C.ink}}>Tax ID:</strong> {mpc.taxId}<br/>
                    {viewInv.rep&&<><strong style={{color:C.ink}}>Rep:</strong> {displayRepStamp(viewInv.rep)}<br/></>}
                    {mpc.phone&&<><strong style={{color:C.ink}}>Phone:</strong> {mpc.phone}</>}
                  </div>
                </div>
              </div>

              {/* Line items table with row numbers and navy header */}
              {hasItems?(
                <>
                  <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",marginBottom:24}}>
                    <div style={{display:"grid",gridTemplateColumns:"32px 80px 1fr 60px 80px 90px",background:C.navy,padding:"10px 16px",gap:8}}>
                      {["#","SKU","Description","Qty","Price","Total"].map(h=>(
                        <div key={h} style={{fontSize:11,fontWeight:600,color:C.white,textAlign:["Qty","Price","Total"].includes(h)?"right":"left"}}>{h}</div>
                      ))}
                    </div>
                    {viewInv.items.map((item,i)=>{
                      const caseSize = Math.max(1, Number(item.case)||1);
                      const linePrice = Number(item.price)||0;
                      const unitPrice = caseSize > 1 ? linePrice / caseSize : null;
                      return (
                      <div key={i} style={{display:"grid",gridTemplateColumns:"32px 80px 1fr 60px 80px 90px",gap:8,padding:"11px 16px",borderTop:`1px solid ${C.border}`,background:i%2===0?C.white:C.surface}}>
                        <div style={{fontSize:12,color:C.inkLight}}>{i+1}</div>
                        <div style={{fontSize:11,fontWeight:600,color:C.blue,fontFamily:"monospace"}}>{item.sku||"—"}</div>
                        <div style={{fontSize:12,fontWeight:500,color:C.ink}}>{item.name}</div>
                        <div style={{fontSize:12,color:C.ink,textAlign:"right"}}>{item.qty}</div>
                        <div style={{fontSize:12,color:C.ink,textAlign:"right"}}>
                          ${linePrice.toFixed(2)}
                          {unitPrice != null && (
                            <div style={{fontSize:9,color:C.inkLight,fontWeight:400,marginTop:2}}>
                              ${unitPrice.toFixed(2)}/unit · case of {caseSize}
                            </div>
                          )}
                        </div>
                        <div style={{fontSize:12,fontWeight:500,color:C.ink,textAlign:"right"}}>${(linePrice*(Number(item.qty)||0)).toFixed(2)}</div>
                      </div>
                      );
                    })}
                  </div>
                  <div style={{display:"flex",justifyContent:"flex-end",marginBottom:24}}>
                    <div style={{width:300}}>
                      {reconciliationMismatch && (
                        <div style={{fontSize:11,padding:"6px 8px",borderRadius:6,background:"#FEF3C7",color:"#92400E",border:"1px solid #FCD34D",marginBottom:6,lineHeight:1.4}}>
                          Line items + recorded adjustments sum to <strong>${expectedFromItems.toFixed(2)}</strong>; this invoice was charged <strong>${storedTotal.toFixed(2)}</strong>. Total due reflects the charged amount.
                        </div>
                      )}
                      <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}><span style={{color:C.inkMid}}>Subtotal</span><span style={{fontWeight:500}}>${subtotal.toFixed(2)}</span></div>
                      {invDiscount && discountAmt > 0 && (
                        <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                          <span style={{color:C.teal}}>{invDiscount.label || "Discount"}{invDiscount.pct ? ` (${invDiscount.pct}%)` : ""}</span>
                          <span style={{color:C.teal,fontWeight:500}}>−${discountAmt.toFixed(2)}</span>
                        </div>
                      )}
                      {invShipping && shippingAmt > 0 && (
                        <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                          <span style={{color:C.inkMid}}>Shipping{invShipping.label ? ` (${invShipping.label})` : ""}</span>
                          <span style={{fontWeight:500}}>${shippingAmt.toFixed(2)}</span>
                        </div>
                      )}
                      {invShipping && shippingAmt === 0 && (
                        <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                          <span style={{color:C.inkMid}}>Shipping{invShipping.label ? ` (${invShipping.label})` : ""}</span>
                          <span style={{color:C.teal,fontWeight:500}}>FREE</span>
                        </div>
                      )}
                      <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",fontSize:13,borderBottom:`1px solid ${C.border}`}}><span style={{color:C.inkMid}}>Tax</span><span style={{color:C.teal,fontWeight:500}}>$0.00 — Tax exempt</span></div>
                      <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",fontSize:16,fontWeight:700,color:C.navy}}><span>Total due</span><span>${authoritativeTotal.toFixed(2)}</span></div>
                    </div>
                  </div>
                </>
              ):(
                <div style={{marginBottom:24}}>
                  <div style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"14px 18px",marginBottom:16}}>
                    <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:6}}>Items</div>
                    <div style={{fontSize:13,color:C.inkMid}}>{typeof viewInv.items==="string"?viewInv.items:"—"}</div>
                  </div>
                  <div style={{display:"flex",justifyContent:"flex-end"}}>
                    <div style={{fontSize:16,fontWeight:700,color:C.navy}}>Total: ${Number(viewInv.total||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
                  </div>
                </div>
              )}

              {/* Notes */}
              {viewInv.notes&&<div style={{background:C.surface,borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12,color:C.inkMid}}><strong>Notes:</strong> {viewInv.notes}</div>}
              {viewInv.repCreated&&<div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:14}}>This invoice was created by your sales rep during a field visit.</div>}
              {viewInv.source==="admin_invoice"&&<div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:14}}>This invoice was issued to you by MotorPower Care.</div>}

              {/* Tax exemption notice */}
              <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"12px 16px",marginBottom:20}}>
                <div style={{fontSize:11,fontWeight:700,color:"#1D4ED8",marginBottom:4}}>TAX EXEMPTION NOTICE</div>
                <div style={{fontSize:11,color:"#1E40AF",lineHeight:1.6}}>This sale is exempt from sales tax. Purchaser holds a valid resale certificate{cp.ein?` (EIN: ${cp.ein})`:""}: on file. Seller tax ID: {mpc.taxId}. For wholesale/resale purposes only.</div>
              </div>

              {/* Payment information */}
              {(mpc.bankName||mpc.paypalEmail||mpc.zelleEmail)&&(
                <div style={{background:C.surface,borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:11,color:C.inkMid}}>
                  <strong style={{color:C.ink}}>Payment information</strong><br/>
                  {mpc.bankName&&<span>Bank: {mpc.bankName}{mpc.bankRouting?` | Routing: ${mpc.bankRouting}`:""}{mpc.bankAccount?` | Acct: ${mpc.bankAccount}`:""}<br/></span>}
                  {mpc.paypalEmail&&<span>PayPal: {mpc.paypalEmail}<br/></span>}
                  {mpc.zelleEmail&&<span>Zelle: {mpc.zelleEmail}<br/></span>}
                </div>
              )}

              {/* Footer */}
              <div style={{borderTop:`1px solid ${C.border}`,paddingTop:14,marginBottom:20,display:"flex",justifyContent:"space-between"}}>
                <div style={{fontSize:11,color:C.inkLight}}>{mpc.invoiceNotes||"Thank you for your business"} — {mpc.name}</div>
                <div style={{fontSize:11,color:C.inkLight}}>{mpc.email}</div>
              </div>

              {/* Customer action buttons */}
              <div style={{display:"flex",gap:10}}>
                <button style={{...S.btnSecondary,flex:1}} onClick={()=>setViewInv(null)}>Close</button>
                {viewInv.status!=="paid" && viewInv.status!=="cancelled" && viewInv.status!=="payment_pending" && <button style={{...S.btnPrimary,flex:1}} onClick={()=>{setPayingId(viewInv.id);setPayStep("method");setPayMethod("cc");setPayError("");setPayResult(null);setViewInv(null);}}>Pay now</button>}
              </div>
            </div>
          </div>
        </div>
        );
      })()}
    </div>
  );
}

// ─── NOTIFICATION DATA ────────────────────────────────────────────────────────
const INIT_NOTIFICATIONS = [
  {id:1, time:"Apr 10, 2025 4:02 PM", type:"order_completed",   icon:"✓", color:"#166534", bg:"#DCFCE7", title:"Order completed",        body:"Apex Car Care LLC placed order #ORD-4822 — $178.59",         action:"View order"},
  {id:2, time:"Apr 10, 2025 2:15 PM", type:"order_started",     icon:"◐", color:"#B45309", bg:"#FEF3C7", title:"Order started — not completed", body:"FastLane Auto Parts started checkout but did not complete. Cart value: $93.60", action:"Follow up"},
  {id:3, time:"Apr 9, 2025 11:30 AM", type:"invoice_created",   icon:"◎", color:"#1560BD", bg:"#E8F0FE", title:"Field invoice created",    body:"Marcus T. created INV-F041 for Apex Car Care LLC — $88.80",  action:"View invoice"},
  {id:4, time:"Apr 9, 2025 9:00 AM",  type:"order_completed",   icon:"✓", color:"#166534", bg:"#DCFCE7", title:"Order completed",          body:"Westside Repair Center placed order #ORD-4821 — $980.00",    action:"View order"},
  {id:5, time:"Apr 8, 2025 3:45 PM",  type:"signup",            icon:"★", color:"#5B21B6", bg:"#EDE9FE", title:"New account application",  body:"Desert Diesel Service applied for a wholesale account",      action:"Review"},
  {id:6, time:"Apr 7, 2025 10:20 AM", type:"order_started",     icon:"◐", color:"#B45309", bg:"#FEF3C7", title:"Order started — not completed", body:"Pacific Fleet Mgmt started checkout but did not complete. Cart value: $1,240.00", action:"Follow up"},
  {id:7, time:"Apr 10, 2025 5:15 PM", type:"material_order",    icon:"📦", color:"#0D7A5F", bg:"#E0F4EE", title:"Material order received",  body:"Apex Car Care LLC ordered 3 items: Product flyer — DPF line ×2, Shelf talker ×1. FREE — ship with next delivery.", action:"Process order"},
  {id:8, time:"Apr 9, 2025 3:00 PM",  type:"material_order",    icon:"📦", color:"#0D7A5F", bg:"#E0F4EE", title:"Material order received",  body:"Marcus T. (rep) ordered 4 items: Counter display ×1, Product flyer ×3. Total: $25.00 — ship to rep territory.", action:"Process order"},
];

function AdminNotificationsTab({onNavigate, onFocusInvoice, onFocusAdjustRequest, accounts = []}) {
  // Admin-only removal state: notifications for removed (voided + hidden)
  // invoices are not shown. Display-level filter, so timing of the fetch
  // relative to the per-invoice notification regeneration does not matter.
  const notifRemovals = useOrderRemovals();
  const [notifications, setNotifications] = useState(INIT_NOTIFICATIONS);
  const [filter, setFilter] = useState("all");
  const [notifSearch, setNotifSearch] = useState("");
  const [followUp, setFollowUp] = useState(null); // abandoned-cart notification being followed up on
  // Mark-shipped modal state for a specific material-order notification.
  // null when no modal is open; { notif, notes, busy } when admin is in the
  // "Mark order MAT-XXX as shipped?" flow.
  const [markShipNotif, setMarkShipNotif] = useState(null);
  const [markShipNotes, setMarkShipNotes] = useState("");
  const [markShipBusy, setMarkShipBusy] = useState(false);
  // Amber sync-pending banner — appears at top of Notifications tab when
  // markMaterialOrderShipped fails. Retryable; admin clicks Mark shipped
  // again and the helper is idempotent.
  const [markShipError, setMarkShipError] = useState("");
  // Pending stock requests (Supabase inventory_requests, migration 0020).
  // Surfaced as a separate card at the top of this tab so admin sees the
  // queue without scrolling. The review action navigates to the Inventory
  // tab where the full Pending Stock Requests section lives (with inline
  // qty edit + approve/reject). RLS server-side limits this fetch to admin.
  const [pendingInvRequests, setPendingInvRequests] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listInventoryRequests({ status: 'pending', limit: 50 });
        if (!cancelled) setPendingInvRequests(rows || []);
      } catch (e) {
        console.warn("[AdminNotificationsTab] listInventoryRequests failed:", e?.message || e);
        // Leave previous state in place; non-fatal — full UI still works.
      }
    };
    load();
    const unsub = subscribeInventoryRequests(() => { load(); });
    return () => { cancelled = true; unsub && unsub(); };
  }, []);
  // Pending invoice void requests (Supabase invoice_void_requests, 0022).
  // Mirrors the inventory-requests amber card pattern above. The Review
  // queue button navigates to the Orders tab where the full review UI
  // lives with inline decision-note + Approve/Reject buttons.
  const [pendingVoidReqs, setPendingVoidReqs] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listInvoiceVoidRequests({ status: 'pending', limit: 50 });
        if (!cancelled) setPendingVoidReqs(rows || []);
      } catch (e) {
        console.warn("[AdminNotificationsTab] listInvoiceVoidRequests failed:", e?.message || e);
      }
    };
    load();
    const unsub = subscribeInvoiceVoidRequests(() => { load(); });
    return () => { cancelled = true; unsub && unsub(); };
  }, []);
  // Pending invoice ADJUSTMENT requests (invoice_adjustment_requests, 0028).
  // The blue card below deep-links each request to the Orders tab.
  const [pendingAdjReqs, setPendingAdjReqs] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listAdjustmentRequests({ status: 'pending', limit: 50 });
        if (!cancelled) setPendingAdjReqs(rows || []);
      } catch (e) {
        console.warn("[AdminNotificationsTab] listAdjustmentRequests failed:", e?.message || e);
      }
    };
    load();
    const unsub = subscribeAdjustmentRequests(() => { load(); });
    return () => { cancelled = true; unsub && unsub(); };
  }, []);
  // Subscribe to SHARED_INVOICES so notifications tied to an invoice
  // (invoice_created) can auto-clear once that invoice is marked paid
  // or cancelled — see visibleNotifications below.
  const [notifSharedInvoices, setNotifSharedInvoices] = useState(() => SHARED_INVOICES.getAll());
  useEffect(() => SHARED_INVOICES.subscribe(setNotifSharedInvoices), []);

  // Auto-clear rule for a notification. A notification vanishes from the
  // list once it's BOTH read AND its underlying object is handled.
  // Unread notifications ALWAYS stay visible so admin never misses one.
  // Types with no structured link (order_started cart abandonment,
  // signup — body-only reference) stay until admin dismisses manually.
  const shouldAutoRemove = (n) => {
    if (!n || !n.read) return false;
    switch (n.type) {
      case 'invoice_created': {
        if (!n.sharedInvoiceId) return false;
        const inv = notifSharedInvoices.find(i => i.id === n.sharedInvoiceId);
        if (!inv) return true; // invoice no longer exists → nothing to act on
        const s = String(inv.status || "").toLowerCase();
        return s === 'paid' || s === 'done' || s === 'cancelled';
      }
      case 'material_order':
        // orderStatus is patched onto the notification when admin marks
        // it shipped via confirmMarkShipped above.
        return n.orderStatus === 'shipped';
      case 'order_completed':
        // Nothing further for admin to do once they've seen it.
        return true;
      default:
        // signup / order_started / anything else: manual dismiss only.
        return false;
    }
  };
  const visibleNotifications = notifications.filter(n => !shouldAutoRemove(n) && !(n.sharedInvoiceId && notifRemovals.map && notifRemovals.map[n.sharedInvoiceId]));
  const unread = visibleNotifications.filter(n=>!n.read).length;

  // Structured pull-outs from an `order_started` notification body so the
  // follow-up modal can show real details instead of the raw sentence.
  // Bodies look like: "FastLane Auto Parts started checkout but did not
  // complete. Cart value: $93.60". A new live source (if we add one later)
  // can instead set n.customer / n.cartValue directly and skip parsing.
  const parseCustomer = (n) => {
    if(n?.customer) return n.customer;
    const m = (n?.body||"").match(/^(.+?) started checkout/i);
    return m ? m[1].trim() : "";
  };
  const parseCartValue = (n) => {
    if(n?.cartValue != null) return n.cartValue;
    const m = (n?.body||"").match(/Cart value:\s*\$([\d,]+(?:\.\d+)?)/i);
    return m ? m[1] : "";
  };

  // Wire the per-row action button + the abandoned-cart banner follow-up.
  // - invoice_created: switch to Orders tab AND deep-link to the invoice modal.
  // - order_completed / material_order: switch to Orders tab.
  // - order_started: open an inline Follow-up modal (customer + cart value
  //   + contact info looked up from accounts) so the admin sees what the
  //   follow-up is about without having to hunt in the Accounts list.
  // - signup: switch to Accounts tab (pending apps already surface there).
  // All paths mark the row as read.
  // Opens the mark-shipped modal for a specific material_order notification.
  // Replaces the generic handleAction → onNavigate("orders") flow for the
  // "Mark shipped" button; Dismiss still goes through dismiss(), and the
  // card's title click can still navigate if needed in the future.
  const openMarkShipModal = (n) => {
    if (!n || n.type !== "material_order" || n.orderStatus === "shipped") return;
    setMarkShipNotif(n);
    setMarkShipNotes("");
    setMarkShipError("");
  };
  const closeMarkShipModal = () => {
    if (markShipBusy) return; // don't let admin cancel mid-write
    setMarkShipNotif(null);
    setMarkShipNotes("");
  };
  // Admin confirms "Mark shipped" in the modal. Supabase-first: await the
  // UPDATE scoped to exactly one row by client_id. On success: close modal,
  // patch the notification's shipped-state fields in local React state so
  // the card re-renders greyed + "Shipped on ..." immediately (realtime
  // would also re-fire from the listener subscriber, but we update locally
  // for snappier UX). On failure: close modal, surface amber banner. Helper
  // is idempotent so a retry via re-clicking Mark shipped is safe.
  const confirmMarkShipped = async () => {
    if (!markShipNotif || markShipBusy) return;
    setMarkShipBusy(true);
    const clientId = markShipNotif.materialOrderId;
    const notes = (markShipNotes || "").trim();
    let row = null;
    try {
      row = await markMaterialOrderShipped(clientId, notes || null);
    } catch(e) {
      console.warn("[AdminNotificationsTab] markMaterialOrderShipped threw:", e?.message || e);
    }
    setMarkShipBusy(false);
    if (!row) {
      setMarkShipError(`Couldn't mark ${clientId} as shipped — sync failed. Try again.`);
      setMarkShipNotif(null);
      setMarkShipNotes("");
      return;
    }
    // Success path: update local notification state; mirror the Supabase
    // row into SHARED_MATERIAL_ORDERS so any other subscriber (admin's own
    // Notifications feed subscriber, or any future consumer on the admin
    // side) gets the fresh shipped-state fields via the merged-add path.
    setNotifications(ns => ns.map(n => n.materialOrderId === clientId ? {
      ...n,
      orderStatus: "shipped",
      shippedDate: row.shipped_date || new Date().toISOString(),
      shippedNotes: row.shipped_notes || notes || null,
      read: true,
    } : n));
    try {
      SHARED_MATERIAL_ORDERS.add({
        id: clientId,
        status: "shipped",
        shippedDate: row.shipped_date || new Date().toISOString(),
        shippedNotes: row.shipped_notes || notes || null,
      });
    } catch(e) { /* cosmetic mirror — Supabase has the truth */ }
    setMarkShipNotif(null);
    setMarkShipNotes("");
    setMarkShipError("");
  };

  const handleAction = (n) => {
    if(!n) return;
    setNotifications(ns=>ns.map(x=>x.id===n.id?{...x,read:true}:x));
    if(n.type === "invoice_created") {
      if(n.sharedInvoiceId && onFocusInvoice) onFocusInvoice(n.sharedInvoiceId);
      if(onNavigate) onNavigate("orders");
    } else if(n.type === "order_completed" || n.type === "material_order") {
      if(onNavigate) onNavigate("orders");
    } else if(n.type === "order_started") {
      setFollowUp(n);
    } else if(n.type === "signup") {
      if(onNavigate) onNavigate("accounts");
    }
  };

  // Subscribe to live material orders from rep/customer portals (localStorage
  // mirror — drives the notifications feed via the existing code below).
  useEffect(()=>{
    const unsub = SHARED_MATERIAL_ORDERS.subscribe((orders)=>{
      const latest = orders[0];
      if(!latest) return;
      setNotifications(prev=>{
        const existingIdx = prev.findIndex(n => n.materialOrderId === latest.id);
        if (existingIdx !== -1) {
          // Mechanic #3: an existing notification for this material order
          // is already in state. In the old code we returned `prev` and
          // walked away, which meant a status flip (pending → shipped,
          // from admin on another device) never updated the card. Now we
          // patch the shipped-state fields in place so the card re-renders
          // as greyed + "Shipped on ..." even when the change originated
          // elsewhere. Non-shipped-state fields are untouched so admin's
          // local notes/read flags aren't clobbered.
          const current = prev[existingIdx];
          const nextStatus = latest.status || 'pending';
          const sameStatus = current.orderStatus === nextStatus
            && current.shippedDate === (latest.shippedDate || null)
            && current.shippedNotes === (latest.shippedNotes || null);
          if (sameStatus) return prev;
          return prev.map((n, i) => i === existingIdx ? {
            ...n,
            orderStatus: nextStatus,
            shippedDate: latest.shippedDate || null,
            shippedNotes: latest.shippedNotes || null,
          } : n);
        }
        const itemSummary = latest.items.map(i=>`${i.name} ×${i.qty}`).join(", ");
        return [{
          id:Date.now(), time:new Date().toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"numeric",minute:"2-digit"}),
          type:"material_order", icon:"📦", color:"#0D7A5F", bg:"#E0F4EE",
          title:"Material order received",
          body:`${latest.accountName} (${latest.source}) ordered ${latest.items.length} item${latest.items.length>1?"s":""}: ${itemSummary}. ${latest.total===0?"FREE":"$"+latest.total.toFixed(2)} — ship with next delivery.`,
          action:"Process order", materialOrderId:latest.id,
          // Carry the shipped-state fields from the Supabase row so a
          // notification built from an already-shipped order renders
          // correctly on first mount (not just on status flip).
          orderStatus: latest.status || 'pending',
          shippedDate: latest.shippedDate || null,
          shippedNotes: latest.shippedNotes || null,
        },...prev];
      });
    });
    return unsub;
  },[]);

  // Phase C — admin-side material_orders hydrate + realtime. Admin's RLS
  // grants full read, so we pass no filter and receive every row. Rows
  // merge into SHARED_MATERIAL_ORDERS via .add() (which is now idempotent
  // on id), which in turn triggers the localStorage subscriber above so
  // the Notifications feed picks up cross-device orders without any change
  // to the notification render path. Never clears localStorage.
  useEffect(()=>{
    let mounted = true;
    const dbRowToOrder = (r) => ({
      id: r.client_id || String(r.id),
      _supabaseRowId: r.id,
      source: r.source || "customer",
      accountName: r.account_name || "",
      rep: r.rep_name || "",
      userId: r.user_id || "",
      items: Array.isArray(r.items) ? r.items : [],
      total: Number(r.total) || 0,
      status: r.status || "pending",
      shippedDate: r.shipped_date || null,
      date: r.placed_at ? new Date(r.placed_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
      placedAt: r.placed_at || new Date().toISOString(),
      fromDb: true,
    });
    const mergeRows = (rows) => {
      // Phase C micro-fix: previous version skipped .add() when the row was
      // already in SHARED_MATERIAL_ORDERS._data (loaded from localStorage).
      // On any AdminNotificationsTab REMOUNT (e.g. admin switching away and
      // back), _data persists across mounts via localStorage, but the
      // component's `notifications` React state resets to INIT_NOTIFICATIONS
      // — no memory of previously-created material-order notifications.
      // With the skip in place, .add() never fired → notification listener
      // at App.js:2941 never received the row → notification card never
      // appeared. Removing the skip is safe because SHARED_MATERIAL_ORDERS
      // .add() already has its own internal idempotent guard (does not
      // double-unshift on duplicate id) AND fires listeners on BOTH the
      // "new" and "already-present" branches, so the subscriber reliably
      // gets its callback on every hydrate regardless of localStorage
      // state. Verified by reading RepPortal.js:227-234.
      let added = 0, refired = 0;
      (rows || []).forEach(r => {
        const o = dbRowToOrder(r);
        const alreadyLocal = SHARED_MATERIAL_ORDERS.getAll().some(x => String(x.id) === String(o.id));
        SHARED_MATERIAL_ORDERS.add(o);
        if (alreadyLocal) { refired++; console.debug("[admin material_orders hydrate] re-fired listener for id already in local", o.id); }
        else              { added++;   console.debug("[admin material_orders hydrate] added to local", o.id); }
      });
      if (added > 0 || refired > 0) console.info(`[admin material_orders hydrate] ${added} newly merged, ${refired} re-fired (already in local).`);
    };
    (async () => {
      try {
        const rows = await listMaterialOrders({});
        console.debug("[admin material_orders hydrate] fetched", (rows||[]).length, "row(s) from Supabase", (rows||[]).map(r => r.client_id || r.id));
        if (mounted) mergeRows(rows);
      } catch(e) { console.warn("[admin material_orders] mount fetch failed:", e?.message||e); }
    })();
    const unsub = subscribeMaterialOrders({}, async () => {
      if (!mounted) return;
      try {
        const rows = await listMaterialOrders({});
        if (mounted) mergeRows(rows);
      } catch(e) { console.warn("[admin material_orders] realtime refetch failed:", e?.message||e); }
    });
    return () => { mounted = false; if (typeof unsub === "function") unsub(); };
  },[]);

  // Subscribe to live field invoices + customer-placed orders from SHARED_INVOICES.
  // Two distinct notifications based on inv.source:
  //   - source==="portal_order"  → customer placed the order themselves;
  //                                show as "New customer order" with a green check
  //                                + View order action. Routes to the Orders tab
  //                                with deep-link (see handleAction).
  //   - otherwise (rep-created)  → "Field invoice created" blue ◎ (legacy copy).
  // Both use `type:"order_completed"` for portal_order so the Orders-completed
  // stat card counts customer orders too.
  const buildOrderNotif = (inv, isBulk=false) => {
    const isCustomerOrder = inv.source === "portal_order";
    const isOfficeInvoice = inv.source === "admin_invoice";
    const displayId = inv.orderId || inv.id;
    return {
      id: isBulk ? Date.now()+Math.random() : Date.now(),
      time: inv.sharedAt ? new Date(inv.sharedAt).toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"numeric",minute:"2-digit"}) : new Date().toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"numeric",minute:"2-digit"}),
      type: isCustomerOrder ? "order_completed" : "invoice_created",
      icon: isCustomerOrder ? "✓" : "◎",
      color: isCustomerOrder ? "#166534" : "#1560BD",
      bg:    isCustomerOrder ? "#DCFCE7" : "#E8F0FE",
      title: isCustomerOrder ? "New customer order" : isOfficeInvoice ? "Invoice created in the office" : "Field invoice created",
      body:  isCustomerOrder
        ? `${inv.customer||"Customer"} placed ${displayId} — $${Number(inv.total||0).toFixed(2)}${inv.rep?` · rep: ${displayRepStamp(inv.rep)}`:""}`
        : isOfficeInvoice
          ? `${inv.id} created for ${inv.customer} — $${Number(inv.total||0).toFixed(2)}${inv.rep && inv.rep!==HOUSE_REP_LABEL ? ` · credited to ${inv.rep}` : " · house account (no rep)"}`
          : `${displayRepStamp(inv.rep)||"Rep"} created ${inv.id} for ${inv.customer} — $${Number(inv.total||0).toFixed(2)}`,
      action: isCustomerOrder ? "View order" : "View invoice",
      sharedInvoiceId: inv.id,
    };
  };
  useEffect(()=>{
    const checkExisting = SHARED_INVOICES.getAll();
    if(checkExisting.length>0){
      setNotifications(prev=>{
        let updated = [...prev];
        checkExisting.forEach(inv=>{
          if(!updated.some(n=>n.sharedInvoiceId===inv.id)){
            updated = [buildOrderNotif(inv, true),...updated];
          }
        });
        return updated;
      });
    }
    const unsub2 = SHARED_INVOICES.subscribe((invoices)=>{
      if(!invoices||invoices.length===0) return;
      const latest = invoices[0];
      setNotifications(prev=>{
        if(prev.some(n=>n.sharedInvoiceId===latest.id)) return prev;
        return [buildOrderNotif(latest, false),...prev];
      });
    });
    return unsub2;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const markAllRead = () => setNotifications(ns=>ns.map(n=>({...n,read:true})));
  const dismiss = (id) => setNotifications(ns=>ns.filter(n=>n.id!==id));

  // Filter chain uses visibleNotifications so auto-cleared items don't
  // show anywhere (stat cards, filter tabs, list). Manual dismiss still
  // works via the × icon on each row.
  const preFiltered = filter==="all" ? visibleNotifications :
    filter==="followup" ? visibleNotifications.filter(n=>n.type==="order_started") :
    filter==="orders" ? visibleNotifications.filter(n=>n.type==="order_completed") :
    filter==="material_order" ? visibleNotifications.filter(n=>n.type==="material_order") :
    visibleNotifications.filter(n=>n.type===filter);
  const filtered = notifSearch.trim() ? preFiltered.filter(n=>{
    const q=notifSearch.toLowerCase();
    return (n.title||"").toLowerCase().includes(q)||(n.body||"").toLowerCase().includes(q)||(n.time||"").toLowerCase().includes(q);
  }) : preFiltered;

  // Follow-up modal — opens from the "Follow up" button on any
  // order_started notification (and from the amber abandoned-cart banner).
  // Matches account by company name (case-insensitive). If no account
  // exists (seeded customer that's not in INIT_ACCOUNTS), we still show
  // cart value / time so the admin isn't left guessing.
  const followUpCompany = followUp ? parseCustomer(followUp) : "";
  const followUpCart    = followUp ? parseCartValue(followUp) : "";
  const followUpAccount = followUp
    ? (accounts||[]).find(a => (a.company||"").toLowerCase() === followUpCompany.toLowerCase())
    : null;

  return (
    <div>
      {/* Abandoned-cart follow-up modal */}
      {followUp && (
        <div style={S.modal} onClick={()=>setFollowUp(null)}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:520,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Follow up on abandoned cart</div>
            <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>{followUp.time}</div>

            <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:10,padding:"12px 14px",marginBottom:16}}>
              <div style={{fontSize:11,color:C.amber,fontWeight:600,marginBottom:4,textTransform:"uppercase",letterSpacing:0.3}}>Customer</div>
              <div style={{fontSize:15,fontWeight:600,color:C.ink,marginBottom:6}}>{followUpCompany || "(unknown)"}</div>
              {followUpCart && <div style={{fontSize:13,color:C.amber}}>Cart value: <strong style={{color:C.ink}}>${followUpCart}</strong></div>}
            </div>

            {followUpAccount ? (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:8,textTransform:"uppercase",letterSpacing:0.3}}>Contact</div>
                <div style={{background:C.surface,borderRadius:10,padding:"12px 14px"}}>
                  {followUpAccount.contact && <div style={{fontSize:14,fontWeight:500,color:C.ink,marginBottom:6}}>{followUpAccount.contact}</div>}
                  {followUpAccount.email && (
                    <div style={{fontSize:13,marginBottom:4}}>
                      <a href={`mailto:${followUpAccount.email}?subject=${encodeURIComponent("Quick follow-up from MotorPower Care")}&body=${encodeURIComponent(`Hi ${followUpAccount.contact||"there"},\n\nI noticed you started placing an order with us but didn't complete it. Is there anything I can help you with?\n\nBest regards,\nMotorPower Care`)}`} style={{color:C.blue,textDecoration:"none"}}>{followUpAccount.email}</a>
                    </div>
                  )}
                  {followUpAccount.phone && (
                    <div style={{fontSize:13,marginBottom:4}}>
                      <a href={`tel:${followUpAccount.phone.replace(/[^\d+]/g,"")}`} style={{color:C.blue,textDecoration:"none"}}>{followUpAccount.phone}</a>
                    </div>
                  )}
                  {followUpAccount.rep && <div style={{fontSize:12,color:C.inkLight,marginTop:6}}>Assigned rep: <strong style={{color:C.ink}}>{followUpAccount.rep}</strong></div>}
                  {followUpAccount.tier && <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>Tier: <strong style={{color:C.ink}}>{followUpAccount.tier}</strong></div>}
                </div>
              </div>
            ) : (
              <div style={{fontSize:12,color:C.inkLight,padding:"10px 12px",background:C.surface,borderRadius:8,marginBottom:16}}>
                No matching account found for <strong>{followUpCompany}</strong>. This customer may not be in the accounts list yet.
              </div>
            )}

            <div style={{display:"flex",gap:8,flexWrap:"wrap",justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setFollowUp(null)}>Close</button>
              {followUpAccount?.email && (
                <a href={`mailto:${followUpAccount.email}?subject=${encodeURIComponent("Quick follow-up from MotorPower Care")}&body=${encodeURIComponent(`Hi ${followUpAccount.contact||"there"},\n\nI noticed you started placing an order with us but didn't complete it. Is there anything I can help you with?\n\nBest regards,\nMotorPower Care`)}`} style={{...S.btnPrimary,textDecoration:"none",display:"inline-block"}}>Email customer</a>
              )}
              {followUpAccount?.phone && (
                <a href={`tel:${followUpAccount.phone.replace(/[^\d+]/g,"")}`} style={{...S.btnSecondary,textDecoration:"none",display:"inline-block"}}>Call</a>
              )}
              {followUpAccount && onNavigate && (
                <button style={S.btnSecondary} onClick={()=>{ setFollowUp(null); onNavigate("accounts"); }}>Open account</button>
              )}
              <button style={S.btnSuccess} onClick={()=>{ const id = followUp.id; setFollowUp(null); dismiss(id); }}>Mark as followed up</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <div style={{fontSize:14,fontWeight:600,color:C.ink}}>Notifications & alerts</div>
          <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>
            Order started/completed, new signups, invoices, tool alerts. When SendGrid is connected these will also send to info@mpcare.com.
          </div>
        </div>
        {unread>0&&<button style={S.btnSecondary} onClick={markAllRead}>Mark all read</button>}
      </div>

      {/* Pending Stock Requests card — only renders when there are pending
          inventory_requests rows. Click "Review" to jump to the Inventory tab
          where the full queue (with inline qty edit + approve/reject buttons)
          lives. Realtime-subscribed above so this card shows up the moment a
          rep files a request, even if admin is on the Notifications tab. */}
      {pendingInvRequests.length > 0 && (
        <div style={{
          marginBottom:16,
          padding:"14px 16px",
          background:"#FEF3C7",
          border:"1px solid #FCD34D",
          borderRadius:10,
          display:"flex",
          alignItems:"flex-start",
          gap:12,
          justifyContent:"space-between"
        }}>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:13, fontWeight:600, color:"#92400E", marginBottom:4}}>
              {pendingInvRequests.length} pending stock request{pendingInvRequests.length===1?"":"s"} from sales reps
            </div>
            <div style={{fontSize:12, color:"#78350F"}}>
              Reps are waiting for approval before the stock counts toward their on-hand inventory.
            </div>
            <div style={{marginTop:8, fontSize:12, color:"#78350F"}}>
              {pendingInvRequests.slice(0,3).map(req => (
                <div key={req.id} style={{marginTop:2}}>
                  <strong>{req.rep_name || req.rep_id || "Rep"}</strong>
                  {" → "}
                  <span style={{fontFamily:"monospace", fontSize:11}}>{req.sku}</span>
                  {req.product_name && <span style={{marginLeft:6}}>{req.product_name}</span>}
                  <span style={{marginLeft:8, fontWeight:600}}>×{req.requested_qty}</span>
                </div>
              ))}
              {pendingInvRequests.length > 3 && (
                <div style={{marginTop:4, fontStyle:"italic"}}>
                  …and {pendingInvRequests.length - 3} more.
                </div>
              )}
            </div>
          </div>
          <button
            style={{...S.btnPrimary, whiteSpace:"nowrap"}}
            onClick={() => { if (onNavigate) onNavigate("repinventory"); }}
          >
            Review queue
          </button>
        </div>
      )}

      {/* Pending invoice ADJUSTMENT requests — rep-filed via RepInvoices. Each
          Review button deep-links to that request on the Orders tab. */}
      {pendingAdjReqs.length > 0 && (
        <div style={{marginBottom:16, padding:"14px 16px", background:"#DBEAFE", border:"1px solid #93C5FD", borderRadius:10}}>
          <div style={{fontSize:13, fontWeight:600, color:"#1E40AF", marginBottom:4}}>
            {pendingAdjReqs.length} invoice adjustment request{pendingAdjReqs.length===1?"":"s"} from sales reps
          </div>
          <div style={{fontSize:12, color:"#1E3A8A", marginBottom:8}}>
            Reps are asking to correct invoices. Nothing changes until you approve.
          </div>
          {pendingAdjReqs.slice(0,5).map(req => {
            const p = (req.proposed_changes && typeof req.proposed_changes === 'object') ? req.proposed_changes : {};
            const s = (req.original_snapshot && typeof req.original_snapshot === 'object') ? req.original_snapshot : {};
            return (
              <div key={req.id} style={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, padding:"6px 0", borderTop:"1px solid #BFDBFE", fontSize:12, color:"#1E3A8A"}}>
                <div style={{minWidth:0}}>
                  <strong>{req.rep_name || req.rep_email || "Rep"}</strong>{" → "}
                  <span style={{fontFamily:"monospace", fontSize:11}}>{req.invoice_id}</span>
                  {req.customer && <span style={{marginLeft:6}}>({req.customer})</span>}
                  <span style={{marginLeft:6, fontWeight:600}}>${(Number(s.total)||0).toFixed(2)} → ${(Number(p.total)||0).toFixed(2)}</span>
                  {req.reason && <div style={{fontSize:11, color:"#1D4ED8"}}>&ldquo;{req.reason}&rdquo;</div>}
                </div>
                <button
                  style={{...S.btnPrimary, whiteSpace:"nowrap", background:"#1D4ED8", padding:"6px 12px", fontSize:12}}
                  onClick={() => { if (onFocusAdjustRequest) onFocusAdjustRequest(String(req.id)); if (onNavigate) onNavigate("orders"); }}
                >Review</button>
              </div>
            );
          })}
          {pendingAdjReqs.length > 5 && (
            <div style={{marginTop:4, fontSize:12, fontStyle:"italic", color:"#1E3A8A"}}>…and {pendingAdjReqs.length - 5} more on the Orders tab.</div>
          )}
        </div>
      )}

      {/* Pending invoice void requests — rep-filed via RepInvoices, admin
          reviews on Orders tab. Approve flips portal_orders.status='cancelled'
          (which existing repMetrics math treats as excluded-from-commission
          + inventory-restored). Reject leaves the invoice as-is. */}
      {pendingVoidReqs.length > 0 && (
        <div style={{
          marginBottom:16,
          padding:"14px 16px",
          background:"#FEE2E2",
          border:"1px solid #FCA5A5",
          borderRadius:10,
          display:"flex",
          alignItems:"flex-start",
          gap:12,
          justifyContent:"space-between"
        }}>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:13, fontWeight:600, color:"#991B1B", marginBottom:4}}>
              {pendingVoidReqs.length} invoice void request{pendingVoidReqs.length===1?"":"s"} from sales reps
            </div>
            <div style={{fontSize:12, color:"#7F1D1D"}}>
              Reps are asking you to void invoices. Approve to cancel (removes commission, restores inventory); reject to keep as is.
            </div>
            <div style={{marginTop:8, fontSize:12, color:"#7F1D1D"}}>
              {pendingVoidReqs.slice(0,3).map(req => {
                const snap = (req.invoice_snapshot && typeof req.invoice_snapshot === 'object') ? req.invoice_snapshot : {};
                return (
                  <div key={req.id} style={{marginTop:2}}>
                    <strong>{req.rep_name || req.rep_id || "Rep"}</strong>
                    {" → "}
                    <span style={{fontFamily:"monospace", fontSize:11}}>{req.invoice_id}</span>
                    {snap.customer && <span style={{marginLeft:6}}>({snap.customer})</span>}
                    {snap.total != null && <span style={{marginLeft:6, fontWeight:600}}>${(Number(snap.total)||0).toFixed(2)}</span>}
                    {req.reason && <div style={{fontSize:11, marginLeft:14, color:"#9A3412"}}>&ldquo;{req.reason}&rdquo;</div>}
                  </div>
                );
              })}
              {pendingVoidReqs.length > 3 && (
                <div style={{marginTop:4, fontStyle:"italic"}}>
                  …and {pendingVoidReqs.length - 3} more.
                </div>
              )}
            </div>
          </div>
          <button
            style={{...S.btnPrimary, whiteSpace:"nowrap", background:"#991B1B"}}
            onClick={() => { if (onNavigate) onNavigate("orders"); }}
          >
            Review queue
          </button>
        </div>
      )}

      {/* Stats — click a card to filter the list below. Click the active
          card again to clear and return to "All". Same pattern as the other
          admin-panel top rows. */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:16}}>
        {[
          {l:"Follow up needed",   v:visibleNotifications.filter(n=>n.type==="order_started").length,   warn:true, key:"followup"},
          {l:"Orders completed",   v:visibleNotifications.filter(n=>n.type==="order_completed").length, up:true,   key:"orders"},
          {l:"Material orders",    v:visibleNotifications.filter(n=>n.type==="material_order").length,  teal:true, key:"material_order"},
          {l:"New invoices",       v:visibleNotifications.filter(n=>n.type==="invoice_created").length,            key:"invoice_created"},
          {l:"New applications",   v:visibleNotifications.filter(n=>n.type==="signup").length,                     key:"signup"},
        ].map(m=>{
          const active = filter===m.key;
          const accent = m.warn ? C.amber : m.teal ? C.teal : C.blue;
          return (
            <div
              key={m.l}
              onClick={()=>setFilter(active ? "all" : m.key)}
              style={{
                ...S.metric,
                ...(m.warn?{borderTop:`3px solid ${C.amber}`}:m.teal?{borderTop:`3px solid ${C.teal}`}:{}),
                cursor:"pointer",
                boxShadow: active ? `0 0 0 2px ${accent}` : undefined,
                transition:"box-shadow 0.15s, transform 0.15s"
              }}
              onMouseEnter={e=>{ if(!active) e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
            >
              <div style={S.mLabel}>{m.l}</div>
              <div style={S.mValue}>{m.v}</div>
              {active && <div style={{fontSize:10,color:accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
            </div>
          );
        })}
      </div>

      {/* Material-order mark-shipped sync warning. Appears when the
          Supabase write failed (network / RLS / etc). Retryable — admin
          clicks Mark shipped on the same card again, helper is idempotent. */}
      {markShipError && (
        <div style={{margin:"0 0 12px", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
          <div style={{flex:1}}><strong>{markShipError}</strong></div>
          <button
            onClick={() => setMarkShipError("")}
            style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:"pointer"}}
          >Dismiss</button>
        </div>
      )}

      {/* Follow up banner — clickable shortcut into the Follow-up filter. */}
      {visibleNotifications.filter(n=>n.type==="order_started"&&!n.read).length>0&&(
        <div
          onClick={()=>setFilter("followup")}
          style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:10,padding:"12px 16px",marginBottom:16,cursor:"pointer",transition:"box-shadow 0.15s",...(filter==="followup"?{boxShadow:`0 0 0 2px ${C.amber}`}:{})}}
          onMouseEnter={e=>{ if(filter!=="followup") e.currentTarget.style.boxShadow=`0 0 0 1px ${C.amber}`; }}
          onMouseLeave={e=>{ if(filter!=="followup") e.currentTarget.style.boxShadow="none"; }}
        >
          <div style={{fontSize:13,fontWeight:600,color:C.amber,marginBottom:4}}>
            {visibleNotifications.filter(n=>n.type==="order_started").length} cart{visibleNotifications.filter(n=>n.type==="order_started").length>1?"s":""} abandoned — follow up recommended
          </div>
          <div style={{fontSize:12,color:C.amber}}>These customers started checkout but did not complete their order. A quick email or call can close the sale.</div>
        </div>
      )}

      {/* Filter tabs + search */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{display:"flex",gap:6}}>
          {[["all","All"],["followup","Follow up"],["orders","Completed orders"],["material_order","Material orders"],["invoice_created","Invoices"],["signup","Applications"]].map(([k,l])=>(
            <button key={k} onClick={()=>setFilter(k)} style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${filter===k?C.blue:C.border}`,background:filter===k?C.blueLight:C.white,color:filter===k?C.blue:C.inkMid,fontSize:12,cursor:"pointer"}}>
              {l}
            </button>
          ))}
        </div>
        <input style={{...S.input,width:200,fontSize:12,padding:"6px 12px"}} placeholder="Search notifications..." value={notifSearch} onChange={e=>setNotifSearch(e.target.value)}/>
      </div>

      {/* Notification list */}
      <div style={S.card}>
        {filtered.length===0&&<div style={{padding:"24px",textAlign:"center",color:C.inkLight,fontSize:13}}>No notifications in this category</div>}
        {filtered.map(n=>{
          // Material-order notifications get a distinct Mark-shipped flow
          // (not the generic navigate-to-Orders action). Cards where the
          // order is already shipped render greyed + a "Shipped on ..."
          // label instead of a button — admin can still Dismiss.
          const isMaterial = n.type === "material_order";
          const isShipped = isMaterial && n.orderStatus === "shipped";
          const shippedDateLabel = (n.shippedDate)
            ? new Date(n.shippedDate).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"})
            : null;
          return (
          <div key={n.id} style={{display:"flex",gap:14,padding:"14px 18px",borderBottom:`1px solid ${C.border}`,background:n.read?C.white:C.surface,alignItems:"flex-start",opacity:isShipped?0.65:1,position:"relative"}}>
            <div style={{width:32,height:32,borderRadius:"50%",background:n.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,color:n.color,flexShrink:0,marginTop:2}}>
              {n.icon}
            </div>
            <div style={{flex:1,paddingRight:52}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <div style={{fontSize:13,fontWeight:600,color:C.ink}}>{n.title}</div>
                  {isShipped && <span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:6,background:C.greenLight,color:C.green}}>Shipped</span>}
                </div>
                <span style={{fontSize:11,color:C.inkLight}}>{n.time}</span>
              </div>
              <div style={{fontSize:12,color:C.inkMid,marginBottom:isShipped?4:8}}>{n.body}</div>
              {isShipped && (
                <div style={{fontSize:11,color:C.inkLight,marginBottom:8,fontStyle:"italic"}}>
                  Shipped{shippedDateLabel?` on ${shippedDateLabel}`:""}{n.shippedNotes?` · ${n.shippedNotes}`:""}
                </div>
              )}
              <div style={{display:"flex",gap:8}}>
                {isMaterial && !isShipped && (
                  <button style={S.btnSmall} onClick={()=>openMarkShipModal(n)}>Mark shipped</button>
                )}
                {!isMaterial && (
                  <button style={S.btnSmall} onClick={()=>handleAction(n)}>{n.action}</button>
                )}
              </div>
            </div>
            {/* Prominent close (×) button — pinned to the right side of
                every notification card. Manual override for the auto-clear
                (visibleNotifications filter above) which fires when a
                notification is both read AND its underlying object is
                handled. Styled bold + always-visible so admin can spot
                it at a glance; PR #99's subtle version was too easy to
                miss. */}
            <button
              onClick={(e)=>{ e.stopPropagation(); dismiss(n.id); }}
              title="Dismiss this notification"
              aria-label="Dismiss notification"
              style={{
                position:"absolute",
                top:"50%",
                right:14,
                transform:"translateY(-50%)",
                background:C.redLight,
                border:`1px solid #FCA5A5`,
                color:"#B91C1C",
                fontSize:16,
                fontWeight:700,
                lineHeight:1,
                width:28,
                height:28,
                borderRadius:"50%",
                cursor:"pointer",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexShrink:0,
                boxShadow:"0 1px 2px rgba(185,28,28,0.15)"
              }}
              onMouseEnter={e=>{e.currentTarget.style.background="#B91C1C";e.currentTarget.style.color=C.white;e.currentTarget.style.borderColor="#B91C1C";}}
              onMouseLeave={e=>{e.currentTarget.style.background=C.redLight;e.currentTarget.style.color="#B91C1C";e.currentTarget.style.borderColor="#FCA5A5";}}
            >×</button>
          </div>
          );
        })}
      </div>

      <div style={{background:"#E0F4EE",borderRadius:10,padding:"12px 16px",marginTop:16}}>
        <div style={{fontSize:12,fontWeight:600,color:"#0D7A5F",marginBottom:4}}>Email notifications — powered by Resend</div>
        <div style={{fontSize:12,color:"#166534"}}>Resend is connected. Emails are sent automatically for: new signups, invoice creation, material orders, tool recalls, and account approvals. All notifications also send to info@mpcare.com.</div>
      </div>

      {/* Mark-shipped modal. Opens from a pending material_order
          notification card's "Mark shipped" button. Optional shipping notes
          textarea. Supabase-first: await markMaterialOrderShipped scoped
          to one row by client_id. On success the notification re-renders
          as shipped + greyed via setNotifications patch. On failure the
          modal closes and the amber banner at top of the tab surfaces the
          error; admin can re-click Mark shipped to retry (idempotent). */}
      {markShipNotif && (
        <div
          onClick={closeMarkShipModal}
          style={{position:"fixed",inset:0,background:"rgba(15,23,42,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:3000}}
        >
          <div
            onClick={e=>e.stopPropagation()}
            style={{background:C.white,borderRadius:12,padding:"22px 24px",minWidth:480,maxWidth:560,boxShadow:"0 12px 32px rgba(0,0,0,0.2)"}}
          >
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:6}}>
              Mark order {markShipNotif.materialOrderId || ""} as shipped?
            </div>
            <div style={{fontSize:12,color:C.inkMid,marginBottom:16,lineHeight:1.5}}>
              {markShipNotif.body}
            </div>
            <div style={S.fg}>
              <label style={S.label}>Shipping notes (optional)</label>
              <textarea
                style={{...S.input,height:88,resize:"vertical",fontFamily:"inherit"}}
                value={markShipNotes}
                onChange={e=>setMarkShipNotes(e.target.value)}
                placeholder="Tracking number, carrier, delivery date, anything else…"
                disabled={markShipBusy}
              />
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <button
                style={{...S.btnSecondary,opacity:markShipBusy?0.5:1,cursor:markShipBusy?"not-allowed":"pointer"}}
                onClick={closeMarkShipModal}
                disabled={markShipBusy}
              >Cancel</button>
              <button
                style={{...S.btnPrimary,opacity:markShipBusy?0.6:1,cursor:markShipBusy?"not-allowed":"pointer"}}
                onClick={confirmMarkShipped}
                disabled={markShipBusy}
              >{markShipBusy ? "Marking…" : "Mark shipped"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ADMIN COMMISSION TAB ──────────────────────────────────────────────────────
// Derives commission payments per-rep per-period directly from SHARED_INVOICES
// (the same source the Rep Commission page uses), so what admin pays matches
// exactly what the rep sees owed. Periods where admin confirms payment are
// persisted to localStorage ("mpcare_commission_paid_periods") so the "paid"
// status survives refreshes.
const COMMISSION_PAID_LS = "mpcare_commission_paid_periods";
function loadPaidPeriods() {
  try { const raw = localStorage.getItem(COMMISSION_PAID_LS); return raw ? JSON.parse(raw) : {}; } catch(e) { return {}; }
}
function savePaidPeriods(map) {
  try { localStorage.setItem(COMMISSION_PAID_LS, JSON.stringify(map)); } catch(e) {}
}

// Thin wrapper so the top-level "Commission" admin nav tab can render
// AdminCommissionTab without duplicating the rep-list merge logic that
// AdminRepsTab already does. Pulls liveReps + accounts from parent
// (AdminPanel), merges ADMIN_REP_DATA seed + liveReps (dedupe by email),
// subscribes to SHARED_REP_CUSTOMERS for route-planner customer sets, and
// reads rep rate overrides from SHARED_SETTINGS. Same identity as the
// AdminRepsTab -> AdminCommissionTab bottom section, just reachable from
// its own nav entry.
function AdminCommissionTabWrapper({ liveReps: liveRepsProp = [], inactiveReps = [], allAccounts = [], onOpenInOrders }) {
  // Deleted / paused reps stay listed here (badged) so unpaid commission never vanishes from admin view.
  const liveReps = useMemo(()=>[...(liveRepsProp||[]), ...(inactiveReps||[])],[liveRepsProp, inactiveReps]);
  const [sharedRepCusts, setSharedRepCusts] = useState(()=>SHARED_REP_CUSTOMERS.getAll());
  useEffect(()=>SHARED_REP_CUSTOMERS.subscribe(d=>setSharedRepCusts(d)),[]);

  // FIX (2026-04-20): admin commission used to look up rep rates via
  // SHARED_SETTINGS.getRepRate(demo.name) where demo.name is the SHORT form
  // "Marcus T." from ADMIN_REP_DATA. But the rate is written at the FULL
  // name "Marcus Thompson" by AdminRepsTab's edit form and by the rep
  // portal. Same localStorage, different keys → admin saw 8% (demo fallback)
  // while the rep saw 10% (actual setting).
  //
  // The fix consults three sources in order:
  //   1. Supabase rep_commission_rates — cross-device canonical, keyed by
  //      rep.id (UUID for live reps, int for demo). This is the authoritative
  //      record.
  //   2. SHARED_SETTINGS by live rep name (full name from Supabase auth).
  //      Same key the rep portal reads, matches admin's write path.
  //   3. SHARED_SETTINGS by demo short name, in case admin ever edited an
  //      older short-name entry.
  //   4. demo.rate (seed fallback).
  // Supabase rates are fetched on mount and cached into `supabaseRates` so
  // every rep-row derivation is a pure O(1) map lookup.
  const [supabaseRates, setSupabaseRates] = useState({});
  const [ratesRefreshTick, setRatesRefreshTick] = useState(0);
  useEffect(()=>{
    let cancelled = false;
    (async ()=>{
      try {
        const rows = await getRepCommissionRates();
        if (cancelled) return;
        const map = {};
        (rows || []).forEach(r => { if (r?.rep_id != null) map[String(r.rep_id)] = r.rate; });
        setSupabaseRates(map);
      } catch(e) {
        console.warn("[AdminCommission] getRepCommissionRates failed:", e?.message || e);
      }
    })();
    return () => { cancelled = true; };
  // Re-run whenever ratesRefreshTick flips — any SHARED_SETTINGS change on
  // this browser bumps the tick, which re-fetches Supabase. That way an
  // admin editing a rep's rate in the Sales reps tab has the new rate show
  // up in the Commission tab without a page reload.
  },[ratesRefreshTick]);

  // Bump the tick whenever SHARED_SETTINGS fires (admin saved a rate here or
  // in the rep detail modal, in this tab or another). Cheap and explicit.
  useEffect(()=>{
    if (!SHARED_SETTINGS.subscribe) return;
    return SHARED_SETTINGS.subscribe(() => setRatesRefreshTick(t => t + 1));
  },[]);

  const _extractRate = (stored) => {
    if (stored == null) return null;
    if (typeof stored === "object") return stored.rate ?? null;
    return stored;
  };
  const _resolveRate = (demo, live) => {
    const liveIdText = live?.id != null ? String(live.id) : "";
    const demoIdText = demo?.id != null ? String(demo.id) : "";
    const supabaseRate =
      (liveIdText && supabaseRates[liveIdText] != null ? supabaseRates[liveIdText] : null)
      ?? (demoIdText && supabaseRates[demoIdText] != null ? supabaseRates[demoIdText] : null);
    if (supabaseRate != null) return Number(supabaseRate) || 0;
    const liveName = live?.name || "";
    const liveSetting = liveName ? _extractRate(SHARED_SETTINGS.getRepRate(liveName)) : null;
    if (liveSetting != null) return Number(liveSetting) || 0;
    const demoSetting = demo?.name ? _extractRate(SHARED_SETTINGS.getRepRate(demo.name)) : null;
    if (demoSetting != null) return Number(demoSetting) || 0;
    return Number(demo?.rate) || 0;
  };

  const reps = useMemo(()=>{
    const demoByEmail = new Map();
    ADMIN_REP_DATA.forEach(r => { if(r.email) demoByEmail.set(r.email.toLowerCase(), r); });
    const merged = ADMIN_REP_DATA.map(demo => {
      const live = liveReps.find(lr => lr.email?.toLowerCase() === demo.email?.toLowerCase());
      const rate = _resolveRate(demo, live);
      return { ...demo, ...(live||{}), rate };
    });
    const extras = (liveReps||[]).filter(lr => !demoByEmail.has((lr.email||"").toLowerCase())).map(lr => ({
      ...lr,
      rate: _resolveRate(null, lr),
      customers: lr.customers || [],
    }));
    return [...merged, ...extras];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[liveReps, supabaseRates]);

  return (
    <AdminCommissionTab onOpenInOrders={onOpenInOrders} reps={reps} allAccounts={allAccounts} sharedRepCusts={sharedRepCusts}/>
  );
}

// Commission-tab Delete = void the invoice with a required reason (same semantics
// as the Orders-tab Void: Cancelled everywhere, excluded from commission, nothing
// erased). Reuses CancelOrderModal (reason list, note rules, verify-payment banner,
// refund preview) and the shared performAdminVoid. On mount (= the click) it does
// FRESH reads: pending rep adjustment / void requests (strict, fails closed),
// the invoice's paid rows and corrections. Order of writes (Rule Zero): void in
// Supabase first, and ONLY if it succeeded the correction line is recorded.
function CommissionInvoiceDelete({ target, onClose, allAccounts = [], onDone, onOpenInOrders, legacyPaidIds }) {
  const inv = target && target.inv;
  const invId = inv ? String(inv.id) : "";
  const [phase, setPhase] = useState("checking");   // checking | blocked | error | ready
  const [info, setInfo] = useState({});
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const busyRef = useRef(false);
  useEffect(() => {
    if (!invId) return undefined;
    let cancelled = false;
    setPhase("checking"); setInfo({}); setReason(""); setNote(""); setError("");
    (async () => {
      try {
        const [pend, paid, corr] = await Promise.all([
          listPendingRequestsForInvoiceStrict(invId),
          listCommissionPaymentsPaged({ invoiceId: invId }),
          listCorrections({ invoiceId: invId }),
        ]);
        if (cancelled) return;
        if (!pend.ok) { setInfo({ error: "The pending rep requests for this invoice could not be checked (" + pend.error + "). Nothing was changed." }); setPhase("error"); return; }
        if (pend.adjust.length > 0 || pend.void.length > 0) { setInfo({ pend }); setPhase("blocked"); return; }
        if (!paid.ok) { setInfo({ error: "The commission payout records could not be read (" + paid.error + "). Nothing was changed." }); setPhase("error"); return; }
        if (!corr.ok) { setInfo({ error: "The commission corrections could not be read (" + corr.error + "). Nothing was changed." }); setPhase("error"); return; }
        // Fail closed before any write: corrections table missing while commission was paid (0031), or a legacy-only paid invoice.
        const pre = preflightCorrectionState({ invoiceId: invId, paidRowsCount: (paid.rows || []).length, corr, legacyPaid: isLegacyPaid(legacyPaidIds, invId) });
        if (!pre.ok) { setInfo({ error: pre.message }); setPhase("error"); return; }
        setInfo({ paidRows: paid.rows, corrRows: corr.rows });
        setPhase("ready");
      } catch (e) {
        console.warn("[CommissionInvoiceDelete] fresh checks failed for", invId, ":", e?.message || e);
        if (!cancelled) { setInfo({ error: "The checks before deleting failed (" + (e?.message || e) + "). Nothing was changed." }); setPhase("error"); }
      }
    })();
    return () => { cancelled = true; };
  }, [invId]);
  if (!inv) return null;

  const overlay = (children) => (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2500}}>
      <div style={{background:C.white,width:480,maxWidth:"94vw",borderRadius:12,padding:"24px 28px",maxHeight:"92vh",overflowY:"auto"}}>{children}</div>
    </div>
  );
  if (phase === "checking") return overlay(<div style={{fontSize:13,color:C.inkMid}}>Checking invoice {invId} before deleting...</div>);
  if (phase === "error") return overlay(<>
    <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>Cannot delete {invId} yet</div>
    <div style={{fontSize:12,color:C.red,background:C.redLight,borderRadius:8,padding:"8px 12px",marginBottom:14}}>{info.error}</div>
    <div style={{display:"flex",justifyContent:"flex-end"}}><button style={S.btnSecondary} onClick={onClose}>Close</button></div>
  </>);
  if (phase === "blocked") {
    const nAdj = (info.pend?.adjust || []).length, nVoid = (info.pend?.void || []).length;
    return overlay(<>
      <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>A rep request is pending for {invId}</div>
      <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:14}}>
        The rep has {nAdj > 0 ? `${nAdj} adjustment request${nAdj===1?"":"s"}` : ""}{nAdj > 0 && nVoid > 0 ? " and " : ""}{nVoid > 0 ? `${nVoid} void request${nVoid===1?"":"s"}` : ""} waiting on this invoice. Decide it in Orders first, then delete from here if it is still needed. Nothing was changed.
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={S.btnSecondary} onClick={onClose}>Close</button>
        {onOpenInOrders && <button style={S.btnPrimary} onClick={()=>{ onClose(); onOpenInOrders(invId); }}>Open in Orders</button>}
      </div>
    </>);
  }

  // Commission consequence, from the FRESH reads above (same pure formula as the ledger).
  const paidRows = info.paidRows || [];
  let consequence;
  if (paidRows.length > 0) {
    const c = computeCorrection({ paidRows, corrections: info.corrRows || [], newTotal: 0, isVoid: true });
    if (c.ok && !c.none) consequence = `Already paid: a correction of ${fmtSignedMoney(c.delta)} for ${target.repName || "the rep"} will be recorded and netted against their next payout. The paid record itself is never changed.`;
    else if (c.ok) consequence = "Already paid: the paid commission already matches, so no new correction is needed.";
    else consequence = `Already paid, but the correction cannot be worked out automatically (${c.reason}). It will appear under Correction needed for a manual review.`;
  } else {
    const amt = (Number(inv.total) || 0) * (Number(target.rate) || 0) / 100;
    consequence = `Commission of $${amt.toFixed(2)} will be removed from ${target.repName || "the rep"}'s pending commission.`;
  }

  const submit = async () => {
    if (busyRef.current) return;
    busyRef.current = true; setBusy(true); setError("");
    try {
      // Re-check for a pending rep request at SUBMIT time (the modal may have been open for a while). Fails closed.
      const pendNow = await listPendingRequestsForInvoiceStrict(invId);
      if (!pendNow.ok) { setError("The pending rep requests for this invoice could not be re-checked (" + pendNow.error + "). Nothing was changed."); return; }
      if ((pendNow.adjust || []).length > 0 || (pendNow.void || []).length > 0) {
        setInfo(prev => ({ ...prev, pend: pendNow })); setPhase("blocked"); return;
      }
      // Re-run the commission preflight at SUBMIT time too (commission may have been marked Paid on another
      // tab/device, or the corrections table state may have changed, while this modal was open). Fails closed.
      const [paidNow, corrNow] = await Promise.all([
        listCommissionPaymentsPaged({ invoiceId: invId }),
        listCorrections({ invoiceId: invId }),
      ]);
      if (!paidNow.ok || !corrNow.ok) {
        setError("The commission records could not be re-checked (" + (paidNow.ok ? corrNow.error : paidNow.error) + "). Nothing was changed.");
        return;
      }
      const preNow = preflightCorrectionState({ invoiceId: invId, paidRowsCount: (paidNow.rows || []).length, corr: corrNow, legacyPaid: isLegacyPaid(legacyPaidIds, invId) });
      if (!preNow.ok) { setError(preNow.message + " Nothing was changed."); return; }
      // Freshest cache object for the F1 snapshot (performAdminVoid copies it by value before its first await).
      const live = SHARED_INVOICES.getAll().find(x => x.id === inv.id) || inv;
      // By-value copy for the rep email: the void mutates the live cache object.
      let preVoid = null;
      try { preVoid = JSON.parse(JSON.stringify(live)); } catch (e) { console.warn("[CommissionInvoiceDelete] could not copy the invoice for the rep email:", e?.message || e); }
      const acct = (allAccounts || []).find(a => a.company === live.customer);
      const res = await performAdminVoid({
        inv: live, reason, note, acct, accountName: live.customer, displayId: live.id, displayAmount: Number(live.total) || 0, adminEmail: "",
      });
      if (!adminVoidedInDb(res)) { setError(res.error || "Cancellation failed"); return; }
      // Void is in Supabase: NOW (and only now) record the correction. A void saved on this
      // device only (no database row) has no ledger entry to correct.
      let cres = { status: "none", message: "" };
      if (!voidLocalOnly(res)) {
        cres = await recordCorrectionAfterAction({ invoiceId: invId, reason: "Invoice voided by admin (Commission tab): " + reason, source: "commission_tab", expect: "void", legacyPaid: isLegacyPaid(legacyPaidIds, invId) });
      }
      // Rep email: fire-and-forget, only AFTER the void is in the database and only when THIS action
      // did it (not when someone else had already voided it, not for a device-only void).
      let emailPromise = null;
      if (preVoid && !res.alreadyVoidedElsewhere && !res.localOnly && !(res.dbRes && res.dbRes.localOnly)) {
        emailPromise = Promise.resolve(notifyRepInvoiceChanged({
          kind: "void", invoice: preVoid, reason: reason + (note && String(note).trim() ? " - " + String(note).trim() : ""),
          oldTotal: Number(preVoid.total) || 0, newTotal: 0, commissionNote: commissionSentenceForRep("void", cres, paidRows.length),
        })).catch(e => { console.warn("[CommissionInvoiceDelete] rep email promise rejected (the void is saved):", e?.message || e); return { sent: false, skipped: "threw" }; });
      }
      const parts = [];
      let level = "ok";
      if (!res.ok) { level = "bad"; parts.push(`Invoice ${invId} was voided in the database, but a later step failed: ${res.error}`); }
      if (cres.status === "failed") { level = "bad"; parts.push(`Invoice ${invId} voided but the correction was not recorded; it will appear under Correction needed.${cres.detail ? " (" + cres.detail + ")" : ""}`); }
      else if (cres.status === "recorded") parts.push(`Invoice ${invId} voided. ${cres.message}`);
      else if (res.ok) parts.push(paidRows.length === 0 ? `Invoice ${invId} voided. Its commission was removed from pending.` : `Invoice ${invId} voided.`);
      if (res.noticeText) parts.push(res.noticeText);
      // The void is saved: show the result and close NOW, then append the email outcome when it is known
      // (say "emailed" only when the send really happened; never hold the modal busy for the email).
      const bannerLevel = level === "ok" && res.noticeText ? "warn" : level;
      const baseText = parts.join(" ");
      if (onDone) onDone({ level: bannerLevel, text: baseText });
      repEmailSentence(emailPromise).then((emailSentence) => {
        if (emailSentence && onDone) onDone({ level: bannerLevel, text: baseText + " " + emailSentence });
      }).catch((e) => console.warn("[CommissionInvoiceDelete] email outcome unavailable:", e?.message || e));
      onClose();
    } catch (e) {
      console.warn("[CommissionInvoiceDelete] submit failed for", invId, ":", e?.message || e);
      setError(e?.message || "Cancellation failed");
    } finally {
      busyRef.current = false; setBusy(false);
    }
  };

  return (
    <CancelOrderModal
      order={{ id: invId, amount: Number(inv.total) || 0 }} invoice={inv}
      reason={reason} setReason={setReason} note={note} setNote={setNote}
      busy={busy} error={error} onClose={onClose} onSubmit={submit}
      commissionPaid={paidRows.length > 0} consequence={consequence}
    />
  );
}

// Invoice ids that currently have a pending rep adjustment / void request. Drives ONLY the
// disabled-button tooltip of Adjust; CommissionInvoiceAdjust re-checks with a strict fresh read.
function usePendingRequestInvoiceIds(enabled = true) {
  const [ids, setIds] = useState(() => new Set());
  const refresh = useCallback(async () => {
    try {
      const [a, v] = await Promise.all([listAdjustmentRequests({ status: "pending" }), listInvoiceVoidRequests({ status: "pending" })]);
      setIds(new Set([...(a || []), ...(v || [])].map(r => String(r.invoice_id))));
    } catch (e) { console.warn("[usePendingRequestInvoiceIds] pending rep request list failed (Adjust tooltip only):", e?.message || e); }
  }, []);
  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    let u1 = () => {}, u2 = () => {};
    try { u1 = subscribeAdjustmentRequests(() => refresh()); } catch (e) { console.warn("[usePendingRequestInvoiceIds] adjustment request subscribe failed:", e?.message || e); }
    try { u2 = subscribeInvoiceVoidRequests(() => refresh()); } catch (e) { console.warn("[usePendingRequestInvoiceIds] void request subscribe failed:", e?.message || e); }
    return () => { try { u1(); } catch (e) { console.warn("[usePendingRequestInvoiceIds] unsubscribe failed:", e?.message || e); } try { u2(); } catch (e) { console.warn("[usePendingRequestInvoiceIds] unsubscribe failed:", e?.message || e); } };
  }, [refresh, enabled]);
  return ids;
}

// Commission-tab Adjust = change the lines of an UNPAID rep-created invoice directly.
// Reuses the rep-request engine (createAdminAdjustment -> approveAdjustmentRequest,
// migration 0032) through performAdminAdjust. Editing scope: change a quantity,
// remove a line, add a catalog product at the CATALOG price. There are no free price
// overrides. On mount (= the click) it does FRESH reads (pending rep requests strict,
// the invoice's paid rows and corrections) so the commission preview is worked out
// from the ledger and the action fails closed when a check cannot be made.
function CommissionInvoiceAdjust({ target, onClose, onDone, onOpenInOrders, legacyPaidIds }) {
  const inv = target && target.inv;
  const invId = inv ? String(inv.id) : "";
  const origItems = useMemo(() => parseInvItems(inv && inv.items), [inv]);
  const extras = useMemo(() => extrasFromInvoice(inv || {}), [inv]);
  const [phase, setPhase] = useState("checking");   // checking | blocked | error | ready
  const [info, setInfo] = useState({});
  const [lines, setLines] = useState(() => origItems.map(i => ({ sku: i.sku, qty: Number(i.qty) || 1 })));
  const [addFilter, setAddFilter] = useState("");
  const [reason, setReason] = useState("");
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [orphanId, setOrphanId] = useState(null);
  const busyRef = useRef(false);
  const [catalog] = useState(() => expandCatalogForPicker(SHARED_PRODUCTS.getActive()));
  const lookup = useCallback((sku) => catalog.find(p => p.sku === sku) || null, [catalog]);
  useEffect(() => {
    if (!invId) return undefined;
    let cancelled = false;
    setPhase("checking"); setInfo({});
    (async () => {
      try {
        const [pend, paid, corr] = await Promise.all([
          listPendingRequestsForInvoiceStrict(invId),
          listCommissionPaymentsPaged({ invoiceId: invId }),
          listCorrections({ invoiceId: invId }),
        ]);
        if (cancelled) return;
        if (!pend.ok) { setInfo({ error: "The pending rep requests for this invoice could not be checked (" + pend.error + "). Nothing was changed." }); setPhase("error"); return; }
        if (pend.adjust.length > 0 || pend.void.length > 0) { setInfo({ pend }); setPhase("blocked"); return; }
        if (!paid.ok) { setInfo({ error: "The commission payout records could not be read (" + paid.error + "). Nothing was changed." }); setPhase("error"); return; }
        if (!corr.ok) { setInfo({ error: "The commission corrections could not be read (" + corr.error + "). Nothing was changed." }); setPhase("error"); return; }
        // Fail closed before any write: corrections table missing while commission was paid (0031), or a legacy-only paid invoice.
        const pre = preflightCorrectionState({ invoiceId: invId, paidRowsCount: (paid.rows || []).length, corr, legacyPaid: isLegacyPaid(legacyPaidIds, invId) });
        if (!pre.ok) { setInfo({ error: pre.message }); setPhase("error"); return; }
        setInfo({ paidRows: paid.rows, corrRows: corr.rows });
        setPhase("ready");
      } catch (e) {
        console.warn("[CommissionInvoiceAdjust] fresh checks failed for", invId, ":", e?.message || e);
        if (!cancelled) { setInfo({ error: "The checks before adjusting failed (" + (e?.message || e) + "). Nothing was changed." }); setPhase("error"); }
      }
    })();
    return () => { cancelled = true; };
  }, [invId]);
  if (!inv) return null;

  const overlay = (children) => (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2500}}>
      <div style={{background:C.white,width:600,maxWidth:"94vw",borderRadius:12,padding:"24px 28px",maxHeight:"92vh",overflowY:"auto"}}>{children}</div>
    </div>
  );
  if (phase === "checking") return overlay(<div style={{fontSize:13,color:C.inkMid}}>Checking invoice {invId} before adjusting...</div>);
  if (phase === "error") return overlay(<>
    <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>Cannot adjust {invId} yet</div>
    <div style={{fontSize:12,color:C.red,background:C.redLight,borderRadius:8,padding:"8px 12px",marginBottom:14}}>{info.error}</div>
    <div style={{display:"flex",justifyContent:"flex-end"}}><button style={S.btnSecondary} onClick={onClose}>Close</button></div>
  </>);
  if (phase === "blocked") {
    const nAdj = (info.pend?.adjust || []).length, nVoid = (info.pend?.void || []).length;
    return overlay(<>
      <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>A rep request is pending for {invId}</div>
      <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:14}}>
        The rep has {nAdj > 0 ? `${nAdj} adjustment request${nAdj===1?"":"s"}` : ""}{nAdj > 0 && nVoid > 0 ? " and " : ""}{nVoid > 0 ? `${nVoid} void request${nVoid===1?"":"s"}` : ""} waiting on this invoice. Decide it in Orders first, then adjust from here if it is still needed. Nothing was changed.
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={S.btnSecondary} onClick={onClose}>Close</button>
        {onOpenInOrders && <button style={S.btnPrimary} onClick={()=>{ onClose(); onOpenInOrders(invId); }}>Open in Orders</button>}
      </div>
    </>);
  }

  // Original lines stay selectable even if the SKU has left the catalog.
  const options = (() => {
    const have = new Set(catalog.map(p => p.sku));
    const extra = origItems.filter(i => i && i.sku && !have.has(i.sku)).map(i => ({ sku: i.sku, name: i.name || i.sku, price: Number(i.price) || 0, case: i.case }));
    return [...catalog, ...extra];
  })();
  const built = buildProposedItems(inv.items, lines, lookup);
  const oldTotal = Number(inv.total) || 0;
  const newTotal = recomputeTotal(built.items, extras);
  const diff = diffItems(inv.items, built.items).filter(r => r.kind !== "unchanged");
  const unitFor = (sku) => {
    const o = origItems.find(i => i.sku === sku);
    if (o) return Number(o.price) || 0;
    const p = lookup(sku);
    return p ? Number(p.price) || 0 : null;
  };
  const setLine = (i, k, v) => setLines(ls => ls.map((l, li) => li === i ? { ...l, [k]: v } : l));
  const changed = diff.length > 0;
  const effect = commissionEffect({ paidRows: info.paidRows, corrections: info.corrRows, oldTotal, newTotal, rate: target.rate, repName: target.repName, isVoid: false });
  const kindColor = { added: C.green, removed: C.red, changed: C.amber };
  const filterQ = addFilter.trim().toLowerCase();
  const addOptions = options.filter(o => !filterQ || `${o.sku} ${o.name}`.toLowerCase().includes(filterQ)).slice(0, 60);

  const submit = async () => {
    if (busyRef.current) return;
    setError("");
    const why = reason.trim();
    if (!why) { setError("Please enter a reason. The rep will see it."); return; }
    if (built.missing.length) { setError(`Product not found in the catalog: ${built.missing.join(", ")}`); return; }
    if (!changed) { setError("Nothing was changed. Edit a quantity, remove a line or add a product first."); return; }
    if (!ack) { setError("Tick the box confirming you checked in Square / accounting that this invoice has not been paid."); return; }
    busyRef.current = true; setBusy(true);
    try {
      // Freshest cache object; performAdminAdjust copies it by value before its first await.
      const live = SHARED_INVOICES.getAll().find(x => x.id === inv.id) || inv;
      const res = await performAdminAdjust({ invoice: live, lines, lookup, reason: why, confirmedUnpaid: true, legacyPaid: isLegacyPaid(legacyPaidIds, invId) });
      if (!res.ok) {
        console.warn("[CommissionInvoiceAdjust] adjust failed for", invId, ":", res.message);
        if (res.pendingRequestId) setOrphanId(res.pendingRequestId);
        if (!res.nothingChanged) {
          // The invoice may already carry the change: report at tab level and refresh what the tab shows.
          if (onDone) onDone({ level: "bad", text: res.message });
          onClose();
          return;
        }
        setError(res.message || "The adjustment failed. Nothing was changed.");
        return;
      }
      const c = res.correction || { status: "none" };
      const parts = [`Invoice ${invId} adjusted: $${res.oldTotal.toFixed(2)} to $${res.newTotal.toFixed(2)}.`];
      let level = "ok";
      if (c.status === "recorded") parts.push(c.message);
      else if (c.status === "failed") { level = "bad"; parts.push(`The correction was not recorded; it will appear under Correction needed.${c.detail ? " (" + c.detail + ")" : ""}`); }
      else parts.push((typeof res.paidRowsCount === "number" ? res.paidRowsCount : (info.paidRows || []).length) === 0 ? "Its pending commission was recalculated from the new total." : "The paid commission already matches, so no correction was needed.");
      parts.push("The rep sees the change on their invoice.");
      // The change is saved: show the result and close NOW, then append the email outcome when it is known
      // (say "emailed" only when the send really happened; never hold the modal busy for the email).
      const baseText = parts.join(" ");
      if (onDone) onDone({ level, text: baseText });
      repEmailSentence(res.emailPromise).then((emailSentence) => {
        if (emailSentence && onDone) onDone({ level, text: baseText + " " + emailSentence });
      }).catch((e) => console.warn("[CommissionInvoiceAdjust] email outcome unavailable:", e?.message || e));
      onClose();
    } catch (e) {
      console.warn("[CommissionInvoiceAdjust] submit threw for", invId, ":", e?.message || e);
      setError(e?.message || "The adjustment failed unexpectedly. Check Orders and the Commission tab before trying again.");
    } finally {
      busyRef.current = false; setBusy(false);
    }
  };

  return overlay(<>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:10}}>
      <div style={{fontSize:17,fontWeight:600,color:C.ink}}>Adjust invoice {invId}</div>
      <button onClick={()=>{ if(!busy) onClose(); }} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:C.inkLight,lineHeight:1}} aria-label="Close">×</button>
    </div>
    <div style={{fontSize:12,color:C.inkMid,marginBottom:10,lineHeight:1.5}}>
      Change a quantity, remove a line or add a product. Products already on the invoice keep their price; new products use the current catalog price. The change is saved first, then the rep sees it on their invoice.
    </div>
    <div style={{background:C.surface,borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:C.ink}}>
      <strong>Customer:</strong> {inv.customer} &nbsp;·&nbsp; <strong>Rep:</strong> {target.repName || displayRepStamp(inv.rep) || "—"} &nbsp;·&nbsp; <strong>Date:</strong> {inv.date}
    </div>
    {lines.map((row, i) => {
      const unit = row.sku ? unitFor(row.sku) : null;
      const isNew = !origItems.some(o => o.sku === row.sku) || !row.sku;
      const name = (options.find(o => o.sku === row.sku) || {}).name || row.sku;
      return (
        <div key={i} style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"8px 10px",marginBottom:8}}>
          <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:6}}>
            <div style={{flex:1,minWidth:0,fontSize:12,color:C.ink}}>
              {row.sku ? <><strong>{row.sku}</strong> {name}{isNew && <span style={{...S.pillAmber,marginLeft:6}}>NEW</span>}</> : (
                <div>
                  <input style={{...S.input,fontSize:12,padding:"6px 8px",marginBottom:4}} placeholder="Search catalog by SKU or name..." value={addFilter} onChange={e=>setAddFilter(e.target.value)} disabled={busy}/>
                  <select style={{...S.select,fontSize:12,padding:"6px 8px"}} value="" disabled={busy} onChange={e=>{ setLine(i,"sku",e.target.value); setAddFilter(""); }}>
                    <option value="">Choose a product...</option>
                    {addOptions.map(o => <option key={o.sku} value={o.sku}>{o.sku} — {o.name} (${(Number(o.price)||0).toFixed(2)})</option>)}
                  </select>
                </div>
              )}
            </div>
            <button disabled={busy || lines.length < 2} aria-label="Remove line" title={lines.length < 2 ? "An invoice must keep at least one line. To cancel the whole invoice use Delete." : "Remove this line"} onClick={()=>setLines(ls=>ls.filter((_,li)=>li!==i))} style={{background:"none",border:"none",color:C.inkLight,cursor:lines.length<2?"not-allowed":"pointer",fontSize:18,padding:0}}>×</button>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"80px 1fr 1fr",gap:8,alignItems:"end"}}>
            <label style={{display:"flex",flexDirection:"column",gap:2,fontSize:10,color:C.inkLight,fontWeight:600,textTransform:"uppercase"}}>Qty
              <input type="number" min="1" step="1" value={row.qty} disabled={busy} onChange={e=>setLine(i,"qty",parseInt(e.target.value)||1)} style={{...S.input,fontSize:12,padding:"6px 8px",textAlign:"center"}}/>
            </label>
            <div style={{textAlign:"right",fontSize:12,color:C.inkLight}}>Unit {unit!=null?`$${unit.toFixed(2)}`:"—"}</div>
            <div style={{textAlign:"right",fontSize:12,fontWeight:600,color:C.ink}}>Line {unit!=null?`$${(unit*(Number(row.qty)||0)).toFixed(2)}`:"—"}</div>
          </div>
        </div>
      );
    })}
    <button style={S.btnGhost} disabled={busy || lines.some(l => !l.sku)} onClick={()=>setLines(ls=>[...ls,{sku:"",qty:1}])}>+ Add product</button>
    <div style={{height:1,background:C.border,margin:"12px 0"}}/>
    <div style={{background:changed?C.amberLight:C.surface,borderRadius:8,padding:"8px 12px",fontSize:12,color:C.ink,marginBottom:10}}>
      <div style={{display:"flex",justifyContent:"space-between"}}><span>Current total</span><span>${oldTotal.toFixed(2)}</span></div>
      <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:14}}><span>New total</span><span>${newTotal.toFixed(2)}</span></div>
      <div style={{display:"flex",justifyContent:"space-between",color:C.inkLight}}><span>Difference</span><span>{newTotal-oldTotal>=0?"+":"-"}${Math.abs(newTotal-oldTotal).toFixed(2)}</span></div>
      {extras.discountPct>0&&<div data-testid="adjust-discount-note" style={{color:C.inkLight,marginTop:4}}>Includes the customer's {formatPct(extras.discountPct)}% discount, applied to the new subtotal.</div>}
    </div>
    {diff.length > 0 && (
      <div style={{margin:"0 0 10px",fontSize:12,color:C.inkMid}}>
        {diff.map(r => (
          <div key={r.sku} style={{display:"flex",justifyContent:"space-between",padding:"2px 0"}}>
            <span><span style={{color:kindColor[r.kind],fontWeight:600,textTransform:"capitalize"}}>{r.kind}</span> · {r.sku} {r.name}</span>
            <span>{r.oldQty} → {r.newQty}</span>
          </div>
        ))}
      </div>
    )}
    <div style={{fontSize:12,color:effect.kind==="paid_manual"?C.red:"#075985",background:effect.kind==="paid_manual"?C.redLight:"#E0F2FE",borderRadius:8,padding:"8px 12px",marginBottom:12,lineHeight:1.5}}>
      <strong>Commission:</strong> {changed ? effect.text : "Change a line to see the commission effect."}
    </div>
    <div style={S.fg}>
      <label style={S.label}>Reason (visible to the rep) *</label>
      <textarea style={{...S.input,minHeight:60,resize:"vertical"}} value={reason} disabled={busy} onChange={e=>setReason(e.target.value)} placeholder="e.g. Customer reduced the order from 5 to 3 cases"/>
    </div>
    <label style={{display:"flex",gap:8,alignItems:"flex-start",fontSize:12,color:C.inkMid,marginBottom:12,lineHeight:1.5}}>
      <input type="checkbox" checked={ack} disabled={busy} onChange={e=>setAck(e.target.checked)} style={{marginTop:2}}/>
      <span>I checked in Square / accounting that this invoice has NOT been paid (payment status is tracked per device).</span>
    </label>
    <div style={{fontSize:11,color:C.inkLight,marginBottom:12,lineHeight:1.5}}>
      Warning: a paid mark the rep made on their own device cannot be seen from this device, so this tick is the only guard. If the rep already marked it paid, the rep's copy still receives the new total, and the rep is told to contact you.
    </div>
    {error && (
      <div style={{padding:"8px 12px",background:C.amberLight,color:"#92400E",fontSize:12,borderRadius:6,marginBottom:10,border:"1px solid #FCD34D"}}>
        {error}
        {orphanId && onOpenInOrders && <div style={{marginTop:6}}><button style={S.btnGhost} onClick={()=>{ onClose(); onOpenInOrders(invId); }}>Open in Orders</button></div>}
      </div>
    )}
    <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
      <button style={S.btnSecondary} onClick={onClose} disabled={busy}>Cancel</button>
      <button style={{...S.btnPrimary,opacity:busy?0.6:1}} onClick={submit} disabled={busy}>{busy?"Adjusting…":"Adjust invoice"}</button>
    </div>
  </>);
}

function AdminCommissionTab({ onOpenInOrders, reps = [], allAccounts = [], sharedRepCusts = {} }) {
  const [sharedInvs, setSharedInvs] = useState(()=>SHARED_INVOICES.getAll());
  useEffect(()=>SHARED_INVOICES.subscribe(setSharedInvs),[]);
  // Legacy per-period paidMap (mpcare_commission_paid_periods). Kept as a
  // fallback — the NEW source of truth is the rep_commission_payments
  // Supabase table (one row per invoice per payout). See 0012 migration.
  // We still read the legacy map so periods marked paid before this deploy
  // (e.g. Marcus's April 2026 payout) don't silently flip back to pending.
  const [paidMap, setPaidMap] = useState(loadPaidPeriods);
  // Per-invoice commission payments from Supabase. paidInvoiceIds is the
  // hot path — a Set used by every partition call for O(1) lookup.
  const [paidRows, setPaidRows] = useState([]);
  const paidInvoiceIds = useMemo(() => {
    const s = new Set();
    paidRows.forEach(r => { if (r?.invoice_id) s.add(r.invoice_id); });
    return s;
  },[paidRows]);
  // invoice_id → the latest row (for showing paid date / method / batch in
  // the expand-row view and for "undo this invoice" wiring).
  const paidRowByInvoiceId = useMemo(() => {
    const m = {};
    paidRows.forEach(r => {
      if (!r?.invoice_id) return;
      const prev = m[r.invoice_id];
      if (!prev || new Date(r.paid_at||0) > new Date(prev.paid_at||0)) m[r.invoice_id] = r;
    });
    return m;
  },[paidRows]);

  // Initial fetch + realtime subscription so the table stays in sync across
  // admin sessions and reflects rep-side reads immediately.
  useEffect(()=>{
    let cancelled = false;
    (async () => {
      const rows = await listRepCommissionPayments();
      if (!cancelled) setPaidRows(rows);
    })();
    const unsub = subscribeRepCommissionPayments(async () => {
      // Full refetch on any event — simpler than patch logic and the table
      // is tiny (one row per paid invoice). Errors are already logged inside
      // the helper.
      const rows = await listRepCommissionPayments();
      if (!cancelled) setPaidRows(rows);
    });
    return () => { cancelled = true; unsub && unsub(); };
  },[]);

  // Commission corrections ledger (migration 0031): fetched on mount + realtime
  // through the PAGED payments reader. paidRows above (the existing reader)
  // keeps driving the existing behaviour; the ledger's own complete paged rows
  // drive only the correction logic (anchoring, the reconcile scan, netting).
  const ledger = useCommissionLedger();
  // Rep remittances (0033): badges per invoice + the warn-only Mark Paid gate. Fetched once per mount, kept fresh by realtime.
  const remit = useRemittanceList();
  // The tick is stored as the KEY of the warning it acknowledges (warned invoice ids + pay-through date),
  // so it invalidates itself whenever either changes; it is also cleared whenever the modal opens.
  const [remitAckKey, setRemitAckKey] = useState("");
  const [corrOnlyRep, setCorrOnlyRep] = useState(null);
  const [payNotice, setPayNotice] = useState("");
  const [corrSel, setCorrSel] = useState(null);   // ticked correction ids; null = not initialised yet

  // ── Legacy backfill ──────────────────────────────────────────────────────
  // Existing production paid-periods (Marcus's April 2026 etc.) live only in
  // mpcare_commission_paid_periods on admin's browser. To move them into the
  // per-invoice model we snapshot the invoices dated ≤ paidAt and INSERT one
  // row per invoice. Guards:
  //   • Runs once per (rep, period) — tracked in mpcare_commission_backfilled
  //     to avoid re-running on every mount.
  //   • Skips periods where ANY invoice already has a Supabase row (i.e.
  //     backfill was already done or admin has since migrated manually).
  //   • Only runs after paidRows has loaded (so the "already done?" check
  //     can see existing rows).
  //   • Never deletes from the legacy localStorage map — that stays as a
  //     double-confirm fallback via classifyInvoicePayoutStatus.
  const [backfillChecked, setBackfillChecked] = useState(false);
  const [backfillIncomplete, setBackfillIncomplete] = useState(false);
  // One backfill at a time (in-flight ref) and NO automatic retry after a failure:
  // a failed run sets backfillFailedRef and only a remount or the explicit,
  // bounded "Retry legacy migration" button (backfillRetryTick, max 5) runs it
  // again, never every dependency change. Two overlapping runs could otherwise
  // both insert the same legacy rows.
  const backfillInFlightRef = useRef(false);
  const backfillFailedRef = useRef(false);
  const [backfillRetryTick, setBackfillRetryTick] = useState(0);
  const retryLegacyBackfill = () => {
    if (backfillInFlightRef.current || backfillRetryTick >= 5) return;
    backfillFailedRef.current = false;
    setBackfillRetryTick(t => t + 1);
  };
  useEffect(()=>{
    if (backfillChecked) return;
    if (backfillInFlightRef.current) return;
    if (backfillFailedRef.current) return;
    if (!reps || reps.length === 0) return;
    if (!sharedInvs || sharedInvs.length === 0) return;
    backfillInFlightRef.current = true;
    // Wait one tick after paidRows has been fetched so the "already done"
    // check is accurate. Tracks via a localStorage flag because paidRows
    // starts as [] on mount and we want to wait for the first fetch.
    (async () => {
      // The reconcile scan is only released when EVERY legacy write succeeded
      // (see finally): a failed or partial backfill keeps it gated.
      let backfillComplete = true;
      try {
        // Always run the "already done?" check against a fresh fetch — not
        // against stale state — to be safe under rapid remounts.
        const currentRows = await listRepCommissionPayments();
        const existingIds = new Set((currentRows||[]).map(r=>r.invoice_id).filter(Boolean));
        let done = {};
        try { const s = localStorage.getItem("mpcare_commission_backfilled"); if (s) done = JSON.parse(s) || {}; } catch(e) {}
        // IMPORTANT: ignore `done[key]` whenever the legacy localStorage entry
        // for that key STILL EXISTS in paidMap. The previous version of this
        // code (pre-PR#60) set done[key]=true BEFORE awaiting the Supabase
        // write and persisted `done` at the end regardless of write success.
        // So browsers that hit a transient failure ended up with done[key]=true
        // AND the legacy entry still sitting in mpcare_commission_paid_periods,
        // which meant PR#60 skipped the period forever (thinking it was
        // migrated) even though the real rep_commission_payments rows were
        // never written. Symptom: admin's Commission tab kept showing a
        // "Legacy" batch that absorbed new same-day orders. The presence of
        // a legacy entry is the ground-truth signal that migration didn't
        // complete — always retry those keys, duplicate-guarded by existingIds.
        const pendingByKey = {};   // key → Array<row>
        const keyLegacyEntry = {}; // key → legacy map entry (for recording paidAt display later)
        for (const rep of reps) {
          const customerNames = collectRepCustomerNames({
            repName: rep.name,
            assignedAccounts: allAccounts,
            sharedRepCustomers: sharedRepCusts[rep.name],
            staticCustomers: rep.customers || [],
          });
          const m = computeRepMetrics({ repName: rep.name, customerNames, allInvoices: sharedInvs, rate: rep.rate || 0 });
          const periods = groupInvoicesByMonth(m.invoices, rep.rate || 0);
          periods.forEach(p => {
            const key = `${rep.name}__${p.period}`;
            const legacy = paidMap[key];
            // Only skip if done[key] is true AND the legacy entry has already
            // been cleaned out — that combination proves an actual successful
            // migration. Stale done flags from the pre-PR#60 bug are ignored.
            if (done[key] && !legacy) return;
            if (!legacy || !legacy.paidAt) return;
            const paidAt = new Date(legacy.paidAt);
            if (isNaN(paidAt.getTime())) return;
            // Backfill every invoice in this rep's period that doesn't already
            // have a Supabase row. User confirmed ("those keep it paid") they
            // want the displayed paid set preserved verbatim on migration, so
            // we snapshot the whole period rather than filtering by paidAt
            // cutoff. From then on Mark Paid writes real per-invoice rows and
            // there is no legacy fallback left to absorb future orders.
            const invsToBackfill = (p.invoices||[]).filter(inv => {
              if (!inv?.id) return false;
              if (existingIds.has(inv.id)) return false;
              return true;
            });
            if (invsToBackfill.length === 0) {
              // Nothing to write, but the legacy map is superseded by Supabase
              // so we still need to retire the key. Queue it for cleanup
              // without a write.
              pendingByKey[key] = pendingByKey[key] || [];
              keyLegacyEntry[key] = legacy;
              return;
            }
            const batchId = `legacy-${key}-${paidAt.getTime()}`;
            const repIdText = rep.id != null ? String(rep.id) : "";
            pendingByKey[key] = pendingByKey[key] || [];
            invsToBackfill.forEach(inv => {
              pendingByKey[key].push({
                invoice_id: String(inv.id),
                rep_id: repIdText,
                rep_name: rep.name,
                paid_at: paidAt.toISOString(),
                paid_date: paidAt.toISOString().slice(0, 10),
                method: legacy.method || "",
                notes: legacy.notes ? `${legacy.notes} (legacy backfill)` : "Legacy backfill from mpcare_commission_paid_periods",
                batch_id: batchId,
                period: p.period,
                amount: (Number(inv.total)||0) * (rep.rate||0) / 100,
                commission_amount: (Number(inv.total)||0) * (rep.rate||0) / 100,
                commission_rate: rep.rate || 0,
                invoice_amount: Number(inv.total) || 0,
              });
            });
            keyLegacyEntry[key] = legacy;
          });
        }

        // Write each (rep, period) group independently. If one group fails we
        // do NOT mark it done — next mount retries. Successful groups get:
        //   1. done[key] = true (skip on future mounts)
        //   2. their entry removed from the legacy localStorage map so the
        //      legacy fallback inside classifyInvoicePayoutStatus can't absorb
        //      future same-day invoices into the now-migrated period.
        let anySucceeded = false;
        let totalMigrated = 0;
        const legacyMapNext = { ...paidMap };
        let legacyMapChanged = false;
        for (const key of Object.keys(pendingByKey)) {
          const rows = pendingByKey[key];
          let writeOk = true;
          if (rows.length > 0) {
            const res = await markInvoicesCommissionPaid(rows);
            if (res.ok) {
              totalMigrated += res.count || rows.length;
              anySucceeded = true;
            } else {
              console.warn(`[commission backfill] insert failed for ${key}, will retry next mount:`, res.error);
              writeOk = false;
              backfillComplete = false;
            }
          }
          if (writeOk) {
            done[key] = true;
            if (key in legacyMapNext) {
              delete legacyMapNext[key];
              legacyMapChanged = true;
            }
          }
        }
        if (anySucceeded) {
          console.info(`[commission backfill] migrated ${totalMigrated} invoice(s) from legacy localStorage to Supabase.`);
          const fresh = await listRepCommissionPayments();
          setPaidRows(fresh);
        }
        if (legacyMapChanged) {
          try {
            localStorage.setItem(COMMISSION_PAID_LS, JSON.stringify(legacyMapNext));
            setPaidMap(legacyMapNext);
          } catch(e) { console.warn("[commission backfill] legacy localStorage cleanup failed:", e?.message||e); }
        }
        try { localStorage.setItem("mpcare_commission_backfilled", JSON.stringify(done)); } catch(e) {}
      } catch (e) {
        console.warn("[commission backfill] threw:", e?.message || e);
        backfillComplete = false;
      } finally {
        backfillInFlightRef.current = false;
        if (backfillComplete) { setBackfillIncomplete(false); setBackfillChecked(true); }
        else { backfillFailedRef.current = true; setBackfillIncomplete(true); }
      }
    })();
  },[reps, sharedInvs, paidMap, allAccounts, sharedRepCusts, backfillChecked, backfillRetryTick]);

  // ── Batch-based commission rollup ────────────────────────────────────────
  // Admins asked for "pay-this-batch-now / next batch opens fresh" semantics
  // (requested 2026-04-20). Each click of Mark Paid is a frozen historical
  // row; new invoices arriving after appear in a separate Pending bucket.
  // The old per-period partial view lumped new + old together in one row.
  // New data shape:
  //   pendingRows: one per (rep × period) that still has uncovered commission
  //   paidBatches: one per batch_id across all reps (frozen history)
  const { pendingRows, paidBatches, totalPaid, totalPending, legacyPaidIds, repCorrRows, corrRepIds } = (() => {
    const pending = [];
    const paid = [];
    const legacyIds = new Set();   // invoices only covered by a per-device legacy payout
    const corrRows = [];           // per-rep corrections summaries (Corrections cards)
    const corrRepIds = [];
    (reps || []).forEach(rep => {
      const customerNames = collectRepCustomerNames({
        repName: rep.name,
        assignedAccounts: allAccounts,
        sharedRepCustomers: sharedRepCusts[rep.name],
        staticCustomers: rep.customers || [],
      });
      const m = computeRepMetrics({
        repName: rep.name,
        customerNames,
        allInvoices: sharedInvs,
        rate: rep.rate || 0,
      });
      // Narrow legacy paidMap to this rep so the batchize helper can honour
      // pre-deploy per-period flags via date cutoff.
      const legacyForRep = {};
      Object.entries(paidMap || {}).forEach(([k,v]) => {
        const sep = k.indexOf("__");
        if (sep < 0) return;
        if (k.slice(0, sep) === rep.name) legacyForRep[k.slice(sep + 2)] = v;
      });
      // Only this rep's Supabase rows — filter here instead of passing the
      // global set so legacy-only reps don't accidentally see another rep's
      // batches.
      const repIdText = rep.id != null ? String(rep.id) : "";
      const myPaidRows = paidRows.filter(r => {
        if (!r) return false;
        if (repIdText && String(r.rep_id||"") === repIdText) return true;
        if (r.rep_name && r.rep_name === rep.name) return true;
        return false;
      });
      const { batches, pendingPeriods } = batchizeRepInvoices(m.invoices, rep.rate || 0, myPaidRows, legacyForRep);
      batches.forEach(b => { if (b.legacy) (b.invoices||[]).forEach(i => { if (i?.id != null) legacyIds.add(String(i.id)); }); });
      if (repIdText) {
        corrRepIds.push(repIdText);
        const summary = repCorrectionSummary({ corrections: ledger.corrections, repId: repIdText, paidRows: ledger.paidRows, detectOrphans: true });
        if (summary.all.length > 0 || summary.inert.length > 0) {
          corrRows.push({ rep: rep.name, repId: repIdText, inactiveStatus: rep.inactiveStatus || null, summary, pendingRows: pendingPeriods.length });
        }
      }
      // Append each batch with rep metadata for the admin view.
      batches.forEach(b => {
        paid.push({
          id: `${rep.name}__batch__${b.batchId}`,
          rep: rep.name,
          repId: repIdText,
          inactiveStatus: rep.inactiveStatus || null,
          rate: rep.rate || 0,
          batchId: b.batchId,
          paidAt: b.paidAt,
          paidDateDisplay: b.paidAt ? new Date(b.paidAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
          method: b.method,
          notes: b.notes,
          invoices: b.invoices,
          invoiceCount: b.invoiceCount,
          commission: b.commission,
          legacy: !!b.legacy,
          periodLabel: b.periodLabel || "",
        });
      });
      // Pending periods: one row per month that has uncovered invoices.
      pendingPeriods.forEach(p => {
        pending.push({
          id: `${rep.name}__pending__${p.periodLabel}`,
          rep: rep.name,
          repId: repIdText,
          inactiveStatus: rep.inactiveStatus || null,
          rate: rep.rate || 0,
          period: p.periodLabel,
          year: p.year,
          month: p.month,
          invoices: p.invoices,
          invoiceCount: p.invoices.length,
          sales: p.sales,
          commission: p.commission,
        });
      });
    });
    pending.sort((a,b) => (b.year - a.year) || (b.month - a.month) || a.rep.localeCompare(b.rep));
    paid.sort((a,b) => {
      const ta = a.paidAt ? new Date(a.paidAt).getTime() : 0;
      const tb = b.paidAt ? new Date(b.paidAt).getTime() : 0;
      return tb - ta;
    });
    return {
      pendingRows: pending,
      paidBatches: paid,
      totalPending: pending.reduce((s,p)=>s+p.commission, 0),
      totalPaid:    paid.reduce((s,p)=>s+p.commission, 0),
      legacyPaidIds: legacyIds,
      repCorrRows: corrRows,
      corrRepIds,
    };
  })();
  // Correction totals (kept separate from the invoice totals above and never
  // mixed into computeRepMetrics): open corrections are added to pending as
  // their own labelled line, settled corrections to the paid total.
  const corrTotals = adminCorrectionTotals({ corrections: ledger.corrections, repIds: corrRepIds, paidRows: ledger.paidRows });
  const pendingWithCorr = totalPending + corrTotals.openTotal;
  const paidWithCorr = totalPaid + corrTotals.settledTotal;
  // Correction-only settlements ('corr-...' batches) shown in Payment history.
  const corrOnlyHistory = correctionOnlySettlements((ledger.corrections||[]).filter(c => corrRepIds.includes(String(c.rep_id))));
  const settleMap = settlementBatches(ledger.corrections);
  const frozenPaidRows = Array.isArray(ledger.paidRows) ? ledger.paidRows : paidRows;
  // Reconcile scan: only on a complete picture (both ledger reads ok AND the
  // legacy backfill has completed). It PROPOSES; nothing is written until the
  // admin confirms a line.
  const scanInvoices = (sharedInvs||[]).filter(i => i && i.id != null).map(i => ({ id: i.id, total: i.total, status: i.status, rep: i.rep, repId: i.repId }));
  const scan = (ledger.ready && !ledger.missingTable && backfillChecked)
    ? findNeededCorrections({ paidRows: ledger.paidRows, invoices: scanInvoices, corrections: ledger.corrections, legacyPaidIds })
    : null;

  // Mark-paid modal state — now also carries a "pay through date" picker
  // (defaults to today) so admin can limit the batch to invoices dated on
  // or before a cutoff. Prevents same-day new invoices from being sucked
  // into the current payout by accident.
  const _todayYmd = () => {
    const t = new Date();
    const pad = (n) => String(n).padStart(2,"0");
    return `${t.getFullYear()}-${pad(t.getMonth()+1)}-${pad(t.getDate())}`;
  };
  const [markingId, setMarkingId] = useState(null);
  const [markBusy, setMarkBusy] = useState(false);
  const [payForm, setPayForm] = useState({date:"", method:"ACH", notes:"", payThrough: _todayYmd()});
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [viewingInvoice, setViewingInvoice] = useState(null);
  // Commission-tab Delete (= void with a required reason): see CommissionInvoiceDelete.
  const [deleteFor, setDeleteFor] = useState(null);
  const [deleteNotice, setDeleteNotice] = useState(null);   // { level: "ok" | "warn" | "bad", text }
  // Commission-tab Adjust: see CommissionInvoiceAdjust. pendingReqIds only drives the
  // disabled-button tooltip; the modal itself re-checks pending requests with a strict fresh read.
  const [adjustFor, setAdjustFor] = useState(null);
  const pendingReqIds = usePendingRequestInvoiceIds();
  const adjBlock = (inv) => adminAdjustBlockReason(inv, { pendingIds: pendingReqIds });
  const afterDelete = async (n) => {
    setDeleteNotice(n);
    // Refresh what this tab shows: payout rows (the void changed which rows resolve) and the ledger.
    try { setPaidRows(await listRepCommissionPayments()); }
    catch (e) { console.warn("[AdminCommissionTab] refresh of payout rows after delete failed:", e?.message || e); }
    ledger.reload();
  };

  // Parse a YYYY-MM-DD date string as END of that local day (23:59:59.999)
  // so "pay through Apr 20" includes everything created on Apr 20.
  const _endOfDay = (ymd) => {
    if (!ymd) return null;
    const [y,m,d] = ymd.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m-1, d, 23, 59, 59, 999);
  };

  // Open corrections offered in Mark Paid: only on a COMPLETE picture. While the
  // paged payments are not loaded (ledger.paidRows null) the anchor filter cannot
  // run, so an inert correction would look open: nothing is listed then.
  const openCorrectionsFor = (repIdText) => {
    if (!Array.isArray(ledger.paidRows)) return [];
    const r = repCorrRows.find(x => x.repId === String(repIdText||""));
    return r ? r.summary.open : [];
  };
  const openMarkPaid = (id) => {
    setMarkingId(id);
    setRemitAckKey("");
    setPayForm({date:"", method:"ACH", notes:"", payThrough: _todayYmd()});
    // null = "not initialised": CorrectionsPayoutSection ticks the open
    // corrections by default when they FIRST render on a ready ledger (not
    // captured here, when the ledger may still be loading).
    setCorrSel(null);
  };

  /**
   * Mark the selected pending row's invoices as paid, respecting the
   * pay-through cutoff in payForm.payThrough. Only invoices dated on or
   * before that cutoff are included in the new batch. Invoices after
   * stay pending and appear in the next pending row.
   */
  const markPaid = async (id) => {
    if (markBusy) return;
    const row = pendingRows.find(p => p.id === id);
    if (!row) { setMarkingId(null); return; }
    const cutoff = _endOfDay(payForm.payThrough || _todayYmd());
    const candidates = (row.invoices || []).filter(inv => {
      if (!inv?.id) return false;
      if (!cutoff) return true;
      const d = inv.sharedAt ? new Date(inv.sharedAt) : (inv.date ? new Date(inv.date) : null);
      if (!d || isNaN(d.getTime())) return true;  // date-unknown invoices still pay
      return d.getTime() <= cutoff.getTime();
    });
    if (candidates.length === 0) {
      alert("No invoices match the pay-through date. Nothing to pay.");
      setMarkingId(null);
      return;
    }
    // WARN ONLY (never a block): rep invoices with no payment received from the rep need the tick.
    const remitGateNow = payoutRemitGate(candidates, remit);
    const remitGateKeyNow = gateAckKey(remitGateNow, payForm.payThrough);
    const remitAckedNow = remitGateKeyNow !== "" && remitAckKey === remitGateKeyNow;
    if (remitGateNow.loading || (remitGateNow.needsAck && !remitAckedNow)) {
      alert(remitGateNow.loading ? "Still checking which invoices the sales rep has paid in. Try again in a moment." : "Tick the box to confirm you understand some invoices have no payment received from the rep.");
      return;
    }
    setMarkBusy(true);
    try {
      const paidAt = new Date().toISOString();
      const batchId = `${row.repId||row.rep}-${row.period}-${Date.now()}`;
      const rows = candidates.map(inv => ({
        invoice_id: String(inv.id),
        rep_id: row.repId || "",
        rep_name: row.rep,
        paid_at: paidAt,
        paid_date: paidAt.slice(0, 10),
        method: payForm.method || "",
        notes: payForm.notes || "",
        batch_id: batchId,
        period: row.period,
        amount: (Number(inv.total)||0) * (row.rate||0) / 100,
        commission_amount: (Number(inv.total)||0) * (row.rate||0) / 100,
        commission_rate: row.rate || 0,
        invoice_amount: Number(inv.total) || 0,
      }));
      // ONE shared helper (also used by the rep-detail Mark Paid): without
      // ticked corrections it is exactly markInvoicesCommissionPaid(rows).
      // A failed ledger read leaves corrSel null (nothing ticked): invoices only.
      const corrIds = (ledger.ready && Array.isArray(corrSel)) ? corrSel : [];
      const admin = corrIds.length > 0 ? await currentAdminIdentity() : null;
      const res = await runCommissionPayout({ repId: row.repId, rows, batchId, method: payForm.method, notes: payForm.notes, admin, selectedCorrectionIds: corrIds });
      if (!res.ok && !res.fallbackAllowed) {
        // Corrections were included: never the per-browser localStorage fallback.
        console.warn("[markPaid] payout with corrections failed:", res.stage, res.error);
        alert(describePayoutResult(res));
        ledger.reload();
        return;
      }
      if (!res.ok) {
        console.warn("[markPaid] Supabase write failed, falling back to legacy localStorage:", res.error);
        const date = payForm.date || new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
        const legacyKey = `${row.rep}__${row.period}`;
        const next = { ...paidMap, [legacyKey]: { date, method: payForm.method, notes: payForm.notes, paidAt: (cutoff||new Date()).toISOString() } };
        setPaidMap(next);
        savePaidPeriods(next);
      } else {
        const fresh = await listRepCommissionPayments();
        setPaidRows(fresh);
        const msg = describePayoutResult(res);
        if (msg) setPayNotice(msg);
      }
      ledger.reload();
      setMarkingId(null);
      setPayForm({date:"", method:"ACH", notes:"", payThrough: _todayYmd()});
    } finally {
      setMarkBusy(false);
    }
  };

  /**
   * Undo a single invoice's payout — deletes its Supabase row. The invoice
   * flips back to the Pending section for its period. Batch metadata
   * stays intact for the remaining invoices.
   */
  const undoInvoicePayout = async (inv, batchIdForUndo) => {
    if (!inv?.id) return;
    if (!window.confirm(`Undo commission payout for ${inv.id}? It will return to Pending.`)) return;
    // Refused while a correction is settled against this payout, was settled IN
    // its batch, or is still open and anchored to it (fresh corrections read by
    // invoice id and batch id, never by rep id; fails closed only when that read
    // fails). The batch ids come from the paid rows this tab already holds.
    const guard = await checkUndoAllowed(undoScopeFromRows(paidRows, [String(inv.id)], [batchIdForUndo]));
    if (!guard.ok) { alert(guard.message); return; }
    const res = await unmarkInvoiceCommissionPaid(String(inv.id));
    if (res.ok) {
      const fresh = await listRepCommissionPayments();
      setPaidRows(fresh);
    } else {
      alert(`Could not undo: ${res.error||"unknown error"}`);
    }
  };

  return (
    <div>
      {markingId&&(()=>{
        const row = pendingRows.find(p=>p.id===markingId);
        if (!row) return null;
        const cutoff = _endOfDay(payForm.payThrough || _todayYmd());
        const eligible = (row.invoices||[]).filter(inv => {
          if (!cutoff) return true;
          const d = inv.sharedAt ? new Date(inv.sharedAt) : (inv.date ? new Date(inv.date) : null);
          if (!d || isNaN(d.getTime())) return true;
          return d.getTime() <= cutoff.getTime();
        });
        const skipped = (row.invoices||[]).length - eligible.length;
        const eligibleTotal = eligible.reduce((s,inv)=>s+(Number(inv.total)||0)*(row.rate||0)/100, 0);
        return (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:"min(480px,94vw)",boxSizing:"border-box",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Mark commission as paid</div>
            <div style={{fontSize:13,color:C.inkLight,marginBottom:6}}>
              {row.rep} — {row.period} — <strong style={{color:C.ink}}>${eligibleTotal.toFixed(2)}</strong>
            </div>
            <div style={{fontSize:12,color:C.inkMid,marginBottom:18}}>
              Paying {eligible.length} invoice{eligible.length===1?"":"s"} on or before the cutoff below.
              {skipped > 0 && <span style={{color:"#B45309",fontWeight:500}}> {skipped} newer invoice{skipped===1?"":"s"} will stay pending for the next batch.</span>}
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}>
                <label style={S.label}>Payment date *</label>
                <input style={S.input} type="date" value={payForm.date} onChange={e=>setPayForm(f=>({...f,date:e.target.value}))}/>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Pay through *</label>
                <input style={S.input} type="date" value={payForm.payThrough} onChange={e=>setPayForm(f=>({...f,payThrough:e.target.value}))}/>
              </div>
            </div>
            <div style={S.fg}>
              <label style={S.label}>Payment method *</label>
              <select style={S.select} value={payForm.method} onChange={e=>setPayForm(f=>({...f,method:e.target.value}))}>
                <option value="ACH">ACH / Bank transfer</option>
                <option value="Check">Check</option>
                <option value="Wire">Wire transfer</option>
                <option value="Zelle">Zelle</option>
                <option value="Cash">Cash</option>
                <option value="PayPal">PayPal</option>
              </select>
            </div>
            <div style={S.fg}>
              <label style={S.label}>Notes (optional)</label>
              <input style={S.input} value={payForm.notes} onChange={e=>setPayForm(f=>({...f,notes:e.target.value}))} placeholder="Reference number, memo, etc."/>
            </div>
            <CorrectionsPayoutSection open={openCorrectionsFor(row.repId)} selected={corrSel} onChange={setCorrSel} invoiceCommission={eligibleTotal} ready={ledger.ready} error={ledger.error} onRetry={ledger.reload}/>
            {(()=>{
              // Confirm waits for the ledger (paged payments + corrections) so the
              // default ticks are never captured from a partial picture. When the
              // read FAILED the corrections part is disabled with a Retry and the
              // button is explicitly invoices-only (a plain payout is never blocked
              // by a corrections outage, and never silently skips corrections).
              const ledgerLoading = !ledger.ready && !ledger.error;
              const ticksPending = ledger.ready && corrSel===null && openCorrectionsFor(row.repId).length>0;
              const rg = payoutRemitGate(eligible, remit);
              const rgKey = gateAckKey(rg, payForm.payThrough);
              const remitAck = rgKey !== "" && remitAckKey === rgKey;
              const remitBlocked = rg.loading || (rg.needsAck && !remitAck);
              return (<>
            <PayoutRemitGate gate={rg} ack={remitAck} setAck={(v)=>setRemitAckKey(v?rgKey:"")}/>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setMarkingId(null)} disabled={markBusy}>Cancel</button>
              <button style={{...S.btnPrimary,opacity:(markBusy||ledgerLoading||ticksPending||remitBlocked)?0.6:1}} onClick={()=>markPaid(markingId)} disabled={markBusy || eligible.length===0 || ledgerLoading || ticksPending || remitBlocked}>{markBusy?"Saving...":(ledger.error?"Confirm payment (invoices only)":"Confirm payment")}</button>
            </div>
              </>);
            })()}
          </div>
        </div>
        );
      })()}

      {/* Top summary cards: $pending (red when > 0), $paid YTD, rep count. */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:16}}>
        <div style={{...S.metric, borderTop: `3px solid ${pendingWithCorr>0?"#B91C1C":C.inkLight}`}}>
          <div style={S.mLabel}>Pending payout (total)</div>
          <div style={{...S.mValue,color:pendingWithCorr>0?"#B91C1C":C.inkLight}}>${pendingWithCorr.toFixed(2)}</div>
          <div style={S.mSub}>{pendingRows.length} open period{pendingRows.length===1?"":"s"} across {new Set(pendingRows.map(p=>p.rep)).size} rep{new Set(pendingRows.map(p=>p.rep)).size===1?"":"s"}</div>
          {corrTotals.openCount>0 && <div style={{...S.mSub,color:corrTotals.openTotal<0?C.red:C.green}}>Invoices ${totalPending.toFixed(2)} + open corrections {fmtSignedMoney(corrTotals.openTotal)} ({corrTotals.openCount})</div>}
        </div>
        <div style={{...S.metric, borderTop: `3px solid ${C.green}`}}>
          <div style={S.mLabel}>Total paid out (all-time)</div>
          <div style={{...S.mValue,color:C.green}}>${paidWithCorr.toFixed(2)}</div>
          <div style={S.mSub}>{paidBatches.length} payout batch{paidBatches.length===1?"":"es"}</div>
          {corrTotals.settledTotal!==0 && <div style={S.mSub}>Batches ${totalPaid.toFixed(2)} + settled corrections {fmtSignedMoney(corrTotals.settledTotal)}</div>}
        </div>
        <div style={{...S.metric, borderTop: `3px solid ${C.blue}`}}>
          <div style={S.mLabel}>Active reps</div>
          <div style={S.mValue}>{(reps||[]).length}</div>
          <div style={S.mSub}>Commission tracked per rep</div>
        </div>
      </div>

      {/* Invoice PDF modal — opens from any expanded-row View button. */}
      {viewingInvoice && <AdminInvoiceModal inv={viewingInvoice} onClose={()=>setViewingInvoice(null)} onStatusChange={()=>{}}/>}
      {deleteFor && <CommissionInvoiceDelete target={deleteFor} allAccounts={allAccounts} legacyPaidIds={legacyPaidIds} onClose={()=>setDeleteFor(null)} onOpenInOrders={onOpenInOrders} onDone={afterDelete}/>}
      {adjustFor && <CommissionInvoiceAdjust target={adjustFor} legacyPaidIds={legacyPaidIds} onClose={()=>setAdjustFor(null)} onOpenInOrders={onOpenInOrders} onDone={afterDelete}/>}
      {deleteNotice && (
        <div style={{background:deleteNotice.level==="bad"?C.redLight:C.amberLight,border:`1px solid ${deleteNotice.level==="bad"?C.red:C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:deleteNotice.level==="bad"?C.red:C.amber,marginBottom:12,display:"flex",justifyContent:"space-between",gap:12}}>
          <span>{deleteNotice.text}</span>
          <button style={S.btnGhost} onClick={()=>setDeleteNotice(null)}>Dismiss</button>
        </div>
      )}

      {payNotice && (
        <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.amber,marginBottom:12,display:"flex",justifyContent:"space-between",gap:12}}>
          <span>{payNotice}</span>
          <button style={S.btnGhost} onClick={()=>setPayNotice("")}>Dismiss</button>
        </div>
      )}
      {ledger.error && (
        <div style={{background:C.redLight,border:`1px solid ${C.red}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.red,marginBottom:12}}>
          Commission corrections could not be loaded completely ({ledger.error}). Correction totals may be out of date; the correction scan is paused.
        </div>
      )}
      {ledger.missingTable && (
        <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.amber,marginBottom:12}}>
          Commission corrections are not set up yet (migration 0031_rep_commission_corrections.sql has not been run). Adjusting or voiding an invoice whose commission was already paid will not be reflected until it is.
        </div>
      )}
      {corrTotals.unlisted.length>0 && (
        <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.amber,marginBottom:12}}>
          <div style={{fontWeight:600,marginBottom:4}}>Corrections for reps who are not in this tab's rep list ({corrTotals.unlistedOpenCount + corrTotals.unlistedOrphanCount})</div>
          {corrTotals.unlisted.map(u => (
            <div key={u.repId}>{u.repName||"Unknown rep"} ({u.repId||"no id"}): {u.count>0 && <span>{u.count} open correction{u.count===1?"":"s"}, {fmtSignedMoney(u.total)}. </span>}{u.orphanCount>0 && <span>{u.orphanCount} claimed by a payout that never wrote its payment rows (more than 10 minutes ago), {fmtSignedMoney(u.orphanTotal)}, not counted as paid. </span>}This money is owed or due but is not in any total or payout below until the rep appears in this tab's list.</div>
          ))}
        </div>
      )}
      {backfillIncomplete && !ledger.missingTable && (
        <div style={{marginBottom:12}}>
          <button style={{...S.btnSmall,opacity:backfillRetryTick>=5?0.5:1}} disabled={backfillRetryTick>=5} onClick={retryLegacyBackfill}>Retry legacy migration{backfillRetryTick>=5?" (limit reached, reload the page)":""}</button>
        </div>
      )}
      <CorrectionScanCard scan={scan} onRecorded={ledger.reload} notReadyReason={backfillIncomplete && !ledger.missingTable ? "The Correction needed scan is paused: legacy commission payouts are not migrated to Supabase yet (the backfill did not complete; see the console). Use Retry legacy migration below, or reload this tab. Until then no corrections are proposed." : ""}/>
      {repCorrRows.map(r => (
        <CorrectionsCard key={r.repId} summary={r.summary} mode="admin" title={`Corrections for ${r.rep}${r.inactiveStatus?(r.inactiveStatus==="deleted"?" (deleted)":" (paused)"):""}`} onChanged={ledger.reload} onSettle={(r.pendingRows===0 && ledger.ready)?()=>setCorrOnlyRep(r):null} settleLabel="Settle corrections only (nothing pending)"/>
      ))}
      {corrOnlyRep && (
        <CorrectionOnlyModal repId={corrOnlyRep.repId} repName={corrOnlyRep.rep} open={corrOnlyRep.summary.open} onClose={()=>setCorrOnlyRep(null)} onDone={(res)=>{ if(res && res.ok){ const m=describePayoutResult(res); if(m) setPayNotice(m); } ledger.reload(); }}/>
      )}

      {/* ── Pending payments ── Every rep × period that has uncovered
          commission. Each row is a distinct "to be paid" bucket; when admin
          clicks Mark Paid it freezes into Payment history below and this
          row clears out. New invoices arriving afterward spawn a fresh
          pending row (that's the batch semantics admins asked for). */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <span style={S.cardTitle}>Pending payments</span>
          <span style={{fontSize:11,color:C.inkLight}}>Each row becomes a frozen batch when you click Mark Paid</span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"140px 140px 80px 110px 60px 120px 120px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Rep</span><span>Period</span><span style={{textAlign:"right"}}>Invoices</span><span style={{textAlign:"right"}}>Sales</span><span>Rate</span><span style={{textAlign:"right"}}>Pending</span><span></span>
        </div>
        {pendingRows.length===0 && <div style={{padding:20,textAlign:"center",color:C.inkLight,fontSize:12}}>No pending commission right now. Nice.</div>}
        {pendingRows.map(p => {
          const isExpanded = expandedRowId === p.id;
          return (
            <div key={p.id}>
              <div
                onClick={()=>setExpandedRowId(isExpanded?null:p.id)}
                style={{display:"grid",gridTemplateColumns:"140px 140px 80px 110px 60px 120px 120px",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",cursor:"pointer",background:isExpanded?C.blueLight:C.amberLight}}
              >
                <span style={{fontWeight:600,color:C.ink,minWidth:0}}>{p.rep} {isExpanded?"▲":"▼"}{p.inactiveStatus&&<div style={{marginTop:2}}><span style={{...S.pillRed,fontSize:10}}>{p.inactiveStatus==="deleted"?"Deleted":"Paused"}</span></div>}</span>
                <span style={{color:C.inkLight}}>{p.period}</span>
                <span style={{color:C.inkLight,textAlign:"right"}}>{p.invoiceCount}</span>
                <span style={{color:C.ink,textAlign:"right"}}>${p.sales.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                <span style={{color:C.teal,fontWeight:600}}>{p.rate}%</span>
                <span style={{fontWeight:700,color:"#B45309",textAlign:"right"}}>${p.commission.toFixed(2)}</span>
                <button style={S.btnSuccess} onClick={e=>{e.stopPropagation();openMarkPaid(p.id);}}>Mark paid</button>
              </div>
              {isExpanded && (
                <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                  <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 130px",gap:8,padding:"8px 18px",fontSize:10,fontWeight:600,color:C.inkLight}}>
                    <span>Invoice</span><span>Date</span><span>Customer</span><span>Items</span><span style={{textAlign:"right"}}>Total</span><span style={{textAlign:"right"}}>Commission</span><span></span>
                  </div>
                  {p.invoices.map(inv => {
                    const itemsLabel = Array.isArray(inv.items)
                      ? inv.items.map(i=>`[${i.sku||"—"}] ${i.name||""} ×${i.qty||0}`).join(", ")
                      : (inv.items || "—");
                    return (
                      <div key={inv.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 130px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`}}>
                        <span style={{fontWeight:600,color:C.blue}}>{inv.id}</span>
                        <span style={{color:C.inkLight}}>{inv.date||""}</span>
                        <span style={{color:C.ink}}>{inv.customer||""} <RemitBadge inv={inv} remit={remit}/></span>
                        <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={itemsLabel}>{itemsLabel}</span>
                        <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number(inv.total)||0).toFixed(2)}</span>
                        <span style={{fontWeight:500,color:C.teal,textAlign:"right"}}>${((Number(inv.total)||0)*(p.rate||0)/100).toFixed(2)}</span>
                        <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                          <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setViewingInvoice(inv);}}>View</button>
                          <button disabled={!!adjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:adjBlock(inv)?0.5:1,cursor:adjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setAdjustFor({inv:inv,repName:p.rep,rate:p.rate});}} title={adjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>
                          <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDeleteFor({inv,repName:p.rep,rate:p.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ── Paid batches ── Frozen historical payouts. Each row is one click
          of Mark Paid. Expanding shows the exact invoices that were in that
          batch + per-invoice Undo to rescind a single one. */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <span style={S.cardTitle}>Payment history (batches)</span>
          <span style={{fontSize:11,color:C.inkLight}}>{paidBatches.length} batch{paidBatches.length===1?"":"es"} total</span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"140px 110px 100px 80px 110px 120px 60px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Rep</span><span>Paid date</span><span>Method</span><span style={{textAlign:"right"}}>Invoices</span><span style={{textAlign:"right"}}>Commission</span><span>Notes</span><span></span>
        </div>
        {paidBatches.length===0 && <div style={{padding:20,textAlign:"center",color:C.inkLight,fontSize:12}}>No paid batches yet. Once you mark the first pending payment paid, it'll move here.</div>}
        {paidBatches.map(b => {
          const isExpanded = expandedRowId === b.id;
          return (
            <div key={b.id}>
              <div
                onClick={()=>setExpandedRowId(isExpanded?null:b.id)}
                style={{display:"grid",gridTemplateColumns:"140px 110px 100px 80px 110px 120px 60px",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",cursor:"pointer",background:isExpanded?C.blueLight:"transparent"}}
              >
                <span style={{fontWeight:600,color:C.ink,minWidth:0}}>{b.rep} {isExpanded?"▲":"▼"}{b.inactiveStatus&&<div style={{marginTop:2}}><span style={{...S.pillRed,fontSize:10}}>{b.inactiveStatus==="deleted"?"Deleted":"Paused"}</span></div>}</span>
                <span style={{color:C.inkLight}}>{b.paidDateDisplay||"—"}</span>
                <span style={{color:C.inkLight}}>{b.method||"—"}</span>
                <span style={{color:C.inkLight,textAlign:"right"}}>{b.invoiceCount}</span>
                <span style={{fontWeight:600,color:C.green,textAlign:"right"}}>${b.commission.toFixed(2)}</span>
                <span style={{color:C.inkLight,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={b.notes||""}>{b.legacy?<span style={S.pillGray}>Legacy</span>:(b.notes||"—")}</span>
                <span style={S.pillGreen}>Paid</span>
              </div>
              {isExpanded && (
                <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                  <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:10,fontWeight:600,color:C.inkLight}}>
                    <span>Invoice</span><span>Date</span><span>Customer</span><span>Items</span><span style={{textAlign:"right"}}>Total</span><span style={{textAlign:"right"}}>Commission</span><span></span>
                  </div>
                  {(()=>{
                    // Frozen view: amounts and rate come from the PAID rows (what was
                    // actually paid), never total x the current rate. Legacy batches
                    // and batches without paid rows keep the old rendering (null).
                    const lines = frozenBatchLines({ batch:b, paidRows:frozenPaidRows, corrections:ledger.corrections, allInvoices:sharedInvs });
                    if (!lines) return null;
                    return lines.map(ln => {
                      const inv = ln.inv;
                      const itemsLabel = inv && Array.isArray(inv.items)
                        ? inv.items.map(i=>`[${i.sku||"—"}] ${i.name||""} ×${i.qty||0}`).join(", ")
                        : ((inv && inv.items) || "—");
                      // Undo is never offered on a voided / not-in-list line (it would
                      // delete the payout record of a cancelled invoice and silently
                      // drop its clawback) nor on a duplicate payout row.
                      const isInSupabase = paidInvoiceIds.has(ln.id) && !ln.voided && !ln.duplicate;
                      return (
                        <div key={ln.rowKey}>
                          <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`,background:ln.voided?"#FEF2F2":"#F0FDF4"}}>
                            <span style={{fontWeight:600,color:C.blue}}>{ln.id}</span>
                            <span style={{color:C.inkLight}}>{(inv&&inv.date)||""}</span>
                            <span style={{color:C.ink}}>{(inv&&inv.customer)||""} <RemitBadge inv={inv||{id:ln.id}} remit={remit}/>{ln.voided && <span style={{...S.pillRed,marginLeft:6}} title={ln.cancelled?"This invoice was cancelled after it was paid":"This invoice is no longer in this rep's active invoice list"}>{ln.cancelled?"VOIDED":"NOT IN LIST"}</span>}{ln.duplicate && <span style={{...S.pillAmber,marginLeft:6}} title="A second payout row exists for this invoice. It is counted in the batch total.">DUPLICATE PAYOUT ROW</span>}</span>
                            <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={itemsLabel}>{itemsLabel}</span>
                            <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number.isFinite(ln.invoiceAmount)?ln.invoiceAmount:(Number(inv&&inv.total)||0)).toFixed(2)}</span>
                            <span style={{fontWeight:500,color:C.teal,textAlign:"right"}} title={ln.rate!=null?`Paid at ${Number(ln.rate).toFixed(2)}%`:""}>${(Number.isFinite(ln.commission)?ln.commission:0).toFixed(2)}</span>
                            <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                              {inv && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setViewingInvoice(inv);}}>View</button>}
                              {isInSupabase && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();undoInvoicePayout(inv||{id:ln.id},b.batchId);}} title="Undo this invoice's payout — moves back to Pending">Undo</button>}
                              {inv && !ln.voided && <button disabled={!!adjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:adjBlock(inv)?0.5:1,cursor:adjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setAdjustFor({inv:inv,repName:b.rep,rate:ln.rate!=null?ln.rate:b.rate});}} title={adjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>}
                              {inv && !ln.voided && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDeleteFor({inv,repName:b.rep,rate:ln.rate!=null?ln.rate:b.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>}
                            </span>
                          </div>
                          {ln.corrections.map(c => (
                            <div key={c.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 150px",gap:8,padding:"4px 18px 6px",fontSize:10,color:C.inkLight,background:"#FFFBEB"}}>
                              <span></span><span>{c.created_at?new Date(c.created_at).toLocaleDateString("en-US",{month:"short",day:"numeric"}):""}</span>
                              <span style={{gridColumn:"3 / span 2"}}>Correction ({c.status}): {c.reason}</span>
                              <span></span>
                              <span style={{fontWeight:600,color:c.delta<0?C.red:C.green,textAlign:"right"}}>{fmtSignedMoney(c.delta)}</span>
                              <span></span>
                            </div>
                          ))}
                        </div>
                      );
                    });
                  })() || b.invoices.map(inv => {
                    const itemsLabel = Array.isArray(inv.items)
                      ? inv.items.map(i=>`[${i.sku||"—"}] ${i.name||""} ×${i.qty||0}`).join(", ")
                      : (inv.items || "—");
                    const isInSupabase = paidInvoiceIds.has(String(inv.id));
                    return (
                      <div key={inv.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`,background:"#F0FDF4"}}>
                        <span style={{fontWeight:600,color:C.blue}}>{inv.id}</span>
                        <span style={{color:C.inkLight}}>{inv.date||""}</span>
                        <span style={{color:C.ink}}>{inv.customer||""} <RemitBadge inv={inv} remit={remit}/></span>
                        <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={itemsLabel}>{itemsLabel}</span>
                        <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number(inv.total)||0).toFixed(2)}</span>
                        <span style={{fontWeight:500,color:C.teal,textAlign:"right"}}>${((Number(inv.total)||0)*(b.rate||0)/100).toFixed(2)}</span>
                        <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                          <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setViewingInvoice(inv);}}>View</button>
                          {isInSupabase && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();undoInvoicePayout(inv,b.batchId);}} title="Undo this invoice's payout — moves back to Pending">Undo</button>}
                          <button disabled={!!adjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:adjBlock(inv)?0.5:1,cursor:adjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setAdjustFor({inv:inv,repName:b.rep,rate:b.rate});}} title={adjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>
                          <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDeleteFor({inv,repName:b.rep,rate:b.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>
                        </span>
                      </div>
                    );
                  })}
                  {settleMap.has(b.batchId) && (
                    <div style={{padding:"8px 18px",fontSize:11,color:C.inkMid,background:"#FFFBEB",borderTop:`1px solid ${C.border}`}}>
                      Corrections settled in this payout: {settleMap.get(b.batchId).count} ({fmtSignedMoney(settleMap.get(b.batchId).total)}). Cash paid = ${b.commission.toFixed(2)} invoices {fmtSignedMoney(settleMap.get(b.batchId).total)} corrections = ${(b.commission+settleMap.get(b.batchId).total).toFixed(2)}.
                    </div>
                  )}
                  <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 1fr 90px 90px 150px",gap:8,padding:"10px 18px",fontSize:11,fontWeight:600,background:C.tealLight}}>
                    <span></span><span></span><span></span>
                    <span style={{color:C.teal}}>Batch total</span>
                    <span style={{color:C.ink,textAlign:"right"}}>${b.invoices.reduce((s,i)=>s+(Number(i.total)||0),0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                    <span style={{color:C.green,textAlign:"right"}}>${b.commission.toFixed(2)}</span>
                    <span></span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        {corrOnlyHistory.map(cs => {
          const rowId = `corr__${cs.batchId}`;
          const isExpanded = expandedRowId === rowId;
          return (
            <div key={rowId}>
              <div onClick={()=>setExpandedRowId(isExpanded?null:rowId)} style={{display:"grid",gridTemplateColumns:"140px 110px 100px 80px 110px 120px 60px",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",cursor:"pointer",background:isExpanded?C.blueLight:"#FFFBEB"}}>
                <span style={{fontWeight:600,color:C.ink}}>{cs.repName||"Rep"} {isExpanded?"▲":"▼"}</span>
                <span style={{color:C.inkLight}}>{cs.paidAt?new Date(cs.paidAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}):"—"}</span>
                <span style={{color:C.inkLight}}>{cs.method||"—"}</span>
                <span style={{color:C.inkLight,textAlign:"right"}}>{cs.count}</span>
                <span style={{fontWeight:600,color:cs.total<0?C.red:C.green,textAlign:"right"}}>{fmtSignedMoney(cs.total)}</span>
                <span style={{color:C.inkLight,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={cs.notes||""}>{cs.notes||"—"}</span>
                <span style={S.pillAmber}>Corrections</span>
              </div>
              {isExpanded && (
                <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                  <div style={{padding:"8px 18px",fontSize:11,color:C.inkMid}}>Corrections settlement. No invoice payout rows exist for this batch ({cs.batchId}).</div>
                  {cs.corrections.map(c => (
                    <div key={c.id} style={{display:"grid",gridTemplateColumns:"100px 1fr 90px",gap:8,padding:"6px 18px",fontSize:11,borderTop:`1px solid ${C.border}`}}>
                      <span style={{fontWeight:600,color:C.blue}}>{c.invoice_id}</span>
                      <span style={{color:C.inkLight}}>{c.reason}</span>
                      <span style={{fontWeight:600,color:c.delta<0?C.red:C.green,textAlign:"right"}}>{fmtSignedMoney(c.delta)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── ADMIN PANEL ───────────────────────────────────────────────────────────────
// Inline stubs for admin-only modules (RepPortal exports used when available)
const ADMIN_TRAINING_STUB = [
  {id:1,title:"How to demo catalytic converter cleaner",category:"product",duration:"8 min",required:true,watched:true,thumbnail:"🎬",desc:"Step-by-step demo script for repair shops.",uploadedBy:"Sam T.",date:"Mar 15, 2025",showToCustomers:true},
  {id:2,title:"DPF system explainer for diesel shops",category:"product",duration:"12 min",required:true,watched:true,thumbnail:"🎬",desc:"Full DPF product line walkthrough.",uploadedBy:"Sam T.",date:"Mar 20, 2025",showToCustomers:true},
  {id:3,title:"How to handle objections at the counter",category:"sales",duration:"15 min",required:true,watched:false,thumbnail:"🎬",desc:"Top 10 objections and how to respond.",uploadedBy:"Sam T.",date:"Apr 1, 2025",showToCustomers:false},
];
const ADMIN_MATERIALS_STUB = [
  {id:1,name:"Product flyer — DPF line",category:"flyer",price:0,unit:"per pack of 10",active:true,stock:500,desc:"Full-color double-sided flyer covering the DPF product line.",showToCustomers:true},
  {id:2,name:"Shelf talker — catalytic cleaner",category:"shelf",price:0,unit:"per pack of 5",active:true,stock:200,desc:"3x5 shelf talker with P0420 cure claim and MSRP.",showToCustomers:true},
  {id:3,name:"Counter display — starter kit",category:"display",price:25.00,unit:"per unit",active:true,stock:40,desc:"Countertop cardboard display holding 12 units.",showToCustomers:true},
  {id:4,name:"Window cling — MPC branding",category:"other",price:0,unit:"per pack of 3",active:true,stock:150,desc:"Static cling for shop window.",showToCustomers:true},
  {id:5,name:"Banner — trade show 3x6ft",category:"banner",price:45.00,unit:"per unit",active:false,stock:12,desc:"Retractable banner stand with full MPC branding.",showToCustomers:false},
];
const ADMIN_TOOLS_STUB = [
  {id:1,name:"OBD-II diagnostic scanner",value:280,minUnitsPerMonth:12,category:"diagnostic",maxCirculation:20,active:true,desc:"Reads and clears P0420, P0430, and DPF codes.",currentLoaned:8},
  {id:2,name:"DPF pressure differential tester",value:180,minUnitsPerMonth:8,category:"diagnostic",maxCirculation:15,active:true,desc:"Tests DPF back-pressure to show blockage level.",currentLoaned:5},
  {id:3,name:"Fuel injector flow tester",value:350,minUnitsPerMonth:12,category:"diagnostic",maxCirculation:10,active:true,desc:"Shows injector flow rate vs spec.",currentLoaned:3},
];
const ADMIN_AGREEMENTS_STUB = [
  {id:1,toolId:1,toolName:"OBD-II diagnostic scanner",shop:"Apex Car Care LLC",rep:"Marcus T.",startDate:"Feb 1, 2025",minUnits:12,lastMonthUnits:18,status:"compliant",warnings:0,value:280},
  {id:2,toolId:1,toolName:"OBD-II diagnostic scanner",shop:"FastLane Auto Parts",rep:"Marcus T.",startDate:"Mar 1, 2025",minUnits:12,lastMonthUnits:9,status:"warning",warnings:1,value:280},
  {id:3,toolId:3,toolName:"Fuel injector flow tester",shop:"Westside Repair Center",rep:"Sarah L.",startDate:"Mar 15, 2025",minUnits:12,lastMonthUnits:4,status:"recall",warnings:2,value:350},
];

// Inline lightweight versions of the three program tabs for admin
function AdminTrainingTab({videos,setVideos,accounts=[],reps=[]}) {
  const emptyForm={title:"",category:"product",duration:"",required:false,desc:"",videoUrl:"",videoType:"youtube",thumbnailUrl:""};
  const [showModal,setShowModal]=useState(false);
  const [editingId,setEditingId]=useState(null);
  const [nv,setNv]=useState(emptyForm);
  const [previewId,setPreviewId]=useState(null);
  const [videoSearch,setVideoSearch]=useState("");
  const [saveBusy,setSaveBusy]=useState(false);
  const [saveError,setSaveError]=useState("");
  const openAdd=()=>{setEditingId(null);setNv(emptyForm);setSaveError("");setShowModal(true);};
  const openEdit=(v)=>{setEditingId(v.id);setNv({title:v.title||"",category:v.category||"product",duration:v.duration||"",required:!!v.required,desc:v.desc||"",videoUrl:v.videoUrl||"",videoType:v.videoType||"youtube",thumbnailUrl:v.thumbnailUrl||""});setSaveError("");setShowModal(true);};
  // Quiz editor state — mirrors the AdminCertificationTab pattern
  // (CertPortal.js:667). Migration 0025 added a `questions` JSONB column
  // to training_videos so each uploaded video can carry its own quiz.
  // editingQ holds the video whose quiz is open; tempQuestions is the
  // draft — committed on Save via upsertTrainingVideo (which only writes
  // the questions field, preserving every other video metadata field).
  const [editingQ, setEditingQ] = useState(null);
  const [tempQuestions, setTempQuestions] = useState([]);
  const [qBusy, setQBusy] = useState(false);
  const [qError, setQError] = useState("");
  const startEditQuestions = (video) => {
    const src = Array.isArray(video.questions) ? video.questions : [];
    // Deep clone so cancel doesn't leak edits back to the live row.
    setTempQuestions(JSON.parse(JSON.stringify(src)));
    setEditingQ(video);
    setQError("");
  };
  const closeQuestions = () => { if (!qBusy) { setEditingQ(null); setTempQuestions([]); setQError(""); } };
  const addQuestion = () => setTempQuestions(qs => [...qs, { id: Date.now(), q: "", opts: ["","","",""], answer: 0 }]);
  const updateQ  = (i, field, val) => setTempQuestions(qs => qs.map((q, qi) => qi === i ? { ...q, [field]: val } : q));
  const updateOpt = (qi, oi, val) => setTempQuestions(qs => qs.map((q, i) => i === qi ? { ...q, opts: q.opts.map((o, j) => j === oi ? val : o) } : q));
  const removeQuestion = (qi) => setTempQuestions(qs => qs.filter((_, i) => i !== qi));
  const saveQuestions = async () => {
    if (!editingQ || qBusy) return;
    // Basic validation — skip empty questions (empty q text OR all-empty options)
    const cleaned = (tempQuestions || []).filter(q => q && q.q && q.q.trim().length > 0);
    setQBusy(true); setQError("");
    try {
      // upsert with { id, questions } — trainingClientToRow only writes
      // `questions` when supplied, so every other metadata field on the
      // row is preserved exactly.
      const saved = await upsertTrainingVideo({ ...editingQ, questions: cleaned });
      setVideos(vs => vs.map(x => x.id === editingQ.id ? { ...x, ...saved } : x));
      setEditingQ(null); setTempQuestions([]); setQError("");
    } catch (e) {
      console.warn("[AdminTrainingTab] save questions failed:", e?.message || e);
      setQError(e?.message || "Save failed. Check your connection and try again.");
    } finally {
      setQBusy(false);
    }
  };
  // Notifies whichever audience a training video is (newly) visible to.
  // Fires from two call sites below: once on initial upload (reps — new
  // uploads are always showToReps:true by default, see payload below) and
  // once when admin flips a video's customer visibility on (dealers only
  // learn about a video once it's actually visible to them — emailing them
  // earlier would link to something they can't see yet). Sequential
  // send loop (not Promise.all) mirrors the existing AdminBroadcastsTab
  // pattern — same reasoning: avoid bursting the email API rate limit.
  // Best-effort: a failed send for one recipient is logged and skipped,
  // never blocks the video save/toggle that triggered it.
  const notifyNewTrainingVideo = async (video, audience) => {
    const recipients = audience === 'rep'
      ? (reps||[]).filter(r=>r.email).map(r=>({name:r.name||"Sales Rep", email:r.email}))
      : (accounts||[]).filter(a=>a.status==="approved" && !(a.role==="rep"||a.tier==="rep") && a.email)
          .map(a=>({name:a.contact||a.company||"there", email:a.email}));
    for (const r of recipients) {
      try {
        const result = await emailNewTrainingVideo({
          recipientName: r.name, title: video.title, description: video.desc,
          duration: video.duration, category: video.category, audience,
        }, r.email);
        if (!result?.success) console.warn("[AdminTrainingTab] new-video email failed for", r.email, ":", result?.error);
      } catch (e) {
        console.warn("[AdminTrainingTab] new-video email threw for", r.email, ":", e?.message || e);
      }
    }
  };
  // Supabase-first save (migration 0023). Persists cross-device so reps and
  // customers see admin's uploads immediately. Realtime subscription in the
  // parent hydrates the list; we also patch local state for a snappy UX.
  const saveVideo=async()=>{
    if(!nv.title || saveBusy) return;
    setSaveBusy(true); setSaveError("");
    try {
      const now=new Date();
      const dateStr=now.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
      const isNew = !editingId;
      const payload = editingId
        ? { id: editingId, ...nv }
        : { ...nv, uploadedBy: "Admin", date: dateStr, showToCustomers: false, showToReps: true, active: true };
      const saved = await upsertTrainingVideo(payload);
      // Patch local state for immediate render — realtime will re-hydrate
      // shortly after, which is idempotent (matching id replaces the row).
      if (editingId) {
        setVideos(vs => vs.map(x => x.id === editingId ? { ...x, ...saved } : x));
      } else {
        setVideos(vs => [saved, ...vs]);
      }
      setShowModal(false); setNv(emptyForm); setEditingId(null);
      // Fire-and-forget — email failures must never block the save the
      // admin is waiting on. New uploads default to showToReps:true, so
      // every genuinely new video notifies reps; editing an existing video
      // never re-notifies.
      if (isNew && saved) notifyNewTrainingVideo(saved, 'rep');
    } catch (e) {
      console.warn("[AdminTrainingTab] upsertTrainingVideo failed:", e?.message || e);
      setSaveError(e?.message || "Save failed. Check your connection and try again.");
    } finally {
      setSaveBusy(false);
    }
  };
  // Toggle customer visibility — Supabase UPDATE via upsert with the id set.
  const toggleShowToCustomers = async (v) => {
    try {
      const nowVisible = !v.showToCustomers;
      const saved = await upsertTrainingVideo({ ...v, showToCustomers: nowVisible });
      setVideos(vs => vs.map(x => x.id === v.id ? { ...x, ...saved } : x));
      // Only notify on OFF→ON — flipping it back off should stay silent.
      if (nowVisible && saved) notifyNewTrainingVideo(saved, 'customer');
    } catch (e) {
      console.warn("[AdminTrainingTab] toggle showToCustomers failed for", v.id, ":", e?.message || e);
    }
  };
  // Delete — Supabase DELETE via helper. Hard delete (matches pre-migration
  // "Remove" button behavior). Consider adding a soft-delete option later
  // if audit history becomes a requirement.
  const removeVideo = async (id) => {
    try {
      await deleteTrainingVideo(id);
      setVideos(vs => vs.filter(x => x.id !== id));
    } catch (e) {
      console.warn("[AdminTrainingTab] deleteTrainingVideo failed for", id, ":", e?.message || e);
    }
  };
  const getEmbedUrl=(url,type)=>{
    if(type==="youtube"){const m=url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/);return m?`https://www.youtube.com/embed/${m[1]}`:url;}
    if(type==="vimeo"){const m=url.match(/vimeo\.com\/(\d+)/);return m?`https://player.vimeo.com/video/${m[1]}`:url;}
    return url;
  };
  // Card thumbnail fallback: when admin hasn't set a manual thumbnailUrl,
  // auto-derive YouTube's own thumbnail (img.youtube.com, no API key) so
  // the row still shows a real frame instead of the 🎬 placeholder. Manual
  // thumbnailUrl always wins when set. Same helper used in RepPortal's
  // TrainingHub and CustomerTraining below, for a consistent look across
  // all three portals.
  const getThumbnail=(v)=>{
    if(v?.thumbnailUrl) return v.thumbnailUrl;
    if(v?.videoUrl && (v.videoType||"youtube")==="youtube"){
      const m=v.videoUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/);
      if(m) return `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg`;
    }
    return "";
  };
  return (
    <div>
      {/* Question editor modal — mirrors the AdminCertificationTab pattern
          (CertPortal.js:722). Persists via upsertTrainingVideo which only
          writes the questions field when supplied, preserving all other
          video metadata on the row. */}
      {editingQ && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}} onClick={closeQuestions}>
          <div style={{background:C.white,borderRadius:16,padding:"24px",width:640,maxHeight:"85vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:4}}>Edit quiz questions</div>
            <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>{editingQ.title}</div>
            {tempQuestions.length === 0 && (
              <div style={{fontSize:12,color:C.inkLight,background:C.surface,padding:"14px",borderRadius:8,marginBottom:12,textAlign:"center"}}>
                No questions yet. Click <strong>+ Add question</strong> below to start building the quiz.
              </div>
            )}
            {tempQuestions.map((q,qi)=>(
              <div key={q.id || qi} style={{background:C.surface,borderRadius:10,padding:"14px",marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <span style={{fontSize:12,fontWeight:600,color:C.ink}}>Question {qi+1}</span>
                  <button onClick={()=>removeQuestion(qi)} disabled={qBusy} style={{...S.btnDanger,padding:"2px 8px",fontSize:11}}>Remove</button>
                </div>
                <div style={S.fg}>
                  <input style={S.input} value={q.q||""} disabled={qBusy} onChange={e=>updateQ(qi,"q",e.target.value)} placeholder="Question text (e.g., What is the recommended dilution ratio?)"/>
                </div>
                {(q.opts||["","","",""]).map((opt,oi)=>(
                  <div key={oi} style={{display:"flex",gap:8,marginBottom:6,alignItems:"center"}}>
                    <input type="radio" name={`correct-${qi}`} checked={q.answer===oi} disabled={qBusy} onChange={()=>updateQ(qi,"answer",oi)} style={{accentColor:C.teal}}/>
                    <input style={{...S.input,fontSize:12}} value={opt||""} disabled={qBusy} onChange={e=>updateOpt(qi,oi,e.target.value)} placeholder={`Option ${String.fromCharCode(65+oi)}`}/>
                    <span style={{fontSize:10,color:q.answer===oi?C.teal:C.inkLight,flexShrink:0,minWidth:52}}>{q.answer===oi?"✓ Correct":""}</span>
                  </div>
                ))}
              </div>
            ))}
            <button style={S.btnGhost} disabled={qBusy} onClick={addQuestion}>+ Add question</button>
            {qError && (
              <div style={{padding:"8px 12px",background:C.redLight,color:C.red,borderRadius:6,fontSize:12,marginTop:10}}>{qError}</div>
            )}
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
              <button style={S.btnSecondary} disabled={qBusy} onClick={closeQuestions}>Cancel</button>
              <button style={S.btnPrimary} disabled={qBusy} onClick={saveQuestions}>{qBusy?"Saving…":"Save questions"}</button>
            </div>
          </div>
        </div>
      )}
      {showModal&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:580,maxHeight:"85vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editingId?"Edit training video":"Upload training video"}</div>
            <div style={S.fg}><label style={S.label}>Title *</label><input style={S.input} value={nv.title} onChange={e=>setNv(v=>({...v,title:e.target.value}))} placeholder="How to demo catalytic converter cleaner"/></div>
            <div style={S.fg}>
              <label style={S.label}>Video source *</label>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                {[["youtube","YouTube"],["vimeo","Vimeo"],["direct","Direct URL / MP4"],["file","Upload file"]].map(([k,l])=>(
                  <button key={k} onClick={()=>setNv(v=>({...v,videoType:k}))} style={{padding:"6px 14px",borderRadius:8,border:`1px solid ${nv.videoType===k?C.teal:C.border}`,background:nv.videoType===k?C.tealBg:"transparent",color:nv.videoType===k?C.teal:C.inkLight,fontSize:12,fontWeight:500,cursor:"pointer"}}>{l}</button>
                ))}
              </div>
              {nv.videoType==="file"?(
                <div style={{border:`2px dashed ${C.border}`,borderRadius:10,padding:"24px 16px",textAlign:"center",cursor:"pointer",background:C.surface}} onClick={()=>{const inp=document.createElement("input");inp.type="file";inp.accept="video/*";inp.onchange=(e)=>{const f=e.target.files[0];if(f){const url=URL.createObjectURL(f);setNv(v=>({...v,videoUrl:url,fileName:f.name}));}};inp.click();}}>
                  {nv.videoUrl?<div><span style={{color:C.teal,fontWeight:600}}>{nv.fileName||"Video selected"}</span><div style={{fontSize:11,color:C.inkLight,marginTop:4}}>Click to change</div></div>
                  :<div><div style={{fontSize:24,marginBottom:6}}>📁</div><div style={{fontSize:13,color:C.inkLight}}>Click to select video file</div><div style={{fontSize:11,color:C.inkLight,marginTop:4}}>MP4, MOV, AVI, WebM supported</div></div>}
                </div>
              ):(
                <input style={S.input} value={nv.videoUrl} onChange={e=>setNv(v=>({...v,videoUrl:e.target.value}))} placeholder={nv.videoType==="youtube"?"https://www.youtube.com/watch?v=...":nv.videoType==="vimeo"?"https://vimeo.com/123456789":"https://example.com/video.mp4"}/>
              )}
              {nv.videoUrl&&nv.videoType!=="file"&&(
                <div style={{marginTop:10,borderRadius:10,overflow:"hidden",background:"#000",position:"relative",paddingBottom:"56.25%"}}>
                  {nv.videoType==="direct"?<video src={nv.videoUrl} controls style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}/>
                  :<iframe title="preview" src={getEmbedUrl(nv.videoUrl,nv.videoType)} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>}
                </div>
              )}
            </div>
            <div style={S.fg}><label style={S.label}>Thumbnail URL (optional)</label><input style={S.input} value={nv.thumbnailUrl} onChange={e=>setNv(v=>({...v,thumbnailUrl:e.target.value}))} placeholder="https://example.com/thumb.jpg"/>
              {nv.thumbnailUrl&&<img src={nv.thumbnailUrl} alt="" style={{marginTop:8,maxHeight:80,borderRadius:6,border:`1px solid ${C.border}`}} onError={e=>{e.target.style.display="none"}}/>}
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Category</label><select style={S.select} value={nv.category} onChange={e=>setNv(v=>({...v,category:e.target.value}))}>{["product","sales","admin","marketing"].map(c=><option key={c} value={c}>{c}</option>)}</select></div>
              <div style={S.fg}><label style={S.label}>Duration</label><input style={S.input} value={nv.duration} onChange={e=>setNv(v=>({...v,duration:e.target.value}))} placeholder="8 min"/></div>
            </div>
            <div style={S.fg}><label style={S.label}>Description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={nv.desc} onChange={e=>setNv(v=>({...v,desc:e.target.value}))}/></div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:C.ink,marginBottom:14,cursor:"pointer"}}><input type="checkbox" checked={nv.required} onChange={e=>setNv(v=>({...v,required:e.target.checked}))} style={{width:14,height:14}}/>Required for certification</label>
            {saveError && (
              <div style={{padding:"8px 12px",background:C.redLight,color:C.red,borderRadius:6,fontSize:12,marginBottom:10}}>{saveError}</div>
            )}
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} disabled={saveBusy} onClick={()=>{setShowModal(false);setEditingId(null);setSaveError("");}}>Cancel</button>
              <button style={S.btnPrimary} disabled={saveBusy} onClick={saveVideo}>{saveBusy?"Saving…":(editingId?"Save changes":"Upload")}</button>
            </div>
          </div>
        </div>
      )}
      {previewId&&(()=>{const pv=videos.find(x=>x.id===previewId);if(!pv)return null;return(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}} onClick={()=>setPreviewId(null)}>
          <div style={{background:C.white,borderRadius:16,padding:"24px 28px",width:720,maxWidth:"90vw"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{fontSize:16,fontWeight:600,color:C.ink}}>{pv.title}</div>
              <button style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.inkLight}} onClick={()=>setPreviewId(null)}>×</button>
            </div>
            {pv.videoUrl?(
              <div style={{borderRadius:10,overflow:"hidden",background:"#000",position:"relative",paddingBottom:"56.25%"}}>
                {pv.videoType==="direct"||pv.videoType==="file"?<video src={pv.videoUrl} controls style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}/>
                :<iframe title="play" src={getEmbedUrl(pv.videoUrl,pv.videoType)} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>}
              </div>
            ):<div style={{padding:40,textAlign:"center",background:C.surface,borderRadius:10,color:C.inkLight}}>No video URL provided</div>}
            <div style={{marginTop:12,fontSize:13,color:C.inkLight}}>{pv.desc}</div>
          </div>
        </div>
      );})()}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <span style={{fontSize:14,fontWeight:600,color:C.ink}}>Training videos ({videos.length})</span>
        <div style={{display:"flex",gap:8}}>
          <input style={{...S.input,width:200,fontSize:12,padding:"6px 12px"}} placeholder="Search videos..." value={videoSearch} onChange={e=>setVideoSearch(e.target.value)}/>
          <button style={S.btnPrimary} onClick={openAdd}>+ Upload video</button>
        </div>
      </div>
      <div style={S.card}>
        <div style={{display:"grid",gridTemplateColumns:"60px 1fr 80px 80px 70px 90px 80px 210px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span></span><span>Title</span><span>Category</span><span>Duration</span><span>Required</span><span>Customers</span><span>Uploaded</span><span></span>
        </div>
        {videos.filter(v=>{if(!videoSearch.trim())return true;const q=videoSearch.toLowerCase();return (v.title||"").toLowerCase().includes(q)||(v.desc||"").toLowerCase().includes(q)||(v.category||"").toLowerCase().includes(q);}).map(v=>{
          const thumb=getThumbnail(v);
          return (
          <div key={v.id} style={{display:"grid",gridTemplateColumns:"60px 1fr 80px 80px 70px 90px 80px 210px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
            <div style={{width:52,height:36,borderRadius:6,background:C.surface,overflow:"hidden",cursor:v.videoUrl?"pointer":"default",display:"flex",alignItems:"center",justifyContent:"center",position:"relative"}} onClick={()=>v.videoUrl&&setPreviewId(v.id)}>
              {thumb?<img src={thumb} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>:<span style={{fontSize:18}}>🎬</span>}
              {v.videoUrl&&<div style={{position:"absolute",background:"rgba(0,0,0,0.5)",borderRadius:"50%",width:20,height:20,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{color:"#fff",fontSize:10,marginLeft:2}}>▶</span></div>}
            </div>
            <div><div style={{fontWeight:500,color:C.ink}}>{v.title}</div><div style={{fontSize:11,color:C.inkLight}}>{v.videoUrl?<span style={{color:C.teal}}>{v.videoType==="file"?"Uploaded":"Link"}</span>:<span style={{color:"#e67e22"}}>No video</span>}{v.desc?" — "+v.desc.slice(0,40)+"...":""}</div></div>
            <span style={S.pillBlue}>{v.category}</span>
            <span style={{color:C.inkLight}}>{v.duration}</span>
            <span style={v.required?S.pillBlue:S.pillGray}>{v.required?"Yes":"No"}</span>
            <button onClick={()=>toggleShowToCustomers(v)} style={v.showToCustomers?S.btnSuccess:S.btnSecondary}>{v.showToCustomers?"Visible":"Hidden"}</button>
            <span style={{color:C.inkLight}}>{v.date}</span>
            <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              <button style={S.btnSecondary} onClick={()=>openEdit(v)}>Edit</button>
              <button
                style={{...S.btnSecondary, background: (v.questions && v.questions.length>0) ? C.tealLight : undefined, color: (v.questions && v.questions.length>0) ? C.teal : undefined}}
                onClick={()=>startEditQuestions(v)}
                title="Add or edit the quiz questions for this video"
              >
                Questions{(v.questions && v.questions.length>0) ? ` (${v.questions.length})` : ""}
              </button>
              <button style={S.btnDanger} onClick={()=>removeVideo(v.id)}>×</button>
            </div>
          </div>
          );})}
      </div>
    </div>
  );
}

function AdminMaterialsTab({materials,setMaterials}) {
  // Single modal handles both Add and Edit. `modal` carries mode:
  //   null        — modal closed
  //   "add"       — creating a new material
  //   {mode:"edit", id} — editing the material with that id
  // Editing preserves the existing id, so any product/kit that has the
  // material in its `linkedMaterials` array stays wired after the edit.
  const blank = {name:"",category:"flyer",price:0,unit:"per pack of 10",active:true,stock:0,desc:"",imageUrl:"",showToCustomers:false};
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState(blank);
  const [viewing,setViewing]=useState(null); // id of material being viewed in detail
  const viewingItem = viewing ? materials.find(m=>m.id===viewing) : null;
  const editMode = modal && modal.mode === "edit";

  const openAdd    = () => { setForm({...blank}); setModal("add"); };
  const openEdit   = (m) => { setForm({...blank, ...m}); setModal({mode:"edit", id:m.id}); };
  const closeModal = () => { setModal(null); setForm({...blank}); };
  const saveItem   = () => {
    if(!form.name.trim()) return;
    if(modal === "add") {
      setMaterials(ms=>[...ms, {id:Date.now(), ...form}]);
    } else if(editMode) {
      setMaterials(ms=>ms.map(x=>x.id===modal.id ? {...x, ...form, id:x.id} : x));
    }
    closeModal();
  };

  return (
    <div>
      {/* Add / Edit modal — same form for both. */}
      {modal&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:520,maxHeight:"85vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editMode?"Edit marketing material":"Add marketing material"}</div>
            <div style={S.fg}><label style={S.label}>Name *</label><input style={S.input} value={form.name} onChange={e=>setForm(v=>({...v,name:e.target.value}))} placeholder="Product flyer — DPF line"/></div>
            <div style={S.fg}>
              <ImageUploader value={form.imageUrl} onChange={url=>setForm(v=>({...v,imageUrl:url}))} folder="marketing" label="Image"/>
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Category</label><select style={S.select} value={form.category} onChange={e=>setForm(v=>({...v,category:e.target.value}))}>{["flyer","shelf","display","banner","other"].map(c=><option key={c} value={c}>{c}</option>)}</select></div>
              <div style={S.fg}><label style={S.label}>Unit label</label><input style={S.input} value={form.unit} onChange={e=>setForm(v=>({...v,unit:e.target.value}))} placeholder="per pack of 10"/></div>
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Price ($) — 0 = free</label><input style={S.input} type="number" min="0" step="0.01" value={form.price} onChange={e=>setForm(v=>({...v,price:parseFloat(e.target.value)||0}))}/></div>
              <div style={S.fg}><label style={S.label}>Stock qty</label><input style={S.input} type="number" min="0" value={form.stock} onChange={e=>setForm(v=>({...v,stock:parseInt(e.target.value)||0}))}/></div>
            </div>
            <div style={S.fg}><label style={S.label}>Description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={form.desc} onChange={e=>setForm(v=>({...v,desc:e.target.value}))}/></div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:C.ink,marginBottom:10,cursor:"pointer"}}><input type="checkbox" checked={!!form.active} onChange={e=>setForm(v=>({...v,active:e.target.checked}))} style={{width:14,height:14}}/>Active (visible to reps/customers)</label>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:C.ink,marginBottom:14,cursor:"pointer"}}><input type="checkbox" checked={!!form.showToCustomers} onChange={e=>setForm(v=>({...v,showToCustomers:e.target.checked}))} style={{width:14,height:14}}/>Visible to customers</label>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={closeModal}>Cancel</button>
              <button style={S.btnPrimary} onClick={saveItem}>{editMode?"Save changes":"Add item"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Detail view — opens on row click. Read-only; Edit button swaps to
          the edit modal, "Close" dismisses. */}
      {viewingItem&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}} onClick={()=>setViewing(null)}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:560,maxHeight:"85vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",gap:16,marginBottom:16}}>
              {viewingItem.imageUrl?<img src={viewingItem.imageUrl} alt="" style={{width:100,height:100,borderRadius:8,objectFit:"cover",flexShrink:0}} onError={e=>{e.target.style.display="none"}}/>:<div style={{width:100,height:100,borderRadius:8,background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32,flexShrink:0}}>📄</div>}
              <div style={{flex:1}}>
                <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>{viewingItem.name}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:6}}>
                  <span style={S.pillGray}>{viewingItem.category}</span>
                  <span style={viewingItem.active?S.pillGreen:S.pillGray}>{viewingItem.active?"Active":"Off"}</span>
                  <span style={viewingItem.showToCustomers?S.pillGreen:S.pillGray}>{viewingItem.showToCustomers?"Visible to customers":"Hidden from customers"}</span>
                </div>
                <div style={{fontSize:13,color:C.ink,fontWeight:600}}>{viewingItem.price===0?"FREE":`$${Number(viewingItem.price||0).toFixed(2)}`}<span style={{fontWeight:400,color:C.inkLight,marginLeft:6}}>{viewingItem.unit}</span></div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:2}}>Stock</div>
                <div style={{fontSize:16,fontWeight:600,color:C.ink}}>{viewingItem.stock ?? 0}</div>
              </div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:2}}>Unit</div>
                <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{viewingItem.unit||"—"}</div>
              </div>
            </div>
            {viewingItem.desc&&(
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:4}}>Description</div>
                <div style={{fontSize:13,color:C.ink,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{viewingItem.desc}</div>
              </div>
            )}
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setViewing(null)}>Close</button>
              <button style={S.btnPrimary} onClick={()=>{ const m = viewingItem; setViewing(null); openEdit(m); }}>Edit</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}><span style={{fontSize:14,fontWeight:600,color:C.ink}}>Marketing materials ({materials.length})</span><button style={S.btnPrimary} onClick={openAdd}>+ Add material</button></div>
      <div style={S.card}>
        <div style={{display:"grid",gridTemplateColumns:"50px 1fr 80px 80px 80px 80px 90px 80px 120px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span></span><span>Name</span><span>Category</span><span>Price</span><span>Unit</span><span>Stock</span><span>Customers</span><span>Status</span><span></span>
        </div>
        {materials.map(m=>(
          // Row is clickable → opens the read-only detail view. Action
          // buttons (Visible / On-Off / Edit) stopPropagation so they
          // still work without also triggering the view modal.
          <div
            key={m.id}
            onClick={()=>setViewing(m.id)}
            style={{display:"grid",gridTemplateColumns:"50px 1fr 80px 80px 80px 80px 90px 80px 120px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,cursor:"pointer",transition:"background 0.15s"}}
            onMouseEnter={e=>{e.currentTarget.style.background=C.surface;}}
            onMouseLeave={e=>{e.currentTarget.style.background="";}}
          >
            {m.imageUrl?<img src={m.imageUrl} alt="" style={{width:40,height:40,borderRadius:6,objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>:<div style={{width:40,height:40,borderRadius:6,background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>📄</div>}
            <div><div style={{fontWeight:500,color:C.ink}}>{m.name}</div><div style={{fontSize:11,color:C.inkLight}}>{m.desc?.slice(0,50)}{m.desc&&m.desc.length>50?"...":""}</div></div>
            <span style={S.pillGray}>{m.category}</span>
            <span style={{color:C.ink}}>{m.price===0?"FREE":`$${Number(m.price||0).toFixed(2)}`}</span>
            <span style={{color:C.inkLight,fontSize:11}}>{m.unit}</span>
            <span style={{color:C.ink}}>{m.stock}</span>
            <button onClick={e=>{e.stopPropagation();setMaterials(ms=>ms.map(x=>x.id===m.id?{...x,showToCustomers:!x.showToCustomers}:x));}} style={m.showToCustomers?S.btnSuccess:S.btnSecondary}>{m.showToCustomers?"Visible":"Hidden"}</button>
            <span style={m.active?S.pillGreen:S.pillGray}>{m.active?"Active":"Off"}</span>
            <div style={{display:"flex",gap:4}}>
              <button style={S.btnSmall} onClick={e=>{e.stopPropagation();openEdit(m);}}>Edit</button>
              <button style={m.active?S.btnDanger:S.btnSuccess} onClick={e=>{e.stopPropagation();setMaterials(ms=>ms.map(x=>x.id===m.id?{...x,active:!x.active}:x));}}>{m.active?"Off":"On"}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── ADMIN PRODUCTS TAB ──────────────────────────────────────────────────────
// NOTE: `setProducts` / `setKits` are now `saveProducts` / `saveKits`
// wrappers from the parent — they push every mutation straight to Supabase
// via savePortalProducts. There is no local cache that can drift out of
// sync; state is always authoritative. Do not replace these with
// useState-style setters.
function AdminProductsTab({products,setProducts,kits,setKits,materials,catalogLoaded,catalogLoadError,catalogSaveError,stockSyncError,onDismissStockSync,onSeedFromCode,onStockChanged}) {
  const [adding,setAdding]=useState(false);
  const [editing,setEditing]=useState(null);
  const [kitModal,setKitModal]=useState(false);
  const [editingKit,setEditingKit]=useState(null);
  const [catFilter,setCatFilter]=useState("all");
  const [search,setSearch]=useState("");
  // Top-bar stat-card filter. "kits" scrolls into the kit section below,
  // "low" shows only low-stock products. Layered on top of catFilter/search.
  const [productFilter,setProductFilter]=useState("all");
  const cats = Object.keys(CAT_LABELS);
  const blank = {sku:"",name:"",price:0,case:12,stock:0,desc:"",category:"fuel",imageUrl:"",videoUrl:"",active:true,relatedSkus:[],linkedMaterials:[],how:[""],benefits:[""],compatible:[""],tips:[{tag:"",col:"blue",text:""}]};
  const [form,setForm]=useState({...blank});
  const blankKit = {sku:"",name:"",desc:"",items:[""],price:0,case:6,tag:"",badge:"",color:"#0B1F3A",imageUrl:"",videoUrl:"",highlight:"",relatedSkus:[],linkedMaterials:[]};
  const [kitForm,setKitForm]=useState({...blankKit});

  const allSkus = [...products.map(p=>({sku:p.sku,name:p.name})),...kits.map(k=>({sku:k.sku,name:k.name}))];

  const filtered = products.filter(p=>{
    if(productFilter==="low" && p.stock >= 20) return false;
    if(catFilter!=="all" && p.category!==catFilter) return false;
    if(search.trim()){
      const q=search.toLowerCase();
      return p.name.toLowerCase().includes(q)||p.sku.toLowerCase().includes(q);
    }
    return true;
  });

  const saveProduct = () => {
    if(!form.sku||!form.name) return;
    const cleaned = {...form,
      how:(form.how||[]).filter(s=>s.trim()),
      benefits:(form.benefits||[]).filter(s=>s.trim()),
      compatible:(form.compatible||[]).filter(s=>s.trim()),
      tips:(form.tips||[]).filter(t=>t.text?.trim()||t.tag?.trim())
    };
    // Detect stock change so we can sync to warehouse
    const oldProduct = editing ? products.find(p=>p.sku===editing) : null;
    const stockChanged = editing ? (Number(cleaned.stock)||0) !== (Number(oldProduct?.stock)||0) : (Number(cleaned.stock)||0) > 0;
    if(editing) {
      if(cleaned.sku!==editing) {
        // SKU changed — remove old, add updated
        setProducts(ps=>[...ps.filter(p=>p.sku!==editing),{...cleaned}]);
      } else {
        setProducts(ps=>ps.map(p=>p.sku===editing?{...p,...cleaned}:p));
      }
    } else {
      setProducts(ps=>[...ps,{...cleaned}]);
    }
    // Sync stock change to warehouse so rep inventory page reflects the update
    if(stockChanged && onStockChanged) {
      onStockChanged(cleaned.sku, Number(cleaned.stock)||0, cleaned.name);
    }
    setAdding(false); setEditing(null); setForm({...blank});
  };

  const saveKit = () => {
    if(!kitForm.sku||!kitForm.name) return;
    const cleaned = {...kitForm,items:kitForm.items.filter(i=>i.trim())};
    const newSku = cleaned.sku;
    const oldSku = editingKit;
    // Prevent collisions: if SKU changed (or is new), make sure it isn't already used
    // by another kit or product. Otherwise cross-portal sync would alias two items.
    if(!editingKit || newSku !== oldSku) {
      const collision = products.some(p=>p.sku===newSku) || kits.some(k=>k.sku===newSku && k.sku!==oldSku);
      if(collision) { alert(`SKU "${newSku}" is already used by another product or kit. Choose a different SKU.`); return; }
    }
    if(editingKit) {
      // FIX (Phase A): combine the kit rename AND the relatedSkus cascade into
      // a SINGLE setKits call. The previous version made two sequential
      // setKits calls, and because setKits resolves its updater against
      // adminKitsRef.current (which only updates via a useEffect AFTER render),
      // the second call saw the stale pre-rename array. Its saveCatalog write
      // then OVERWROTE the first call's Supabase write with an unrenamed kits
      // column. Symptom: admin changes KIT-DPF → KIT-DPF-V2, clicks Save, the
      // modal closes, but the SKU change never lands in portal_orders.kits.
      // One functional update avoids the race entirely.
      setKits(ks => ks.map(k => {
        if(k.sku === oldSku) {
          // This is the kit being renamed. Apply the full cleaned form.
          return cleaned;
        }
        // Cascade relatedSkus rename for other kits when the SKU changed.
        if(newSku !== oldSku && Array.isArray(k.relatedSkus) && k.relatedSkus.includes(oldSku)) {
          return {...k, relatedSkus: k.relatedSkus.map(s => s === oldSku ? newSku : s)};
        }
        return k;
      }));
      // Cascade relatedSkus rename into products — single setProducts call,
      // only touches products that actually reference the old SKU.
      if(newSku !== oldSku) {
        setProducts(ps => ps.map(p => {
          if(!Array.isArray(p.relatedSkus) || !p.relatedSkus.includes(oldSku)) return p;
          return {...p, relatedSkus: p.relatedSkus.map(s => s === oldSku ? newSku : s)};
        }));
      }
    } else {
      setKits(ks=>[...ks,cleaned]);
    }
    setKitModal(false); setEditingKit(null); setKitForm({...blankKit});
  };

  const startEdit = (p) => { setForm({relatedSkus:[],linkedMaterials:[],how:[""],benefits:[""],compatible:[""],tips:[{tag:"",col:"blue",text:""}],...p}); setEditing(p.sku); setAdding(true); };
  const startEditKit = (k) => { setKitForm({relatedSkus:[],linkedMaterials:[],...k,items:k.items?.length?[...k.items]:[""]}); setEditingKit(k.sku); setKitModal(true); };
  const deleteKit = (sku) => { setKits(ks=>ks.filter(k=>k.sku!==sku)); };
  const [confirmDelete,setConfirmDelete]=useState(null);
  const deleteProduct = (sku) => { setProducts(ps=>ps.filter(p=>p.sku!==sku)); setConfirmDelete(null); };

  const toggleRelated = (sku, isKit) => {
    const setter = isKit ? setKitForm : setForm;
    setter(f => {
      const list = f.relatedSkus||[];
      return {...f, relatedSkus: list.includes(sku) ? list.filter(s=>s!==sku) : [...list, sku]};
    });
  };
  const toggleMaterial = (id, isKit) => {
    const setter = isKit ? setKitForm : setForm;
    setter(f => {
      const list = f.linkedMaterials||[];
      return {...f, linkedMaterials: list.includes(id) ? list.filter(i=>i!==id) : [...list, id]};
    });
  };

  // Shared related products + materials picker
  const RelatedPicker = ({current, onToggle, matCurrent, onToggleMat, excludeSku}) => (
    <div>
      <div style={{marginBottom:14}}>
        <label style={S.label}>Recommended / related products</label>
        <div style={{maxHeight:120,overflowY:"auto",border:`1px solid ${C.border}`,borderRadius:8,padding:6}}>
          {allSkus.filter(s=>s.sku!==excludeSku).map(s=>(
            <label key={s.sku} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.ink,padding:"3px 4px",cursor:"pointer"}}>
              <input type="checkbox" checked={(current||[]).includes(s.sku)} onChange={()=>onToggle(s.sku)} style={{width:13,height:13}}/>
              <span style={{fontWeight:500}}>{s.sku}</span> — {s.name}
            </label>
          ))}
        </div>
        <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>These will show as "Recommended with this product" on the catalog</div>
      </div>
      {materials&&materials.length>0&&(
        <div style={{marginBottom:14}}>
          <label style={S.label}>Linked marketing materials</label>
          <div style={{maxHeight:100,overflowY:"auto",border:`1px solid ${C.border}`,borderRadius:8,padding:6}}>
            {materials.map(m=>(
              <label key={m.id} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.ink,padding:"3px 4px",cursor:"pointer"}}>
                <input type="checkbox" checked={(matCurrent||[]).includes(m.id)} onChange={()=>onToggleMat(m.id)} style={{width:13,height:13}}/>
                {m.name} <span style={{...S.pillGray,marginLeft:4}}>{m.category}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  // Product form modal
  const productModal = adding && (
    <div style={S.modal}>
      <div style={{...S.modalBox,width:600,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editing?"Edit product":"Add product"}</div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>SKU *</label><input style={S.input} value={form.sku} onChange={e=>setForm(f=>({...f,sku:e.target.value}))} placeholder="7000"/></div>
          <div style={S.fg}><label style={S.label}>Category *</label><select style={S.select} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>{cats.map(c=><option key={c} value={c}>{CAT_LABELS[c]}</option>)}</select></div>
        </div>
        <div style={S.fg}><label style={S.label}>Product name *</label><input style={S.input} value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Fuel system cleaner"/></div>
        <div style={S.fg}>
          <ImageUploader value={form.imageUrl||""} onChange={url=>setForm(f=>({...f,imageUrl:url}))} folder="products" label="Product image"/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Product video <span style={{fontWeight:400,color:C.inkLight}}>(optional)</span></label>
          <input style={S.input} value={form.videoUrl||""} onChange={e=>setForm(f=>({...f,videoUrl:e.target.value}))} placeholder="Paste a YouTube, Vimeo, or direct MP4 link"/>
          <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>If set, a video player appears on the product page with a fullscreen button. Leave blank to hide.</div>
        </div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>Price per unit ($)</label><input style={S.input} type="number" min="0" step="0.01" value={form.price} onChange={e=>setForm(f=>({...f,price:parseFloat(e.target.value)||0}))}/></div>
          <div style={S.fg}><label style={S.label}>Case qty</label><input style={S.input} type="number" min="1" value={form.case} onChange={e=>setForm(f=>({...f,case:parseInt(e.target.value)||1}))}/></div>
        </div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>Stock level</label><input style={S.input} type="number" min="0" value={form.stock} onChange={e=>setForm(f=>({...f,stock:parseInt(e.target.value)||0}))}/></div>
          <div style={S.fg}><label style={S.label}>Status</label><select style={S.select} value={form.active===false?"inactive":"active"} onChange={e=>setForm(f=>({...f,active:e.target.value==="active"}))}><option value="active">Active</option><option value="inactive">Inactive</option></select></div>
        </div>

        {/* ─── Variations (PR-V1) ─────────────────────────────────────────
            Optional per-product list of size / model variants, each with
            its own SKU, price, and stock. Backward-compatible: products
            without variations render exactly as before. When variations
            are set, the customer ProductDetail page shows a size / model
            dropdown that updates the displayed price + stock count.
            Cart line items still use the parent SKU in PR-V1 — full cart
            and invoice wiring lands in PR-V2. */}
        <div style={{marginTop:8,marginBottom:14,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
          <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Variations <span style={{fontWeight:400,color:C.inkLight}}>(optional)</span></label>
          <div style={{fontSize:11,color:C.inkLight,marginBottom:8,lineHeight:1.5}}>
            Use variations when one product comes in multiple sizes or models with their own SKU, price, and stock — like wiper blades (16″, 18″, 20″…) or TPE floor mats (one variant per car model). Leave empty if this product is sold in one configuration only.
          </div>
          {(form.variations||[]).map((v,i)=>(
            <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 100px 80px 80px 30px",gap:6,marginBottom:6,alignItems:"center"}}>
              <input
                style={{...S.input,fontSize:12}}
                value={v.label||""}
                onChange={e=>{const arr=[...(form.variations||[])];arr[i]={...arr[i],label:e.target.value};setForm(f=>({...f,variations:arr}));}}
                placeholder='e.g. 18" or Toyota Camry 2018-2024'
              />
              <input
                style={{...S.input,fontSize:12,fontFamily:"monospace"}}
                value={v.sku||""}
                onChange={e=>{const arr=[...(form.variations||[])];arr[i]={...arr[i],sku:e.target.value};setForm(f=>({...f,variations:arr}));}}
                placeholder="SKU"
              />
              <input
                style={{...S.input,fontSize:12}}
                type="number"
                min="0"
                step="0.01"
                value={v.price ?? ""}
                onChange={e=>{const arr=[...(form.variations||[])];arr[i]={...arr[i],price:parseFloat(e.target.value)||0};setForm(f=>({...f,variations:arr}));}}
                placeholder="Price"
              />
              <input
                style={{...S.input,fontSize:12}}
                type="number"
                min="0"
                value={v.stock ?? ""}
                onChange={e=>{const arr=[...(form.variations||[])];arr[i]={...arr[i],stock:parseInt(e.target.value)||0};setForm(f=>({...f,variations:arr}));}}
                placeholder="Stock"
              />
              <button
                style={{...S.btnDanger,padding:"4px 8px",fontSize:10}}
                onClick={()=>setForm(f=>({...f,variations:f.variations.filter((_,j)=>j!==i)}))}
                title="Remove this variation"
              >X</button>
            </div>
          ))}
          {(form.variations||[]).length===0 && (
            <div style={{fontSize:11,color:C.inkLight,fontStyle:"italic",padding:"4px 0 8px"}}>No variations yet. Click below to add one.</div>
          )}
          <button style={S.btnSmall} onClick={()=>setForm(f=>({...f,variations:[...(f.variations||[]),{label:"",sku:"",price:0,stock:0}]}))}>+ Add variation</button>
          {(form.variations||[]).length > 0 && (
            <div style={{fontSize:11,color:C.amber,marginTop:8,padding:"6px 10px",background:C.amberLight,border:"1px solid #FCD34D",borderRadius:6,lineHeight:1.5}}>
              Customers will see a size / model picker on the product page. The parent Price and Stock above are not shown to customers when variations are set. Cart line items will be wired to variation SKUs in the next deploy.
            </div>
          )}
        </div>

        <div style={S.fg}><label style={S.label}>Description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={form.desc} onChange={e=>setForm(f=>({...f,desc:e.target.value}))}/></div>

        {/* ─── How it works ─── */}
        <div style={{marginTop:8,marginBottom:14,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
          <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>How it works (step-by-step instructions)</label>
          {(form.how||[""]).map((step,i)=>(
            <div key={i} style={{display:"flex",gap:6,marginBottom:6,alignItems:"center"}}>
              <span style={{fontSize:11,fontWeight:600,color:C.blue,minWidth:44}}>Step {i+1}</span>
              <input style={{...S.input,flex:1,fontSize:12}} value={step} onChange={e=>{const h=[...(form.how||[""])];h[i]=e.target.value;setForm(f=>({...f,how:h}));}} placeholder={`Step ${i+1} instruction...`}/>
              {(form.how||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>setForm(f=>({...f,how:f.how.filter((_,j)=>j!==i)}))}>X</button>}
            </div>
          ))}
          <button style={S.btnSmall} onClick={()=>setForm(f=>({...f,how:[...(f.how||[]),""]}))}>+ Add step</button>
        </div>

        {/* ─── Key benefits ─── */}
        <div style={{marginBottom:14}}>
          <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Key benefits</label>
          {(form.benefits||[""]).map((b,i)=>(
            <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
              <input style={{...S.input,flex:1,fontSize:12}} value={b} onChange={e=>{const arr=[...(form.benefits||[""])];arr[i]=e.target.value;setForm(f=>({...f,benefits:arr}));}} placeholder={`Benefit ${i+1}...`}/>
              {(form.benefits||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>setForm(f=>({...f,benefits:f.benefits.filter((_,j)=>j!==i)}))}>X</button>}
            </div>
          ))}
          <button style={S.btnSmall} onClick={()=>setForm(f=>({...f,benefits:[...(f.benefits||[]),""]}))}>+ Add benefit</button>
        </div>

        {/* ─── Compatible vehicles ─── */}
        <div style={{marginBottom:14}}>
          <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Compatible vehicles / systems</label>
          {(form.compatible||[""]).map((c,i)=>(
            <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
              <input style={{...S.input,flex:1,fontSize:12}} value={c} onChange={e=>{const arr=[...(form.compatible||[""])];arr[i]=e.target.value;setForm(f=>({...f,compatible:arr}));}} placeholder={`Compatible system ${i+1}...`}/>
              {(form.compatible||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>setForm(f=>({...f,compatible:f.compatible.filter((_,j)=>j!==i)}))}>X</button>}
            </div>
          ))}
          <button style={S.btnSmall} onClick={()=>setForm(f=>({...f,compatible:[...(f.compatible||[]),""]}))}>+ Add</button>
        </div>

        {/* ─── Selling tips ─── */}
        <div style={{marginBottom:14,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
          <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Selling tips for reps</label>
          {(form.tips||[{tag:"",col:"blue",text:""}]).map((tip,i)=>(
            <div key={i} style={{background:C.surface,borderRadius:8,padding:"10px 12px",marginBottom:8}}>
              <div style={{display:"flex",gap:6,marginBottom:6}}>
                <div style={{flex:1}}><label style={{fontSize:10,color:C.inkLight}}>Tag label</label><input style={{...S.input,fontSize:12}} value={tip.tag} onChange={e=>{const arr=[...(form.tips||[])];arr[i]={...arr[i],tag:e.target.value};setForm(f=>({...f,tips:arr}));}} placeholder="Opening / Value pitch / Upsell"/></div>
                <div style={{width:100}}><label style={{fontSize:10,color:C.inkLight}}>Color</label><select style={{...S.select,fontSize:12}} value={tip.col||"blue"} onChange={e=>{const arr=[...(form.tips||[])];arr[i]={...arr[i],col:e.target.value};setForm(f=>({...f,tips:arr}));}}>
                  {["blue","green","amber","red"].map(c=><option key={c} value={c}>{c}</option>)}
                </select></div>
                {(form.tips||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10,alignSelf:"flex-end"}} onClick={()=>setForm(f=>({...f,tips:f.tips.filter((_,j)=>j!==i)}))}>X</button>}
              </div>
              <textarea style={{...S.input,fontSize:12,height:48,resize:"vertical"}} value={tip.text} onChange={e=>{const arr=[...(form.tips||[])];arr[i]={...arr[i],text:e.target.value};setForm(f=>({...f,tips:arr}));}} placeholder="Tip text - what the rep should say or do..."/>
            </div>
          ))}
          <button style={S.btnSmall} onClick={()=>setForm(f=>({...f,tips:[...(f.tips||[]),{tag:"",col:"blue",text:""}]}))}>+ Add tip</button>
        </div>

        <RelatedPicker current={form.relatedSkus} onToggle={s=>toggleRelated(s,false)} matCurrent={form.linkedMaterials} onToggleMat={id=>toggleMaterial(id,false)} excludeSku={form.sku}/>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button style={S.btnSecondary} onClick={()=>{setAdding(false);setEditing(null);setForm({...blank});}}>Cancel</button>
          <button style={S.btnPrimary} onClick={saveProduct}>{editing?"Save changes":"Add product"}</button>
        </div>
      </div>
    </div>
  );

  // Kit form modal
  const kitFormModal = kitModal && (
    <div style={S.modal}>
      <div style={{...S.modalBox,width:600,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editingKit?"Edit kit / bundle":"Add kit / bundle"}</div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>Kit SKU *</label><input style={S.input} value={kitForm.sku} onChange={e=>setKitForm(f=>({...f,sku:e.target.value}))} placeholder="KIT-NEW"/></div>
          <div style={S.fg}><label style={S.label}>Badge label</label><input style={S.input} value={kitForm.badge} onChange={e=>setKitForm(f=>({...f,badge:e.target.value}))} placeholder="DPF"/></div>
        </div>
        <div style={S.fg}><label style={S.label}>Kit name *</label><input style={S.input} value={kitForm.name} onChange={e=>setKitForm(f=>({...f,name:e.target.value}))} placeholder="DPF Cleaning Kit"/></div>
        <div style={S.fg}>
          <ImageUploader value={kitForm.imageUrl||""} onChange={url=>setKitForm(f=>({...f,imageUrl:url}))} folder="kits" label="Kit image"/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Kit video <span style={{fontWeight:400,color:C.inkLight}}>(optional)</span></label>
          <input style={S.input} value={kitForm.videoUrl||""} onChange={e=>setKitForm(f=>({...f,videoUrl:e.target.value}))} placeholder="Paste a YouTube, Vimeo, or direct MP4 link"/>
          <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>If set, a video player appears on the kit detail with a fullscreen button. Leave blank to hide.</div>
        </div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>Price per unit ($)</label><input style={S.input} type="number" min="0" step="0.01" value={kitForm.price} onChange={e=>setKitForm(f=>({...f,price:parseFloat(e.target.value)||0}))}/></div>
          <div style={S.fg}><label style={S.label}>Case qty</label><input style={S.input} type="number" min="1" value={kitForm.case} onChange={e=>setKitForm(f=>({...f,case:parseInt(e.target.value)||1}))}/></div>
        </div>
        <div style={S.twoCol}>
          <div style={S.fg}><label style={S.label}>Tag</label><input style={S.input} value={kitForm.tag} onChange={e=>setKitForm(f=>({...f,tag:e.target.value}))} placeholder="Best seller"/></div>
          <div style={S.fg}><label style={S.label}>Highlight text</label><input style={S.input} value={kitForm.highlight||""} onChange={e=>setKitForm(f=>({...f,highlight:e.target.value}))} placeholder="Save vs buying separately"/></div>
        </div>
        <div style={S.fg}><label style={S.label}>Description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={kitForm.desc} onChange={e=>setKitForm(f=>({...f,desc:e.target.value}))}/></div>
        <div style={{marginBottom:14}}>
          <label style={S.label}>Kit items (products included in this bundle)</label>
          {kitForm.items.map((item,i)=>(
            <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
              <input style={{...S.input,flex:1}} value={item} onChange={e=>{const items=[...kitForm.items];items[i]=e.target.value;setKitForm(f=>({...f,items}));}} placeholder={`Product ${i+1} — e.g. DPF foam cleaner (400ml)`}/>
              {kitForm.items.length>1&&<button style={S.btnDanger} onClick={()=>setKitForm(f=>({...f,items:f.items.filter((_,j)=>j!==i)}))}>×</button>}
            </div>
          ))}
          <button style={S.btnSmall} onClick={()=>setKitForm(f=>({...f,items:[...f.items,""]}))}>+ Add item to bundle</button>
        </div>
        <RelatedPicker current={kitForm.relatedSkus} onToggle={s=>toggleRelated(s,true)} matCurrent={kitForm.linkedMaterials} onToggleMat={id=>toggleMaterial(id,true)} excludeSku={kitForm.sku}/>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button style={S.btnSecondary} onClick={()=>{setKitModal(false);setEditingKit(null);setKitForm({...blankKit});}}>Cancel</button>
          <button style={S.btnPrimary} onClick={saveKit}>{editingKit?"Save changes":"Add kit"}</button>
        </div>
      </div>
    </div>
  );

  // Loading — Supabase hydration hasn't completed yet. Don't render the list
  // (empty list would mislead the admin) and don't let any input fire edits
  // that write an empty array back to Supabase.
  if (!catalogLoaded) {
    return (
      <div style={{padding:"48px 24px",textAlign:"center",color:C.inkLight,fontSize:13}}>
        <div style={{marginBottom:8,fontWeight:500,color:C.inkMid}}>Loading catalog from Supabase…</div>
        <div>Hold on, we're fetching the authoritative product + kit list.</div>
      </div>
    );
  }

  // Empty Supabase — migration path. Shown the first time the admin opens
  // this tab after deploying a fresh project, or after someone intentionally
  // wiped `portal_products`. Clicking Seed writes the hardcoded catalog from
  // src/seeds/catalogSeed.js to Supabase once; all subsequent edits go back
  // to the normal write path.
  if (products.length === 0 && kits.length === 0) {
    return (
      <div style={{padding:"32px 24px"}}>
        {catalogLoadError && (
          <div style={{background:C.redLight,border:`1px solid ${C.red}`,color:C.red,padding:"10px 14px",borderRadius:8,fontSize:12,marginBottom:14}}>
            Failed to load catalog from Supabase: {catalogLoadError}
          </div>
        )}
        <div style={{...S.card,padding:"28px 32px",maxWidth:640}}>
          <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>Catalog is empty in Supabase</div>
          <div style={{fontSize:13,color:C.inkMid,lineHeight:1.6,marginBottom:18}}>
            The <code>portal_products</code> row has no products or kits yet.
            Click below to seed the table from the bundled hardcoded catalog
            (<code>src/seeds/catalogSeed.js</code>). After seeding, edits you
            make here save directly to Supabase — deploys will never overwrite
            them again.
          </div>
          <button style={S.btnPrimary} onClick={onSeedFromCode}>Seed catalog from code</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      {productModal}{kitFormModal}
      {/* Save / load banners */}
      {catalogLoadError && (
        <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,color:C.amber,padding:"8px 12px",borderRadius:8,fontSize:12,marginBottom:12}}>
          Catalog load warning: {catalogLoadError}
        </div>
      )}
      {catalogSaveError && (
        <div style={{background:C.redLight,border:`1px solid ${C.red}`,color:C.red,padding:"8px 12px",borderRadius:8,fontSize:12,marginBottom:12}}>
          Last save failed: {catalogSaveError} — your local view is ahead of Supabase. Retry the edit.
        </div>
      )}
      {stockSyncError && (
        <div style={{background:C.redLight,border:`1px solid ${C.red}`,color:C.red,padding:"8px 12px",borderRadius:8,fontSize:12,marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <div style={{flex:1}}>{stockSyncError} Open Rep Inventory and use Receive / adjust on the warehouse card to correct it. This message clears when the Rep Inventory tab reads the warehouse.</div>
          {onDismissStockSync && <button onClick={onDismissStockSync} style={{background:"transparent",border:`1px solid ${C.red}`,color:C.red,fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer"}}>Dismiss</button>}
        </div>
      )}
      {/* Metrics — click a card to filter the list below.
          "Total products" resets the filter. "Low stock" shows only
          items with stock < 20 (regardless of category). "Total kits"
          shortcuts to the kit section. */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[
          {l:"Total products",v:products.length,                              key:"all"},
          {l:"Total kits",v:kits.length,                                      key:"kits"},
          {l:"Low stock (<20)",v:products.filter(p=>p.stock<20).length,warn:true, key:"low"},
          {l:"Categories",v:cats.length,                                      key:"all"},
        ].map((m,i)=>{
          const active = productFilter===m.key && m.key!=="all";
          const accent = m.warn ? C.amber : C.blue;
          return (
            <div
              key={m.l+i}
              onClick={()=>setProductFilter(active ? "all" : m.key)}
              style={{
                ...S.metric,
                ...(m.warn?{borderTop:`3px solid ${C.amber}`}:{}),
                cursor:"pointer",
                boxShadow: active ? `0 0 0 2px ${accent}` : undefined,
                transition:"box-shadow 0.15s, transform 0.15s"
              }}
              onMouseEnter={e=>{ if(!active) e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
            >
              <div style={S.mLabel}>{m.l}</div>
              <div style={S.mValue}>{m.v}</div>
              {active && <div style={{fontSize:10,color:accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
            </div>
          );
        })}
      </div>

      {/* Filters + actions */}
      <div style={{display:"flex",gap:8,marginBottom:16,alignItems:"center",flexWrap:"wrap"}}>
        <select style={{...S.select,width:"auto",fontSize:12,padding:"7px 12px"}} value={catFilter} onChange={e=>setCatFilter(e.target.value)}>
          <option value="all">All categories</option>
          {cats.map(c=><option key={c} value={c}>{CAT_LABELS[c]}</option>)}
        </select>
        <input style={{...S.input,width:200,fontSize:12,padding:"7px 12px"}} placeholder="Search by name or SKU..." value={search} onChange={e=>setSearch(e.target.value)}/>
        <div style={{flex:1}}/>
        <button style={S.btnSecondary} onClick={()=>{setKitForm({...blankKit});setEditingKit(null);setKitModal(true);}}>+ Add kit</button>
        <button style={S.btnPrimary} onClick={()=>{setForm({...blank});setEditing(null);setAdding(true);}}>+ Add product</button>
      </div>

      {/* Kits section */}
      {kits.length>0&&(
        <div style={{marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>Service kits & bundles ({kits.length})</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:12}}>
            {kits.map(k=>(
              <div key={k.sku} style={{...S.card,padding:16}}>
                <div style={{display:"flex",gap:12,alignItems:"start"}}>
                  {k.imageUrl?<img src={k.imageUrl} alt="" style={{width:56,height:56,borderRadius:8,objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>:<div style={{width:56,height:56,borderRadius:8,background:k.color||C.navy,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><span style={{fontSize:10,fontWeight:700,color:"white",letterSpacing:"0.05em"}}>{k.badge||k.sku}</span></div>}
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.ink}}>{k.name}</div>
                    <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{k.sku} · ${k.price.toFixed(2)}/unit · Case of {k.case}</div>
                    {k.tag&&<span style={{...S.pillBlue,marginTop:4,display:"inline-block"}}>{k.tag}</span>}
                  </div>
                  <div style={{display:"flex",gap:4}}>
                    <button style={S.btnSmall} onClick={()=>startEditKit(k)}>Edit</button>
                    <button style={S.btnDanger} onClick={()=>deleteKit(k.sku)}>×</button>
                  </div>
                </div>
                <div style={{marginTop:8,fontSize:11,color:C.inkLight}}>{k.desc}</div>
                <div style={{marginTop:6}}>{k.items.map((it,i)=><div key={i} style={{fontSize:11,color:C.inkMid}}>• {it}</div>)}</div>
                {k.highlight&&<div style={{marginTop:6,fontSize:11,color:C.teal,fontWeight:500}}>{k.highlight}</div>}
                {(k.relatedSkus?.length>0||k.linkedMaterials?.length>0)&&(
                  <div style={{marginTop:8,paddingTop:8,borderTop:`1px solid ${C.border}`}}>
                    {k.relatedSkus?.length>0&&<div style={{fontSize:10,color:C.inkLight}}>Related: {k.relatedSkus.map(s=>allSkus.find(x=>x.sku===s)?.name||s).join(", ")}</div>}
                    {k.linkedMaterials?.length>0&&<div style={{fontSize:10,color:C.inkLight,marginTop:2}}>Materials: {k.linkedMaterials.map(id=>materials?.find(m=>m.id===id)?.name||id).join(", ")}</div>}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Products by category */}
      {(catFilter==="all"?cats:[catFilter]).map(cat=>{
        const catProducts = filtered.filter(p=>p.category===cat);
        if(catProducts.length===0) return null;
        return (
          <div key={cat} style={{marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:8}}>{CAT_LABELS[cat]} ({catProducts.length})</div>
            <div style={S.card}>
              <div style={{display:"grid",gridTemplateColumns:"50px 70px 1fr 70px 60px 70px 70px 90px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                <span></span><span>SKU</span><span>Product</span><span>Price</span><span>Case</span><span>Stock</span><span>Status</span><span></span>
              </div>
              {catProducts.map(p=>(
                <div key={p.sku}>
                  <div style={{display:"grid",gridTemplateColumns:"50px 70px 1fr 70px 60px 70px 70px 90px",alignItems:"center",gap:8,padding:"10px 18px",borderBottom:(p.relatedSkus?.length||p.linkedMaterials?.length)?`none`:`1px solid ${C.border}`,fontSize:12}}>
                    {p.imageUrl?<img src={p.imageUrl} alt="" style={{width:40,height:40,borderRadius:6,objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>:<div style={{width:40,height:40,borderRadius:6,background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:600,color:C.inkLight}}>{p.sku}</div>}
                    <span style={{fontWeight:600,color:C.blue,fontSize:11}}>
                      {p.sku}
                      {Array.isArray(p.variations) && p.variations.length > 0 && (
                        <span style={{display:"block",fontWeight:500,color:C.amber,fontSize:9,marginTop:1}}>{p.variations.length} variation{p.variations.length===1?"":"s"}</span>
                      )}
                    </span>
                    <div><div style={{fontWeight:500,color:C.ink}}>{p.name}</div><div style={{fontSize:10,color:C.inkLight}}>{p.desc?.slice(0,60)}...</div></div>
                    <span style={{color:C.ink,fontWeight:500}}>{Array.isArray(p.variations) && p.variations.length > 0 ? <span style={{fontSize:10,color:C.inkLight,fontStyle:"italic"}}>varies</span> : `$${p.price.toFixed(2)}`}</span>
                    <span style={{color:C.inkLight}}>{p.case}</span>
                    <span style={{color:p.stock<20?C.red:p.stock<50?C.amber:C.teal,fontWeight:500}}>{Array.isArray(p.variations) && p.variations.length > 0 ? (p.variations.reduce((s,v)=>s+(Number(v.stock)||0),0)) : p.stock}</span>
                    <span style={p.active===false?S.pillGray:S.pillGreen}>{p.active===false?"Inactive":"Active"}</span>
                    <div style={{display:"flex",gap:4}}>
                      <button style={S.btnSmall} onClick={()=>startEdit(p)}>Edit</button>
                      <button style={{...S.btnSmall,color:C.red,borderColor:"#FCA5A5"}} onClick={()=>setConfirmDelete(p)}>✕</button>
                    </div>
                  </div>
                  {(p.relatedSkus?.length>0||p.linkedMaterials?.length>0)&&(
                    <div style={{padding:"4px 18px 10px 138px",borderBottom:`1px solid ${C.border}`,fontSize:10,color:C.inkLight}}>
                      {p.relatedSkus?.length>0&&<span>Recommended: {p.relatedSkus.map(s=>allSkus.find(x=>x.sku===s)?.name||s).join(", ")}</span>}
                      {p.relatedSkus?.length>0&&p.linkedMaterials?.length>0&&<span> · </span>}
                      {p.linkedMaterials?.length>0&&<span>Materials: {p.linkedMaterials.map(id=>materials?.find(m=>m.id===id)?.name||id).join(", ")}</span>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {/* Delete confirmation modal */}
      {confirmDelete&&(
        <div style={S.modal}>
          <div style={{...S.modalBox,width:420}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:8}}>Delete product?</div>
            <div style={{fontSize:13,color:C.inkLight,marginBottom:6}}>Are you sure you want to permanently delete this product?</div>
            <div style={{background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:8,padding:"12px 14px",marginBottom:16}}>
              <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{confirmDelete.name}</div>
              <div style={{fontSize:12,color:C.inkLight}}>SKU: {confirmDelete.sku} · ${confirmDelete.price?.toFixed(2)} · Case of {confirmDelete.case}</div>
            </div>
            <div style={{fontSize:12,color:C.red,marginBottom:16}}>This action cannot be undone. The product will be removed from all portals.</div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setConfirmDelete(null)}>Cancel</button>
              <button style={{...S.btnPrimary,background:"#DC2626"}} onClick={()=>deleteProduct(confirmDelete.sku)}>Delete permanently</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ADMIN ORDERS TAB ────────────────────────────────────────────────────────
const CARRIERS = ["UPS","FedEx","USPS","FedEx Freight","UPS Freight","Other"];

// Cancel-order modal — collects reason + note and previews the refund outcome
// before the admin commits. Branches on the invoice's payment state so the
// preview text accurately reflects whether money will flow back (card/ACH),
// accounting needs to cut a manual refund (check/wire), or nothing to refund.
function CancelOrderModal({order, invoice, reason, setReason, note, setNote, busy, error, onClose, onSubmit, commissionPaid=false, consequence=null, alsoRemove=false, setAlsoRemove, removeReason="", setRemoveReason}) {
  // Money already received from the sales rep (0033): warn + required tick, pass through otherwise.
  // Used by BOTH the Orders-tab void and the Commission-tab Delete. Only rep-created invoices can
  // have a remittance, so anything else skips the read. A failed read is shown, never silent.
  const remitInvId = String((invoice && invoice.id) || (order && order.id) || "");
  const remitApplies = isRepInvoice({ id: remitInvId, repCreated: !!(invoice && invoice.repCreated) });
  const [remitGate, setRemitGate] = useState(() => remitApplies ? null : { needsAck: false, tone: "none", text: "" });
  const [remitAck, setRemitAck] = useState(false);
  useEffect(() => {
    // Reset first: a re-rendered modal must never keep the previous invoice's gate or tick.
    setRemitAck(false);
    setRemitGate(remitApplies ? null : { needsAck: false, tone: "none", text: "" });
    if (!remitApplies) return undefined;
    let dead = false;
    getActiveRemittanceForInvoiceStrict(remitInvId).then(
      (r) => { if (!dead) setRemitGate(voidRemittanceGate(r)); },
      (e) => { console.warn("[CancelOrderModal] remittance check threw for", remitInvId, ":", e?.message || e); if (!dead) setRemitGate(voidRemittanceGate({ ok: false, error: e?.message || String(e) })); }
    );
    return () => { dead = true; };
  }, [remitApplies, remitInvId]);
  const remitBlocked = remitGate === null || (remitGate.needsAck && !remitAck);
  const submitGuarded = async () => {
    if (remitApplies) {
      // Re-check at submit time (a payment may have been recorded while this modal was open).
      let now;
      try { now = voidRemittanceGate(await getActiveRemittanceForInvoiceStrict(remitInvId)); }
      catch (e) { console.warn("[CancelOrderModal] remittance re-check threw for", remitInvId, ":", e?.message || e); now = voidRemittanceGate({ ok: false, error: e?.message || String(e) }); }
      if (now.needsAck && !(remitGate && remitGate.needsAck && remitAck && remitGate.tone === now.tone)) { setRemitGate(now); setRemitAck(false); return; }
    }
    onSubmit();
  };
  const isPaidCardOrAch = invoice && invoice.status==="paid" && (invoice.paidMethod==="Credit card" || invoice.paidMethod==="ACH") && (invoice.paymentId || invoice.transactionId);
  const isPaidOther     = invoice && invoice.status==="paid" && !isPaidCardOrAch;
  const isUnpaid        = !invoice || invoice.status==="outstanding" || invoice.status==="payment_pending";
  const total = (invoice?.total || order?.amount || 0);
  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2500}}>
      <div style={{background:C.white,width:"min(520px,94vw)",boxSizing:"border-box",borderRadius:12,padding:"24px 28px",maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:4}}>Void order {order?.id}</div>
        <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>The customer will be notified by email with the reason you pick. The void is saved to the database first, so reps and dealers on other devices see it too.</div>
        <div style={S.fg}>
          <label style={S.label}>Reason *</label>
          <select style={S.select} value={reason} onChange={e=>setReason(e.target.value)} disabled={busy}>
            <option value="">Select a reason…</option>
            <option>Customer cancelled</option>
            <option>Out of stock</option>
            <option>Delivery address issue</option>
            <option>Other</option>
          </select>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Note to customer{reason==="Other"?" *":" (optional)"}</label>
          <textarea style={{...S.input,minHeight:72,resize:"vertical",fontFamily:"inherit"}} value={note} onChange={e=>setNote(e.target.value)} placeholder="Additional context for the customer..." disabled={busy}/>
        </div>
        <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",marginBottom:16}}>
          <div style={{fontSize:11,fontWeight:600,color:C.inkLight,marginBottom:6,letterSpacing:"0.05em",textTransform:"uppercase"}}>Refund</div>
          {isPaidCardOrAch && (
            <div style={{fontSize:12,color:C.ink}}>
              A <strong>${total.toFixed(2)}</strong> refund will be issued to the <strong>{invoice.paidMethod}</strong>{invoice.paidLast4?` ending in ${invoice.paidLast4}`:""} used on this invoice.
              <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>Customer email will confirm the refund with the transaction ID. Funds typically appear within 3–5 business days.</div>
            </div>
          )}
          {isPaidOther && (
            <div style={{fontSize:12,color:C.amber}}>
              Invoice was paid by <strong>{invoice.paidMethod || "other"}</strong>. Accounting will need to issue a manual refund — customer email will mention this.
            </div>
          )}
          {isUnpaid && (
            <div style={{fontSize:12,color:C.inkLight}}>
              No refund is due — this invoice is <strong>{invoice?.status==="payment_pending"?"payment pending":"outstanding"}</strong> and has not been paid yet.
            </div>
          )}
        </div>
        {commissionPaid && (
          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:"#92400E"}}>
            <strong>Commission already paid.</strong> This invoice already has commission marked paid. A correction line will be recorded for the rep automatically and netted into their next payout.
          </div>
        )}
        {consequence && (
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:C.ink}}>
            <strong>Commission effect.</strong> {consequence}
          </div>
        )}
        {remitGate === null && <div style={{fontSize:11,color:C.inkLight,marginBottom:12}}>Checking whether the sales rep already handed this payment in...</div>}
        {remitGate && remitGate.needsAck && (
          <div style={{background:remitGate.tone==="error"?"#FEE2E2":"#FEF3C7",border:`1px solid ${remitGate.tone==="error"?"#FCA5A5":"#FCD34D"}`,borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:remitGate.tone==="error"?"#991B1B":"#92400E"}}>
            <strong>Received from the sales rep.</strong> {remitGate.text}
            <label style={{display:"flex",gap:8,alignItems:"flex-start",marginTop:6,fontWeight:600,cursor:"pointer"}}>
              <input type="checkbox" checked={remitAck} disabled={busy} onChange={e=>setRemitAck(e.target.checked)} style={{marginTop:2}}/>
              <span>I understand; void anyway</span>
            </label>
          </div>
        )}
        <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:"#92400E"}}>
          <strong>Verify payment first.</strong> Payment status is tracked per device and may not show that the dealer already paid. Check Square / accounting before voiding so no refund is missed.
        </div>
        {setAlsoRemove && (
          <div style={{marginBottom:14}}>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:C.ink,cursor:"pointer"}}>
              <input type="checkbox" checked={alsoRemove} onChange={e=>setAlsoRemove(e.target.checked)} disabled={busy}/>
              Also remove from the Orders list (admin view only, can be restored)
            </label>
            {alsoRemove && (
              <div style={{marginTop:8}}>
                <label style={S.label}>Reason for removal * (internal, not shown to customer or rep)</label>
                <input style={S.input} value={removeReason} onChange={e=>setRemoveReason(e.target.value)} placeholder="e.g. Duplicate entry, test order..." disabled={busy}/>
              </div>
            )}
          </div>
        )}
        {error && <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12}}>{error}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button style={{...S.btnSecondary,opacity:busy?0.6:1}} onClick={onClose} disabled={busy}>Keep order</button>
          <button style={{...S.btnPrimary,background:C.red,opacity:(busy||remitBlocked)?0.7:1}} onClick={submitGuarded} disabled={busy || remitBlocked}>
            {busy ? "Voiding..." : (isPaidCardOrAch ? "Void & refund" : "Void order")}
          </button>
        </div>
      </div>
    </div>
  );
}

// Remove-from-list modal. REMOVE is a reversible, admin-view-only soft hide
// of an ALREADY VOIDED order (migration 0027 order_removals). Nothing in
// portal_orders is changed or deleted. Reason is required and internal.
function RemoveOrderModal({order, reason, setReason, busy, error, onClose, onSubmit}) {
  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2500}}>
      <div style={{background:C.white,width:480,borderRadius:12,padding:"24px 28px",maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:4}}>Remove {order?.id} from the Orders list</div>
        <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>The order stays voided and nothing is deleted. It is only hidden from admin lists (use Show removed to see it, or Restore to bring it back). Reps and dealers still see the Cancelled order.</div>
        <div style={S.fg}>
          <label style={S.label}>Reason for removal *</label>
          <input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. Duplicate entry, test order, entered by mistake..." disabled={busy}/>
        </div>
        {error && <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12}}>{error}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button style={{...S.btnSecondary,opacity:busy?0.6:1}} onClick={onClose} disabled={busy}>Keep in list</button>
          <button style={{...S.btnPrimary,background:C.red,opacity:busy?0.7:1}} onClick={onSubmit} disabled={busy}>{busy?"Removing...":"Remove from list"}</button>
        </div>
      </div>
    </div>
  );
}

// ── ADMIN: SIGNUP & TERMS EDITOR ───────────────────────────────────────────
// Lets admin customize all signup-page + Terms-modal copy from the Settings
// tab. Writes through PORTAL_SETTINGS (Supabase + localStorage cache), so
// updates appear on every browser including anonymous signup visitors.
function AdminSignupTermsEditor() {
  const [form, setForm] = useState(() => PORTAL_SETTINGS.get());
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState("");
  // Re-sync from store (e.g. after hydrate completes on initial load).
  useEffect(() => PORTAL_SETTINGS.subscribe(setForm), []);

  const sec = Array.isArray(form.termsSections) ? form.termsSections : [];
  const setSec = (idx, patch) => setForm(f => ({
    ...f,
    termsSections: (f.termsSections||[]).map((s,i)=> i===idx ? {...s, ...patch} : s)
  }));
  const addSec = () => setForm(f => ({ ...f, termsSections: [...(f.termsSections||[]), {title:"New section", text:""}] }));
  const removeSec = (idx) => {
    if(!window.confirm("Remove this section?")) return;
    setForm(f => ({ ...f, termsSections: (f.termsSections||[]).filter((_,i)=>i!==idx) }));
  };
  const moveSec = (idx, dir) => {
    setForm(f => {
      const list = [...(f.termsSections||[])];
      const j = idx + dir;
      if (j < 0 || j >= list.length) return f;
      [list[idx], list[j]] = [list[j], list[idx]];
      return { ...f, termsSections: list };
    });
  };

  const resetAllToDefaults = () => {
    if(!window.confirm("Reset ALL signup & terms content to the built-in defaults? Your customizations will be lost.")) return;
    setForm({ ...PORTAL_DEFAULTS });
  };

  const save = async () => {
    setSaving(true); setSaveMsg("");
    try {
      await PORTAL_SETTINGS.setAll(form);
      setSaveMsg("Saved. Customers will see the updated copy on their next signup-page load.");
    } catch(e) {
      setSaveMsg("Save failed: " + (e?.message || e));
    }
    setSaving(false);
  };

  const cardStyle = { ...S.card, marginTop: 20 };
  return (
    <div style={cardStyle}>
      <div style={S.cardHdr}><span style={S.cardTitle}>Signup & Terms copy</span></div>
      <div style={{padding:"18px 20px"}}>
        <div style={{fontSize:12,color:C.inkMid,lineHeight:1.6,marginBottom:16,padding:"10px 14px",background:C.blueLight,borderRadius:8}}>
          Everything below is shown to customers and reps during signup. Changes save to Supabase so every visitor sees the latest version. The "Wholesale Account Agreement" modal appears only for customer signups.
        </div>

        {/* Signup disclaimers */}
        <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>Short signup disclaimers (under the form)</div>
        <div style={S.fg}>
          <label style={S.label}>Customer signup disclaimer</label>
          <textarea style={{...S.input,height:60,resize:"vertical"}} value={form.signupBlurbCustomer||""} onChange={e=>setForm(f=>({...f,signupBlurbCustomer:e.target.value}))}/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Rep signup disclaimer</label>
          <textarea style={{...S.input,height:60,resize:"vertical"}} value={form.signupBlurbRep||""} onChange={e=>setForm(f=>({...f,signupBlurbRep:e.target.value}))}/>
        </div>

        {/* Tier descriptions */}
        <div style={{fontSize:13,fontWeight:600,color:C.ink,margin:"16px 0 10px"}}>Account tier descriptions (customer signup sidebar)</div>
        <div style={S.fg}><label style={S.label}>Dealer</label><input style={S.input} value={form.tierDealer||""} onChange={e=>setForm(f=>({...f,tierDealer:e.target.value}))}/></div>
        <div style={S.fg}><label style={S.label}>Distributor</label><input style={S.input} value={form.tierDistributor||""} onChange={e=>setForm(f=>({...f,tierDistributor:e.target.value}))}/></div>
        <div style={S.fg}><label style={S.label}>Enterprise</label><input style={S.input} value={form.tierEnterprise||""} onChange={e=>setForm(f=>({...f,tierEnterprise:e.target.value}))}/></div>

        {/* Terms modal */}
        <div style={{fontSize:13,fontWeight:600,color:C.ink,margin:"16px 0 10px"}}>Wholesale Account Agreement (Terms modal)</div>
        <div style={S.fg}>
          <label style={S.label}>Agreement title (modal header)</label>
          <input style={S.input} value={form.termsTitle||""} onChange={e=>setForm(f=>({...f,termsTitle:e.target.value}))}/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Yellow intro callout (top of modal)</label>
          <textarea style={{...S.input,height:60,resize:"vertical"}} value={form.termsIntroNote||""} onChange={e=>setForm(f=>({...f,termsIntroNote:e.target.value}))}/>
        </div>

        <div style={{fontSize:12,fontWeight:600,color:C.inkMid,textTransform:"uppercase",letterSpacing:"0.06em",margin:"12px 0 8px"}}>Sections ({sec.length})</div>
        {sec.map((s,idx)=>(
          <div key={idx} style={{border:`1px solid ${C.border}`,borderRadius:10,padding:14,marginBottom:10,background:C.surface}}>
            <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:11,fontWeight:600,color:C.inkLight,background:C.bg,padding:"2px 8px",borderRadius:6}}>#{idx+1}</span>
              <input style={{...S.input,flex:1,fontWeight:500}} value={s?.title||""} onChange={e=>setSec(idx,{title:e.target.value})} placeholder="Section title"/>
              <button style={{...S.btnSmall,padding:"4px 10px"}} disabled={idx===0} onClick={()=>moveSec(idx,-1)} title="Move up">↑</button>
              <button style={{...S.btnSmall,padding:"4px 10px"}} disabled={idx===sec.length-1} onClick={()=>moveSec(idx,1)} title="Move down">↓</button>
              <button style={{...S.btnDanger,padding:"4px 10px"}} onClick={()=>removeSec(idx)}>Remove</button>
            </div>
            <textarea style={{...S.input,height:100,resize:"vertical",fontFamily:"inherit"}} value={s?.text||""} onChange={e=>setSec(idx,{text:e.target.value})} placeholder="Section text…"/>
          </div>
        ))}
        <button style={{...S.btnSmall,marginTop:4}} onClick={addSec}>+ Add section</button>

        <div style={{marginTop:14}}>
          <div style={S.fg}>
            <label style={S.label}>Acceptance checkbox text (above the "Accept" button)</label>
            <textarea style={{...S.input,height:70,resize:"vertical"}} value={form.termsAcceptLine||""} onChange={e=>setForm(f=>({...f,termsAcceptLine:e.target.value}))}/>
          </div>
        </div>

        <div style={{display:"flex",gap:10,alignItems:"center",marginTop:16,flexWrap:"wrap"}}>
          <button style={{...S.btnPrimary,opacity:saving?0.6:1}} onClick={save} disabled={saving}>{saving?"Saving…":"Save signup & terms"}</button>
          <button style={S.btnSecondary} onClick={resetAllToDefaults} disabled={saving}>Reset to built-in defaults</button>
          {saveMsg && <div style={{fontSize:12,color:saveMsg.startsWith("Saved")?C.green:C.red,marginLeft:6,flex:1}}>{saveMsg}</div>}
        </div>
      </div>
    </div>
  );
}

// ── SHIP NOW MODAL ────────────────────────────────────────────────────────────
// One-stop shipping entry for admin. Replaces the inline "Add tracking" form.
// Three mutually-exclusive paths (matches 0011 migration delivery_method enum):
//   1. 'carrier'    — UPS/FedEx/USPS/DHL/Other + tracking # (required). Fires
//                      tracking email to dealer. Sets shipping_status=shipped.
//   2. 'rep'        — admin picks a sales rep who physically delivered the
//                      order. Goes straight to delivered (skips shipped) and
//                      stores delivered_by_rep. Fires a shipping email with
//                      rep name (per user spec 2026-04-19 decision #6).
//   3. 'notes_only' — admin marks as shipped without tracking. Notes captured
//                      in shipping_notes. No email.
//
// Writes go to BOTH SHARED_INVOICES (for same-browser instant refresh via its
// subscribe pub/sub) AND Supabase portal_orders (via updatePortalOrderShipping
// so dealer on another device sees the same state). Matches existing
// saveShipping/markDelivered pattern — does not introduce new state paths.
function ShipNowModal({order, accounts, onClose, onCompleted}) {
  const [method, setMethod] = useState("carrier");
  const [carrier, setCarrier] = useState("UPS");
  const [tracking, setTracking] = useState("");
  const [shippedDate, setShippedDate] = useState(()=>new Date().toISOString().slice(0,10));
  const [carrierNotes, setCarrierNotes] = useState("");
  const [repName, setRepName] = useState("");
  const [repNotes, setRepNotes] = useState("");
  const [notesOnly, setNotesOnly] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  // Rep list sourced from SHARED_REP_PROFILES — same store admin uses for
  // rep assignment pickers, so any approved rep is available here without
  // threading a prop through AdminPanel → AdminOrdersTab.
  // Deleted / paused reps (from the Supabase-hydrated accounts prop) are filtered out of the picker;
  // SHARED_REP_PROFILES itself is never trimmed.
  // Also excludes any rep whose live profile is present and not approved (e.g. deleted under the old flow).
  const inactiveNamesForPicker = useMemo(()=>pickerBlockedRepNameSet(accounts),[accounts]);
  const inactiveEmailsForPicker = useMemo(()=>pickerBlockedRepEmailSet(accounts),[accounts]);
  const [repProfilesSnapshot, setRepProfilesSnapshot] = useState(()=>{
    try { return SHARED_REP_PROFILES.getAll ? SHARED_REP_PROFILES.getAll() : {}; } catch(e) { return {}; }
  });
  const repList = useMemo(()=>{
    const names = new Set();
    Object.values(repProfilesSnapshot||{}).forEach(r=>{
      if(!r?.name) return;
      if(inactiveNamesForPicker.has(String(r.name).trim().toLowerCase())) return;
      if(r.email && inactiveEmailsForPicker.has(String(r.email).toLowerCase())) return;
      names.add(r.name);
    });
    return [...names].sort();
  },[repProfilesSnapshot, inactiveNamesForPicker, inactiveEmailsForPicker]);
  useEffect(()=>{
    if(!SHARED_REP_PROFILES?.subscribe) return;
    const unsub = SHARED_REP_PROFILES.subscribe(all=>setRepProfilesSnapshot(all||{}));
    return unsub;
  },[]);

  if(!order) return null;

  const todayLabel = new Date(shippedDate+"T12:00:00").toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
  const acct = accounts?.find(a=>a.company===order.account);

  const confirm = async () => {
    setErr(""); setBusy(true);
    try {
      const raw = order._raw || {};
      const invId = raw.id || order.id;
      const orderRef = raw.orderId || "";

      if(method === "carrier") {
        if(!tracking.trim()) { setErr("Tracking number is required for carrier shipment."); setBusy(false); return; }
        SHARED_INVOICES.updateShipping(invId, {
          tracking: tracking.trim(),
          carrier,
          notes: carrierNotes || "",
          shippedDate: todayLabel,
          deliveryMethod: "carrier",
        });
        try {
          await updatePortalOrderShipping(
            { invoiceId: invId, orderId: orderRef },
            { tracking: tracking.trim(), carrier, shippedDate: todayLabel,
              shippingStatus: "shipped", notes: carrierNotes || "",
              deliveryMethod: "carrier" }
          );
        } catch(e) { console.warn("ShipNow carrier DB sync:", e?.message||e); }
        if(acct?.email) {
          try {
            await emailOrderShipped({
              customerName: acct.contact || acct.company || order.account,
              customerEmail: acct.email,
              orderId: order.id,
              trackingNumber: tracking.trim(),
              carrier,
              estimatedDelivery: "",
              items: order.items,
            });
          } catch(e) { console.warn("ShipNow carrier email:", e?.message||e); }
        }
      }
      else if(method === "rep") {
        if(!repName) { setErr("Pick which rep delivered the order."); setBusy(false); return; }
        SHARED_INVOICES.markDeliveredByRep(invId, {
          repName,
          deliveredDate: todayLabel,
          notes: repNotes || "",
        });
        try {
          await updatePortalOrderShipping(
            { invoiceId: invId, orderId: orderRef },
            { shippingStatus: "delivered", deliveredDate: todayLabel,
              notes: repNotes || "", deliveryMethod: "rep",
              deliveredByRep: repName }
          );
        } catch(e) { console.warn("ShipNow rep DB sync:", e?.message||e); }
        if(acct?.email) {
          // Tracking email repurposed for rep-delivered case — carrier field
          // doubles as "delivered by <rep>" so the dealer sees who brought it.
          try {
            await emailOrderShipped({
              customerName: acct.contact || acct.company || order.account,
              customerEmail: acct.email,
              orderId: order.id,
              trackingNumber: "—",
              carrier: `Delivered in person by ${repName}`,
              estimatedDelivery: todayLabel,
              items: order.items,
            });
          } catch(e) { console.warn("ShipNow rep email:", e?.message||e); }
        }
      }
      else if(method === "notes_only") {
        const note = notesOnly.trim();
        SHARED_INVOICES.updateShipping(invId, {
          notes: note,
          shippedDate: todayLabel,
          shippingNotes: note,
          deliveryMethod: "notes_only",
        });
        try {
          await updatePortalOrderShipping(
            { invoiceId: invId, orderId: orderRef },
            { shippedDate: todayLabel, shippingStatus: "shipped",
              notes: note, deliveryMethod: "notes_only" }
          );
        } catch(e) { console.warn("ShipNow notes DB sync:", e?.message||e); }
      }

      setBusy(false);
      if(onCompleted) onCompleted();
      if(onClose) onClose();
    } catch(e) {
      console.error("ShipNow confirm failed:", e);
      setErr(e?.message || "Failed to save. Try again.");
      setBusy(false);
    }
  };

  const tabStyle = (active) => ({
    flex: 1, padding: "10px 12px", fontSize: 12, fontWeight: 600,
    textAlign: "center", cursor: "pointer",
    border: `1px solid ${active ? C.blue : C.border}`,
    background: active ? C.blueLight : C.white,
    color: active ? C.blue : C.inkMid,
    borderRadius: 8,
  });

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:"20px 0",overflowY:"auto"}}>
      <div style={{background:C.white,width:560,borderRadius:12,overflow:"hidden",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{padding:"16px 24px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",background:C.surface}}>
          <div>
            <div style={{fontSize:16,fontWeight:600,color:C.ink}}>Ship Now — {order.id}</div>
            <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>{order.account} · ${Number(order.amount||0).toFixed(2)}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:C.inkLight,lineHeight:1}}>×</button>
        </div>

        <div style={{padding:"20px 24px"}}>
          <div style={{display:"flex",gap:8,marginBottom:18}}>
            <div style={tabStyle(method==="carrier")}    onClick={()=>!busy && setMethod("carrier")}>Ship with carrier</div>
            <div style={tabStyle(method==="rep")}        onClick={()=>!busy && setMethod("rep")}>Sales rep delivered</div>
            <div style={tabStyle(method==="notes_only")} onClick={()=>!busy && setMethod("notes_only")}>Notes only</div>
          </div>

          {method==="carrier" && (
            <>
              <div style={S.twoCol}>
                <div style={S.fg}>
                  <label style={S.label}>Carrier *</label>
                  <select style={S.select} value={carrier} onChange={e=>setCarrier(e.target.value)} disabled={busy}>
                    {["UPS","FedEx","USPS","DHL","Other"].map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Date shipped</label>
                  <input style={S.input} type="date" value={shippedDate} onChange={e=>setShippedDate(e.target.value)} disabled={busy}/>
                </div>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Tracking number *</label>
                <input style={S.input} value={tracking} onChange={e=>setTracking(e.target.value)} placeholder="1Z999AA10123456784" disabled={busy}/>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Notes (optional)</label>
                <input style={S.input} value={carrierNotes} onChange={e=>setCarrierNotes(e.target.value)} placeholder="Partial shipment, backorder on DPF cleaner..." disabled={busy}/>
              </div>
              <div style={{fontSize:11,color:C.inkLight,background:C.blueLight,border:`1px solid ${C.border}`,padding:"8px 10px",borderRadius:6,marginBottom:10}}>
                Confirming sends a tracking email to {acct?.email || "the dealer on file"}.
              </div>
            </>
          )}

          {method==="rep" && (
            <>
              <div style={S.fg}>
                <label style={S.label}>Which rep delivered? *</label>
                <select style={S.select} value={repName} onChange={e=>setRepName(e.target.value)} disabled={busy}>
                  <option value="">— Select rep —</option>
                  {repList.map(n=><option key={n} value={n}>{n}</option>)}
                </select>
                {repList.length===0 && <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>No reps found in SHARED_REP_PROFILES. Approve a rep first.</div>}
              </div>
              <div style={S.fg}>
                <label style={S.label}>Date of delivery</label>
                <input style={S.input} type="date" value={shippedDate} onChange={e=>setShippedDate(e.target.value)} disabled={busy}/>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Notes (optional)</label>
                <input style={S.input} value={repNotes} onChange={e=>setRepNotes(e.target.value)} placeholder="Signed by customer, left at back door..." disabled={busy}/>
              </div>
              <div style={{fontSize:11,color:C.inkLight,background:C.blueLight,border:`1px solid ${C.border}`,padding:"8px 10px",borderRadius:6,marginBottom:10}}>
                Order is marked Delivered immediately. Dealer gets an email noting {repName || "the rep"} dropped it off.
              </div>
            </>
          )}

          {method==="notes_only" && (
            <>
              <div style={S.fg}>
                <label style={S.label}>Date shipped</label>
                <input style={S.input} type="date" value={shippedDate} onChange={e=>setShippedDate(e.target.value)} disabled={busy}/>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Shipping notes</label>
                <textarea style={{...S.input,minHeight:80,resize:"vertical"}} value={notesOnly} onChange={e=>setNotesOnly(e.target.value)} placeholder="Shipped via in-house courier, ETA Friday..." disabled={busy}/>
              </div>
              <div style={{fontSize:11,color:C.inkLight,background:C.surface,border:`1px solid ${C.border}`,padding:"8px 10px",borderRadius:6,marginBottom:10}}>
                Marks the order as shipped. No tracking number. No email sent.
              </div>
            </>
          )}

          {err && <div style={{fontSize:12,color:C.red,background:C.redLight,border:`1px solid ${C.red}`,padding:"8px 10px",borderRadius:6,marginBottom:10}}>{err}</div>}

          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button style={S.btnSecondary} onClick={onClose} disabled={busy}>Cancel</button>
            <button style={{...S.btnPrimary,background:busy?C.inkLight:C.green,borderColor:busy?C.inkLight:C.green}} onClick={confirm} disabled={busy}>
              {busy ? "Saving..." : method==="rep" ? "Mark Delivered" : "Mark Shipped"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── UNSHIPPED ORDERS BANNER ──────────────────────────────────────────────────
// Global admin banner — visible on every admin tab (per 2026-04-19 decision
// #5) until every unshipped order is handled via Ship Now. Driven purely by
// data: shows anything whose shipping_status is null/pending AND whose
// payment status is not cancelled. Click a row to jump straight into the
// order (AdminPanel sets tab=orders + focusInvoiceId).
function UnshippedOrdersBanner({ unshipped, onOpen, onDismissAll }) {
  const [collapsed, setCollapsed] = useState(false);
  if(!unshipped || unshipped.length === 0) return null;
  const top = unshipped.slice(0, 3);
  const more = unshipped.length - top.length;
  return (
    <div style={{background:"#FFF7ED",border:"1px solid #F59E0B",borderRadius:10,padding:"12px 16px",marginBottom:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:13,fontWeight:600,color:"#9A3412"}}>
          {unshipped.length} unshipped order{unshipped.length>1?"s":""} waiting to ship
        </div>
        <button style={{background:"none",border:"none",color:"#9A3412",fontSize:12,fontWeight:600,cursor:"pointer"}} onClick={()=>setCollapsed(c=>!c)}>
          {collapsed ? "Show" : "Hide"}
        </button>
      </div>
      {!collapsed && (
        <div style={{marginTop:8,display:"flex",flexDirection:"column",gap:6}}>
          {top.map(o=>(
            <div key={o.id} onClick={()=>onOpen && onOpen(o)} style={{display:"grid",gridTemplateColumns:"100px 1fr 110px 80px 50px",gap:10,padding:"8px 10px",background:C.white,border:`1px solid ${C.border}`,borderRadius:8,fontSize:12,cursor:"pointer",alignItems:"center"}}>
              <span style={{fontWeight:600,color:C.blue,fontFamily:"monospace"}}>{o.id}</span>
              <span style={{color:C.ink,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{o.customer}</span>
              <span style={{color:C.inkLight,fontSize:11}}>{o.date || "—"}</span>
              <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${Number(o.total||0).toFixed(2)}</span>
              <span style={{fontSize:11,color:C.inkLight,textAlign:"right"}}>{o.itemCount} {o.itemCount===1?"item":"items"}</span>
            </div>
          ))}
          {more > 0 && <div style={{fontSize:11,color:"#9A3412",textAlign:"center",marginTop:2}}>+ {more} more — open the Orders tab to see all</div>}
        </div>
      )}
    </div>
  );
}

function AdminOrdersTab({accounts, overdueInvoices=[], overdueTotal=0, focusInvoiceId=null, onFocusHandled, adminUserEmail="", focusAdjustRequestId=null, onAdjustFocusHandled, onCreateInvoice}) {
  const [orders,setOrders]=useState(RECENT_ORDERS.map(o=>({...o,tracking:"",carrier:"",shippedDate:"",notes:""})));
  const [search,setSearch]=useState("");
  const [acctFilter,setAcctFilter]=useState("all");
  // Top-bar stat-card filter. Clicking a card filters the list below to just
  // the matching subset; clicking the same card again (or the Total card)
  // clears the filter. "Total orders" is the default/reset state.
  const [listFilter,setListFilter]=useState("all");
  const [viewOrder,setViewOrder]=useState(null);
  const [viewFieldInvoice,setViewFieldInvoice]=useState(null);
  const [editShipping,setEditShipping]=useState(null);
  const [shipForm,setShipForm]=useState({tracking:"",carrier:"UPS",notes:""});
  // Ship Now modal target (field invoice / portal order row). Legacy
  // editShipping above stays for the demo RECENT_ORDERS rows that aren't
  // in SHARED_INVOICES — Ship Now is the path for real dealer orders.
  const [shipNowFor,setShipNowFor]=useState(null);

  // Rep remittances (0033): fetched once per tab mount, kept fresh by realtime (unique channel, cleaned up).
  const remit = useRemittanceList();
  const remitActive = useMemo(()=>activeRemittanceMap(remit.rows),[remit.rows]);
  const remitActiveIds = useMemo(()=>activeRemittanceIds(remit.rows),[remit.rows]);
  const [remitFilter,setRemitFilter]=useState("");
  // Merge shared field invoices from rep portal
  const [sharedInvs,setSharedInvs]=useState(()=>SHARED_INVOICES.getAll());
  useEffect(()=>SHARED_INVOICES.subscribe(invs=>setSharedInvs(invs)),[]);

  // Admin-only removal state (order_removals event log, migration 0027).
  // A removed order is only HIDDEN from admin lists; rep and dealer portals
  // never read this table.
  const removals = useOrderRemovals();
  const removedMap = removals.map || {};
  const [showRemoved,setShowRemoved]=useState(false);
  const [actionNotice,setActionNotice]=useState("");
  const [restoringId,setRestoringId]=useState(null);   // F7 in-flight guard
  const restoreLockRef=useRef(false);                    // N4 synchronous restore guard
  const deepLinkRef=useRef(null);                       // F4 pending deep-link id

  // ── Pending invoice void requests (Supabase invoice_void_requests) ──────────
  // Migration 0022. Admin reviews rep-initiated void requests here. Approve
  // flips portal_orders.status='cancelled' (which existing repMetrics math
  // already treats as excluded-from-commission + restored-to-inventory).
  // Reject leaves the invoice exactly as it is. Q2(a) — commission-paid
  // invoices show a warning before the Approve button but admin can still
  // proceed; reconciliation is a separate manual step.
  const [pendingVoidRequests, setPendingVoidRequests] = useState([]);
  const [voidReqError, setVoidReqError] = useState("");
  const [voidReqBusy, setVoidReqBusy] = useState({});       // id → bool while approve/reject in flight
  const [voidDecisionNote, setVoidDecisionNote] = useState({}); // id → optional note text
  // Set of invoice_ids whose commission has already been paid out via
  // rep_commission_payments. Used to show the Q2(a) warning before approve.
  const [commissionPaidInvoiceIds, setCommissionPaidInvoiceIds] = useState(new Set());
  // "loading" until listRepCommissionPayments has answered; adjustment approve
  // stays disabled until "ok" (the commission-paid warning needs the real list).
  const [commissionIdsState, setCommissionIdsState] = useState("loading");

  // ── Pending invoice ADJUSTMENT requests (invoice_adjustment_requests, 0028) ──
  // Rep-filed. Nothing changes on the invoice until Approve here. Approve is a
  // fresh-fetch + compare-and-set surgical UPDATE of portal_orders
  // (approveAdjustmentRequest in supabase.js); Reject writes only the request.
  const [pendingAdjRequests, setPendingAdjRequests] = useState([]);
  const [adjReqError, setAdjReqError] = useState("");
  const [adjReqBusy, setAdjReqBusy] = useState({});          // id → bool while approve/reject in flight
  const [adjDecisionNote, setAdjDecisionNote] = useState({}); // id → note text
  const [adjCommissionAck, setAdjCommissionAck] = useState({}); // id → ticked "commission already paid" box
  const [adjNotPaidAck, setAdjNotPaidAck] = useState({});        // id → ticked "confirmed not paid in Square" box (always required)
  const [adjHighlightId, setAdjHighlightId] = useState(null);
  const [adjApplied, setAdjApplied] = useState({});      // id → true when an order row already carries this request (finish-only)
  const [adjNeedsAck, setAdjNeedsAck] = useState({});    // id → true after the helper asked for the typed FINISH acknowledgement
  const [adjFinishText, setAdjFinishText] = useState({}); // id → text typed in the FINISH box
  const adjBusyRef = useRef({});                              // synchronous double-click guard

  const refreshPendingAdjRequests = useCallback(async () => {
    try {
      const rows = await listAdjustmentRequests({ status: 'pending', limit: 200 });
      setPendingAdjRequests(rows || []);
    } catch (e) {
      console.warn("[AdminOrdersTab] listAdjustmentRequests failed:", e?.message || e);
      setAdjReqError(e?.message || "Failed to load adjustment requests.");
    }
  }, []);
  useEffect(() => { refreshPendingAdjRequests(); }, [refreshPendingAdjRequests]);
  useEffect(() => {
    const unsub = subscribeAdjustmentRequests(() => { refreshPendingAdjRequests(); });
    return unsub;
  }, [refreshPendingAdjRequests]);

  // For requests the admin already started processing (audit written / error
  // recorded), find out whether the invoice ALREADY carries the change. If so the
  // card switches to finish-only mode (Reject unavailable, no payment checks).
  useEffect(() => {
    const ids = (pendingAdjRequests || []).filter(r => r && (r.pre_apply_order != null || r.last_apply_error != null)).map(r => r.id);
    if (!ids.length) return undefined;
    let cancelled = false;
    (async () => {
      for (const rid of ids) {
        try {
          const applied = await isAdjustmentRequestApplied(rid);
          if (!cancelled) setAdjApplied(s => (s[rid] === applied ? s : { ...s, [rid]: applied }));
        } catch (e) {
          console.warn("[AdminOrdersTab] could not check whether request", rid, "is already applied:", e?.message || e);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [pendingAdjRequests]);

  // Deep link from the Notifications tab: scroll to + highlight that request.
  useEffect(() => {
    if (!focusAdjustRequestId) return;
    setAdjHighlightId(focusAdjustRequestId);
    let el = null;
    try { el = document.getElementById("adj-req-" + focusAdjustRequestId); }
    catch (e) { console.warn("[AdminOrdersTab] lookup of adjustment request card failed:", e?.message || e); }
    if (el) {
      try { if (el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" }); }
      catch (e) { console.warn("[AdminOrdersTab] scroll to adjustment request failed:", e?.message || e); }
      if (onAdjustFocusHandled) onAdjustFocusHandled();
      return undefined;
    }
    // Card not rendered (list still loading, or the request was already decided).
    const t = setTimeout(() => { if (onAdjustFocusHandled) onAdjustFocusHandled(); }, 5000);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusAdjustRequestId, pendingAdjRequests]);

  const handleApproveAdjustRequest = async (req) => {
    if (!req || adjBusyRef.current[req.id]) return;
    // A request the admin already started processing (audit written / error
    // recorded) is never blocked here by device-local guards: the helper decides
    // (finish-only when the invoice already carries the request, otherwise the
    // normal checks with the values passed below), and Reject stays available
    // unless the invoice already carries the change.
    const inProgress = req.pre_apply_order != null || req.last_apply_error != null;
    const cached = SHARED_INVOICES.getAll().find(i => i.id === req.invoice_id);
    if (!inProgress) {
      // Payment state is NOT stored in portal_orders, so nothing here can prove an
      // invoice is unpaid. These are mitigations: cache must know the invoice, the
      // commission list must be loaded, and the admin must confirm in Square.
      if (!cached) {
        setAdjReqError("This invoice is not in this device's invoice list, so its payment status cannot be checked. Reload the admin portal and try again.");
        return;
      }
      if (commissionIdsState !== "ok") {
        setAdjReqError(commissionIdsState === "error" ? "Commission records could not be loaded. Use Retry before approving." : "Checking commission records... try again in a moment.");
        return;
      }
      if (!adjNotPaidAck[req.id]) {
        setAdjReqError("Tick the box confirming you checked in Square / accounting that this invoice has not been paid.");
        return;
      }
      if (commissionPaidInvoiceIds.has(String(req.invoice_id)) && !adjCommissionAck[req.id]) {
        setAdjReqError("Tick the box confirming you understand the commission for this invoice was already paid and will not be re-calculated automatically.");
        return;
      }
    }
    const typedFinish = String(adjFinishText[req.id] || "").trim().toUpperCase() === "FINISH";
    if (adjNeedsAck[req.id] && !typedFinish) {
      setAdjReqError("Type FINISH in the box to finish this request as it stands.");
      return;
    }
    adjBusyRef.current[req.id] = true;
    setAdjReqBusy(b => ({ ...b, [req.id]: true }));
    setAdjReqError("");
    try {
      const { rows } = await approveAdjustmentRequest(req.id, {
        note: adjDecisionNote[req.id] || null,
        adminEmail: adminUserEmail || "",
        expectedUpdatedAt: req.updated_at,
        cacheStatus: cached ? (cached.status ?? "") : null,
        cacheFound: !!cached,
        confirmedUnpaid: !!adjNotPaidAck[req.id],
        acknowledgeDivergence: !!adjNeedsAck[req.id] && typedFinish,
      });
      // DB is the truth now; mirror it into this device's cache (idempotent).
      try { SHARED_INVOICES.applyAdjustment(rows); }
      catch (e) { console.warn("[AdminOrdersTab] SHARED_INVOICES.applyAdjustment local mirror failed:", e?.message || e); }
      setAdjDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      setAdjNeedsAck(s => { const n = { ...s }; delete n[req.id]; return n; });
      setAdjFinishText(s => { const n = { ...s }; delete n[req.id]; return n; });
      setAdjReqError("");
      // Record-on-action: correction line when this invoice commission was already paid
      // (fresh reads; a failure never undoes the approval, the scan stays the backstop).
      const cres = await recordCorrectionAfterAction({ invoiceId: req.invoice_id, reason: `Invoice adjusted (approved rep request ${req.id})`, source: "approved_adjustment", expect: "adjust" });
      if (cres.status === "failed") setActionNotice(cres.message);
    } catch (e) {
      console.warn("[AdminOrdersTab] approveAdjustmentRequest failed for", req.id, ":", e?.message || e);
      if (e && e.name === "PartialApplyError") {
        // The invoice rows may already carry the change while the request is still pending.
        setAdjReqError(`Approve for ${req.invoice_id} may be PARTLY applied: the invoice may already be updated but the request is still pending. Press Approve again to finish (it is safe to repeat), or contact a developer if it keeps failing. Recorded error: ${e.lastApplyError || e.message}`);
      } else if (e && e.needsAcknowledgement) {
        setAdjNeedsAck(s => ({ ...s, [req.id]: true }));
        setAdjReqError(e.message);
      } else {
        const msg = e?.message || "unknown error";
        // "Nothing was changed" only when the helper PROVED no invoice write happened.
        const suffix = e?.alreadyDecided ? "" : e?.nothingChanged === true ? " Nothing was changed on the invoice." : " The invoice may have been updated: press Approve again to check and finish, or refresh.";
        setAdjReqError(`Approve failed for ${req.invoice_id}: ${msg}${suffix}`);
      }
    } finally {
      // Wait for the refreshed request row (its updated_at moved) BEFORE the
      // busy flag clears, so an immediate retry never sends a stale updated_at.
      try { await refreshPendingAdjRequests(); }
      catch (e2) { console.warn("[AdminOrdersTab] refreshPendingAdjRequests after approve failed:", e2?.message || e2); }
      delete adjBusyRef.current[req.id];
      setAdjReqBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  const handleRejectAdjustRequest = async (req) => {
    if (!req || adjBusyRef.current[req.id]) return;
    if (!String(adjDecisionNote[req.id] || "").trim()) {
      setAdjReqError("A note is required to reject: the rep will see it.");
      return;
    }
    adjBusyRef.current[req.id] = true;
    setAdjReqBusy(b => ({ ...b, [req.id]: true }));
    setAdjReqError("");
    try {
      await rejectAdjustmentRequest(req.id, { note: adjDecisionNote[req.id], adminEmail: adminUserEmail || "" });
      setAdjDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      await refreshPendingAdjRequests();
    } catch (e) {
      console.warn("[AdminOrdersTab] rejectAdjustmentRequest failed for", req.id, ":", e?.message || e);
      // alreadyDecided (another admin / the rep got there first): plain readable note,
      // the list refresh below removes the card. Same treatment as the approve path.
      setAdjReqError(e?.alreadyDecided ? (e?.message || "This request was already decided.") : `Reject failed for ${req.invoice_id}: ${e?.message || "unknown error"}`);
      // The request row / applied state may have moved (an approve landed): reload.
      refreshPendingAdjRequests();
    } finally {
      delete adjBusyRef.current[req.id];
      setAdjReqBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  const refreshPendingVoidRequests = useCallback(async () => {
    try {
      const rows = await listInvoiceVoidRequests({ status: 'pending', limit: 200 });
      setPendingVoidRequests(rows || []);
      setVoidReqError("");
    } catch (e) {
      console.warn("[AdminOrdersTab] listInvoiceVoidRequests failed:", e?.message || e);
      setVoidReqError(e?.message || "Failed to load void requests.");
    }
  }, []);

  // Direct query that REPORTS failure (listRepCommissionPayments swallows errors
  // and returns [], which would look like "no commission paid"). On failure the
  // state becomes "error" (Approve stays disabled, Retry button) and the last
  // good set of ids is kept.
  const refreshCommissionPaidIds = useCallback(async () => {
    const res = await listCommissionPaidInvoiceIds();
    if (res.ok) {
      setCommissionPaidInvoiceIds(res.ids);
      setCommissionIdsState("ok");
    } else {
      console.warn("[AdminOrdersTab] commission-paid lookup failed:", res.error);
      setCommissionIdsState("error");
    }
  }, []);

  useEffect(() => { refreshPendingVoidRequests(); }, [refreshPendingVoidRequests]);
  useEffect(() => { refreshCommissionPaidIds(); },   [refreshCommissionPaidIds]);
  useEffect(() => {
    const unsub = subscribeRepCommissionPayments(() => { refreshCommissionPaidIds(); });
    return () => { if (unsub) unsub(); };
  }, [refreshCommissionPaidIds]);
  useEffect(() => {
    const unsub = subscribeInvoiceVoidRequests(() => { refreshPendingVoidRequests(); });
    return unsub;
  }, [refreshPendingVoidRequests]);

  const handleApproveVoidRequest = async (req, opts) => {
    if (!req || voidReqBusy[req.id]) return;
    setVoidReqBusy(b => ({ ...b, [req.id]: true }));
    try {
      // Read BEFORE approving: the local mirror below flips the cached invoice to
      // cancelled. This path never issues a refund, so a paid invoice is flagged
      // "manual" (never "not_applicable") for the admin to settle separately.
      const cachedInv = SHARED_INVOICES.getAll().find(i => i.id === req.invoice_id);
      const refundNeeded = !!cachedInv && refundPlan(snapshotForRefund(cachedInv)) !== "not_applicable";
      const out = await approveInvoiceVoidRequest(req.id, {
        note: voidDecisionNote[req.id] || (opts && opts.dismiss ? "Dismissed: the invoice was already cancelled." : null),
        adminEmail: adminUserEmail || "",
      });
      if (out && out.alreadyVoided) {
        // The invoice was already voided (portal_orders untouched by the helper).
        // Only the request was decided: the cache is left exactly as it is.
        setActionNotice(`The void request for ${req.invoice_id} was marked approved. The invoice had already been voided, so nothing on the invoice was changed (no second cancel reason, no refund status change).`);
      } else {
        // Local mirror: flip the invoice in SHARED_INVOICES so any open admin
        // view (this tab's invoice rows, the unshipped-orders banner) reflects
        // the cancellation without waiting for a hydrate.
        try {
          SHARED_INVOICES.cancel(req.invoice_id, {
            reason: `Void approved by admin (req:${req.id})${req.reason ? ` — rep reason: ${req.reason}` : ""}`,
            note: voidDecisionNote[req.id] || "",
            refundStatus: refundNeeded ? 'manual' : 'not_applicable',
          });
        } catch (e) {
          console.warn("[AdminOrdersTab] SHARED_INVOICES.cancel local mirror failed:", e?.message || e);
        }
      }
      // Record-on-action: correction line when this invoice's commission was already
      // paid (fresh reads; a failure never undoes the approval, the scan is the backstop).
      const cres = await recordCorrectionAfterAction({ invoiceId: req.invoice_id, reason: `Rep void request approved (req:${req.id})`, source: "approved_void", expect: "void" });
      if (cres.status === "failed") setActionNotice(cres.message);
      await refreshPendingVoidRequests();
      setVoidDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      setVoidReqError("");
    } catch (e) {
      console.warn("[AdminOrdersTab] approveInvoiceVoidRequest failed for", req.id, ":", e?.message || e);
      setVoidReqError(`Approve failed for ${req.invoice_id}: ${e?.message || "unknown error"}`);
    } finally {
      setVoidReqBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  // Dismiss a pending ADJUSTMENT request whose invoice is already cancelled: it
  // can never be applied, so the request is closed with a system note the rep sees.
  const handleDismissAdjustRequest = async (req) => {
    if (!req || adjBusyRef.current[req.id]) return;
    adjBusyRef.current[req.id] = true;
    setAdjReqBusy(b => ({ ...b, [req.id]: true }));
    setAdjReqError("");
    try {
      await rejectAdjustmentRequest(req.id, { note: "Dismissed: this invoice was already cancelled, so the adjustment can no longer be applied.", adminEmail: adminUserEmail || "" });
      await refreshPendingAdjRequests();
    } catch (e) {
      console.warn("[AdminOrdersTab] dismiss of adjustment request failed for", req.id, ":", e?.message || e);
      setAdjReqError(e?.alreadyDecided ? (e?.message || "This request was already decided.") : `Dismiss failed for ${req.invoice_id}: ${e?.message || "unknown error"}`);
      refreshPendingAdjRequests();
    } finally {
      delete adjBusyRef.current[req.id];
      setAdjReqBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  const handleRejectVoidRequest = async (req) => {
    if (!req || voidReqBusy[req.id]) return;
    setVoidReqBusy(b => ({ ...b, [req.id]: true }));
    try {
      await rejectInvoiceVoidRequest(req.id, {
        note: voidDecisionNote[req.id] || null,
        adminEmail: adminUserEmail || "",
      });
      await refreshPendingVoidRequests();
      setVoidDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      setVoidReqError("");
    } catch (e) {
      console.warn("[AdminOrdersTab] rejectInvoiceVoidRequest failed for", req.id, ":", e?.message || e);
      setVoidReqError(`Reject failed for ${req.invoice_id}: ${e?.message || "unknown error"}`);
    } finally {
      setVoidReqBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  // Deep-link target from the Notifications tab. When `focusInvoiceId` is
  // set on mount (or changes later), look the invoice up in SHARED_INVOICES
  // and open the invoice modal, then tell the parent we've handled it so
  // it clears the request. Guards against the invoice being unknown (rare
  // but possible if an admin manually cleared SHARED_INVOICES).
  useEffect(()=>{
    if(!focusInvoiceId) return;
    const inv = sharedInvs.find(x=>x.id===focusInvoiceId);
    if(inv){
      // Log already loaded and says removed: turn Show removed on right away.
      // Otherwise keep the id pending for the effect below (log still loading).
      if(removedMap[inv.id]) { setShowRemoved(true); deepLinkRef.current = null; }
      else deepLinkRef.current = removals.loaded ? null : inv.id;
      setViewFieldInvoice(inv);
    }
    else { console.warn("AdminOrdersTab: focus invoice id not found in SHARED_INVOICES:", focusInvoiceId); }
    if(onFocusHandled) onFocusHandled();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[focusInvoiceId, sharedInvs, onFocusHandled]);
  // The focus id is cleared immediately above, but the removal log may load
  // AFTER that. Re-evaluate whenever the removals change so a deep link to a
  // removed order still turns on Show removed once we know it is removed.
  useEffect(()=>{
    const id = deepLinkRef.current;
    if(!id) return;
    if(removedMap[id]) { setShowRemoved(true); deepLinkRef.current = null; }
    else if(removals.loaded) deepLinkRef.current = null;
  },[removedMap, removals.loaded]);
  // NOTE: we preserve payment_pending / cancelled statuses verbatim so the
  // status column + stat cards show them distinctly. Paid rolls up to "done"
  // to match the legacy order-status color/label scheme used by StatusLabel.
  // Customer-placed orders + rep field invoices live in SHARED_INVOICES and
  // need to expose their tracking / shipping fields so admin can edit them
  // from this tab. Without copying these from _raw, a customer order's
  // tracking info is invisible in the Orders row even after saveShipping
  // persists it to SHARED_INVOICES.
  const fieldInvoices = sharedInvs.map(inv=>({
    id:inv.id, date:inv.date, amount:Number(inv.total||0),
    status: inv.shippingStatus==="delivered" ? "done"
          : inv.status==="paid" ? "done"
          : inv.status==="cancelled" ? "cancelled"
          : inv.status==="payment_pending" ? "payment_pending"
          : inv.shippingStatus==="shipped" || inv.tracking ? "transit"
          : "pending",
    items:Array.isArray(inv.items)?inv.items.map(i=>`${i.name} ×${i.qty}`).join(", "):"—",
    account:inv.customer||"—",
    tracking:inv.tracking||"", carrier:inv.carrier||"", shippedDate:inv.shippedDate||"", notes:inv.notes||"",
    shippingStatus:inv.shippingStatus||"",
    isFieldInvoice:true, _raw:inv
  }));
  // Deduplicate: don't show field invoices whose id already appears in orders
  const orderIds = new Set(orders.map(o=>o.id));
  const uniqueFieldInvs = fieldInvoices.filter(fi=>!orderIds.has(fi.id));
  const allOrders = [...orders,...uniqueFieldInvs];
  // Removed orders (admin soft hide). Demo RECENT_ORDERS are never removable.
  // Stat cards, awaiting banner, account filter and counts use the VISIBLE
  // list; the table itself adds the removed rows back only when Show removed
  // is on. allOrders stays complete for detail lookups.
  const isRemovedOrder = (o) => !!(o && o.isFieldInvoice && isInvoiceRemoved(o, removedMap));
  const visibleOrders = allOrders.filter(o=>!isRemovedOrder(o));
  const visibleFieldInvs = uniqueFieldInvs.filter(o=>!isRemovedOrder(o));
  const listBase = showRemoved ? allOrders : visibleOrders;

  const [orderSort,setOrderSort]=useState({key:"date",dir:"desc"});
  const oSortBy=(key)=>setOrderSort(s=>({key,dir:s.key===key&&s.dir==="asc"?"desc":"asc"}));
  const oSortArrow=(key)=>orderSort.key===key?(orderSort.dir==="asc"?" ^":" v"):"";
  // Moved up from below: the Overdue-payments card filter needs this map,
  // and JS const declarations can't be referenced before their line.
  const overdueById = {};
  (overdueInvoices||[]).forEach(inv=>{ overdueById[inv.id] = daysOverdue(inv); });
  const matchesFilters = (o)=>{
    if(acctFilter!=="all" && o.account!==acctFilter) return false;
    // Top-bar card filter (see listFilter state + card onClick handlers below).
    if(listFilter==="field"      && !o.isFieldInvoice) return false;
    if(listFilter==="transit"    && o.status!=="transit") return false;
    if(listFilter==="awaiting"   && o.status!=="payment_pending") return false;
    if(listFilter==="delivered"  && o.status!=="done") return false;
    if(listFilter==="overdue")   {
      const invId = o._raw?.id || (o.isFieldInvoice ? o.id : null);
      if (!invId || !(overdueById[invId] > 0)) return false;
    }
    if(remitFilter) {
      const rid = o._raw?.id || (o.isFieldInvoice ? o.id : null);
      if(!matchesRemitFilter(o._raw || (rid ? {id:rid} : null), remitActiveIds, remitFilter)) return false;
    }
    if(search.trim()){
      const q=search.toLowerCase();
      return o.id.toLowerCase().includes(q)||(typeof o.items==="string"?o.items:"").toLowerCase().includes(q)||o.account.toLowerCase().includes(q)||(o.tracking||"").toLowerCase().includes(q);
    }
    return true;
  };
  // "Show removed (N)": N counts removed orders that match the CURRENT
  // filters (account, card filter, search), not the global total (F10).
  const removedCount = allOrders.filter(o=>isRemovedOrder(o) && matchesFilters(o)).length;
  const filtered = listBase.filter(matchesFilters).sort((a,b)=>{
    const k=orderSort.key;const dir=orderSort.dir==="asc"?1:-1;
    if(k==="date")return dir*(new Date(a.date||0)-new Date(b.date||0));
    if(k==="amount")return dir*((a.amount||0)-(b.amount||0));
    if(k==="status")return dir*(a.status||"").localeCompare(b.status||"");
    if(k==="account")return dir*(a.account||"").localeCompare(b.account||"");
    return 0;
  });

  const saveShipping = (orderId) => {
    const today = new Date().toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
    const order = allOrders.find(o=>o.id===orderId);
    // Field invoices (customer-placed orders + rep field invoices) live in
    // SHARED_INVOICES. Calling setOrders on them does nothing — we have to
    // write through to the shared store so the rep portal + customer portal
    // both see the tracking info. The subscribe hook above refreshes this
    // tab's row on the next tick.
    if(order?.isFieldInvoice) {
      SHARED_INVOICES.updateShipping(order.id, {
        tracking: shipForm.tracking || "",
        carrier: shipForm.carrier || "",
        notes: shipForm.notes || "",
        shippedDate: today,
      });
      // Also persist to Supabase so the dealer + rep see it on any device.
      // Local SHARED_INVOICES is per-browser; without this write, admin
      // tracking edits never reach the dealer's other browser/phone.
      const raw = order._raw || {};
      updatePortalOrderShipping(
        { invoiceId: raw.id || order.id, orderId: raw.orderId || "" },
        {
          tracking: shipForm.tracking || "",
          carrier: shipForm.carrier || "",
          shippedDate: today,
          shippingStatus: shipForm.tracking ? "shipped" : "pending",
          notes: shipForm.notes || "",
        }
      ).catch(e => console.warn("Admin saveShipping DB sync:", e?.message || e));
    } else {
      // Demo / legacy RECENT_ORDERS rows that aren't in SHARED_INVOICES —
      // keep the existing local-state update so the admin tab still shows
      // tracking on them.
      setOrders(os=>os.map(o=>o.id===orderId?{...o,...shipForm,shippedDate:today,status:shipForm.tracking?"transit":o.status}:o));
    }
    setEditShipping(null);
    // Email customer when order is shipped with tracking
    if(shipForm.tracking && order) {
      const custAcct = accounts.find(a=>a.company===order.account);
      if(custAcct && custAcct.email) {
        emailOrderShipped({
          customerName:custAcct.contact||custAcct.company, customerEmail:custAcct.email,
          orderId:order.id, trackingNumber:shipForm.tracking, carrier:shipForm.carrier||"",
          estimatedDelivery:"", items:order.items
        });
      }
    }
  };

  const markDelivered = (orderId) => {
    const order = allOrders.find(o=>o.id===orderId);
    const today = new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
    // Same branching as saveShipping: field invoices must go through
    // SHARED_INVOICES so the customer and rep portals also see "delivered".
    if(order?.isFieldInvoice) {
      SHARED_INVOICES.markDelivered(order.id);
      const raw = order._raw || {};
      updatePortalOrderShipping(
        { invoiceId: raw.id || order.id, orderId: raw.orderId || "" },
        { shippingStatus: "delivered", deliveredDate: today }
      ).catch(e => console.warn("Admin markDelivered DB sync:", e?.message || e));
    } else {
      setOrders(os=>os.map(o=>o.id===orderId?{...o,status:"done"}:o));
    }
  };

  // ── Order cancellation ──────────────────────────────────────────────────
  // Admin-initiated cancel with reason picker + optional note + automated refund
  // for card/ACH invoices. Demo RECENT_ORDERS don't have a matching invoice so
  // only field-invoice / portal-order rows can be cancelled here.
  const [cancelFor,setCancelFor]=useState(null);
  const [cancelReason,setCancelReason]=useState("");
  const [cancelNote,setCancelNote]=useState("");
  const [cancelBusy,setCancelBusy]=useState(false);
  const [cancelError,setCancelError]=useState("");
  const [cancelAlsoRemove,setCancelAlsoRemove]=useState(false);
  const [cancelRemoveReason,setCancelRemoveReason]=useState("");

  const openCancel = (order) => {
    setCancelFor(order);
    setCancelReason("");   // no default: admin must pick a reason
    setCancelNote("");
    setCancelError("");
    setCancelAlsoRemove(false);
    setCancelRemoveReason("");
  };
  const closeCancel = () => {
    if (cancelBusy) return;
    setCancelFor(null); setCancelError(""); setCancelNote("");
    setCancelAlsoRemove(false); setCancelRemoveReason("");
  };

  // ── Remove (soft hide of a voided order) / Restore ───────────────────────
  const [removeFor,setRemoveFor]=useState(null);
  const [removeReason,setRemoveReason]=useState("");
  const [removeBusy,setRemoveBusy]=useState(false);
  const [removeError,setRemoveError]=useState("");
  const openRemove = (order) => { setRemoveFor(order); setRemoveReason(""); setRemoveError(""); };
  const closeRemove = () => { if (removeBusy) return; setRemoveFor(null); setRemoveError(""); setRemoveReason(""); };
  const removalSnapshot = (inv, prevStatus) => ({
    id: inv.id, orderId: inv.orderId || null, customer: inv.customer || null, total: Number(inv.total||0),
    status: prevStatus || inv.status || null, rep: inv.rep || null, date: inv.date || null,
    cancelReason: inv.cancelReason || null, cancelledDate: inv.cancelledDate || null,
  });
  const submitRemove = async () => {
    if (!removeFor) return;
    if (!removeReason.trim()) { setRemoveError("Please enter a reason for removing this order."); return; }
    const inv = sharedInvs.find(x=>x.id===(removeFor._raw?.id || removeFor.id));
    if (!inv) { setRemoveError("Invoice not found"); return; }
    setRemoveBusy(true); setRemoveError("");
    try {
      const res = await insertOrderRemoval({
        invoiceRef: inv.id, orderRef: inv.orderId || "", action: "remove",
        reason: removeReason, actor: adminUserEmail || "", snapshot: removalSnapshot(inv),
        cachedStatus: inv.status,
      });
      if (!res.ok) { setRemoveError(res.reason || "Could not remove the order."); return; }
      applyLocalRemovalEvent(res.event);
      setRemoveFor(null); setRemoveReason("");
      setViewOrder(null); setViewFieldInvoice(null);
      setActionNotice("");
    } catch (e) {
      console.warn("[AdminOrdersTab] submitRemove failed:", e?.message || e);
      setRemoveError(e?.message || "Could not remove the order.");
    } finally {
      setRemoveBusy(false);
    }
  };
  const restoreOrder = async (o) => {
    const inv = o?._raw || sharedInvs.find(x=>x.id===o?.id);
    if (!inv) return;
    if (restoringId || restoreLockRef.current) return;   // F7: one restore at a time (ref closes the same-tick double-click window)
    restoreLockRef.current = true;
    setRestoringId(inv.id);
    setActionNotice("");
    try {
      const res = await insertOrderRemoval({
        invoiceRef: inv.id, orderRef: inv.orderId || "", action: "restore",
        reason: "Restored to Orders list", actor: adminUserEmail || "", snapshot: removalSnapshot(inv),
        cachedStatus: inv.status,
      });
      if (!res.ok) { setActionNotice("Restore failed: " + (res.reason || "unknown error")); return; }
      applyLocalRemovalEvent(res.event);
    } catch (e) {
      console.warn("[AdminOrdersTab] restoreOrder failed:", e?.message || e);
      setActionNotice("Restore failed: " + (e?.message || "unknown error"));
    } finally {
      restoreLockRef.current = false;
      setRestoringId(null);
    }
  };

  const submitCancel = async () => {
    if (!cancelFor) return;
    const invId = cancelFor._raw?.id || cancelFor.id;
    const inv = sharedInvs.find(x=>x.id===invId);
    if (!inv) { setCancelError("Invoice not found"); return; }
    const reasonErr = validateVoidReason(cancelReason, cancelNote);
    if (reasonErr) { setCancelError(reasonErr); return; }
    if (cancelAlsoRemove && !cancelRemoveReason.trim()) { setCancelError("Please enter a reason for removing the order from the list, or untick the remove option."); return; }
    setCancelBusy(true); setCancelError("");
    try {
      // The whole void (F1 snapshot, Supabase-first cancel, refund, mirror, email,
      // optional remove) lives in the shared performAdminVoid (src/adminVoid.js),
      // also used by the Commission tab Delete button.
      const res = await performAdminVoid({
        inv, reason: cancelReason, note: cancelNote,
        acct: accounts?.find(a=>a.company===cancelFor.account),
        accountName: cancelFor.account, displayId: cancelFor.id, displayAmount: cancelFor.amount,
        alsoRemove: cancelAlsoRemove, removeReason: cancelRemoveReason, adminEmail: adminUserEmail,
      });
      // The void may have reached the database even when a later step threw (res.ok false):
      // same rule as the Commission-tab Delete. Only a void that never reached it is a failure.
      if (!adminVoidedInDb(res)) { setCancelError(res.error || "Cancellation failed"); return; }
      // Record-on-action: if this invoice's commission was already paid, record the
      // correction line now (fresh reads, never blocks or undoes the void). A local-only
      // void (no database row) has no ledger entry to correct.
      let corrNote = "";
      if (!voidLocalOnly(res)) {
        const cres = await recordCorrectionAfterAction({ invoiceId: invId, reason: "Invoice voided by admin: " + cancelReason, source: "orders_void", expect: "void" });
        if (cres.status === "failed") corrNote = cres.message;
      }
      const partialNote = res.ok ? "" : `Order ${invId} was voided in the database, but a later step failed: ${res.error}`;
      setActionNotice([partialNote, res.noticeText, corrNote].filter(Boolean).join(" "));

      setCancelFor(null);
      setCancelNote("");
      setCancelAlsoRemove(false); setCancelRemoveReason("");
      setViewOrder(null);
      setViewFieldInvoice(null);
    } finally {
      setCancelBusy(false);
    }
  };

  // (overdueById lookup moved above the filter section — see comment there.)

  const carrierTrackUrl = (carrier,tracking) => {
    if(!tracking) return null;
    if(carrier==="UPS") return `https://www.ups.com/track?tracknum=${tracking}`;
    if(carrier==="FedEx"||carrier==="FedEx Freight") return `https://www.fedex.com/fedextrack/?trknbr=${tracking}`;
    if(carrier==="USPS") return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}`;
    return null;
  };

  // Banner shown for a removed order in BOTH detail branches (order detail and
  // the invoice view reached by deep link / notification Review / View PDF).
  const renderRemovedBanner = (o) => {
    if(!isRemovedOrder(o)) return null;
    const ev = removedMap[o.id];
    const restoring = restoringId===o.id;
    return (
      <div style={{background:"#F3F4F6",border:"1px solid #D1D5DB",borderRadius:10,padding:"14px 18px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:"#374151",marginBottom:4}}>Removed from the Orders list{ev?.created_at?` on ${new Date(ev.created_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"})}`:""}{ev?.actor?` by ${ev.actor}`:""}</div>
          {ev?.reason && <div style={{fontSize:12,color:"#374151"}}>Reason: {ev.reason}</div>}
          <div style={{fontSize:11,color:"#6B7280",marginTop:4}}>Hidden from admin lists only. Reps and dealers still see this order as Cancelled.</div>
        </div>
        <button style={{...S.btnSecondary,opacity:restoring?0.6:1}} disabled={!!restoringId} onClick={()=>restoreOrder(o)}>{restoring?"Restoring...":"Restore"}</button>
      </div>
    );
  };
  // F6: display-only warning for a cancelled card/ACH invoice with no refund record.
  const renderNoRefundNote = (inv) => cancelledWithoutRefundRecord(inv) ? (
    <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginTop:8}}>
      No refund is recorded on this device for this cancelled card/ACH invoice. Verify in Square / accounting whether a refund is still owed.
    </div>
  ) : null;

  if(viewFieldInvoice) {
    const canCancel = viewFieldInvoice.status !== "cancelled" && viewFieldInvoice.status !== "paid" ? true : viewFieldInvoice.status === "paid";
    const fakeOrder = { id: viewFieldInvoice.id, invoiceId: viewFieldInvoice.id, account: viewFieldInvoice.customer, amount: viewFieldInvoice.total||0, _raw: viewFieldInvoice, isFieldInvoice: true };
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <button style={S.btnGhost} onClick={()=>setViewFieldInvoice(null)}>← Back to orders</button>
          {canCancel && viewFieldInvoice.status!=="cancelled" && <button style={S.btnDanger} onClick={()=>openCancel(fakeOrder)}>Void order</button>}
          {viewFieldInvoice.status==="cancelled" && !removedMap[viewFieldInvoice.id] && <button style={S.btnSecondary} onClick={()=>openRemove(fakeOrder)}>Remove from list</button>}
        </div>
        <AdminInvoiceModal inv={viewFieldInvoice} onClose={()=>setViewFieldInvoice(null)} onStatusChange={()=>{/* SHARED_INVOICES.subscribe on parent auto-refreshes */}}
          topSlot={(actionNotice || isRemovedOrder(fakeOrder) || cancelledWithoutRefundRecord(viewFieldInvoice)) ? (
            <>
              {actionNotice && <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12}}>{actionNotice}</div>}
              {renderRemovedBanner(fakeOrder)}
              {renderNoRefundNote(viewFieldInvoice)}
            </>
          ) : null}/>
        {cancelFor && cancelFor.id===viewFieldInvoice.id && (
          <CancelOrderModal
            order={cancelFor}
            invoice={sharedInvs.find(x=>x.id===viewFieldInvoice.id)}
            reason={cancelReason} setReason={setCancelReason}
            note={cancelNote} setNote={setCancelNote}
            busy={cancelBusy} error={cancelError}
            onClose={closeCancel} onSubmit={submitCancel}
            commissionPaid={commissionPaidInvoiceIds.has(String(viewFieldInvoice.id))}
            alsoRemove={cancelAlsoRemove} setAlsoRemove={setCancelAlsoRemove}
            removeReason={cancelRemoveReason} setRemoveReason={setCancelRemoveReason}
          />
        )}
        {removeFor && removeFor.id===viewFieldInvoice.id && (
          <RemoveOrderModal order={removeFor} reason={removeReason} setReason={setRemoveReason} busy={removeBusy} error={removeError} onClose={closeRemove} onSubmit={submitRemove}/>
        )}
      </div>
    );
  }

  if(viewOrder) {
    const o = allOrders.find(x=>x.id===viewOrder);
    if(!o) return null;
    const acct = accounts?.find(a=>a.company===o.account);
    const trackUrl = carrierTrackUrl(o.carrier,o.tracking);
    return (
      <div>
        <button style={{...S.btnGhost,marginBottom:16}} onClick={()=>setViewOrder(null)}>← Back to orders</button>
        <div style={{...S.card,padding:"24px 28px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:20}}>
            <div>
              <div style={{fontSize:20,fontWeight:600,color:C.ink}}>{o.id}</div>
              <div style={{fontSize:13,color:C.inkLight,marginTop:4}}>Placed on {o.date}</div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <StatusLabel s={o._raw?.status==="cancelled"?"cancelled":o.status}/>
              {/* For field invoices, expose the printable invoice PDF that
                  used to be the only thing View showed. The tracking UI
                  lives on THIS page — this button is just for when admin
                  wants the PDF/print view. */}
              {o.isFieldInvoice && o._raw && <button style={S.btnSecondary} onClick={()=>setViewFieldInvoice(o._raw)}>View invoice PDF</button>}
              {o._raw?.status!=="cancelled" && o.status!=="done" && <button style={S.btnSuccess} onClick={()=>markDelivered(o.id)}>Mark delivered</button>}
              {o.isFieldInvoice && o._raw && o._raw.status!=="cancelled" && o.status!=="done" && <button style={S.btnDanger} onClick={()=>openCancel(o)}>Void order</button>}
              {o.isFieldInvoice && o._raw && o._raw.status==="cancelled" && !removedMap[o.id] && <button style={S.btnSecondary} onClick={()=>openRemove(o)}>Remove from list</button>}
            </div>
          </div>
          {actionNotice && <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:16}}>{actionNotice}</div>}
          {renderRemovedBanner(o)}
          {o._raw?.status==="cancelled" && (
            <div style={{background:C.redLight,border:`1px solid ${C.red}`,borderRadius:10,padding:"14px 18px",marginBottom:20}}>
              <div style={{fontSize:13,fontWeight:600,color:C.red,marginBottom:4}}>Order cancelled{o._raw.cancelledDate?` on ${o._raw.cancelledDate}`:""}</div>
              {o._raw.cancelReason && <div style={{fontSize:12,color:C.red}}>Reason: {o._raw.cancelReason}</div>}
              {o._raw.cancelNote && <div style={{fontSize:12,color:C.red,marginTop:2}}>Note: {o._raw.cancelNote}</div>}
              {o._raw.refundStatus==="refunded" && (
                <div style={{fontSize:12,color:"#166534",marginTop:6}}>
                  Refund issued{o._raw.refundMethod?` to ${o._raw.refundMethod}`:""}{o._raw.refundLast4?` ··${o._raw.refundLast4}`:""}{o._raw.refundTransactionId?` · ${o._raw.refundTransactionId}`:""}
                </div>
              )}
              {o._raw.refundStatus==="manual" && <div style={{fontSize:12,color:C.amber,marginTop:6}}>Refund required — process manually via accounting.</div>}
              {o._raw.refundStatus==="failed" && <div style={{fontSize:12,color:C.red,marginTop:6}}>Refund attempt failed — accounting must follow up.</div>}
              {o._raw.refundStatus==="not_applicable" && <div style={{fontSize:12,color:C.inkLight,marginTop:6}}>No refund issued (invoice was unpaid).</div>}
              {renderNoRefundNote(o._raw)}
            </div>
          )}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
            <div style={{...S.card,padding:16}}>
              <div style={{fontSize:11,fontWeight:600,color:C.inkLight,marginBottom:8}}>ACCOUNT</div>
              <div style={{fontSize:14,fontWeight:500,color:C.ink}}>{o.account}</div>
              {acct&&<><div style={{fontSize:12,color:C.inkLight,marginTop:4}}>{acct.contact} · {acct.email}</div>
              <div style={{fontSize:12,color:C.inkLight}}>{acct.address}</div>
              <div style={{marginTop:6}}><span style={S.pillBlue}>{acct.tier}</span></div></>}
            </div>
            <div style={{...S.card,padding:16}}>
              <div style={{fontSize:11,fontWeight:600,color:C.inkLight,marginBottom:8}}>ORDER SUMMARY</div>
              <div style={{fontSize:22,fontWeight:600,color:C.ink}}>${o.amount.toLocaleString()}</div>
              <div style={{fontSize:12,color:C.inkLight,marginTop:4}}>Status: {o.status==="done"?"Delivered":o.status==="transit"?"In transit":"Processing"}</div>
              {acct?.rep&&<div style={{fontSize:12,color:C.inkLight,marginTop:2}}>Rep: {acct.rep}</div>}
            </div>
          </div>

          {/* Shipping & tracking */}
          <div style={{...S.card,padding:16,marginBottom:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:12,fontWeight:600,color:C.ink}}>Shipping & tracking</div>
              {/* Field invoices use the Ship Now modal (3 options: carrier /
                  rep delivered / notes only) — matches the new unified flow.
                  Demo RECENT_ORDERS (no _raw) still use the legacy inline
                  form via editShipping since they're not in SHARED_INVOICES. */}
              {o.isFieldInvoice
                ? <button style={{background:C.green,border:`1px solid ${C.green}`,color:"#fff",fontSize:12,padding:"6px 14px",borderRadius:6,fontWeight:600,cursor:"pointer"}} onClick={()=>setShipNowFor(o)}>
                    {o._raw?.shippingStatus==="shipped" || o._raw?.shippingStatus==="delivered" ? "Update shipping" : "Ship Now"}
                  </button>
                : <button style={S.btnSmall} onClick={()=>{setShipForm({tracking:o.tracking||"",carrier:o.carrier||"UPS",notes:o.notes||""});setEditShipping(o.id);}}>
                    {o.tracking?"Edit tracking":"Add tracking"}
                  </button>}
            </div>
            {o.tracking?(
              <div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                  <div><div style={{fontSize:10,color:C.inkLight}}>Carrier</div><div style={{fontSize:13,fontWeight:500,color:C.ink}}>{o.carrier}</div></div>
                  <div><div style={{fontSize:10,color:C.inkLight}}>Tracking #</div>
                    {trackUrl?<a href={trackUrl} target="_blank" rel="noopener noreferrer" style={{fontSize:13,fontWeight:500,color:C.blue,textDecoration:"none"}}>{o.tracking}</a>
                    :<div style={{fontSize:13,fontWeight:500,color:C.ink}}>{o.tracking}</div>}
                  </div>
                  <div><div style={{fontSize:10,color:C.inkLight}}>Shipped</div><div style={{fontSize:13,fontWeight:500,color:C.ink}}>{o.shippedDate||"—"}</div></div>
                </div>
                {o.notes&&<div style={{marginTop:8,fontSize:12,color:C.inkLight}}>Notes: {o.notes}</div>}
              </div>
            ):(
              <div style={{fontSize:12,color:C.inkLight}}>No tracking information added yet</div>
            )}
          </div>

          {/* Edit shipping modal */}
          {editShipping===o.id&&(
            <div style={{...S.card,padding:16,marginBottom:20,background:C.blueLight,border:`1px solid ${C.blue}`}}>
              <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:10}}>Update shipping info</div>
              <div style={S.twoCol}>
                <div style={S.fg}><label style={S.label}>Carrier</label><select style={S.select} value={shipForm.carrier} onChange={e=>setShipForm(f=>({...f,carrier:e.target.value}))}>{CARRIERS.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
                <div style={S.fg}><label style={S.label}>Tracking number</label><input style={S.input} value={shipForm.tracking} onChange={e=>setShipForm(f=>({...f,tracking:e.target.value}))} placeholder="1Z999AA10123456784"/></div>
              </div>
              <div style={S.fg}><label style={S.label}>Shipping notes (optional)</label><input style={S.input} value={shipForm.notes} onChange={e=>setShipForm(f=>({...f,notes:e.target.value}))} placeholder="Partial shipment, backorder on DPF cleaner..."/></div>
              <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                <button style={S.btnSecondary} onClick={()=>setEditShipping(null)}>Cancel</button>
                <button style={S.btnPrimary} onClick={()=>saveShipping(o.id)}>Save tracking</button>
              </div>
            </div>
          )}

          <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:8}}>Items</div>
          <div style={S.card}>
            {(typeof o.items==="string"?o.items.split(", "):["—"]).map((item,i)=>(
              <div key={i} style={{padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:13,color:C.ink,display:"flex",justifyContent:"space-between"}}>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
        {cancelFor && cancelFor.id===o.id && (
          <CancelOrderModal
            order={cancelFor}
            invoice={sharedInvs.find(x=>x.id===(cancelFor._raw?.id || cancelFor.id))}
            reason={cancelReason} setReason={setCancelReason}
            note={cancelNote} setNote={setCancelNote}
            busy={cancelBusy} error={cancelError}
            onClose={closeCancel} onSubmit={submitCancel}
            commissionPaid={commissionPaidInvoiceIds.has(String(o.id))}
            alsoRemove={cancelAlsoRemove} setAlsoRemove={setCancelAlsoRemove}
            removeReason={cancelRemoveReason} setRemoveReason={setCancelRemoveReason}
          />
        )}
        {removeFor && removeFor.id===o.id && (
          <RemoveOrderModal order={removeFor} reason={removeReason} setReason={setRemoveReason} busy={removeBusy} error={removeError} onClose={closeRemove} onSubmit={submitRemove}/>
        )}
        {/* Ship Now / Update shipping modal — also rendered on the order-
            LIST view below (same shipNowFor state). Without this, clicking
            "Update shipping" from the order-DETAIL page (this branch,
            reached via viewOrder) set shipNowFor but the component's early
            `return` here meant the modal JSX further down was never reached
            — the button appeared to do nothing. Mirrors the CancelOrderModal
            pattern immediately above. */}
        {shipNowFor && shipNowFor.id===o.id && (
          <ShipNowModal
            order={shipNowFor}
            accounts={accounts}
            onClose={()=>setShipNowFor(null)}
            onCompleted={()=>{
              // SHARED_INVOICES.subscribe refresh handles same-browser rerender;
              // explicit refresh here covers the portal_orders-only case.
              setSharedInvs(SHARED_INVOICES.getAll());
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div>
      {overdueInvoices && overdueInvoices.length>0 && (
        <div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:600,color:"#B91C1C"}}>{overdueInvoices.length} invoice{overdueInvoices.length>1?"s":""} overdue — ${overdueTotal.toFixed(2)} unpaid</div>
          <div style={{fontSize:11,color:"#991B1B",marginTop:2}}>Customers have passed their Net-term due date without payment. Flagged rows below.</div>
        </div>
      )}
      {(() => {
        const awaitingConfirm = visibleOrders.filter(o=>o.status==="payment_pending");
        return (
          <>
            {actionNotice && <div style={{fontSize:12,color:"#92400E",background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:16}}>{actionNotice}</div>}
            {awaitingConfirm.length>0 && (
              <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:12,padding:"12px 18px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"#92400E"}}>{awaitingConfirm.length} invoice{awaitingConfirm.length>1?"s":""} awaiting your payment confirmation</div>
                  <div style={{fontSize:11,color:"#92400E",marginTop:2}}>Customers reported sending wire / check payments. Open each invoice below and confirm once funds arrive.</div>
                </div>
              </div>
            )}
            {/* Pending invoice ADJUSTMENT requests — rep-filed (migration 0028).
                Shows a before/after diff. Nothing changes on the invoice until
                Approve; Approve applies one compare-and-set UPDATE of
                portal_orders items / total / payment terms only. */}
            {pendingAdjRequests.length > 0 && (
              <div style={{background:"#DBEAFE",border:"1px solid #93C5FD",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
                <div style={{marginBottom:10}}>
                  <div style={{fontSize:13,fontWeight:600,color:"#1E40AF"}}>
                    {pendingAdjRequests.length} adjustment request{pendingAdjRequests.length===1?"":"s"} from sales reps
                  </div>
                  <div style={{fontSize:11,color:"#1E40AF",marginTop:2}}>Approve to change the invoice lines and total exactly as shown. Reject to keep the invoice as is (a note is required and the rep will see it).</div>
                </div>
                {adjReqError && (
                  <div style={{background:C.redLight,color:C.red,fontSize:12,padding:"8px 12px",borderRadius:8,marginBottom:10}}>{adjReqError}</div>
                )}
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {pendingAdjRequests.map(req => {
                    const busy = !!adjReqBusy[req.id];
                    const snap = (req.original_snapshot && typeof req.original_snapshot === 'object') ? req.original_snapshot : {};
                    const prop = (req.proposed_changes && typeof req.proposed_changes === 'object') ? req.proposed_changes : {};
                    const oldItems = parseInvItems(snap.items);
                    const newItems = parseInvItems(prop.items);
                    const diffRows = diffItems(oldItems, newItems);
                    const oldTotal = Number(snap.total) || 0;
                    const newTotal = Number(prop.total) || 0;
                    const termsChanged = prop.paymentTerms && snap.paymentTerms && prop.paymentTerms !== snap.paymentTerms;
                    const commissionPaid = commissionPaidInvoiceIds.has(String(req.invoice_id));
                    const cached = sharedInvs.find(i => i.id === req.invoice_id);
                    const cst = String(cached?.status || "").toLowerCase();
                    const blockedByPayment = cst === "paid" || cst === "payment_pending" || cst === "done";
                    const blockedByCancel = cst === "cancelled";
                    // Payment state lives only in each device's cache (never in portal_orders),
                    // so these are mitigations: cache must know the invoice, its status class
                    // must equal what the rep saw, and the commission list must have loaded.
                    const blockedNoCache = !cached;
                    const blockedStatusDiff = !!cached && !blockedByPayment && !blockedByCancel && snap.status != null && snap.status !== "" && statusClass(snap.status) !== statusClass(cached.status);
                    const checkingCommission = commissionIdsState === "loading";
                    const commissionLoadFailed = commissionIdsState === "error";
                    const shipped = !!cached && (["shipped","delivered"].includes(String(cached.shippingStatus||"").toLowerCase()) || !!String(cached.tracking||cached.trackingNumber||"").trim());
                    const otherPendingVoid = pendingVoidRequests.some(v => v && v.invoice_id === req.invoice_id);
                    const otherPendingAdj = pendingAdjRequests.some(a => a && a.invoice_id === req.invoice_id && a.id !== req.id);
                    // A request the admin already started processing is never blocked by
                    // device-local guards (the helper decides). If the invoice already carries
                    // the change (finishMode) only "Finish approval" is legal: Reject is refused.
                    const inProgress = req.pre_apply_order != null || req.last_apply_error != null;
                    const finishMode = adjApplied[req.id] === true;
                    // Reject is refused by the database while an apply is in progress or applied:
                    // marker on an order row (finishMode) OR audit written with no failure recorded.
                    const rejectBlocked = finishMode || applyInProgressByFields(req);
                    const needsAck = !!adjNeedsAck[req.id];
                    const typedFinish = String(adjFinishText[req.id] || "").trim().toUpperCase() === "FINISH";
                    const approveDisabled = busy || (needsAck && !typedFinish) || (!inProgress && (blockedByPayment || blockedByCancel || blockedNoCache || blockedStatusDiff || checkingCommission || commissionLoadFailed));
                    const nm = s => String(s || "").trim().toLowerCase().replace(/\./g, "");
                    const repMismatch = !!(cached && cached.rep && req.rep_name && nm(cached.rep).split(" ")[0] !== nm(req.rep_name).split(" ")[0]);
                    const kindStyle = { added:{bg:"#DCFCE7",tag:"Added"}, removed:{bg:"#FEE2E2",tag:"Removed"}, changed:{bg:"#FEF3C7",tag:"Changed"}, unchanged:{bg:"transparent",tag:""} };
                    return (
                      <div key={req.id} id={"adj-req-"+req.id} style={{background:"#fff",border:`${adjHighlightId===req.id?2:1}px solid ${adjHighlightId===req.id?"#2563EB":C.border}`,borderRadius:10,padding:"10px 14px"}}>
                        <div style={{display:"grid",gridTemplateColumns:"1.2fr 1fr 2fr",gap:10,alignItems:"flex-start",fontSize:12,marginBottom:8}}>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Invoice</div>
                            <div style={{fontWeight:600,color:C.ink,fontFamily:"monospace"}}>{req.invoice_id}</div>
                            <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{req.customer || snap.customer || "—"}</div>
                          </div>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Rep</div>
                            <div style={{color:C.ink}}>{req.rep_name || req.rep_email || "—"}</div>
                            <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{req.created_at ? new Date(req.created_at).toLocaleString() : ""}</div>
                          </div>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Rep&rsquo;s reason</div>
                            <div style={{color:C.inkMid,fontSize:12}}>{req.reason || "(no reason given)"}</div>
                          </div>
                        </div>
                        <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",marginBottom:8,fontSize:12}}>
                          <div style={{display:"grid",gridTemplateColumns:"1.6fr 1fr 1fr 70px",gap:8,padding:"6px 10px",background:C.surface,fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}>
                            <span>Product</span><span>Before</span><span>After</span><span></span>
                          </div>
                          {diffRows.map(r => (
                            <div key={r.sku} style={{display:"grid",gridTemplateColumns:"1.6fr 1fr 1fr 70px",gap:8,padding:"6px 10px",borderTop:`1px solid ${C.border}`,background:kindStyle[r.kind].bg}}>
                              <span><span style={{fontFamily:"monospace"}}>{r.sku}</span> {r.name}</span>
                              <span>{r.oldQty>0 ? `${r.oldQty} × $${Number(r.oldPrice).toFixed(2)}` : "—"}</span>
                              <span>{r.newQty>0 ? `${r.newQty} × $${Number(r.newPrice).toFixed(2)}` : "—"}</span>
                              <span style={{fontSize:10,fontWeight:600,color:C.inkMid}}>{kindStyle[r.kind].tag}</span>
                            </div>
                          ))}
                          <div style={{display:"flex",justifyContent:"space-between",padding:"8px 10px",borderTop:`1px solid ${C.border}`,background:C.surface,fontWeight:600}}>
                            <span>Total</span>
                            <span>${oldTotal.toFixed(2)} → ${newTotal.toFixed(2)} ({newTotal-oldTotal>=0?"+":"-"}${Math.abs(newTotal-oldTotal).toFixed(2)})</span>
                          </div>
                          {termsChanged && (
                            <div style={{padding:"6px 10px",borderTop:`1px solid ${C.border}`}}>Payment terms: {snap.paymentTerms} → <strong>{prop.paymentTerms}</strong></div>
                          )}
                        </div>
                        {req.last_apply_error && (
                          <div style={{background:C.redLight,color:C.red,borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12}}>
                            The last attempt to approve this request did not finish (the invoice may be partly updated; pressing Approve again is safe): {req.last_apply_error}
                          </div>
                        )}
                        {finishMode && (
                          <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#1E3A8A"}}>
                            <strong>Already applied to the invoice.</strong> An earlier approve attempt already updated this invoice. Pressing <em>Finish approval</em> only marks the request approved (older duplicate order rows without the change are completed); the payment checks are not needed. Reject is not available because the invoice already carries the change.
                          </div>
                        )}
                        {needsAck && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>The invoice was edited after the change was applied.</strong> Its lines no longer match what the rep asked for. You can still finish: type FINISH to mark the request approved as it stands (nothing on the invoice is changed).
                            <input type="text" placeholder="Type FINISH" value={adjFinishText[req.id] || ""} disabled={busy}
                              onChange={e=>setAdjFinishText(s=>({...s,[req.id]:e.target.value}))}
                              style={{...S.input,padding:"6px 10px",fontSize:12,marginTop:6}} />
                          </div>
                        )}
                        {remitActive.get(String(req.invoice_id)) && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Received from the sales rep.</strong> {requestRemittanceWarning(remitActive.get(String(req.invoice_id)), "adjust")}
                          </div>
                        )}
                        {(otherPendingVoid || otherPendingAdj) && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Another request is pending for this invoice</strong> ({otherPendingVoid ? "a void request" : "another adjustment request"}). Decide them together: approving a void after this adjustment (or the reverse) would conflict.
                          </div>
                        )}
                        {!inProgress && blockedNoCache && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Cannot approve:</strong> this invoice is not in this device&rsquo;s invoice list, so its payment status cannot be checked. Reload the admin portal.
                          </div>
                        )}
                        {!inProgress && blockedStatusDiff && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Cannot approve:</strong> this device shows the invoice as &ldquo;{cached.status}&rdquo; but the rep filed the request when it was &ldquo;{snap.status}&rdquo;. Reject it and ask the rep to file a new one.
                          </div>
                        )}
                        {shipped && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>⚠ Goods already sent:</strong> this invoice shows as {String(cached.shippingStatus||"").toLowerCase()==="delivered"?"delivered":"shipped"}{cached.tracking?` (tracking ${cached.tracking})`:""}. Approving changes the invoice lines and total only; the shipping record and what was physically sent will NOT change.
                          </div>
                        )}
                        {!finishMode && (<div style={{background:"#F3F4F6",border:`1px solid ${C.border}`,borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:C.inkMid}}>
                          <strong>Payment status cannot be verified centrally.</strong> Whether an invoice is paid is stored per device, not in the database, so another device may already have it as paid. Check Square / accounting yourself before approving.
                          <label style={{display:"flex",gap:8,alignItems:"flex-start",marginTop:6,fontWeight:600,color:C.ink}}>
                            <input type="checkbox" style={{marginTop:2}} checked={!!adjNotPaidAck[req.id]} disabled={busy} onChange={e=>setAdjNotPaidAck(s=>({...s,[req.id]:e.target.checked}))}/>
                            <span>I confirmed in Square / accounting that this invoice has not been paid</span>
                          </label>
                        </div>)}
                        {!inProgress && checkingCommission && (<div style={{fontSize:12,color:C.inkLight,marginBottom:8}}>Checking commission records...</div>)}
                        {!inProgress && commissionLoadFailed && (
                          <div style={{fontSize:12,color:C.red,marginBottom:8,display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                            <span>Commission records could not be loaded, so Approve is disabled.</span>
                            <button style={{...S.btnSmall,background:"#fff",color:C.red,border:`1px solid ${C.red}`}} onClick={()=>{ setCommissionIdsState("loading"); refreshCommissionPaidIds(); }}>Retry</button>
                          </div>
                        )}
                        {!inProgress && blockedByPayment && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Cannot approve:</strong> this invoice is marked {cst === "payment_pending" ? "payment pending" : "paid"} here. Changing it would change what the dealer already paid. Reject this request and ask the rep to request a void instead.
                          </div>
                        )}
                        {!inProgress && blockedByCancel && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <span style={{fontWeight:700,background:C.inkMid,color:"#fff",borderRadius:10,padding:"1px 8px",fontSize:10,marginRight:6}}>Already cancelled</span><strong>Cannot approve:</strong> this invoice is already cancelled. Dismiss this request (it can never be applied) or Reject it with a note.
                          </div>
                        )}
                        {repMismatch && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Check the rep:</strong> the invoice lists rep &ldquo;{displayRepStamp(cached.rep)}&rdquo; but the request was filed by &ldquo;{req.rep_name}&rdquo;.
                          </div>
                        )}
                        {!inProgress && commissionPaid && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>⚠ Commission already paid.</strong> This invoice already has commission marked paid (its total will change to ${newTotal.toFixed(2)}). A correction line will be recorded for the rep automatically and netted into their next payout.
                            <label style={{display:"flex",gap:8,alignItems:"center",marginTop:6,fontWeight:600}}>
                              <input type="checkbox" checked={!!adjCommissionAck[req.id]} disabled={busy} onChange={e=>setAdjCommissionAck(s=>({...s,[req.id]:e.target.checked}))}/>
                              I understand; approve anyway
                            </label>
                          </div>
                        )}
                        <input
                          type="text"
                          placeholder="Note to rep (optional when approving, required when rejecting)"
                          value={adjDecisionNote[req.id] != null ? adjDecisionNote[req.id] : ""}
                          disabled={busy}
                          onChange={e=>setAdjDecisionNote(s=>({...s,[req.id]:e.target.value}))}
                          style={{...S.input,padding:"6px 10px",fontSize:12,marginBottom:8}}
                        />
                        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                          <button
                            style={{...S.btnSmall,background:"#fff",color:C.red,border:`1px solid ${C.red}`,opacity:(busy||rejectBlocked)?0.6:1,cursor:rejectBlocked?"not-allowed":"pointer"}}
                            disabled={busy || rejectBlocked}
                            title={rejectBlocked ? "Approval is in progress or already applied on the invoice, so the request cannot be rejected. Press Approve (Finish approval)." : ""}
                            onClick={()=>handleRejectAdjustRequest(req)}
                          >Reject</button>
                          {blockedByCancel && (
                            <button
                              style={{...S.btnSmall,background:C.inkMid,color:"#fff",opacity:(busy||rejectBlocked)?0.6:1,cursor:rejectBlocked?"not-allowed":"pointer"}}
                              disabled={busy || rejectBlocked}
                              title="The invoice is already cancelled. Closes this request with a system note the rep can see."
                              onClick={()=>handleDismissAdjustRequest(req)}
                            >Dismiss</button>
                          )}
                          <button
                            style={{...S.btnSmall,background:"#1D4ED8",color:"#fff",opacity:approveDisabled?0.5:1,cursor:approveDisabled?"not-allowed":"pointer"}}
                            disabled={approveDisabled}
                            onClick={()=>handleApproveAdjustRequest(req)}
                          >{busy ? "…" : finishMode ? "Finish approval" : (checkingCommission && !inProgress) ? "Checking commission records..." : "Approve adjustment"}</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {/* Pending invoice void requests — rep-filed, admin reviews
                here. Approve flips portal_orders.status='cancelled' (existing
                repMetrics math auto-excludes from commission + restores
                inventory). Reject leaves the invoice unchanged. Per Q2(a),
                if commission has already been paid out for the invoice,
                we surface a warning inline but still let admin proceed —
                payout reconciliation is a separate manual step. */}
            {pendingVoidRequests.length > 0 && (
              <div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:"#991B1B"}}>
                      {pendingVoidRequests.length} void request{pendingVoidRequests.length===1?"":"s"} from sales reps
                    </div>
                    <div style={{fontSize:11,color:"#991B1B",marginTop:2}}>Approve to cancel the invoice (removes from commission, restores inventory). Reject to keep it as is.</div>
                  </div>
                </div>
                {voidReqError && (
                  <div style={{background:C.redLight,color:C.red,fontSize:12,padding:"8px 12px",borderRadius:8,marginBottom:10}}>{voidReqError}</div>
                )}
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {pendingVoidRequests.map(req => {
                    const busy = !!voidReqBusy[req.id];
                    const snap = (req.invoice_snapshot && typeof req.invoice_snapshot === 'object') ? req.invoice_snapshot : {};
                    const total = Number(snap.total) || 0;
                    const commissionPaid = commissionPaidInvoiceIds.has(String(req.invoice_id));
                    const cachedForReq = sharedInvs.find(i => i.id === req.invoice_id);
                    const alreadyCancelled = String(cachedForReq?.status || "").toLowerCase() === "cancelled";
                    return (
                      <div key={req.id} style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:10,padding:"10px 14px"}}>
                        <div style={{display:"grid",gridTemplateColumns:"1.2fr 1fr 0.9fr 1fr",gap:10,alignItems:"flex-start",fontSize:12,marginBottom:8}}>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Invoice</div>
                            <div style={{fontWeight:600,color:C.ink,fontFamily:"monospace"}}>{req.invoice_id}</div>
                            <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{snap.customer || "—"}</div>
                          </div>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Rep</div>
                            <div style={{color:C.ink}}>{req.rep_name || req.rep_id || "—"}</div>
                            <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{req.created_at ? new Date(req.created_at).toLocaleString() : ""}</div>
                          </div>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Total</div>
                            <div style={{fontWeight:600,color:C.ink}}>${total.toFixed(2)}</div>
                            <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>{Array.isArray(snap.items) ? `${snap.items.length} item${snap.items.length===1?"":"s"}` : ""}</div>
                          </div>
                          <div>
                            <div style={{fontSize:11,color:C.inkLight}}>Rep&rsquo;s reason</div>
                            <div style={{color:C.inkMid,fontSize:12}}>{req.reason || "(no reason given)"}</div>
                          </div>
                        </div>
                        {commissionPaid && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>⚠ Commission already paid.</strong> This invoice already has commission marked paid. A correction line will be recorded for the rep automatically and netted into their next payout.
                          </div>
                        )}
                        {remitActive.get(String(req.invoice_id)) && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Received from the sales rep.</strong> {requestRemittanceWarning(remitActive.get(String(req.invoice_id)), "void")}
                          </div>
                        )}
                        {pendingAdjRequests.some(a => a && a.invoice_id === req.invoice_id) && (
                          <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                            <strong>Another request is pending for this invoice</strong> (an adjustment request). Decide them together: approving this void would cancel the invoice the adjustment is meant to correct.
                          </div>
                        )}
                        {alreadyCancelled && (
                          <div style={{background:"#F3F4F6",border:`1px solid ${C.border}`,borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:C.inkMid}}>
                            <span style={{fontWeight:700,background:C.inkMid,color:"#fff",borderRadius:10,padding:"1px 8px",fontSize:10,marginRight:6}}>Already cancelled</span>
                            This invoice was already cancelled (for example an admin voided it meanwhile). Dismiss only marks this request decided; the invoice is not changed again.
                          </div>
                        )}
                        {(()=>{
                          // Display-only, harmless: a paid / payment-pending invoice is voided
                          // here without any automatic refund (the void flow itself is unchanged).
                          if (alreadyCancelled) return null;
                          const s = String(cachedForReq?.status || "").toLowerCase();
                          if (s !== "paid" && s !== "payment_pending") return null;
                          const cardOrAch = refundPlan(snapshotForRefund(cachedForReq)) === "refund";
                          return (
                            <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12,color:"#92400E"}}>
                              <strong>⚠ Marked {s === "paid" ? "paid" : "payment pending"}.</strong> Approving this void cancels the invoice but does NOT refund the dealer. Handle any refund separately.
                              {cardOrAch && <> <strong>Paid by card/ACH: no refund is issued by this approval.</strong> Refund it in Square / accounting, or void it from the Orders list instead so the refund is issued automatically. The invoice is recorded as refund handled manually.</>}
                            </div>
                          );
                        })()}
                        <input
                          type="text"
                          placeholder="Decision note (optional — visible to rep)"
                          value={voidDecisionNote[req.id] != null ? voidDecisionNote[req.id] : ""}
                          disabled={busy}
                          onChange={e=>setVoidDecisionNote(s=>({...s,[req.id]:e.target.value}))}
                          style={{...S.input,padding:"6px 10px",fontSize:12,marginBottom:8}}
                        />
                        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                          <button
                            style={{...S.btnSmall,background:"#fff",color:C.red,border:`1px solid ${C.red}`,opacity:busy?0.6:1}}
                            disabled={busy}
                            onClick={()=>handleRejectVoidRequest(req)}
                          >
                            Reject
                          </button>
                          {alreadyCancelled ? (
                            <button
                              style={{...S.btnSmall,background:C.inkMid,color:"#fff",opacity:busy?0.6:1}}
                              disabled={busy}
                              title="Only marks this request decided. The invoice is not changed again."
                              onClick={()=>handleApproveVoidRequest(req,{dismiss:true})}
                            >
                              {busy ? "…" : "Dismiss"}
                            </button>
                          ) : (
                            <button
                              style={{...S.btnSmall,background:C.red,color:"#fff",opacity:busy?0.6:1}}
                              disabled={busy}
                              onClick={()=>handleApproveVoidRequest(req)}
                            >
                              {busy ? "…" : "Approve void"}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:12,marginBottom:16}}>
              {[
                {l:"Total orders",v:visibleOrders.length,                                                                                     key:"all"},
                {l:"Field invoices",v:visibleFieldInvs.length,                                                               teal:true,    key:"field"},
                {l:"In transit",v:visibleOrders.filter(o=>o.status==="transit").length,                                                       key:"transit"},
                {l:"Awaiting confirmation",v:awaitingConfirm.length,                                                        warn:awaitingConfirm.length>0, key:"awaiting"},
                {l:"Delivered / Paid",v:visibleOrders.filter(o=>o.status==="done").length,                                                    key:"delivered"},
                {l:"Overdue payments",v:overdueInvoices?.length||0,                                                         danger:(overdueInvoices?.length||0)>0, key:"overdue"},
              ].map(m=>{
                const active = listFilter===m.key || (m.key==="all" && listFilter==="all");
                const accent = m.danger ? "#B91C1C" : m.warn ? C.amber : m.teal ? C.teal : C.blue;
                return (
                  <div
                    key={m.l}
                    onClick={()=>setListFilter(listFilter===m.key && m.key!=="all" ? "all" : m.key)}
                    style={{
                      ...S.metric,
                      ...(m.danger?{borderTop:`3px solid #B91C1C`}:m.warn?{borderTop:`3px solid ${C.amber}`}:m.teal?{borderTop:`3px solid ${C.teal}`}:{}),
                      cursor:"pointer",
                      boxShadow: active ? `0 0 0 2px ${accent}` : undefined,
                      transition: "box-shadow 0.15s, transform 0.15s"
                    }}
                    onMouseEnter={e=>{ if(!active) e.currentTarget.style.transform="translateY(-1px)"; }}
                    onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
                  >
                    <div style={S.mLabel}>{m.l}</div>
                    <div style={S.mValue}>{m.v}</div>
                    {active && m.key!=="all" && <div style={{fontSize:10,color:accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
                  </div>
                );
              })}
            </div>
          </>
        );
      })()}
      <RemittanceSummaryLine remit={remit}/>
      <div style={S.card}>
        <div style={{...S.cardHdr,flexWrap:"wrap",gap:8}}><span style={S.cardTitle}>All orders & invoices ({filtered.length})</span>
          <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
            {onCreateInvoice && <button style={{...S.btnPrimary,whiteSpace:"nowrap",padding:"6px 12px",fontSize:12}} onClick={onCreateInvoice} title="Create an invoice for a dealer account (the dealer's discount rate is applied)">+ Create invoice</button>}
            {(removedCount>0 || showRemoved) && (
              <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.inkMid,cursor:"pointer",whiteSpace:"nowrap"}}>
                <input type="checkbox" checked={showRemoved} onChange={e=>setShowRemoved(e.target.checked)}/>
                <span title="Removed orders matching the current filters">Show removed ({removedCount})</span>
              </label>
            )}
            <select style={{...S.select,width:"auto",fontSize:12,padding:"5px 10px"}} value={remitFilter} onChange={e=>setRemitFilter(e.target.value)} title="Filter by who paid us: the sales rep handed the payment in, or not yet">
              {ORDERS_REMIT_FILTERS.map(f=><option key={f.value} value={f.value}>{f.label}</option>)}
            </select>
            <select style={{...S.select,width:"auto",fontSize:12,padding:"5px 10px"}} value={acctFilter} onChange={e=>setAcctFilter(e.target.value)}>
              <option value="all">All accounts</option>
              {[...new Set(listBase.map(o=>o.account))].map(a=><option key={a} value={a}>{a}</option>)}
            </select>
            <input style={{...S.input,width:180,fontSize:12,padding:"5px 10px"}} placeholder="Search..." value={search} onChange={e=>setSearch(e.target.value)}/>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"90px 1fr 140px 80px 100px 120px 130px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Order</span><span>Items</span>
          <span style={{cursor:"pointer"}} onClick={()=>oSortBy("account")}>Account{oSortArrow("account")}</span>
          <span style={{cursor:"pointer"}} onClick={()=>oSortBy("amount")}>Amount{oSortArrow("amount")}</span>
          <span style={{cursor:"pointer"}} onClick={()=>oSortBy("status")}>Status{oSortArrow("status")}</span>
          <span>Tracking</span><span></span>
        </div>
        {filtered.length===0&&<div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>No orders or invoices found</div>}
        {filtered.map(o=>{
          const itemStr = typeof o.items==="string"?o.items:"—";
          const invId = o._raw?.id || (o.isFieldInvoice ? o.id : null);
          const late = invId ? (overdueById[invId]||0) : 0;
          const isCancelled = o._raw?.status==="cancelled";
          const rowRemoved = isRemovedOrder(o);
          return (
          <div key={o.id} style={{display:"grid",gridTemplateColumns:"90px 1fr 140px 80px 100px 120px 130px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,background:late>0?"#FEF2F2":o.isFieldInvoice?"#FAFFFE":"transparent",opacity:rowRemoved?0.55:1}}>
            <span style={{fontWeight:600,color:o.isFieldInvoice?C.teal:C.ink}}>
              {o.id}
              {rowRemoved && <span title={removedMap[o.id]?.reason ? `Removed: ${removedMap[o.id].reason}` : "Removed"} style={{...S.pillGray,display:"inline-block",marginLeft:6,fontSize:9,verticalAlign:"middle"}}>Removed</span>}
              {late>0 && <span title={`Payment is ${late} day${late===1?"":"s"} overdue`} style={{display:"inline-block",marginLeft:6,background:"#B91C1C",color:"white",fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:6,verticalAlign:"middle"}}>OVERDUE</span>}
            </span>
            <span style={{color:C.inkMid,fontSize:11}}>{itemStr.length>50?itemStr.slice(0,50)+"...":itemStr}</span>
            <span style={{color:C.inkLight}}>{o.account}</span>
            <span style={{fontWeight:600,color:late>0?"#B91C1C":C.ink}}>
              ${o.amount.toLocaleString()}
              {late>0 && <div style={{fontSize:10,fontWeight:500,color:"#B91C1C",marginTop:1}}>{late}d late</div>}
            </span>
            {/* Status column — unified 4-value pill (Paid / Pending / Shipped /
                Overdue + Cancelled) rendered identically across admin, rep,
                and customer portals via deriveInvoiceDisplayStatus. Pending
                payment (customer reported wire/check) keeps its extra
                admin-only hint as a secondary caption below. */}
            {o.isFieldInvoice && o._raw
              ? <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  <InvoicePill inv={o._raw}/>
                  {remitActive.get(String(o._raw.id)) && (()=>{ const rp = remittancePill(remitActive.get(String(o._raw.id))); return <span style={rp.style} title="The sales rep handed this payment in to the company (not paid by the shop directly)">{rp.label}</span>; })()}
                  {o.status==="payment_pending" && <span style={{fontSize:9,color:"#B45309",fontWeight:600}} title={`${o._raw?.pendingMethod||"Payment"} reported — needs confirmation`}>⏳ Needs confirmation</span>}
                </div>
              : <StatusLabel s={o.status}/>}
            {/* Tracking / Ship Now column. Unshipped field invoices get a
                prominent green Ship Now button. Shipped rows show the
                clickable carrier tracking link. Cancelled rows show nothing. */}
            <span style={{fontSize:11,color:C.inkLight,display:"flex",flexDirection:"column",gap:2}}>
              {(() => {
                const tUrl = carrierTrackUrl(o.carrier, o.tracking);
                const rawShip = o._raw?.shippingStatus;
                const isShipped = rawShip === "shipped" || rawShip === "delivered";
                if(o.tracking) {
                  return tUrl
                    ? <a href={tUrl} target="_blank" rel="noopener noreferrer" style={{color:C.blue,fontWeight:500,textDecoration:"none"}} onClick={e=>e.stopPropagation()}>{o.carrier}: {o.tracking.slice(0,14)}{o.tracking.length>14?"…":""}</a>
                    : <span style={{color:C.ink,fontWeight:500}}>{o.carrier}: {o.tracking.slice(0,14)}{o.tracking.length>14?"…":""}</span>;
                }
                if(isShipped) {
                  return <span style={{color:C.green,fontWeight:600,fontSize:11}}>✓ {rawShip==="delivered"?"Delivered":"Shipped"}{o._raw?.deliveredByRep?` by ${o._raw.deliveredByRep}`:""}</span>;
                }
                if(isCancelled) return <span style={{fontSize:10,color:C.inkLight}}>—</span>;
                if(o.isFieldInvoice) {
                  return <button style={{background:C.green,border:`1px solid ${C.green}`,color:"#fff",fontSize:11,padding:"5px 11px",borderRadius:6,cursor:"pointer",alignSelf:"flex-start",fontWeight:600}} onClick={e=>{e.stopPropagation(); setShipNowFor(o);}}>Ship Now</button>;
                }
                return <button style={{background:"none",border:`1px dashed ${C.border}`,color:C.blue,fontSize:10,padding:"3px 8px",borderRadius:6,cursor:"pointer",alignSelf:"flex-start",fontWeight:500}} onClick={()=>setViewOrder(o.id)}>+ Add tracking</button>;
              })()}
              {o.isFieldInvoice && <span style={{fontSize:9,color:C.inkLight}}>{o._raw?.source==="portal_order"?"Dealer order":o._raw?.source==="admin_invoice"?"Office invoice":"Field invoice"}</span>}
            </span>
            {/* View always routes through the order-detail page (viewOrder)
                — even for field invoices — so the tracking UI is reachable
                from a single path. The detail page has a "View invoice PDF"
                button that still opens the legacy read-only modal when the
                admin wants to print/save the PDF. */}
            <span style={{display:"flex",gap:6}}>
              <button style={S.btnSmall} onClick={()=>setViewOrder(o.id)}>View</button>
              {rowRemoved && <button style={{...S.btnSmall,opacity:restoringId?0.6:1}} disabled={!!restoringId} onClick={()=>restoreOrder(o)}>{restoringId===o.id?"Restoring...":"Restore"}</button>}
            </span>
          </div>
          );
        })}
      </div>
      {shipNowFor && (
        <ShipNowModal
          order={shipNowFor}
          accounts={accounts}
          onClose={()=>setShipNowFor(null)}
          onCompleted={()=>{
            // SHARED_INVOICES.subscribe refresh handles same-browser rerender;
            // explicit refresh here covers the portal_orders-only case.
            setSharedInvs(SHARED_INVOICES.getAll());
          }}
        />
      )}
    </div>
  );
}

function AdminToolsTab({tools,setTools,agreements,setAgreements}) {
  const statusColors = {compliant:S.pillGreen,warning:S.pillAmber,recall:S.pillRed};
  // Top-bar stat-card filter. "all" is reset. Other values match the
  // agreement.status field exactly. Click-again toggles off.
  const [statusFilter,setStatusFilter]=useState("all");
  const [toolSearch,setToolSearch]=useState("");

  // Shared form state for both Add and Edit, matching the Product form
  // pattern. `modal` carries intent:
  //   null      — closed
  //   "add"     — creating a new tool
  //   {mode:"edit", id} — editing the tool with that id
  // Detail view is a separate `viewing` id (read-only modal). Edits
  // preserve the tool's id, so any existing agreement's toolId stays
  // wired. Same contract we used in PR #36 for marketing materials.
  const blank = {
    name:"", category:"diagnostic", value:0, minUnitsPerMonth:0, maxCirculation:1,
    desc:"", active:true, imageUrl:"", videoUrl:"",
    howToUse:[""], benefits:[""], compatible:[""],
  };
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState(blank);
  const [viewing,setViewing]=useState(null);
  const viewingItem = viewing ? tools.find(t=>t.id===viewing) : null;
  const editMode = modal && modal.mode === "edit";
  const openAdd    = () => { setForm({...blank}); setModal("add"); };
  const openEdit   = (t) => { setForm({...blank, ...t,
    howToUse:   t.howToUse?.length   ? [...t.howToUse]   : [""],
    benefits:   t.benefits?.length   ? [...t.benefits]   : [""],
    compatible: t.compatible?.length ? [...t.compatible] : [""],
  }); setModal({mode:"edit", id:t.id}); };
  const closeModal = () => { setModal(null); setForm({...blank}); };
  const saveItem   = () => {
    if(!form.name.trim()) return;
    const cleaned = {
      ...form,
      howToUse:   (form.howToUse  ||[]).filter(s=>s.trim()),
      benefits:   (form.benefits  ||[]).filter(s=>s.trim()),
      compatible: (form.compatible||[]).filter(s=>s.trim()),
    };
    if(modal === "add") {
      setTools(ts=>[...ts, {id:Date.now(), currentLoaned:0, ...cleaned}]);
    } else if(editMode) {
      // Spread-merge preserves any field not in the form (e.g. currentLoaned),
      // and force-preserves id so agreement.toolId references stay valid.
      setTools(ts=>ts.map(x=>x.id===modal.id ? {...x, ...cleaned, id:x.id} : x));
    }
    closeModal();
  };

  // Small helpers for list-of-strings fields (howToUse / benefits / compatible).
  const updateItem = (field, i, val) => setForm(f=>{ const arr=[...(f[field]||[""])]; arr[i]=val; return {...f,[field]:arr}; });
  const removeItem = (field, i)      => setForm(f=>({...f,[field]:(f[field]||[]).filter((_,j)=>j!==i)}));
  const addItem    = (field)         => setForm(f=>({...f,[field]:[...(f[field]||[]),""]}));

  return (
    <div>
      {/* Add / Edit modal — matches the Product form pattern: ImageUploader,
          optional video URL, then numeric fields, then list-style rich fields
          (How to use, Key benefits, Compatible vehicles / systems). */}
      {modal&&(
        <div style={S.modal}>
          <div style={{...S.modalBox,width:600,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:16}}>{editMode?"Edit tool":"Add tool to catalog"}</div>
            <div style={S.fg}><label style={S.label}>Tool name *</label><input style={S.input} value={form.name} onChange={e=>setForm(v=>({...v,name:e.target.value}))} placeholder="DPF cleaning machine"/></div>
            <div style={S.fg}>
              <ImageUploader value={form.imageUrl||""} onChange={url=>setForm(v=>({...v,imageUrl:url}))} folder="tools" label="Tool image"/>
            </div>
            <div style={S.fg}>
              <label style={S.label}>Tool video <span style={{fontWeight:400,color:C.inkLight}}>(optional)</span></label>
              <input style={S.input} value={form.videoUrl||""} onChange={e=>setForm(v=>({...v,videoUrl:e.target.value}))} placeholder="Paste a YouTube, Vimeo, or direct MP4 link"/>
              <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Optional demo video. Leave blank to hide.</div>
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Category</label><input style={S.input} value={form.category||""} onChange={e=>setForm(v=>({...v,category:e.target.value}))} placeholder="diagnostic / cleaning / measurement"/></div>
              <div style={S.fg}><label style={S.label}>Status</label><select style={S.select} value={form.active===false?"inactive":"active"} onChange={e=>setForm(v=>({...v,active:e.target.value==="active"}))}><option value="active">Active</option><option value="inactive">Inactive</option></select></div>
            </div>
            <div style={S.twoCol}>
              <div style={S.fg}><label style={S.label}>Value ($)</label><input style={S.input} type="number" min="0" value={form.value} onChange={e=>setForm(v=>({...v,value:parseFloat(e.target.value)||0}))}/></div>
              <div style={S.fg}><label style={S.label}>Min units/month</label><input style={S.input} type="number" min="0" value={form.minUnitsPerMonth} onChange={e=>setForm(v=>({...v,minUnitsPerMonth:parseInt(e.target.value)||0}))}/></div>
            </div>
            <div style={S.fg}><label style={S.label}>Max circulation</label><input style={S.input} type="number" min="1" value={form.maxCirculation} onChange={e=>setForm(v=>({...v,maxCirculation:parseInt(e.target.value)||1}))}/></div>
            <div style={S.fg}><label style={S.label}>Short description</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={form.desc} onChange={e=>setForm(v=>({...v,desc:e.target.value}))}/></div>

            {/* ─── How to use ─── */}
            <div style={{marginTop:8,marginBottom:14,paddingTop:12,borderTop:`1px solid ${C.border}`}}>
              <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>How to use (step-by-step instructions)</label>
              {(form.howToUse||[""]).map((step,i)=>(
                <div key={i} style={{display:"flex",gap:6,marginBottom:6,alignItems:"center"}}>
                  <span style={{fontSize:11,fontWeight:600,color:C.blue,minWidth:44}}>Step {i+1}</span>
                  <input style={{...S.input,flex:1,fontSize:12}} value={step} onChange={e=>updateItem("howToUse",i,e.target.value)} placeholder={`Step ${i+1} instruction...`}/>
                  {(form.howToUse||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>removeItem("howToUse",i)}>X</button>}
                </div>
              ))}
              <button style={S.btnSmall} onClick={()=>addItem("howToUse")}>+ Add step</button>
            </div>

            {/* ─── Key benefits ─── */}
            <div style={{marginBottom:14}}>
              <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Key benefits</label>
              {(form.benefits||[""]).map((b,i)=>(
                <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
                  <input style={{...S.input,flex:1,fontSize:12}} value={b} onChange={e=>updateItem("benefits",i,e.target.value)} placeholder={`Benefit ${i+1}...`}/>
                  {(form.benefits||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>removeItem("benefits",i)}>X</button>}
                </div>
              ))}
              <button style={S.btnSmall} onClick={()=>addItem("benefits")}>+ Add benefit</button>
            </div>

            {/* ─── Compatible vehicles / systems ─── */}
            <div style={{marginBottom:14}}>
              <label style={{...S.label,fontSize:13,fontWeight:600,color:C.ink}}>Compatible vehicles / systems</label>
              {(form.compatible||[""]).map((c,i)=>(
                <div key={i} style={{display:"flex",gap:6,marginBottom:6}}>
                  <input style={{...S.input,flex:1,fontSize:12}} value={c} onChange={e=>updateItem("compatible",i,e.target.value)} placeholder={`Compatible system ${i+1}...`}/>
                  {(form.compatible||[]).length>1&&<button style={{...S.btnDanger,padding:"4px 8px",fontSize:10}} onClick={()=>removeItem("compatible",i)}>X</button>}
                </div>
              ))}
              <button style={S.btnSmall} onClick={()=>addItem("compatible")}>+ Add</button>
            </div>

            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={closeModal}>Cancel</button>
              <button style={S.btnPrimary} onClick={saveItem}>{editMode?"Save changes":"Add tool"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Read-only detail view — opens on row click. Same structure as the
          Materials detail view (PR #36). Edit button swaps to the edit modal. */}
      {viewingItem&&(
        <div style={S.modal} onClick={()=>setViewing(null)}>
          <div style={{...S.modalBox,width:600,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",gap:16,marginBottom:16}}>
              {viewingItem.imageUrl
                ? <img src={viewingItem.imageUrl} alt="" style={{width:120,height:120,borderRadius:10,objectFit:"cover",flexShrink:0,border:`1px solid ${C.border}`}} onError={e=>{e.target.style.display="none"}}/>
                : <div style={{width:120,height:120,borderRadius:10,background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,flexShrink:0,border:`1px solid ${C.border}`}}>🔧</div>}
              <div style={{flex:1}}>
                <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>{viewingItem.name}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                  {viewingItem.category && <span style={S.pillGray}>{viewingItem.category}</span>}
                  <span style={viewingItem.active?S.pillGreen:S.pillGray}>{viewingItem.active?"Active":"Off"}</span>
                </div>
                {viewingItem.desc && <div style={{fontSize:13,color:C.inkMid,lineHeight:1.5}}>{viewingItem.desc}</div>}
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:16}}>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:2}}>Tool value</div>
                <div style={{fontSize:15,fontWeight:600,color:C.ink}}>${Number(viewingItem.value||0).toFixed(0)}</div>
              </div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:2}}>Min units/month</div>
                <div style={{fontSize:15,fontWeight:600,color:C.ink}}>{viewingItem.minUnitsPerMonth||0}</div>
              </div>
              <div style={{background:C.surface,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:2}}>Circulation</div>
                <div style={{fontSize:15,fontWeight:600,color:C.ink}}>{viewingItem.currentLoaned||0}/{viewingItem.maxCirculation||0}</div>
              </div>
            </div>
            {viewingItem.videoUrl && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:4}}>Video</div>
                <a href={viewingItem.videoUrl} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.blue,wordBreak:"break-all"}}>{viewingItem.videoUrl}</a>
              </div>
            )}
            {(viewingItem.howToUse||[]).filter(s=>s&&s.trim()).length>0 && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:6}}>How to use</div>
                <ol style={{margin:0,paddingLeft:20,fontSize:13,color:C.ink,lineHeight:1.6}}>
                  {viewingItem.howToUse.filter(s=>s&&s.trim()).map((s,i)=><li key={i} style={{marginBottom:4}}>{s}</li>)}
                </ol>
              </div>
            )}
            {(viewingItem.benefits||[]).filter(s=>s&&s.trim()).length>0 && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:6}}>Key benefits</div>
                <ul style={{margin:0,paddingLeft:20,fontSize:13,color:C.ink,lineHeight:1.6}}>
                  {viewingItem.benefits.filter(s=>s&&s.trim()).map((s,i)=><li key={i} style={{marginBottom:4}}>{s}</li>)}
                </ul>
              </div>
            )}
            {(viewingItem.compatible||[]).filter(s=>s&&s.trim()).length>0 && (
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,fontWeight:600,color:C.inkLight,marginBottom:6}}>Compatible vehicles / systems</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {viewingItem.compatible.filter(s=>s&&s.trim()).map((s,i)=><span key={i} style={S.pillGray}>{s}</span>)}
                </div>
              </div>
            )}
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={()=>setViewing(null)}>Close</button>
              <button style={S.btnPrimary} onClick={()=>{ const t = viewingItem; setViewing(null); openEdit(t); }}>Edit</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[
          {l:"Active agreements",v:agreements.length,                                                  key:"all"},
          {l:"Compliant",v:agreements.filter(a=>a.status==="compliant").length,  up:true,              key:"compliant"},
          {l:"Warnings",v:agreements.filter(a=>a.status==="warning").length,     warn:true,            key:"warning"},
          {l:"Recalls needed",v:agreements.filter(a=>a.status==="recall").length, red:true,            key:"recall"},
        ].map(m=>{
          const active = statusFilter===m.key && m.key!=="all";
          const accent = m.red ? C.red : m.warn ? C.amber : m.up ? C.green : C.blue;
          return (
            <div
              key={m.l}
              onClick={()=>setStatusFilter(active ? "all" : m.key)}
              style={{
                ...S.metric,
                ...(m.red?{borderTop:`3px solid ${C.red}`}:m.warn?{borderTop:`3px solid ${C.amber}`}:{}),
                cursor:"pointer",
                boxShadow: active ? `0 0 0 2px ${accent}` : undefined,
                transition:"box-shadow 0.15s, transform 0.15s"
              }}
              onMouseEnter={e=>{ if(!active) e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
            >
              <div style={S.mLabel}>{m.l}</div><div style={S.mValue}>{m.v}</div>
              {active && <div style={{fontSize:10,color:accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
            </div>
          );
        })}
      </div>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
        <input style={{...S.input,width:220,fontSize:12,padding:"6px 12px"}} placeholder="Search tools, shops, reps..." value={toolSearch} onChange={e=>setToolSearch(e.target.value)}/>
      </div>
      <div style={S.card}>
        <div style={{...S.cardHdr,marginBottom:0}}><span style={S.cardTitle}>All tool agreements</span></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 160px 80px 90px 90px 80px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
          <span>Tool</span><span>Shop</span><span>Rep</span><span>Min/mo</span><span>Last month</span><span>Status</span>
        </div>
        {agreements.filter(agr=>{
          if(statusFilter!=="all" && agr.status!==statusFilter) return false;
          if(!toolSearch.trim()) return true;
          const q=toolSearch.toLowerCase();
          return (agr.toolName||"").toLowerCase().includes(q)||(agr.shop||"").toLowerCase().includes(q)||(agr.rep||"").toLowerCase().includes(q)||(agr.status||"").toLowerCase().includes(q);
        }).map(agr=>(
          <div key={agr.id} style={{display:"grid",gridTemplateColumns:"1fr 160px 80px 90px 90px 80px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,background:agr.status==="recall"?C.redLight:agr.status==="warning"?C.amberLight:"transparent"}}>
            <div><div style={{fontWeight:500,color:C.ink}}>{agr.toolName}</div><div style={{fontSize:11,color:C.inkLight}}>Since {agr.startDate}</div></div>
            <span style={{color:C.ink}}>{agr.shop}</span>
            <span style={{color:C.inkLight}}>{agr.rep}</span>
            <span style={{color:C.inkLight}}>{agr.minUnits}</span>
            <span style={{fontWeight:500,color:agr.lastMonthUnits>=agr.minUnits?C.teal:C.red}}>{agr.lastMonthUnits}</span>
            <span style={statusColors[agr.status]||S.pillGray}>{agr.status}</span>
          </div>
        ))}
      </div>
      <div style={{marginTop:16,...S.card}}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Tool catalog</span><button style={S.btnPrimary} onClick={openAdd}>+ Add tool</button></div>
        {tools.filter(t=>{if(!toolSearch.trim())return true;const q=toolSearch.toLowerCase();return (t.name||"").toLowerCase().includes(q)||(t.desc||"").toLowerCase().includes(q);}).map(t=>(
          // Row click opens the read-only detail view. Action buttons use
          // stopPropagation so they still work independently.
          <div
            key={t.id}
            onClick={()=>setViewing(t.id)}
            style={{display:"grid",gridTemplateColumns:"50px 1fr 80px 100px 80px 80px 70px 80px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,cursor:"pointer",transition:"background 0.15s"}}
            onMouseEnter={e=>{e.currentTarget.style.background=C.surface;}}
            onMouseLeave={e=>{e.currentTarget.style.background="";}}
          >
            {t.imageUrl
              ? <img src={t.imageUrl} alt="" style={{width:40,height:40,borderRadius:6,objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>
              : <div style={{width:40,height:40,borderRadius:6,background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>🔧</div>}
            <div><div style={{fontWeight:500,color:C.ink}}>{t.name}</div><div style={{fontSize:11,color:C.inkLight}}>{t.desc?.slice(0,55)}{t.desc&&t.desc.length>55?"...":""}</div></div>
            <span style={{color:C.ink}}>${t.value}</span>
            <span style={{color:C.inkLight}}>{t.minUnitsPerMonth} units/mo</span>
            <span style={{color:C.ink}}>{t.currentLoaned}/{t.maxCirculation}</span>
            <span style={t.active?S.pillGreen:S.pillGray}>{t.active?"Active":"Off"}</span>
            <button style={S.btnSmall} onClick={e=>{e.stopPropagation();openEdit(t);}}>Edit</button>
            <button style={t.active?S.btnDanger:S.btnSuccess} onClick={e=>{e.stopPropagation();setTools(ts=>ts.map(x=>x.id===t.id?{...x,active:!x.active}:x));}}>{t.active?"Deactivate":"Activate"}</button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── ADMIN REPS TAB — Activity tracking, customer DB, visit logs ─────────────
const ADMIN_REP_DATA = [
  {id:1, name:"Marcus T.", email:"marcus@mpcare.com", phone:"619-555-0148", rate:8, paySchedule:"15th of month", startDate:"Jan 1, 2025", territory:"Southern California", notes:"Senior rep — DPF specialist", ytdSales:42100, accounts:3,
    customers:[
      {id:1,company:"Apex Car Care LLC",contact:"John Smith",email:"john@apexcarcare.com",phone:"619-555-0100",address:"1234 Industrial Blvd, San Diego, CA 92101",tier:"distributor",priority:"high",ytd:42100,ein:"82-1234567",lastVisit:"2025-04-10",visitCycle:30},
      {id:2,company:"FastLane Auto Parts",contact:"Maria Reyes",email:"maria@fastlane.com",phone:"623-555-0200",address:"500 Commerce Ave, Phoenix, AZ 85001",tier:"dealer",priority:"medium",ytd:18450,ein:"74-9876543",lastVisit:"2025-04-08",visitCycle:30},
      {id:6,company:"Valley Truck Center",contact:"Bob Walsh",email:"bob@valleytruck.com",phone:"559-555-0600",address:"4500 E Kings Canyon Rd, Fresno, CA 93702",tier:"distributor",priority:"high",ytd:31200,ein:"91-3456789",lastVisit:"2025-04-01",visitCycle:30},
      {id:7,company:"Coastal Motor Works",contact:"Lisa Park",email:"lisa@coastalmotor.com",phone:"619-555-0700",address:"850 Rosecrans St, San Diego, CA 92106",tier:"dealer",priority:"low",ytd:4100,ein:"",lastVisit:"2025-04-05",visitCycle:30},
      {id:8,company:"Inland Empire Auto",contact:"Carlos V.",email:"carlos@inlandemp.com",phone:"909-555-0800",address:"1100 Iowa Ave, Riverside, CA 92507",tier:"distributor",priority:"medium",ytd:15600,ein:"",lastVisit:"2025-03-20",visitCycle:30},
    ],
    prospects:[
      {id:101,company:"Golden State Tire & Brake",contact:"Tony Morales",email:"tony@gstirebrake.com",phone:"619-555-1100",address:"2700 National Ave, San Diego, CA 92113",tier:"dealer",priority:"high",lastContact:"2025-03-10",comments:[{date:"Mar 10, 2025",text:"Cold called - interested in DPF products. Asked for samples."}],reminders:[{date:"2025-04-15",text:"Follow up on DPF samples",done:false}]},
      {id:102,company:"Summit Auto Electric",contact:"Karen Liu",email:"karen@summitauto.com",phone:"858-555-1200",address:"4480 Clairemont Dr, San Diego, CA 92117",tier:"dealer",priority:"medium",lastContact:"2025-03-22",comments:[{date:"Mar 22, 2025",text:"Met at SEMA regional. Wants pricing for fuel system line."}],reminders:[{date:"2025-04-20",text:"Send pricing sheet",done:false}]},
      {id:103,company:"Border City Diesel",contact:"Miguel Espinoza",email:"miguel@borderdiesel.com",phone:"619-555-1300",address:"1180 E Beyer Blvd, San Ysidro, CA 92173",tier:"distributor",priority:"high",lastContact:"2025-03-15",comments:[{date:"Feb 28, 2025",text:"Left business card."},{date:"Mar 15, 2025",text:"Miguel called back. Wants DPF foam demo."}],reminders:[{date:"2025-04-12",text:"Schedule DPF demo",done:false}]},
    ],
    visits:[
      {date:"2025-04-12",company:"Apex Car Care LLC",type:"shop_visit",note:"Discussed new DPF product line. Placed order for 24 units.",duration:45},
      {date:"2025-04-11",company:"FastLane Auto Parts",type:"shop_visit",note:"Quarterly review. Maria interested in wiper blade display.",duration:30},
      {date:"2025-04-10",company:"Apex Car Care LLC",type:"follow_up",note:"Called to confirm delivery schedule for pending order.",duration:10},
      {date:"2025-04-09",company:"Valley Truck Center",type:"shop_visit",note:"Product training for new diesel additive. Left samples.",duration:60},
      {date:"2025-04-08",company:"FastLane Auto Parts",type:"shop_visit",note:"Delivered promotional materials and shelf talkers.",duration:25},
      {date:"2025-04-07",company:"Coastal Motor Works",type:"cold_call",note:"Introduced engine flush line. Lisa wants to trial 6 units.",duration:35},
      {date:"2025-04-05",company:"Coastal Motor Works",type:"shop_visit",note:"Dropped off engine flush trial units. Set 30-day check-in.",duration:20},
      {date:"2025-04-04",company:"Inland Empire Auto",type:"shop_visit",note:"Visited location #2. Spoke with manager about reorder.",duration:40},
      {date:"2025-04-03",company:"Apex Car Care LLC",type:"shop_visit",note:"Routine check-in. Restocked DPF cleaner display.",duration:30},
      {date:"2025-04-01",company:"Valley Truck Center",type:"shop_visit",note:"Reviewed Q1 performance. Bob happy with results.",duration:50},
      {date:"2025-03-28",company:"FastLane Auto Parts",type:"shop_visit",note:"Installed new shelf display unit.",duration:40},
      {date:"2025-03-25",company:"Inland Empire Auto",type:"shop_visit",note:"Met with Carlos at main location. Discussed expansion.",duration:45},
      {date:"2025-03-20",company:"Inland Empire Auto",type:"follow_up",note:"Follow-up call on pending distributor upgrade.",duration:15},
      {date:"2025-03-18",company:"Apex Car Care LLC",type:"shop_visit",note:"Monthly review with John. Strong DPF sales continue.",duration:35},
    ]
  },
  {id:2, name:"Sarah L.", email:"sarah@mpcare.com", phone:"661-555-0200", rate:6, paySchedule:"15th of month", startDate:"Feb 1, 2025", territory:"Central Valley", notes:"New rep — dealer focus", ytdSales:18450, accounts:1,
    customers:[
      {id:3,company:"Westside Repair Center",contact:"Dave Kim",email:"dave@westsiderepair.com",phone:"661-555-0300",address:"77 Main St, Bakersfield, CA 93301",tier:"dealer",priority:"high",ytd:9200,ein:"33-7890123",lastVisit:"2025-04-06",visitCycle:30},
      {id:5,company:"Desert Auto Service",contact:"Rick Torres",email:"rick@desertauto.com",phone:"760-555-0500",address:"340 Palm Canyon Dr, Palm Springs, CA 92262",tier:"dealer",priority:"medium",ytd:7800,ein:"",lastVisit:"2025-04-02",visitCycle:30},
    ],
    prospects:[
      {id:201,company:"High Desert Auto Repair",contact:"Jim Booker",email:"jim@highdesertauto.com",phone:"760-555-1500",address:"56100 29 Palms Hwy, Yucca Valley, CA 92284",tier:"dealer",priority:"low",lastContact:"2025-04-01",comments:[{date:"Apr 1, 2025",text:"Phone call. Jim orders from O'Reilly. Open to wholesale pricing."}],reminders:[{date:"2025-04-25",text:"Send comparison sheet",done:false}]},
    ],
    visits:[
      {date:"2025-04-11",company:"Westside Repair Center",type:"shop_visit",note:"Product training with new owner Dave. Good reception.",duration:55},
      {date:"2025-04-09",company:"Desert Auto Service",type:"shop_visit",note:"Quarterly check-in. Rick wants to add catalyst cleaner.",duration:30},
      {date:"2025-04-06",company:"Westside Repair Center",type:"follow_up",note:"Called Dave to confirm training schedule.",duration:10},
      {date:"2025-04-02",company:"Desert Auto Service",type:"shop_visit",note:"Delivered new pricing sheets and samples.",duration:25},
      {date:"2025-03-30",company:"Westside Repair Center",type:"shop_visit",note:"Routine visit. Restocked shelf display.",duration:20},
      {date:"2025-03-25",company:"Desert Auto Service",type:"cold_call",note:"Prospecting visit. Rick interested in full product line.",duration:40},
    ]
  },
  {id:3, name:"James R.", email:"james@mpcare.com", phone:"760-555-0300", rate:7, paySchedule:"End of month", startDate:"Mar 1, 2025", territory:"Arizona / Nevada", notes:"Fleet and commercial accounts", ytdSales:0, accounts:0,
    customers:[
      {id:4,company:"Pacific Fleet Mgmt",contact:"Amy Chen",email:"amy@pacificfleet.com",phone:"858-555-0400",address:"2200 Harbor Dr, Long Beach, CA 90802",tier:"enterprise",priority:"high",ytd:0,ein:"55-6543210",lastVisit:"2025-04-01",visitCycle:30},
    ],
    prospects:[
      {id:301,company:"Rancho Performance",contact:"Alex Vargas",email:"alex@ranchoperf.com",phone:"951-555-1600",address:"24850 Alessandro Blvd, Moreno Valley, CA 92553",tier:"dealer",priority:"medium",lastContact:"",comments:[],reminders:[{date:"2025-04-18",text:"First visit - bring sample kit",done:false}]},
      {id:302,company:"Oceanview Motors",contact:"Sarah Bennett",email:"sarah@oceanviewmotors.com",phone:"760-555-1400",address:"310 S Coast Hwy, Oceanside, CA 92054",tier:"dealer",priority:"medium",lastContact:"",comments:[],reminders:[]},
    ],
    visits:[
      {date:"2025-04-10",company:"Pacific Fleet Mgmt",type:"shop_visit",note:"Fleet assessment — 80 vehicles. Preparing custom quote.",duration:90},
      {date:"2025-04-05",company:"Pacific Fleet Mgmt",type:"follow_up",note:"Sent fleet pricing proposal via email.",duration:15},
      {date:"2025-04-01",company:"Pacific Fleet Mgmt",type:"shop_visit",note:"Initial meeting with Amy. Toured their maintenance facility.",duration:60},
    ]
  },
];

function AdminRepsTab({onOpenInOrders,liveReps=[],pendingReps=[],onApproveRep,onRejectRep,allAccounts=[],onRepSuspensionChange,inactiveReps=[],onRequestDelete,onRequestPause,archiveCount=0,onOpenArchive}) {
  // Deleted / paused reps (from the Supabase-hydrated accounts) are hidden here. Demo seed copies
  // are matched by email so a deleted live rep cannot reappear as the demo rep on any browser.
  const hiddenRepEmails = new Set((inactiveReps||[]).map(r=>String(r.email||"").toLowerCase()).filter(Boolean));
  const hiddenRepIds = new Set((inactiveReps||[]).map(r=>String(r.id)));
  const hiddenRepKey = [...hiddenRepIds].sort().join("|")+"#"+[...hiddenRepEmails].sort().join("|");
  const isHiddenRep = (r) => !!r && (hiddenRepIds.has(String(r.id)) || hiddenRepIds.has(String(r.supabaseId)) || hiddenRepEmails.has(String(r.email||"").toLowerCase()));
  // ── Persist rep edits + deletions to localStorage ──
  const loadRepOverrides = () => {
    try { const raw=localStorage.getItem("mpcare_rep_overrides"); return raw?JSON.parse(raw):{}; } catch(e){ return {}; }
  };
  const loadDeletedReps = () => {
    try { const raw=localStorage.getItem("mpcare_deleted_reps"); return raw?JSON.parse(raw):[]; } catch(e){ return []; }
  };
  const saveRepOverrides = (overrides) => {
    try { localStorage.setItem("mpcare_rep_overrides",JSON.stringify(overrides)); } catch(e){}
  };
  const saveDeletedReps = (ids) => {
    try { localStorage.setItem("mpcare_deleted_reps",JSON.stringify(ids)); } catch(e){}
  };

  // Build initial reps: merge ADMIN_REP_DATA + liveReps (deduplicate by email), apply saved overrides, filter deleted
  const [reps, setReps] = useState(()=>{
    const overrides = loadRepOverrides();
    const deleted = new Set(loadDeletedReps());
    // Deduplicate: if a liveRep has the same email as a demo rep, merge into demo (keep demo's customers/visits/etc, update profile fields)
    const demoEmails = new Set(ADMIN_REP_DATA.map(r=>r.email?.toLowerCase()));
    const merged = ADMIN_REP_DATA.map(demo => {
      const liveMatch = liveReps.find(lr => lr.email?.toLowerCase() === demo.email?.toLowerCase());
      if(liveMatch) {
        // Live rep matches demo — update profile fields but keep demo's rich data (customers, visits, prospects, ytdSales)
        return { ...demo, name:liveMatch.name||demo.name, phone:liveMatch.phone||demo.phone, territory:liveMatch.territory||demo.territory, supabaseId:liveMatch.id };
      }
      return demo;
    });
    // Add truly new liveReps (no email match in demo data)
    const newLive = liveReps.filter(lr => !demoEmails.has(lr.email?.toLowerCase()));
    // The per-browser deleted list only hides demo/non-live reps; live reps (Supabase) are governed by
    // the Supabase-derived hidden set, so a rep restored on another device is never hidden by stale local state.
    const base = [...merged,...newLive].filter(r=>((r.isLive||r.supabaseId)||!deleted.has(r.id)) && !isHiddenRep(r));
    return base.map(r => overrides[r.id] ? {...r,...overrides[r.id]} : r);
  });
  // When a rep is deleted/paused while this tab is open (this or a later hydrate), drop it from the
  // local list and close any detail/edit view for it. Display only; no data is written.
  useEffect(()=>{
    if(!hiddenRepKey || hiddenRepKey==="#") return;
    setReps(rs=>{
      const next=rs.filter(r=>!isHiddenRep(r));
      return next.length===rs.length?rs:next;
    });
    setSelectedRep(s=>{ const id=(s&&typeof s==="object")?s.id:s; return (id!=null && hiddenRepIds.has(String(id)))?null:s; });
    setEditingRep(e=>(e!=null && hiddenRepIds.has(String(e)))?null:e);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[hiddenRepKey]);

  // Subscribe to shared visits from rep portal (localStorage mirror).
  const [sharedVisits, setSharedVisits] = useState(()=>SHARED_VISITS.getAll());
  useEffect(()=>SHARED_VISITS.subscribe(v=>setSharedVisits(v)),[]);

  // Phase B — also hydrate shop_visits from Supabase on admin mount and
  // subscribe to realtime INSERTs. Admin's RLS allows reading every row
  // (admin_all_visits policy). Rows are merged into SHARED_VISITS so the
  // existing Reps tab view (which filters sharedVisits by rep name) sees
  // visits from reps on other devices without a page reload. localStorage
  // is never cleared — admin's local cache grows as rows arrive.
  useEffect(()=>{
    let mounted = true;
    const dbRowToVisit = (r) => ({
      id: r.client_id || r.id,
      _supabaseUuid: r.id,
      rep: r.rep_name || "",
      company: r.shop_name || "",
      date: r.visited_at ? new Date(r.visited_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
      note: r.notes || "",
      type: r.visit_type || "shop_visit",
      duration: Number(r.duration_minutes) || 30,
      createdAt: r.created_at || r.visited_at || new Date().toISOString(),
      fromDb: true,
    });
    const mergeRows = (rows) => {
      const existing = SHARED_VISITS.getAll();
      const existingIds = new Set(existing.map(v => String(v.id)));
      let added = 0;
      (rows || []).forEach(r => {
        const v = dbRowToVisit(r);
        if (existingIds.has(String(v.id))) return;
        SHARED_VISITS.add(v);
        existingIds.add(String(v.id));
        added++;
      });
      if (added > 0) console.info(`[admin shop_visits hydrate] merged ${added} row(s) from Supabase.`);
    };
    (async () => {
      try {
        const rows = await listShopVisits(null); // admin fetches all
        if (mounted) mergeRows(rows);
      } catch(e) { console.warn("[admin shop_visits] mount fetch failed:", e?.message||e); }
    })();
    const unsub = subscribeShopVisits(null, async () => {
      if (!mounted) return;
      try {
        const rows = await listShopVisits(null);
        if (mounted) mergeRows(rows);
      } catch(e) { console.warn("[admin shop_visits] realtime refetch failed:", e?.message||e); }
    });
    return () => { mounted = false; if (typeof unsub === "function") unsub(); };
  },[]);

  // Subscribe to shared rep profiles — when rep edits their own profile, update admin view
  useEffect(()=>{
    const unsub = SHARED_REP_PROFILES.subscribe((profiles)=>{
      const allProfiles = Object.values(profiles);
      setReps(rs=>rs.map(r=>{
        // Match by id, supabaseId, or email
        const shared = profiles[r.id] || profiles[r.supabaseId] || profiles[r.email]
          || allProfiles.find(p => p.email && p.email.toLowerCase() === r.email?.toLowerCase());
        if(!shared) return r;
        const changed = shared.name!==r.name || shared.email!==r.email || shared.phone!==r.phone || shared.territory!==r.territory;
        if(!changed) return r;
        return {...r, name:shared.name||r.name, email:shared.email||r.email, phone:shared.phone||r.phone, territory:shared.territory||r.territory };
      }));
    });
    return unsub;
  },[]);

  // Subscribe to shared rep customers — when rep edits their customer list, admin sees it
  const [sharedRepCusts, setSharedRepCusts] = useState(()=>SHARED_REP_CUSTOMERS.getAll());
  useEffect(()=>SHARED_REP_CUSTOMERS.subscribe(d=>setSharedRepCusts(d)),[]);

  // Live SHARED_INVOICES so per-rep YTD sales / unit counts / commission stay
  // in sync with the Rep Commission page and the AdminCommissionTab below.
  // Admin-visible = live invoices minus removed ones (shared selector, F5).
  const sharedInvoicesLive = useAdminVisibleInvoices();

  // FIX (2026-04-20): admin's rep list previously carried the hardcoded
  // fallback rate (6 for live reps, 8 for Marcus seed). The actual rate
  // admin set via the rep's edit form lives in TWO places: Supabase
  // rep_commission_rates (authoritative, cross-device) AND SHARED_SETTINGS
  // localStorage. Neither was consulted here, so the rep-detail view's
  // "Commission: 8%" disagreed with the rep portal's "10%" which does
  // read SHARED_SETTINGS. Patch the reps state with the real rate as
  // soon as we can load it.
  const [supabaseRates, setSupabaseRates] = useState({});
  useEffect(()=>{
    let cancelled = false;
    (async ()=>{
      try {
        const rows = await getRepCommissionRates();
        if (cancelled) return;
        const map = {};
        (rows || []).forEach(r => { if (r?.rep_id != null) map[String(r.rep_id)] = r.rate; });
        setSupabaseRates(map);
      } catch(e) {
        console.warn("[AdminRepsTab] getRepCommissionRates failed:", e?.message || e);
      }
    })();
    return () => { cancelled = true; };
  },[]);
  // Keep the reps state in sync with the resolved rates — runs whenever the
  // Supabase rates cache refreshes. Only touches rep.rate; everything else
  // about the rep row is preserved (customers, visits, territory, etc.).
  const _extractRateValue = (stored) => {
    if (stored == null) return null;
    if (typeof stored === "object") return stored.rate ?? null;
    return stored;
  };
  useEffect(()=>{
    setReps(prev => prev.map(r => {
      const idText = r.id != null ? String(r.id) : "";
      const supaRate = idText && supabaseRates[idText] != null ? Number(supabaseRates[idText]) : null;
      if (supaRate != null && supaRate !== r.rate) return { ...r, rate: supaRate };
      const liveSetting = r.name ? _extractRateValue(SHARED_SETTINGS.getRepRate(r.name)) : null;
      if (supaRate == null && liveSetting != null && Number(liveSetting) !== r.rate) {
        return { ...r, rate: Number(liveSetting) };
      }
      return r;
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[supabaseRates]);
  // Also listen for SHARED_SETTINGS subscribes so an admin edit on the
  // same browser propagates without a reload.
  useEffect(()=>{
    if (!SHARED_SETTINGS.subscribe) return;
    return SHARED_SETTINGS.subscribe(({repRates})=>{
      setReps(prev => prev.map(r => {
        const setting = r.name ? _extractRateValue(repRates?.[r.name]) : null;
        if (setting != null && Number(setting) !== r.rate) return { ...r, rate: Number(setting) };
        return r;
      }));
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // One-call helper: returns { ytdRevenue, ytdUnits, ytdEarned, ... } for a rep.
  const repMetricsFor = (rep) => computeRepMetrics({
    repName: rep.name,
    customerNames: collectRepCustomerNames({
      repName: rep.name,
      assignedAccounts: allAccounts,
      sharedRepCustomers: sharedRepCusts[rep.name],
      staticCustomers: rep.customers || [],
    }),
    allInvoices: sharedInvoicesLive,
    rate: rep.rate || 0,
  });

  // Merge shared rep customers into each rep's customer/prospect lists
  const repsWithCustomers = reps.map(r => {
    const shared = sharedRepCusts[r.name];
    if(!shared) return r;
    // Replace demo customers with live rep customer data if available
    const liveCustomers = shared.customers;
    const liveProspects = shared.prospects;
    if(!liveCustomers || liveCustomers.length===0) return r;
    // Merge: use shared customers as primary, fill in any demo-only customers not in shared data
    const sharedCompanies = new Set(liveCustomers.map(c=>(c.company||"").toLowerCase()));
    const demoOnly = (r.customers||[]).filter(c=>!sharedCompanies.has((c.company||"").toLowerCase()));
    const mergedCustomers = [...liveCustomers, ...demoOnly];
    // For prospects: if shared has prospects, use them; otherwise keep demo
    const mergedProspects = (liveProspects && liveProspects.length > 0)
      ? liveProspects
      : (r.prospects || []);
    return {...r, customers: mergedCustomers, prospects: mergedProspects};
  });

  // Merge shared visits into each rep's visit list (de-duplicate by date+company+note)
  const repsWithVisits = repsWithCustomers.map(r => {
    const repShared = sharedVisits.filter(v=>v.rep===r.name);
    if(repShared.length===0) return r;
    const existingKeys = new Set((r.visits||[]).map(v=>v.date+"|"+v.company+"|"+v.note));
    const newVisits = repShared.filter(v=>!existingKeys.has(v.date+"|"+v.company+"|"+v.note))
      .map(v=>({date:v.date,company:v.company,type:v.type||"shop_visit",note:v.note||"",duration:v.duration||30}));
    if(newVisits.length===0) return r;
    const merged = [...newVisits,...(r.visits||[])].sort((a,b)=>b.date.localeCompare(a.date));
    return {...r, visits:merged};
  });

  const [repSearch,setRepSearch]=useState("");
  // Top-bar stat-card filter. Clicking a card narrows the rep list below
  // to reps who contribute to that metric (e.g. "Potential customers" shows
  // only reps with at least one prospect). Click-again or "Total reps" resets.
  const [repListFilter,setRepListFilter]=useState("all");
  const [selectedRep, setSelectedRep] = useState(null);
  const [viewTab, setViewTab] = useState("activity"); // activity | assigned | customers | prospects | commission
  const [period, setPeriod] = useState("all"); // today | week | month | all
  // Optional visit-type filter set when admin clicks a "Shop visits" / "Follow-ups"
  // / "Cold calls" stat card on the detail page. "" means show all types.
  const [visitTypeFilter, setVisitTypeFilter] = useState("");
  const [assignedAcctSearch, setAssignedAcctSearch] = useState("");
  // Legacy paid-periods map (mpcare_commission_paid_periods). Still read as
  // a fallback so pre-this-deploy paid periods don't silently flip back to
  // pending. New payouts go to Supabase rep_commission_payments below.
  const [detailPaidMap, setDetailPaidMap] = useState(loadPaidPeriods);
  useEffect(()=>{
    const reload = () => setDetailPaidMap(loadPaidPeriods());
    window.addEventListener("focus", reload);
    window.addEventListener("storage", reload);
    return ()=>{
      window.removeEventListener("focus", reload);
      window.removeEventListener("storage", reload);
    };
  },[]);
  // Per-invoice commission payout rows from Supabase — shared source of
  // truth with AdminCommissionTab + RepCommission. Subscribed so admin's
  // own "mark paid" / "undo" actions on either tab propagate here live.
  const [detailPaidRows, setDetailPaidRows] = useState([]);
  const detailPaidInvoiceIds = useMemo(() => {
    const s = new Set();
    detailPaidRows.forEach(r => { if (r?.invoice_id) s.add(r.invoice_id); });
    return s;
  },[detailPaidRows]);
  useEffect(()=>{
    let cancelled = false;
    (async () => {
      const rows = await listRepCommissionPayments();
      if (!cancelled) setDetailPaidRows(rows);
    })();
    const unsub = subscribeRepCommissionPayments(async () => {
      const rows = await listRepCommissionPayments();
      if (!cancelled) setDetailPaidRows(rows);
    });
    return () => { cancelled = true; unsub && unsub(); };
  },[]);
  // Commission corrections ledger for the rep detail Commission sub-tab
  // (fetched on mount + realtime, paged payments reader, same as the top-level tab).
  // Only loaded (and subscribed) while the rep's Commission sub-tab is open.
  const detailLedger = useCommissionLedger({ enabled: !!selectedRep && viewTab === "commission" });
  // Rep remittances (0033) for the badges and the warn-only Mark Paid gate of this sub-tab.
  // Loaded (and subscribed) only while a rep's Commission sub-tab is open, like the ledger above.
  const detailRemit = useRemittanceList({ enabled: !!selectedRep && viewTab === "commission" });
  // The tick is the KEY of the warning it acknowledges (warned invoice ids + pay-through date);
  // cleared whenever the detail Mark Paid modal opens, and invalid as soon as the warning changes.
  const [detailRemitAckKey, setDetailRemitAckKey] = useState("");
  // Commission sub-tab Delete (= void with a required reason): see CommissionInvoiceDelete.
  const [detailDeleteFor, setDetailDeleteFor] = useState(null);
  const [detailDeleteNotice, setDetailDeleteNotice] = useState(null);   // { level: "ok" | "warn" | "bad", text }
  // Commission sub-tab Adjust: see CommissionInvoiceAdjust (same modal, same guards).
  const [detailAdjustFor, setDetailAdjustFor] = useState(null);
  const detailPendingReqIds = usePendingRequestInvoiceIds(!!selectedRep && viewTab === "commission");
  const detailAdjBlock = (inv) => adminAdjustBlockReason(inv, { pendingIds: detailPendingReqIds });
  const afterDetailDelete = async (n) => {
    setDetailDeleteNotice(n);
    try { setDetailPaidRows(await listRepCommissionPayments()); }
    catch (e) { console.warn("[AdminRepsTab] refresh of payout rows after delete failed:", e?.message || e); }
    detailLedger.reload();
  };
  const [detailCorrSel, setDetailCorrSel] = useState(null);   // null = not initialised yet
  const [detailCorrOnly, setDetailCorrOnly] = useState(false);
  const [detailPayNotice, setDetailPayNotice] = useState("");
  // Mark-paid modal state for the rep detail Commission sub-tab.
  const [detailMarkingPeriod, setDetailMarkingPeriod] = useState(null);
  const [detailPayForm, setDetailPayForm] = useState({date:"", method:"ACH", notes:""});
  const [detailMarkBusy, setDetailMarkBusy] = useState(false);
  // Expandable invoice rows inside the Commission sub-tab (one at a time).
  const [detailExpandedPeriod, setDetailExpandedPeriod] = useState(null);

  // ── Phase A authoritative join — rep_route_customers UUID match ────────────
  // The fuzzy-name matcher below catches typical variants ("Marcus Thompson"
  // vs "Marcus T." vs "Marcus") but cannot tolerate single-letter typos or
  // historical name drift (e.g. customer_settings.rep = "Adam Kakoom" while
  // the rep profile is now "Adam Kakoon"). Phase A's rep_route_customers
  // table holds the authoritative UUID-keyed assignment, so we use it as a
  // fallback: any account whose id matches an active customer_key for this
  // rep's UUID counts as assigned regardless of customer_settings.rep
  // spelling. customer_settings.rep is left exactly as the admin / signup
  // saved it — we never rewrite a single user-entered string.
  //
  // Loaded inside this component (not piped down via prop) so the change is
  // self-contained. listAllRepRouteCustomers is admin-RLS-gated; reps and
  // customers cannot reach this code path. Active rows only.
  const [repRouteRows, setRepRouteRows] = useState([]);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listAllRepRouteCustomers();
        if (!cancelled) setRepRouteRows((rows || []).filter(r => r && r.active));
      } catch (e) {
        console.warn("[AdminRepsTab] listAllRepRouteCustomers failed:", e?.message || e);
        // Leave previous state in place; matcher will fall back to name match.
      }
    };
    load();
    const unsub = subscribeAllRepRouteCustomers(() => { load(); });
    return () => { cancelled = true; unsub && unsub(); };
  }, []);

  // Build map of rep name → assigned accounts from the admin accounts list.
  //
  // Why this is fuzzy-matched, not exact-string-matched:
  //   The `ac.rep` field on an account can be set from three places, and they
  //   don't always use the same form of the rep's name:
  //     • Admin edit     → writes rep's display name as shown in the admin UI
  //                        (usually the full profile full_name, e.g. "Marcus Thompson")
  //     • Customer signup → writes whatever the customer typed into the rep-name
  //                         field (often a short form, e.g. "Marcus T." or "Marcus")
  //     • INIT_ACCOUNTS  → seed data uses the short "First L." form (e.g. "Marcus T.")
  //   Exact equality on `ac.rep === rep.name` silently drops every customer whose
  //   rep was captured with a different variant — so a rep with 8 real customers
  //   could show "Assigned accounts: 0". Instead we build an identifier set per
  //   rep (full name, email, id, supabaseId, "First L." short form, first-name
  //   only) and match an account when its `rep` field normalises to any of them.
  //   Plus the Phase A UUID fallback above for any drift the name match misses.
  const _normRepId = (s) => String(s||"").trim().toLowerCase();
  const _repIdentifiers = (rep) => {
    const ids = new Set();
    const add = (v) => { const n = _normRepId(v); if (n) ids.add(n); };
    add(rep.name); add(rep.email); add(rep.id); add(rep.supabaseId);
    if (rep.name) {
      const parts = String(rep.name).trim().split(/\s+/);
      if (parts.length >= 2 && parts[1]) {
        add(parts[0] + " " + parts[1][0] + "."); // "Marcus T."
        add(parts[0] + " " + parts[1][0]);        // "Marcus T"
        add(parts[0]);                             // "Marcus"
      }
    }
    return ids;
  };
  // Read admin-edit overrides once so we can tag each match with the assignment
  // source (admin edit vs. customer signup). If a localStorage override for an
  // account contains an explicit rep field, an admin wrote it via the Accounts
  // tab — otherwise the rep came from the customer's signup profile (or from
  // the INIT_ACCOUNTS seed, which we treat as admin-seeded for display purposes
  // since a real admin pre-populated it).
  const _acctOverridesForSource = (() => {
    try { const r = localStorage.getItem("mpcare_acct_overrides"); return r ? JSON.parse(r) : {}; }
    catch(e){ return {}; }
  })();
  const _assignedBy = (ac) => {
    const ov = _acctOverridesForSource[ac.id];
    if (ov && typeof ov.rep === "string" && ov.rep.trim()) return "admin";
    if (ac.isLive) return "customer_signup";
    return "admin"; // seed data (INIT_ACCOUNTS) was admin-pre-populated
  };
  // Iterate reps (not accounts) so we can match each rep's identifier set
  // against every account in one pass. Two parallel join paths:
  //   (1) Fuzzy-name match against ac.rep — handles common variants like
  //       "Marcus T." vs "Marcus Thompson" (legacy / customer-signup data).
  //   (2) Phase A UUID-keyed match against rep_route_customers — handles
  //       any drift the fuzzy match can't tolerate (typos, rep renames).
  // Either path counts. customer_settings.rep is never rewritten — the fix
  // is purely additive on the read side.
  const repAssignedAccounts = (() => {
    const map = {};
    (repsWithVisits||[]).forEach(rep => {
      const ids = _repIdentifiers(rep);
      // Phase A: collect customer_keys for this rep's active rep_route_customers
      // rows. rep_id on the table is TEXT — UUID-as-text for live reps or the
      // demo int-as-text for seed reps. customer_key is the dealer's
      // profiles.id::text; ac.id on a live account is that same profile UUID.
      const repIdStr = rep.supabaseId
        ? String(rep.supabaseId)
        : (rep.id != null ? String(rep.id) : "");
      const uuidKeys = new Set();
      if (repIdStr) {
        (repRouteRows || []).forEach(r => {
          if (r && String(r.rep_id) === repIdStr) {
            uuidKeys.add(String(r.customer_key));
          }
        });
      }
      const matches = (allAccounts||[]).filter(ac => {
        // Display-only: deleted/paused dealers are removed from the rep's assigned list/counts.
        // (allAccounts itself is untouched, so commission/history lookups elsewhere still resolve them.)
        if (ac.status === "deleted" || ac.status === "paused") return false;
        // (1) Fuzzy-name match
        const field = _normRepId(ac.rep);
        if (field && ids.has(field)) return true;
        // (2) Phase A UUID-keyed authoritative match
        if (uuidKeys.has(String(ac.id))) return true;
        return false;
      }).map(ac => ({ ...ac, _assignedBy: _assignedBy(ac) }));
      map[rep.name] = matches;
    });
    return map;
  })();
  const [editingRep, setEditingRep] = useState(null);
  const [editRepData, setEditRepData] = useState(null);
  const [confirmDeleteRep, setConfirmDeleteRep] = useState(null);
  const [reviewingApp, setReviewingApp] = useState(null);
  const [expandedRepCust, setExpandedRepCust] = useState(null); // customer id expanded in rep detail
  const [repCustViewInvoice, setRepCustViewInvoice] = useState(null); // invoice being viewed from rep customer

  const startEditRep = (rep) => { setEditRepData({...rep}); setEditingRep(rep.id); };
  const [saveRepError, setSaveRepError] = useState("");
  const [saveRepBusy, setSaveRepBusy] = useState(false);
  const saveRepEdit = async () => {
    if (saveRepBusy) return;
    setSaveRepError("");
    const updated = {...editRepData};
    // Local-only updates first so the admin sees the change immediately.
    setReps(rs=>rs.map(r=>r.id===editingRep?{...r,...updated}:r));
    const overrides = loadRepOverrides();
    overrides[editingRep] = { rate:updated.rate, paySchedule:updated.paySchedule, name:updated.name, email:updated.email, phone:updated.phone, territory:updated.territory, notes:updated.notes, startDate:updated.startDate, ytdSales:updated.ytdSales };
    saveRepOverrides(overrides);
    SHARED_SETTINGS.setRepRate(updated.name, updated.rate||0, updated.paySchedule);
    const repProfileKey = updated.supabaseId || updated.id || updated.email || editingRep;
    SHARED_REP_PROFILES.set(repProfileKey, { name:updated.name, email:updated.email, phone:updated.phone, territory:updated.territory, refCode:updated.refCode||"" });
    if(updated.email) SHARED_REP_PROFILES.set(updated.email, { name:updated.name, email:updated.email, phone:updated.phone, territory:updated.territory, refCode:updated.refCode||"" });

    // Supabase write for the commission rate is AWAITED (not fire-and-forget
    // anymore). The old version swallowed errors with .catch(console.warn),
    // which is how the admin could save 10% in this modal, have the Supabase
    // write silently fail and then see 8% in the Commission tab on every
    // device — because that tab's sole source of truth is Supabase. Awaiting
    // + surfacing the error is the CLAUDE.md rule #5: no silent catches
    // around writes.
    //
    // We write ONLY under the Supabase UUID. Production's
    // rep_commission_rates.rep_id column is uuid-typed (the migration file
    // says TEXT but the live schema diverged), so writing the demo integer
    // id "1" — which the previous version also tried for redundancy — is
    // rejected at the DB layer with "invalid input syntax for type uuid".
    // Demo-only reps (no Supabase auth user) keep their rate in
    // SHARED_SETTINGS / localStorage only, which is fine — the Commission
    // tab's _resolveRate falls back to SHARED_SETTINGS when no Supabase row
    // is found.
    const isUuid = (s) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(s||""));
    const supabaseUuid =
      isUuid(updated.supabaseId) ? String(updated.supabaseId) :
      isUuid(editingRep)         ? String(editingRep)         :
      isUuid(updated.id)         ? String(updated.id)         :
      null;

    if (!supabaseUuid) {
      // Demo-only rep with no Supabase auth user. Local stores were already
      // updated above; nothing to write to Supabase. Close cleanly — this is
      // the historical / expected behavior for seed-only reps.
      setEditingRep(null); setEditRepData(null);
      return;
    }

    setSaveRepBusy(true);
    let writeError = null;
    try {
      await setRepCommissionRate(supabaseUuid, updated.rate||0);
    } catch(e) {
      console.warn(`[saveRepEdit] rep_commission_rates write failed for rep_id=${supabaseUuid}:`, e?.message||e);
      writeError = e?.message || String(e);
    }
    setSaveRepBusy(false);

    if (writeError) {
      // The admin NEEDS to know — the Commission tab will keep showing the
      // old rate until Supabase accepts the write.
      setSaveRepError(
        "Commission rate could not save to the database. The rate is updated on " +
        "this browser but the Commission tab (and other devices) will still show " +
        "the old rate until Supabase accepts the write.\n\n" +
        "Details (rep_id=" + supabaseUuid + "): " + writeError + "\n\n" +
        "This usually means the current admin session doesn't satisfy the " +
        "rep_commission_rates RLS policy (is_admin() requires profiles.role='admin' " +
        "for your auth user)."
      );
      return;
    }
    setEditingRep(null); setEditRepData(null);
  };
  // ── Rep suspension (pause + delete) ──
  // Mirrors the customer-side flow in AdminPanel.applySuspension. Rep suspension
  // is stored in mpcare_rep_overrides[id] with status/reason/snapshot so the
  // "Deleted & paused accounts" section under the Accounts tab can render the
  // rep's name, reason, date, and history even after they're removed from the
  // reps list. mpcare_deleted_reps is kept in sync for backward compat with
  // existing dropdown filters elsewhere in the app.
  const [suspendRepModal,setSuspendRepModal]=useState(null); // { rep, mode:"pause"|"delete" }
  const [suspendRepReason,setSuspendRepReason]=useState("");
  const [suspendRepSubmitting,setSuspendRepSubmitting]=useState(false);
  const openSuspendRepModal = (rep,mode) => {
    // Pause AND Delete for a rep that has a real Supabase profile go through the strict,
    // Supabase-first modals owned by AdminPanel (softPauseProfile / softDeleteProfile).
    // Only demo-only seed reps (no profile) keep the legacy local modal.
    if(rep.supabaseId||rep.isLive){
      if(mode==="delete" && typeof onRequestDelete==="function"){ onRequestDelete(rep); return; }
      if(mode==="pause" && typeof onRequestPause==="function"){ onRequestPause(rep); return; }
    }
    setSuspendRepModal({rep,mode}); setSuspendRepReason("");
  };
  const applyRepSuspension = async () => {
    if(!suspendRepModal) return;
    const { rep, mode } = suspendRepModal;
    const reason = (suspendRepReason||"").trim();
    if(!reason) return;
    setSuspendRepSubmitting(true);
    const nowIso = new Date().toISOString();
    const nextStatus = mode==="delete" ? "deleted" : "paused";
    // 1) Remove from local reps list — it'll show up in the suspended section instead.
    setReps(rs=>rs.filter(r=>r.id!==rep.id));
    // 2) Persist override with a full snapshot + reason so the suspended section
    //    can render the rep's name, email, territory, and history with no extra lookup.
    const overrides = loadRepOverrides();
    overrides[rep.id] = {
      ...(overrides[rep.id]||{}),
      // Snapshot fields for the suspended section
      name: rep.name, email: rep.email, phone: rep.phone, territory: rep.territory,
      rate: rep.rate, paySchedule: rep.paySchedule, startDate: rep.startDate,
      refCode: rep.refCode, supabaseId: rep.supabaseId, isLive: !!rep.isLive,
      // Suspension metadata
      status: nextStatus,
      ...(mode==="delete"
        ? {deletion_reason:reason, deleted_at:nowIso, paused_reason:null, paused_at:null}
        : {paused_reason:reason, paused_at:nowIso, deletion_reason:null, deleted_at:null})
    };
    saveRepOverrides(overrides);
    // 3) Keep the legacy deleted-reps list in sync so existing filters keep working.
    const deleted = loadDeletedReps();
    [rep.id, rep.email, rep.supabaseId].filter(Boolean).forEach(k=>{ if(!deleted.includes(k)) deleted.push(k); });
    saveDeletedReps(deleted);
    // 4) SHARED_REP_PROFILES is off-limits (avatars / phone / territory) so it is NOT scrubbed here.
    //    Pickers filter deleted/paused reps by the Supabase-derived inactive set instead.
    // 5) Legacy path: normally only reached for demo-only reps with no profile row (live reps use
    //    the strict AdminPanel helpers). Supabase: approved=false + rejected=true blocks login.
    if(rep.supabaseId || rep.isLive) {
      const sbId = rep.supabaseId || rep.id;
      const payload = {
        approved:false, rejected:true, status: nextStatus,
        ...(mode==="delete" ? {deletion_reason:reason, deleted_at:nowIso}
                             : {paused_reason:reason, paused_at:nowIso})
      };
      try { await updateProfile(sbId,payload); }
      catch(e){ console.warn("Suspend rep DB sync:",e?.message); }
    }
    setSuspendRepSubmitting(false);
    setSuspendRepModal(null);
    setSuspendRepReason("");
    setConfirmDeleteRep(null); // close the legacy modal if it was the trigger
    setSelectedRep(null);
    // Notify AdminPanel so the Deleted & paused accounts section picks up
    // the new rep entry from mpcare_rep_overrides on the next render.
    if(typeof onRepSuspensionChange==="function") onRepSuspensionChange();
  };
  // Legacy handler kept for any existing callers — routes to the new modal.
  const deleteRep = (id) => {
    const repToDelete = reps.find(r=>r.id===id);
    if(repToDelete) openSuspendRepModal(repToDelete,"delete");
  };

  const today = new Date().toISOString().slice(0,10);
  const weekAgo = new Date(Date.now()-7*86400000).toISOString().slice(0,10);
  const monthAgo = new Date(Date.now()-30*86400000).toISOString().slice(0,10);

  const filterVisits = (visits) => {
    let out = visits;
    if(period==="today") out = out.filter(v=>v.date===today);
    else if(period==="week")  out = out.filter(v=>v.date>=weekAgo);
    else if(period==="month") out = out.filter(v=>v.date>=monthAgo);
    // Visit-type filter when admin clicked Shop visits / Follow-ups / Cold calls
    // card on the detail page.
    if(visitTypeFilter) out = out.filter(v=>v.type===visitTypeFilter);
    return out;
  };

  const getRepStats = (rep) => {
    const visits = rep.visits || [];
    const todayV = visits.filter(v=>v.date===today).length;
    const weekV  = visits.filter(v=>v.date>=weekAgo).length;
    const monthV = visits.filter(v=>v.date>=monthAgo).length;
    const shopVisits = visits.filter(v=>v.type==="shop_visit").length;
    const followUps  = visits.filter(v=>v.type==="follow_up").length;
    const coldCalls  = visits.filter(v=>v.type==="cold_call").length;
    const avgDuration = visits.length>0 ? Math.round(visits.reduce((s,v)=>s+v.duration,0)/visits.length) : 0;
    return {todayV,weekV,monthV,shopVisits,followUps,coldCalls,avgDuration,total:visits.length};
  };

  const typeLabel = {shop_visit:"Shop visit",follow_up:"Follow-up",cold_call:"Cold call"};
  const typeStyle = {shop_visit:S.pillGreen,follow_up:S.pillBlue,cold_call:S.pillPurple};

  const exportCustomers = (rep) => {
    const headers = ["Company","Contact","Email","Phone","Address","Tier","Priority","EIN","YTD Sales","Last Visit","Visit Cycle (days)"];
    const rows = (rep.customers||[]).map(c=>[c.company,c.contact,c.email,c.phone,c.address,c.tier,c.priority,c.ein||"",c.ytd||0,c.lastVisit||"",c.visitCycle||30]);
    const csv = [headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob([csv],{type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href=url; a.download=`${rep.name.replace(/\s/g,"_")}_customers.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  const exportActivity = (rep) => {
    const headers = ["Date","Company","Type","Notes","Duration (min)"];
    const filtered = filterVisits(rep.visits);
    const rows = filtered.map(v=>[v.date,v.company,typeLabel[v.type]||v.type,v.note,v.duration]);
    const csv = [headers,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob = new Blob([csv],{type:"text/csv"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href=url; a.download=`${rep.name.replace(/\s/g,"_")}_activity_log.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  const visitDays = (lastVisit,cycle=30) => {
    if(!lastVisit) return {days:999,color:C.red,label:"Never"};
    const days = Math.floor((Date.now()-new Date(lastVisit))/(1000*60*60*24));
    if(days<=cycle*0.7) return {days,color:C.teal,label:`${days}d ago`};
    if(days<=cycle) return {days,color:C.amber,label:`${days}d ago`};
    return {days,color:C.red,label:`${days}d ago`};
  };

  // ── Rep detail view ── (use repsWithVisits so shared visits show up)
  const detailRep = selectedRep ? repsWithVisits.find(r=>r.id===selectedRep) : null;
  const detailStats = detailRep ? getRepStats(detailRep) : null;
  const detailFiltered = detailRep ? filterVisits(detailRep.visits||[]) : [];
  const detailMetrics = detailRep ? repMetricsFor(detailRep) : null;

  // ── Duplicate route-customer detector (admin cleanup tool) ─────────────────
  // Reported bug: a rep re-adding a business already on their list got a
  // brand-new row instead of being told it already existed — every manually
  // added prospect/customer gets a fresh customer_key ("local-<timestamp>",
  // see RepPortal.js's keyOf), so the UNIQUE(rep_id, customer_key) constraint
  // never catches it since the keys never collide. The add-flow itself is
  // now fixed (RepRoutePlanner / RepPotentialCustomers block the duplicate
  // at submit time by company name), but that does nothing for rows created
  // before the fix shipped. This surfaces those pre-existing duplicates
  // here for admin to review and merge — it NEVER auto-merges anything;
  // every merge is one explicit admin click per group, and the losing
  // row(s) are soft-deactivated (active=false via the existing
  // deactivateRepRouteCustomer — never a hard DELETE), matching this
  // table's established pattern everywhere else in the app.
  const detailRepRouteRows = detailRep ? (() => {
    const repIdStr = detailRep.supabaseId ? String(detailRep.supabaseId) : (detailRep.id != null ? String(detailRep.id) : "");
    if (!repIdStr) return [];
    return (repRouteRows||[]).filter(r => r && String(r.rep_id) === repIdStr);
  })() : [];
  const dupGroups = (() => {
    const groups = {};
    detailRepRouteRows.forEach(r => {
      const name = String(r.customer_data?.company||"").trim().toLowerCase();
      if (!name) return;
      (groups[name] = groups[name] || []).push(r);
    });
    return Object.values(groups).filter(g => g.length > 1);
  })();
  const [mergeReview, setMergeReview] = useState(false);
  const [mergeBusy, setMergeBusy] = useState(null); // customer_key currently merging
  const mergeDuplicateGroup = async (group, keepRow) => {
    if (mergeBusy) return;
    const repIdStr = detailRep.supabaseId ? String(detailRep.supabaseId) : String(detailRep.id);
    const others = group.filter(r => r.customer_key !== keepRow.customer_key);
    setMergeBusy(keepRow.customer_key);
    try {
      // Fill any field the kept row is missing from the other row(s) —
      // never overwrite something the kept row already has.
      const merged = { ...(keepRow.customer_data || {}) };
      ['contact','email','phone','address','city','state','zip','ein','website','notes'].forEach(f => {
        if (!merged[f]) { const donor = others.find(o => o.customer_data?.[f]); if (donor) merged[f] = donor.customer_data[f]; }
      });
      // Union every row's visit history so a merge can never lose a logged
      // visit, deduped by date+note.
      const seen = new Set();
      merged.visitHistory = [keepRow, ...others]
        .flatMap(r => r.customer_data?.visitHistory || [])
        .filter(v => { const k = `${v.date}|${v.note}`; if (seen.has(k)) return false; seen.add(k); return true; })
        .sort((a,b)=>String(b.date||"").localeCompare(String(a.date||"")));
      const lastVisits = [keepRow, ...others].map(r=>r.customer_data?.lastVisit).filter(Boolean).sort();
      if (lastVisits.length) merged.lastVisit = lastVisits[lastVisits.length-1];

      const saved = await upsertRepRouteCustomer({
        repId: repIdStr, repName: detailRep.name,
        customerKey: keepRow.customer_key, customerData: merged,
        isProspect: keepRow.is_prospect, source: keepRow.source, active: true,
      });
      if (!saved) { alert("Merge failed to save — check your connection and try again. Nothing was changed."); return; }
      for (const o of others) { await deactivateRepRouteCustomer(repIdStr, o.customer_key); }
      // repRouteRows refreshes itself via the admin-wide realtime
      // subscription (subscribeAllRepRouteCustomers) already wired above —
      // no manual refetch needed.
    } catch (e) {
      console.warn("[AdminRepsTab] mergeDuplicateGroup failed:", e?.message || e);
      alert("Merge failed: " + (e?.message || e) + ". Nothing was changed.");
    } finally {
      setMergeBusy(null);
    }
  };

  // ── Rep list overview ──
  const filteredReps=repsWithVisits.filter(r=>{
    // Stat-card filter — narrow to reps that contribute to the clicked metric.
    if(repListFilter==="assigned"  && !((repAssignedAccounts[r.name]||[]).length>0)) return false;
    if(repListFilter==="customers" && !((r.customers||[]).length>0)) return false;
    if(repListFilter==="prospects" && !((r.prospects||[]).length>0)) return false;
    if(repListFilter==="visits30"  && !(r.visits.filter(v=>v.date>=monthAgo).length>0)) return false;
    if(repListFilter==="ytdsales"  && !(repMetricsFor(r).ytdRevenue>0)) return false;
    if(!repSearch)return true;
    // Trim to handle pasted ref codes with stray whitespace.
    const q=repSearch.trim().toLowerCase();
    if(!q) return true;
    return r.name.toLowerCase().includes(q)||r.email.toLowerCase().includes(q)||(r.territory||"").toLowerCase().includes(q)||(r.refCode||"").toLowerCase().includes(q)||(r.phone||"").includes(q);
  });

  return (
    <div>
      {/* ── Rep detail view ── */}
      {detailRep&&detailStats&&(<>
        <button style={{...S.btnGhost,marginBottom:16}} onClick={()=>setSelectedRep(null)}>← Back to all reps</button>
        <div style={{...S.card,padding:"20px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:16}}>
            <div style={{width:52,height:52,borderRadius:"50%",background:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:700,color:C.blue}}>
              {detailRep.name.split(" ").map(w=>w[0]).join("").toUpperCase()}
            </div>
            <div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18,fontWeight:600,color:C.ink}}>{detailRep.name}</span>
                {detailRep.refCode&&<span style={{fontSize:11,fontFamily:"monospace",color:C.blue,background:C.blueLight,padding:"2px 8px",borderRadius:4}}>{detailRep.refCode}</span>}
              </div>
              <div style={{fontSize:12,color:C.inkLight}}>{detailRep.email} · {detailRep.phone}</div>
              <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>Territory: {detailRep.territory} · Since {detailRep.startDate} · Commission: {detailRep.rate}%</div>
            </div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button style={S.btnSecondary} onClick={()=>startEditRep(detailRep)}>Edit rep</button>
            {/* Role conversion — reverse direction: rep who should have
                been a customer. Uses supabaseId (the Supabase auth.uid)
                for the update; falls back to detail.id for demo reps
                which don't have a supabaseId. */}
            {detailRep.supabaseId && (
              <button
                style={{...S.btnSecondary,color:C.blue,borderColor:C.blue}}
                onClick={async()=>{
                  if(!window.confirm(`Convert ${detailRep.name} to a Customer (dealer) account?\n\nThey'll keep the same email + password + phone + territory info. On next sign-in they'll see the customer portal instead of the rep portal.\n\nContinue?`)) return;
                  try {
                    await changeAccountRole(detailRep.supabaseId, "customer", "dealer");
                    alert("Converted to Customer (dealer). Ask them to sign out and back in to see the customer portal.");
                    setSelectedRep(null);
                    if(onRepSuspensionChange) onRepSuspensionChange();
                  } catch(e) {
                    alert("Conversion failed: " + (e?.message || e));
                  }
                }}
              >Convert to Customer →</button>
            )}
            <button style={{...S.btnSecondary,color:C.amber,borderColor:"#FCD34D"}} onClick={()=>openSuspendRepModal(detailRep,"pause")}>Pause</button>
            <button style={{...S.btnSecondary,color:C.red,borderColor:"#FCA5A5"}} onClick={()=>openSuspendRepModal(detailRep,"delete")}>Delete</button>
            <button style={S.btnSecondary} onClick={()=>exportActivity(detailRep)}>⬇ Activity</button>
            <button style={S.btnSecondary} onClick={()=>exportCustomers(detailRep)}>⬇ Customers</button>
          </div>
        </div>
        {/* Stat cards are clickable — each card routes the admin into the
            matching sub-tab with the right filter preset. Consistent with
            the "click a card to filter the list" pattern from PR #32 used
            across the other admin tabs. */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:16}}>
          {[
            {l:"Assigned accounts", v:(repAssignedAccounts[detailRep.name]||[]).length, sub:"admin + customer signup",
              onClick:()=>{ setViewTab("assigned"); setAssignedAcctSearch(""); }},
            {l:"Today",              v:detailStats.todayV, sub:"visits",
              onClick:()=>{ setViewTab("activity"); setPeriod("today"); setVisitTypeFilter(""); }},
            {l:"This week",          v:detailStats.weekV,  sub:"visits",
              onClick:()=>{ setViewTab("activity"); setPeriod("week"); setVisitTypeFilter(""); }},
            {l:"This month",         v:detailStats.monthV, sub:"visits",
              onClick:()=>{ setViewTab("activity"); setPeriod("month"); setVisitTypeFilter(""); }},
            {l:"YTD sales",          v:`$${(detailMetrics?.ytdRevenue||0).toLocaleString(undefined,{maximumFractionDigits:0})}`, sub:`${detailMetrics?.ytdInvoiceCount||0} invoices · ${detailMetrics?.ytdUnits||0} units`,
              onClick:()=>{ setViewTab("commission"); }},
          ].map(m=>(
            <div key={m.l} onClick={m.onClick} style={{...S.metric,cursor:"pointer",transition:"transform 0.15s, box-shadow 0.15s"}}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow="0 2px 4px rgba(0,0,0,0.06)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={S.mLabel}>{m.l}</div><div style={S.mValue}>{m.v}</div><div style={S.mSub}>{m.sub}</div>
            </div>
          ))}
        </div>
        {/* Second row: commission roll-up. All three cards open the new
            Commission sub-tab where admin sees per-period breakdown with
            invoice numbers and can mark periods paid. */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
          {[
            {l:"YTD commission earned", v:`$${(detailMetrics?.ytdEarned||0).toFixed(2)}`, sub:`@ ${detailRep.rate}% on invoiced sales`, accent:C.teal},
            {l:"YTD paid out",          v:`$${(detailMetrics?.ytdPaidOut||0).toFixed(2)}`, sub:`${detailMetrics?.ytdPaidInvoiceCount||0} paid invoices`, accent:C.green},
            {l:"Pending payout (estimate)", v:`$${(detailMetrics?.pendingCommission||0).toFixed(2)}`, sub:"See the exact figure on the Commission tab below", accent:C.amber},
          ].map(m=>(
            <div key={m.l} onClick={()=>setViewTab("commission")} style={{...S.metric,borderTop:`3px solid ${m.accent}`,cursor:"pointer",transition:"transform 0.15s, box-shadow 0.15s"}}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow="0 2px 4px rgba(0,0,0,0.06)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}
            >
              <div style={S.mLabel}>{m.l}</div><div style={S.mValue}>{m.v}</div><div style={S.mSub}>{m.sub}</div>
            </div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:16}}>
          {[
            {l:"Shop visits", v:detailStats.shopVisits, type:"shop_visit", accent:C.teal},
            {l:"Follow-ups",  v:detailStats.followUps,  type:"follow_up",  accent:C.blue},
            {l:"Cold calls",  v:detailStats.coldCalls,  type:"cold_call",  accent:C.purple},
          ].map(m=>{
            const isActive = viewTab==="activity" && visitTypeFilter===m.type;
            return (
              <div key={m.l}
                onClick={()=>{ setViewTab("activity"); setPeriod("all"); setVisitTypeFilter(visitTypeFilter===m.type?"":m.type); }}
                style={{...S.metric,borderTop:`3px solid ${m.accent}`,cursor:"pointer",boxShadow:isActive?`0 0 0 2px ${m.accent}`:undefined,transition:"transform 0.15s, box-shadow 0.15s"}}
                onMouseEnter={e=>{ if(!isActive) e.currentTarget.style.transform="translateY(-1px)"; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
              >
                <div style={S.mLabel}>{m.l}</div>
                <div style={S.mValue}>{m.v}</div>
                {isActive && <div style={{fontSize:10,color:m.accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
              </div>
            );
          })}
        </div>
        <div style={{display:"flex",gap:4,marginBottom:16}}>
          {[["activity","Activity log"],["assigned","Assigned accounts"],["customers","Customer database"],["prospects","Potential customers"],["commission","Commission"]].map(([k,l])=>(
            <button key={k} style={{...S.btnSecondary,background:viewTab===k?C.blue:"transparent",color:viewTab===k?C.white:C.ink,fontWeight:viewTab===k?600:400,position:"relative"}} onClick={()=>{setViewTab(k);if(k==="assigned")setAssignedAcctSearch("");}}>
              {l}
              {k==="assigned"&&(repAssignedAccounts[detailRep.name]||[]).length>0&&<span style={{marginLeft:4,fontSize:10,background:viewTab===k?"rgba(255,255,255,0.3)":C.blue,color:C.white,borderRadius:10,padding:"1px 6px",fontWeight:600}}>{(repAssignedAccounts[detailRep.name]||[]).length}</span>}
              {k==="prospects"&&(detailRep.prospects||[]).filter(p=>(p.reminders||[]).some(r=>!r.done&&r.date<=today)).length>0&&<span style={{position:"absolute",top:-4,right:-4,width:8,height:8,borderRadius:"50%",background:C.red}}/>}
            </button>
          ))}
        </div>
        {viewTab==="activity"&&(<div style={S.card}>
          <div style={{...S.cardHdr,flexWrap:"wrap",gap:8}}><span style={S.cardTitle}>Visit log ({detailFiltered.length} entries)</span>
            <div style={{display:"flex",gap:4}}>{[["today","Today"],["week","This week"],["month","This month"],["all","All time"]].map(([k,l])=>(<button key={k} style={{...S.btnSmall,background:period===k?C.blue:C.blueLight,color:period===k?C.white:C.blue}} onClick={()=>setPeriod(k)}>{l}</button>))}</div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"90px 1fr 90px 1fr 70px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}><span>Date</span><span>Shop / Customer</span><span>Type</span><span>Notes</span><span>Duration</span></div>
          {detailFiltered.length===0&&<div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>No visits found for this period</div>}
          {detailFiltered.map((v,i)=>(<div key={i} style={{display:"grid",gridTemplateColumns:"90px 1fr 90px 1fr 70px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}><span style={{color:C.inkMid,fontWeight:500}}>{v.date}</span><span style={{fontWeight:500,color:C.ink}}>{v.company}</span><span style={typeStyle[v.type]||S.pillGray}>{typeLabel[v.type]||v.type}</span><span style={{color:C.inkLight,fontSize:11}}>{v.note}</span><span style={{color:C.inkMid}}>{v.duration} min</span></div>))}
        </div>)}
        {/* Invoice PDF modal — shared across the Customer-database and
            Commission sub-tabs. Hoisted out of the customers block so
            Commission-tab View buttons can open it too. */}
        {repCustViewInvoice&&<AdminInvoiceModal inv={repCustViewInvoice} onClose={()=>setRepCustViewInvoice(null)} onStatusChange={()=>{/* useAdminVisibleInvoices subscribes to SHARED_INVOICES */}}/>}
        {viewTab==="customers"&&(<>
          {dupGroups.length>0 && (
            <div style={{background:"#FEF3C7",border:"1px solid #FCD34D",borderRadius:10,padding:"12px 16px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:"#92400E"}}>{dupGroups.length} possible duplicate business{dupGroups.length>1?"es":""} found</div>
                <div style={{fontSize:11,color:"#92400E",marginTop:2}}>The same company name appears more than once in {detailRep.name}'s list — likely added twice before the add-flow's duplicate check shipped.</div>
              </div>
              <button style={{...S.btnPrimary,background:"#92400E",flexShrink:0}} onClick={()=>setMergeReview(true)}>Review & merge</button>
            </div>
          )}
          {mergeReview && (
            <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
              <div style={{background:C.white,borderRadius:16,padding:"24px 28px",width:720,maxHeight:"85vh",overflowY:"auto"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <div style={{fontSize:16,fontWeight:600,color:C.ink}}>Merge duplicate businesses — {detailRep.name}</div>
                  <button style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.inkLight}} onClick={()=>setMergeReview(false)}>×</button>
                </div>
                <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>Pick which row to keep for each duplicate — its info wins, any field it's missing is filled in from the other row, and all visit history is combined. The row(s) not kept are removed from the active list (soft-deactivated — never permanently deleted).</div>
                {dupGroups.length===0 && <div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>No more duplicates — all merged.</div>}
                {dupGroups.map((group,gi)=>(
                  <div key={gi} style={{...S.card,padding:16,marginBottom:14}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>{group[0].customer_data?.company||"(no name)"} — {group.length} entries</div>
                    <div style={{display:"flex",flexDirection:"column",gap:8}}>
                      {group.map(row=>{
                        const d = row.customer_data||{};
                        const busy = mergeBusy===row.customer_key;
                        return (
                          <div key={row.customer_key} style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10}}>
                            <div style={{fontSize:12}}>
                              <div style={{color:C.ink}}>{d.contact||"—"} · {d.email||"—"} · {d.phone||"—"}</div>
                              <div style={{color:C.inkLight,fontSize:11,marginTop:2}}>{d.address||"—"}</div>
                              <div style={{color:C.inkLight,fontSize:10,marginTop:2}}>{row.is_prospect?"Potential customer":"Route customer"} · {(d.visitHistory||[]).length} visit note{(d.visitHistory||[]).length===1?"":"s"} · added {row.created_at?new Date(row.created_at).toLocaleDateString():"—"}</div>
                            </div>
                            <button style={{...S.btnSmall,flexShrink:0,opacity:mergeBusy?0.6:1}} disabled={!!mergeBusy} onClick={()=>mergeDuplicateGroup(group,row)}>{busy?"Merging…":"Keep this one"}</button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div style={S.card}>
          <div style={S.cardHdr}><span style={S.cardTitle}>Customers ({(detailRep.customers||[]).length})</span><button style={S.btnSecondary} onClick={()=>exportCustomers(detailRep)}>Export CSV</button></div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 120px 140px 100px 80px 80px 80px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}><span>Company</span><span>Contact</span><span>Email / Phone</span><span>Address</span><span>Tier</span><span>YTD sales</span><span>Last visit</span></div>
          {(detailRep.customers||[]).length===0&&<div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>No customers assigned to this rep.</div>}
          {(detailRep.customers||[]).map(c=>{
            const vs=visitDays(c.lastVisit,c.visitCycle||30);
            const isExpanded = expandedRepCust===c.id;
            // Gather invoices for this customer — strict live-invoice derivation,
            // NO demo RECENT_ORDERS mixing, so numbers tie out to the rep's own
            // Commission page and the Admin Commission payout table.
            const custName = c.company||"";
            const custMetrics = computeCustomerMetrics({ customerName: custName, allInvoices: sharedInvoicesLive });
            const custInvoices = custMetrics.invoices.slice().sort((a,b)=>new Date(b.date||0)-new Date(a.date||0));
            const invCount = custInvoices.length;
            const custYtdRev = custMetrics.ytdRevenue;
            return(<div key={c.id}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 120px 140px 100px 80px 80px 80px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,cursor:"pointer",background:isExpanded?C.blueLight:C.white,transition:"background 0.15s"}} onClick={()=>setExpandedRepCust(isExpanded?null:c.id)}>
                <div>
                  <div style={{fontWeight:600,color:C.ink,display:"flex",alignItems:"center",gap:6}}>
                    <span style={{fontSize:10,color:C.inkLight,transition:"transform 0.15s",display:"inline-block",transform:isExpanded?"rotate(90deg)":"rotate(0deg)"}}>▶</span>
                    {c.company}
                    {invCount>0&&<span style={{fontSize:9,background:C.blue,color:C.white,borderRadius:10,padding:"1px 6px",fontWeight:600}}>{invCount}</span>}
                  </div>
                  {c.ein&&<div style={{fontSize:10,color:C.inkLight,marginLeft:16}}>EIN: {c.ein}</div>}
                </div>
                <span style={{color:C.inkMid}}>{c.contact}</span>
                <div><div style={{fontSize:11,color:C.inkMid}}>{c.email}</div><div style={{fontSize:10,color:C.inkLight}}>{c.phone}</div></div>
                <span style={{fontSize:10,color:C.inkLight}}>{c.address?.split(",").slice(-2).join(",")}</span>
                <span style={c.tier==="enterprise"?S.pillPurple:c.tier==="distributor"?S.pillBlue:S.pillGray}>{c.tier}</span>
                <span style={{fontWeight:600,color:C.ink}} title="Sum of this customer's non-cancelled invoices this year">${custYtdRev.toLocaleString(undefined,{maximumFractionDigits:0})}</span>
                <span style={{fontSize:11,fontWeight:500,color:vs.color}}>{vs.label}</span>
              </div>
              {isExpanded&&(
                <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"16px 24px"}}>
                  {/* Customer detail header */}
                  <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
                    {[["Contact",c.contact||"—"],["Email",c.email||"—"],["Phone",c.phone||"—"],["Address",c.address||"—"]].map(([label,val])=>(
                      <div key={label} style={{background:C.white,borderRadius:8,padding:"10px 12px"}}>
                        <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{label}</div>
                        <div style={{fontSize:12,color:C.ink,fontWeight:500}}>{val}</div>
                      </div>
                    ))}
                  </div>
                  {/* Sales summary — derived from custMetrics (shared helper) so
                      these numbers match the rep's Commission page and the
                      Admin Commission table exactly. */}
                  <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10,marginBottom:14}}>
                    <div style={{background:C.white,borderRadius:8,padding:"10px 12px",textAlign:"center"}}><div style={{fontSize:9,fontWeight:600,color:C.inkLight,textTransform:"uppercase",marginBottom:4}}>This week</div><div style={{fontSize:16,fontWeight:700,color:C.blue}}>${custMetrics.weekRevenue.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div></div>
                    <div style={{background:C.white,borderRadius:8,padding:"10px 12px",textAlign:"center"}}><div style={{fontSize:9,fontWeight:600,color:C.inkLight,textTransform:"uppercase",marginBottom:4}}>This month</div><div style={{fontSize:16,fontWeight:700,color:C.teal}}>${custMetrics.monthRevenue.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div></div>
                    <div style={{background:C.white,borderRadius:8,padding:"10px 12px",textAlign:"center"}}><div style={{fontSize:9,fontWeight:600,color:C.inkLight,textTransform:"uppercase",marginBottom:4}}>All time</div><div style={{fontSize:16,fontWeight:700,color:C.navy}}>${custMetrics.totalRevenue.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div></div>
                    <div style={{background:C.greenLight,borderRadius:8,padding:"10px 12px",textAlign:"center"}}><div style={{fontSize:9,fontWeight:600,color:C.green,textTransform:"uppercase",marginBottom:4}}>Paid</div><div style={{fontSize:16,fontWeight:700,color:C.green}}>{custMetrics.paidCount}</div></div>
                    <div style={{background:C.amberLight,borderRadius:8,padding:"10px 12px",textAlign:"center"}}><div style={{fontSize:9,fontWeight:600,color:C.amber,textTransform:"uppercase",marginBottom:4}}>Pending</div><div style={{fontSize:16,fontWeight:700,color:C.amber}}>{custMetrics.pendingCount}</div></div>
                  </div>
                  {/* Invoices table */}
                  <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:8}}>Invoices ({invCount})</div>
                  {invCount===0?(
                    <div style={{background:C.white,borderRadius:8,padding:"16px",textAlign:"center",color:C.inkLight,fontSize:12}}>No invoices found for this customer.</div>
                  ):(
                    <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",background:C.white}}>
                      <div style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 80px 65px 80px 50px",gap:6,padding:"8px 14px",fontSize:10,fontWeight:600,color:C.inkLight,background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                        <span>Invoice</span><span>Date</span><span>Items</span><span style={{textAlign:"right"}}>Amount</span><span>Status</span><span>Via</span><span></span>
                      </div>
                      {custInvoices.map(inv=>(
                        <div key={inv.id} style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 80px 65px 80px 50px",gap:6,padding:"9px 14px",fontSize:11,borderBottom:`1px solid ${C.border}`,alignItems:"center"}}>
                          <span style={{fontWeight:600,color:C.blue,fontFamily:"monospace",fontSize:10}}>{inv.id}</span>
                          <span style={{color:C.inkLight}}>{inv.date}</span>
                          <span style={{color:C.inkMid,fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{Array.isArray(inv.items)?inv.items.map(i=>`${i.name} ×${i.qty}`).join(", "):inv.items||"—"}</span>
                          <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${Number(inv.total||inv.amount||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                          <InvoicePill inv={inv}/>
                          <span style={{color:C.inkLight,fontSize:10}}>{inv.sent==="email"?"Email":inv.sent==="print"?"Print":inv.sent==="order"?"Order":inv.repCreated?"Field":inv.source==="admin_invoice"?"Office":"—"}</span>
                          <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={(e)=>{e.stopPropagation();setRepCustViewInvoice(inv);}}>View</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>);
          })}
        </div>
        </>)}
        {viewTab==="assigned"&&(()=>{
          const assigned=repAssignedAccounts[detailRep.name]||[];
          const q=assignedAcctSearch.toLowerCase();
          const filtered=q?assigned.filter(ac=>(ac.company||"").toLowerCase().includes(q)||(ac.contact||"").toLowerCase().includes(q)||(ac.email||"").toLowerCase().includes(q)||(ac.phone||"").includes(q)||(ac.address||"").toLowerCase().includes(q)||(ac.tier||"").toLowerCase().includes(q)):assigned;
          return(<div style={S.card}>
            <div style={{...S.cardHdr,flexWrap:"wrap",gap:8}}>
              <span style={S.cardTitle}>Assigned accounts ({assigned.length})</span>
              <input style={{...S.input,width:260}} value={assignedAcctSearch} onChange={e=>setAssignedAcctSearch(e.target.value)} placeholder="Search accounts by name, email, phone..."/>
            </div>
            {filtered.length===0?(
              <div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>{assigned.length===0?"No accounts assigned to this rep yet.":"No accounts match your search."}</div>
            ):(<>
              <div style={{display:"grid",gridTemplateColumns:"1fr 130px 160px 120px 80px 80px 80px 110px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                <span>Company</span><span>Contact</span><span>Email / Phone</span><span>Address</span><span>Tier</span><span>Status</span><span>Discount</span><span>Assigned by</span>
              </div>
              {filtered.map(ac=>{
                const acctName=ac.company&&ac.company!=="—"?ac.company:ac.email;
                // Same rule as the customer table above: admin-visible (not
                // removed) AND non-cancelled, so both totals agree.
                const acInvs=sharedInvoicesLive.filter(i=>(i.customer===acctName||i.customer===ac.company)&&i.status!=="cancelled");
                const acTotal=acInvs.reduce((s,i)=>s+Number(i.total||0),0);
                // Assignment-source badge: "Admin" if an admin edited the rep on this account;
                // "Customer signup" if the rep field came from the customer's own signup profile
                // (or a cross-portal signup flow). Source is computed at map-build time above.
                const src=ac._assignedBy||"admin";
                const srcLabel=src==="customer_signup"?"Customer signup":"Admin";
                const srcStyle=src==="customer_signup"
                  ?{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:8,background:"#EDE9FE",color:"#6D28D9",whiteSpace:"nowrap"}
                  :{fontSize:10,fontWeight:600,padding:"2px 7px",borderRadius:8,background:"#DBEAFE",color:"#1E40AF",whiteSpace:"nowrap"};
                return(
                <div key={ac.id} style={{display:"grid",gridTemplateColumns:"1fr 130px 160px 120px 80px 80px 80px 110px",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                  <div>
                    <div style={{fontWeight:600,color:C.ink}}>{acctName}</div>
                    {acTotal>0&&<div style={{fontSize:10,color:C.teal,fontWeight:500}}>${acTotal.toLocaleString(undefined,{minimumFractionDigits:2})} total orders</div>}
                  </div>
                  <span style={{color:C.inkMid}}>{ac.contact||"—"}</span>
                  <div><div style={{fontSize:11,color:C.inkMid}}>{ac.email||"—"}</div><div style={{fontSize:10,color:C.inkLight}}>{ac.phone||""}</div></div>
                  <span style={{fontSize:10,color:C.inkLight}}>{ac.address&&ac.address!=="—"?ac.address.split(",").slice(-2).join(",").trim():"—"}</span>
                  <span style={ac.tier==="distributor"?S.pillBlue:ac.tier==="enterprise"?S.pillPurple:S.pillGray}>{ac.tier||"dealer"}</span>
                  <span style={ac.status==="approved"?S.pillGreen:ac.status==="pending"?S.pillAmber:S.pillRed}>{ac.status||"—"}</span>
                  <span style={{fontSize:11,color:ac.discount?C.teal:C.inkLight}}>{ac.discount?ac.discount+"%":"—"}</span>
                  <span style={srcStyle}>{srcLabel}</span>
                </div>);
              })}
            </>)}
          </div>);
        })()}
        {viewTab==="commission"&&(()=>{
          // Batch-based view for this specific rep. Same data model as the
          // top-level Admin Commission tab (batchizeRepInvoices) so all three
          // views (admin top-level, admin rep-detail, rep portal) tie out to
          // the same numbers. Each admin "Mark paid" click freezes a batch;
          // new invoices arriving after spawn a fresh pending row.
          const commInvoices = detailMetrics?.invoices || [];
          // Narrow legacy paid map + Supabase rows to this rep.
          const legacyForRep = {};
          Object.entries(detailPaidMap || {}).forEach(([k,v]) => {
            const sep = k.indexOf("__");
            if (sep < 0) return;
            if (k.slice(0, sep) === detailRep.name) legacyForRep[k.slice(sep + 2)] = v;
          });
          const repIdText = detailRep.id != null ? String(detailRep.id) : "";
          const myPaidRows = detailPaidRows.filter(r => {
            if (!r) return false;
            if (repIdText && String(r.rep_id||"") === repIdText) return true;
            if (r.rep_name && r.rep_name === detailRep.name) return true;
            return false;
          });
          const { batches: paidBatches, pendingPeriods: pendingPeriodsBatched, totalPaid, totalPending } = batchizeRepInvoices(commInvoices, detailRep.rate || 0, myPaidRows, legacyForRep);
          // Invoices covered ONLY by a per-device legacy payout (Delete / Adjust refuse these, see commissionPreflight).
          const detailLegacyPaidIds = new Set();
          paidBatches.forEach(b => { if (b.legacy) (b.invoices || []).forEach(i => { if (i && i.id != null) detailLegacyPaidIds.add(String(i.id)); }); });
          // Corrections for THIS rep (kept separate from the invoice totals).
          const detailCorrSummary = repCorrectionSummary({ corrections: detailLedger.corrections, repId: repIdText, paidRows: detailLedger.paidRows, detectOrphans: true });
          // Open corrections offered in Mark Paid: complete picture only (see the top-level tab).
          const detailOpenForPayout = Array.isArray(detailLedger.paidRows) ? detailCorrSummary.open : [];
          const detailPendingWithCorr = totalPending + detailCorrSummary.openTotal;
          const detailPaidWithCorr = totalPaid + detailCorrSummary.settledTotal;
          const detailSettleMap = settlementBatches(detailLedger.corrections);
          const detailCorrOnlyHistory = repIdText ? correctionOnlySettlements((detailLedger.corrections||[]).filter(c => String(c.rep_id) === repIdText)) : [];
          const detailFrozenRows = Array.isArray(detailLedger.paidRows) ? detailLedger.paidRows : myPaidRows;

          const itemsLabel = (inv) => Array.isArray(inv.items)
            ? inv.items.map(i=>`[${i.sku||"—"}] ${i.name||""} ×${i.qty||0}`).join(", ")
            : (inv.items || "—");

          // Parse YYYY-MM-DD as end-of-day local (23:59:59.999). Matches
          // AdminCommissionTab._endOfDay so the cutoff semantics are identical.
          const _endOfDay = (ymd) => {
            if (!ymd) return null;
            const [y,m,d] = ymd.split("-").map(Number);
            if (!y || !m || !d) return null;
            return new Date(y, m-1, d, 23, 59, 59, 999);
          };
          const _todayYmd = () => {
            const t = new Date();
            const pad = (n) => String(n).padStart(2,"0");
            return `${t.getFullYear()}-${pad(t.getMonth()+1)}-${pad(t.getDate())}`;
          };

          const markPeriodPaid = async (periodLabel) => {
            if (detailMarkBusy) return;
            const pending = pendingPeriodsBatched.find(x => x.periodLabel === periodLabel);
            if (!pending) return;
            const cutoff = _endOfDay(detailPayForm.payThrough || _todayYmd());
            const eligible = (pending.invoices || []).filter(inv => {
              if (!inv?.id) return false;
              if (!cutoff) return true;
              const d = inv.sharedAt ? new Date(inv.sharedAt) : (inv.date ? new Date(inv.date) : null);
              if (!d || isNaN(d.getTime())) return true;
              return d.getTime() <= cutoff.getTime();
            });
            if (eligible.length === 0) {
              alert("No invoices match the pay-through date. Nothing to pay.");
              setDetailMarkingPeriod(null);
              return;
            }
            // WARN ONLY (never a block): same gate as the Commission tab Mark Paid.
            const detailRemitGateNow = payoutRemitGate(eligible, detailRemit);
            const detailRemitKeyNow = gateAckKey(detailRemitGateNow, detailPayForm.payThrough);
            const detailRemitAckedNow = detailRemitKeyNow !== "" && detailRemitAckKey === detailRemitKeyNow;
            if (detailRemitGateNow.loading || (detailRemitGateNow.needsAck && !detailRemitAckedNow)) {
              alert(detailRemitGateNow.loading ? "Still checking which invoices the sales rep has paid in. Try again in a moment." : "Tick the box to confirm you understand some invoices have no payment received from the rep.");
              return;
            }
            setDetailMarkBusy(true);
            try {
              const paidAt = new Date().toISOString();
              const batchId = `${repIdText||detailRep.name}-${periodLabel}-${Date.now()}`;
              const rows = eligible.map(inv => ({
                invoice_id: String(inv.id),
                rep_id: repIdText,
                rep_name: detailRep.name,
                paid_at: paidAt,
                paid_date: paidAt.slice(0, 10),
                method: detailPayForm.method || "",
                notes: detailPayForm.notes || "",
                batch_id: batchId,
                period: periodLabel,
                amount: (Number(inv.total)||0) * (detailRep.rate||0) / 100,
                commission_amount: (Number(inv.total)||0) * (detailRep.rate||0) / 100,
                commission_rate: detailRep.rate || 0,
                invoice_amount: Number(inv.total) || 0,
              }));
              // ONE shared helper (same as the top-level Mark Paid): without ticked
              // corrections it is exactly markInvoicesCommissionPaid(rows).
              // A failed ledger read leaves detailCorrSel null (nothing ticked): invoices only.
              const detailCorrIds = (detailLedger.ready && Array.isArray(detailCorrSel)) ? detailCorrSel : [];
              const detailAdmin = detailCorrIds.length > 0 ? await currentAdminIdentity() : null;
              const res = await runCommissionPayout({ repId: repIdText, rows, batchId, method: detailPayForm.method, notes: detailPayForm.notes, admin: detailAdmin, selectedCorrectionIds: detailCorrIds });
              if (!res.ok && !res.fallbackAllowed) {
                // Corrections were included: never the per-browser localStorage fallback.
                console.warn("[detail markPeriodPaid] payout with corrections failed:", res.stage, res.error);
                alert(describePayoutResult(res));
                detailLedger.reload();
                return;
              }
              if (res.ok) {
                const fresh = await listRepCommissionPayments();
                setDetailPaidRows(fresh);
                const msg = describePayoutResult(res);
                if (msg) setDetailPayNotice(msg);
              } else {
                console.warn("[detail markPeriodPaid] Supabase failed, falling back to legacy map:", res.error);
                const date = detailPayForm.date || new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
                const key = `${detailRep.name}__${periodLabel}`;
                const next = { ...detailPaidMap, [key]: { date, method: detailPayForm.method, notes: detailPayForm.notes, paidAt: (cutoff||new Date()).toISOString() } };
                setDetailPaidMap(next);
                savePaidPeriods(next);
              }
              detailLedger.reload();
              setDetailMarkingPeriod(null);
              setDetailPayForm({date:"", method:"ACH", notes:"", payThrough: _todayYmd()});
            } finally {
              setDetailMarkBusy(false);
            }
          };
          const undoBatch = async (batch) => {
            if (!batch) return;
            if (batch.legacy) {
              if (!window.confirm(`Undo legacy payout for ${detailRep.name} — ${batch.periodLabel || batch.batchId}?`)) return;
              const key = `${detailRep.name}__${batch.periodLabel}`;
              if (detailPaidMap[key]) {
                const { [key]:_discard, ...rest } = detailPaidMap;
                setDetailPaidMap(rest);
                savePaidPeriods(rest);
              }
              return;
            }
            if (!window.confirm(`Undo all ${batch.invoiceCount} invoices in this payout? Each will return to Pending.`)) return;
            // A batch that still holds a VOIDED / not-in-list paid row is refused: the
            // loop below only undoes resolved invoices and would leave that row behind
            // as a ghost (its payout record must not be deleted either).
            const batchLines = frozenBatchLines({ batch, paidRows: detailFrozenRows, corrections: detailLedger.corrections, allInvoices: SHARED_INVOICES.getAll() });
            if (!batchLines) {
              // The frozen payout rows are not loaded yet: the voided-line check cannot run, so refuse (never skip it).
              alert("The payout rows for this batch are still loading, so it cannot be undone yet. Wait a moment and try again.");
              return;
            }
            if (batchLines.some(l => l.voided)) {
              alert("This payout contains a voided or unlisted invoice, so the whole batch cannot be undone here. Undo the other invoices one by one, or leave it as recorded: the paid record of a voided invoice is kept and any clawback is handled as a correction.");
              return;
            }
            // Refused while a correction is settled against, settled in, or open on any of these payouts.
            const undoGuard = await checkUndoAllowed(undoScopeFromRows(detailFrozenRows, (batch.invoices || []).map(i => String(i.id)), [batch.batchId]));
            if (!undoGuard.ok) { alert(undoGuard.message); return; }
            let anyFail = false;
            for (const inv of (batch.invoices || [])) {
              const res = await unmarkInvoiceCommissionPaid(String(inv.id));
              if (!res.ok) anyFail = true;
            }
            const fresh = await listRepCommissionPayments();
            setDetailPaidRows(fresh);
            if (anyFail) alert("Some invoice payouts could not be undone — check console for details.");
          };

          return (<>
            {/* Mark-paid modal */}
            {detailMarkingPeriod && (()=>{
              const cutoff = _endOfDay(detailPayForm.payThrough || _todayYmd());
              const eligible = (detailMarkingPeriod.invoices||[]).filter(inv => {
                if (!cutoff) return true;
                const d = inv.sharedAt ? new Date(inv.sharedAt) : (inv.date ? new Date(inv.date) : null);
                if (!d || isNaN(d.getTime())) return true;
                return d.getTime() <= cutoff.getTime();
              });
              const skipped = (detailMarkingPeriod.invoices||[]).length - eligible.length;
              const eligibleTotal = eligible.reduce((s,inv)=>s+(Number(inv.total)||0)*(detailRep.rate||0)/100, 0);
              return (
              <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
                <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:"min(480px,94vw)",boxSizing:"border-box",maxHeight:"90vh",overflowY:"auto"}}>
                  <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Mark commission as paid</div>
                  <div style={{fontSize:13,color:C.inkLight,marginBottom:6}}>
                    {detailRep.name} — {detailMarkingPeriod.periodLabel} — <strong style={{color:C.ink}}>${eligibleTotal.toFixed(2)}</strong>
                  </div>
                  <div style={{fontSize:12,color:C.inkMid,marginBottom:18}}>
                    Paying {eligible.length} invoice{eligible.length===1?"":"s"} on or before the cutoff below.
                    {skipped > 0 && <span style={{color:"#B45309",fontWeight:500}}> {skipped} newer invoice{skipped===1?"":"s"} will stay pending for the next batch.</span>}
                  </div>
                  <div style={S.twoCol}>
                    <div style={S.fg}>
                      <label style={S.label}>Payment date *</label>
                      <input style={S.input} type="date" value={detailPayForm.date} onChange={e=>setDetailPayForm(f=>({...f,date:e.target.value}))}/>
                    </div>
                    <div style={S.fg}>
                      <label style={S.label}>Pay through *</label>
                      <input style={S.input} type="date" value={detailPayForm.payThrough || _todayYmd()} onChange={e=>setDetailPayForm(f=>({...f,payThrough:e.target.value}))}/>
                    </div>
                  </div>
                  <div style={S.fg}>
                    <label style={S.label}>Payment method *</label>
                    <select style={S.select} value={detailPayForm.method} onChange={e=>setDetailPayForm(f=>({...f,method:e.target.value}))}>
                      <option value="ACH">ACH / Bank transfer</option>
                      <option value="Check">Check</option>
                      <option value="Wire">Wire transfer</option>
                      <option value="Zelle">Zelle</option>
                      <option value="Cash">Cash</option>
                      <option value="PayPal">PayPal</option>
                    </select>
                  </div>
                  <div style={S.fg}>
                    <label style={S.label}>Notes (optional)</label>
                    <input style={S.input} value={detailPayForm.notes} onChange={e=>setDetailPayForm(f=>({...f,notes:e.target.value}))} placeholder="Reference number, memo, etc."/>
                  </div>
                  <CorrectionsPayoutSection open={detailOpenForPayout} selected={detailCorrSel} onChange={setDetailCorrSel} invoiceCommission={eligibleTotal} ready={detailLedger.ready} error={detailLedger.error} onRetry={detailLedger.reload}/>
                  {(()=>{
                    // Same readiness rules as the top-level Mark Paid modal.
                    const ledgerLoading = !detailLedger.ready && !detailLedger.error;
                    const ticksPending = detailLedger.ready && detailCorrSel===null && detailOpenForPayout.length>0;
                    const rg = payoutRemitGate(eligible, detailRemit);
                    const rgKey = gateAckKey(rg, detailPayForm.payThrough);
                    const detailRemitAck = rgKey !== "" && detailRemitAckKey === rgKey;
                    const remitBlocked = rg.loading || (rg.needsAck && !detailRemitAck);
                    return (<>
                  <PayoutRemitGate gate={rg} ack={detailRemitAck} setAck={(v)=>setDetailRemitAckKey(v?rgKey:"")}/>
                  <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                    <button style={S.btnSecondary} onClick={()=>{ setDetailMarkingPeriod(null); setDetailPayForm({date:"",method:"ACH",notes:"",payThrough:_todayYmd()}); }} disabled={detailMarkBusy}>Cancel</button>
                    <button style={{...S.btnPrimary,opacity:(detailMarkBusy||ledgerLoading||ticksPending||remitBlocked)?0.6:1}} onClick={()=>markPeriodPaid(detailMarkingPeriod.periodLabel)} disabled={detailMarkBusy || eligible.length===0 || ledgerLoading || ticksPending || remitBlocked}>{detailMarkBusy?"Saving...":(detailLedger.error?"Confirm payment (invoices only)":"Confirm payment")}</button>
                  </div>
                    </>);
                  })()}
                </div>
              </div>
              );
            })()}

            {/* Summary cards — pending flashes red when > 0 */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:12}}>
              <div style={{...S.metric,borderTop:`3px solid ${C.teal}`}}>
                <div style={S.mLabel}>Total invoices</div>
                <div style={S.mValue}>{commInvoices.length}</div>
                <div style={S.mSub}>${commInvoices.reduce((s,i)=>s+Number(i.total||0),0).toLocaleString(undefined,{maximumFractionDigits:2})} in sales</div>
              </div>
              <div style={{...S.metric,borderTop:`3px solid ${C.green}`}}>
                <div style={S.mLabel}>Paid out to rep</div>
                <div style={{...S.mValue,color:C.green}}>${detailPaidWithCorr.toFixed(2)}</div>
                <div style={S.mSub}>{paidBatches.length} batch{paidBatches.length===1?"":"es"}{detailCorrSummary.settledTotal!==0 ? ` · incl. settled corrections ${fmtSignedMoney(detailCorrSummary.settledTotal)}` : ""}</div>
              </div>
              <div style={{...S.metric,borderTop:`3px solid ${detailPendingWithCorr>0?"#B91C1C":C.inkLight}`}}>
                <div style={S.mLabel}>Pending payout</div>
                <div style={{...S.mValue,color:detailPendingWithCorr>0?"#B91C1C":C.inkLight}}>${detailPendingWithCorr.toFixed(2)}</div>
                <div style={S.mSub}>{pendingPeriodsBatched.length} open period{pendingPeriodsBatched.length===1?"":"s"}</div>
                {detailCorrSummary.open.length>0 && <div style={{...S.mSub,color:detailCorrSummary.openTotal<0?C.red:C.green}}>Invoices ${totalPending.toFixed(2)} + open corrections {fmtSignedMoney(detailCorrSummary.openTotal)}</div>}
              </div>
            </div>

            {detailPayNotice && (
              <div style={{background:C.amberLight,border:`1px solid ${C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.amber,marginBottom:12,display:"flex",justifyContent:"space-between",gap:12}}>
                <span>{detailPayNotice}</span>
                <button style={S.btnGhost} onClick={()=>setDetailPayNotice("")}>Dismiss</button>
              </div>
            )}
            {detailLedger.error && (
              <div style={{background:C.redLight,border:`1px solid ${C.red}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.red,marginBottom:12}}>
                Commission corrections could not be loaded completely ({detailLedger.error}). Correction totals may be out of date.
              </div>
            )}
            <CorrectionsCard summary={detailCorrSummary} mode="admin" title={`Corrections for ${detailRep.name}`} onChanged={detailLedger.reload} onSettle={(pendingPeriodsBatched.length===0 && detailLedger.ready)?()=>setDetailCorrOnly(true):null} settleLabel="Settle corrections only (nothing pending)"/>
            {detailCorrOnly && (
              <CorrectionOnlyModal repId={repIdText} repName={detailRep.name} open={detailOpenForPayout}onClose={()=>setDetailCorrOnly(false)} onDone={(res)=>{ if(res && res.ok){ const m=describePayoutResult(res); if(m) setDetailPayNotice(m); } detailLedger.reload(); }}/>
            )}

            {detailDeleteFor && <CommissionInvoiceDelete target={detailDeleteFor} allAccounts={allAccounts} legacyPaidIds={detailLegacyPaidIds} onClose={()=>setDetailDeleteFor(null)} onOpenInOrders={onOpenInOrders} onDone={afterDetailDelete}/>}
            {detailAdjustFor && <CommissionInvoiceAdjust target={detailAdjustFor} legacyPaidIds={detailLegacyPaidIds} onClose={()=>setDetailAdjustFor(null)} onOpenInOrders={onOpenInOrders} onDone={afterDetailDelete}/>}
            {detailDeleteNotice && (
              <div style={{background:detailDeleteNotice.level==="bad"?C.redLight:C.amberLight,border:`1px solid ${detailDeleteNotice.level==="bad"?C.red:C.amber}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:detailDeleteNotice.level==="bad"?C.red:C.amber,marginBottom:12,display:"flex",justifyContent:"space-between",gap:12}}>
                <span>{detailDeleteNotice.text}</span>
                <button style={S.btnGhost} onClick={()=>setDetailDeleteNotice(null)}>Dismiss</button>
              </div>
            )}
            {/* Pending bucket — fresh invoices since last payout */}
            {pendingPeriodsBatched.length > 0 && (
              <div style={S.card}>
                <div style={S.cardHdr}>
                  <span style={S.cardTitle}>Pending payments for {detailRep.name}</span>
                  <span style={{fontSize:11,color:C.inkLight}}>Each row becomes a frozen batch when you click Mark paid</span>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"140px 1fr 90px 110px 110px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                  <span>Period</span><span>Details</span><span style={{textAlign:"right"}}>Sales</span><span style={{textAlign:"right"}}>Pending</span><span></span>
                </div>
                {pendingPeriodsBatched.map(p => {
                  const isExpanded = detailExpandedPeriod === "pending-"+p.periodLabel;
                  return (
                    <div key={"pending-"+p.periodLabel}>
                      <div onClick={()=>setDetailExpandedPeriod(isExpanded?null:"pending-"+p.periodLabel)} style={{display:"grid",gridTemplateColumns:"140px 1fr 90px 110px 110px",gap:8,padding:"12px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",cursor:"pointer",background:isExpanded?C.blueLight:C.amberLight}}>
                        <span style={{fontWeight:600,color:C.ink}}>{p.periodLabel}</span>
                        <span style={{color:C.inkLight}}>{p.invoices.length} invoice{p.invoices.length===1?"":"s"} · {detailRep.rate}% rate</span>
                        <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${p.sales.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                        <span style={{fontWeight:700,color:"#B45309",textAlign:"right"}}>${p.commission.toFixed(2)}</span>
                        <button style={{...S.btnSuccess,fontSize:11,padding:"4px 10px"}} onClick={e=>{e.stopPropagation();setDetailMarkingPeriod(p);setDetailPayForm({date:"",method:"ACH",notes:"",payThrough:_todayYmd()});setDetailCorrSel(null);setDetailRemitAckKey("");}}>Mark paid</button>
                      </div>
                      {isExpanded && (
                        <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                          <div style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 130px",gap:8,padding:"8px 18px",fontSize:10,fontWeight:600,color:C.inkLight}}>
                            <span>Invoice</span><span>Date</span><span>Customer</span><span>Items</span><span style={{textAlign:"right"}}>Total</span><span style={{textAlign:"right"}}>Commission</span><span></span>
                          </div>
                          {p.invoices.map(inv => (
                            <div key={inv.id} style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 130px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`}}>
                              <span style={{fontWeight:600,color:C.blue}}>{inv.id}</span>
                              <span style={{color:C.inkLight}}>{inv.date||""}</span>
                              <span style={{color:C.ink}}>{inv.customer||""} <RemitBadge inv={inv} remit={detailRemit}/></span>
                              <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={itemsLabel(inv)}>{itemsLabel(inv)}</span>
                              <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number(inv.total)||0).toFixed(2)}</span>
                              <span style={{fontWeight:500,color:C.teal,textAlign:"right"}}>${((Number(inv.total)||0)*(detailRep.rate||0)/100).toFixed(2)}</span>
                              <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                                <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setRepCustViewInvoice(inv);}}>View</button>
                                <button disabled={!!detailAdjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:detailAdjBlock(inv)?0.5:1,cursor:detailAdjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setDetailAdjustFor({inv:inv,repName:detailRep.name,rate:detailRep.rate});}} title={detailAdjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>
                                <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDetailDeleteFor({inv,repName:detailRep.name,rate:detailRep.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Paid batches — frozen history */}
            <div style={S.card}>
              <div style={S.cardHdr}>
                <span style={S.cardTitle}>Payment history (batches)</span>
                <span style={{fontSize:11,color:C.inkLight}}>{paidBatches.length} batch{paidBatches.length===1?"":"es"}</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"120px 100px 80px 100px 100px 120px",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                <span>Paid date</span><span>Method</span><span style={{textAlign:"right"}}>Invoices</span><span style={{textAlign:"right"}}>Commission</span><span>Status</span><span></span>
              </div>
              {paidBatches.length===0 && <div style={{padding:20,textAlign:"center",color:C.inkLight,fontSize:12}}>No payouts yet for {detailRep.name}.</div>}
              {paidBatches.map(b => {
                const isExpanded = detailExpandedPeriod === "batch-"+b.batchId;
                return (
                  <div key={"batch-"+b.batchId}>
                    <div onClick={()=>setDetailExpandedPeriod(isExpanded?null:"batch-"+b.batchId)} style={{display:"grid",gridTemplateColumns:"120px 100px 80px 100px 100px 120px",gap:8,padding:"12px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",cursor:"pointer",background:isExpanded?C.blueLight:"transparent"}}>
                      <span style={{fontWeight:600,color:C.ink}}>{b.paidAt ? new Date(b.paidAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "—"}</span>
                      <span style={{color:C.inkLight}}>{b.method||"—"}</span>
                      <span style={{color:C.inkLight,textAlign:"right"}}>{b.invoiceCount}</span>
                      <span style={{fontWeight:600,color:C.green,textAlign:"right"}}>${b.commission.toFixed(2)}</span>
                      <span style={{display:"flex",gap:4}}>{b.legacy&&<span style={S.pillGray}>Legacy</span>}<span style={S.pillGreen}>Paid</span></span>
                      <button style={{...S.btnSmall,fontSize:11,padding:"4px 10px",color:C.red,borderColor:"#FCA5A5"}} onClick={e=>{e.stopPropagation();undoBatch(b);}}>Undo batch</button>
                    </div>
                    {isExpanded && (
                      <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                        <div style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:10,fontWeight:600,color:C.inkLight}}>
                          <span>Invoice</span><span>Date</span><span>Customer</span><span>Items</span><span style={{textAlign:"right"}}>Total</span><span style={{textAlign:"right"}}>Commission</span><span></span>
                        </div>
                        {(()=>{
                          // Frozen view: paid amounts and rate come from the PAID rows,
                          // never total x the current rate; a paid id missing from the
                          // resolved invoices is shown as VOIDED so count and rows agree.
                          const lines = frozenBatchLines({ batch:b, paidRows:detailFrozenRows, corrections:detailLedger.corrections, allInvoices:SHARED_INVOICES.getAll() });
                          if (!lines) return null;
                          return lines.map(ln => {
                            const inv = ln.inv;
                            // No Undo on a voided / not-in-list line or a duplicate payout row.
                            const canUndoOne = !b.legacy && detailPaidInvoiceIds.has(ln.id) && !ln.voided && !ln.duplicate;
                            return (
                              <div key={ln.rowKey}>
                                <div style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`,background:ln.voided?"#FEF2F2":"#F0FDF4"}}>
                                  <span style={{fontWeight:600,color:C.blue}}>{ln.id}</span>
                                  <span style={{color:C.inkLight}}>{(inv&&inv.date)||""}</span>
                                  <span style={{color:C.ink}}>{(inv&&inv.customer)||""} <RemitBadge inv={inv||{id:ln.id}} remit={detailRemit}/>{ln.voided && <span style={{...S.pillRed,marginLeft:6}} title={ln.cancelled?"This invoice was cancelled after it was paid":"This invoice is no longer in this rep's active invoice list"}>{ln.cancelled?"VOIDED":"NOT IN LIST"}</span>}{ln.duplicate && <span style={{...S.pillAmber,marginLeft:6}} title="A second payout row exists for this invoice. It is counted in the batch total.">DUPLICATE PAYOUT ROW</span>}</span>
                                  <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={inv?itemsLabel(inv):""}>{inv?itemsLabel(inv):"—"}</span>
                                  <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number.isFinite(ln.invoiceAmount)?ln.invoiceAmount:(Number(inv&&inv.total)||0)).toFixed(2)}</span>
                                  <span style={{fontWeight:500,color:C.teal,textAlign:"right"}} title={ln.rate!=null?`Paid at ${Number(ln.rate).toFixed(2)}%`:""}>${(Number.isFinite(ln.commission)?ln.commission:0).toFixed(2)}</span>
                                  <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                                    {inv && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setRepCustViewInvoice(inv);}}>View</button>}
                                    {canUndoOne && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={async e=>{e.stopPropagation(); if(!window.confirm(`Undo commission payout for ${ln.id}?`)) return; const undoGuard = await checkUndoAllowed(undoScopeFromRows(detailFrozenRows, [ln.id], [b.batchId])); if(!undoGuard.ok){ alert(undoGuard.message); return; } const res = await unmarkInvoiceCommissionPaid(ln.id); if(res.ok){ const fresh = await listRepCommissionPayments(); setDetailPaidRows(fresh); } else alert(`Could not undo: ${res.error||"unknown"}`);}}>Undo</button>}
                                    {inv && !ln.voided && <button disabled={!!detailAdjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:detailAdjBlock(inv)?0.5:1,cursor:detailAdjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setDetailAdjustFor({inv:inv,repName:detailRep.name,rate:ln.rate!=null?ln.rate:detailRep.rate});}} title={detailAdjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>}
                                    {inv && !ln.voided && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDetailDeleteFor({inv,repName:detailRep.name,rate:ln.rate!=null?ln.rate:detailRep.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>}
                                  </span>
                                </div>
                                {ln.corrections.map(c => (
                                  <div key={c.id} style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 150px",gap:8,padding:"4px 18px 6px",fontSize:10,color:C.inkLight,background:"#FFFBEB"}}>
                                    <span></span><span>{c.created_at?new Date(c.created_at).toLocaleDateString("en-US",{month:"short",day:"numeric"}):""}</span>
                                    <span style={{gridColumn:"3 / span 2"}}>Correction ({c.status}): {c.reason}</span>
                                    <span></span>
                                    <span style={{fontWeight:600,color:c.delta<0?C.red:C.green,textAlign:"right"}}>{fmtSignedMoney(c.delta)}</span>
                                    <span></span>
                                  </div>
                                ))}
                              </div>
                            );
                          });
                        })() || b.invoices.map(inv => {
                          const canUndoOne = !b.legacy && detailPaidInvoiceIds.has(String(inv.id));
                          return (
                            <div key={inv.id} style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 1fr 90px 90px 150px",gap:8,padding:"8px 18px",fontSize:11,alignItems:"center",borderTop:`1px solid ${C.border}`,background:"#F0FDF4"}}>
                              <span style={{fontWeight:600,color:C.blue}}>{inv.id}</span>
                              <span style={{color:C.inkLight}}>{inv.date||""}</span>
                              <span style={{color:C.ink}}>{inv.customer||""} <RemitBadge inv={inv} remit={detailRemit}/></span>
                              <span style={{color:C.inkLight,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={itemsLabel(inv)}>{itemsLabel(inv)}</span>
                              <span style={{fontWeight:500,color:C.ink,textAlign:"right"}}>${(Number(inv.total)||0).toFixed(2)}</span>
                              <span style={{fontWeight:500,color:C.teal,textAlign:"right"}}>${((Number(inv.total)||0)*(detailRep.rate||0)/100).toFixed(2)}</span>
                              <span style={{display:"flex",gap:4,justifyContent:"flex-end",flexWrap:"wrap",minWidth:0}}>
                                <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px"}} onClick={e=>{e.stopPropagation();setRepCustViewInvoice(inv);}}>View</button>
                                {canUndoOne && <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={async e=>{e.stopPropagation(); if(!window.confirm(`Undo commission payout for ${inv.id}?`)) return; const undoGuard = await checkUndoAllowed(undoScopeFromRows(detailFrozenRows, [String(inv.id)], [b.batchId])); if(!undoGuard.ok){ alert(undoGuard.message); return; } const res = await unmarkInvoiceCommissionPaid(String(inv.id)); if(res.ok){ const fresh = await listRepCommissionPayments(); setDetailPaidRows(fresh); } else alert(`Could not undo: ${res.error||"unknown"}`);}}>Undo</button>}
                                <button disabled={!!detailAdjBlock(inv)} style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#EFF6FF",color:C.blue,border:"1px solid #BFDBFE",opacity:detailAdjBlock(inv)?0.5:1,cursor:detailAdjBlock(inv)?"not-allowed":"pointer"}} onClick={e=>{e.stopPropagation();setDetailAdjustFor({inv:inv,repName:detailRep.name,rate:detailRep.rate});}} title={detailAdjBlock(inv) || "Adjust = change quantities / lines of this unpaid invoice. The rep sees it and the commission follows."}>Adjust</button>
                                <button style={{...S.btnSmall,fontSize:10,padding:"3px 8px",background:"#FEE2E2",color:C.red,border:"1px solid #FCA5A5"}} onClick={e=>{e.stopPropagation();setDetailDeleteFor({inv,repName:detailRep.name,rate:detailRep.rate});}} title="Delete = void this invoice (Cancelled everywhere, excluded from commission). Asks for a reason.">Delete</button>
                              </span>
                            </div>
                          );
                        })}
                        {detailSettleMap.has(b.batchId) && (
                          <div style={{padding:"8px 18px",fontSize:11,color:C.inkMid,background:"#FFFBEB",borderTop:`1px solid ${C.border}`}}>
                            Corrections settled in this payout: {detailSettleMap.get(b.batchId).count} ({fmtSignedMoney(detailSettleMap.get(b.batchId).total)}). Cash paid = ${b.commission.toFixed(2)} invoices {fmtSignedMoney(detailSettleMap.get(b.batchId).total)} corrections = ${(b.commission+detailSettleMap.get(b.batchId).total).toFixed(2)}.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              {detailCorrOnlyHistory.map(cs => (
                <div key={"corr-"+cs.batchId} style={{display:"grid",gridTemplateColumns:"120px 100px 80px 100px 100px 120px",gap:8,padding:"12px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,alignItems:"center",background:"#FFFBEB"}} title={`Corrections settlement ${cs.batchId}`}>
                  <span style={{fontWeight:600,color:C.ink}}>{cs.paidAt ? new Date(cs.paidAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "—"}</span>
                  <span style={{color:C.inkLight}}>{cs.method||"—"}</span>
                  <span style={{color:C.inkLight,textAlign:"right"}}>{cs.count}</span>
                  <span style={{fontWeight:600,color:cs.total<0?C.red:C.green,textAlign:"right"}}>{fmtSignedMoney(cs.total)}</span>
                  <span style={S.pillAmber}>Corrections settlement</span>
                  <span></span>
                </div>
              ))}
            </div>
          </>);
        })()}

        {viewTab==="prospects"&&(<div style={S.card}>
          <div style={S.cardHdr}><span style={S.cardTitle}>Potential customers ({(detailRep.prospects||[]).length})</span><button style={S.btnSecondary} onClick={()=>{const h=["Company","Contact","Email","Phone","Address","Tier","Priority","Last Contact","Comments","Reminders"];const rows=(detailRep.prospects||[]).map(p=>[p.company,p.contact,p.email,p.phone,p.address,p.tier,p.priority,p.lastContact||"",(p.comments||[]).map(c2=>c2.date+": "+c2.text).join(" | "),(p.reminders||[]).map(r=>(r.done?"[DONE] ":"")+r.date+": "+r.text).join(" | ")]);const csv=[h,...rows].map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");const blob=new Blob([csv],{type:"text/csv"});const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;a.download=`${detailRep.name.replace(/\s/g,"_")}_prospects.csv`;a.click();URL.revokeObjectURL(url);}}>Export CSV</button></div>
          {(detailRep.prospects||[]).length===0?<div style={{padding:24,textAlign:"center",color:C.inkLight,fontSize:13}}>No potential customers tracked.</div>:(<>
            <div style={{display:"grid",gridTemplateColumns:"1fr 120px 140px 100px 80px 100px 1fr",gap:8,padding:"8px 18px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}><span>Company</span><span>Contact</span><span>Email / Phone</span><span>Address</span><span>Priority</span><span>Last contact</span><span>Reminders</span></div>
            {(detailRep.prospects||[]).map(p=>{const dr=(p.reminders||[]).filter(r=>!r.done&&r.date<=today);return(<div key={p.id} style={{display:"grid",gridTemplateColumns:"1fr 120px 140px 100px 80px 100px 1fr",alignItems:"center",gap:8,padding:"11px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12,background:dr.length>0?"#FFFBEB":"transparent"}}><div><div style={{fontWeight:600,color:C.ink}}>{p.company}</div>{(p.comments||[]).length>0&&<div style={{fontSize:10,color:C.inkLight}}>{(p.comments||[]).length} comment{(p.comments||[]).length>1?"s":""}</div>}</div><span style={{color:C.inkMid}}>{p.contact}</span><div><div style={{fontSize:11,color:C.inkMid}}>{p.email}</div><div style={{fontSize:10,color:C.inkLight}}>{p.phone}</div></div><span style={{fontSize:10,color:C.inkLight}}>{p.address?.split(",").slice(-2).join(",")}</span><span style={p.priority==="high"?S.pillRed:p.priority==="medium"?S.pillAmber:S.pillGray}>{p.priority}</span><span style={{fontSize:11,color:p.lastContact?C.inkMid:C.inkLight}}>{p.lastContact||"Never"}</span><div>{dr.length>0?<div style={{display:"flex",flexDirection:"column",gap:2}}>{dr.map((r,i)=>(<span key={i} style={{fontSize:10,padding:"2px 6px",borderRadius:4,background:"#FEF3C7",color:"#B45309"}}>{r.text}</span>))}</div>:<span style={{fontSize:10,color:C.inkLight}}>{(p.reminders||[]).length>0?`${(p.reminders||[]).filter(r=>r.done).length}/${(p.reminders||[]).length} done`:"None"}</span>}</div></div>);})}
          </>)}
        </div>)}
      </>)}

      {/* ── Rep list (hidden when detail is open) ── */}
      {!selectedRep&&<>
      {/* Pending rep applications */}
      {pendingReps.length>0&&(
        <div style={{marginBottom:20}}>
          <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>Pending sales rep applications ({pendingReps.length})</div>
          {pendingReps.map(ac=>(
            <div key={ac.id} style={{background:C.white,border:`2px solid ${C.teal}`,borderRadius:12,padding:"16px 18px",marginBottom:10}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:16,alignItems:"start"}}>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}>
                    <span style={{fontSize:14,fontWeight:600,color:C.ink}}>{ac.contact||ac.email}</span>
                    <span style={{background:C.tealLight,color:C.teal,fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:6}}>Sales Rep</span>
                  </div>
                  <div style={{fontSize:12,color:C.inkLight}}>{ac.email} · Applied {ac.joined}</div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setReviewingApp(reviewingApp===ac.id?null:ac.id)} style={{...S.btnSecondary,fontSize:12,padding:"7px 14px"}}>{reviewingApp===ac.id?"Hide details":"Review →"}</button>
                  {ac.isLive&&typeof onRequestDelete==="function"&&canOfferDelete(ac)&&<button onClick={()=>onRequestDelete(ac)} style={{background:"rgba(248,113,113,0.2)",border:"1px solid rgba(248,113,113,0.45)",color:"#B91C1C",borderRadius:8,fontSize:12,fontWeight:600,padding:"7px 14px",cursor:"pointer"}}>Delete</button>}
                </div>
              </div>
              {reviewingApp===ac.id&&(
                <div style={{marginTop:14,borderTop:`1px solid ${C.border}`,paddingTop:14}}>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                    <div style={{background:C.surface,borderRadius:8,padding:"12px 14px"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Personal information</div>
                      <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:4}}>{ac.contact||"—"}</div>
                      <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Email: {ac.email||"—"}</div>
                      <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Phone: {ac.phone||"Not provided"}</div>
                      {ac.refCode&&<div style={{fontSize:11,fontFamily:"monospace",color:C.blue,marginTop:4}}>Ref: {ac.refCode}</div>}
                    </div>
                    <div style={{background:C.surface,borderRadius:8,padding:"12px 14px"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Territory & details</div>
                      <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Territory: {ac.address||"Not specified"}</div>
                      <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Applied: {ac.joined||"—"}</div>
                      <div style={{fontSize:12,color:C.inkMid}}>Role: Sales Representative</div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                    <button onClick={()=>{onRejectRep&&onRejectRep(ac.id);setReviewingApp(null);}} style={{...S.btnSecondary,fontSize:12,padding:"8px 18px",color:C.red}}>Reject application</button>
                    <button onClick={()=>{onApproveRep&&onApproveRep(ac.id);setReviewingApp(null);}} style={{...S.btnPrimary,background:C.teal,fontSize:12,padding:"8px 18px"}}>Approve as sales rep →</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {archiveCount>0 && typeof onOpenArchive==="function" && (
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
          <button
            style={{...S.btnSmall,background:"transparent",color:C.red,border:`1px solid ${C.red}`}}
            onClick={onOpenArchive}
            title="Deleted and paused reps and dealers, with Restore"
          >Deleted &amp; paused accounts ({archiveCount}) →</button>
        </div>
      )}
      {/* Summary metrics — Combined YTD is derived from live invoices so it
          matches the sum of each rep's YTD sales shown on their own page. */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:12,marginBottom:16}}>
        {(()=>{
          const combinedYTD = repsWithVisits.reduce((s,r)=>s+repMetricsFor(r).ytdRevenue,0);
          return [
            {l:"Total reps",         v:reps.length,                                                                                  key:"all"},
            {l:"Assigned accounts",  v:Object.values(repAssignedAccounts).reduce((s,a)=>s+a.length,0),                                key:"assigned"},
            {l:"Total customers",    v:repsWithVisits.reduce((s,r)=>s+(r.customers||[]).length,0),                                    key:"customers"},
            {l:"Potential customers",v:repsWithVisits.reduce((s,r)=>s+(r.prospects||[]).length,0),                                    key:"prospects"},
            {l:"Total visits (30d)", v:repsWithVisits.reduce((s,r)=>s+r.visits.filter(v=>v.date>=monthAgo).length,0),                 key:"visits30"},
            {l:"Combined YTD sales", v:`$${combinedYTD.toLocaleString(undefined,{maximumFractionDigits:0})}`,                         key:"ytdsales"},
          ];
        })().map(m=>{
          const active = repListFilter===m.key && m.key!=="all";
          return (
            <div
              key={m.l}
              onClick={()=>setRepListFilter(active ? "all" : m.key)}
              style={{
                ...S.metric,
                cursor:"pointer",
                boxShadow: active ? `0 0 0 2px ${C.blue}` : undefined,
                transition:"box-shadow 0.15s, transform 0.15s"
              }}
              onMouseEnter={e=>{ if(!active) e.currentTarget.style.transform="translateY(-1px)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
            >
              <div style={S.mLabel}>{m.l}</div><div style={S.mValue}>{m.v}</div>
              {active && <div style={{fontSize:10,color:C.blue,marginTop:4,fontWeight:600}}>Filtering reps ↓</div>}
            </div>
          );
        })}
      </div>

      {/* Search */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <span style={{fontSize:13,fontWeight:600,color:C.ink}}>All sales reps ({filteredReps.length})</span>
        <input style={{...S.input,width:260}} value={repSearch} onChange={e=>setRepSearch(e.target.value)} placeholder="Search by name, email, ref code..."/>
      </div>

      {/* Rep cards */}
      {filteredReps.map(rep=>{
        const stats = getRepStats(rep);
        const rm = repMetricsFor(rep);
        return (
          <div key={rep.id} style={{...S.card,cursor:"pointer",transition:"box-shadow 0.15s"}} onClick={()=>{setSelectedRep(rep.id);setViewTab("activity");setPeriod("all");}}>
            <div style={{padding:"18px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div style={{display:"flex",alignItems:"center",gap:14}}>
                <div style={{width:44,height:44,borderRadius:"50%",background:rep.isLive?C.tealLight:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,fontWeight:700,color:rep.isLive?C.teal:C.blue}}>
                  {rep.name.split(" ").map(w=>w[0]).join("").toUpperCase()}
                </div>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:14,fontWeight:600,color:C.ink}}>{rep.name}</span>
                    {rep.refCode&&<span style={{fontSize:10,fontFamily:"monospace",color:C.blue,background:C.blueLight,padding:"1px 6px",borderRadius:4}}>{rep.refCode}</span>}
                    {rep.isLive&&<span style={{fontSize:10,color:C.teal,background:C.tealLight,padding:"1px 6px",borderRadius:4,fontWeight:600}}>New</span>}
                  </div>
                  <div style={{fontSize:11,color:C.inkLight}}>{rep.email} · {rep.territory}</div>
                  <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>
                    <span style={{fontWeight:600,color:(repAssignedAccounts[rep.name]||[]).length>0?C.blue:C.inkLight}}>{(repAssignedAccounts[rep.name]||[]).length} assigned accounts</span>
                    {" · "}{(rep.customers||[]).length} customers · {(rep.prospects||[]).length} prospects · Commission: {rep.rate}% · Since {rep.startDate}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:16,alignItems:"center"}}>
                <div style={{textAlign:"center"}}><div style={{fontSize:18,fontWeight:600,color:C.ink}}>{stats.todayV}</div><div style={{fontSize:10,color:C.inkLight}}>Today</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:18,fontWeight:600,color:C.ink}}>{stats.weekV}</div><div style={{fontSize:10,color:C.inkLight}}>This week</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:18,fontWeight:600,color:C.ink}}>{stats.monthV}</div><div style={{fontSize:10,color:C.inkLight}}>This month</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:18,fontWeight:600,color:C.teal}}>${rm.ytdRevenue.toLocaleString(undefined,{maximumFractionDigits:0})}</div><div style={{fontSize:10,color:C.inkLight}}>YTD sales</div></div>
                <div style={{textAlign:"center"}}><div style={{fontSize:18,fontWeight:600,color:C.amber}}>${rm.pendingCommission.toFixed(0)}</div><div style={{fontSize:10,color:C.inkLight}}>Pending commission (est.)</div></div>
                <div style={{display:"flex",gap:4,alignItems:"center"}}>
                  <button style={{...S.btnSmall,fontSize:11}} onClick={e=>{e.stopPropagation();startEditRep(rep);}}>Edit</button>
                  <button style={{...S.btnSmall,fontSize:11,color:C.amber,borderColor:"#FCD34D"}} title="Pause — temporarily block login" onClick={e=>{e.stopPropagation();openSuspendRepModal(rep,"pause");}}>⏸</button>
                  <button style={{...S.btnSmall,fontSize:11,color:C.red,borderColor:"#FCA5A5"}} title="Delete — move to Deleted & paused accounts" onClick={e=>{e.stopPropagation();openSuspendRepModal(rep,"delete");}}>✕</button>
                </div>
                <div style={{color:C.inkLight,fontSize:16}}>›</div>
              </div>
            </div>
          </div>
        );
      })}

      {/* Commission payments */}
      <div style={{marginTop:8}}>
        <div style={{fontSize:11,color:C.inkLight,marginBottom:8}}>Commission for deleted or paused reps is not listed here. It stays visible, with a Deleted / Paused badge, under the Commission tab.</div>
        <AdminCommissionTab onOpenInOrders={onOpenInOrders} reps={repsWithVisits} allAccounts={allAccounts} sharedRepCusts={sharedRepCusts}/>
      </div>
      </>}

      {/* ── Rep edit modal ── */}
      {editingRep&&editRepData&&(
        <div style={S.modal}>
          <div style={{...S.modalBox,width:560,maxHeight:"85vh",overflowY:"auto"}}>
            <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Edit sales rep</div>
            <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>{editRepData.name}</div>
            {editRepData.refCode&&<div style={{fontSize:12,fontFamily:"monospace",color:C.blue,background:C.blueLight,display:"inline-block",padding:"3px 10px",borderRadius:6,marginBottom:12}}>Ref: {editRepData.refCode}</div>}

            <div style={{background:C.surface,borderRadius:8,padding:"14px 16px",marginBottom:16}}>
              <div style={{fontSize:11,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>Personal information</div>
              <div style={S.twoCol}>
                <div style={S.fg}><label style={S.label}>Full name *</label><input style={S.input} value={editRepData.name||""} onChange={e=>setEditRepData(d=>({...d,name:e.target.value}))}/></div>
                <div style={S.fg}><label style={S.label}>Email</label><input style={S.input} value={editRepData.email||""} onChange={e=>setEditRepData(d=>({...d,email:e.target.value}))}/></div>
              </div>
              <div style={S.twoCol}>
                <div style={S.fg}><label style={S.label}>Phone</label><input style={S.input} value={editRepData.phone||""} onChange={e=>setEditRepData(d=>({...d,phone:e.target.value}))}/></div>
                <div style={S.fg}><label style={S.label}>Territory / region</label><input style={S.input} value={editRepData.territory||""} onChange={e=>setEditRepData(d=>({...d,territory:e.target.value}))}/></div>
              </div>
            </div>

            <div style={{background:C.surface,borderRadius:8,padding:"14px 16px",marginBottom:16}}>
              <div style={{fontSize:11,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>Commission & schedule</div>
              <div style={S.twoCol}>
                <div style={S.fg}>
                  <label style={S.label}>Commission rate (%)</label>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <input style={{...S.input,width:80}} type="number" min="0" max="30" step="0.5" value={editRepData.rate||0} onChange={e=>setEditRepData(d=>({...d,rate:parseFloat(e.target.value)||0}))}/>
                    <span style={{fontSize:12,color:C.inkLight}}>%</span>
                    {editRepData.rate>0&&<span style={{...S.pillGreen}}>{editRepData.rate}% commission</span>}
                  </div>
                </div>
                <div style={S.fg}><label style={S.label}>Pay schedule</label>
                  <select style={S.select} value={editRepData.paySchedule||"15th of month"} onChange={e=>setEditRepData(d=>({...d,paySchedule:e.target.value}))}>
                    <option value="15th of month">15th of month</option>
                    <option value="End of month">End of month</option>
                    <option value="Bi-weekly">Bi-weekly</option>
                    <option value="Weekly">Weekly</option>
                  </select>
                </div>
              </div>
              <div style={S.twoCol}>
                <div style={S.fg}><label style={S.label}>Start date</label><input style={S.input} value={editRepData.startDate||""} onChange={e=>setEditRepData(d=>({...d,startDate:e.target.value}))}/></div>
                <div style={S.fg}>
                  <label style={S.label}>YTD sales (auto)</label>
                  <div style={{...S.input,background:C.surface,color:C.inkMid,display:"flex",alignItems:"center"}}>${repMetricsFor(editRepData).ytdRevenue.toLocaleString(undefined,{maximumFractionDigits:0})}</div>
                  <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Derived from live invoices — edit invoices, not this field.</div>
                </div>
              </div>
            </div>

            <div style={S.fg}>
              <label style={S.label}>Notes</label>
              <textarea style={{...S.input,height:64,resize:"vertical"}} value={editRepData.notes||""} onChange={e=>setEditRepData(d=>({...d,notes:e.target.value}))} placeholder="Internal notes about this rep..."/>
            </div>

            {saveRepError && (
              <div style={{background:C.redLight,border:`1px solid ${C.red}`,color:C.red,padding:"10px 14px",borderRadius:8,fontSize:12,marginTop:12,whiteSpace:"pre-wrap"}}>
                {saveRepError}
              </div>
            )}

            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
              <button style={{...S.btnSecondary,color:C.amber}} onClick={()=>{openSuspendRepModal(editRepData,"pause");setEditingRep(null);}}>Pause rep</button>
              <button style={{...S.btnSecondary,color:C.red}} onClick={()=>{openSuspendRepModal(editRepData,"delete");setEditingRep(null);}}>Delete rep</button>
              <div style={{flex:1}}/>
              <button style={S.btnSecondary} onClick={()=>{setEditingRep(null);setEditRepData(null);setSaveRepError("");}} disabled={saveRepBusy}>Cancel</button>
              <button style={{...S.btnPrimary, opacity:saveRepBusy?0.6:1, cursor:saveRepBusy?"not-allowed":"pointer"}} onClick={saveRepEdit} disabled={saveRepBusy}>
                {saveRepBusy ? "Saving…" : "Save changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Pause / delete rep — reason capture ──
          A reason is always required so every suspended rep has an auditable "why".
          The rep moves to the Deleted & paused accounts section under the
          Accounts tab (with full history + Restore button). */}
      {suspendRepModal&&(()=>{
        const { rep, mode } = suspendRepModal;
        const isDelete = mode==="delete";
        const rm = repMetricsFor(rep);
        return (
          <div style={S.modal}>
            <div style={{...S.modalBox,width:480}}>
              <div style={{fontSize:17,fontWeight:700,color:C.ink,marginBottom:4}}>{isDelete?"Delete":"Pause"} sales rep?</div>
              <div style={{fontSize:13,color:C.inkLight,marginBottom:14}}>
                {isDelete
                  ? "The rep will be moved to Deleted & paused accounts. Full history, commissions, and assigned dealers are preserved, but login is blocked — they'll see a \"Contact MotorPower Care\" message."
                  : "The rep will be temporarily blocked from signing in. You can restore them anytime from Deleted & paused accounts under the Accounts tab."}
              </div>
              <div style={{background:isDelete?"#FEF2F2":C.amberLight,border:`1px solid ${isDelete?"#FCA5A5":"#FCD34D"}`,borderRadius:8,padding:"11px 14px",marginBottom:14}}>
                <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{rep.name}</div>
                <div style={{fontSize:12,color:C.inkLight}}>{rep.email}{rep.territory?" · "+rep.territory:""}</div>
                <div style={{fontSize:12,color:C.inkLight}}>{rep.customers?.length||0} customers · ${rm.ytdRevenue.toLocaleString(undefined,{maximumFractionDigits:0})} YTD sales</div>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Reason <span style={{color:C.red}}>*</span></label>
                <textarea
                  style={{...S.input,minHeight:80,resize:"vertical",fontFamily:"inherit"}}
                  value={suspendRepReason}
                  onChange={e=>setSuspendRepReason(e.target.value)}
                  placeholder={isDelete?"e.g. Rep resigned, territory reorganization, policy violation…":"e.g. On leave, performance review, compliance hold…"}
                  autoFocus
                />
                <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>Kept on file with the rep's history.</div>
              </div>
              <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
                <button style={S.btnSecondary} onClick={()=>{setSuspendRepModal(null);setSuspendRepReason("");}} disabled={suspendRepSubmitting}>Cancel</button>
                <button
                  style={{...S.btnPrimary,background:isDelete?"#DC2626":C.amber,opacity:(suspendRepSubmitting||!suspendRepReason.trim())?0.5:1,cursor:(suspendRepSubmitting||!suspendRepReason.trim())?"not-allowed":"pointer"}}
                  onClick={applyRepSuspension}
                  disabled={suspendRepSubmitting||!suspendRepReason.trim()}
                >
                  {suspendRepSubmitting?"Working…":(isDelete?"Delete rep":"Pause rep")}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

// ── ADMIN REP INVENTORY TAB — Warehouse stock + per-rep inventory ledger ────
// Source of truth for current rep on-hand:
//   on_hand(rep, sku) = sum(inventory_movements for rep, sku) - sum(sold units from invoices)
// There is no separate rep_inventory table; everything derives from the ledger
// + SHARED_INVOICES so the math in requirement #4 is automatic and drift-free.

// exported for the render tests (src/inventoryTabRender.test.js)
export function AdminRepInventoryTab({ liveReps: liveRepsProp = [], inactiveReps = [], allAccounts = [], adminUserEmail = "", onWarehouseChanged, onLiveWarehouseRead }) {
  // Deleted / paused reps stay listed here (badged) so rep stock never vanishes from admin view.
  const liveReps = useMemo(()=>[...(liveRepsProp||[]), ...(inactiveReps||[])],[liveRepsProp, inactiveReps]);
  // ── Sources of truth ──────────────────────────────────────────────────────
  const [warehouse, setWarehouse] = useState([]);          // [{sku, product_name, qty, updated_at}]
  const [movements, setMovements] = useState([]);          // append-only ledger
  const [invoices, setInvoices] = useState(()=>SHARED_INVOICES.getAll());
  const [loading, setLoading] = useState(true);
  // Shared rep customer store (route planner data) — used to match invoices to reps.
  const [sharedRepCusts, setSharedRepCusts] = useState(()=>SHARED_REP_CUSTOMERS.getAll());
  useEffect(()=>{ const unsub = SHARED_REP_CUSTOMERS.subscribe(setSharedRepCusts); return unsub; },[]);
  // Shared rep profile overrides so admin sees current rep metadata.
  const [sharedRepProfiles, setSharedRepProfiles] = useState(()=>SHARED_REP_PROFILES.getAll());
  useEffect(()=>{ const unsub = SHARED_REP_PROFILES.subscribe(setSharedRepProfiles); return unsub; },[]);

  // Reload movements + warehouse on mount and after any mutation.
  // The WHOLE ledger is read (every page, verified against the exact server count). A
  // failed read is not silent: ledgerNotice drives an amber banner with Retry, and the
  // last GOOD in-memory ledger / warehouse is kept (the localStorage cache is only adopted
  // if this session never had a good read; the admin's unfiltered ledger read is never
  // cached at all). onWarehouseChanged (which syncs the product listing stock) only runs
  // on LIVE warehouse rows, never on a cache, and not from the background refreshes.
  // refresh() runs through ONE coordinator (src/refreshCoordinator.js): never two fetches
  // at once, and `await refresh()` after a mutation resolves only when the fetch that
  // started after the write has finished, so the table shows the new numbers.
  const [ledgerNotice, setLedgerNotice] = useState("");
  const ledgerGoodRef = useRef(false);
  const warehouseGoodRef = useRef(false);
  const syncProductsRef = useRef(false);
  const refreshRunRef = useRef(null);
  const refresherRef = useRef(null);
  refreshRunRef.current = async (ctx) => {
    // ctx.isCurrent() turns false when the coordinator abandoned this run at its deadline:
    // a LATE result must neither be adopted nor touch the loading flag of a newer run.
    const current = () => !(ctx && typeof ctx.isCurrent === "function") || ctx.isCurrent();
    setLoading(true);
    let doSync = false;
    try {
      doSync = syncProductsRef.current;
      syncProductsRef.current = false;
      const [w, m] = await Promise.all([getWarehouseStockChecked(), getInventoryMovementsChecked()]);
      if(!current()) {
        console.warn("[AdminRepInventoryTab] a late refresh result was ignored (the run had timed out)");
        if(doSync) syncProductsRef.current = true;     // the product-listing sync did not happen: the next refresh does it
        return false;
      }
      const problems = [];
      if(m.ok) { ledgerGoodRef.current = true; setMovements(m.rows || []); }
      else { problems.push(`inventory ledger: ${m.error}`); if(!ledgerGoodRef.current) setMovements(m.rows || []); }
      if(w.ok) { warehouseGoodRef.current = true; setWarehouse(w.rows || []); }
      else { problems.push(`warehouse stock: ${w.error}`); if(!warehouseGoodRef.current) setWarehouse(w.rows || []); }
      setLedgerNotice(problems.join(" · "));
      if(w.ok && onLiveWarehouseRead) onLiveWarehouseRead();
      if(doSync && w.ok && onWarehouseChanged) onWarehouseChanged(w.rows || []);
      return m.ok && w.ok;
    } catch(e) {
      console.warn("[AdminRepInventoryTab] refresh threw:", e?.message || e);
      if(current()) setLedgerNotice(`refresh failed: ${e?.message || e}`);
      return false;
    } finally { if(current()) setLoading(false); }
  };
  if(!refresherRef.current) refresherRef.current = createRefreshCoordinator((ctx) => refreshRunRef.current(ctx), {
    label: "AdminRepInventoryTab",
    // a read that never settles is FAILED: the same amber banner (with Retry) as any failed read
    onTimeout: (ms) => { syncProductsRef.current = true; setLoading(false); setLedgerNotice(`refresh did not finish within ${Math.round(ms/1000)} s (the server did not answer): showing the last saved numbers`); },
  });
  // Mount, mutations, Retry and realtime call refresh() at once. The focus / tab-visible /
  // 60 s triggers pass { throttle:true, syncProducts:false }: skipped when the last
  // SUCCESSFUL read is under 15 s old, no product-listing stock write, timer only while
  // the tab is visible.
  const refresh = (opts)=>{
    if(!opts || opts.syncProducts !== false) syncProductsRef.current = true;
    return refresherRef.current.request({ throttle: !!(opts && opts.throttle) });
  };
  useEffect(()=>{ refresh(); },[]);
  useEffect(()=>{ const unsub = SHARED_INVOICES.subscribe(setInvoices); return unsub; },[]);
  // Freshness fallback: realtime is not guaranteed to be published for the inventory
  // tables, so also re-read on focus / visibility (one call) and every 60 s.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>attachFreshness(()=>{ refresh({ syncProducts:false, throttle:true }); }),[]);

  // Real-time sync — when ANY rep posts a rep_receive movement (or a warehouse
  // change happens from another browser) this admin view re-fetches the ledger
  // + warehouse. Meets requirement #1 ("admin and rep views show identical
  // numbers from a single Supabase source"): the subscription keeps them
  // identical without anyone hitting refresh. Safe if realtime is disabled —
  // the helper logs once and then falls back to manual refresh on mount.
  useEffect(()=>{
    const unsub = subscribeToInventoryChanges(() => { refresh(); });
    return unsub;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // ── Stock-receipt approval queue (Supabase inventory_requests, migration 0020) ──
  // Pending rows surfaced for admin review here AND on AdminNotificationsTab.
  // Approve writes ONE rep_receive row to inventory_movements via the
  // approveInventoryRequest helper (which re-fetches the request fresh before
  // writing — never operates on stale cached state per CLAUDE.md hard-rule #3).
  // Reject leaves inventory untouched. Both decisions are append-only — there
  // is no DELETE policy on inventory_requests, mirroring inventory_movements.
  const [inventoryRequests, setInventoryRequests] = useState([]);
  const [requestsError, setRequestsError] = useState("");
  const [reqEditedQty, setReqEditedQty] = useState({});       // id → number admin is about to approve
  const [reqDecisionNote, setReqDecisionNote] = useState({}); // id → optional note
  const [reqActionBusy, setReqActionBusy] = useState({});     // id → boolean while approve/reject in flight

  const refreshInventoryRequests = useCallback(async () => {
    try {
      const rows = await listInventoryRequests({ status: 'pending', limit: 200 });
      setInventoryRequests(rows || []);
      setRequestsError("");
    } catch (e) {
      console.warn("[AdminRepInventoryTab] listInventoryRequests failed:", e?.message || e);
      setRequestsError(e?.message || "Failed to load stock requests.");
    }
  }, []);

  useEffect(() => { refreshInventoryRequests(); }, [refreshInventoryRequests]);
  useEffect(() => {
    const unsub = subscribeInventoryRequests(() => { refreshInventoryRequests(); });
    return unsub;
  }, [refreshInventoryRequests]);

  const handleApproveRequest = async (req) => {
    if (!req || reqActionBusy[req.id]) return;
    const editedQty = reqEditedQty[req.id];
    const approvedQty = (editedQty != null && editedQty !== "")
      ? Number(editedQty)
      : Number(req.requested_qty);
    if (!Number.isFinite(approvedQty) || approvedQty <= 0) {
      setRequestsError("Approved qty must be greater than zero. Use Reject instead.");
      return;
    }
    setReqActionBusy(b => ({ ...b, [req.id]: true }));
    try {
      await approveInventoryRequest(req.id, {
        approvedQty,
        note: reqDecisionNote[req.id] || null,
        adminEmail: adminUserEmail || "",
      });
      // The permanent rep_receive row is saved: the result must not wait on a read that
      // can be slow or hang, so clear the edit state first and refresh in the background
      // (the queue: the row leaves pending; the ledger: the new rep_receive row).
      setReqEditedQty(s => { const n = { ...s }; delete n[req.id]; return n; });
      setReqDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      setRequestsError("");
      refreshInventoryRequests();
      Promise.resolve(refresh()).catch(e=>console.warn("[AdminRepInventoryTab] refresh after approve failed:", e?.message || e));
    } catch (e) {
      console.warn("[AdminRepInventoryTab] approve failed for request", req.id, ":", e?.message || e);
      setRequestsError(`Approve failed: ${e?.message || "unknown error"}`);
    } finally {
      setReqActionBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  const handleRejectRequest = async (req) => {
    if (!req || reqActionBusy[req.id]) return;
    setReqActionBusy(b => ({ ...b, [req.id]: true }));
    try {
      await rejectInventoryRequest(req.id, {
        note: reqDecisionNote[req.id] || null,
        adminEmail: adminUserEmail || "",
      });
      await refreshInventoryRequests();
      setReqEditedQty(s => { const n = { ...s }; delete n[req.id]; return n; });
      setReqDecisionNote(s => { const n = { ...s }; delete n[req.id]; return n; });
      setRequestsError("");
    } catch (e) {
      console.warn("[AdminRepInventoryTab] reject failed for request", req.id, ":", e?.message || e);
      setRequestsError(`Reject failed: ${e?.message || "unknown error"}`);
    } finally {
      setReqActionBusy(b => { const n = { ...b }; delete n[req.id]; return n; });
    }
  };

  // Warehouse is never auto-seeded from code (CLAUDE.md rule #1: code must never
  // write hardcoded/seed data to Supabase at runtime). Admin manually seeds via
  // the "Receive / adjust" button on the Warehouse stock card below — the empty-
  // state message inside that card ("Warehouse is empty. Add stock with the
  // Receive / adjust button.") guides them through it. Removing the auto-seed
  // also protects against accidental overwrites of admin-entered counts after
  // any future data-clear operation.

  // ── Period filter for "sold" column ───────────────────────────────────────
  const [period, setPeriod] = useState("all"); // week|month|year|all
  const periodLabel = { week:"last 7 days", month:"this month", year:"this year", all:"all time" }[period] || "all time";
  const periodStart = useMemo(()=>{
    const now = new Date();
    if(period==="week")  { const d=new Date(now); d.setDate(d.getDate()-7);   return d; }
    if(period==="month") { return new Date(now.getFullYear(), now.getMonth(), 1); }
    if(period==="year")  { return new Date(now.getFullYear(), 0, 1); }
    return null;
  },[period]);

  // ── Build rep identity list from the LIVE Supabase rep profiles (+ paused /
  // deleted reps, badged) and SHARED_REP_PROFILES overrides. Uses the Supabase
  // user id as rep_id so inventory_movements can be filtered by rep via the RLS
  // policy. The hardcoded demo reps (ADMIN_REP_DATA) are NOT listed: they have no
  // real stock and fuzzy-matched real reps' invoices. A demo rep appears only when
  // a ledger row actually references it (rep_id equal to its name). Ledger rows of
  // a rep_id that matches no listed rep land in the "Unassigned / unknown rep id"
  // bucket below, so no ledger row is ever left out of the totals.
  const repList = useMemo(()=>{
    const out = {};
    // NOTE: liveReps entries have `name` (from contact), not `full_name`. Checking
    // p.name first fixes the bug where the repList fell through to p.email even
    // though a display name existed on the liveRep entry.
    (liveReps||[]).forEach(p=>{
      const name = p.name || p.full_name || p.email || "";
      if(!name) return;
      const key = p.id || name;
      out[key] = {
        key,
        name,
        email: p.email || "",
        supabaseId: p.id || null,
        isLive: true,
        inactiveStatus: p.inactiveStatus || null
      };
    });
    // Demo reps only when the ledger references them.
    const ledgerRepIds = new Set((movements||[]).map(m=>m && m.rep_id).filter(Boolean).map(String));
    ADMIN_REP_DATA.forEach(r=>{
      if(!ledgerRepIds.has(String(r.name)) || out[r.name]) return;
      if(Object.values(out).some(x=>x.email && r.email && x.email.toLowerCase()===r.email.toLowerCase())) return;
      out[r.name] = { key: r.name, name: r.name, email: r.email||"", supabaseId: null, isLive: false };
    });
    // Overlay SHARED_REP_PROFILES so admin edits to phone/territory/name flow in (an
    // admin edit of a rep's display name / email reaches the list; skips the "—" placeholder).
    return overlayRepProfiles(Object.values(out), sharedRepProfiles);
  },[liveReps, sharedRepProfiles, movements]);

  // ── Core math — src/inventoryMath.js, the SAME functions the rep portal and the
  // delete-impact modal call, so the numbers cannot differ between accounts.
  //   assigned(rep, sku) = SIGNED sum of the rep's ledger rows
  //                        (assign / return / adjust_rep / rep_receive)
  //   sold(rep, sku)     = ALL-TIME UNITS on invoices the rep created + dealer
  //                        orders the rep delivered; cancelled never deduct
  //   onHand             = assigned − sold (signed; negative = oversold).
  // The "Sold period" dropdown only changes the DISPLAYED Sold column / card
  // (soldInPeriod). It never changes onHand or the Adjust baseline.
  // The catalog is the ONE source the rep portal uses too (inventoryCatalog()); the tab
  // subscribes to it so names and case sizes are current whenever the catalog loads.
  const [catalogVersion, setCatalogVersion] = useState(0);
  useEffect(()=>SHARED_PRODUCTS.subscribe(()=>setCatalogVersion(v=>v+1)),[]);
  const UNKNOWN_REP_KEY = "__unknown_rep_id__";
  // The identity inventoryMath matches invoices / ledger rows against: the SAME shared
  // helper the delete-impact figure uses (inventoryMath.buildRepIdentity).
  const identityOf = (r, ledgerRows)=>buildRepIdentity({
    rep: r, ledgerRows, sharedRepProfiles, sharedRepCustomers: sharedRepCusts, assignedAccounts: allAccounts,
  });
  // Every listed rep's identity + the one-owner resolver: a name-only invoice stamp is
  // deducted from EXACTLY ONE rep (exact name wins; the fuzzy first-name + last-initial
  // match counts only if one listed rep fits; otherwise the invoice is unattributed).
  const peerModel = useMemo(()=>{
    const identities = repList.map(r=>identityOf(r, movements));
    return { identities, resolver: createOwnerResolver(identities) };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[movements, repList, allAccounts, sharedRepCusts, sharedRepProfiles]);
  const dedupedInvoices = useMemo(()=>dedupeInvoicesById(invoices || []),[invoices]);

  // Invoices that would take stock from a rep but that no listed rep owns exactly once.
  const unattributed = useMemo(()=>{
    const idx = indexCatalog(inventoryCatalog());
    const caseBySku = {};
    Object.keys(idx).forEach(k=>{ if(idx[k].case != null) caseBySku[k] = idx[k].case; });
    return unattributedInvoices(dedupedInvoices, peerModel.identities, { resolver: peerModel.resolver, caseBySku });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dedupedInvoices, peerModel, catalogVersion]);
  const ledgerHasRepRows = useMemo(()=>(movements||[]).some(m=>m && m.rep_id && REP_LEDGER_TYPES.includes(m.movement_type)),[movements]);

  // Per rep rows + the "unknown rep id" bucket, from ONE call per rep.
  const repRows = useMemo(()=>{
    const catalog = inventoryCatalog();
    const out = repList.map((r, i)=>{
      const rows = repInventoryRows({
        movements, invoices: dedupedInvoices, rep: peerModel.identities[i], catalog, since: periodStart, resolver: peerModel.resolver,
      }).map(x=>({
        sku: x.sku, key: x.key, productName: x.name || "", assigned: x.received, sold: x.sold,
        soldInPeriod: x.soldInPeriod, onHand: x.onHand, mismatch: x.oversold, oversoldBy: x.oversoldBy,
      }));
      const t = inventoryTotals(rows.map(x=>({ received:x.assigned, sold:x.sold, onHand:x.onHand })));
      return {
        ...r, rows,
        totals: { assigned: t.received, sold: t.sold, soldInPeriod: rows.reduce((s,x)=>s+x.soldInPeriod,0), onHand: t.unitsOnHand, oversold: t.unitsOversold },
        mismatchCount: rows.filter(x=>x.mismatch).length,
      };
    });
    // Ledger rows whose rep_id matches no listed rep (also when NO rep is listed at all,
    // e.g. before the rep list has loaded): shown and counted, never dropped.
    const known = new Set(repList.map(r=>String(r.key)));
    const strays = (movements||[]).filter(m=>m && m.rep_id && !known.has(String(m.rep_id)) && REP_LEDGER_TYPES.includes(m.movement_type));
    if(strays.length > 0) {
      const rows = repInventoryRows({ movements: strays, invoices: [], anyRep: true, catalog })
        .map(x=>({
          sku: x.sku, key: x.key, productName: x.name || "", assigned: x.received, sold: 0,
          soldInPeriod: 0, onHand: x.onHand, mismatch: x.oversold, oversoldBy: x.oversoldBy,
        }));
      const t = inventoryTotals(rows.map(x=>({ received:x.assigned, sold:x.sold, onHand:x.onHand })));
      const ids = Array.from(new Set(strays.map(m=>`${m.rep_id}${m.rep_name?` (${m.rep_name})`:""}`)));
      out.push({
        key: UNKNOWN_REP_KEY, name: "Unassigned / unknown rep id", email: "", supabaseId: null, isLive: false,
        isUnknown: true, unknownIds: ids, rows,
        totals: { assigned: t.received, sold: 0, soldInPeriod: 0, onHand: t.unitsOnHand, oversold: t.unitsOversold },
        mismatchCount: rows.filter(x=>x.mismatch).length,
      });
    }
    return out;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[movements, dedupedInvoices, repList, peerModel, periodStart, catalogVersion]);

  // The SKU list of the Assign picker: the SAME flattened list the rep pickers use.
  const assignCatalog = useMemo(()=>flattenCatalogForPicker(inventoryCatalog()).map(p=>({ sku:p.sku, name:p.name })),[catalogVersion]); // eslint-disable-line react-hooks/exhaustive-deps
  // parent SKU -> its variation SKUs (for the note on the warehouse row of a variation product)
  const variationParents = useMemo(()=>{
    const m = {};
    inventoryCatalog().forEach(p=>{
      if(p && p.sku && Array.isArray(p.variations) && p.variations.length > 0) m[normSku(p.sku)] = p.variations.map(v=>v && v.sku).filter(Boolean);
    });
    return m;
  },[catalogVersion]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Global summary metrics ────────────────────────────────────────────────
  // "With sales reps" is inventoryTotals over the very rows shown below, so it
  // equals the sum of the per-SKU rows on screen. Units on hand (SKUs with stock)
  // and oversold units (shortfalls) are separate figures, never netted together.
  const summary = useMemo(()=>{
    const totalWarehouse = warehouse.reduce((s,w)=>s + (Number(w.qty)||0), 0);
    const allRows = [];
    repRows.forEach(r=>r.rows.forEach(x=>allRows.push({ received:x.assigned, sold:x.sold, onHand:x.onHand })));
    const t = inventoryTotals(allRows);
    const soldInPeriod = repRows.reduce((s,r)=>s + r.totals.soldInPeriod, 0);
    const mismatchReps = repRows.filter(r=>r.mismatchCount>0).length;
    return {
      totalWarehouse, unitsOnHand: t.unitsOnHand, unitsOversold: t.unitsOversold, oversoldSkus: t.oversoldSkuCount,
      totalAssigned: t.received, totalSold: t.sold, soldInPeriod, mismatchReps,
    };
  },[warehouse, repRows]);

  // ── Rep selector ──────────────────────────────────────────────────────────
  const [selectedRepKey, setSelectedRepKey] = useState("all");
  // Click the "Reconciliation flags" card to filter the rep breakdown below
  // to only reps with mismatches (sold more than they were assigned).
  // NOTE: must be declared BEFORE `visibleReps` reads it. Previously sat
  // below, which threw ReferenceError (TDZ) on first render and wiped the
  // whole Rep Inventory page.
  const [onlyMismatches, setOnlyMismatches] = useState(false);
  const visibleReps = (() => {
    const base = selectedRepKey === "all" ? repRows : repRows.filter(r=>r.key===selectedRepKey);
    return onlyMismatches ? base.filter(r => r.mismatchCount > 0) : base;
  })();

  // ── Modals ────────────────────────────────────────────────────────────────
  const [assignModal, setAssignModal] = useState(null);   // { repKey?, sku? } pre-fills
  const [adjustRepModal, setAdjustRepModal] = useState(null); // { rep, sku, productName, currentOnHand }
  const [warehouseModal, setWarehouseModal] = useState(null); // { sku, productName, qty }
  const [historyFilter, setHistoryFilter] = useState({ repKey:"all", sku:"", type:"all" });
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  // What the last write actually did (e.g. "warehouse count was not changed"), dismissable.
  const [actionNotice, setActionNotice] = useState(null);   // { kind:"ok"|"warn", text }

  // ── Mutations ─────────────────────────────────────────────────────────────
  // After a write the table is refreshed, but the handler NEVER waits for it: the permanent
  // ledger row is already saved, so the result (modal closing / "Posted ..." message) must
  // not depend on a read that can be slow or hang. A failed refresh only shows the
  // existing amber banner (refresh() never rejects; the catch is belt and braces).
  const refreshAfterWrite = (what)=>{
    Promise.resolve(refresh()).catch(e=>console.warn("[AdminRepInventoryTab] refresh after", what, "failed:", e?.message || e));
  };
  // A write whose LEDGER row was saved but whose warehouse step failed: the row is
  // permanent, so the modal is closed (a second Submit would write a second permanent row
  // for the same quantity) and the message, which says to fix the warehouse count with
  // Receive / adjust, is shown in the dismissable warning banner.
  const closeAfterLedgerSaved = (e, closeModal)=>{
    closeModal(null);
    setErrorMsg("");
    setActionNotice({ kind: "warn", text: e.message });
    refreshAfterWrite("a ledger-saved write");
  };

  async function onAssign({ repKey, repName, sku, productName, qty, reason }) {
    setSubmitting(true); setErrorMsg("");
    try {
      const out = await assignInventoryToRep({
        repId: repKey, repName, sku, productName, qty,
        reason, createdBy: adminUserEmail || ""
      });
      setAssignModal(null);
      // a SKU with no warehouse row is still assigned (ledger row under that exact SKU),
      // and the admin is told the warehouse count was NOT changed
      setActionNotice({
        kind: out && out.warehouseSkipped ? "warn" : "ok",
        text: `Assigned ${qty} x ${sku} to ${repName}.${out && out.warehouseSkipped ? ` ${out.warehouseNote}` : ""}`,
      });
      refreshAfterWrite("assign");
    } catch(e) {
      console.warn("[AdminRepInventoryTab] assign failed for", repKey, sku, ":", e?.message || e);
      // the ledger row may have been saved even though the warehouse step failed
      if(e && e.ledgerSaved) closeAfterLedgerSaved(e, setAssignModal);
      else setErrorMsg(e.message || "Assignment failed.");
    }
    finally { setSubmitting(false); }
  }

  async function onReturn({ repKey, repName, sku, productName, qty, reason }) {
    setSubmitting(true); setErrorMsg("");
    try {
      const out = await returnInventoryFromRep({
        repId: repKey, repName, sku, productName, qty,
        reason: reason || "Return from rep", createdBy: adminUserEmail || ""
      });
      setAdjustRepModal(null);
      setActionNotice({
        kind: out && out.warehouseSkipped ? "warn" : "ok",
        text: `Returned ${qty} x ${sku} from ${repName}.${out && out.warehouseSkipped ? ` ${out.warehouseNote}` : ""}`,
      });
      refreshAfterWrite("return");
    } catch(e) {
      console.warn("[AdminRepInventoryTab] return failed for", repKey, sku, ":", e?.message || e);
      if(e && e.ledgerSaved) closeAfterLedgerSaved(e, setAdjustRepModal);
      else setErrorMsg(e.message || "Return failed.");
    }
    finally { setSubmitting(false); }
  }

  // The all-time on-hand of ONE rep / SKU from FRESH server data, never from this
  // browser's caches: the rep's whole ledger is re-read from Supabase (every page,
  // verified), the orders (portal_orders, every page, verified) are re-read and merged
  // over the cached invoices (the database wins, a database cancel wins), and the result
  // goes through the very inventoryMath call the table uses. Nothing here is written;
  // if either read fails it THROWS and the caller writes nothing.
  // (The other reps' rep_name snapshots, used only to recognise their invoice stamps,
  // come from the tab's last ledger read; they never change a quantity, only which rep a
  // name-only stamp is attributed to.)
  async function readFreshOnHand({ repKey, sku }) {
    const idx = repList.findIndex(r=>r.key===repKey);
    if(idx < 0) throw new Error("This rep is not in the list any more; reload the page and try again.");
    const [ledger, orders] = await Promise.all([getInventoryMovementsChecked({ repId: repKey }), getAllPortalOrdersChecked()]);
    if(!ledger.ok) throw new Error(`The inventory ledger could not be re-read, so nothing was changed: ${ledger.error}`);
    if(!orders.ok) throw new Error(`The orders could not be re-read from the server, so nothing was changed: ${orders.error}`);
    const identities = repList.map((r, i)=>identityOf(r, i === idx ? ledger.rows : movements));
    const cachedInvoices = SHARED_INVOICES.getAll();
    const merged = mergeFreshInvoices(cachedInvoices, orders.rows);
    const resolver = createOwnerResolver(identities);
    const catalog = inventoryCatalog();
    const rows = repInventoryRows({
      movements: ledger.rows,
      invoices: merged,
      rep: identities[idx],
      catalog,
      resolver,
    });
    const key = normSku(sku);
    const row = rows.find(x=>x.key===key);
    // WHY the fresh number can differ from the table: the invoices of this rep and SKU whose
    // counted units differ between this browser's cache and the server rows.
    const cat = indexCatalog(catalog);
    const caseBySku = {};
    Object.keys(cat).forEach(k=>{ if(cat[k].case != null) caseBySku[k] = cat[k].case; });
    const changes = freshInvoiceChanges(cachedInvoices, merged, { sku, caseBySku, owns: inv=>resolver.resolve(inv).index === idx });
    // Invoices that take stock from SOME rep but are attributed to nobody are NOT in the
    // on-hand; those holding this SKU are reported so the admin can resolve the stamp first.
    const unattributed = unattributedInvoices(merged, identities, { resolver, caseBySku }).items
      .filter(u=>u.bySku && u.bySku[key] > 0)
      .map(u=>({ id: u.id, units: u.bySku[key], rep: u.rep }));
    return { onHand: row ? row.onHand : 0, changes, unattributed };
  }

  // Used by the Adjust modal when it opens and again when the admin presses "Review":
  // returns the fresh on-hand (plus why it differs from the table and the unattributed
  // invoices holding this SKU), or { ok:false, error } (nothing is written either way).
  async function onPrepareAdjust({ repKey, sku }) {
    try {
      const fresh = await readFreshOnHand({ repKey, sku });
      return { ok: true, onHand: fresh.onHand, changes: fresh.changes, unattributed: fresh.unattributed };
    } catch(e) {
      console.warn("[AdminRepInventoryTab] adjust baseline read failed for", repKey, sku, ":", e?.message || e);
      return { ok: false, error: e?.message || "The fresh on-hand count could not be read." };
    }
  }

  // The new count is what the admin physically counted. The change written to the
  // (append-only, permanent) ledger is NEW − the ALL-TIME on-hand re-derived NOW from
  // fresh server data (readFreshOnHand). The modal already showed the admin that fresh
  // number in a confirmation step; `expectedOnHand` is the number that was confirmed, and
  // if the fresh count has moved since, NOTHING is written and the new figure is returned
  // so the admin confirms again. An empty or non-integer count is rejected (an empty field
  // is never a "set to 0"). A positive change is an 'adjust_rep' row (positive qty), not an
  // 'assign': readers sum both identically and the history stays accurate.
  // Returns { ok:true, posted:{delta,qty,movementType,from,to,id,differs} } (qty / movementType / id are
  // the values of the ROW the database returned) | { ok:false, changed:true, onHand, changes, unattributed }
  // | { ok:false, error }. The table refresh runs in the background: the result never waits for it.
  async function onAdjustRep({ repKey, repName, sku, productName, newOnHand, expectedOnHand, reason }) {
    setSubmitting(true); setErrorMsg("");
    try {
      const raw = typeof newOnHand === "string" ? newOnHand.trim() : newOnHand;
      const target = (raw === "" || raw == null || typeof raw === "boolean") ? NaN : Number(raw);
      if(!Number.isInteger(target) || target < 0) throw new Error("Type the counted on-hand quantity as a whole number, 0 or more (an empty field is not a count).");
      const fresh = await readFreshOnHand({ repKey, sku });
      if(expectedOnHand != null && fresh.onHand !== Number(expectedOnHand)) return { ok: false, changed: true, onHand: fresh.onHand, changes: fresh.changes, unattributed: fresh.unattributed };
      const delta = target - fresh.onHand;
      if(delta === 0) {
        setActionNotice({ kind: "ok", text: `${repName} already has exactly ${target} of ${sku}: nothing was posted.` });
        refreshAfterWrite("adjust (nothing posted)");
        return { ok: true, posted: { delta: 0, from: fresh.onHand, to: target } };
      }
      const row = await adjustRepInventory({
        repId: repKey, repName, sku, productName, delta,
        reason: `${reason || "Manual adjustment by admin"} (on hand ${fresh.onHand} → ${target})`,
        createdBy: adminUserEmail || "",
        movementType: 'adjust_rep'
      });
      // Report what the DATABASE returned for the permanent row (quantity, type, id), not
      // only the numbers computed here. The permanent row is saved at this point, so the
      // result is returned at once and the table refreshes in the background.
      const savedQty = row && row.qty != null && Number.isFinite(Number(row.qty)) ? Number(row.qty) : delta;
      const savedType = row && row.movement_type ? String(row.movement_type) : "adjust_rep";
      const savedId = row && row.id != null ? row.id : null;
      const differs = savedQty !== delta || savedType !== "adjust_rep";
      const sgn = (n)=>`${n > 0 ? "+" : ""}${n}`;
      setActionNotice({
        kind: differs ? "warn" : "ok",
        text: `Posted ${sgn(savedQty)} (${savedType}${savedId != null ? `, ledger row ${savedId}` : ""}) for ${repName}, ${sku}: on hand ${fresh.onHand} → ${target}.${differs ? ` The database saved a different row than requested (requested ${sgn(delta)} adjust_rep): check the history below.` : ""}`,
      });
      refreshAfterWrite("adjust");
      return { ok: true, posted: { delta, qty: savedQty, movementType: savedType, from: fresh.onHand, to: target, id: savedId, differs } };
    } catch(e) {
      console.warn("[AdminRepInventoryTab] adjust failed for", repKey, sku, ":", e?.message || e);
      setErrorMsg(e.message || "Adjustment failed.");
      return { ok: false, error: e.message || "Adjustment failed." };
    }
    finally { setSubmitting(false); }
  }

  async function onWarehouseAdjust({ sku, productName, newQty, reason }) {
    setSubmitting(true); setErrorMsg("");
    try {
      await adjustWarehouseStock({
        sku, productName, newQty,
        reason: reason || "Warehouse count update", createdBy: adminUserEmail || ""
      });
      setWarehouseModal(null);
      refreshAfterWrite("warehouse update");
    } catch(e) {
      console.warn("[AdminRepInventoryTab] warehouse update failed for", sku, ":", e?.message || e);
      if(e && e.ledgerSaved) closeAfterLedgerSaved(e, setWarehouseModal);
      else setErrorMsg(e.message || "Warehouse update failed.");
    }
    finally { setSubmitting(false); }
  }

  // ── Movement history, with filters ────────────────────────────────────────
  const filteredHistory = useMemo(()=>{
    let rows = [...movements];
    if(historyFilter.repKey !== "all") rows = rows.filter(m=>m.rep_id===historyFilter.repKey);
    if(historyFilter.sku) rows = rows.filter(m=>String(m.sku||"").toLowerCase().includes(historyFilter.sku.trim().toLowerCase()));
    if(historyFilter.type !== "all") rows = rows.filter(m=>m.movement_type===historyFilter.type);
    return rows.slice(0, 300);
  },[movements, historyFilter]);

  const movementLabel = {
    assign: "Assigned to rep",
    return: "Returned to warehouse",
    adjust_rep: "Manual rep adjust",
    warehouse_receive: "Warehouse receipt",
    warehouse_adjust: "Warehouse adjust",
    rep_receive: "Rep self-reported",
  };
  const movementPill = {
    assign: S.pillBlue,
    return: S.pillAmber,
    adjust_rep: S.pillPurple,
    warehouse_receive: S.pillGreen,
    warehouse_adjust: S.pillGray,
    rep_receive: S.pillPurple,
  };

  // cell styles of the unattributed-invoices table (local, so nothing is used before it is defined)
  const unTh = { textAlign:"left", padding:"6px 10px", fontSize:10, fontWeight:600, color:C.inkLight, textTransform:"uppercase", letterSpacing:"0.04em" };
  const unTd = { padding:"6px 10px", fontSize:12, color:C.ink };

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <div>
      {ledgerNotice && (
        <div role="alert" style={{background:"#FEF3C7",border:"1px solid #F59E0B",borderRadius:8,padding:"10px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,fontSize:12,color:"#92400E"}}>
          <div style={{flex:1}}>
            <div style={{fontWeight:600}}>Inventory could not be refreshed, showing the last saved numbers</div>
            <div style={{marginTop:2,opacity:0.85}}>{ledgerNotice}</div>
          </div>
          <button onClick={()=>refresh()} style={{background:"transparent",border:"1px solid #F59E0B",color:"#92400E",fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer"}}>Retry</button>
        </div>
      )}
      {actionNotice && (
        <div role="status" style={{background: actionNotice.kind==="warn" ? "#FEF3C7" : C.tealLight, border:`1px solid ${actionNotice.kind==="warn" ? "#F59E0B" : C.teal}`, borderRadius:8, padding:"10px 14px", marginBottom:12, display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, fontSize:12, color: actionNotice.kind==="warn" ? "#92400E" : C.ink}}>
          <div style={{flex:1}}>{actionNotice.text}</div>
          <button onClick={()=>setActionNotice(null)} style={{background:"transparent",border:"1px solid currentColor",color:"inherit",fontSize:11,padding:"4px 10px",borderRadius:6,cursor:"pointer"}}>Dismiss</button>
        </div>
      )}
      {repList.length===0 && ledgerHasRepRows && (
        <div role="alert" style={{background:"#FEF3C7",border:"1px solid #F59E0B",borderRadius:8,padding:"10px 14px",marginBottom:12,fontSize:12,color:"#92400E"}}>
          <div style={{fontWeight:600}}>No sales reps are listed yet, but the ledger holds rep stock.</div>
          <div style={{marginTop:2,opacity:0.85}}>The rep list has not loaded (or no live rep profile exists). All of that stock is shown below as "Unassigned / unknown rep id" and is counted in "With sales reps", so the totals are not zero. It moves to the right rep once the rep list loads.</div>
        </div>
      )}
      {/* Top summary cards. Cards are clickable — the first three scroll into
          the relevant section, the fourth filters the rep breakdown to only
          mismatched reps (click again to reset). */}
      <div style={{...S.metrics, gridTemplateColumns:"repeat(4,minmax(0,1fr))"}}>
        <div
          style={{...S.metric, cursor:"pointer", transition:"box-shadow 0.15s, transform 0.15s"}}
          onClick={()=>{ const el=document.getElementById("rep-inv-warehouse"); if(el) el.scrollIntoView({behavior:"smooth",block:"start"}); }}
          onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-1px)"; }}
          onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
        >
          <div style={S.mLabel}>Warehouse on hand</div>
          <div style={S.mValue}>{summary.totalWarehouse.toLocaleString()}</div>
          <div style={S.mSub}>{warehouse.length} SKU{warehouse.length===1?"":"s"} tracked</div>
        </div>
        <div
          style={{...S.metric, cursor:"pointer", transition:"box-shadow 0.15s, transform 0.15s"}}
          onClick={()=>{ const el=document.getElementById("rep-inv-breakdown"); if(el) el.scrollIntoView({behavior:"smooth",block:"start"}); }}
          onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-1px)"; }}
          onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
        >
          <div style={S.mLabel}>With sales reps</div>
          <div style={S.mValue}>{summary.unitsOnHand.toLocaleString()}</div>
          <div style={S.mSub}>Sum of the on-hand rows below</div>
          {summary.unitsOversold>0 && (
            <div style={{...S.mSub, color:C.red, fontWeight:600}}>Oversold: {summary.unitsOversold.toLocaleString()} unit{summary.unitsOversold===1?"":"s"} on {summary.oversoldSkus} row{summary.oversoldSkus===1?"":"s"}</div>
          )}
        </div>
        <div
          style={{...S.metric, cursor:"pointer", transition:"box-shadow 0.15s, transform 0.15s"}}
          onClick={()=>{ const el=document.getElementById("rep-inv-breakdown"); if(el) el.scrollIntoView({behavior:"smooth",block:"start"}); }}
          onMouseEnter={e=>{ e.currentTarget.style.transform="translateY(-1px)"; }}
          onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
        >
          <div style={S.mLabel}>Sold ({periodLabel})</div>
          <div style={S.mValue}>{summary.soldInPeriod.toLocaleString()}</div>
          <div style={S.mSub}>Across all reps{period==="all"?"":" · display only, on-hand uses all time"}</div>
        </div>
        <div
          onClick={()=>{ if(summary.mismatchReps>0) setOnlyMismatches(v=>!v); }}
          style={{
            ...S.metric,
            ...(summary.mismatchReps>0?{borderColor:C.red, background:C.redLight}:{}),
            cursor: summary.mismatchReps>0 ? "pointer" : "default",
            boxShadow: onlyMismatches ? `0 0 0 2px ${C.red}` : undefined,
            transition:"box-shadow 0.15s, transform 0.15s"
          }}
          onMouseEnter={e=>{ if(summary.mismatchReps>0 && !onlyMismatches) e.currentTarget.style.transform="translateY(-1px)"; }}
          onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
        >
          <div style={{...S.mLabel, color: summary.mismatchReps>0?C.red:C.inkLight}}>Reconciliation flags</div>
          <div style={{...S.mValue, color: summary.mismatchReps>0?C.red:C.ink}}>{summary.mismatchReps}</div>
          <div style={S.mSub}>{summary.mismatchReps===0?"No rep is oversold":(onlyMismatches?"Filtering list ↓ — click to clear":"Click to filter rep breakdown")}</div>
        </div>
      </div>

      {/* Pending stock requests — inventory_requests rows with status='pending'.
          Reps file these via "+ Request stock from MPC" in their portal; admin
          reviews here. Approve writes ONE rep_receive row to inventory_movements
          (qty = the approved amount, possibly edited inline below). Reject
          leaves inventory untouched. Both decisions stay visible to the rep in
          their portal for audit. */}
      <div id="rep-inv-pending-requests" style={{...S.card, marginTop:16, ...(inventoryRequests.length>0 ? {borderColor:"#F59E0B", boxShadow:"0 0 0 1px #FDE68A"} : {})}}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>
            Pending stock requests
            {inventoryRequests.length > 0 && (
              <span style={{marginLeft:8, fontSize:11, fontWeight:600, color:"#92400E", background:"#FEF3C7", padding:"2px 8px", borderRadius:10}}>
                {inventoryRequests.length} awaiting review
              </span>
            )}
          </div>
          <span style={{fontSize:11, color:C.inkLight}}>
            Approve to add stock to the rep&rsquo;s inventory; reject to leave their on-hand unchanged.
          </span>
        </div>
        {requestsError && (
          <div style={{padding:"10px 14px", margin:"10px 14px", background:C.redLight, color:C.red, borderRadius:8, fontSize:13}}>
            {requestsError}
          </div>
        )}
        {inventoryRequests.length === 0 ? (
          <div style={{padding:"18px 18px", fontSize:13, color:C.inkLight}}>
            No pending stock requests. Reps file these from their inventory tab via
            &ldquo;+ Request stock from MPC&rdquo;.
          </div>
        ) : (
          <div style={{maxHeight:420, overflowY:"auto"}}>
            <table style={{width:"100%", borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:C.surface, borderBottom:`1px solid ${C.border}`}}>
                  <th style={thStyle}>Filed</th>
                  <th style={thStyle}>Rep</th>
                  <th style={thStyle}>SKU / Product</th>
                  <th style={{...thStyle, textAlign:"right"}}>Requested</th>
                  <th style={{...thStyle, textAlign:"right"}}>Approve qty</th>
                  <th style={thStyle}>Reason / decision note</th>
                  <th style={{...thStyle, textAlign:"right"}}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {inventoryRequests.map(req => {
                  const busy = !!reqActionBusy[req.id];
                  const editedQty = reqEditedQty[req.id];
                  const noteVal   = reqDecisionNote[req.id] != null ? reqDecisionNote[req.id] : "";
                  const showQty   = (editedQty != null && editedQty !== "") ? editedQty : req.requested_qty;
                  return (
                    <tr key={req.id} style={{borderBottom:`1px solid ${C.border}`}}>
                      <td style={{...tdStyle, color:C.inkLight, fontSize:11, whiteSpace:"nowrap"}}>
                        {req.created_at ? new Date(req.created_at).toLocaleString() : "—"}
                      </td>
                      <td style={tdStyle}>
                        {req.rep_name || (req.rep_id ? <span style={{fontFamily:"monospace", fontSize:11, color:C.inkLight}}>{req.rep_id}</span> : "—")}
                      </td>
                      <td style={tdStyle}>
                        <span style={{fontFamily:"monospace", fontSize:11}}>{req.sku}</span>
                        {req.product_name && <span style={{color:C.inkLight, marginLeft:6, fontSize:11}}>{req.product_name}</span>}
                      </td>
                      <td style={{...tdStyle, textAlign:"right", fontWeight:600, color:C.ink}}>
                        {req.requested_qty}
                      </td>
                      <td style={{...tdStyle, textAlign:"right"}}>
                        <input
                          type="number"
                          min="1"
                          step="1"
                          value={showQty}
                          disabled={busy}
                          onChange={e => setReqEditedQty(s => ({ ...s, [req.id]: e.target.value }))}
                          style={{...S.input, width:90, padding:"4px 6px", fontSize:13, textAlign:"right"}}
                        />
                      </td>
                      <td style={tdStyle}>
                        {req.reason && (
                          <div style={{fontSize:12, color:C.inkMid, marginBottom:4}}>
                            <span style={{color:C.inkLight, fontSize:10, marginRight:4}}>Rep&rsquo;s note:</span>
                            {req.reason}
                          </div>
                        )}
                        <input
                          type="text"
                          placeholder="Decision note (optional)"
                          value={noteVal}
                          disabled={busy}
                          onChange={e => setReqDecisionNote(s => ({ ...s, [req.id]: e.target.value }))}
                          style={{...S.input, padding:"4px 8px", fontSize:12}}
                        />
                      </td>
                      <td style={{...tdStyle, textAlign:"right", whiteSpace:"nowrap"}}>
                        <button
                          style={{...S.btnSmall, background:C.teal, color:"#fff", marginRight:6, opacity: busy ? 0.6 : 1}}
                          disabled={busy}
                          onClick={() => handleApproveRequest(req)}
                        >
                          {busy ? "…" : "Approve"}
                        </button>
                        <button
                          style={{...S.btnSmall, background:"#fff", color:C.red, border:`1px solid ${C.red}`, opacity: busy ? 0.6 : 1}}
                          disabled={busy}
                          onClick={() => handleRejectRequest(req)}
                        >
                          Reject
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        <div style={{padding:"8px 18px", fontSize:11, color:C.inkLight, borderTop:`1px solid ${C.border}`, background:C.surface}}>
          Approved requests write a rep_receive row to the inventory ledger (qty = approved amount). Rejected requests leave the ledger untouched. Reps see both decisions in their portal.
        </div>
      </div>

      {/* Warehouse stock card */}
      <div id="rep-inv-warehouse" style={S.card}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>Warehouse stock</div>
          <button style={S.btnSmall} onClick={()=>setWarehouseModal({ sku:"", productName:"", qty:0, isNew:true })}>
            + Receive / adjust
          </button>
        </div>
        {warehouse.length===0 && !loading && (
          <div style={{padding:18, fontSize:13, color:C.inkLight}}>
            Warehouse is empty. Add stock with the Receive / adjust button.
          </div>
        )}
        {warehouse.length>0 && (
          <div style={{maxHeight:300, overflowY:"auto"}}>
            <table style={{width:"100%", borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:C.surface, borderBottom:`1px solid ${C.border}`}}>
                  <th style={thStyle}>SKU</th>
                  <th style={thStyle}>Product</th>
                  <th style={{...thStyle, textAlign:"right"}}>On hand</th>
                  <th style={thStyle}>Last update</th>
                  <th style={{...thStyle, textAlign:"right"}}></th>
                </tr>
              </thead>
              <tbody>
                {warehouse.map(w=>(
                  <tr key={w.sku} style={{borderBottom:`1px solid ${C.border}`}}>
                    <td style={tdStyle}><span style={{fontFamily:"monospace"}}>{w.sku}</span></td>
                    <td style={tdStyle}>
                      {w.product_name || "—"}
                      {variationParents[normSku(w.sku)] && (
                        <div style={{fontSize:10, color:C.inkLight, marginTop:2}}>
                          Has variations ({variationParents[normSku(w.sku)].join(", ")}): assigns use the variation SKUs, so this parent count is not changed by them.
                        </div>
                      )}
                    </td>
                    <td style={{...tdStyle, textAlign:"right", fontWeight:600, color: w.qty<10 ? C.red : C.ink}}>{Number(w.qty).toLocaleString()}</td>
                    <td style={{...tdStyle, color:C.inkLight, fontSize:11}}>{w.updated_at ? new Date(w.updated_at).toLocaleString() : "—"}</td>
                    <td style={{...tdStyle, textAlign:"right"}}>
                      <button style={S.btnSmall} onClick={()=>setWarehouseModal({ sku:w.sku, productName:w.product_name||"", qty:w.qty })}>Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {unattributed.count>0 && (
        <div style={{...S.card, borderColor:"#F59E0B"}}>
          <div style={S.cardHdr}>
            <div style={S.cardTitle}>Unattributed invoices</div>
            <span style={{fontSize:11, color:C.inkLight}}>deducted from nobody</span>
          </div>
          <div style={{padding:"10px 18px", fontSize:12, color:"#92400E"}}>
            <b>{unattributed.count} invoice{unattributed.count===1?"":"s"} ({unattributed.units.toLocaleString()} unit{unattributed.units===1?"":"s"})</b> take stock from a rep but cannot be matched to exactly one listed rep:
            {" "}{unattributed.ambiguous} carry a short name (like "Sam T.") that fits several reps, {unattributed.unmatched} fit no listed rep.
            They are NOT deducted from any rep, so the on-hand figures below can be higher than the real stock by these units until each invoice carries the rep's full name or id.
          </div>
          <details style={{padding:"0 18px 12px"}}>
            <summary style={{fontSize:12, cursor:"pointer", color:C.inkMid}}>Show the invoices{unattributed.items.length>50?" (first 50)":""}</summary>
            <table style={{width:"100%", borderCollapse:"collapse", marginTop:6}}>
              <thead>
                <tr style={{background:C.surface}}>
                  <th style={unTh}>Invoice</th>
                  <th style={unTh}>Rep stamp</th>
                  <th style={unTh}>Customer</th>
                  <th style={{...unTh, textAlign:"right"}}>Units</th>
                  <th style={unTh}>Why</th>
                </tr>
              </thead>
              <tbody>
                {unattributed.items.slice(0,50).map(u=>(
                  <tr key={u.id} style={{borderTop:`1px solid ${C.border}`}}>
                    <td style={unTd}><span style={{fontFamily:"monospace"}}>{u.id}</span></td>
                    <td style={unTd}>{displayRepStamp(u.rep) || "—"}</td>
                    <td style={unTd}>{u.customer || "—"}</td>
                    <td style={{...unTd, textAlign:"right"}}>{u.units}</td>
                    <td style={unTd}>
                      {u.deliveredByCause
                        ? `The delivering rep "${u.deliveredBy}" does not name a single listed rep, and the account rep stamp "${displayRepStamp(u.accountRep) || "(none)"}" does not either (${u.reason==="ambiguous" ? `fits several reps: ${u.candidates.join(", ")}` : "no listed rep matches"}).`
                        : (u.reason==="ambiguous" ? `fits several reps: ${u.candidates.join(", ")}` : "no listed rep matches")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </details>
        </div>
      )}

      {/* Per-rep inventory */}
      <div id="rep-inv-breakdown" style={S.card}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>Per-rep inventory{onlyMismatches ? " — reconciliation flags only" : ""}</div>
          <div style={{display:"flex", gap:8, alignItems:"center"}}>
            <span style={{fontSize:11, color:C.inkLight}} title="Only changes the Sold column and the Sold card. On hand always uses all-time sales.">Show sold for:</span>
            <select style={{...S.select, width:120, padding:"5px 8px", fontSize:12}} value={period} onChange={e=>setPeriod(e.target.value)}>
              <option value="week">Last 7 days</option>
              <option value="month">This month</option>
              <option value="year">This year</option>
              <option value="all">All time</option>
            </select>
            <span style={{fontSize:11, color:C.inkLight, marginLeft:8}}>Rep:</span>
            <select style={{...S.select, width:180, padding:"5px 8px", fontSize:12}} value={selectedRepKey} onChange={e=>setSelectedRepKey(e.target.value)}>
              <option value="all">All reps</option>
              {repList.map(r=>(<option key={r.key} value={r.key}>{r.name}{r.inactiveStatus?` (${r.inactiveStatus})`:""}</option>))}
              {repRows.some(r=>r.isUnknown) && <option value={UNKNOWN_REP_KEY}>Unassigned / unknown rep id</option>}
            </select>
            <button style={S.btnSmall} onClick={()=>setAssignModal({ repKey: (selectedRepKey==="all" || selectedRepKey===UNKNOWN_REP_KEY || repList.find(r=>r.key===selectedRepKey)?.inactiveStatus) ? (repList.find(r=>!r.inactiveStatus)?.key||"") : selectedRepKey })}>
              + Assign products
            </button>
          </div>
        </div>
        <div style={{padding:"8px 0"}}>
          {visibleReps.length===0 && (
            <div style={{padding:18, fontSize:13, color:C.inkLight}}>
              {repList.length===0 ? "No sales reps found. Add a rep in the Sales reps tab first." : "Pick a rep from the dropdown."}
            </div>
          )}
          {visibleReps.map(rep=>(
            <div key={rep.key} style={{padding:"8px 18px 14px", borderBottom:`1px solid ${C.border}`}}>
              <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8}}>
                <div>
                  <span style={{fontSize:13, fontWeight:600, color:C.ink}}>{rep.name}</span>
                  {rep.inactiveStatus && <span style={{...S.pillRed, marginLeft:8}}>{rep.inactiveStatus==="deleted"?"Deleted":"Paused"}</span>}
                  {rep.email && <span style={{fontSize:11, color:C.inkLight, marginLeft:8}}>{rep.email}</span>}
                  {rep.isUnknown && <span style={{...S.pillRed, marginLeft:8}}>Not a listed rep</span>}
                  {rep.mismatchCount>0 && <span style={{...S.pillRed, marginLeft:10}}>⚠ {rep.mismatchCount} oversold</span>}
                </div>
                <div style={{fontSize:11, color:C.inkLight}}>
                  Assigned: <b style={{color:C.ink}}>{rep.totals.assigned}</b> · Sold ({periodLabel}): <b style={{color:C.ink}}>{rep.totals.soldInPeriod}</b> · On hand: <b style={{color:C.ink}}>{rep.totals.onHand}</b>
                  {rep.totals.oversold>0 && <> · <b style={{color:C.red}}>Oversold: {rep.totals.oversold}</b></>}
                </div>
              </div>
              {rep.isUnknown && (
                <div style={{fontSize:11, color:C.inkLight, margin:"0 0 6px"}}>
                  These ledger rows belong to a rep id that matches no listed rep: {rep.unknownIds.join(", ")}. They are counted in the totals above.
                </div>
              )}
              {period!=="all" && !rep.isUnknown && rep.rows.length>0 && (
                <div style={{fontSize:11, color:C.inkLight, margin:"0 0 6px", fontStyle:"italic"}}>
                  Sold shows {periodLabel}. On hand always uses all-time sales.
                </div>
              )}
              {rep.rows.length===0 ? (
                <div style={{fontSize:12, color:C.inkLight, fontStyle:"italic", padding:"6px 0"}}>
                  No inventory assigned yet. Click "Assign products" to give this rep stock.
                </div>
              ) : (
                <table style={{width:"100%", borderCollapse:"collapse"}}>
                  <thead>
                    <tr style={{background:C.surface}}>
                      <th style={thStyleSm}>SKU</th>
                      <th style={thStyleSm}>Product</th>
                      <th style={{...thStyleSm, textAlign:"right"}}>Assigned</th>
                      <th style={{...thStyleSm, textAlign:"right"}}>Sold ({periodLabel})</th>
                      <th style={{...thStyleSm, textAlign:"right"}}>On hand</th>
                      <th style={{...thStyleSm, textAlign:"center"}}>Status</th>
                      <th style={{...thStyleSm, textAlign:"right"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rep.rows.map(row=>(
                      <tr key={row.sku} style={{borderTop:`1px solid ${C.border}`}}>
                        <td style={tdStyleSm}><span style={{fontFamily:"monospace"}}>{row.sku}</span></td>
                        <td style={tdStyleSm}>{row.productName || "—"}</td>
                        <td style={{...tdStyleSm, textAlign:"right"}}>{row.assigned}</td>
                        <td style={{...tdStyleSm, textAlign:"right"}}>{row.soldInPeriod}</td>
                        <td style={{...tdStyleSm, textAlign:"right", fontWeight:600, color: row.mismatch ? C.red : C.ink}}>{row.mismatch ? `Oversold by ${row.oversoldBy}` : row.onHand}</td>
                        <td style={{...tdStyleSm, textAlign:"center"}}>
                          {row.mismatch
                            ? <span style={S.pillRed}>⚠ Oversold</span>
                            : (row.onHand === 0 ? <span style={S.pillGray}>Empty</span> : <span style={S.pillGreen}>OK</span>)}
                        </td>
                        <td style={{...tdStyleSm, textAlign:"right"}}>
                          {!rep.isUnknown && (
                            <button style={S.btnSmall} onClick={()=>setAdjustRepModal({
                              repKey: rep.key, repName: rep.name, sku: row.sku,
                              productName: row.productName, currentOnHand: row.onHand
                            })}>Adjust</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Movement history (append-only ledger) */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>Inventory movement history</div>
          <div style={{display:"flex", gap:8, alignItems:"center"}}>
            <select style={{...S.select, width:160, padding:"5px 8px", fontSize:12}} value={historyFilter.repKey} onChange={e=>setHistoryFilter(f=>({...f, repKey:e.target.value}))}>
              <option value="all">All reps + warehouse</option>
              {repList.map(r=>(<option key={r.key} value={r.key}>{r.name}{r.inactiveStatus?` (${r.inactiveStatus})`:""}</option>))}
            </select>
            <select style={{...S.select, width:160, padding:"5px 8px", fontSize:12}} value={historyFilter.type} onChange={e=>setHistoryFilter(f=>({...f, type:e.target.value}))}>
              <option value="all">All types</option>
              <option value="assign">Assigned to rep</option>
              <option value="return">Returned from rep</option>
              <option value="adjust_rep">Rep count adjust</option>
              <option value="rep_receive">Rep self-reported</option>
              <option value="warehouse_receive">Warehouse receipt</option>
              <option value="warehouse_adjust">Warehouse adjust</option>
            </select>
            <input style={{...S.input, width:120, padding:"5px 8px", fontSize:12}} placeholder="SKU filter" value={historyFilter.sku} onChange={e=>setHistoryFilter(f=>({...f, sku:e.target.value}))}/>
          </div>
        </div>
        {filteredHistory.length===0 ? (
          <div style={{padding:18, fontSize:13, color:C.inkLight}}>No movements recorded yet.</div>
        ) : (
          <div style={{maxHeight:420, overflowY:"auto"}}>
            <table style={{width:"100%", borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:C.surface, borderBottom:`1px solid ${C.border}`}}>
                  <th style={thStyle}>When</th>
                  <th style={thStyle}>Type</th>
                  <th style={thStyle}>Rep</th>
                  <th style={thStyle}>SKU / Product</th>
                  <th style={{...thStyle, textAlign:"right"}}>Qty</th>
                  <th style={thStyle}>Reason</th>
                  <th style={thStyle}>By</th>
                </tr>
              </thead>
              <tbody>
                {filteredHistory.map(m=>(
                  <tr key={m.id} style={{borderBottom:`1px solid ${C.border}`}}>
                    <td style={{...tdStyle, color:C.inkLight, fontSize:11, whiteSpace:"nowrap"}}>
                      {m.created_at ? new Date(m.created_at).toLocaleString() : "—"}
                    </td>
                    <td style={tdStyle}><span style={movementPill[m.movement_type]||S.pillGray}>{movementLabel[m.movement_type]||m.movement_type}</span></td>
                    <td style={tdStyle}>{m.rep_name || (m.rep_id ? m.rep_id : <span style={{color:C.inkLight}}>— warehouse —</span>)}</td>
                    <td style={tdStyle}>
                      <span style={{fontFamily:"monospace", fontSize:11}}>{m.sku}</span>
                      {m.product_name && <span style={{color:C.inkLight, marginLeft:6, fontSize:11}}>{m.product_name}</span>}
                    </td>
                    <td style={{...tdStyle, textAlign:"right", fontWeight:600, color: (Number(m.qty)||0)>=0 ? C.teal : C.red}}>
                      {(Number(m.qty)||0) > 0 ? "+" : ""}{m.qty}
                    </td>
                    <td style={{...tdStyle, color:C.inkMid, fontSize:12}}>{m.reason || ""}</td>
                    <td style={{...tdStyle, color:C.inkLight, fontSize:11}}>{m.created_by || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{padding:"8px 18px", fontSize:11, color:C.inkLight, borderTop:`1px solid ${C.border}`, background:C.surface}}>
          History is append-only. Records cannot be edited or deleted — to correct a mistake, post a new compensating movement.
        </div>
      </div>

      {/* ── Assign products modal ───────────────────────────────────────────── */}
      {assignModal && (
        <AssignProductsModal
          repList={repList.filter(r=>!r.inactiveStatus)}
          warehouse={warehouse}
          catalogItems={assignCatalog}
          variationParents={variationParents}
          initialRepKey={assignModal.repKey}
          initialSku={assignModal.sku}
          submitting={submitting}
          error={errorMsg}
          onClose={()=>{ setAssignModal(null); setErrorMsg(""); }}
          onSubmit={onAssign}
        />
      )}

      {/* ── Adjust rep on-hand modal ────────────────────────────────────────── */}
      {adjustRepModal && (
        <AdjustRepModal
          key={`${adjustRepModal.repKey}|${adjustRepModal.sku}`}
          data={adjustRepModal}
          submitting={submitting}
          error={errorMsg}
          onClose={()=>{ setAdjustRepModal(null); setErrorMsg(""); }}
          onAdjust={onAdjustRep}
          onReturn={onReturn}
          onPrepare={onPrepareAdjust}
        />
      )}

      {/* ── Warehouse adjust modal ──────────────────────────────────────────── */}
      {warehouseModal && (
        <WarehouseModal
          data={warehouseModal}
          submitting={submitting}
          error={errorMsg}
          onClose={()=>{ setWarehouseModal(null); setErrorMsg(""); }}
          onSubmit={onWarehouseAdjust}
        />
      )}
    </div>
  );
}

// Small shared table cell styles for the inventory tab
const thStyle = { textAlign:"left", padding:"10px 14px", fontSize:11, fontWeight:600, color:C.inkLight, textTransform:"uppercase", letterSpacing:"0.04em" };
const tdStyle = { padding:"10px 14px", fontSize:13, color:C.ink };
const thStyleSm = { textAlign:"left", padding:"6px 10px", fontSize:10, fontWeight:600, color:C.inkLight, textTransform:"uppercase", letterSpacing:"0.04em" };
const tdStyleSm = { padding:"6px 10px", fontSize:12, color:C.ink };

// ── Assign products modal ──────────────────────────────────────────────────
// The SKU list is the SAME flattened list the rep pickers use (flattenCatalogForPicker):
// a product with variations is replaced by its variation SKUs, so the SKU assigned here
// is the SKU the rep invoices and requests (no parent/variation split row in the ledger).
// Warehouse rows keyed by a SKU that is not in the catalog stay listed; a parent row of
// a variation product is not offered (its variations are). A SKU with NO warehouse row
// can still be assigned: the ledger row is written under that exact SKU and the
// warehouse count is left alone (no warehouse row is created implicitly).
function AssignProductsModal({ repList, warehouse, catalogItems = [], variationParents = {}, initialRepKey, initialSku, submitting, error, onClose, onSubmit }) {
  const options = useMemo(()=>{
    const seen = new Set();
    const out = [];
    (catalogItems||[]).forEach(c=>{
      const k = normSku(c && c.sku);
      if(!k || seen.has(k)) return;
      seen.add(k);
      const w = (warehouse||[]).find(x=>x.sku===c.sku);
      out.push({ sku:c.sku, name:c.name||"", hasRow:!!w, qty:w ? (Number(w.qty)||0) : 0 });
    });
    (warehouse||[]).forEach(w=>{
      const k = normSku(w.sku);
      if(!k || seen.has(k) || variationParents[k]) return;
      seen.add(k);
      out.push({ sku:w.sku, name:w.product_name||"", hasRow:true, qty:Number(w.qty)||0 });
    });
    // Warehouse-backed SKUs (a row with stock) first, then SKUs with no warehouse row, then
    // empty warehouse rows (not selectable); the order inside each group is unchanged.
    const rank = (o)=>(o.hasRow && o.qty>0 ? 0 : !o.hasRow ? 1 : 2);
    return out.map((o, i)=>({ o, i })).sort((a, b)=>(rank(a.o) - rank(b.o)) || (a.i - b.i)).map(x=>x.o);
  },[catalogItems, warehouse, variationParents]);
  // Default selection: the first SKU that HAS warehouse stock when one exists, so a quick
  // Assign decrements the warehouse; only when none has stock does a no-row SKU come first.
  const firstUsable = options.find(o=>o.hasRow && o.qty>0) || options.find(o=>!o.hasRow);
  const [repKey, setRepKey] = useState(initialRepKey || (repList[0]?.key || ""));
  const [sku, setSku] = useState(initialSku || (firstUsable ? firstUsable.sku : ""));
  const [qty, setQty] = useState(1);
  const [reason, setReason] = useState("");
  const rep = repList.find(r=>r.key===repKey);
  const opt = options.find(o=>o.sku===sku);
  const maxQty = opt && opt.hasRow ? opt.qty : null;      // null: no warehouse row, no warehouse limit
  const productName = opt ? opt.name : "";
  const qtyNum = Number(qty);
  const bad = !rep || !sku || !(qtyNum>0) || (maxQty!=null && qtyNum>maxQty) || submitting;

  return (
    <div style={S.modal} onClick={onClose}>
      <div style={S.modalBox} onClick={e=>e.stopPropagation()}>
        <h3 style={{fontSize:16, fontWeight:600, margin:"0 0 16px"}}>Assign products to rep</h3>
        <div style={S.fg}>
          <label style={S.label}>Sales rep</label>
          <select style={S.select} value={repKey} onChange={e=>setRepKey(e.target.value)}>
            {repList.length===0 && <option value="">No reps available</option>}
            {repList.map(r=>(<option key={r.key} value={r.key}>{r.name}{r.inactiveStatus?` (${r.inactiveStatus})`:""}</option>))}
          </select>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Product (SKU)</label>
          <select style={S.select} value={sku} onChange={e=>setSku(e.target.value)}>
            {options.length===0 && <option value="">No products</option>}
            {options.map(o=>(
              <option key={o.sku} value={o.sku} disabled={o.hasRow && o.qty<=0}>
                {o.sku} — {o.name||"—"} ({o.hasRow ? `${o.qty} in warehouse` : "no warehouse row"})
              </option>
            ))}
          </select>
        </div>
        <div style={S.fg}>
          <label style={S.label}>{maxQty!=null ? `Qty to assign (warehouse has ${maxQty})` : "Qty to assign"}</label>
          <input type="number" min="1" max={maxQty!=null ? maxQty : undefined} style={S.input} value={qty} onChange={e=>setQty(e.target.value)}/>
          {opt && !opt.hasRow && (
            <div style={{fontSize:11, color:"#92400E", marginTop:4}}>
              Warehouse has no row for this SKU: the warehouse count will not be changed (no warehouse row is created).
            </div>
          )}
        </div>
        <div style={S.fg}>
          <label style={S.label}>Reason / notes (optional)</label>
          <input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. Restocking Marcus for Q2 route"/>
        </div>
        {error && <div style={{color:C.red, fontSize:12, marginBottom:10}}>{error}</div>}
        <div style={{display:"flex", gap:10, justifyContent:"flex-end"}}>
          <button style={S.btnSecondary} onClick={onClose} disabled={submitting}>Cancel</button>
          <button
            style={{...S.btnPrimary, opacity: bad ? 0.5 : 1}}
            disabled={bad}
            onClick={()=>onSubmit({ repKey:rep.key, repName:rep.name, sku, productName, qty:qtyNum, reason })}
          >
            {submitting ? "Assigning…" : `Assign ${qty} to ${rep?.name||"rep"}`}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Adjust rep on-hand modal (with optional Return-to-warehouse shortcut) ───
// The permanent ledger row is based on FRESH server data, never on this screen:
//   1. on open the modal asks the tab for the fresh on-hand (ledger + orders re-read from
//      Supabase) and shows THAT number;
//   2. "Review adjustment" re-reads it again and shows a confirmation step: on hand now X,
//      you typed Y, this will post +/-Z as an adjust_rep row;
//   3. "Confirm" re-reads once more and posts only if the count is still X (otherwise it
//      shows the new figures and asks again); the result shows what was actually posted.
// Save needs a typed whole number: an empty field is never a count (never a "set to 0").
function AdjustRepModal({ data, submitting, error, onClose, onAdjust, onReturn, onPrepare }) {
  const [mode, setMode] = useState("adjust"); // 'adjust' | 'return'
  const [newOnHand, setNewOnHand] = useState(String(Math.max(0, Number(data.currentOnHand)||0)));
  const [returnQty, setReturnQty] = useState(1);
  const [reason, setReason] = useState("");
  const [base, setBase] = useState({ status:"loading", onHand:null, error:"", changes:[], unattributed:[] });
  const [step, setStep] = useState("edit");        // edit | confirm | done
  const [confirmOnHand, setConfirmOnHand] = useState(null);
  const [checking, setChecking] = useState(false);
  const [localError, setLocalError] = useState("");
  const [posted, setPosted] = useState(null);
  // the fresh baseline: on-hand + WHY it differs from the table (invoices whose counted
  // units differ between this browser's cache and the server) + the unattributed
  // invoices that hold this SKU (not counted in the on-hand)
  const readyBase = (r)=>({ status:"ready", onHand:r.onHand, error:"", changes:Array.isArray(r.changes) ? r.changes : [], unattributed:Array.isArray(r.unattributed) ? r.unattributed : [] });
  const errorBase = (r)=>({ status:"error", onHand:null, error:(r && r.error) || "The fresh on-hand count could not be read.", changes:[], unattributed:[] });

  const loadBase = async ()=>{
    setBase({ status:"loading", onHand:null, error:"", changes:[], unattributed:[] });
    const r = await onPrepare({ repKey:data.repKey, sku:data.sku });
    setBase(r && r.ok ? readyBase(r) : errorBase(r));
  };
  useEffect(()=>{
    let alive = true;
    (async()=>{
      const r = await onPrepare({ repKey:data.repKey, sku:data.sku });
      if(!alive) return;
      setBase(r && r.ok ? readyBase(r) : errorBase(r));
    })();
    return ()=>{ alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[data.repKey, data.sku]);

  const typed = String(newOnHand).trim();
  const validCount = /^\d+$/.test(typed);               // a non-empty whole number, 0 or more
  const target = validCount ? Number(typed) : null;
  const ready = base.status === "ready";
  const delta = validCount && ready ? target - base.onHand : null;
  const confirmDelta = validCount && confirmOnHand!=null ? target - confirmOnHand : null;
  const maxReturn = Math.max(0, ready ? base.onHand : (Number(data.currentOnHand)||0));
  const fmtOnHand = n => (n<0 ? `Oversold by ${-n}` : String(n));
  const fmtDelta = n => `${n>0?"+":""}${n}`;

  const review = async ()=>{
    setLocalError("");
    setChecking(true);
    const r = await onPrepare({ repKey:data.repKey, sku:data.sku });
    setChecking(false);
    if(!r || !r.ok) { setLocalError((r && r.error) || "The fresh on-hand count could not be read, so nothing was changed."); return; }
    setBase(readyBase(r));
    setConfirmOnHand(r.onHand);
    setStep("confirm");
  };
  const confirm = async ()=>{
    setLocalError("");
    const r = await onAdjust({
      repKey:data.repKey, repName:data.repName, sku:data.sku, productName:data.productName,
      newOnHand:typed, expectedOnHand:confirmOnHand, reason
    });
    if(r && r.ok) { setPosted(r.posted); setStep("done"); return; }
    if(r && r.changed) {
      setLocalError(`The on-hand count changed from ${confirmOnHand} to ${r.onHand} while you were confirming, so NOTHING was posted. Check the new figures below and confirm again.`);
      setConfirmOnHand(r.onHand);
      setBase(readyBase(r));
    }
    // any other failure: the tab already set `error` (shown below); nothing was posted
  };

  return (
    <div style={S.modal} onClick={onClose}>
      <div style={S.modalBox} onClick={e=>e.stopPropagation()}>
        <h3 style={{fontSize:16, fontWeight:600, margin:"0 0 4px"}}>Adjust {data.repName}'s inventory</h3>
        <div style={{fontSize:12, color:C.inkLight, marginBottom:14}}>
          <span style={{fontFamily:"monospace"}}>{data.sku}</span> — {data.productName} · On hand now (all time, fresh from the server):{" "}
          {base.status==="loading" && <b>reading…</b>}
          {base.status==="ready" && <b style={{color: base.onHand<0 ? C.red : C.ink}}>{fmtOnHand(base.onHand)}</b>}
          {base.status==="error" && <b style={{color:C.red}}>unknown</b>}
          {base.status==="ready" && base.onHand !== Number(data.currentOnHand) && (
            <div style={{marginTop:4, color:"#92400E"}}>The table showed {fmtOnHand(Number(data.currentOnHand)||0)}; the number above is the fresh one the adjustment uses.</div>
          )}
          {base.status==="ready" && base.onHand !== Number(data.currentOnHand) && base.changes.length > 0 && (
            <div style={{marginTop:4, color:"#92400E"}}>
              Why: the server differs from this browser for {base.changes.length === 1 ? "this invoice" : `these ${base.changes.length} invoices`}:
              <ul style={{margin:"2px 0 0", paddingLeft:18}}>
                {base.changes.slice(0, 10).map(c=>(
                  <li key={c.id}>
                    <span style={{fontFamily:"monospace"}}>{c.id}</span>:{" "}
                    {c.kind==="new"
                      ? `only on the server, ${c.freshUnits} unit${c.freshUnits===1?"":"s"} of ${data.sku} counted`
                      : `${c.cacheStatus || "?"} → ${c.freshStatus || "?"}, ${c.cacheUnits} → ${c.freshUnits} unit${c.freshUnits===1?"":"s"} of ${data.sku} counted`}
                  </li>
                ))}
              </ul>
              {base.changes.length > 10 && <div>…and {base.changes.length - 10} more</div>}
            </div>
          )}
          {base.status==="error" && (
            <div style={{marginTop:4, color:C.red}}>
              {base.error} Nothing can be posted until the fresh count is read.{" "}
              <button style={{...S.btnSmall, marginLeft:4}} onClick={loadBase}>Retry</button>
            </div>
          )}
        </div>
        {step==="done" ? (
          <>
            <div style={{background:C.tealLight, border:`1px solid ${C.teal}`, borderRadius:8, padding:"10px 12px", fontSize:13, color:C.ink, marginBottom:14}}>
              {posted && posted.delta===0
                ? <>Nothing was posted: the rep already has exactly {posted.to}.</>
                : <>Posted <b>{posted && fmtDelta(posted.qty != null ? posted.qty : posted.delta)}</b> as <b>{(posted && posted.movementType) || "adjust_rep"}</b>{posted && posted.id != null ? <> (ledger row {posted.id})</> : null} for {data.repName}, {data.sku}. On hand was <b>{posted && posted.from}</b>, now <b>{posted && posted.to}</b>.</>}
              {posted && posted.differs && <div style={{marginTop:6, color:"#92400E"}}>The database saved a different row than requested (requested {fmtDelta(posted.delta)} adjust_rep): check the history.</div>}
            </div>
            <div style={{display:"flex", gap:10, justifyContent:"flex-end"}}>
              <button style={S.btnPrimary} onClick={onClose}>Close</button>
            </div>
          </>
        ) : (
          <>
            <div style={{display:"flex", gap:8, marginBottom:14}}>
              <button
                style={{...(mode==="adjust"?S.btnPrimary:S.btnSecondary), fontSize:12, padding:"7px 14px"}}
                disabled={step==="confirm"}
                onClick={()=>setMode("adjust")}>Manual adjust</button>
              <button
                style={{...(mode==="return"?S.btnPrimary:S.btnSecondary), fontSize:12, padding:"7px 14px"}}
                disabled={step==="confirm"}
                onClick={()=>setMode("return")}>Return to warehouse</button>
            </div>
            {mode==="adjust" ? (
              step==="confirm" ? (
                <div style={{border:`1px solid ${C.border}`, borderRadius:8, padding:"12px 14px", marginBottom:14, fontSize:13, color:C.ink}}>
                  <div>On hand now: <b>{confirmOnHand!=null ? fmtOnHand(confirmOnHand) : "—"}</b> <span style={{color:C.inkLight}}>(just re-read from the server)</span></div>
                  <div>You typed: <b>{target}</b></div>
                  <div style={{marginTop:6}}>
                    {confirmDelta===0
                      ? <>The rep already has exactly {target}: <b>there is nothing to post</b>.</>
                      : <>This will post <b style={{color: confirmDelta<0 ? C.red : C.teal}}>{confirmDelta!=null ? fmtDelta(confirmDelta) : ""}</b> as an <b>adjust_rep</b> row (permanent: the history cannot be edited or deleted).</>}
                  </div>
                  <div style={{marginTop:6, fontSize:12, color:C.inkLight}}>Reason: {reason}</div>
                  {base.unattributed.length > 0 && (
                    <div role="alert" style={{marginTop:10, background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:6, padding:"8px 10px", fontSize:12, color:"#92400E"}}>
                      <b>Warning:</b> {base.unattributed.length} unattributed invoice{base.unattributed.length===1?"":"s"} ({base.unattributed.reduce((s,u)=>s+u.units,0).toLocaleString()} unit{base.unattributed.reduce((s,u)=>s+u.units,0)===1?"":"s"} of {data.sku}: {base.unattributed.slice(0,5).map(u=>u.id).join(", ")}{base.unattributed.length>5?", …":""}) are NOT counted in this on-hand.
                      Resolve their rep stamp first: if one is attributed to this rep later, it will take its units from the count you are about to fix and this permanent row would double-correct it.
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <div style={S.fg}>
                    <label style={S.label}>New on-hand count (physical count after admin re-count)</label>
                    <input type="number" min="0" step="1" style={S.input} value={newOnHand} onChange={e=>setNewOnHand(e.target.value)}/>
                    <div style={{fontSize:11, color: delta==null||delta===0?C.inkLight:(delta<0?C.red:C.teal), marginTop:4}}>
                      {!validCount ? "Type the counted quantity (a whole number, 0 or more). An empty field is not a count."
                        : !ready ? "Waiting for the fresh on-hand count…"
                        : `Change: ${fmtDelta(delta)} (warehouse unchanged)`}
                    </div>
                  </div>
                  <div style={S.fg}>
                    <label style={S.label}>Reason (required)</label>
                    <input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. Physical recount on 2026-04-15"/>
                  </div>
                </>
              )
            ) : (
              <>
                <div style={S.fg}>
                  <label style={S.label}>Units to return to warehouse (max {maxReturn})</label>
                  <input type="number" min="1" max={maxReturn} style={S.input} value={returnQty} onChange={e=>setReturnQty(e.target.value)}/>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Reason</label>
                  <input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. Route reassignment"/>
                </div>
              </>
            )}
            {localError && <div style={{color:C.red, fontSize:12, marginBottom:10}}>{localError}</div>}
            {error && <div style={{color:C.red, fontSize:12, marginBottom:10}}>{error}</div>}
            <div style={{display:"flex", gap:10, justifyContent:"flex-end"}}>
              <button style={S.btnSecondary} onClick={onClose} disabled={submitting || checking}>Cancel</button>
              {mode==="adjust" ? (
                step==="confirm" ? (
                  <>
                    <button style={S.btnSecondary} onClick={()=>{ setStep("edit"); setLocalError(""); }} disabled={submitting}>Back</button>
                    <button
                      style={{...S.btnPrimary, opacity: (confirmDelta===0 || submitting)?0.5:1}}
                      disabled={confirmDelta===0 || confirmDelta==null || submitting}
                      onClick={confirm}
                    >
                      {submitting ? "Posting…" : `Confirm and post ${confirmDelta!=null ? fmtDelta(confirmDelta) : ""}`}
                    </button>
                  </>
                ) : (
                  <button
                    style={{...S.btnPrimary, opacity: (!validCount || !reason.trim() || !ready || delta===0 || checking || submitting)?0.5:1}}
                    disabled={!validCount || !reason.trim() || !ready || delta===0 || checking || submitting}
                    onClick={review}
                  >
                    {checking ? "Checking…" : "Review adjustment"}
                  </button>
                )
              ) : (
                <button
                  style={{...S.btnPrimary, opacity: (Number(returnQty)<=0 || Number(returnQty)>maxReturn || submitting)?0.5:1}}
                  disabled={Number(returnQty)<=0 || Number(returnQty)>maxReturn || submitting}
                  onClick={()=>onReturn({
                    repKey:data.repKey, repName:data.repName, sku:data.sku,
                    productName:data.productName, qty:Number(returnQty), reason
                  })}
                >
                  {submitting ? "Returning…" : `Return ${returnQty} to warehouse`}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── Warehouse receive / adjust modal ───────────────────────────────────────
function WarehouseModal({ data, submitting, error, onClose, onSubmit }) {
  const [sku, setSku] = useState(data.sku || "");
  const [productName, setProductName] = useState(data.productName || "");
  const [qty, setQty] = useState(String(data.qty || 0));
  const [reason, setReason] = useState("");
  const isEdit = !data.isNew;

  // Auto-complete product name from catalog when SKU matches a known product
  useEffect(()=>{
    if(!sku || productName) return;
    const hit = flattenCatalogForPicker(inventoryCatalog()).find(p=>String(p.sku).toLowerCase()===String(sku).trim().toLowerCase());
    if(hit) setProductName(hit.name);
  },[sku]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={S.modal} onClick={onClose}>
      <div style={S.modalBox} onClick={e=>e.stopPropagation()}>
        <h3 style={{fontSize:16, fontWeight:600, margin:"0 0 16px"}}>
          {isEdit ? "Update warehouse stock" : "Receive or add warehouse stock"}
        </h3>
        <div style={S.fg}>
          <label style={S.label}>SKU</label>
          <input style={{...S.input, fontFamily:"monospace"}} value={sku} onChange={e=>setSku(e.target.value)} disabled={isEdit}/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Product name</label>
          <input style={S.input} value={productName} onChange={e=>setProductName(e.target.value)}/>
        </div>
        <div style={S.fg}>
          <label style={S.label}>New on-hand count</label>
          <input type="number" min="0" style={S.input} value={qty} onChange={e=>setQty(e.target.value)}/>
          <div style={{fontSize:11, color:C.inkLight, marginTop:4}}>
            Change from current ({data.qty||0}): {Math.trunc(Number(qty)||0) - (data.qty||0) > 0 ? "+" : ""}{Math.trunc(Number(qty)||0) - (data.qty||0)}
          </div>
        </div>
        <div style={S.fg}>
          <label style={S.label}>Reason (required)</label>
          <input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. PO-4021 received, Apr 15 2026"/>
        </div>
        {error && <div style={{color:C.red, fontSize:12, marginBottom:10}}>{error}</div>}
        <div style={{display:"flex", gap:10, justifyContent:"flex-end"}}>
          <button style={S.btnSecondary} onClick={onClose} disabled={submitting}>Cancel</button>
          <button
            style={{...S.btnPrimary, opacity: (!sku.trim() || !reason.trim() || submitting)?0.5:1}}
            disabled={!sku.trim() || !reason.trim() || submitting}
            onClick={()=>onSubmit({ sku:sku.trim(), productName:productName.trim(), newQty:Number(qty), reason })}
          >
            {submitting ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── ADMIN BROADCASTS TAB — Email campaigns to customers & reps ──────────────
const BROADCAST_TYPES = [
  {id:"promotion",label:"Promotion",color:C.teal,icon:"🏷️"},
  {id:"new_release",label:"New product release",color:C.blue,icon:"🚀"},
  {id:"newsletter",label:"Newsletter",color:C.purple,icon:"📰"},
  {id:"announcement",label:"Announcement",color:C.amber,icon:"📢"},
  {id:"price_update",label:"Price update",color:C.red,icon:"💲"},
];

function AdminBroadcastsTab({accounts, reps}) {
  const allCustomers = (accounts||[]).filter(a=>a.status==="approved");
  const allReps = (reps||[]);

  // Compose state
  const [composing, setComposing] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [campaignType, setCampaignType] = useState("promotion");
  const [images, setImages] = useState([]);  // [{name, url, file}]
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedReps, setSelectedReps] = useState([]);
  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null); // {total, sent, failed}

  // History
  const [history, setHistory] = useState(()=>{
    try { const h=localStorage.getItem("mpcare_broadcast_history"); return h?JSON.parse(h):[]; } catch(e){ return []; }
  });
  const saveHistory = (h) => { setHistory(h); try{localStorage.setItem("mpcare_broadcast_history",JSON.stringify(h.slice(0,50)));}catch(e){} };

  // Search filters
  const [custSearch, setCustSearch] = useState("");
  const [repSearch, setRepSearch] = useState("");

  const filteredCustomers = allCustomers.filter(c=>
    c.company.toLowerCase().includes(custSearch.toLowerCase()) ||
    c.contact.toLowerCase().includes(custSearch.toLowerCase()) ||
    c.email.toLowerCase().includes(custSearch.toLowerCase())
  );
  const filteredReps = allReps.filter(r=>
    r.name.toLowerCase().includes(repSearch.toLowerCase()) ||
    r.email.toLowerCase().includes(repSearch.toLowerCase()) ||
    (r.territory||"").toLowerCase().includes(repSearch.toLowerCase())
  );

  const toggleCustomer = (id) => setSelectedCustomers(s=>s.includes(id)?s.filter(x=>x!==id):[...s,id]);
  const toggleRep = (id) => setSelectedReps(s=>s.includes(id)?s.filter(x=>x!==id):[...s,id]);
  const selectAllCustomers = () => setSelectedCustomers(filteredCustomers.map(c=>c.id));
  const deselectAllCustomers = () => setSelectedCustomers([]);
  const selectAllReps = () => setSelectedReps(filteredReps.map(r=>r.id));
  const deselectAllReps = () => setSelectedReps([]);

  const totalRecipients = selectedCustomers.length + selectedReps.length;

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files||[]);
    files.forEach(file => {
      const url = URL.createObjectURL(file);
      setImages(prev=>[...prev, {name:file.name, url, size:file.size}]);
    });
    e.target.value = "";
  };
  const removeImage = (idx) => setImages(prev=>prev.filter((_,i)=>i!==idx));

  const sendBroadcast = async () => {
    if(!subject.trim() || !body.trim() || totalRecipients===0) return;
    setSending(true);
    setSendResult(null);

    const recipients = [
      ...selectedCustomers.map(id=>{ const c=allCustomers.find(x=>x.id===id); return c?{name:c.contact||c.company, email:c.email, company:c.company, type:"customer"}:null; }).filter(Boolean),
      ...selectedReps.map(id=>{ const r=allReps.find(x=>x.id===id); return r?{name:r.name, email:r.email, company:"MotorPower Care", type:"rep"}:null; }).filter(Boolean),
    ];

    const typeInfo = BROADCAST_TYPES.find(t=>t.id===campaignType)||BROADCAST_TYPES[0];
    let sent=0, failed=0;

    for(const recipient of recipients) {
      const result = await emailBroadcast({
        subject,
        body,
        campaignType: typeInfo.label,
        recipientName: recipient.name,
        recipientCompany: recipient.company,
        recipientType: recipient.type,
        images: images.map(img=>({name:img.name, url:img.url})),
      }, recipient.email);
      if(result.success) sent++; else failed++;
    }

    const entry = {
      id: Date.now(),
      date: new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}),
      time: new Date().toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"}),
      subject,
      type: campaignType,
      typeLabel: typeInfo.label,
      recipientCount: recipients.length,
      recipients: recipients.map(r=>({name:r.name, email:r.email, type:r.type})),
      sent,
      failed,
      imageCount: images.length,
    };
    saveHistory([entry,...history]);
    setSendResult({total:recipients.length, sent, failed});
    setSending(false);
  };

  const resetCompose = () => {
    setComposing(false); setSubject(""); setBody(""); setCampaignType("promotion");
    setImages([]); setSelectedCustomers([]); setSelectedReps([]); setSendResult(null);
  };

  // ─── Sent confirmation view ───
  if(sendResult) return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:"60vh",textAlign:"center"}}>
      <div style={{width:64,height:64,borderRadius:"50%",background:sendResult.failed===0?C.tealLight:C.amberLight,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:18,fontSize:28}}>
        {sendResult.failed===0?"✓":"⚠"}
      </div>
      <div style={{fontSize:22,fontWeight:700,color:C.ink,marginBottom:6}}>Broadcast sent!</div>
      <div style={{fontSize:14,color:C.inkLight,marginBottom:24}}>
        {sendResult.sent} of {sendResult.total} email{sendResult.total>1?"s":""} delivered successfully
        {sendResult.failed>0&&<span style={{color:C.red}}> · {sendResult.failed} failed</span>}
      </div>
      <div style={{display:"flex",gap:12}}>
        <button style={S.btnSecondary} onClick={resetCompose}>Back to broadcasts</button>
        <button style={S.btnPrimary} onClick={()=>{resetCompose();setComposing(true);}}>Send another</button>
      </div>
    </div>
  );

  // ─── Compose view ───
  if(composing) return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontSize:18,fontWeight:700,color:C.ink}}>Compose broadcast</div>
          <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>{totalRecipients} recipient{totalRecipients!==1?"s":""} selected</div>
        </div>
        <button style={S.btnSecondary} onClick={resetCompose}>← Back</button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 340px",gap:20}}>
        {/* Left — compose form */}
        <div>
          {/* Campaign type */}
          <div style={{...S.card,padding:"16px 20px",marginBottom:16}}>
            <label style={{...S.label,marginBottom:10}}>Campaign type</label>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {BROADCAST_TYPES.map(t=>(
                <button key={t.id} onClick={()=>setCampaignType(t.id)} style={{
                  display:"flex",alignItems:"center",gap:6,padding:"7px 14px",borderRadius:8,fontSize:12,fontWeight:500,cursor:"pointer",
                  border:campaignType===t.id?`2px solid ${t.color}`:`1px solid ${C.border}`,
                  background:campaignType===t.id?`${t.color}12`:C.white,
                  color:campaignType===t.id?t.color:C.inkMid,
                }}>
                  <span>{t.icon}</span>{t.label}
                </button>
              ))}
            </div>
          </div>

          {/* Subject + body */}
          <div style={S.card}>
            <div style={{padding:"18px 20px"}}>
              <div style={S.fg}>
                <label style={S.label}>Subject line *</label>
                <input style={S.input} value={subject} onChange={e=>setSubject(e.target.value)} placeholder="e.g. New DPF product launch — exclusive early pricing"/>
              </div>
              <div style={S.fg}>
                <label style={S.label}>Message body *</label>
                <textarea style={{...S.input,height:200,resize:"vertical",fontFamily:"inherit",lineHeight:1.6}} value={body} onChange={e=>setBody(e.target.value)} placeholder={"Write your message here...\n\nYou can include:\n• Product details and pricing\n• Promotion codes\n• Deadlines and call-to-action\n• Links to your website"}/>
              </div>

              {/* Image attachments */}
              <div style={{marginBottom:14}}>
                <label style={S.label}>Images / attachments</label>
                <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                  {images.map((img,i)=>(
                    <div key={i} style={{display:"flex",alignItems:"center",gap:6,background:C.blueLight,borderRadius:8,padding:"5px 10px",fontSize:11,color:C.blue}}>
                      <span>📎 {img.name}</span>
                      <span style={{fontSize:10,color:C.inkLight}}>({(img.size/1024).toFixed(0)}KB)</span>
                      <button onClick={()=>removeImage(i)} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:14,padding:0}}>×</button>
                    </div>
                  ))}
                </div>
                <label style={{...S.btnSecondary,display:"inline-flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12}}>
                  📷 Add images
                  <input type="file" accept="image/*" multiple onChange={handleImageUpload} style={{display:"none"}}/>
                </label>
              </div>
            </div>
          </div>

          {/* Send button */}
          <div style={{display:"flex",gap:12,marginTop:16,alignItems:"center"}}>
            <button
              style={{...S.btnPrimary,opacity:(!subject.trim()||!body.trim()||totalRecipients===0||sending)?0.5:1,padding:"12px 32px",fontSize:14}}
              disabled={!subject.trim()||!body.trim()||totalRecipients===0||sending}
              onClick={sendBroadcast}
            >
              {sending ? "Sending..." : `Send to ${totalRecipients} recipient${totalRecipients!==1?"s":""}`}
            </button>
            {totalRecipients===0&&<span style={{fontSize:12,color:C.red}}>Select at least one recipient →</span>}
          </div>
        </div>

        {/* Right — recipient picker */}
        <div>
          {/* Customers */}
          <div style={{...S.card,marginBottom:16}}>
            <div style={{...S.cardHdr,background:C.surface}}>
              <span style={S.cardTitle}>Customers / shops ({allCustomers.length})</span>
              <span style={{fontSize:11,color:C.teal,fontWeight:500}}>{selectedCustomers.length} selected</span>
            </div>
            <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.border}`}}>
              <input style={{...S.input,fontSize:11,padding:"6px 10px"}} placeholder="Search customers..." value={custSearch} onChange={e=>setCustSearch(e.target.value)}/>
            </div>
            <div style={{padding:"6px 12px",borderBottom:`1px solid ${C.border}`,display:"flex",gap:8}}>
              <button style={{...S.btnGhost,fontSize:10}} onClick={selectAllCustomers}>Select all</button>
              <button style={{...S.btnGhost,fontSize:10,color:C.inkLight}} onClick={deselectAllCustomers}>Clear</button>
            </div>
            <div style={{maxHeight:200,overflowY:"auto"}}>
              {filteredCustomers.map(c=>(
                <label key={c.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 14px",cursor:"pointer",borderBottom:`1px solid ${C.border}`,background:selectedCustomers.includes(c.id)?"#F0F9FF":"transparent",fontSize:12}}>
                  <input type="checkbox" checked={selectedCustomers.includes(c.id)} onChange={()=>toggleCustomer(c.id)}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:500,color:C.ink,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{c.company}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>{c.contact} · {c.email}</div>
                  </div>
                  <span style={c.tier==="distributor"?S.pillBlue:c.tier==="enterprise"?S.pillPurple:S.pillGray}>{c.tier}</span>
                </label>
              ))}
              {filteredCustomers.length===0&&<div style={{padding:14,fontSize:12,color:C.inkLight,textAlign:"center"}}>No customers found</div>}
            </div>
          </div>

          {/* Sales reps */}
          <div style={S.card}>
            <div style={{...S.cardHdr,background:C.surface}}>
              <span style={S.cardTitle}>Sales reps ({allReps.length})</span>
              <span style={{fontSize:11,color:C.teal,fontWeight:500}}>{selectedReps.length} selected</span>
            </div>
            <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.border}`}}>
              <input style={{...S.input,fontSize:11,padding:"6px 10px"}} placeholder="Search reps..." value={repSearch} onChange={e=>setRepSearch(e.target.value)}/>
            </div>
            <div style={{padding:"6px 12px",borderBottom:`1px solid ${C.border}`,display:"flex",gap:8}}>
              <button style={{...S.btnGhost,fontSize:10}} onClick={selectAllReps}>Select all</button>
              <button style={{...S.btnGhost,fontSize:10,color:C.inkLight}} onClick={deselectAllReps}>Clear</button>
            </div>
            <div style={{maxHeight:200,overflowY:"auto"}}>
              {filteredReps.map(r=>(
                <label key={r.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 14px",cursor:"pointer",borderBottom:`1px solid ${C.border}`,background:selectedReps.includes(r.id)?"#F0F9FF":"transparent",fontSize:12}}>
                  <input type="checkbox" checked={selectedReps.includes(r.id)} onChange={()=>toggleRep(r.id)}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:500,color:C.ink}}>{r.name}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>{r.email}{r.territory?` · ${r.territory}`:""}</div>
                  </div>
                </label>
              ))}
              {filteredReps.length===0&&<div style={{padding:14,fontSize:12,color:C.inkLight,textAlign:"center"}}>No reps found</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // ─── Main view — history + new campaign button ───
  const typeInfo = (id) => BROADCAST_TYPES.find(t=>t.id===id)||BROADCAST_TYPES[0];

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontSize:18,fontWeight:700,color:C.ink}}>Broadcasts</div>
          <div style={{fontSize:12,color:C.inkLight,marginTop:2}}>Send promotions, newsletters, and announcements to customers and sales reps</div>
        </div>
        <button style={{...S.btnPrimary,display:"flex",alignItems:"center",gap:8}} onClick={()=>setComposing(true)}>
          <span style={{fontSize:16}}>✉</span> New broadcast
        </button>
      </div>

      {/* Quick stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
        <div style={S.metric}>
          <div style={S.mLabel}>Total sent</div>
          <div style={S.mValue}>{history.length}</div>
          <div style={S.mSub}>All time</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLabel}>Recipients reached</div>
          <div style={S.mValue}>{history.reduce((s,h)=>s+h.sent,0)}</div>
          <div style={S.mSub}>Emails delivered</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLabel}>This month</div>
          <div style={S.mValue}>{history.filter(h=>{const d=new Date(h.date);const now=new Date();return d.getMonth()===now.getMonth()&&d.getFullYear()===now.getFullYear();}).length}</div>
          <div style={S.mSub}>Campaigns</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLabel}>Available contacts</div>
          <div style={S.mValue}>{allCustomers.length + allReps.length}</div>
          <div style={S.mSub}>{allCustomers.length} customers · {allReps.length} reps</div>
        </div>
      </div>

      {/* Campaign history */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <span style={S.cardTitle}>Campaign history</span>
          {history.length>0&&<button style={{...S.btnGhost,fontSize:11,color:C.red}} onClick={()=>{if(window.confirm("Clear all broadcast history?"))saveHistory([]);}}>Clear history</button>}
        </div>
        {history.length===0 ? (
          <div style={{padding:"40px 20px",textAlign:"center"}}>
            <div style={{fontSize:36,marginBottom:12}}>📨</div>
            <div style={{fontSize:14,fontWeight:500,color:C.ink,marginBottom:6}}>No broadcasts yet</div>
            <div style={{fontSize:12,color:C.inkLight,marginBottom:16}}>Create your first campaign to start reaching your customers and sales reps</div>
            <button style={S.btnPrimary} onClick={()=>setComposing(true)}>Create first broadcast</button>
          </div>
        ) : (
          <div>
            {history.map(h=>{
              const ti = typeInfo(h.type);
              return (
                <div key={h.id} style={{display:"grid",gridTemplateColumns:"130px 1fr 100px 100px 80px",alignItems:"center",padding:"12px 18px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                  <div>
                    <div style={{fontWeight:500,color:C.ink}}>{h.date}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>{h.time}</div>
                  </div>
                  <div style={{minWidth:0}}>
                    <div style={{fontWeight:500,color:C.ink,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{h.subject}</div>
                    <div style={{display:"flex",gap:6,marginTop:3,alignItems:"center"}}>
                      <span style={{fontSize:10,padding:"1px 7px",borderRadius:6,background:`${ti.color}18`,color:ti.color,fontWeight:500}}>{ti.icon} {ti.label}</span>
                      {h.imageCount>0&&<span style={{fontSize:10,color:C.inkLight}}>📎 {h.imageCount} image{h.imageCount>1?"s":""}</span>}
                    </div>
                  </div>
                  <div style={{textAlign:"center"}}>
                    <div style={{fontWeight:600,color:C.ink}}>{h.recipientCount}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>recipients</div>
                  </div>
                  <div style={{textAlign:"center"}}>
                    <div style={{fontWeight:600,color:C.teal}}>{h.sent}</div>
                    <div style={{fontSize:10,color:C.inkLight}}>delivered</div>
                  </div>
                  <div style={{textAlign:"center"}}>
                    {h.failed>0
                      ? <span style={S.pillRed}>{h.failed} failed</span>
                      : <span style={S.pillGreen}>All sent</span>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// Read-only "what does deleting this account affect" figures for the Delete modal.
// Reads SHARED_INVOICES (in memory), rep_commission_payments, rep_commission_rates and
// inventory_movements; WRITES NOTHING. Figures are estimates (the Commission and Rep
// Inventory tabs remain the authoritative views, which is why deleted reps stay listed there).
// exported for the tests (src/inventoryTabRender.test.js)
export async function computeDeleteImpact(ac, accounts) {
  const invoices = SHARED_INVOICES.getAll();
  const total = i => Number(i.total || i.amount || 0);
  const isOpen = i => i.status !== "paid" && i.status !== "done" && i.status !== "cancelled";
  const isRep = ac.role === "rep" || ac.tier === "rep";
  if (ac.status === "pending" || ac.status === "rejected") return { applicant: true };
  if (!isRep) {
    const acctName = ac.company && ac.company !== "—" ? ac.company : ac.email;
    const mine = invoices.filter(i => i.customer === acctName || i.customer === ac.company || i.customer === ac.contact || i.customer === ac.email || (i.userId && i.userId === ac.supabaseId));
    const open = mine.filter(isOpen);
    return { openCount: open.length, openInvoices: open.length, openBalance: open.reduce((s, i) => s + total(i), 0), assignedRep: ac.rep || "" };
  }
  const repName = ac.contact && ac.contact !== "—" ? ac.contact : (ac.name || ac.email || "");
  // ALL assigned dealers, including paused / deleted ones: their invoices still carry this rep's commission.
  const allDealers = (accounts || []).filter(a => a.role !== "rep" && a.tier !== "rep");
  const customerNames = collectRepCustomerNames({ repName, assignedAccounts: allDealers });
  const repInvs = filterRepInvoices(invoices, repName, customerNames);
  let partial = false;
  let pendingCommission = 0;
  try {
    const [rates, paidRows] = await Promise.all([getRepCommissionRates(), listRepCommissionPayments()]);
    const rateRow = (rates || []).find(r => String(r.rep_id) === String(ac.supabaseId || ac.id));
    // Same fallback as the Commission tab: a rep with no rate row earns the default 6%.
    const rate = rateRow && rateRow.rate != null && rateRow.rate !== "" && Number.isFinite(Number(rateRow.rate)) ? Number(rateRow.rate) : 6;
    const paidIds = new Set((paidRows || []).map(r => r && r.invoice_id).filter(Boolean));
    const unpaid = repInvs.filter(i => !paidIds.has(i.id) && i.status !== "cancelled");
    pendingCommission = unpaid.reduce((s, i) => s + total(i), 0) * rate / 100;
  } catch (e) { partial = true; console.warn("[computeDeleteImpact] commission lookup failed:", e?.message || e); }
  // Open commission corrections (signed) are owed to / by the rep too: add them
  // to pendingCommission (read-only; anchored to the complete paged payments).
  try {
    const corrRepId = String(ac.supabaseId || ac.id);
    const [corr, paidPaged] = await Promise.all([listCorrections({ repId: corrRepId }), listCommissionPaymentsPaged({ repId: corrRepId })]);
    if (!corr.ok || !paidPaged.ok) {
      partial = true;
      console.warn("[computeDeleteImpact] corrections lookup failed:", corr.error || paidPaged.error);
    } else {
      pendingCommission += repCorrectionSummary({ corrections: corr.rows, repId: corrRepId, paidRows: paidPaged.rows }).openTotal;
    }
  } catch (e) { partial = true; console.warn("[computeDeleteImpact] corrections lookup threw:", e?.message || e); }
  // Units on hand with the rep: the SAME calculation as the Rep Inventory tab and the
  // rep portal (inventoryMath), summed over the rep's SKU rows, with the SAME rep identity
  // (inventoryMath.buildRepIdentity: shared-profile names, ledger rep_name snapshots, route
  // customers, assigned dealers) and the SAME one-owner rule for name-only invoice stamps
  // (every rep account is a peer). Units with stock and oversold shortfalls are separate
  // figures (never netted together). The WHOLE ledger is read (the other reps' rep_name
  // snapshots are aliases of THEIR identities); if it cannot be read the figure is marked
  // partial instead of showing a wrong 0.
  let onHandUnits = 0;
  let oversoldUnits = 0;
  try {
    const repId = String(ac.supabaseId || ac.id);
    const ledger = await getInventoryMovementsChecked();
    if (!ledger.ok) {
      partial = true;
      console.warn("[computeDeleteImpact] inventory ledger lookup failed:", ledger.error);
    } else {
      // The listed reps are the same set the Rep Inventory tab lists: approved reps, then deleted / paused ones.
      const peers = overlayRepProfiles(
        (accounts || [])
          .filter(a => (a.role === "rep" || a.tier === "rep") && (a.supabaseId || a.isLive) && ["approved", "deleted", "paused"].includes(a.status))
          .map(a => ({
            key: String(a.supabaseId || a.id),
            name: a.status === "approved" ? (a.contact || "—") : (a.contact && a.contact !== "—" ? a.contact : (a.email || "—")),
            email: a.email || "", supabaseId: a.supabaseId || a.id,
          })),
        SHARED_REP_PROFILES.getAll()
      );
      let at = peers.findIndex(p => p.key === repId);
      if (at < 0) { peers.push({ key: repId, name: repName, email: ac.email || "", supabaseId: repId }); at = peers.length - 1; }
      const identities = peers.map(p => buildRepIdentity({
        rep: p, ledgerRows: ledger.rows, sharedRepProfiles: SHARED_REP_PROFILES.getAll(),
        sharedRepCustomers: SHARED_REP_CUSTOMERS.getAll(), assignedAccounts: accounts || [],
      }));
      const rows = repInventoryRows({
        movements: ledger.rows.filter(m => m && String(m.rep_id) === repId),
        invoices: dedupeInvoicesById(invoices),
        rep: identities[at],
        catalog: inventoryCatalog(),
        resolver: createOwnerResolver(identities),
      });
      const t = inventoryTotals(rows);
      onHandUnits = t.unitsOnHand;
      oversoldUnits = t.unitsOversold;
    }
  } catch (e) { partial = true; console.warn("[computeDeleteImpact] inventory lookup failed:", e?.message || e); }
  return {
    partial, pendingCommission, onHandUnits, oversoldUnits,
    assignedDealers: customerNames.length,
    openInvoices: repInvs.filter(isOpen).length,
  };
}

function AdminPanel({onExit, onLogout, user}) {
  const [tab,setTab]=useState("accounts");
  // Cross-tab deep-link target: when the Notifications tab fires "View
  // invoice", it stashes the invoice id here before switching tabs. The
  // AdminOrdersTab reads this via its `focusInvoiceId` prop, opens the
  // matching field-invoice modal on mount, then clears it via onFocusHandled.
  const [focusInvoiceId,setFocusInvoiceId]=useState(null);
  // Deep link: Notifications "Review" on an adjustment request -> Orders tab.
  const [focusAdjustRequestId,setFocusAdjustRequestId]=useState(null);
  // Count of rep change requests (adjustment + void) waiting for admin. Drives
  // the amber sidebar badges (Orders + Notifications) and the top-bar chip.
  const [pendingChangeReqCount,setPendingChangeReqCount]=useState(0);
  useEffect(()=>{
    let cancelled=false;
    const load=async()=>{
      // allSettled: one failing list must not hide the other kind's count.
      const [a,v]=await Promise.allSettled([
        listAdjustmentRequests({status:'pending',limit:200}),
        listInvoiceVoidRequests({status:'pending',limit:200}),
      ]);
      if(a.status==="rejected") console.warn("[AdminPanel] pending adjustment-request count failed:", a.reason?.message||a.reason);
      if(v.status==="rejected") console.warn("[AdminPanel] pending void-request count failed:", v.reason?.message||v.reason);
      if(cancelled) return;
      const na=a.status==="fulfilled"?(a.value||[]).length:0;
      const nv=v.status==="fulfilled"?(v.value||[]).length:0;
      // Keep the previous number only when BOTH lists failed.
      if(a.status==="fulfilled"||v.status==="fulfilled") setPendingChangeReqCount(na+nv);
    };
    load();
    const u1=subscribeAdjustmentRequests(()=>{load();});
    const u2=subscribeInvoiceVoidRequests(()=>{load();});
    const iv=setInterval(load,60000);
    return ()=>{ cancelled=true; clearInterval(iv); u1&&u1(); u2&&u2(); };
  },[]);
  // Persist account edits (discount, tier, status, etc.) to localStorage
  const loadAcctOverrides = () => { try{const r=localStorage.getItem("mpcare_acct_overrides");return r?JSON.parse(r):{};}catch(e){return {};} };
  const saveAcctOverrides = (o) => { try{localStorage.setItem("mpcare_acct_overrides",JSON.stringify(o));}catch(e){} };
  const [accounts,setAccounts]=useState(()=>{
    const overrides = loadAcctOverrides();
    return INIT_ACCOUNTS.map(a => overrides[a.id] ? {...a,...overrides[a.id]} : a);
  });
  const [loadingAccounts,setLoadingAccounts]=useState(true);
  const [editingId,setEditingId]=useState(null);
  const [editData,setEditData]=useState(null);
  const [reviewingAcct,setReviewingAcct]=useState(null);
  const [viewingAccount,setViewingAccount]=useState(null);
  const [adminViewInvoice,setAdminViewInvoice]=useState(null);
  // Admin "Create invoice" window: null (closed) or { accountId } (a dealer's profiles.id to preselect, or null).
  const [createInvoiceFor,setCreateInvoiceFor]=useState(null);
  // A click on a Create invoice button while the window is already open (or folded) does not start a second window: it
  // unfolds the open one and keeps its draft. nudge.n counts the clicks; nudge.accountId is the dealer the click came from.
  const [createInvoiceNudge,setCreateInvoiceNudge]=useState({n:0,accountId:null});
  const openCreateInvoice=(accountId)=>{
    if(createInvoiceFor){ setCreateInvoiceNudge(c=>({n:c.n+1,accountId:accountId||null})); return; }
    setCreateInvoiceFor({accountId:accountId||null});
  };
  // Training videos — migration 0023 (Rule Zero).
  //
  // Initial state: [] so the loading skeleton is honest. Supabase hydrate
  // fires from the useEffect below on mount + realtime subscribe. Legacy
  // localStorage cache is intentionally NOT read as an initial fallback
  // here anymore — per the Q2(a) decision in the design discussion, empty
  // Supabase should render as empty state (not fall back to stale local
  // data that may not match cross-device truth). The Supabase-first read
  // will populate quickly; while it's in flight the admin sees a loading
  // spinner instead of stale rows.
  //
  // Legacy key "mpcare_admin_videos" is left in localStorage untouched —
  // any admin whose only copy of a video lives there can inspect it via
  // devtools and re-upload after this migration ships.
  const [adminVideos,setAdminVideos]=useState([]);
  const [adminVideosLoading,setAdminVideosLoading]=useState(true);
  useEffect(()=>{
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listTrainingVideos({});
        if (!cancelled) {
          setAdminVideos(rows || []);
          setAdminVideosLoading(false);
        }
      } catch (e) {
        console.warn("[App] listTrainingVideos failed on admin mount:", e?.message || e);
        if (!cancelled) setAdminVideosLoading(false);
      }
    };
    load();
    const unsub = subscribeTrainingVideos(() => { if (!cancelled) load(); });
    return () => { cancelled = true; unsub && unsub(); };
  },[]);
  const [adminMaterials,setAdminMaterials]=useState(()=>{
    try{const r=localStorage.getItem("mpcare_admin_materials");if(r)return JSON.parse(r);}catch(e){}return ADMIN_MATERIALS_STUB;
  });
  const [adminTools,setAdminTools]=useState(()=>{
    try{const r=localStorage.getItem("mpcare_admin_tools");if(r)return JSON.parse(r);}catch(e){}return ADMIN_TOOLS_STUB;
  });
  const [adminAgreements,setAdminAgreements]=useState(ADMIN_AGREEMENTS_STUB);
  // ─── Admin catalog state (Supabase-only source of truth) ──────────────────
  //
  // The admin product + kit catalog now lives in Supabase (`portal_products`
  // singleton row id=1). The code never seeds adminProducts/adminKits from
  // hardcoded arrays, and it never has a debounced blanket save. Those two
  // patterns caused admin edits to be wiped on every deploy — an empty
  // localStorage + hardcoded seed would race the Supabase load, then the 800ms
  // auto-save would push the stale seed back, deleting real data.
  //
  // Flow:
  //   1. Initial state is [] and `catalogLoaded === false` (loading skeleton).
  //   2. On mount, `getPortalProducts()` fetches the Supabase row.
  //      • If it has products/kits → they become state + push into SHARED_PRODUCTS.
  //      • If the row is empty/missing → catalog stays empty, the admin sees a
  //        one-time "Seed catalog from code" button to migrate the hardcoded
  //        seed into Supabase.
  //   3. Every admin mutation calls `saveProducts(nextProducts)` / `saveKits(nextKits)`
  //      (defined below). These functions immediately update React state,
  //      push to SHARED_PRODUCTS, and POST to Supabase. There is NO timer,
  //      NO debounce, and NO auto-save from hydration. Only explicit admin
  //      actions reach Supabase.
  //
  const [adminProducts, setAdminProducts] = useState([]);
  const [adminKits, setAdminKits]         = useState([]);
  const [catalogLoaded, setCatalogLoaded] = useState(false);
  const [catalogLoadError, setCatalogLoadError] = useState(null);
  // Set when a product-form stock edit could not be written to the warehouse /
  // inventory ledger (the product itself was saved; the warehouse count was not).
  const [stockSyncError, setStockSyncError] = useState("");
  const [catalogSaveError, setCatalogSaveError] = useState(null);

  // Refs hold the latest values so saveProducts/saveKits can update one side
  // and still ship the current other side in the same Supabase write without
  // closing over stale state.
  const adminProductsRef = useRef(adminProducts);
  const adminKitsRef     = useRef(adminKits);
  useEffect(()=>{ adminProductsRef.current = adminProducts; }, [adminProducts]);
  useEffect(()=>{ adminKitsRef.current     = adminKits;     }, [adminKits]);

  // Persist a partial patch (products only, kits only, or both) to Supabase.
  // Called ONLY from the explicit mutators below — never from hydration,
  // never from a timer. Surgical by design: see the rule in CLAUDE.md
  // "Live data protection". The previous version of this function took
  // (nextProducts, nextKits) and ALWAYS wrote both columns, which meant a
  // product-only edit silently shipped whatever was in adminKitsRef back to
  // Supabase. If that ref was stale relative to a kit edit made in another
  // tab / device / realtime update, the other tab's kit edit got reverted.
  // That is exactly how today's `KIT-DPF -> 1005D` rename was wiped.
  const saveCatalog = useCallback(async (patch) => {
    try {
      setCatalogSaveError(null);
      await savePortalProducts(patch);
    } catch (e) {
      console.warn("Portal products save failed:", e?.message);
      setCatalogSaveError(e?.message || "Save failed");
    }
  }, []);

  // Update products: accepts either an array or an updater fn (matches React's
  // setState signature so the existing AdminProductsTab code that calls
  // `setProducts(ps => ps.map(...))` keeps working unchanged). Writes ONLY
  // the products column to Supabase. The kits column is never touched here.
  const saveProducts = useCallback((next) => {
    const resolved = typeof next === "function" ? next(adminProductsRef.current) : next;
    const arr = Array.isArray(resolved) ? resolved : [];
    setAdminProducts(arr);
    SHARED_PRODUCTS.setProducts(arr);
    saveCatalog({ products: arr });
  }, [saveCatalog]);

  // Update kits. Writes ONLY the kits column to Supabase. The products column
  // is never touched here.
  const saveKits = useCallback((next) => {
    const resolved = typeof next === "function" ? next(adminKitsRef.current) : next;
    const arr = Array.isArray(resolved) ? resolved : [];
    setAdminKits(arr);
    SHARED_PRODUCTS.setKits(arr);
    saveCatalog({ kits: arr });
  }, [saveCatalog]);

  // One-shot Supabase hydration on admin mount. This is the ONLY place that
  // reads product data for the admin panel — never localStorage, never the
  // hardcoded seed. The seed exists only so an empty Supabase can be
  // bootstrapped explicitly via the "Seed catalog from code" admin button.
  // Also fetches warehouse stock to enrich products so stock badges reflect reality.
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [remote, warehouseRows] = await Promise.all([
          getPortalProducts(),
          getWarehouseStock().catch(e => { console.warn("[AdminMount] Warehouse stock fetch failed:", e?.message||e); return []; })
        ]);
        if (!mounted) return;
        const products = Array.isArray(remote?.products) ? remote.products : [];
        const kits     = Array.isArray(remote?.kits)     ? remote.kits     : [];
        // Enrich products with warehouse stock so customer-facing stock badges
        // reflect actual warehouse qty rather than a stale product-listing number.
        const wMap = {};
        (warehouseRows||[]).forEach(w => { wMap[w.sku] = Number(w.qty)||0; });
        const enriched = products.map(p => wMap[p.sku] !== undefined ? {...p, stock: wMap[p.sku]} : p);
        setAdminProducts(enriched);
        setAdminKits(kits);
        // Push into the pub/sub store so the customer/rep portals see the
        // same authoritative catalog as soon as the admin mounts.
        SHARED_PRODUCTS.setProducts(enriched);
        SHARED_PRODUCTS.setKits(kits);
        setCatalogLoaded(true);
      } catch (e) {
        if (!mounted) return;
        console.warn("Portal products load failed:", e?.message);
        setCatalogLoadError(e?.message || "Load failed");
        // Still mark loaded so the UI can show the empty state / retry button
        // instead of hanging on the skeleton forever.
        setCatalogLoaded(true);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Migration helper surfaced in the admin UI when Supabase comes up empty.
  // This is the ONLY runtime path that touches the hardcoded seed, and the
  // admin has to click a button to trigger it. After it runs, all subsequent
  // edits flow through saveProducts/saveKits → Supabase.
  const seedCatalogFromCode = useCallback(async () => {
    const seedProducts = ALL_PRODUCTS.map(p => ({
      ...p,
      category: Object.entries(PRODUCTS).find(([, arr]) => arr.some(x => x.sku === p.sku))?.[0] || "fuel",
      active: true,
    }));
    const seedKits = KITS.map(k => ({ ...k, active: true }));
    setAdminProducts(seedProducts);
    setAdminKits(seedKits);
    SHARED_PRODUCTS.setProducts(seedProducts);
    SHARED_PRODUCTS.setKits(seedKits);
    // Intentional full rewrite — this is the one-time migration path and is
    // only reachable when the admin clicks the "Seed catalog from code" button
    // on an empty catalog. Both columns go out together on purpose.
    await saveCatalog({ products: seedProducts, kits: seedKits });
  }, [saveCatalog]);
  // ── Inventory sync callbacks ──────────────────────────────────────────────
  // When warehouse stock changes (assign to rep, receive, adjust), re-enrich
  // the admin product list so the stock column and customer-facing badges
  // update.
  //
  // CRITICAL: this callback fires automatically from background events
  // (Rep Inventory tab mount, realtime inventory subscription, another rep
  // posting a movement on any device). It writes the FULL products array
  // back to Supabase — every price, name, image URL rides along with the
  // stock-only delta. So the source of "current products" MUST be fresh.
  //
  // Two stale-ref clobbers have already happened in this codebase:
  //   1. Kits column: the original implementation passed `adminKitsRef.current`
  //      into `saveCatalog`. A stale tab's ref overwrote kit edits made in
  //      another tab. Fixed by removing kits from the payload.
  //   2. Products column (the bug this fix addresses): the next implementation
  //      kept using `adminProductsRef.current` for the products payload. A
  //      multi-tab admin session could have one tab carrying yesterday-morning
  //      products while another tab made price/picture edits. When ANY rep
  //      posted an inventory movement, the stale tab's realtime subscription
  //      auto-fired this callback and wrote its old products array back to
  //      Supabase — silently reverting the price/picture edits.
  //
  // Fix per CLAUDE.md §READ-THIS-FIRST #3 ("No writes that include stale
  // in-memory state"): re-fetch the products column directly from Supabase
  // immediately before deriving the enriched array. We bypass
  // `getPortalProducts` deliberately because that helper falls back to the
  // localStorage cache on Supabase failure — we'd rather skip the write
  // entirely than risk writing back from cache. Any error path returns
  // without writing; stock display catches up on next inventory event.
  const onWarehouseChanged = useCallback(async (warehouseRows) => {
    let freshProducts;
    try {
      const { data, error } = await supabase
        .from('portal_products')
        .select('products')
        .eq('id', 1)
        .maybeSingle();
      if (error) {
        console.warn("[onWarehouseChanged] Supabase re-fetch failed — skipping stock sync to avoid stale-ref clobber:", error.message);
        return;
      }
      if (!data || data.products == null) {
        console.warn("[onWarehouseChanged] No products row in Supabase — skipping stock sync");
        return;
      }
      freshProducts = typeof data.products === 'string' ? JSON.parse(data.products) : data.products;
      if (!Array.isArray(freshProducts)) {
        console.warn("[onWarehouseChanged] portal_products.products has unexpected shape — skipping stock sync");
        return;
      }
    } catch (e) {
      console.warn("[onWarehouseChanged] Supabase re-fetch threw — skipping stock sync to avoid stale-ref clobber:", e?.message || e);
      return;
    }

    const wMap = {};
    (warehouseRows||[]).forEach(w => { wMap[w.sku] = Number(w.qty)||0; });
    const enriched = freshProducts.map(p => wMap[p.sku] !== undefined ? {...p, stock: wMap[p.sku]} : p);
    // Only update if stock actually changed to avoid unnecessary re-renders / saves
    const changed = enriched.some((p,i) => p.stock !== freshProducts[i]?.stock);
    if(changed) {
      setAdminProducts(enriched);
      SHARED_PRODUCTS.setProducts(enriched);
      saveCatalog({ products: enriched }); // products-only write; payload built from fresh Supabase fetch
    }
  }, [saveCatalog]);

  // A live warehouse read on the Rep Inventory tab clears the Products-tab warning (the
  // admin corrects the count there with Receive / adjust); the warning also has a Dismiss button.
  const onLiveWarehouseRead = useCallback(() => { setStockSyncError(""); }, []);

  // When admin changes stock in the product form, sync that value to warehouse.
  const onProductStockChanged = useCallback(async (sku, newQty, productName) => {
    try {
      await adjustWarehouseStock({
        sku,
        productName,
        newQty: Number(newQty)||0,
        reason: "Stock updated from product listing",
        createdBy: user?.email || "admin"
      });
      setStockSyncError("");
    } catch(e) {
      console.warn("[onProductStockChanged] Failed to sync warehouse:", e?.message||e);
      setStockSyncError(`The warehouse count for ${sku} was NOT updated: ${e?.message||e}`);
    }
  }, [user?.email]);

  // Persist admin materials/tools to localStorage. adminVideos removed
  // from this mirror as of migration 0023 — Supabase is now the source of
  // truth for training videos and the listTrainingVideos helper manages
  // its own offline cache under a separate key. Leaving the legacy
  // "mpcare_admin_videos" key untouched preserves any pre-migration
  // uploads an admin may want to recover via DevTools before re-uploading.
  useEffect(()=>{try{localStorage.setItem("mpcare_admin_materials",JSON.stringify(adminMaterials));}catch(e){}},[adminMaterials]);
  useEffect(()=>{try{localStorage.setItem("mpcare_admin_tools",JSON.stringify(adminTools));}catch(e){}},[adminTools]);

  // Fetch real accounts from Supabase on mount
  useEffect(()=>{
    let mounted=true;
    // A remittance list fetch that started before a local mark / reverse (or before a newer fetch)
    // is DISCARDED, so a just-reversed invoice is never re-marked paid in the cache.
    const remitFetchGate=createFetchGate();
    const syncRemit=async(why)=>{
      const ticket=remitFetchGate.begin();
      try{
        const r=await listRemittances();
        if(!mounted) return;
        if(!remitFetchGate.isCurrent(ticket)) return;
        if(r.ok) SHARED_INVOICES.applyRemittance(r.rows||[]);
        else console.warn("[AdminPanel] listRemittances ("+why+") failed; the cache was not reconciled with rep remittances:",r.error);
      }catch(e){console.warn("[AdminPanel] remittance sync ("+why+") failed:",e?.message||e);}
    };
    (async()=>{
      try{
        const [profiles, assignmentsMap] = await Promise.all([
          getAllProfiles(),
          getAllCustomerAssignments().catch(()=>({})),
        ]);
        if(!mounted)return;
        const liveAccounts=profiles.map(p=>{
          const meta=p.raw_user_meta_data||p.user_metadata||{};
          // Read from direct profile columns first (saved by saveProfileMetadata), then fall back to auth metadata
          const role=p.role||meta.role||"customer";
          // profiles.status 'deleted'/'paused' WINS (Supabase is the source of truth
          // for the admin Delete/Pause lifecycle, on every device); otherwise the
          // approved/rejected booleans decide exactly as before.
          const status=deriveAccountStatus(p);
          const created=p.created_at?new Date(p.created_at).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):"";
          // Customer-settings fallback ensures ref code survives even when profiles table lacks ref_code column.
          const assign = assignmentsMap[p.id] || {};
          return {
            id:p.id,
            company:p.company||meta.company||"—",
            contact:p.full_name||meta.full_name||"—",
            email:p.email||meta.email||"—",
            ein:p.ein||meta.ein||"—",
            address:p.address||meta.address||"—",
            tier:role==="rep"?"rep":(p.tier||meta.tier||"dealer"),
            role,
            refCode:p.ref_code||meta.ref_code||assign.refCode||"",
            phone:p.phone||meta.phone||"",
            status,
            dbStatus:status,   // database-derived baseline, captured BEFORE any per-browser override merge (Edit Account stale-write guard)
            rep:p.rep||assign.rep||"",
            creditLimit:p.credit_limit||assign.creditLimit||0,
            creditUsed:p.credit_used||0,
            terms:_toTermsArray(p.terms)||_toTermsArray(assign.terms)||["cc"],
            discount:p.discount||assign.discount||0,
            joined:created,
            supabaseId:p.id,
            isLive:true,
            ...lifecycleFieldsFromProfile(p)
          };
        });
        // Separate approved reps into the reps tab + sync to SHARED_REP_PROFILES
        // Exclude soft-deleted reps so they don't keep reappearing in dropdowns on reload.
        let deletedRepKeys = new Set();
        try { const raw=localStorage.getItem("mpcare_deleted_reps"); if(raw) JSON.parse(raw).forEach(k=>deletedRepKeys.add(k)); } catch(e){}
        // Supabase wins: a profile that is approved in the database is NOT deleted, even if this
        // browser's per-device list still remembers an earlier delete (e.g. restored on another device).
        liveAccounts.forEach(a=>{ if(a.status==="approved"){ deletedRepKeys.delete(a.id); if(a.email) deletedRepKeys.delete(a.email); } });
        const isRepDeleted = (a) => deletedRepKeys.has(a.id) || (a.email && deletedRepKeys.has(a.email));
        const approvedReps=liveAccounts.filter(a=>(a.role==="rep"||a.tier==="rep")&&a.status==="approved"&&!isRepDeleted(a));
        if(approvedReps.length>0){
          setLiveReps(approvedReps.map(a=>({
            id:a.id, name:a.contact||"—", email:a.email, phone:a.phone||"",
            rate:6, paySchedule:"15th of month", startDate:a.joined||"",
            territory:a.address||"", notes:"", ytdSales:0, accounts:0,
            refCode:a.refCode||"", customers:[], prospects:[], visits:[], isLive:true
          })));
          // Push all live reps to SHARED_REP_PROFILES so customer portal dropdown can find them
          approvedReps.forEach(a=>{
            const repData={name:a.contact||"—", email:a.email, phone:a.phone||"", territory:a.address||"", refCode:a.refCode||""};
            SHARED_REP_PROFILES.set(a.id, repData);
            if(a.email) SHARED_REP_PROFILES.set(a.email, repData);
          });
        }
        // Legacy scrub of the per-browser deleted-reps list, now limited to keys that do NOT belong to a
        // Supabase profile. SHARED_REP_PROFILES is off-limits (avatars / phone / territory that Restore
        // cannot recover), so entries of real (live) reps - active, deleted or paused - are never
        // removed here. Pickers hide deleted/paused live reps via the Supabase-derived inactive set.
        if(deletedRepKeys.size > 0 && SHARED_REP_PROFILES.delete) {
          const liveKeys=new Set();
          liveAccounts.forEach(a=>{ liveKeys.add(a.id); if(a.email) liveKeys.add(a.email); });
          const staleKeys=Array.from(deletedRepKeys).filter(k=>!liveKeys.has(k));
          if(staleKeys.length>0) SHARED_REP_PROFILES.delete(...staleKeys);
        }
        // Merge: live accounts first, then demo accounts that don't overlap by email
        // Apply any localStorage overrides to live accounts too
        const overrides = loadAcctOverrides();
        // Apply overrides — for status: trust Supabase if already approved/rejected;
        // only use localStorage status if Supabase still says "pending" (approve call may have failed)
        // Supabase WINS for status + lifecycle fields (see mergeLiveOverride): a stale
        // override can never resurrect or hide a deleted/paused account.
        const liveWithOverrides = liveAccounts.map(a => mergeLiveOverride(a, overrides[a.id]));
        const liveEmails=new Set(liveAccounts.map(a=>a.email?.toLowerCase()));
        const demoOnly=INIT_ACCOUNTS.filter(a=>!liveEmails.has(a.email?.toLowerCase()));
        const demoWithOverrides = demoOnly.map(a => overrides[a.id] ? {...a,...overrides[a.id]} : a);
        setAccounts([...liveWithOverrides,...demoWithOverrides]);
      }catch(e){
        console.warn("Could not fetch live accounts, using demo data:",e.message);
      }finally{if(mounted)setLoadingAccounts(false);}
      // Fetch orders from Supabase and merge into SHARED_INVOICES so admin sees orders from all browsers/devices
      try{
        const fetchStartedAt=Date.now();   // a revert is skipped for adjustments newer than this
        const dbOrders=await getAllPortalOrders();
        if(dbOrders.length>0){
          // Build user_id → profile name map for resolving customer names
          let profileMap={};
          try{const profs=await getAllProfiles();profs.forEach(p=>{profileMap[p.id]=p.company||p.full_name||p.email||"Customer";});}catch(e){}
          const existing=SHARED_INVOICES.getAll();
          const existingIds=new Set(existing.map(i=>i.id).concat(existing.map(i=>i.orderId)).filter(Boolean));
          dbOrders.forEach(o=>{
            const oId=o.invoice_ref||o.invoice_id||o.order_ref||o.order_id||o.id;
            const oOrderId=o.order_ref||o.order_id||o.id;
            if(existingIds.has(oId)||existingIds.has(oOrderId)||existingIds.has(String(o.id))) return;
            let items=[];
            try{items=typeof o.items==="string"?JSON.parse(o.items):(o.items||[]);}catch(e){}
            const custName=o.customer||(o.user_id&&profileMap[o.user_id])||"Customer";
            SHARED_INVOICES.add({
              id:oId, orderId:oOrderId,
              date:o.created_at?new Date(o.created_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}):"",
              customer:custName, items,
              total:o.total||0, status:o.status||"outstanding",
              paymentTerms:o.payment_terms||"", rep:o.rep||"",
              source:o.source||"portal_order", fromDb:true,
              // Delivery fields feed the rep-stock calculation (a dealer order delivered
              // by a rep takes stock out of that rep).
              deliveryMethod:o.delivery_method||"", deliveredByRep:o.delivered_by_rep||"",
              // Account discount (0034): {} for a row without one, so older invoices are exactly as before.
              ...invoiceDiscountFields(o)
            });
            existingIds.add(oId);
          });
          // Forward-only delivery-method sync for invoices already in the cache.
          try{SHARED_INVOICES.applyDelivery(dbOrders);}catch(e){console.warn("[AdminMount] applyDelivery failed:",e?.message||e);}
          // Forward-only cancel propagation for invoices already in the cache.
          SHARED_INVOICES.applyServerState(dbOrders, { allowRevert: true, fetchStartedAt }); // getAllPortalOrders batch: newest per invoice
        }
      }catch(e){console.warn("Could not fetch orders from DB:",e.message);}
      // Rep remittances (0033): forward-only, idempotent paid mirror onto the cache (the DB wins).
      await syncRemit("mount");
    })();
    // Realtime: a remittance marked / reversed on another device. Re-fetch (the event row is never applied);
    // bursts are collapsed into one fetch. A local mark / reverse reloads at once.
    const remitDeb=createDebounced(()=>{ syncRemit("realtime"); });
    const unsubRemit=subscribeRemittances(()=>{ remitDeb.trigger(); });
    const unsubRemitLocal=subscribeLocalRemittanceChange(()=>{ remitDeb.cancel(); syncRemit("local change"); });
    return ()=>{mounted=false; remitDeb.cancel(); if(unsubRemit) unsubRemit(); unsubRemitLocal();};
  },[]);

  // Subscribe to shared customer profiles — when customer edits their profile, update admin view
  // IMPORTANT: admin-set fields (from localStorage overrides) are NEVER overwritten by customer edits
  useEffect(()=>{
    const unsub = SHARED_CUSTOMER_PROFILES.subscribe((profiles)=>{
      const allProfiles = Object.values(profiles);
      const overrides = loadAcctOverrides(); // Admin's explicit edits
      setAccounts(acs=>acs.map(ac=>{
        const shared = profiles[ac.id] || profiles[ac.supabaseId] || profiles[ac.email]
          || allProfiles.find(p => p.email && p.email.toLowerCase() === ac.email?.toLowerCase());
        if(!shared) return ac;
        const adminOverride = overrides[ac.id] || {};
        // Only apply customer changes for fields admin hasn't explicitly set
        const mergedCompany = adminOverride.company || shared.company || ac.company;
        const mergedContact = adminOverride.contact || shared.contact || ac.contact;
        const mergedEmail = adminOverride.email || shared.email || ac.email;
        const mergedPhone = adminOverride.phone || shared.phone || ac.phone;
        const mergedAddress = adminOverride.address || shared.address || ac.address;
        const mergedEin = adminOverride.ein || shared.ein || ac.ein;
        // Rep: admin controls this field — the customer's profile save CANNOT clear an admin-assigned rep.
        // Bug: customer would save their profile with rep="" and wipe admin's assignment on any admin browser
        // that didn't have the localStorage override. Only accept shared.rep if it's explicitly non-empty
        // (i.e. the customer picked a rep in their profile dropdown); otherwise keep the existing assignment.
        const mergedRep = adminOverride.rep!==undefined ? adminOverride.rep : (shared.rep ? shared.rep : ac.rep);
        const changed = mergedCompany!==ac.company || mergedContact!==ac.contact || mergedPhone!==ac.phone || mergedAddress!==ac.address || mergedEmail!==ac.email || mergedRep!==(ac.rep||"");
        if(!changed) return ac;
        return {...ac, company:mergedCompany, contact:mergedContact, email:mergedEmail, phone:mergedPhone, address:mergedAddress, ein:mergedEin, rep:mergedRep };
      }));
    });
    return unsub;
  },[]);

  const [liveReps,setLiveReps]=useState([]);
  // Deleted / paused reps, derived ONLY from the Supabase-hydrated accounts. They are hidden from
  // operational pickers and the Sales Reps list, but stay reachable in Commission + Rep Inventory
  // (money and stock live there) and in the Deleted & paused archive.
  // Real per-rep commission % from Supabase rep_commission_rates (READ ONLY; falls back to the
  // 6% new-rep default used elsewhere in this file when the lookup fails or has no row).
  const [repRateById,setRepRateById]=useState({});
  useEffect(()=>{
    let cancelled=false;
    (async()=>{
      try{
        const rows=await getRepCommissionRates();
        if(cancelled) return;
        const m={}; (rows||[]).forEach(r=>{ if(r&&r.rep_id!=null) m[String(r.rep_id)]=r.rate; });
        setRepRateById(m);
      }catch(e){ console.warn("[AdminPanel] getRepCommissionRates failed (inactive reps fall back to default rate):",e?.message||e); }
    })();
    return ()=>{ cancelled=true; };
  },[]);
  const inactiveReps=useMemo(()=>inactiveRepAccounts(accounts).map(a=>({
    id:a.id, name:a.contact&&a.contact!=="—"?a.contact:(a.email||"—"), email:a.email, phone:a.phone||"",
    rate:(repRateById[String(a.supabaseId||a.id)]!=null?Number(repRateById[String(a.supabaseId||a.id)])||0:6), paySchedule:"15th of month", startDate:a.joined||"", territory:a.address||"", notes:"",
    ytdSales:0, accounts:0, refCode:a.refCode||"", customers:[], prospects:[], visits:[], isLive:true,
    inactiveStatus:a.status
  })),[accounts,repRateById]);
  const inactiveRepEmails=useMemo(()=>pickerBlockedRepEmailSet(accounts),[accounts]);
  // lower-cased name -> "deleted" | "paused"; names that also belong to an ACTIVE rep are excluded.
  const inactiveRepStatuses=useMemo(()=>inactiveRepStatusMap(accounts),[accounts]);
  const visibleDemoReps=ADMIN_REP_DATA.filter(r=>!inactiveRepEmails.has((r.email||"").toLowerCase()));
  // Build merged rep list for admin dropdown (ADMIN_REP_DATA + live Supabase reps, deduplicated)
  const repList=(()=>{
    const demoEmails=new Set(ADMIN_REP_DATA.map(r=>r.email?.toLowerCase()));
    // Exclude soft-deleted reps (see AdminRepsTab.deleteRep) so old removed accounts don't keep
    // resurfacing in the admin's rep dropdown.
    let deletedKeys=new Set();
    try { const raw=localStorage.getItem("mpcare_deleted_reps"); if(raw) JSON.parse(raw).forEach(k=>deletedKeys.add(k)); } catch(e){}
    const notDeleted=(r)=>!deletedKeys.has(r.id) && !deletedKeys.has(r.email) && !deletedKeys.has(r.supabaseId);
    // liveReps come from Supabase (approved only) so the per-browser deleted list never hides them;
    // demo seed copies of a deleted/paused live rep are hidden by email (Supabase-derived).
    const newLive=liveReps.filter(lr=>!demoEmails.has(lr.email?.toLowerCase()));
    const demo=ADMIN_REP_DATA.filter(r=>notDeleted(r)&&!inactiveRepEmails.has((r.email||"").toLowerCase()));
    return [...demo,...newLive];
  })();
  const approve=async(id)=>{
    const ac=accounts.find(a=>a.id===id);
    setAccounts(a=>a.map(ac=>ac.id===id?{...ac,status:"approved"}:ac));
    // Also persist approved status to localStorage overrides so it survives refresh even if Supabase is slow
    const ov=loadAcctOverrides(); ov[id]={...(ov[id]||{}),status:"approved"}; saveAcctOverrides(ov);
    // Persist to Supabase with retry
    if(ac?.isLive){
      try{await approveUser(id); setAccounts(a=>a.map(x=>x.id===id?{...x,dbStatus:"approved"}:x));}catch(e){
        console.warn("Approve sync failed, retrying:",e.message);
        setTimeout(()=>{approveUser(id).catch(e2=>console.warn("Approve retry failed:",e2.message));},2000);
      }
    }
    // If this is a rep, add to live reps list + sync to SHARED_REP_PROFILES so customer portal sees them
    if(ac&&(ac.role==="rep"||ac.tier==="rep")){
      const newRep={
        id:ac.id, name:ac.contact||"—", email:ac.email, phone:ac.phone||"",
        rate:6, paySchedule:"15th of month", startDate:ac.joined||new Date().toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}),
        territory:ac.address||"", notes:"New rep — pending setup", ytdSales:0, accounts:0,
        refCode:ac.refCode||"", customers:[], prospects:[], visits:[], isLive:true
      };
      setLiveReps(prev=>[...prev,newRep]);
      // Push to shared store so customer portal rep dropdown can find this rep
      SHARED_REP_PROFILES.set(ac.id, {name:ac.contact||"—", email:ac.email, phone:ac.phone||"", territory:ac.address||"", refCode:ac.refCode||""});
      if(ac.email) SHARED_REP_PROFILES.set(ac.email, {name:ac.contact||"—", email:ac.email, phone:ac.phone||"", territory:ac.address||"", refCode:ac.refCode||""});
      if(ac) emailWelcome({customerName:ac.contact||ac.email, customerEmail:ac.email});
    } else {
      if(ac) emailWelcome({customerName:ac.company||ac.contact, customerEmail:ac.email});
    }
  };
  const reject=async(id)=>{
    setAccounts(a=>a.map(ac=>ac.id===id?{...ac,status:"rejected"}:ac));
    const ac=accounts.find(a=>a.id===id);
    // Persist rejected status to localStorage overrides
    const ov=loadAcctOverrides(); ov[id]={...(ov[id]||{}),status:"rejected"}; saveAcctOverrides(ov);
    if(ac?.isLive){
      try{await rejectUser(id); setAccounts(a=>a.map(x=>x.id===id?{...x,dbStatus:"rejected"}:x));}catch(e){
        console.warn("Reject sync failed, retrying:",e.message);
        setTimeout(()=>{rejectUser(id).catch(e2=>console.warn("Reject retry failed:",e2.message));},2000);
      }
    }
  };
  // ── Suspend / delete / restore account ──
  // `status` is extended to include "paused" and "deleted". Both block login
  // (approved=false, rejected=true on the Supabase profile) and both move the
  // account into the "Deleted & paused accounts" section at the bottom of
  // the Accounts tab, where the full history + reason is preserved. Restore
  // flips status back to "approved" and clears the reason fields.
  const [suspendModal,setSuspendModal]=useState(null); // { account, mode: "pause"|"delete" }
  const [suspendReason,setSuspendReason]=useState("");
  const [suspendSubmitting,setSuspendSubmitting]=useState(false);
  const [viewingSuspendedId,setViewingSuspendedId]=useState(null); // expanded row in suspended section
  // ── Delete account (soft-delete, Supabase-first) ──
  // One unified modal for dealers AND reps. Requires a reason AND the typed word DELETE.
  // The database write is awaited FIRST (softDeleteProfile is strict, no silent column
  // stripping); only on success do React state and the localStorage mirror change. On
  // failure the modal shows the error and NOTHING changes locally.
  const [deleteModal,setDeleteModal]=useState(null); // { account }
  const [deleteReason,setDeleteReason]=useState("");
  const [deleteTyped,setDeleteTyped]=useState("");
  const [deleteAck,setDeleteAck]=useState(false);
  const [deleteBusy,setDeleteBusy]=useState(false);
  const [deleteError,setDeleteError]=useState("");
  const [deleteImpact,setDeleteImpact]=useState(null); // { loading, ...figures }
  const deleteImpactTarget=useRef(null);
  // Cached-state guard (the strict Supabase helpers re-check against the FRESH database row):
  // refuses admin rows and the logged-in admin's own row. Delete is allowed for approved, paused,
  // pending and rejected accounts (applicants are restored to their previous state); Pause is approved-only.
  // The account's audit fields (lifecycleFieldsFromProfile) are passed too, so a legacy rejected row that
  // carries an earlier delete/pause record is refused here (immediately, before the admin types anything).
  const lifecycleGuard=(ac,action)=>lifecycleBlockReason(
    {id:ac.supabaseId||ac.id,role:ac.role,status:ac.status,approved:ac.status==="approved",rejected:ac.status==="rejected",...lifecycleFieldsFromProfile(ac)},
    {action,actorId:user?.id}
  );
  const openDeleteModal=(ac)=>{
    if(!ac) return;
    const blocked=lifecycleGuard(ac,"delete");
    if(blocked){ window.alert(blocked); return; }
    setDeleteModal({account:ac}); setDeleteReason(""); setDeleteTyped(""); setDeleteAck(false);
    setDeleteBusy(false); setDeleteError(""); setDeleteImpact({loading:true});
    deleteImpactTarget.current=ac.id;
    computeDeleteImpact(ac,accounts).then(res=>{
      if(deleteImpactTarget.current===ac.id) setDeleteImpact(res);
    }).catch(e=>{
      console.warn("[AdminPanel] delete impact failed:",e?.message||e);
      if(deleteImpactTarget.current===ac.id) setDeleteImpact({partial:true});
    });
  };
  const closeDeleteModal=()=>{ deleteImpactTarget.current=null; setDeleteModal(null); setDeleteImpact(null); setDeleteError(""); };
  // Every rep needs the I-understand tick: the impact estimates (commission, stock) are derived
  // client-side and can under-report, so a rep delete is never one click past a "0" figure.
  const deleteIsRep=!!deleteModal && (deleteModal.account.role==="rep"||deleteModal.account.tier==="rep");
  const deleteNeedsAck=!!(deleteImpact && !deleteImpact.loading && !deleteImpact.applicant && (deleteIsRep || deleteImpact.partial || (deleteImpact.pendingCommission||0)>0 || (deleteImpact.onHandUnits||0)>0));
  const deleteReady=!!deleteModal && !!deleteReason.trim() && deleteTyped==="DELETE" && (!deleteNeedsAck||deleteAck) && !(deleteImpact&&deleteImpact.loading) && !deleteBusy;
  const [lifecycleNotice,setLifecycleNotice]=useState("");
  // null = default (open whenever the archive has entries); true/false = the admin's explicit choice.
  const [archiveOpenPref,setArchiveOpenPref]=useState(null);
  // Local mirror AFTER the database confirmed the Delete / Pause (also the only path for demo seed
  // accounts, which have no profile row). SHARED_REP_PROFILES is deliberately NOT touched: it holds
  // avatars / phone / territory that Restore cannot recover; pickers filter by the Supabase-derived
  // inactive set instead.
  const mirrorLifecycleLocally=(ac,mode,reason,nowIso,actor,priorState)=>{
    const nextStatus=mode==="delete"?"deleted":"paused";
    const fields=mode==="delete"
      ?{deletion_reason:reason,deleted_at:nowIso,paused_reason:null,paused_at:null,deleted_prior_state:(priorState==="pending"||priorState==="rejected")?priorState:null}
      :{paused_reason:reason,paused_at:nowIso,deletion_reason:null,deleted_at:null};
    setAccounts(a=>a.map(x=>x.id===ac.id?{...x,status:nextStatus,dbStatus:nextStatus,...fields,suspended_by:actor||null}:x));
    try{
      const ov=loadAcctOverrides();
      ov[ac.id]={...(ov[ac.id]||{}),status:nextStatus,...fields};
      saveAcctOverrides(ov);
    }catch(e){ console.warn("[AdminPanel] "+mode+": acct override mirror failed:",e?.message||e); }
    if(ac.role==="rep"||ac.tier==="rep"){
      setLiveReps(prev=>prev.filter(r=>r.id!==ac.id&&r.email!==ac.email));
      if(!(ac.isLive||ac.supabaseId)){
        // Demo-only rep (no profile row): keep the legacy per-browser hide list.
        try{
          const raw=localStorage.getItem("mpcare_deleted_reps");
          const list=raw?JSON.parse(raw):[];
          [ac.id,ac.email,ac.supabaseId].filter(Boolean).forEach(k=>{ if(!list.includes(k)) list.push(k); });
          localStorage.setItem("mpcare_deleted_reps",JSON.stringify(list));
        }catch(e){ console.warn("[AdminPanel] "+mode+": deleted-reps mirror failed:",e?.message||e); }
      }
    }
  };
  // After a successful Delete / Pause: expand the archive and show a clear confirmation with a link to it.
  const afterLifecycleSuccess=(ac,verb)=>{
    const label=(ac.company&&ac.company!=="—"?ac.company:(ac.contact||ac.email))||"The account";
    setArchiveOpenPref(true);
    setLifecycleNotice(label+" was "+verb+". Login is blocked and history is kept. Find it (and Restore) under Deleted & paused accounts.");
    if(tab==="accounts") setTimeout(()=>{ try{ const el=document.getElementById("mpcare-deleted-archive"); if(el&&el.scrollIntoView) el.scrollIntoView({behavior:"smooth",block:"start"}); }catch(e){ console.warn("[AdminPanel] scroll to archive failed:",e?.message||e); } },120);
  };
  const performDelete=async()=>{
    if(!deleteReady||!deleteModal) return;
    const ac=deleteModal.account;
    const reason=deleteReason.trim();
    setDeleteBusy(true); setDeleteError("");
    try{
      let nowIso=new Date().toISOString();
      // Demo-only accounts have no profile row: fall back to their cached applicant status for the label.
      let priorState=(ac.status==="pending"||ac.status==="rejected")?ac.status:null;
      if(ac.isLive||ac.supabaseId){
        const row=await softDeleteProfile(ac.supabaseId||ac.id,{reason,actorEmail:user?.email||"",actorId:user?.id});
        if(row?.deleted_at) nowIso=row.deleted_at;
        priorState=row?.deleted_prior_state||null;   // the database row is the truth for the label
      }
      mirrorLifecycleLocally(ac,"delete",reason,nowIso,user?.email||"",priorState);
      setViewingAccount(null);
      closeDeleteModal();
      afterLifecycleSuccess(ac,"deleted");
    }catch(e){
      console.warn("[AdminPanel] delete account failed for",ac.id,e?.message||e);
      setDeleteError(e?.message||"Delete failed. Nothing was changed.");
    }finally{ setDeleteBusy(false); }
  };
  // AdminRepsTab entry points: it holds its own rep objects, so resolve to the hydrated account.
  const accountForRep=(rep)=>{
    const sbId=rep.supabaseId||rep.id;
    return accounts.find(a=>a.id===sbId)||{
      id:sbId, supabaseId:sbId, role:"rep", tier:"rep", isLive:true, status:"approved",
      contact:rep.name, company:rep.name, email:rep.email, phone:rep.phone||"", address:rep.territory||"", refCode:rep.refCode||""
    };
  };
  const requestDeleteRep=(rep)=>openDeleteModal(accountForRep(rep));
  const requestPauseRep=(rep)=>openSuspendModal(accountForRep(rep),"pause");
  const openArchive=()=>{
    setTab("accounts"); setArchiveOpenPref(true);
    setTimeout(()=>{ try{ const el=document.getElementById("mpcare-deleted-archive"); if(el&&el.scrollIntoView) el.scrollIntoView({behavior:"smooth",block:"start"}); }catch(e){ console.warn("[AdminPanel] scroll to archive failed:",e?.message||e); } },80);
  };
  const [restoreBusyId,setRestoreBusyId]=useState(null);
  // "pending" | "rejected" for an archived (deleted) applicant, else null.
  const archivePrior=(ac)=>(ac&&ac.status==="deleted"&&(ac.deleted_prior_state==="pending"||ac.deleted_prior_state==="rejected"))?ac.deleted_prior_state:null;
  const [archiveError,setArchiveError]=useState("");
  const [suspendError,setSuspendError]=useState("");
  const openSuspendModal=(ac,mode)=>{
    if(!ac) return;
    if(mode==="delete"){ openDeleteModal(ac); return; }
    const blocked=lifecycleGuard(ac,"pause");
    if(blocked){ window.alert(blocked); return; }
    setSuspendModal({account:ac,mode}); setSuspendReason(""); setSuspendError("");
  };
  // Pause. Live profiles go through the STRICT Supabase-first helper (softPauseProfile: re-reads the
  // row, refuses non-approved / admin / self, conditional single-row update, verified result). React
  // state and the localStorage mirror change ONLY after the database confirmed it; on failure the
  // modal shows the error and nothing changes. Only demo-only seed accounts (no profile) are local-only.
  const applySuspension=async()=>{
    if(!suspendModal) return;
    const { account: ac, mode } = suspendModal;
    const reason = (suspendReason||"").trim();
    if(!reason){ return; } // UI disables the button; belt-and-braces
    if(mode==="delete"){ setSuspendModal(null); openDeleteModal(ac); return; } // Delete has its own strict modal
    setSuspendSubmitting(true); setSuspendError("");
    try{
      let nowIso = new Date().toISOString();
      if(ac.isLive||ac.supabaseId){
        const row=await softPauseProfile(ac.supabaseId||ac.id,{reason,actorEmail:user?.email||"",actorId:user?.id});
        if(row?.paused_at) nowIso=row.paused_at;
      }
      mirrorLifecycleLocally(ac,"pause",reason,nowIso,user?.email||"");
      setSuspendModal(null);
      setSuspendReason("");
      setViewingAccount(null); // close detail panel; account has moved to the archive
      afterLifecycleSuccess(ac,"paused");
    }catch(e){
      console.warn("[AdminPanel] pause account failed for",ac.id,e?.message||e);
      setSuspendError(e?.message||"Pause failed. Nothing was changed.");
    }finally{ setSuspendSubmitting(false); }
  };
  const restoreAccount=async(ac)=>{
    // Supabase-first: the strict restoreProfile helper re-fetches the row fresh, only
    // touches a row that is really deleted/paused, and verifies the result. Local state
    // and the localStorage mirror change ONLY after it succeeded; on failure an error is
    // shown and nothing changes.
    const label = (ac.company&&ac.company!=="—"?ac.company:(ac.contact||ac.email))||"this account";
    // An applicant deleted while pending/rejected returns to THAT state, never to approved.
    const priorApplicant=(ac.status==="deleted"&&(ac.deleted_prior_state==="pending"||ac.deleted_prior_state==="rejected"))?ac.deleted_prior_state:null;
    const confirmText=priorApplicant
      ?`Restore ${label} as ${priorApplicant}?\n\nThe applicant goes back to the ${priorApplicant} list exactly as it was. They are NOT approved by this action.`
      :`Restore ${label}?\n\nThey will be able to sign in again and will reappear in the active lists. Their orders, invoices, commission and inventory history were never removed.`;
    if(!window.confirm(confirmText)) return;
    setRestoreBusyId(ac.id); setArchiveError("");
    let restoredRow=null;
    try{
      // fromSnapshot lets the helper accept the OLD flow's stripped write (rejected, status text lost)
      // for entries this browser's snapshot proves were paused/deleted; a plain rejected applicant is refused.
      if(ac.isLive || ac.supabaseId){ restoredRow=await restoreProfile(ac.supabaseId || ac.id, { fromSnapshot: !!(ac.fromSnapshot || ac._fromRepOverrides) }); }
    }catch(e){
      console.warn("[AdminPanel] restore account failed for",ac.id,e?.message||e);
      setArchiveError(`Could not restore ${label}: ${e?.message||e}`);
      setRestoreBusyId(null);
      return;
    }
    // Flip back to the state the database row now has (approved, or pending/rejected for a deleted
    // applicant) and clear the suspension metadata.
    const restoredStatus=restoredRow?deriveAccountStatus(restoredRow):(priorApplicant||"approved");
    // `ac` may come from `accounts` state (customer or live rep) or from the
    // mpcare_rep_overrides snapshot (demo/rep-only); handle both.
    const isRep = ac.role==="rep" || ac.tier==="rep";
    // Update accounts state if the id lives there (customer or live rep)
    setAccounts(a=>a.map(x=>x.id===ac.id?{
      ...x, status:restoredStatus, dbStatus:restoredStatus,
      deletion_reason:null, deleted_at:null, paused_reason:null, paused_at:null, suspended_by:null, deleted_prior_state:null
    }:x));
    // Clear the customer-side override
    const ov=loadAcctOverrides();
    if(ov[ac.id]){
      ov[ac.id]={
        ...(ov[ac.id]||{}),
        status:restoredStatus,
        deletion_reason:null, deleted_at:null, paused_reason:null, paused_at:null, deleted_prior_state:null
      };
      saveAcctOverrides(ov);
    }
    // Clear the rep-side override if present (AdminRepsTab wrote this on suspension)
    try {
      const raw=localStorage.getItem("mpcare_rep_overrides");
      if(raw){
        const repOv=JSON.parse(raw);
        if(repOv[ac.id]){
          repOv[ac.id]={
            ...repOv[ac.id],
            status:restoredStatus,
            deletion_reason:null, deleted_at:null, paused_reason:null, paused_at:null, deleted_prior_state:null
          };
          localStorage.setItem("mpcare_rep_overrides",JSON.stringify(repOv));
        }
      }
    } catch(e){}
    if(isRep && restoredStatus==="approved"){
      // Remove from the legacy deleted-reps filter list so dropdowns pick them back up
      try{
        const raw=localStorage.getItem("mpcare_deleted_reps");
        if(raw){
          const list=JSON.parse(raw).filter(k=>k!==ac.id && k!==ac.email && k!==ac.supabaseId);
          localStorage.setItem("mpcare_deleted_reps",JSON.stringify(list));
        }
      }catch(e){}
      // SHARED_REP_PROFILES.set() MERGES but lets empty strings overwrite stored values, so only
      // pass fields that actually have a value (never blank a stored phone / territory / refCode).
      const repData={name:ac.contact||ac.name||"—"};
      if(ac.email) repData.email=ac.email;
      if(ac.phone) repData.phone=ac.phone;
      if(ac.address) repData.territory=ac.address;
      if(ac.refCode) repData.refCode=ac.refCode;
      SHARED_REP_PROFILES.set(ac.id,repData);
      if(ac.email) SHARED_REP_PROFILES.set(ac.email,repData);
      setLiveReps(prev=>{
        if(prev.some(r=>r.id===ac.id)) return prev;
        return [...prev,{
          id:ac.id, name:ac.contact||ac.name||"—", email:ac.email, phone:ac.phone||"",
          rate:6, paySchedule:"15th of month", startDate:ac.joined||"",
          territory:ac.address||"", notes:"", ytdSales:0, accounts:0,
          refCode:ac.refCode||"", customers:[], prospects:[], visits:[], isLive:true
        }];
      });
    }
    setRestoreBusyId(null);
    // Force the suspended section to re-read localStorage in case the change came
    // from a rep-only override (mpcare_rep_overrides) that isn't tied to React state.
    setSuspendRefreshNonce(n=>n+1);
  };
  const [preEditRep,setPreEditRep]=useState("");
  const [savingAcct,setSavingAcct]=useState(false);
  // Phase A — rep-customer assignment sync warning. Populated by saveEdit
  // when customer_settings wrote successfully but the mirror into
  // rep_route_customers failed (the rep won't see the assignment until retry).
  // Admin can dismiss or re-save to retry. Same non-blocking amber-banner
  // pattern as the rep-invoice-sync PR.
  const [assignSyncWarning, setAssignSyncWarning] = useState("");

  // ── Reassign Rep modal — focused entry point for moving a single
  // customer between reps without opening the full Edit Account modal.
  // Calls the same atomic transfer logic as saveEdit's rep-change path:
  //   1. saveCustomerAssignment(custId, {rep: newRepName}) — authoritative
  //      assignment in customer_settings.rep
  //   2. upsertRepRouteCustomer({newRepId, ...}) — appears in new rep's
  //      Route Planner cross-device
  //   3. deactivateRepRouteCustomer(oldRepId, custKey) — soft-removes
  //      from old rep's Route Planner cross-device
  //   4. emailRepAssigned + emailRepChanged on success
  // The user reported that two reps were both receiving commission for
  // the same customer's invoice ("celine account does not have this
  // customer anymore she deleted it but she is still re receiving
  // commission when marcus do an order to this same customer"). The
  // commission half is fixed at filterRepInvoices in src/repMetrics.js —
  // PR #79 makes inv.rep the authoritative attribution source. This
  // modal is the matching admin-side UI: a one-click way to ensure the
  // customer's assignment matches admin's intent, so future invoices
  // get the correct rep stamp.
  const [transferRepCust, setTransferRepCust] = useState(null);
  const [transferRepNewName, setTransferRepNewName] = useState("");
  const [transferRepBusy, setTransferRepBusy] = useState(false);
  const [transferRepError, setTransferRepError] = useState("");

  const openTransferRep = (ac) => {
    if (!ac) return;
    setTransferRepCust(ac);
    setTransferRepNewName(ac.rep || "");
    setTransferRepError("");
  };
  const closeTransferRep = () => {
    if (transferRepBusy) return;
    setTransferRepCust(null);
    setTransferRepNewName("");
  };

  const confirmTransferRep = async () => {
    if (!transferRepCust || transferRepBusy) return;
    const ac = transferRepCust;
    const oldRepName = (ac.rep || "").trim();
    const newRepName = (transferRepNewName || "").trim();
    if (oldRepName === newRepName) {
      setTransferRepCust(null);
      setTransferRepNewName("");
      return;
    }
    setTransferRepBusy(true);
    setTransferRepError("");

    // 1) customer_settings — the authoritative dealer→rep assignment.
    let customerSettingsOk = true;
    try {
      await saveCustomerAssignment(ac.id, { rep: newRepName });
    } catch (e) {
      console.warn("[transferRep] customer_settings update failed:", e?.message || e);
      customerSettingsOk = false;
    }
    if (!customerSettingsOk) {
      setTransferRepError(`Couldn't update assignment for ${ac.company || ac.contact || ac.id}. Try again.`);
      setTransferRepBusy(false);
      return;
    }

    // 2 & 3) rep_route_customers — atomic upsert-new + deactivate-old.
    // Mirrors saveEdit's rep-change block exactly so behavior is consistent
    // between the two entry points (Edit modal and this dedicated flow).
    const findRepId = (name) => {
      if (!name) return null;
      const exact = (repList || []).find(r => (r.name || "").trim() === name);
      const r = exact || (repList || []).find(r => (r.name || "").trim().toLowerCase() === name.toLowerCase());
      if (!r) return null;
      return r.supabaseId || r.id || null;
    };
    const newRepId = newRepName ? findRepId(newRepName) : null;
    // The old rep may be deleted/paused (the modal recommends reassigning away from them), which
    // repList no longer contains. Resolve from the FULL accounts list so the old row is deactivated.
    const oldRepId = oldRepName ? resolveRepIdByName(oldRepName, repList, accounts) : null;
    const dealerKey = String(ac.id);
    const dealerData = {
      company: ac.company || "",
      contact: ac.contact || "",
      email:   ac.email   || "",
      phone:   ac.phone   || "",
      address: ac.address || "",
      tier:    ac.tier    || "",
      ein:     ac.ein     || "",
    };

    let allOk = true;
    const warnParts = [];
    if (newRepName && newRepId) {
      try {
        const row = await upsertRepRouteCustomer({
          repId: String(newRepId),
          repName: newRepName,
          customerKey: dealerKey,
          customerData: dealerData,
          isProspect: false,
          source: 'admin_assign',
          active: true,
        });
        if (!row) { allOk = false; warnParts.push(`couldn't add to ${newRepName}'s Route Planner`); }
      } catch (e) {
        allOk = false;
        warnParts.push(`couldn't add to ${newRepName}'s Route Planner (${e?.message || e})`);
      }
    } else if (newRepName && !newRepId) {
      allOk = false;
      warnParts.push(`couldn't resolve rep id for "${newRepName}"`);
      console.warn("[transferRep] rep_route_customers upsert skipped — no rep id for", newRepName);
    }
    if (oldRepName && oldRepId && oldRepName !== newRepName) {
      try {
        // STRICT: throws on a failed update (no row existing is fine), so the catch below fires.
        await deactivateRepRouteCustomerStrict(String(oldRepId), dealerKey);
      } catch (e) {
        console.warn("[transferRep] deactivate old rep route row failed:", e?.message || e);
        allOk = false;
        warnParts.push(`couldn't remove from ${oldRepName}'s Route Planner (${e?.message || e})`);
      }
    } else if (oldRepName && !oldRepId && oldRepName !== newRepName) {
      console.warn("[transferRep] old rep id unresolved — old rep_route_customers row NOT deactivated for", oldRepName);
      // Only a rep-shaped name that we cannot map to a Supabase id deserves a visible warning;
      // a free-text / demo name never had a rep_route_customers row.
      if (repNameKnown(oldRepName, repList, accounts)) {
        allOk = false;
        warnParts.push(`couldn't identify the previous rep "${oldRepName}", so the old Route Planner entry was NOT removed`);
      }
    }

    // Local state — admin's accounts list and any account override cache
    // need to reflect the new rep so the UI updates without a refresh.
    setAccounts(a => a.map(x => x.id === ac.id ? { ...x, rep: newRepName } : x));
    try {
      const overrides = loadAcctOverrides();
      overrides[ac.id] = { ...(overrides[ac.id] || {}), rep: newRepName };
      saveAcctOverrides(overrides);
    } catch (e) { console.warn("[transferRep] override cache update failed:", e?.message || e); }

    // Email notifications — same as saveEdit's rep-change path.
    try {
      const newRepRecord = newRepName ? (repList || []).find(r => (r.name || "").trim().toLowerCase() === newRepName.toLowerCase()) : null;
      if (newRepRecord?.email) {
        emailRepAssigned({
          repName: newRepName,
          repEmail: newRepRecord.email,
          customerName: ac.contact || "",
          customerCompany: ac.company || "",
          customerEmail: ac.email || "",
          customerPhone: ac.phone || "",
          customerTier: ac.tier || "",
        });
      }
      emailRepChanged({
        customerCompany: ac.company || "",
        customerName: ac.contact || "",
        oldRep: oldRepName || "",
        newRep: newRepName || "",
        changedBy: user?.email || "admin",
      });
    } catch (e) { console.warn("[transferRep] email notification failed:", e?.message || e); }

    setTransferRepBusy(false);
    if (!allOk) {
      setTransferRepError(`Reassignment partially completed: ${warnParts.join(" · ")}. Click Save again to retry.`);
    } else {
      alert(`Reassigned ${ac.company || ac.contact || ac.id} to ${newRepName || "Unassigned"}.`);
      setTransferRepCust(null);
      setTransferRepNewName("");
      setTransferRepError("");
    }
  };

  // DATABASE-derived status the Edit Account modal was opened with (never the override-merged status);
  // saveEdit compares it to the FRESH database row. editOpenedStatusRef is the status the modal displayed
  // (may come from a per-browser override) and only decides whether the admin changed the status.
  const editLoadedStatusRef=useRef(null);
  const editOpenedStatusRef=useRef(null);
  const editBaselineIdRef=useRef(null);
  const startEdit=(ac)=>{
    // A deleted/paused account must never be edited (and thereby re-approved) through this modal;
    // Restore from the Deleted & paused archive is the only way back.
    if(ac && (ac.status==="deleted"||ac.status==="paused")){
      alert("This account is "+ac.status+". Restore it from the Deleted & paused accounts section before editing.");
      return;
    }
    // Ensure editData.terms is always an array — belt & suspenders against
    // any code path that seeded an account without going through the
    // normalizing loader (signup handlers, notification deep-links, etc.).
    const normalizedTerms = Array.isArray(ac.terms) ? ac.terms : (_toTermsArray(ac.terms) || ["cc"]);
    editLoadedStatusRef.current=ac.dbStatus||null;
    editOpenedStatusRef.current=ac.status||null;
    editBaselineIdRef.current=ac.id;
    if(ac.isLive){
      // Refresh the baseline from the database itself (read only). If it cannot be read, the hydrate-time
      // dbStatus above stays in place.
      fetchFreshProfile(ac.id).then(row=>{
        const d=deriveAccountStatus(row);
        if(editBaselineIdRef.current===ac.id && d!=="deleted" && d!=="paused") editLoadedStatusRef.current=d;
      }).catch(e=>console.warn("[AdminPanel] startEdit baseline read failed for",ac.id,e?.message||e));
    }
    setEditingId(ac.id);
    setEditData({...ac, terms: normalizedTerms});
    setPreEditRep(ac.rep||"");
  };
  const saveEdit=async()=>{
    // Re-entry guard: prevent double-clicks on the Save button from firing saveCustomerAssignment,
    // updateProfile, and — most importantly — emailRepChanged / emailRepAssigned multiple times.
    // (Reported: admin assigned one rep once and got 4 duplicate "Rep assignment changed" emails.)
    if(savingAcct) return;
    if(editData && (editData.status==="deleted"||editData.status==="paused")){ console.warn("[AdminPanel] saveEdit blocked: account is",editData.status); return; }
    setSavingAcct(true);
    // Stale-write guard: re-read the profile row NOW. Refuse (nothing written anywhere) when another
    // admin deleted / paused the account or changed its status since this modal opened.
    let writeStatus=false;
    let freshDbStatus=null;
    if(editData?.isLive){
      let freshRow=null;
      try{ freshRow=await fetchFreshProfile(editingId); }
      catch(e){ console.warn("[AdminPanel] saveEdit fresh profile read failed for",editingId,e?.message||e); }
      const guard=editSaveGuard({fresh:freshRow,loadedStatus:editLoadedStatusRef.current,openedStatus:editOpenedStatusRef.current,editedStatus:editData.status});
      if(!guard.ok){
        console.warn("[AdminPanel] saveEdit refused for",editingId,guard.reason,guard.message);
        window.alert(guard.message);
        // Keep the modal (and the admin's typed values) open unless the account is really deleted/paused.
        if(guard.reason==="gone") setEditingId(null);
        setSavingAcct(false);
        return;
      }
      writeStatus=guard.writeStatus;
      freshDbStatus=deriveAccountStatus(freshRow);
    }
    setAccounts(a=>a.map(ac=>ac.id===editingId?editData:ac));
    // Persist account edits to localStorage
    if(editData){
      const overrides=loadAcctOverrides();
      overrides[editingId]={company:editData.company,contact:editData.contact,email:editData.email,phone:editData.phone||"",ein:editData.ein,address:editData.address,tier:editData.tier,status:editData.status,rep:editData.rep,creditLimit:editData.creditLimit,terms:editData.terms,discount:editData.discount||0};
      saveAcctOverrides(overrides);
    }
    if(editData?.isLive){
      try{await updateProfile(editingId,{
        company:editData.company,full_name:editData.contact,phone:editData.phone||"",ein:editData.ein,address:editData.address,
        tier:editData.tier,credit_limit:editData.creditLimit,terms:editData.terms,rep:editData.rep,
        discount:editData.discount||0,
        // approved / rejected only when the admin changed the status in this edit and the fresh row still matched what was loaded.
        ...(writeStatus?{approved:editData.status==="approved",rejected:editData.status==="rejected"}:{})
      });
        // keep the database baseline on the cached account current after a successful write
        const savedId=editingId, newDb=writeStatus?editData.status:freshDbStatus;
        if(newDb) setAccounts(a=>a.map(ac=>ac.id===savedId?{...ac,dbStatus:newDb}:ac));
      }catch(e){console.warn("Profile update sync failed:",e.message);}
      // Always also persist rep/terms/credit/discount to the assignment store — this survives even
      // when the profiles table lacks the extension columns (falls back to a shared localStorage cache).
      let customerSettingsOk = true;
      try{await saveCustomerAssignment(editingId,{rep:editData.rep||"",terms:editData.terms||[],creditLimit:editData.creditLimit||0,discount:editData.discount||0});}catch(e){console.warn("Customer assignment sync failed:",e.message); customerSettingsOk = false;}

      // Phase A — atomic pair: after customer_settings, mirror the rep
      // assignment into rep_route_customers so the rep's portal sees this
      // dealer in their customer list cross-device. Ordered AFTER
      // customer_settings because dealer-side source-of-truth must land first;
      // we never want rep_route_customers newer than customer_settings.
      // Failure of either write surfaces an amber banner and leaves the
      // already-succeeded write in place — admin can re-click Save to retry
      // idempotently (saveCustomerAssignment upserts on user_id;
      // upsertRepRouteCustomer upserts on (rep_id, customer_key);
      // deactivateRepRouteCustomer is a no-op on a row that's already
      // active=false).
      if (customerSettingsOk) {
        const oldRepName = (preEditRep || "").trim();
        const newRepName = (editData.rep || "").trim();
        if (oldRepName !== newRepName) {
          const dealerKey = String(editingId);
          const dealerData = {
            company: editData.company || "",
            contact: editData.contact || "",
            email:   editData.email   || "",
            phone:   editData.phone   || "",
            address: editData.address || "",
            tier:    editData.tier    || "",
            ein:     editData.ein     || "",
          };
          // Resolve rep name → rep id via the admin's own repList (demo int
          // id for seeded reps, Supabase UUID for live reps — matches the
          // rep-identity convention used elsewhere).
          const findRepId = (name) => {
            if (!name) return null;
            const exact = (repList || []).find(r => (r.name || "").trim() === name);
            const r = exact || (repList || []).find(r => (r.name || "").trim().toLowerCase() === name.toLowerCase());
            if (!r) return null;
            return r.supabaseId || r.id || null;
          };
          const newRepId = newRepName ? findRepId(newRepName) : null;
          // The PREVIOUS rep may be deleted/paused, which repList (active pickers) no longer contains.
          // Resolve it from the FULL accounts list (inactive reps included) so the old
          // rep_route_customers row is always deactivated; never skip it silently.
          const oldRepId = oldRepName ? resolveRepIdByName(oldRepName, repList, accounts) : null;

          let newAssignOk = true;
          let oldDeactivateOk = true;
          let newAssignErr = "";
          let oldDeactivateErr = "";

          // 1) Upsert new rep's row (active=true) if a new rep is assigned.
          if (newRepName && newRepId) {
            const row = await upsertRepRouteCustomer({
              repId: String(newRepId),
              repName: newRepName,
              customerKey: dealerKey,
              customerData: dealerData,
              isProspect: false,
              source: 'admin_assign',
              active: true,
            });
            if (!row) { newAssignOk = false; newAssignErr = "Supabase returned null"; }
          } else if (newRepName && !newRepId) {
            newAssignOk = false;
            newAssignErr = `Could not resolve rep id for "${newRepName}"`;
            console.warn("[saveEdit] rep_route_customers upsert skipped —", newAssignErr);
          }

          // 2) Deactivate old rep's row if the rep changed (soft delete).
          if (oldRepName && oldRepId && oldRepName !== newRepName) {
            try {
              // STRICT: throws on a failed update; { existed:false } (no row) is fine and needs no action.
              await deactivateRepRouteCustomerStrict(String(oldRepId), dealerKey);
            } catch(e) {
              console.warn("[saveEdit] deactivate old rep route row failed:", e?.message || e);
              oldDeactivateOk = false;
              oldDeactivateErr = e?.message || String(e);
            }
          } else if (oldRepName && !oldRepId && oldRepName !== newRepName) {
            console.warn("[saveEdit] old rep id unresolved — old rep_route_customers row NOT deactivated for", oldRepName);
            if (repNameKnown(oldRepName, repList, accounts)) {
              oldDeactivateOk = false;
              oldDeactivateErr = `could not identify the previous rep "${oldRepName}", so the old Route Planner entry was NOT removed`;
            }
          }

          // Surface failures via banner so admin knows to retry.
          if (!newAssignOk || !oldDeactivateOk) {
            const parts = [];
            if (!newAssignOk)     parts.push(`couldn't sync to new rep (${newRepName}): ${newAssignErr}`);
            if (!oldDeactivateOk) parts.push(`couldn't remove from previous rep (${oldRepName}): ${oldDeactivateErr}`);
            setAssignSyncWarning(`Dealer ${editData.company || editData.contact || editingId} — ${parts.join(" · ")}. Click Save again to retry.`);
          } else {
            setAssignSyncWarning("");
          }
        }
      }
    }
    // Push discount change to shared settings so customer portal picks it up immediately
    if(editData) SHARED_SETTINGS.setCustomerDiscount(editData.company||editData.id, editData.discount||0);
    // Push profile edits to shared store so customer/rep portal picks them up
    if(editData) {
      const profileKey = editData.supabaseId || editData.id;
      const profilePayload = { company:editData.company, contact:editData.contact, email:editData.email, phone:editData.phone, address:editData.address, ein:editData.ein, tier:editData.tier, refCode:editData.refCode||"", status:editData.status, rep:editData.rep||"" };
      if(editData.role==="rep"||editData.tier==="rep") {
        SHARED_REP_PROFILES.set(profileKey, { name:editData.contact, email:editData.email, phone:editData.phone, territory:editData.address, refCode:editData.refCode||"" });
        if(editData.email) SHARED_REP_PROFILES.set(editData.email, { name:editData.contact, email:editData.email, phone:editData.phone, territory:editData.address, refCode:editData.refCode||"" });
      } else {
        SHARED_CUSTOMER_PROFILES.set(profileKey, profilePayload);
        if(editData.email) SHARED_CUSTOMER_PROFILES.set(editData.email, profilePayload);
      }
    }
    // Email: notify when rep assignment changes
    if(editData && (editData.rep||"") !== preEditRep) {
      const newRepName = editData.rep || "";
      const oldRepName = preEditRep || "";
      // Notify admin of the change
      emailRepChanged({ customerCompany:editData.company, customerName:editData.contact, oldRep:oldRepName, newRep:newRepName, changedBy:"Admin" });
      // Notify the new rep they've been assigned
      if(newRepName) {
        const newRepObj = repList.find(r=>r.name===newRepName);
        if(newRepObj && newRepObj.email) {
          emailRepAssigned({ repName:newRepName, repEmail:newRepObj.email, customerName:editData.contact, customerCompany:editData.company, customerEmail:editData.email, customerPhone:editData.phone, customerTier:editData.tier });
        }
      }
      // Mirror the new rep into preEditRep so a second save on the same dialog (without closing)
      // is treated as a no-op for rep-change-email purposes.
      setPreEditRep(newRepName);
    }
    setEditingId(null);
    setSavingAcct(false);
  };
  const toggleTerm=(termId)=>setEditData(d=>{
    // Defensive: if editData.terms arrived from Supabase as a string or
    // null (pre-normalized legacy row), coerce to array before toggling.
    const arr = Array.isArray(d.terms) ? d.terms : (_toTermsArray(d.terms) || []);
    return {...d, terms: arr.includes(termId) ? arr.filter(t=>t!==termId) : [...arr, termId]};
  });
  const [repSearchOpen,setRepSearchOpen]=useState(false);
  const [repSearchQ,setRepSearchQ]=useState("");
  const [acctSort,setAcctSort]=useState({key:"joined",dir:"desc"});
  const [acctSearch,setAcctSearch]=useState("");
  // Top-bar stat-card filter. "all" is reset; other values filter by tier
  // or status. Layered on top of the search + sort.
  const [acctListFilter,setAcctListFilter]=useState("all");
  const sortBy=(key)=>setAcctSort(s=>({key,dir:s.key===key&&s.dir==="asc"?"desc":"asc"}));
  const sortArrow=(key)=>acctSort.key===key?(acctSort.dir==="asc"?" ^":" v"):"";
  const sortFn=(a,b)=>{
    const k=acctSort.key;const dir=acctSort.dir==="asc"?1:-1;
    if(k==="company")return dir*(a.company||"").localeCompare(b.company||"");
    if(k==="tier")return dir*(a.tier||"").localeCompare(b.tier||"");
    if(k==="status")return dir*(a.status||"").localeCompare(b.status||"");
    if(k==="credit")return dir*((a.creditLimit||0)-(b.creditLimit||0));
    if(k==="joined")return dir*(new Date(a.joined||0)-new Date(b.joined||0));
    return 0;
  };
  const filteredAccounts=accounts.filter(a=>{
    // Hide rep-role users from accounts tab (they belong in Sales Reps tab)
    if(a.role==="rep"||a.tier==="rep") return false;
    // Hide paused/deleted accounts from the active list — they live in the
    // "Deleted & paused accounts" section below.
    if(a.status==="paused"||a.status==="deleted") return false;
    // Stat-card filter
    if(acctListFilter==="dealer"      && (a.tier||"").toLowerCase()!=="dealer") return false;
    if(acctListFilter==="distributor" && (a.tier||"").toLowerCase()!=="distributor") return false;
    if(acctListFilter==="enterprise"  && (a.tier||"").toLowerCase()!=="enterprise") return false;
    if(acctListFilter==="withCredit"  && !((a.creditLimit||0) > 0)) return false;
    if(acctListFilter==="unassigned"  && a.rep && !dealerHasInactiveRep(a,inactiveRepStatuses)) return false;
    if(!acctSearch)return true;
    // Trim to handle pasted ref codes with stray whitespace.
    const q=acctSearch.trim().toLowerCase();
    if(!q) return true;
    return (a.company||"").toLowerCase().includes(q)||(a.contact||"").toLowerCase().includes(q)||(a.email||"").toLowerCase().includes(q)||(a.tier||"").toLowerCase().includes(q)||(a.status||"").toLowerCase().includes(q)||(a.refCode||"").toLowerCase().includes(q)||(a.phone||"").toLowerCase().includes(q)||(a.ein||"").toLowerCase().includes(q);
  }).sort(sortFn);
  const pending=accounts.filter(a=>a.status==="pending");
  const pendingReps=pending.filter(a=>a.role==="rep"||a.tier==="rep");
  const pendingCustomers=pending.filter(a=>a.role!=="rep"&&a.tier!=="rep");
  // All suspended accounts (customers + reps) — shown in the "Deleted & paused accounts"
  // section at the bottom of the Accounts tab with reason, date, and a Restore button.
  //
  // Two sources:
  //   1. `accounts` state — customers (+ any rep-role user that lives in accounts state)
  //   2. `mpcare_rep_overrides` — rep-specific snapshots written by AdminRepsTab when a rep
  //      is paused/deleted. Demo reps (ADMIN_REP_DATA) only live there.
  //
  // `suspendRefreshNonce` is bumped by restoreAccount/applySuspension so the section
  // re-reads localStorage immediately without waiting for an unrelated re-render.
  const [suspendRefreshNonce,setSuspendRefreshNonce]=useState(0);
  const suspendedAccounts=useMemo(()=>{
    // Source of truth: the Supabase-hydrated `accounts` (reps AND dealers). The per-browser
    // mpcare_rep_overrides snapshot is ALWAYS merged in too (deduped by id and email), even after a
    // successful hydrate: reps paused/deleted through the OLD flow whose status write was silently
    // stripped, and demo-only reps, exist only there. Supabase still wins: a snapshot entry whose live
    // account is approved/pending in the database is dropped. The snapshot is never written here.
    const cust=buildArchive(accounts);
    let repEntries=[];
    try {
      const raw=localStorage.getItem("mpcare_rep_overrides");
      if(raw){
        const ov=JSON.parse(raw);
        repEntries=Object.entries(ov)
          .filter(([_,v])=>v && (v.status==="paused"||v.status==="deleted"))
          .map(([id,v])=>({
            id, role:"rep", tier:"rep", isLive:!!v.isLive, supabaseId:v.supabaseId||"",
            company:v.name||"", contact:v.name||"", name:v.name||"",
            email:v.email||"", phone:v.phone||"", address:v.territory||"",
            refCode:v.refCode||"", joined:v.startDate||"",
            status:v.status,
            deletion_reason:v.deletion_reason||null, deleted_at:v.deleted_at||null,
            paused_reason:v.paused_reason||null, paused_at:v.paused_at||null,
            _fromRepOverrides:true,
          }));
      }
    } catch(e) { console.warn("[AdminPanel] mpcare_rep_overrides snapshot unreadable, archive shows Supabase rows only:",e?.message||e); }
    return mergeArchiveWithSnapshot(cust,repEntries,accounts);
  },[accounts,suspendRefreshNonce]);
  const showArchive=archiveOpenPref===null?suspendedAccounts.length>0:archiveOpenPref;
  const toolAlerts=adminAgreements.filter(a=>a.status!=="compliant").length;

  // Watch SHARED_INVOICES so the overdue badge + banner stay live as new
  // portal orders come in or as existing invoices get paid/cancelled.
  // Admin-visible invoices (shared selector, F5): removed orders never feed
  // the overdue / unshipped alerts or the per-account panels below.
  const allInvoicesForAlerts = useAdminVisibleInvoices();
  const overdueInvoices = allInvoicesForAlerts.filter(isOverdue);
  const overdueTotal = overdueInvoices.reduce((s,i)=>s+(i.total||0),0);

  // Unshipped orders — anything in SHARED_INVOICES that isn't cancelled AND
  // hasn't been shipped or delivered yet. Drives the top-of-panel banner
  // and the red badge on the Orders sidebar item.
  const unshippedOrders = allInvoicesForAlerts.filter(inv => {
    if(!inv) return false;
    if(inv.status === "cancelled") return false;
    const ship = inv.shippingStatus;
    if(ship === "shipped" || ship === "delivered") return false;
    return true;
  });
  const unshippedForBanner = unshippedOrders.map(inv => ({
    id: inv.id,
    customer: inv.customer || "—",
    date: inv.date || (inv.sharedAt ? new Date(inv.sharedAt).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : ""),
    total: inv.total || 0,
    itemCount: Array.isArray(inv.items) ? inv.items.reduce((s,i)=>s+(Number(i.qty)||0),0) : 0,
    _raw: inv,
  }));

  // Realtime — pull portal_orders into SHARED_INVOICES as dealers place new
  // orders on other devices. Without this, the admin banner + badge wait
  // until a manual refresh. Enabled by 0011 migration's publication add.
  useEffect(()=>{
    const mergeDbRow = (o) => {
      if(!o) return;
      const oId = o.invoice_ref || o.invoice_id || o.order_ref || o.order_id || String(o.id);
      const oOrderId = o.order_ref || o.order_id || String(o.id);
      const existing = SHARED_INVOICES.getAll();
      const hasId = existing.some(i => i.id === oId || i.orderId === oOrderId || i.id === String(o.id));
      if(hasId) {
        // Existing invoice — sync shipping fields forward so admin banner
        // reflects whatever changed on another device.
        const inv = existing.find(i => i.id === oId || i.orderId === oOrderId || i.id === String(o.id));
        if(inv) {
          const patch = {};
          if(o.tracking != null && o.tracking !== inv.tracking) patch.tracking = o.tracking;
          if(o.carrier != null && o.carrier !== inv.carrier) patch.carrier = o.carrier;
          if(o.shipping_status != null && o.shipping_status !== inv.shippingStatus) patch.shippingStatus = o.shipping_status;
          if(o.shipped_date != null && o.shipped_date !== inv.shippedDate) patch.shippedDate = o.shipped_date;
          if(o.delivered_date != null && o.delivered_date !== inv.deliveredDate) patch.deliveredDate = o.delivered_date;
          if(o.delivered_by_rep != null && o.delivered_by_rep !== inv.deliveredByRep) patch.deliveredByRep = o.delivered_by_rep;
          if(o.delivery_method != null && o.delivery_method !== inv.deliveryMethod) patch.deliveryMethod = o.delivery_method;
          if(Object.keys(patch).length > 0) SHARED_INVOICES.updateShipping(inv.id, patch);
        }
        // Forward-only cancel propagation (another admin voided this order).
        SHARED_INVOICES.applyServerState(o);
        return;
      }
      // New invoice — add it so the unshipped banner picks it up live.
      let items = [];
      try { items = typeof o.items === "string" ? JSON.parse(o.items) : (o.items || []); } catch(e) {}
      SHARED_INVOICES.add({
        id: oId, orderId: oOrderId,
        date: o.created_at ? new Date(o.created_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
        customer: o.customer || "Customer",
        items,
        total: o.total || 0,
        status: o.status || "outstanding",
        paymentTerms: o.payment_terms || "",
        rep: o.rep || "",
        source: o.source || "portal_order",
        fromDb: true,
        shippingStatus: o.shipping_status || "pending",
        tracking: o.tracking || "",
        carrier: o.carrier || "",
        shippedDate: o.shipped_date || "",
        deliveredDate: o.delivered_date || "",
        deliveryMethod: o.delivery_method || "",
        deliveredByRep: o.delivered_by_rep || "",
        // Account discount (0034): {} for a row without one, so older invoices are exactly as before.
        ...invoiceDiscountFields(o),
      });
    };
    const unsub = subscribePortalOrders(({ eventType, new: newRow, old: oldRow }) => {
      if(eventType === 'INSERT' || eventType === 'UPDATE') mergeDbRow(newRow);
      // DELETE left as no-op — portal_orders deletions are rare and admin
      // gets a full refresh on next mount anyway.
    });
    return unsub;
  },[]);

  // Fire payment reminders for any outstanding Net invoice whose due date is
  // tomorrow and fire overdue alerts to admin for invoices past due. Runs
  // whenever accounts hydrate from Supabase. Dedup is now cross-device via
  // public.admin_alert_log (migration 0024) — no matter how many admin
  // browsers or devices exist, each invoice's overdue email fires exactly
  // once GLOBALLY. The backfill runs once per admin mount to migrate any
  // pre-migration localStorage dedupe entries into the Supabase log so a
  // brand-new admin browser doesn't re-send everything.
  useEffect(()=>{
    if(!accounts || accounts.length===0) return;
    const adminEmail = user?.email || "";
    (async () => {
      const all = SHARED_INVOICES.getAll();
      // Backfill first so the sends below correctly see pre-migration
      // dedupe entries + the grace-seed for currently-outstanding overdue
      // invoices. Both operations are idempotent (upsert with
      // ignoreDuplicates), so re-running on every mount is safe.
      await backfillAdminAlertLog(all, adminEmail);
      const resolveAccount = (inv)=>accounts.find(a=>a.company===inv.customer || a.contact===inv.customer) || null;
      await sendDueTomorrowReminders(all, (inv)=>resolveAccount(inv)?.email || "", adminEmail);
      await sendOverdueAdminAlerts(all, resolveAccount, adminEmail);
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[accounts]);

  // Company / invoice settings — persisted to localStorage
  // Migrates older saved records forward so any new wire/check fields added
  // here (bankAccountName, bankSwift, wireNote, checkPayee, checkAddress)
  // have sensible defaults on first render after deploy.
  const [companyInfo,setCompanyInfo]=useState(()=>{
    const defaults = {
      name:"MotorPower Care Inc.",address:"1234 Commerce Blvd, Suite 200",
      city:"San Diego",state:"CA",zip:"92101",
      email:"info@mpcare.com",phone:"(619) 555-0100",website:"www.mpcare.com",
      taxId:"82-4567890",logo:"",
      invoicePrefix:"INV",invoiceNotes:"Thank you for your business!",
      bankName:"",bankRouting:"",bankAccount:"",
      bankAccountName:"MotorPower Care Inc.",bankSwift:"",bankAddress:"",
      wireNote:"Email info@mpcare.com if you need the account number to complete your wire.",
      checkPayee:"MotorPower Care Inc.",
      checkAddress:"1234 Commerce Blvd, Suite 200\nSan Diego, CA 92101",
      paypalEmail:"",zelleEmail:""
    };
    try{
      const s=localStorage.getItem("mpcare_company_info");
      if(s){
        const saved=JSON.parse(s);
        return {...defaults, ...saved};
      }
    }catch(e){
      console.warn("[AdminPanel] Failed to read companyInfo from localStorage:", e?.message||e);
    }
    return defaults;
  });
  // Shipping config — synced via SHARED_SETTINGS, with portal_products.settings.shipping
  // JSONB as the cross-device authoritative store (see PR-B).
  const [shippingCfg,setShippingCfg]=useState(()=>SHARED_SETTINGS.getShipping());

  // Cloud-sync state for the shipping Save flow. `shippingBusy` gates the
  // Save/Retry buttons while a Supabase write is in flight; `shippingSyncError`
  // drives the amber banner above the Save button when the cloud write
  // failed. Retry is idempotent — savePortalSettings is an UPDATE on
  // portal_products id=1 with deterministic columns; re-calling is safe.
  const [shippingSyncError, setShippingSyncError] = useState("");
  const [shippingBusy, setShippingBusy] = useState(false);

  // On mount, hydrate shipping from Supabase (portal_products.settings.shipping
  // JSONB). The state above initializes from SHARED_SETTINGS (localStorage)
  // so first render is instant; this effect catches up to cross-device truth
  // as soon as the network responds. Per PR-B Decision-2: hydrate wins over
  // the local draft — admin's uncommitted edits from a previous session are
  // discarded in favour of the Supabase row. Fixes the "typing looks saved
  // but isn't" mental-model bug the same way PR-A did for companyInfo.
  useEffect(() => {
    let mounted = true;
    getPortalSettings().then(s => {
      if (!mounted) return;
      if (s && s.shipping && typeof s.shipping === 'object') {
        SHARED_SETTINGS.setShipping(s.shipping);
        setShippingCfg(SHARED_SETTINGS.getShipping());
      }
    }).catch(e => console.warn("[AdminPanel] shipping hydrate failed:", e?.message || e));
    return () => { mounted = false; };
  }, []);

  // Supabase-first commit for shipping. Called by the Save button and by
  // the banner's Retry button. Returns true on success, false on failure
  // (amber banner is set in the failure path so callers don't duplicate
  // that wiring).
  //
  // Re-fetches the current portal_products.settings row immediately before
  // the write to avoid clobbering fields another editor (companyInfo, Terms,
  // tier descriptions) may have updated on another device since this tab
  // loaded — per CLAUDE.md §READ-THIS-FIRST #3 "No writes that include stale
  // in-memory state". Only the shipping sub-object is replaced; other keys
  // on settings pass through untouched.
  const saveShippingToCloud = async () => {
    if (shippingBusy) return false;
    setShippingBusy(true);
    setShippingSyncError("");
    try {
      const current = await getPortalSettings();
      const next = { ...(current || {}), shipping: shippingCfg };
      const res = await savePortalSettings(next);
      if (!res) {
        setShippingSyncError("sync-failed");
        return false;
      }
      // Success mirror — SHARED_SETTINGS.setShipping broadcasts to every
      // reader (admin preview, customer checkout, customer dashboard) and
      // persists the cache in mpcare_shared_settings localStorage for the
      // next cold boot.
      try { SHARED_SETTINGS.setShipping(shippingCfg); }
      catch(e) { console.warn("[AdminPanel] SHARED_SETTINGS.setShipping mirror failed:", e?.message || e); }
      return true;
    } catch (e) {
      console.warn("[AdminPanel] saveShippingToCloud threw:", e?.message || e);
      setShippingSyncError("sync-failed");
      return false;
    } finally {
      setShippingBusy(false);
    }
  };

  // Cloud-sync state for the companyInfo Save flow. `companyInfoBusy` gates
  // the Save/Retry buttons while a Supabase write is in flight;
  // `companyInfoSyncError` drives the amber banner shown next to each Save
  // button when the cloud write failed (network, RLS, etc). Retry is
  // idempotent — savePortalSettings is an UPDATE on portal_products id=1
  // with deterministic columns; re-calling it is safe.
  const [companyInfoSyncError, setCompanyInfoSyncError] = useState("");
  const [companyInfoBusy, setCompanyInfoBusy] = useState(false);

  // On mount, hydrate companyInfo from Supabase (portal_products.settings
  // JSONB). The state above initializes from localStorage so first render
  // is instant; this effect catches up to cross-device truth as soon as
  // the network responds. Per PR-A Decision-2: hydrate wins over local
  // draft — if admin had uncommitted edits from a previous session (i.e.
  // they typed but never clicked Save), those values are discarded here
  // in favour of the Supabase row. This fixes the "typing looks saved
  // but isn't" mental-model bug.
  useEffect(() => {
    let mounted = true;
    getPortalSettings().then(s => {
      if (!mounted) return;
      if (s && s.companyInfo && typeof s.companyInfo === 'object') {
        setCompanyInfo(prev => ({ ...prev, ...s.companyInfo }));
      }
    }).catch(e => console.warn("[AdminPanel] companyInfo hydrate failed:", e?.message || e));
    return () => { mounted = false; };
  }, []);

  // Supabase-first commit for companyInfo. Called by both Save buttons and
  // by the banner's Retry button. Returns true on success, false on
  // failure (amber banner is set in the failure path so callers don't have
  // to duplicate that wiring).
  //
  // Re-fetches the current portal_products.settings row immediately before
  // the write to avoid clobbering any fields another editor (Terms,
  // tier descriptions, etc.) may have updated on another device since
  // this tab loaded — per CLAUDE.md §READ-THIS-FIRST #3 "No writes that
  // include stale in-memory state". Only the companyInfo sub-object is
  // replaced; all other keys on settings pass through untouched.
  const saveCompanyInfoToCloud = async () => {
    if (companyInfoBusy) return false;
    setCompanyInfoBusy(true);
    setCompanyInfoSyncError("");
    try {
      const current = await getPortalSettings();
      const next = { ...(current || {}), companyInfo };
      const res = await savePortalSettings(next);
      if (!res) {
        setCompanyInfoSyncError("sync-failed");
        return false;
      }
      // Success mirror — writes the same localStorage key the rest of the
      // app reads. Rep / customer portals see it after their next mount.
      try { localStorage.setItem("mpcare_company_info", JSON.stringify(companyInfo)); }
      catch(e) { console.warn("[AdminPanel] companyInfo localStorage mirror failed:", e?.message || e); }
      return true;
    } catch (e) {
      console.warn("[AdminPanel] saveCompanyInfoToCloud threw:", e?.message || e);
      setCompanyInfoSyncError("sync-failed");
      return false;
    } finally {
      setCompanyInfoBusy(false);
    }
  };

  // Draft-only auto-save: localStorage write on every companyInfo change so
  // the admin's in-progress edits survive a tab refresh without requiring
  // a click on Save. Per PR-A Decision-1: this is a per-browser draft, NOT
  // a commit — Supabase sync happens only via saveCompanyInfoToCloud()
  // from the explicit Save buttons or the banner Retry. Catch logs per
  // CLAUDE.md §4 (no silent catches).
  useEffect(()=>{
    try { localStorage.setItem("mpcare_company_info",JSON.stringify(companyInfo)); }
    catch(e) { console.warn("[AdminPanel] companyInfo draft autosave failed:", e?.message || e); }
  },[companyInfo]);
  const navItems=[
    {key:"accounts",label:"Accounts"},{key:"orders",label:"All orders"},
    {key:"products",label:"Products"},{key:"reps",label:"Sales reps"},
    {key:"commission",label:"Commission"},
    {key:"repinventory",label:"Rep inventory"},
    {key:"training",label:"Training hub"},{key:"marketing",label:"Marketing materials"},
    {key:"tools",label:"Tool lending"},
    {key:"broadcasts",label:"Broadcasts"},
    {key:"notifications",label:"Notifications"},
    {key:"certification",label:"Certification"},
    {key:"settings",label:"Settings"},
  ];
  const tabTitles={accounts:"Account management",orders:"All orders",products:"Product management",reps:"Sales reps",commission:"Commission payments",repinventory:"Rep inventory management",training:"Training hub",marketing:"Marketing materials",tools:"Tool lending program",broadcasts:"Broadcasts & campaigns",notifications:"Notifications & alerts",certification:"Certification program",settings:"Company, shipping & invoice settings"};

  // URL routing — sync tab to browser URL
  useEffect(()=>{
    const path = "/admin/" + tab;
    const qs = window.location.search;
    if(window.location.pathname !== path) window.history.pushState({page:tab}, "", path + qs);
  },[tab]);
  useEffect(()=>{
    const onPop = (e) => { if(e.state?.page) setTab(e.state.page); else setTab("accounts"); };
    window.addEventListener("popstate", onPop);
    const initPath = window.location.pathname.replace(/^\/admin\/?/,"") || "accounts";
    if(tabTitles[initPath]) setTab(initPath);
    return ()=>window.removeEventListener("popstate", onPop);
  },[]);

  return (
    <div style={{...S.app,display:"grid",gridTemplateColumns:"200px 1fr",minHeight:"100vh"}}>
      <div style={{background:"#1E293B",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"20px 16px 14px",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <img src="/mpc-logo.png" alt="MPC" style={{width:32,height:32,objectFit:"contain"}}/>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:C.white}}>MPC Admin</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",marginTop:1}}>Control panel</div>
            </div>
          </div>
        </div>
        <div style={{padding:"10px 0",flex:1}}>
          {navItems.map(n=>(
            <div key={n.key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 16px",fontSize:13,color:tab===n.key?"white":"rgba(255,255,255,0.6)",cursor:"pointer",background:tab===n.key?"rgba(255,255,255,0.09)":"transparent",borderLeft:`3px solid ${tab===n.key?"#60A5FA":"transparent"}`}} onClick={()=>setTab(n.key)}>
              <span>{n.label}</span>
              <span style={{display:"flex",gap:4,alignItems:"center"}}>
              {(n.key==="orders"||n.key==="notifications")&&pendingChangeReqCount>0&&<span title={`${pendingChangeReqCount} invoice change request${pendingChangeReqCount>1?"s":""} from reps waiting for approval`} style={{background:"#F59E0B",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{pendingChangeReqCount}</span>}
              {n.key==="accounts"&&pendingCustomers.length>0&&<span style={{background:"#EF4444",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{pendingCustomers.length}</span>}
              {n.key==="orders"&&unshippedOrders.length>0&&<span title={`${unshippedOrders.length} unshipped order${unshippedOrders.length>1?"s":""}`} style={{background:"#EF4444",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{unshippedOrders.length}</span>}
              {n.key==="orders"&&unshippedOrders.length===0&&overdueInvoices.length>0&&<span title={`${overdueInvoices.length} overdue invoice${overdueInvoices.length>1?"s":""}`} style={{background:"#EF4444",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{overdueInvoices.length}</span>}
              {n.key==="reps"&&pendingReps.length>0&&<span style={{background:"#EF4444",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{pendingReps.length}</span>}
              {n.key==="tools"&&toolAlerts>0&&<span style={{background:"#EF4444",color:"white",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:8}}>{toolAlerts}</span>}
              </span>
            </div>
          ))}
        </div>
        <div style={{padding:"14px 16px",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
          <button onClick={onExit} style={{background:"rgba(255,255,255,0.07)",border:"none",color:"rgba(255,255,255,0.6)",fontSize:12,padding:"7px 12px",borderRadius:6,cursor:"pointer",width:"100%",marginBottom:6}}>← Back to portal</button>
          <button onClick={onLogout||onExit} style={{background:"rgba(239,68,68,0.15)",border:"none",color:"#FCA5A5",fontSize:12,padding:"7px 12px",borderRadius:6,cursor:"pointer",width:"100%"}}>Sign out</button>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"column"}}>
        <div style={{background:C.white,borderBottom:`1px solid ${C.border}`,padding:"0 24px",height:52,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <span style={{fontSize:14,fontWeight:600,color:C.ink}}>{tabTitles[tab]}</span>
          <div style={{display:"flex",gap:8}}>
            {pending.length>0&&tab!=="accounts"&&pendingCustomers.length>0&&<div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:8,padding:"4px 12px",fontSize:12,color:C.amber,cursor:"pointer"}} onClick={()=>setTab("accounts")}>{pendingCustomers.length} account{pendingCustomers.length>1?"s":""} pending</div>}
            {pending.length>0&&tab!=="accounts"&&pendingReps.length>0&&<div style={{background:C.tealLight,border:`1px solid ${C.teal}`,borderRadius:8,padding:"4px 12px",fontSize:12,color:C.teal,cursor:"pointer"}} onClick={()=>setTab("reps")}>{pendingReps.length} rep{pendingReps.length>1?"s":""} pending</div>}
            {pendingChangeReqCount>0&&tab!=="orders"&&<div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:8,padding:"4px 12px",fontSize:12,color:C.amber,cursor:"pointer",fontWeight:600}} onClick={()=>setTab("orders")}>{pendingChangeReqCount} invoice change request{pendingChangeReqCount>1?"s":""}</div>}
            {overdueInvoices.length>0&&tab!=="orders"&&<div style={{background:"#FEE2E2",border:`1px solid #FCA5A5`,borderRadius:8,padding:"4px 12px",fontSize:12,color:"#B91C1C",cursor:"pointer",fontWeight:600}} onClick={()=>setTab("orders")}>{overdueInvoices.length} overdue · ${overdueTotal.toFixed(2)}</div>}
          </div>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:24}}>
          {/* Phase A — rep-customer assignment sync warning. Fires when the
              customer_settings write succeeded but the rep_route_customers
              mirror failed, so the rep's portal won't see the dealer until
              retry. Dismissible; re-save is the idempotent retry path. */}
          {assignSyncWarning && (
            <div style={{margin:"0 0 12px", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
              <div style={{flex:1}}>
                <strong>Assignment sync warning:</strong> {assignSyncWarning}
              </div>
              <button
                onClick={() => setAssignSyncWarning("")}
                style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:"pointer"}}
              >Dismiss</button>
            </div>
          )}
          {/* Confirmation after a successful Delete / Pause: the account moved to the archive. */}
          {lifecycleNotice && (
            <div style={{margin:"0 0 12px", padding:"10px 14px", background:C.greenLight, border:`1px solid ${C.green}`, borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:C.green}}>
              <div style={{flex:1}}>{lifecycleNotice}</div>
              <button onClick={openArchive} style={{marginLeft:12, background:"transparent", border:`1px solid ${C.green}`, color:C.green, fontSize:11, padding:"4px 10px", borderRadius:6, cursor:"pointer"}}>View Deleted &amp; paused accounts</button>
              <button onClick={()=>setLifecycleNotice("")} style={{marginLeft:8, background:"transparent", border:"none", color:C.green, fontSize:11, cursor:"pointer"}}>Dismiss</button>
            </div>
          )}
          {/* Global unshipped-orders banner — visible on every admin tab.
              Clicking a row jumps to the Orders tab with that invoice focused.
              Disappears automatically once every order is shipped. */}
          <UnshippedOrdersBanner
            unshipped={unshippedForBanner}
            onOpen={o => { setFocusInvoiceId(o._raw?.id || o.id); setTab("orders"); }}
          />
          {tab==="accounts"&&(
            <div>
              {loadingAccounts&&<div style={{textAlign:"center",padding:24,color:C.inkLight}}>Loading accounts from database...</div>}
              {/* Top-bar stat cards. "Total accounts" resets. Others filter
                  the list below by tier / credit / rep-assignment state. */}
              {(() => {
                const active = accounts.filter(a => a.role!=="rep" && a.tier!=="rep" && a.status!=="paused" && a.status!=="deleted");
                const cards = [
                  {l:"Active accounts",   v:active.length,                                                                     key:"all"},
                  {l:"Dealers",           v:active.filter(a=>(a.tier||"").toLowerCase()==="dealer").length,                    key:"dealer"},
                  {l:"Distributors",      v:active.filter(a=>(a.tier||"").toLowerCase()==="distributor").length,               key:"distributor"},
                  {l:"Enterprise",        v:active.filter(a=>(a.tier||"").toLowerCase()==="enterprise").length,                key:"enterprise"},
                  {l:"With credit",       v:active.filter(a=>(a.creditLimit||0)>0).length,                  teal:true,        key:"withCredit"},
                  // Display-only: a dealer whose assigned rep was deleted/paused counts as "no rep"
                  // here; customer_settings.rep itself is never rewritten.
                  {l:"No rep assigned",   v:active.filter(a=>!a.rep||dealerHasInactiveRep(a,inactiveRepStatuses)).length,   warn:active.some(a=>!a.rep||dealerHasInactiveRep(a,inactiveRepStatuses)), key:"unassigned"},
                ];
                return (
                  <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:12,marginBottom:16}}>
                    {cards.map(m=>{
                      const activeCard = acctListFilter===m.key && m.key!=="all";
                      const accent = m.warn ? C.amber : m.teal ? C.teal : C.blue;
                      return (
                        <div
                          key={m.l}
                          onClick={()=>setAcctListFilter(activeCard ? "all" : m.key)}
                          style={{
                            ...S.metric,
                            ...(m.warn?{borderTop:`3px solid ${C.amber}`}:m.teal?{borderTop:`3px solid ${C.teal}`}:{}),
                            cursor:"pointer",
                            boxShadow: activeCard ? `0 0 0 2px ${accent}` : undefined,
                            transition:"box-shadow 0.15s, transform 0.15s"
                          }}
                          onMouseEnter={e=>{ if(!activeCard) e.currentTarget.style.transform="translateY(-1px)"; }}
                          onMouseLeave={e=>{ e.currentTarget.style.transform="none"; }}
                        >
                          <div style={S.mLabel}>{m.l}</div>
                          <div style={S.mValue}>{m.v}</div>
                          {activeCard && <div style={{fontSize:10,color:accent,marginTop:4,fontWeight:600}}>Filtering list ↓</div>}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
              {pendingReps.length>0&&(
                <div style={{background:C.tealLight,border:`1px solid ${C.teal}`,borderRadius:12,padding:"14px 18px",marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:C.ink}}>{pendingReps.length} sales rep application{pendingReps.length>1?"s":""} pending review</div>
                    <div style={{fontSize:12,color:C.inkMid,marginTop:2}}>Review and approve in the Sales Reps tab</div>
                  </div>
                  <button onClick={()=>setTab("reps")} style={{...S.btnPrimary,background:C.teal,fontSize:12,padding:"8px 18px"}}>Go to Sales Reps →</button>
                </div>
              )}
              {pendingCustomers.length>0&&(
                <div style={{marginBottom:20}}>
                  <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>Pending account approval ({pendingCustomers.length})</div>
                  {pendingCustomers.map(ac=>(
                    <div key={ac.id} style={{background:C.white,border:`2px solid ${C.amber}`,borderRadius:12,padding:"16px 18px",marginBottom:10}}>
                      <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:16,alignItems:"start"}}>
                        <div>
                          <div style={{fontSize:14,fontWeight:600,color:C.ink,marginBottom:2}}>{ac.company&&ac.company!=="—"?ac.company:ac.email}</div>
                          <div style={{fontSize:12,color:C.inkMid,marginBottom:4}}>{ac.contact} · {ac.email} · Applied {ac.joined}</div>
                          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                            {ac.phone&&ac.phone!=="—"&&<span style={{fontSize:11,background:C.blueLight,color:"#1D4ED8",padding:"2px 8px",borderRadius:6}}>Phone: {ac.phone}</span>}
                            {ac.address&&ac.address!=="—"&&ac.address!=="Not provided"&&<span style={{fontSize:11,background:C.surface,color:C.inkMid,padding:"2px 8px",borderRadius:6,border:`1px solid ${C.border}`}}>{ac.address}</span>}
                            {ac.ein&&ac.ein!=="—"&&<span style={{fontSize:11,background:C.amberLight,color:C.amber,padding:"2px 8px",borderRadius:6}}>EIN: {ac.ein}</span>}
                            <span style={{fontSize:11,background:C.tealLight,color:C.teal,padding:"2px 8px",borderRadius:6}}>{ac.tier||"dealer"}</span>
                            {ac.role==="rep"&&<span style={{fontSize:11,background:C.purpleLight,color:C.purple,padding:"2px 8px",borderRadius:6}}>Sales Rep</span>}
                          </div>
                        </div>
                        <button onClick={()=>setReviewingAcct(reviewingAcct===ac.id?null:ac.id)} style={{...S.btnSecondary,fontSize:12,padding:"7px 14px"}}>{reviewingAcct===ac.id?"Hide details":"Review →"}</button>
                      </div>
                      {reviewingAcct===ac.id&&(
                        <div style={{marginTop:14,borderTop:`1px solid ${C.border}`,paddingTop:14}}>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                            <div style={{background:C.surface,borderRadius:8,padding:"12px 14px"}}>
                              <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Business information</div>
                              <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:4}}>{ac.company||"—"}</div>
                              <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>EIN: {ac.ein&&ac.ein!=="—"?ac.ein:"Not provided"}</div>
                              <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Tier: {ac.tier||"dealer"}</div>
                              <div style={{fontSize:12,color:C.inkMid}}>Address: {ac.address||"Not provided"}</div>
                            </div>
                            <div style={{background:C.surface,borderRadius:8,padding:"12px 14px"}}>
                              <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Contact details</div>
                              <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:4}}>{ac.contact||"—"}</div>
                              <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Email: {ac.email||"—"}</div>
                              <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Phone: {ac.phone||"Not provided"}</div>
                              <div style={{fontSize:12,color:C.inkMid,marginBottom:3}}>Sales rep: {ac.rep||"Not specified"}</div>
                              {ac.refCode&&<div style={{fontSize:11,fontFamily:"monospace",color:C.blue,marginTop:4}}>Ref: {ac.refCode}</div>}
                            </div>
                          </div>
                          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                            <button onClick={()=>{reject(ac.id);setReviewingAcct(null);}} style={{...S.btnSecondary,fontSize:12,padding:"8px 18px",color:C.red}}>Reject application</button>
                            <button onClick={()=>{approve(ac.id);setReviewingAcct(null);startEdit(ac);}} style={{...S.btnPrimary,fontSize:12,padding:"8px 18px"}}>Approve & configure →</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <span style={{fontSize:13,fontWeight:600,color:C.ink}}>All accounts ({filteredAccounts.length}{acctSearch?` of ${accounts.filter(a=>a.role!=="rep"&&a.tier!=="rep"&&a.status!=="paused"&&a.status!=="deleted").length}`:""})</span>
                <input style={{...S.input,width:260}} value={acctSearch} onChange={e=>setAcctSearch(e.target.value)} placeholder="Search by name, email, ref code..."/>
              </div>
              <div style={S.card}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 100px 90px 90px 80px 80px 110px 230px",gap:8,padding:"8px 16px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                  <span style={{cursor:"pointer"}} onClick={()=>sortBy("company")}>Company{sortArrow("company")}</span>
                  <span>Ref code</span>
                  <span style={{cursor:"pointer"}} onClick={()=>sortBy("tier")}>Tier{sortArrow("tier")}</span>
                  <span style={{cursor:"pointer"}} onClick={()=>sortBy("status")}>Status{sortArrow("status")}</span>
                  <span style={{cursor:"pointer"}} onClick={()=>sortBy("credit")}>Credit{sortArrow("credit")}</span>
                  <span>Discount</span><span>Terms</span><span></span>
                </div>
                {filteredAccounts.length===0 && acctSearch && (
                  <div style={{padding:"18px 16px",fontSize:12,color:C.inkLight,textAlign:"center"}}>
                    No dealers matched "<strong style={{color:C.ink}}>{acctSearch.trim()}</strong>".
                    {" "}Try the <button onClick={()=>setTab("reps")} style={{background:"none",border:"none",color:C.blue,cursor:"pointer",textDecoration:"underline",padding:0,fontSize:12}}>Sales Reps</button> tab if this is a rep code.
                  </div>
                )}
                {filteredAccounts.map(ac=>(
                  <div key={ac.id} style={{display:"grid",gridTemplateColumns:"1fr 100px 90px 90px 80px 80px 110px 230px",alignItems:"center",gap:8,padding:"11px 16px",borderBottom:`1px solid ${C.border}`,fontSize:12,cursor:"pointer",background:viewingAccount?.id===ac.id?C.blueLight:C.white}} onClick={()=>setViewingAccount(viewingAccount?.id===ac.id?null:ac)}>
                    <div>
                      <div style={{fontWeight:600,color:C.ink}}>{ac.company&&ac.company!=="—"?ac.company:ac.email}</div>
                      <div style={{fontSize:11,color:C.inkLight}}>{ac.contact}{ac.phone?" · "+ac.phone:""}{ac.address&&ac.address!=="—"?" · "+ac.address:""}</div>
                      {/* Show currently-assigned sales rep on each row so admin
                          doesn't have to open the Edit modal just to see it.
                          Authoritative source: customer_settings.rep, surfaced
                          on `ac.rep` by the accounts hydrate loader. */}
                      <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>
                        Sales rep: <strong style={{color:ac.rep?C.ink:C.red}}>{ac.rep||"Unassigned"}</strong>
                        {dealerHasInactiveRep(ac,inactiveRepStatuses)&&<span style={{...S.pillRed,marginLeft:6,fontSize:10}} title="This dealer's assigned rep was deleted or paused. Use Reassign to move the dealer to another rep.">{dealerInactiveRepStatus(ac,inactiveRepStatuses)==="paused"?"Rep paused":"Rep deleted"}</span>}
                      </div>
                    </div>
                    <span style={{fontSize:11,fontFamily:"monospace",color:ac.refCode?C.blue:C.inkLight}}>{ac.refCode||"—"}</span>
                    <span style={{...S.pillBlue}}>{ac.tier}</span>
                    <span style={ac.status==="approved"?S.pillGreen:ac.status==="pending"?S.pillAmber:ac.status==="paused"?S.pillBlue:S.pillRed}>{ac.status==="approved"?"Approved":ac.status==="pending"?"Pending":ac.status==="paused"?"Paused":ac.status==="deleted"?"Deleted":"Rejected"}</span>
                    <span style={{color:C.ink}}>${ac.creditLimit.toLocaleString()}</span>
                    <span style={(ac.discount||0)>0?{...S.pillGreen}:{color:C.inkLight}}>{(ac.discount||0)>0?`${ac.discount}% off`:"—"}</span>
                    <span style={{color:C.inkLight,fontSize:11}}>{(Array.isArray(ac.terms)?ac.terms:(_toTermsArray(ac.terms)||[])).join(", ")||"—"}</span>
                    <div style={{display:"flex",gap:4,justifyContent:"flex-end"}}>
                      <button
                        onClick={(e)=>{e.stopPropagation();openTransferRep(ac);}}
                        style={{...S.btnSmall,background:"transparent",color:C.blue,border:`1px solid ${C.blue}`}}
                        title="Reassign this dealer to a different sales rep"
                      >Reassign</button>
                      <button onClick={(e)=>{e.stopPropagation();startEdit(ac);}} style={S.btnSmall}>Edit</button>
                      {canOfferDelete(ac,user?.id)&&<>
                      {canOfferLifecycle(ac,user?.id)&&<button
                        onClick={(e)=>{e.stopPropagation();openSuspendModal(ac,"pause");}}
                        style={{...S.btnSmall,background:"transparent",color:C.amber,border:`1px solid ${C.amber}`}}
                        title="Temporarily block this account from logging in"
                      >Pause</button>}
                      <button
                        onClick={(e)=>{e.stopPropagation();openSuspendModal(ac,"delete");}}
                        style={{...S.btnSmall,background:"transparent",color:C.red,border:`1px solid ${C.red}`}}
                        title="Delete this account: removed from every admin list, login blocked, history kept, restorable"
                      >Delete</button>
                      </>}
                    </div>
                  </div>
                ))}
              </div>

              {/* ── ACCOUNT DETAIL PANEL ── */}
              {viewingAccount&&(()=>{
                const ac=accounts.find(a=>a.id===viewingAccount.id)||viewingAccount;
                const acctName=ac.company&&ac.company!=="—"?ac.company:ac.email;
                // Strict live-invoice derivation — no RECENT_ORDERS demo mixing —
                // so these per-account numbers tie out to the rep's Commission
                // page and the Admin Commission table. We still match on a
                // wider set of fields than computeCustomerMetrics (email, user
                // id, contact) because customer_name is less reliable for
                // accounts than for rep route customers.
                const sharedInvs=allInvoicesForAlerts.filter(i=>i.status!=="cancelled" && (i.customer===acctName||i.customer===ac.company||i.customer===ac.contact||i.customer===ac.email||(i.userId&&i.userId===ac.supabaseId)));
                const allInvoices=sharedInvs.slice().sort((a,b)=>new Date(b.date||0)-new Date(a.date||0));
                // Calculate sales by period
                const now=new Date();
                const oneWeekAgo=new Date(now.getTime()-7*24*60*60*1000);
                const oneMonthAgo=new Date(now.getFullYear(),now.getMonth()-1,now.getDate());
                const weekSales=allInvoices.filter(i=>new Date(i.date)>=oneWeekAgo).reduce((s,i)=>s+Number(i.total||i.amount||0),0);
                const monthSales=allInvoices.filter(i=>new Date(i.date)>=oneMonthAgo).reduce((s,i)=>s+Number(i.total||i.amount||0),0);
                const yearSales=allInvoices.reduce((s,i)=>s+Number(i.total||i.amount||0),0);
                const paidCount=allInvoices.filter(i=>i.status==="paid"||i.status==="done").length;
                const pendingCount=allInvoices.filter(i=>i.status==="pending").length;
                return (
                <div style={{marginTop:16,background:C.white,border:`1px solid ${C.border}`,borderRadius:12,overflow:"hidden"}}>
                  {/* Header */}
                  <div style={{background:"linear-gradient(135deg,#0B1F3A 0%,#1560BD 100%)",padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontSize:18,fontWeight:700,color:C.white}}>{acctName}</div>
                      <div style={{fontSize:12,color:"rgba(255,255,255,0.7)",marginTop:3}}>{ac.contact} · {ac.email}{ac.phone?" · "+ac.phone:""} · {ac.tier} · Joined {ac.joined}</div>
                      {ac.address&&ac.address!=="—"&&<div style={{fontSize:11,color:"rgba(255,255,255,0.5)",marginTop:2}}>📍 {ac.address}</div>}
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      {isEligibleDealerAccount(ac)&&<button onClick={()=>openCreateInvoice(ac.supabaseId)} style={{background:"rgba(134,239,172,0.2)",border:"1px solid rgba(134,239,172,0.5)",color:"#DCFCE7",padding:"7px 16px",borderRadius:7,fontSize:12,cursor:"pointer",fontWeight:600}} title="Create an invoice for this dealer (their discount rate is applied)">Create invoice</button>}
                      <button onClick={()=>{startEdit(ac);}} style={{background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.25)",color:C.white,padding:"7px 16px",borderRadius:7,fontSize:12,cursor:"pointer",fontWeight:500}}>Edit account</button>
                      {canOfferLifecycle(ac,user?.id)&&<button onClick={()=>openSuspendModal(ac,"pause")} style={{background:"rgba(251,191,36,0.2)",border:"1px solid rgba(251,191,36,0.45)",color:"#FDE68A",padding:"7px 14px",borderRadius:7,fontSize:12,cursor:"pointer",fontWeight:500}} title="Temporarily block this account from logging in">Pause</button>}
                      {canOfferDelete(ac,user?.id)&&<button onClick={()=>openSuspendModal(ac,"delete")} style={{background:"rgba(248,113,113,0.2)",border:"1px solid rgba(248,113,113,0.45)",color:"#FECACA",padding:"7px 14px",borderRadius:7,fontSize:12,cursor:"pointer",fontWeight:500}} title="Permanently remove this account from active lists (history preserved)">Delete</button>}
                      <button onClick={()=>setViewingAccount(null)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:22,cursor:"pointer",lineHeight:1}}>×</button>
                    </div>
                  </div>
                  {/* Contact details */}
                  <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,padding:"16px 24px 0"}}>
                    {[["Contact",ac.contact||"—"],["Email",ac.email||"—"],["Phone",ac.phone||"—"],["Address",ac.address&&ac.address!=="—"?ac.address:"—"]].map(([label,val])=>(
                      <div key={label} style={{fontSize:12}}>
                        <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{label}</div>
                        <div style={{color:C.ink,fontWeight:500}}>{val}</div>
                      </div>
                    ))}
                  </div>
                  {/* Sales summary cards */}
                  <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,padding:"16px 24px"}}>
                    <div style={{background:C.surface,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>This week</div>
                      <div style={{fontSize:20,fontWeight:700,color:C.blue}}>${weekSales.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
                    </div>
                    <div style={{background:C.surface,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>This month</div>
                      <div style={{fontSize:20,fontWeight:700,color:C.teal}}>${monthSales.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
                    </div>
                    <div style={{background:C.surface,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>Year to date</div>
                      <div style={{fontSize:20,fontWeight:700,color:C.navy}}>${yearSales.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
                    </div>
                    <div style={{background:C.greenLight,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.green,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>Paid</div>
                      <div style={{fontSize:20,fontWeight:700,color:C.green}}>{paidCount}</div>
                    </div>
                    <div style={{background:C.amberLight,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:10,fontWeight:600,color:C.amber,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>Pending</div>
                      <div style={{fontSize:20,fontWeight:700,color:C.amber}}>{pendingCount}</div>
                    </div>
                  </div>
                  {/* Invoices table */}
                  <div style={{padding:"0 24px 20px"}}>
                    <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:10}}>All invoices ({allInvoices.length})</div>
                    {allInvoices.length===0?(
                      <div style={{background:C.surface,borderRadius:10,padding:"24px",textAlign:"center",color:C.inkLight,fontSize:13}}>No invoices found for this account.</div>
                    ):(
                      <div style={{border:`1px solid ${C.border}`,borderRadius:10,overflow:"hidden"}}>
                        <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 90px 70px 90px 50px",gap:8,padding:"9px 16px",fontSize:11,fontWeight:600,color:C.inkLight,background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                          <span>Invoice</span><span>Date</span><span>Items</span><span style={{textAlign:"right"}}>Amount</span><span>Status</span><span>Via</span><span></span>
                        </div>
                        {allInvoices.map(inv=>(
                          <div key={inv.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 90px 70px 90px 50px",gap:8,padding:"10px 16px",fontSize:12,borderBottom:`1px solid ${C.border}`,alignItems:"center"}}>
                            <span style={{fontWeight:600,color:C.blue,fontFamily:"monospace"}}>{inv.id}</span>
                            <span style={{color:C.inkLight}}>{inv.date}</span>
                            <span style={{color:C.inkMid,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{Array.isArray(inv.items)?inv.items.map(i=>`[${i.sku}] ${i.name} ×${i.qty}`).join(", "):inv.items||"—"}</span>
                            <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${Number(inv.total||inv.amount||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                            <InvoicePill inv={inv}/>
                            <span style={{color:C.inkLight,fontSize:11}}>{inv.sent==="email"?"Email":inv.sent==="print"?"Print":inv.sent==="order"?"Portal order":inv.repCreated?"Field rep":inv.source==="admin_invoice"?"Office":"—"}</span>
                            <button style={S.btnSmall} onClick={()=>setAdminViewInvoice(inv)}>View</button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                );
              })()}

              {/* ── SUSPENDED & DELETED ACCOUNTS ──
                  Customers and sales reps that have been paused or deleted live here
                  with their full history, the reason captured at the time of action,
                  and a Restore button. They cannot log in (profiles.approved=false
                  syncs to Supabase) and see "Contact MotorPower Care" instead. */}
              {suspendedAccounts.length>0&&(
                <div id="mpcare-deleted-archive" style={{marginTop:28}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,cursor:"pointer"}} onClick={()=>setArchiveOpenPref(!showArchive)}>
                    <span style={{fontSize:13,fontWeight:600,color:C.ink}}>{showArchive?"▼":"▶"} Deleted &amp; paused accounts ({suspendedAccounts.length})</span>
                    <span style={{fontSize:11,color:C.inkLight}}>Admin-only archive. Reps and dealers removed from every list live here with their reason; Restore brings them back. History is never removed.</span>
                  </div>
                  {showArchive&&archiveError&&(
                    <div style={{margin:"0 0 10px",padding:"10px 14px",background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:8,fontSize:12,color:"#991B1B",display:"flex",justifyContent:"space-between",gap:12}}>
                      <span>{archiveError}</span>
                      <button onClick={()=>setArchiveError("")} style={{background:"transparent",border:"none",color:"#991B1B",cursor:"pointer",fontSize:12}}>Dismiss</button>
                    </div>
                  )}
                  {showArchive&&<div style={S.card}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 90px 150px 110px 1fr 130px",gap:8,padding:"8px 16px",fontSize:11,fontWeight:600,color:C.inkLight,borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                      <span>Account</span><span>Kind</span><span>Status</span><span>Date</span><span>Reason</span><span></span>
                    </div>
                    {suspendedAccounts.map(ac=>{
                      const isRep = ac.role==="rep"||ac.tier==="rep";
                      const when = ac.status==="deleted"?ac.deleted_at:ac.paused_at;
                      const reason = ac.status==="deleted"?ac.deletion_reason:ac.paused_reason;
                      const acctName = ac.company&&ac.company!=="—"?ac.company:(ac.contact||ac.email);
                      const isExpanded = viewingSuspendedId===ac.id;
                      // Same live-invoice derivation we use for active accounts so history ties
                      // out to the rep's Commission page and the Admin Commission table.
                      const acctInvs = isExpanded ? allInvoicesForAlerts.filter(i=>i.status!=="cancelled" && (
                        i.customer===acctName||i.customer===ac.company||i.customer===ac.contact||i.customer===ac.email||
                        (i.userId&&i.userId===ac.supabaseId) || (isRep && i.rep===ac.contact)
                      )).sort((a,b)=>new Date(b.date||0)-new Date(a.date||0)) : [];
                      return (
                        <div key={ac.id} style={{borderBottom:`1px solid ${C.border}`,fontSize:12,background:C.white}}>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 90px 150px 110px 1fr 130px",alignItems:"center",gap:8,padding:"11px 16px",cursor:"pointer"}} onClick={()=>setViewingSuspendedId(isExpanded?null:ac.id)}>
                            <div>
                              <div style={{fontWeight:600,color:C.ink}}>{acctName}</div>
                              <div style={{fontSize:11,color:C.inkLight}}>{ac.contact}{ac.email?" · "+ac.email:""}{ac.phone&&ac.phone!=="—"?" · "+ac.phone:""}</div>
                            </div>
                            <span style={isRep?S.pillPurple:S.pillBlue}>{isRep?"Sales rep":"Customer"}</span>
                            <span style={ac.status==="deleted"?S.pillRed:S.pillAmber} title={archivePrior(ac)?("Deleted applicant (was "+archivePrior(ac)+")"):undefined}>{ac.status==="deleted"?(archivePrior(ac)?"Deleted applicant (was "+archivePrior(ac)+")":"Deleted"):"Paused"}</span>
                            <span style={{color:C.inkLight,fontSize:11}}>{when?new Date(when).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):"—"}</span>
                            <span style={{color:C.inkMid,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={reason||""}>{reason||<em style={{color:C.inkLight}}>No reason recorded</em>}</span>
                            <button disabled={restoreBusyId===ac.id} onClick={(e)=>{e.stopPropagation();restoreAccount(ac);}} style={{...S.btnSmall,background:C.greenLight,color:C.green,border:`1px solid ${C.green}`,opacity:restoreBusyId===ac.id?0.5:1}}>{restoreBusyId===ac.id?"Restoring…":("Restore"+(archivePrior(ac)?" as "+archivePrior(ac):""))}</button>
                          </div>
                          {isExpanded&&(
                            <div style={{background:C.surface,padding:"14px 20px",borderTop:`1px solid ${C.border}`}}>
                              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
                                {[["Contact",ac.contact||"—"],["Email",ac.email||"—"],["Phone",ac.phone||"—"],["Tier",ac.tier||"—"]].map(([l,v])=>(
                                  <div key={l} style={{fontSize:12}}>
                                    <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{l}</div>
                                    <div style={{color:C.ink,fontWeight:500}}>{v}</div>
                                  </div>
                                ))}
                              </div>
                              <div style={{background:ac.status==="deleted"?"#FEF2F2":C.amberLight,border:`1px solid ${ac.status==="deleted"?"#FCA5A5":"#FCD34D"}`,borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12,color:C.ink}}>
                                <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:4}}>Reason for {ac.status==="deleted"?"deletion":"pause"}</div>
                                <div>{reason||"No reason recorded"}</div>
                                {when&&<div style={{fontSize:11,color:C.inkLight,marginTop:4}}>On {new Date(when).toLocaleString()}</div>}
                              </div>
                              <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:8}}>Invoice history ({acctInvs.length})</div>
                              {acctInvs.length===0?(
                                <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:8,padding:"14px",textAlign:"center",color:C.inkLight,fontSize:12}}>No invoices on record.</div>
                              ):(
                                <div style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",background:C.white,maxHeight:260,overflowY:"auto"}}>
                                  <div style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 90px 70px",gap:8,padding:"8px 14px",fontSize:11,fontWeight:600,color:C.inkLight,background:C.surface,borderBottom:`1px solid ${C.border}`}}>
                                    <span>Invoice</span><span>Date</span><span>Items</span><span style={{textAlign:"right"}}>Amount</span><span>Status</span>
                                  </div>
                                  {acctInvs.map(inv=>(
                                    <div key={inv.id} style={{display:"grid",gridTemplateColumns:"100px 90px 1fr 90px 70px",gap:8,padding:"8px 14px",fontSize:12,borderBottom:`1px solid ${C.border}`,alignItems:"center"}}>
                                      <span style={{fontWeight:600,color:C.blue,fontFamily:"monospace"}}>{inv.id}</span>
                                      <span style={{color:C.inkLight}}>{inv.date}</span>
                                      <span style={{color:C.inkMid,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{Array.isArray(inv.items)?inv.items.map(i=>`[${i.sku}] ${i.name} ×${i.qty}`).join(", "):inv.items||"—"}</span>
                                      <span style={{fontWeight:600,color:C.ink,textAlign:"right"}}>${Number(inv.total||inv.amount||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                                      <InvoicePill inv={inv}/>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>}
                </div>
              )}
            </div>
          )}

          {/* ADMIN INVOICE VIEWER */}
          {adminViewInvoice&&<AdminInvoiceModal inv={adminViewInvoice} onClose={()=>setAdminViewInvoice(null)} onStatusChange={()=>{/* useAdminVisibleInvoices subscribes to SHARED_INVOICES */}}/>}

          {/* ADMIN CREATE INVOICE (mounted once; opened from the Orders tab and from a dealer's account panel) */}
          {createInvoiceFor&&<AdminCreateInvoiceModal
            accounts={accounts}
            repOptions={liveReps.filter(r=>r&&r.id&&r.name&&r.name!=="—").map(r=>({id:r.id,name:r.name,email:r.email}))}
            termsList={ALL_TERMS}
            catalogReady={catalogLoaded&&!catalogLoadError}
            getCatalog={()=>({products:SHARED_PRODUCTS.getActive(),kits:SHARED_PRODUCTS.getActiveKits()})}
            initialAccountId={createInvoiceFor.accountId}
            nudge={createInvoiceNudge}
            getMpc={getMpcInfo}
            getOutstanding={(dealerId,company)=>SHARED_INVOICES.getAll().filter(i=>i&&i.status!=="paid"&&i.status!=="done"&&i.status!=="cancelled"&&(i.userId===dealerId||i.customer===company)).reduce((s,i)=>s+(Number(i.total)||0),0)}
            onClose={()=>setCreateInvoiceFor(null)}
            onViewInvoice={(inv)=>setAdminViewInvoice(inv)}
            onOpenInOrders={(id)=>{setFocusInvoiceId(id);setTab("orders");}}
          />}

          {/* EDIT MODAL */}
          {editingId&&editData&&(
            <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
              <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:560,maxHeight:"85vh",overflowY:"auto"}}>
                <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Configure account</div>
                <div style={{fontSize:13,color:C.inkLight,marginBottom:4}}>{editData.company}</div>
                {editData.refCode&&<div style={{fontSize:12,fontFamily:"monospace",color:C.blue,background:C.blueLight,display:"inline-block",padding:"3px 10px",borderRadius:6,marginBottom:12}}>Ref: {editData.refCode}</div>}

                {/* Company details — editable */}
                <div style={{background:C.surface,borderRadius:8,padding:"14px 16px",marginBottom:16}}>
                  <div style={{fontSize:11,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>Company information</div>
                  <div style={S.twoCol}>
                    <div style={S.fg}><label style={S.label}>Company / Shop name *</label><input style={S.input} value={editData.company||""} onChange={e=>setEditData(d=>({...d,company:e.target.value}))}/></div>
                    <div style={S.fg}><label style={S.label}>EIN</label><input style={S.input} value={editData.ein||""} onChange={e=>setEditData(d=>({...d,ein:e.target.value}))} placeholder="XX-XXXXXXX"/></div>
                  </div>
                  <div style={S.twoCol}>
                    <div style={S.fg}><label style={S.label}>Contact name</label><input style={S.input} value={editData.contact||""} onChange={e=>setEditData(d=>({...d,contact:e.target.value}))}/></div>
                    <div style={S.fg}><label style={S.label}>Email</label><input style={S.input} value={editData.email||""} onChange={e=>setEditData(d=>({...d,email:e.target.value}))}/></div>
                  </div>
                  <div style={S.twoCol}>
                    <div style={S.fg}><label style={S.label}>Phone</label><input style={S.input} value={editData.phone||""} onChange={e=>setEditData(d=>({...d,phone:e.target.value}))} placeholder="(619) 555-0100"/></div>
                    <div style={S.fg}><label style={S.label}>Address</label><input style={S.input} value={editData.address||""} onChange={e=>setEditData(d=>({...d,address:e.target.value}))} placeholder="Street, City, State ZIP"/></div>
                  </div>
                  <div style={{fontSize:11,color:C.inkLight,marginTop:2}}>Joined: {editData.joined}</div>
                </div>
                <div style={S.twoCol}>
                  <div style={S.fg}><label style={S.label}>Account tier</label>
                    <select style={S.select} value={editData.tier} onChange={e=>setEditData(d=>({...d,tier:e.target.value}))}>
                      <option value="dealer">Dealer</option><option value="distributor">Distributor</option><option value="enterprise">Enterprise</option>
                    </select>
                  </div>
                  <div style={S.fg}><label style={S.label}>Status</label>
                    <select style={S.select} value={editData.status} onChange={e=>setEditData(d=>({...d,status:e.target.value}))}>
                      <option value="approved">Approved</option><option value="pending">Pending</option><option value="rejected">Rejected</option>
                    </select>
                  </div>
                </div>
                <div style={S.twoCol}>
                  <div style={S.fg}><label style={S.label}>Credit limit ($)</label><input style={S.input} type="number" value={editData.creditLimit} onChange={e=>setEditData(d=>({...d,creditLimit:parseInt(e.target.value)||0}))}/></div>
                  <div style={{...S.fg,position:"relative"}}><label style={S.label}>Assigned rep</label>
                    <div style={{position:"relative"}}>
                      <input style={S.input} value={repSearchOpen?repSearchQ:(editData.rep||"")} placeholder="Search or select a rep…"
                        onFocus={()=>{setRepSearchOpen(true);setRepSearchQ(editData.rep||"");}}
                        onChange={e=>{setRepSearchQ(e.target.value);setRepSearchOpen(true);}}
                        onBlur={()=>setTimeout(()=>setRepSearchOpen(false),200)}
                      />
                      {editData.rep&&!repSearchOpen&&<span style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",cursor:"pointer",fontSize:14,color:C.inkLight,padding:"2px 6px"}} onClick={()=>{setEditData(d=>({...d,rep:""}));setRepSearchQ("");setRepSearchOpen(false);}}>✕</span>}
                    </div>
                    {repSearchOpen&&(()=>{
                      const q=repSearchQ.toLowerCase();
                      const filtered=repList.filter(r=>!q||r.name.toLowerCase().includes(q)||r.email?.toLowerCase().includes(q)||(r.territory||"").toLowerCase().includes(q));
                      return <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:999,background:"#fff",border:`1px solid ${C.border}`,borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",maxHeight:220,overflowY:"auto",marginTop:2}}>
                        <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",fontSize:13,color:C.inkLight}} onClick={()=>{setEditData(d=>({...d,rep:""}));setRepSearchOpen(false);setRepSearchQ("");}}>
                          <em>Unassigned</em>
                        </div>
                        {filtered.length===0&&<div style={{padding:"12px",fontSize:12,color:C.inkLight,textAlign:"center"}}>No reps found</div>}
                        {filtered.map(r=><div key={r.id} style={{padding:"8px 12px",cursor:"pointer",borderBottom:`1px solid ${C.bg}`,transition:"background 0.1s"}}
                          onMouseEnter={e=>e.currentTarget.style.background=C.blueLight}
                          onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                          onClick={()=>{setEditData(d=>({...d,rep:r.name}));setRepSearchOpen(false);setRepSearchQ("");}}>
                          <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{r.name}</div>
                          <div style={{fontSize:11,color:C.inkLight}}>{r.email}{r.territory?` · ${r.territory}`:""}</div>
                        </div>)}
                      </div>;
                    })()}
                  </div>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Special discount % (optional — 0 = no discount)</label>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <input style={{...S.input,width:80}} type="number" min="0" max="50" value={editData.discount||0} onChange={e=>setEditData(d=>({...d,discount:parseInt(e.target.value)||0}))}/>
                    <span style={{fontSize:12,color:C.inkLight}}>% off all orders</span>
                    {(editData.discount||0)>0&&<span style={{...S.pillGreen}}>{editData.discount}% discount active</span>}
                  </div>
                  <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>Set for VIP accounts, large distributors, or special agreements. Shows automatically on all invoices and checkout.</div>
                </div>
                <div style={{marginBottom:16}}>
                  <label style={{...S.label,marginBottom:8}}>Payment terms for this account</label>
                  <div style={{background:C.blueLight,borderRadius:8,padding:"9px 12px",fontSize:12,color:"#1D4ED8",marginBottom:10}}>
                    Only the terms you check here will appear at checkout for this customer.
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {ALL_TERMS.map(t=>(
                      <label key={t.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",borderRadius:8,border:`1px solid ${(Array.isArray(editData.terms)?editData.terms:[]).includes(t.id)?C.blue:C.border}`,background:(Array.isArray(editData.terms)?editData.terms:[]).includes(t.id)?C.blueLight:C.white,cursor:"pointer"}}>
                        <input type="checkbox" checked={(Array.isArray(editData.terms)?editData.terms:[]).includes(t.id)} onChange={()=>toggleTerm(t.id)} style={{accentColor:C.blue,width:14,height:14}}/>
                        <div>
                          <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{t.label}</div>
                          <div style={{fontSize:11,color:C.inkLight}}>{t.desc}</div>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
                {/* Role conversion — used when the user picked the wrong
                    account type at signup. Keeps their email/password and
                    every entered field; only flips role so they land in
                    the rep portal on next login. Admin-only (protected by
                    profiles.protect_profile_fields trigger). */}
                <div style={{marginTop:12,marginBottom:14,padding:"12px 14px",background:"#FEFCE8",border:"1px solid #FDE68A",borderRadius:8}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#92400E",marginBottom:4}}>Wrong account type?</div>
                  <div style={{fontSize:11,color:"#92400E",lineHeight:1.5,marginBottom:8}}>
                    If this person signed up as a customer but should be a Sales Rep, convert them here. Their email + password stay the same — they'll see the rep portal on next sign-in.
                  </div>
                  <button
                    style={{...S.btnSecondary,fontSize:12,padding:"7px 14px",color:C.teal,borderColor:C.teal}}
                    onClick={async()=>{
                      if(!window.confirm(`Convert ${editData.contact || editData.company || editData.email} to a Sales Rep account?\n\nThey'll keep the same email, password, phone, and address. Their customer-side order history stays but the rep portal is what they'll see next time they sign in.\n\nContinue?`)) return;
                      try {
                        await changeAccountRole(editingId, "rep");
                        alert("Converted to Sales Rep. Ask the user to sign out and back in to see the rep portal.");
                        setEditingId(null);
                      } catch(e) {
                        alert("Conversion failed: " + (e?.message || e));
                      }
                    }}
                    disabled={savingAcct}
                  >
                    Convert to Sales Rep →
                  </button>
                </div>
                <div style={{display:"flex",gap:10,justifyContent:"flex-end",alignItems:"center"}}>
                  {/* Mirrors the rep edit modal: Pause / Delete live in the footer too. */}
                  <div style={{display:"flex",gap:8,marginRight:"auto"}}>
                    {canOfferDelete(accounts.find(a=>a.id===editingId)||editData,user?.id)&&<>
                    {canOfferLifecycle(accounts.find(a=>a.id===editingId)||editData,user?.id)&&<button
                      style={{...S.btnSecondary,color:C.amber,borderColor:C.amber}}
                      disabled={savingAcct}
                      title="Temporarily block this account from logging in"
                      onClick={()=>{const ac=accounts.find(a=>a.id===editingId)||editData; setEditingId(null); openSuspendModal(ac,"pause");}}
                    >Pause account</button>}
                    <button
                      style={{...S.btnSecondary,color:C.red,borderColor:C.red}}
                      disabled={savingAcct}
                      title="Delete this account (login blocked, history kept, restorable)"
                      onClick={()=>{const ac=accounts.find(a=>a.id===editingId)||editData; setEditingId(null); openSuspendModal(ac,"delete");}}
                    >Delete account</button>
                    </>}
                  </div>
                  <button style={S.btnSecondary} onClick={()=>setEditingId(null)} disabled={savingAcct}>Cancel</button>
                  <button style={{...S.btnPrimary, opacity:savingAcct?0.6:1, cursor:savingAcct?"not-allowed":"pointer"}} onClick={saveEdit} disabled={savingAcct}>{savingAcct?"Saving…":"Save changes"}</button>
                </div>
              </div>
            </div>
          )}

          {/* ── REASSIGN REP MODAL ──
              Focused entry point for moving a single dealer between sales
              reps. Calls the same atomic transfer logic as saveEdit's
              rep-change path (saveCustomerAssignment + upsertRepRouteCustomer
              + deactivateRepRouteCustomer) so the customer_settings row,
              both reps' Route Planners, and the email notifications all
              stay in lock-step. UI surfaces the current rep clearly so
              admin doesn't have to dig in the Edit modal to see what's
              there now. */}
          {transferRepCust && (
            <div
              onClick={closeTransferRep}
              style={{position:"fixed",inset:0,background:"rgba(15,23,42,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:3000}}
            >
              <div
                onClick={e=>e.stopPropagation()}
                style={{background:C.white,borderRadius:12,padding:"22px 24px",minWidth:480,maxWidth:560,boxShadow:"0 12px 32px rgba(0,0,0,0.2)"}}
              >
                <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:6}}>
                  Reassign sales rep
                </div>
                <div style={{fontSize:12,color:C.inkMid,marginBottom:16,lineHeight:1.5}}>
                  Customer: <strong style={{color:C.ink}}>{transferRepCust.company || transferRepCust.contact || transferRepCust.email}</strong>
                </div>
                <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.inkMid,marginBottom:16}}>
                  Currently assigned to: <strong style={{color:transferRepCust.rep?C.ink:C.red}}>{transferRepCust.rep || "Unassigned"}</strong>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>New sales rep</label>
                  <select
                    style={S.input}
                    value={transferRepNewName}
                    onChange={e=>setTransferRepNewName(e.target.value)}
                    disabled={transferRepBusy}
                  >
                    <option value="">— Unassigned —</option>
                    {(repList || []).map(r => (
                      <option key={r.id || r.name} value={r.name}>{r.name}</option>
                    ))}
                  </select>
                  <div style={{fontSize:10,color:C.inkLight,marginTop:4}}>
                    The new rep will see this dealer in their Route Planner. The previous rep loses commission on any future orders this dealer places (existing paid invoices stay attributed to whoever was rep at the time of sale).
                  </div>
                </div>
                {transferRepError && (
                  <div style={{margin:"12px 0", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, fontSize:12, color:"#92400E"}}>
                    <strong>{transferRepError}</strong>
                  </div>
                )}
                <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
                  <button
                    style={{...S.btnSecondary,opacity:transferRepBusy?0.5:1,cursor:transferRepBusy?"not-allowed":"pointer"}}
                    onClick={closeTransferRep}
                    disabled={transferRepBusy}
                  >Cancel</button>
                  <button
                    style={{...S.btnPrimary,opacity:transferRepBusy?0.6:1,cursor:transferRepBusy?"not-allowed":"pointer"}}
                    onClick={confirmTransferRep}
                    disabled={transferRepBusy}
                  >{transferRepBusy ? "Reassigning…" : "Reassign"}</button>
                </div>
              </div>
            </div>
          )}

          {/* ── DELETE ACCOUNT MODAL (dealers + reps) ──
              Soft delete only: login is blocked and the account leaves every admin list, but the
              profile row, orders, invoices, commission, inventory and assignments are all kept.
              Requires a reason AND the typed word DELETE. The DB write happens before any UI change. */}
          {deleteModal&&(()=>{
            const ac=deleteModal.account;
            const isRep=ac.role==="rep"||ac.tier==="rep";
            const imp=deleteImpact||{loading:true};
            const money=(n)=>"$"+Number(n||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
            const rows=[];
            const isApplicant=ac.status==="pending"||ac.status==="rejected";
            if(!imp.loading&&!imp.partial){
              if(imp.applicant){
                rows.push(["Application status",ac.status==="pending"?"Pending":"Rejected"]);
              } else if(isRep){
                rows.push(["Assigned dealers (not unassigned by this action)",imp.assignedDealers]);
                rows.push(["Estimated pending commission (unpaid, estimate only)",money(imp.pendingCommission),imp.pendingCommission>0]);
                rows.push(["Estimated units on hand with the rep",imp.onHandUnits,imp.onHandUnits>0]);
                if((imp.oversoldUnits||0)>0) rows.push(["Oversold units (invoiced more than received)",imp.oversoldUnits,true]);
                rows.push(["Open invoices",imp.openInvoices]);
              } else {
                rows.push(["Open / outstanding invoices",imp.openInvoices]);
                rows.push(["Outstanding balance",money(imp.openBalance)]);
                rows.push(["Assigned rep",imp.assignedRep||"None"]);
              }
            }
            return (
              <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1100}}>
                <div style={{background:C.white,borderRadius:16,padding:"26px 30px",width:520,maxHeight:"90vh",overflowY:"auto"}}>
                  <div style={{fontSize:17,fontWeight:700,color:C.ink,marginBottom:4}}>Delete {isApplicant?(isRep?"sales rep applicant":"applicant"):(isRep?"sales rep":"dealer account")}?</div>
                  {isApplicant&&<div style={{fontSize:12,color:"#92400E",background:C.amberLight,border:"1px solid #FCD34D",borderRadius:8,padding:"8px 12px",marginBottom:12,lineHeight:1.5}}>This is an <strong>applicant</strong> ({ac.status}). It has no commission, inventory or orders to show. Delete moves it to Deleted &amp; paused accounts; <strong>Restore returns it to {ac.status}</strong>, never to approved.</div>}
                  <div style={{fontSize:13,color:C.inkMid,lineHeight:1.5,marginBottom:12}}>
                    Login is blocked and the account is removed from every admin list. Orders, invoices, commission and inventory history are <strong>kept</strong>. The account can be restored later from Deleted &amp; paused accounts. The email address stays reserved, so this person cannot sign up again with it.
                  </div>
                  <div style={{background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:8,padding:"11px 14px",marginBottom:12}}>
                    <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{ac.company&&ac.company!=="—"?ac.company:(ac.contact||ac.email)}</div>
                    <div style={{fontSize:12,color:C.inkLight}}>{ac.contact}{ac.email?" · "+ac.email:""}</div>
                  </div>
                  <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:8,padding:"10px 14px",marginBottom:12,fontSize:12}}>
                    <div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:6}}>What this affects (read-only)</div>
                    {imp.loading&&<div style={{color:C.inkLight}}>Loading…</div>}
                    {imp.partial&&<div style={{color:"#92400E"}}>Some figures could not be loaded. Please confirm below that you understand.</div>}
                    {rows.map(([l,v,warn])=>(
                      <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"2px 0",color:warn?"#92400E":C.ink,fontWeight:warn?600:400}}>
                        <span>{l}</span><span>{v}</span>
                      </div>
                    ))}
                    {!imp.loading&&isRep&&<div style={{marginTop:6,fontSize:11,color:C.inkLight}}>Dealers assigned to this rep are NOT changed. Use Reassign to move them. Deleted reps stay visible in Commission and Rep Inventory so money and stock are never hidden.</div>}
                  </div>
                  {deleteNeedsAck&&(
                    <label style={{display:"flex",gap:8,alignItems:"flex-start",fontSize:12,color:"#92400E",background:C.amberLight,border:"1px solid #FCD34D",borderRadius:8,padding:"9px 12px",marginBottom:12,cursor:"pointer"}}>
                      <input type="checkbox" checked={deleteAck} onChange={e=>setDeleteAck(e.target.checked)} style={{marginTop:2}}/>
                      <span>I understand{isRep?" there may be unpaid commission or stock on hand for this rep, which stays visible in Commission and Rep Inventory":" the figures above may not be complete"}.</span>
                    </label>
                  )}
                  <div style={S.fg}>
                    <label style={S.label}>Reason <span style={{color:C.red}}>*</span></label>
                    <textarea
                      style={{...S.input,minHeight:70,resize:"vertical",fontFamily:"inherit"}}
                      value={deleteReason}
                      onChange={e=>setDeleteReason(e.target.value)}
                      placeholder="e.g. Closed business, duplicate account, left the company…"
                      autoFocus
                      disabled={deleteBusy}
                    />
                  </div>
                  <div style={S.fg}>
                    <label style={S.label}>Type <strong>DELETE</strong> to confirm <span style={{color:C.red}}>*</span></label>
                    <input style={S.input} value={deleteTyped} onChange={e=>setDeleteTyped(e.target.value)} placeholder="DELETE" disabled={deleteBusy} autoComplete="off"/>
                  </div>
                  {deleteError&&(
                    <div style={{margin:"4px 0 10px",padding:"10px 12px",background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:8,fontSize:12,color:"#991B1B"}}>
                      {deleteError} Nothing was changed.
                    </div>
                  )}
                  <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:12}}>
                    <button style={S.btnSecondary} onClick={closeDeleteModal} disabled={deleteBusy}>Cancel</button>
                    <button
                      style={{...S.btnPrimary,background:"#DC2626",opacity:deleteReady?1:0.5,cursor:deleteReady?"pointer":"not-allowed"}}
                      onClick={performDelete}
                      disabled={!deleteReady}
                    >{deleteBusy?"Deleting…":"Delete account"}</button>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* ── SUSPEND / DELETE REASON MODAL ──
              Shared by pause + delete. A reason is always required so we have an
              auditable "why" for every account that gets blocked from logging in. */}
          {suspendModal&&(()=>{
            const { account: ac, mode } = suspendModal;
            const isDelete = mode==="delete";
            const isRep = ac.role==="rep"||ac.tier==="rep";
            return (
              <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
                <div style={{background:C.white,borderRadius:16,padding:"26px 30px",width:480}}>
                  <div style={{fontSize:17,fontWeight:700,color:C.ink,marginBottom:4}}>{isDelete?"Delete":"Pause"} {isRep?"sales rep":"customer account"}?</div>
                  <div style={{fontSize:13,color:C.inkLight,marginBottom:14}}>
                    {isDelete
                      ? "The account will be moved to Deleted & paused accounts. Full history is preserved, but login is blocked — they'll see a \"Contact MotorPower Care\" message."
                      : "The account will be temporarily blocked from signing in. You can restore it anytime from Deleted & paused accounts."}
                  </div>
                  <div style={{background:isDelete?"#FEF2F2":C.amberLight,border:`1px solid ${isDelete?"#FCA5A5":"#FCD34D"}`,borderRadius:8,padding:"11px 14px",marginBottom:14}}>
                    <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{ac.company&&ac.company!=="—"?ac.company:(ac.contact||ac.email)}</div>
                    <div style={{fontSize:12,color:C.inkLight}}>{ac.contact}{ac.email?" · "+ac.email:""}</div>
                  </div>
                  <div style={S.fg}>
                    <label style={S.label}>Reason <span style={{color:C.red}}>*</span></label>
                    <textarea
                      style={{...S.input,minHeight:80,resize:"vertical",fontFamily:"inherit"}}
                      value={suspendReason}
                      onChange={e=>setSuspendReason(e.target.value)}
                      placeholder={isDelete?"e.g. Customer closed business, consistent non-payment, duplicate account…":"e.g. Credit hold pending payment, account under review, temporary dispute…"}
                      autoFocus
                    />
                    <div style={{fontSize:11,color:C.inkLight,marginTop:4}}>
                      This reason is kept on file with the account's history.
                    </div>
                  </div>
                  {suspendError&&(
                    <div style={{margin:"10px 0 0",padding:"10px 12px",background:"#FEF2F2",border:"1px solid #FCA5A5",borderRadius:8,fontSize:12,color:"#991B1B"}}>
                      {suspendError} Nothing was changed.
                    </div>
                  )}
                  <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:16}}>
                    <button style={S.btnSecondary} onClick={()=>{setSuspendModal(null);setSuspendReason("");setSuspendError("");}} disabled={suspendSubmitting}>Cancel</button>
                    <button
                      style={{...S.btnPrimary,background:isDelete?"#DC2626":C.amber,opacity:(suspendSubmitting||!suspendReason.trim())?0.5:1,cursor:(suspendSubmitting||!suspendReason.trim())?"not-allowed":"pointer"}}
                      onClick={applySuspension}
                      disabled={suspendSubmitting||!suspendReason.trim()}
                    >
                      {suspendSubmitting?"Working…":(isDelete?"Delete account":"Pause account")}
                    </button>
                  </div>
                </div>
              </div>
            );
          })()}

          {tab==="orders"&&<ErrorBoundary label="The Orders tab"><AdminOrdersTab accounts={accounts} overdueInvoices={overdueInvoices} overdueTotal={overdueTotal} focusInvoiceId={focusInvoiceId} onFocusHandled={()=>setFocusInvoiceId(null)} adminUserEmail={user?.email||""} focusAdjustRequestId={focusAdjustRequestId} onAdjustFocusHandled={()=>setFocusAdjustRequestId(null)} onCreateInvoice={()=>openCreateInvoice(null)}/></ErrorBoundary>}
          {tab==="products"&&<AdminProductsTab
            products={adminProducts}
            setProducts={saveProducts}
            kits={adminKits}
            setKits={saveKits}
            materials={adminMaterials}
            catalogLoaded={catalogLoaded}
            catalogLoadError={catalogLoadError}
            catalogSaveError={catalogSaveError}
            stockSyncError={stockSyncError}
            onDismissStockSync={()=>setStockSyncError("")}
            onSeedFromCode={seedCatalogFromCode}
            onStockChanged={onProductStockChanged}
          />}

          {tab==="reps"&&<ErrorBoundary label="The Sales Reps tab"><AdminRepsTab onOpenInOrders={id=>{ setFocusInvoiceId(id); setTab("orders"); }} liveReps={liveReps} pendingReps={pendingReps} onApproveRep={approve} onRejectRep={reject} allAccounts={accounts} onRepSuspensionChange={()=>setSuspendRefreshNonce(n=>n+1)} inactiveReps={inactiveReps} onRequestDelete={requestDeleteRep} onRequestPause={requestPauseRep} archiveCount={suspendedAccounts.length} onOpenArchive={openArchive}/></ErrorBoundary>}
          {tab==="commission"&&<ErrorBoundary label="The Commission tab"><AdminCommissionTabWrapper liveReps={liveReps} inactiveReps={inactiveReps} allAccounts={accounts} onOpenInOrders={id=>{ setFocusInvoiceId(id); setTab("orders"); }}/></ErrorBoundary>}
          {tab==="repinventory"&&<AdminRepInventoryTab liveReps={liveReps} inactiveReps={inactiveReps} allAccounts={accounts} adminUserEmail={user?.email||""} onWarehouseChanged={onWarehouseChanged} onLiveWarehouseRead={onLiveWarehouseRead}/>}
          {tab==="notifications" && <ErrorBoundary label="The Notifications tab"><AdminNotificationsTab onNavigate={setTab} onFocusInvoice={setFocusInvoiceId} onFocusAdjustRequest={setFocusAdjustRequestId} accounts={accounts}/></ErrorBoundary>}
          {tab==="training"  && <AdminTrainingTab videos={adminVideos} setVideos={setAdminVideos} accounts={accounts} reps={liveReps}/>}
          {tab==="marketing" && <AdminMaterialsTab materials={adminMaterials} setMaterials={setAdminMaterials}/>}
          {tab==="tools"     && <AdminToolsTab tools={adminTools} setTools={setAdminTools} agreements={adminAgreements} setAgreements={setAdminAgreements}/>}
          {tab==="certification" && <AdminCertificationTab/>}
          {tab==="broadcasts" && <AdminBroadcastsTab accounts={accounts} reps={visibleDemoReps}/>}

          {tab==="settings" && (
            <div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
                {/* Company info */}
                <div style={S.card}>
                  <div style={S.cardHdr}><span style={S.cardTitle}>Company information</span></div>
                  <div style={{padding:"18px 20px"}}>
                    <div style={S.fg}><label style={S.label}>Company name</label><input style={S.input} value={companyInfo.name} onChange={e=>setCompanyInfo(c=>({...c,name:e.target.value}))}/></div>
                    <div style={S.fg}><label style={S.label}>Street address</label><input style={S.input} value={companyInfo.address} onChange={e=>setCompanyInfo(c=>({...c,address:e.target.value}))}/></div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>City</label><input style={S.input} value={companyInfo.city} onChange={e=>setCompanyInfo(c=>({...c,city:e.target.value}))}/></div>
                      <div style={S.twoCol}>
                        <div style={S.fg}><label style={S.label}>State</label><input style={S.input} value={companyInfo.state} onChange={e=>setCompanyInfo(c=>({...c,state:e.target.value}))}/></div>
                        <div style={S.fg}><label style={S.label}>ZIP</label><input style={S.input} value={companyInfo.zip} onChange={e=>setCompanyInfo(c=>({...c,zip:e.target.value}))}/></div>
                      </div>
                    </div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>Phone</label><input style={S.input} value={companyInfo.phone} onChange={e=>setCompanyInfo(c=>({...c,phone:e.target.value}))}/></div>
                      <div style={S.fg}><label style={S.label}>Email</label><input style={S.input} value={companyInfo.email} onChange={e=>setCompanyInfo(c=>({...c,email:e.target.value}))}/></div>
                    </div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>Website</label><input style={S.input} value={companyInfo.website} onChange={e=>setCompanyInfo(c=>({...c,website:e.target.value}))}/></div>
                      <div style={S.fg}><label style={S.label}>Tax ID / EIN</label><input style={S.input} value={companyInfo.taxId} onChange={e=>setCompanyInfo(c=>({...c,taxId:e.target.value}))}/></div>
                    </div>
                    <div style={S.fg}><label style={S.label}>Company logo URL</label><input style={S.input} value={companyInfo.logo} onChange={e=>setCompanyInfo(c=>({...c,logo:e.target.value}))} placeholder="https://example.com/logo.png"/>
                      {companyInfo.logo&&<img src={companyInfo.logo} alt="" style={{marginTop:8,maxHeight:60,borderRadius:6}} onError={e=>{e.target.style.display="none"}}/>}
                    </div>
                    {/* This card had no Save button of its own — the only
                        commit action lived in the adjacent "Invoice settings"
                        card, labeled "Save company & payment settings" with
                        no visual link back to name/address/logo here. The
                        always-on draft autosave (below, into localStorage
                        only) made unsaved edits LOOK saved on the admin's own
                        browser, so an admin editing only fields on this card
                        could believe they'd saved when nothing had reached
                        Supabase — which is exactly why rep/customer devices
                        never picked up the change. Both buttons call the
                        same saveCompanyInfoToCloud() over the same shared
                        companyInfo state, so either one commits every field
                        on both cards — this one just makes it impossible to
                        edit here and walk away without an obvious save
                        action in the same card. */}
                    {companyInfoSyncError && (
                      <div style={{margin:"8px 0", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
                        <div style={{flex:1}}><strong>Settings saved to this device but cloud sync is pending.</strong> Rep and customer portals on other devices will show older details until this syncs. Click Retry.</div>
                        <button
                          onClick={async () => {
                            const ok = await saveCompanyInfoToCloud();
                            if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                          }}
                          disabled={companyInfoBusy}
                          style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:companyInfoBusy?"not-allowed":"pointer", opacity:companyInfoBusy?0.5:1}}
                        >{companyInfoBusy ? "Retrying…" : "Retry"}</button>
                      </div>
                    )}
                    <button
                      style={{...S.btnPrimary,marginTop:6,opacity:companyInfoBusy?0.6:1,cursor:companyInfoBusy?"not-allowed":"pointer"}}
                      disabled={companyInfoBusy}
                      onClick={async () => {
                        const ok = await saveCompanyInfoToCloud();
                        if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                      }}
                    >{companyInfoBusy ? "Saving…" : "Save company information"}</button>
                  </div>
                </div>

                {/* Invoice settings */}
                <div style={S.card}>
                  <div style={S.cardHdr}><span style={S.cardTitle}>Invoice settings</span></div>
                  <div style={{padding:"18px 20px"}}>
                    <div style={S.fg}><label style={S.label}>Invoice number prefix</label><input style={S.input} value={companyInfo.invoicePrefix} onChange={e=>setCompanyInfo(c=>({...c,invoicePrefix:e.target.value}))} placeholder="INV"/></div>
                    <div style={S.fg}><label style={S.label}>Default invoice note / footer</label><textarea style={{...S.input,height:64,resize:"vertical"}} value={companyInfo.invoiceNotes} onChange={e=>setCompanyInfo(c=>({...c,invoiceNotes:e.target.value}))}/></div>
                    <div style={{marginTop:8,fontSize:12,fontWeight:600,color:C.ink,marginBottom:10}}>Payment methods on invoices</div>
                    <div style={S.fg}><label style={S.label}>Bank name</label><input style={S.input} value={companyInfo.bankName} onChange={e=>setCompanyInfo(c=>({...c,bankName:e.target.value}))} placeholder="Chase Bank"/></div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>Routing number</label><input style={S.input} value={companyInfo.bankRouting} onChange={e=>setCompanyInfo(c=>({...c,bankRouting:e.target.value}))} placeholder="Optional"/></div>
                      <div style={S.fg}><label style={S.label}>Account number</label><input style={S.input} value={companyInfo.bankAccount} onChange={e=>setCompanyInfo(c=>({...c,bankAccount:e.target.value}))} placeholder="Optional"/></div>
                    </div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>PayPal email</label><input style={S.input} value={companyInfo.paypalEmail} onChange={e=>setCompanyInfo(c=>({...c,paypalEmail:e.target.value}))} placeholder="Optional"/></div>
                      <div style={S.fg}><label style={S.label}>Zelle email / phone</label><input style={S.input} value={companyInfo.zelleEmail} onChange={e=>setCompanyInfo(c=>({...c,zelleEmail:e.target.value}))} placeholder="Optional"/></div>
                    </div>

                    {/* ── Wire transfer instructions ───────────────────────────
                        Shown to customers on the Pay invoice → Wire step.
                        Keep empty routing/account blank if you want customers
                        to email for them. */}
                    <div style={{marginTop:16,paddingTop:14,borderTop:`1px solid ${C.border}`,fontSize:12,fontWeight:600,color:C.ink,marginBottom:10}}>Wire transfer instructions (shown to customers when paying)</div>
                    <div style={S.twoCol}>
                      <div style={S.fg}><label style={S.label}>Account holder name</label><input style={S.input} value={companyInfo.bankAccountName||""} onChange={e=>setCompanyInfo(c=>({...c,bankAccountName:e.target.value}))} placeholder="MotorPower Care Inc."/></div>
                      <div style={S.fg}><label style={S.label}>SWIFT code (optional — international)</label><input style={S.input} value={companyInfo.bankSwift||""} onChange={e=>setCompanyInfo(c=>({...c,bankSwift:e.target.value}))} placeholder="BOFAUS3N"/></div>
                    </div>
                    <div style={S.fg}><label style={S.label}>Bank address (optional)</label><input style={S.input} value={companyInfo.bankAddress||""} onChange={e=>setCompanyInfo(c=>({...c,bankAddress:e.target.value}))} placeholder="100 N Tryon St, Charlotte, NC 28255"/></div>
                    <div style={S.fg}>
                      <label style={S.label}>Additional wire notes (optional)</label>
                      <textarea style={{...S.input,height:56,resize:"vertical"}} value={companyInfo.wireNote||""} onChange={e=>setCompanyInfo(c=>({...c,wireNote:e.target.value}))} placeholder="e.g. Email info@mpcare.com if you need the account number."/>
                      <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Appears below the wire details on the customer Pay invoice screen.</div>
                    </div>

                    {/* ── Check-by-mail instructions ───────────────────────────
                        Shown to customers on the Pay invoice → Check step. */}
                    <div style={{marginTop:16,paddingTop:14,borderTop:`1px solid ${C.border}`,fontSize:12,fontWeight:600,color:C.ink,marginBottom:10}}>Check payment instructions (shown to customers when paying)</div>
                    <div style={S.fg}><label style={S.label}>Make check payable to</label><input style={S.input} value={companyInfo.checkPayee||""} onChange={e=>setCompanyInfo(c=>({...c,checkPayee:e.target.value}))} placeholder="MotorPower Care Inc."/></div>
                    <div style={S.fg}>
                      <label style={S.label}>Mail check to (address)</label>
                      <textarea style={{...S.input,height:64,resize:"vertical"}} value={companyInfo.checkAddress||""} onChange={e=>setCompanyInfo(c=>({...c,checkAddress:e.target.value}))} placeholder={"1234 Commerce Blvd, Suite 200\nSan Diego, CA 92101"}/>
                      <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Leave blank to use the company address above.</div>
                    </div>

                    {companyInfoSyncError && (
                      <div style={{margin:"8px 0", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
                        <div style={{flex:1}}><strong>Settings saved to this device but cloud sync is pending.</strong> Rep and customer portals on other devices will show older details until this syncs. Click Retry.</div>
                        <button
                          onClick={async () => {
                            const ok = await saveCompanyInfoToCloud();
                            if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                          }}
                          disabled={companyInfoBusy}
                          style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:companyInfoBusy?"not-allowed":"pointer", opacity:companyInfoBusy?0.5:1}}
                        >{companyInfoBusy ? "Retrying…" : "Retry"}</button>
                      </div>
                    )}
                    <button
                      style={{...S.btnPrimary,marginTop:6,opacity:companyInfoBusy?0.6:1,cursor:companyInfoBusy?"not-allowed":"pointer"}}
                      disabled={companyInfoBusy}
                      onClick={async () => {
                        const ok = await saveCompanyInfoToCloud();
                        if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                      }}
                    >{companyInfoBusy ? "Saving…" : "Save company & payment settings"}</button>
                  </div>
                </div>
              </div>

              {/* Signup & Terms editor — admin-editable legal / marketing copy
                  that customers see at signup. Persists to Supabase so every
                  browser (including anonymous signup visitors) sees the
                  current version. */}
              <AdminSignupTermsEditor/>

              {/* Login account — self-service auth email change */}
              <div style={{marginTop:20}}>
                <ChangeLoginEmail user={user}/>
              </div>

              {/* Shipping settings */}
              <div style={{...S.card,marginTop:20}}>
                <div style={S.cardHdr}><span style={S.cardTitle}>Shipping charges & rules</span></div>
                <div style={{padding:"18px 20px"}}>
                  <div style={S.twoCol}>
                    <div style={S.fg}>
                      <label style={S.label}>Standard shipping rate ($)</label>
                      <input type="number" step="0.01" min="0" style={S.input} value={shippingCfg.flatRate} onChange={e=>setShippingCfg(s=>({...s,flatRate:parseFloat(e.target.value)||0}))}/>
                      <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Charged per order when below free shipping threshold</div>
                    </div>
                    <div style={S.fg}>
                      <label style={S.label}>Express / expedited rate ($)</label>
                      <input type="number" step="0.01" min="0" style={S.input} value={shippingCfg.expeditedRate} onChange={e=>setShippingCfg(s=>({...s,expeditedRate:parseFloat(e.target.value)||0}))}/>
                    </div>
                  </div>
                  <div style={S.twoCol}>
                    <div style={S.fg}>
                      <label style={S.label}>Free shipping threshold ($)</label>
                      <input type="number" step="1" min="0" style={S.input} value={shippingCfg.freeThreshold} onChange={e=>setShippingCfg(s=>({...s,freeThreshold:parseFloat(e.target.value)||0}))}/>
                      <div style={{fontSize:10,color:C.inkLight,marginTop:3}}>Orders above this amount get free standard shipping</div>
                    </div>
                    <div style={{...S.fg,display:"flex",alignItems:"center",gap:10,paddingTop:20}}>
                      <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13,color:C.ink}}>
                        <input type="checkbox" checked={shippingCfg.enableFreeShipping} onChange={e=>setShippingCfg(s=>({...s,enableFreeShipping:e.target.checked}))}/>
                        Enable free shipping threshold
                      </label>
                    </div>
                  </div>
                  <div style={S.twoCol}>
                    <div style={S.fg}>
                      <label style={S.label}>Standard shipping label</label>
                      <input style={S.input} value={shippingCfg.standardLabel} onChange={e=>setShippingCfg(s=>({...s,standardLabel:e.target.value}))}/>
                    </div>
                    <div style={S.fg}>
                      <label style={S.label}>Express shipping label</label>
                      <input style={S.input} value={shippingCfg.expeditedLabel} onChange={e=>setShippingCfg(s=>({...s,expeditedLabel:e.target.value}))}/>
                    </div>
                  </div>
                  {/* Live preview */}
                  <div style={{background:C.surface,borderRadius:10,padding:"14px 16px",border:`1px solid ${C.border}`,marginTop:8}}>
                    <div style={{fontSize:11,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>Preview — what customers see</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                      <div style={{background:C.white,borderRadius:8,padding:"10px 12px",border:`1px solid ${C.border}`}}>
                        <div style={{fontSize:10,color:C.inkLight,marginBottom:2}}>Order $200</div>
                        <div style={{fontSize:14,fontWeight:600,color:C.ink}}>${shippingCfg.flatRate.toFixed(2)} shipping</div>
                        {shippingCfg.enableFreeShipping&&<div style={{fontSize:10,color:C.teal,marginTop:2}}>Add ${(shippingCfg.freeThreshold-200).toFixed(2)} for free</div>}
                      </div>
                      <div style={{background:C.white,borderRadius:8,padding:"10px 12px",border:`1px solid ${C.border}`}}>
                        <div style={{fontSize:10,color:C.inkLight,marginBottom:2}}>Order ${shippingCfg.freeThreshold.toFixed(0)}+</div>
                        <div style={{fontSize:14,fontWeight:600,color:C.teal}}>{shippingCfg.enableFreeShipping?"FREE shipping":`$${shippingCfg.flatRate.toFixed(2)}`}</div>
                      </div>
                      <div style={{background:C.white,borderRadius:8,padding:"10px 12px",border:`1px solid ${C.border}`}}>
                        <div style={{fontSize:10,color:C.inkLight,marginBottom:2}}>Express</div>
                        <div style={{fontSize:14,fontWeight:600,color:C.ink}}>${shippingCfg.expeditedRate.toFixed(2)}</div>
                        <div style={{fontSize:10,color:C.inkLight,marginTop:2}}>{shippingCfg.expeditedLabel}</div>
                      </div>
                    </div>
                  </div>
                  {shippingSyncError && (
                    <div style={{marginTop:14, padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
                      <div style={{flex:1}}><strong>Shipping settings saved to this device but cloud sync is pending.</strong> Customer checkout on other devices will show older rates until this syncs. Click Retry.</div>
                      <button
                        onClick={async () => {
                          const ok = await saveShippingToCloud();
                          if (ok) alert("Shipping settings saved. Customer portal will pick up new rates on next page load.");
                        }}
                        disabled={shippingBusy}
                        style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:shippingBusy?"not-allowed":"pointer", opacity:shippingBusy?0.5:1}}
                      >{shippingBusy ? "Retrying…" : "Retry"}</button>
                    </div>
                  )}
                  <button
                    style={{...S.btnPrimary,marginTop:14,opacity:shippingBusy?0.6:1,cursor:shippingBusy?"not-allowed":"pointer"}}
                    disabled={shippingBusy}
                    onClick={async () => {
                      const ok = await saveShippingToCloud();
                      if (ok) alert("Shipping settings saved. Customer portal will pick up new rates on next page load.");
                    }}
                  >{shippingBusy ? "Saving…" : "Save shipping settings"}</button>
                </div>
              </div>

              {/* Preview */}
              <div style={{...S.card,marginTop:20}}>
                <div style={S.cardHdr}><span style={S.cardTitle}>Invoice preview</span></div>
                <div style={{padding:"24px 28px"}}>
                  <div style={{border:`1px solid ${C.border}`,borderRadius:10,padding:"28px 32px",maxWidth:600}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:20}}>
                      <div>
                        {companyInfo.logo?<img src={companyInfo.logo} alt="" style={{maxHeight:40,marginBottom:8}} onError={e=>{e.target.style.display="none"}}/>:null}
                        <div style={{fontSize:18,fontWeight:700,color:C.navy}}>{companyInfo.name}</div>
                        <div style={{fontSize:12,color:C.inkLight,lineHeight:1.8}}>
                          {companyInfo.address}<br/>
                          {companyInfo.city}, {companyInfo.state} {companyInfo.zip}<br/>
                          {companyInfo.phone} | {companyInfo.email}<br/>
                          {companyInfo.website}
                        </div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontSize:20,fontWeight:700,color:C.navy}}>INVOICE</div>
                        <div style={{fontSize:12,color:C.inkLight}}>{companyInfo.invoicePrefix}-0001</div>
                        <div style={{fontSize:12,color:C.inkLight}}>Tax ID: {companyInfo.taxId}</div>
                      </div>
                    </div>
                    <div style={{borderTop:`2px solid ${C.navy}`,paddingTop:12,fontSize:12,color:C.inkLight}}>
                      {companyInfo.invoiceNotes}
                    </div>
                    {(companyInfo.bankName||companyInfo.paypalEmail||companyInfo.zelleEmail)&&(
                      <div style={{marginTop:12,padding:"10px 14px",background:C.surface,borderRadius:8,fontSize:12}}>
                        <div style={{fontWeight:600,color:C.ink,marginBottom:4}}>Payment methods</div>
                        {companyInfo.bankName&&<div style={{color:C.inkLight}}>Bank: {companyInfo.bankName}{companyInfo.bankRouting?` | Routing: ${companyInfo.bankRouting}`:""}{companyInfo.bankAccount?` | Acct: ${companyInfo.bankAccount}`:""}</div>}
                        {companyInfo.paypalEmail&&<div style={{color:C.inkLight}}>PayPal: {companyInfo.paypalEmail}</div>}
                        {companyInfo.zelleEmail&&<div style={{color:C.inkLight}}>Zelle: {companyInfo.zelleEmail}</div>}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {companyInfoSyncError && (
                <div style={{marginTop:16, padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
                  <div style={{flex:1}}><strong>Settings saved to this device but cloud sync is pending.</strong> Rep and customer portals on other devices will show older details until this syncs. Click Retry.</div>
                  <button
                    onClick={async () => {
                      const ok = await saveCompanyInfoToCloud();
                      if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                    }}
                    disabled={companyInfoBusy}
                    style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:companyInfoBusy?"not-allowed":"pointer", opacity:companyInfoBusy?0.5:1}}
                  >{companyInfoBusy ? "Retrying…" : "Retry"}</button>
                </div>
              )}
              <div style={{marginTop:16,display:"flex",gap:10}}>
                <button
                  style={{...S.btnPrimary,opacity:companyInfoBusy?0.6:1,cursor:companyInfoBusy?"not-allowed":"pointer"}}
                  disabled={companyInfoBusy}
                  onClick={async () => {
                    const ok = await saveCompanyInfoToCloud();
                    if (ok) alert("Saved. Rep and customer portals will pick up the new details on their next page load.");
                  }}
                >{companyInfoBusy ? "Saving…" : "Save settings"}</button>
                <div style={{fontSize:12,color:C.inkLight,display:"flex",alignItems:"center"}}>These details will appear on all invoices generated by your sales reps and on customer-facing documents.</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── CUSTOMER TRAINING PAGE ────────────────────────────────────────────────────
function CustomerTraining() {
  // Migration 0023 (Rule Zero): read from Supabase training_videos filtered
  // to show_to_customers=true + active=true. Prior behavior hardcoded the
  // ADMIN_TRAINING_STUB array, which meant customers NEVER saw admin's
  // real uploads — that was the primary bug this migration closes.
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await listTrainingVideos({ customerVisibleOnly: true });
        if (!cancelled) { setVideos(rows || []); setLoading(false); }
      } catch (e) {
        console.warn("[CustomerTraining] listTrainingVideos failed:", e?.message || e);
        if (!cancelled) setLoading(false);
      }
    };
    load();
    const unsub = subscribeTrainingVideos(() => { if (!cancelled) load(); });
    return () => { cancelled = true; unsub && unsub(); };
  }, []);
  const [watched,setWatched]=useState([]);
  // Preview player state — the "Watch now" button opens a modal that
  // embeds the video (YouTube / Vimeo iframe, or <video> tag for direct
  // URL / file blob). Mirrors the AdminTrainingTab preview at App.js:4594.
  // Prior to this the "Watch now" button had no onClick and did nothing.
  const [previewId, setPreviewId] = useState(null);
  const getEmbedUrl = (url, type) => {
    if (!url) return "";
    if (type === "youtube") { const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/); return m ? `https://www.youtube.com/embed/${m[1]}` : url; }
    if (type === "vimeo")   { const m = url.match(/vimeo\.com\/(\d+)/); return m ? `https://player.vimeo.com/video/${m[1]}` : url; }
    return url;
  };
  // Card thumbnail: admin's explicit thumbnailUrl wins when set; otherwise
  // auto-derive YouTube's own thumbnail from the video URL (img.youtube.com,
  // no API key needed) so a video with no manual thumbnail still shows a
  // real image instead of the generic ▶ glyph. Mirrors RepPortal's
  // TrainingHub getThumbnail helper — same extraction regex as getEmbedUrl.
  const getThumbnail = (v) => {
    if (v?.thumbnailUrl) return v.thumbnailUrl;
    if (v?.videoUrl && (v.videoType||"youtube") === "youtube") {
      const m = v.videoUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&?/]+)/);
      if (m) return `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg`;
    }
    return "";
  };
  const catColors={product:S.pillBlue,sales:S.pillGreen,admin:S.pillGray,marketing:{fontSize:10,fontWeight:500,padding:"2px 8px",borderRadius:8,background:"#EDE9FE",color:"#5B21B6"}};
  return (
    <div style={S.content}>
      {previewId && (() => {
        const pv = videos.find(v => v.id === previewId);
        if (!pv) return null;
        return (
          <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}} onClick={()=>setPreviewId(null)}>
            <div style={{background:C.white,borderRadius:16,padding:"24px 28px",width:720,maxWidth:"90vw"}} onClick={e=>e.stopPropagation()}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <div style={{fontSize:16,fontWeight:600,color:C.ink}}>{pv.title}</div>
                <button style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.inkLight}} onClick={()=>setPreviewId(null)}>×</button>
              </div>
              {pv.videoUrl ? (
                <div style={{borderRadius:10,overflow:"hidden",background:"#000",position:"relative",paddingBottom:"56.25%"}}>
                  {(pv.videoType==="direct" || pv.videoType==="file")
                    ? <video src={pv.videoUrl} controls style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}/>
                    : <iframe title="play" src={getEmbedUrl(pv.videoUrl,pv.videoType||"youtube")} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>}
                </div>
              ) : <div style={{padding:40,textAlign:"center",background:C.surface,borderRadius:10,color:C.inkLight}}>No video URL provided</div>}
              {pv.desc && <div style={{marginTop:12,fontSize:13,color:C.inkLight}}>{pv.desc}</div>}
            </div>
          </div>
        );
      })()}
      <div style={{marginBottom:20}}>
        <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Training & demo videos</div>
        <div style={{fontSize:13,color:C.inkLight}}>Product guides, demo techniques, and how-to videos from MotorPower Care — available to all approved accounts.</div>
      </div>
      {loading && (
        <div style={{...S.card,padding:"32px",textAlign:"center",color:C.inkLight,fontSize:13}}>Loading videos…</div>
      )}
      {!loading && videos.length===0 && (
        <div style={{...S.card,padding:"32px",textAlign:"center",color:C.inkLight,fontSize:13}}>No videos available yet. Check back soon.</div>
      )}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
        {videos.map(v=>{
          const done=watched.includes(v.id);
          const thumb=getThumbnail(v);
          return (
            <div key={v.id} style={{background:C.white,border:`1px solid ${done?"#86EFAC":C.border}`,borderRadius:12,overflow:"hidden"}}>
              {/* 16:9 responsive box (the classic position:relative + height:0
                  + paddingBottom:56.25% trick, same one this file's own
                  video-preview modal already uses) instead of a fixed
                  height:88 box. A fixed short height forced object-fit:cover
                  to crop a real YouTube thumbnail down to a sliver — badly
                  cutting off video title cards baked into the image. */}
              <div style={{position:"relative",paddingBottom:"56.25%",height:0,background:done?C.tealLight:C.surface,borderBottom:`1px solid ${C.border}`,cursor:v.videoUrl?"pointer":"default",overflow:"hidden"}} onClick={()=>v.videoUrl && setPreviewId(v.id)}>
                {thumb && <img src={thumb} alt="" style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>}
                <span style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",fontSize:36,color:thumb?"#fff":"inherit",textShadow:thumb?"0 1px 4px rgba(0,0,0,0.6)":"none"}}>{done?"✓":"▶"}</span>
              </div>
              <div style={{padding:"14px 16px"}}>
                <div style={{display:"flex",gap:6,marginBottom:8,flexWrap:"wrap"}}>
                  <span style={catColors[v.category]||S.pillGray}>{v.category}</span>
                  {done&&<span style={S.pillGreen}>Watched</span>}
                </div>
                <div style={{fontSize:14,fontWeight:600,color:C.ink,marginBottom:6}}>{v.title}</div>
                <div style={{fontSize:12,color:C.inkMid,marginBottom:12,lineHeight:1.6}}>{v.desc}</div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:11,color:C.inkLight}}>{v.duration} · Added {v.date}</span>
                  <div style={{display:"flex",gap:8}}>
                    {!done&&<button style={S.btnSecondary} onClick={()=>setWatched(w=>[...w,v.id])}>Mark watched</button>}
                    <button
                      style={{...S.btnPrimary, opacity: v.videoUrl ? 1 : 0.5, cursor: v.videoUrl ? "pointer" : "not-allowed"}}
                      disabled={!v.videoUrl}
                      title={v.videoUrl ? "Watch this video" : "This video has no URL yet"}
                      onClick={()=>v.videoUrl && setPreviewId(v.id)}
                    >
                      Watch now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── CUSTOMER MARKETING MATERIALS PAGE ─────────────────────────────────────────
function CustomerMarketing({onAddMaterialsToCart, customerName, userId, onMaterialOrderSyncPending}) {
  const materials = ADMIN_MATERIALS_STUB.filter(m=>m.active&&m.showToCustomers);
  const [added,setAdded]=useState([]);
  const [orderPlaced,setOrderPlaced]=useState(null);
  const [toast,setToast]=useState("");
  const catColors={flyer:S.pillBlue,shelf:S.pillGreen,display:S.pillAmber,banner:{fontSize:10,fontWeight:500,padding:"2px 8px",borderRadius:8,background:"#EDE9FE",color:"#5B21B6"},other:S.pillGray};

  const showToast=(msg)=>{setToast(msg);setTimeout(()=>setToast(""),3000);};

  const addItem=(item)=>{
    if(!added.find(a=>a.id===item.id)){
      const next=[...added,{...item,qty:1}];
      setAdded(next);
      if(onAddMaterialsToCart) onAddMaterialsToCart(next);
    }
  };
  const updateQty=(id,qty)=>{
    if(qty<=0){remove(id);return;}
    const next=added.map(a=>a.id===id?{...a,qty}:a);
    setAdded(next);
    if(onAddMaterialsToCart) onAddMaterialsToCart(next);
  };
  const remove=(id)=>{
    const next=added.filter(a=>a.id!==id);
    setAdded(next);
    if(onAddMaterialsToCart) onAddMaterialsToCart(next);
  };
  const [placingOrder, setPlacingOrder] = useState(false);
  const placeOrder=async ()=>{
    if (placingOrder) return;
    const orderId=`MAT-${Date.now().toString(36).toUpperCase()}`;
    const total=added.reduce((s,a)=>s+a.price*a.qty,0);
    const dateStr=new Date().toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
    const order={id:orderId,items:[...added],total,date:dateStr};

    // Phase C — Rule Zero: Supabase-first. Await material_orders insert,
    // then mirror to localStorage regardless of outcome. order.id is the
    // stable "MAT-XXXX" client id and becomes material_orders.client_id
    // for exact-key dedupe via the non-partial unique index.
    setPlacingOrder(true);
    let supabaseOk = true;
    if (userId) {
      try {
        const row = await upsertMaterialOrder({
          clientId: String(orderId),
          orderRef: String(orderId),
          source: 'customer',
          accountName: customerName || "Customer",
          repName: null,
          repId: null,
          userId: userId,
          items: added.map(a => ({ name: a.name, qty: a.qty, price: a.price, sku: a.sku || "MAT" })),
          total,
          status: 'pending',
          placedAt: new Date().toISOString(),
        });
        if (!row) supabaseOk = false;
      } catch(e) {
        console.warn("[CustomerMarketing placeOrder] material_orders write threw:", e?.message || e);
        supabaseOk = false;
      }
    }
    setPlacingOrder(false);

    // localStorage mirror — always runs. Existing SHARED_INVOICES invoice
    // generation keeps working (covered by the Phase B rep-invoice sync
    // plumbing already).
    setOrderPlaced(order);
    SHARED_MATERIAL_ORDERS.add({...order, source:"customer", accountName:customerName||"Customer", userId:userId||""});
    // Collision-resistant id (same fix as the wholesale-order invId above) —
    // this one only ever lands in the local SHARED_INVOICES mirror (the real
    // Supabase write above uses orderId, already collision-resistant via
    // Date.now().toString(36)), so a clash here wasn't dropping a database
    // row, just risking a confusing duplicate invoice number in one
    // browser's own history. Fixed anyway for consistency.
    const invId=`INV-MAT-${String(Date.now()).slice(-6)}${Math.random().toString(36).slice(2,8).toUpperCase()}`;
    SHARED_INVOICES.add({
      id:invId, orderId, date:dateStr,
      customer:customerName||"Customer",
      items:added.map(a=>({sku:"MAT",name:a.name,qty:a.qty,price:a.price})),
      total, status:total===0?"paid":"outstanding",
      paymentTerms:total===0?"Free materials":"Net 30",
      rep:"", source:"material_order"
    });
    setAdded([]);
    showToast("Order placed! Your materials will be shipped with your next product delivery.");
    emailMaterialOrder({accountName:customerName||"Customer", source:"customer", items:order.items, total:order.total, orderId});
    if (!supabaseOk && typeof onMaterialOrderSyncPending === "function") {
      onMaterialOrderSyncPending(String(orderId));
    }
  };

  return (
    <div style={S.content}>
      {/* Toast */}
      {toast&&<div style={{position:"fixed",top:24,right:24,background:"#166534",color:"#fff",padding:"12px 20px",borderRadius:10,fontSize:13,fontWeight:500,zIndex:3000,boxShadow:"0 4px 16px rgba(0,0,0,0.15)"}}>{toast}</div>}

      <div style={{marginBottom:20}}>
        <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Marketing materials</div>
        <div style={{fontSize:13,color:C.inkLight}}>Free and priced materials to help promote MotorPower Care products in your shop. Select the quantity you need and place your order to have them shipped.</div>
      </div>

      {/* Order placed confirmation */}
      {orderPlaced&&!added.length&&(
        <div style={{background:"#DCFCE7",border:"1px solid #86EFAC",borderRadius:10,padding:"14px 18px",marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:600,color:"#166534",marginBottom:6}}>Order #{orderPlaced.id} placed on {orderPlaced.date}</div>
          <div style={{fontSize:12,color:"#166534"}}>{orderPlaced.items.length} item{orderPlaced.items.length>1?"s":""} — {orderPlaced.total===0?"FREE":`$${orderPlaced.total.toFixed(2)}`}. Admin notified. Materials will ship with your next product delivery.</div>
        </div>
      )}

      {added.length>0&&(
        <div style={{background:C.white,border:`1px solid ${C.teal}`,borderRadius:10,padding:"14px 18px",marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:600,color:C.teal,marginBottom:10}}>Your material order ({added.length} item{added.length>1?"s":""})</div>
          {added.map(item=>(
            <div key={item.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:13,padding:"6px 0",borderBottom:`1px solid ${C.border}`}}>
              <span style={{flex:1,color:C.ink}}>{item.name} <span style={{fontSize:11,color:C.inkLight}}>({item.unit})</span></span>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",border:`1px solid ${C.border}`,borderRadius:6,overflow:"hidden"}}>
                  <button onClick={()=>updateQty(item.id,item.qty-1)} style={{background:C.surface,border:"none",padding:"3px 8px",cursor:"pointer",fontSize:13,color:C.ink}}>-</button>
                  <span style={{padding:"3px 10px",fontSize:12,fontWeight:500,minWidth:28,textAlign:"center"}}>{item.qty}</span>
                  <button onClick={()=>updateQty(item.id,item.qty+1)} style={{background:C.surface,border:"none",padding:"3px 8px",cursor:"pointer",fontSize:13,color:C.ink}}>+</button>
                </div>
                <span style={{minWidth:60,textAlign:"right",fontWeight:500,color:item.price===0?C.teal:C.ink}}>{item.price===0?"FREE":`$${(item.price*item.qty).toFixed(2)}`}</span>
                <button onClick={()=>remove(item.id)} style={{background:"none",border:"none",color:C.inkLight,cursor:"pointer",fontSize:16,lineHeight:1}}>×</button>
              </div>
            </div>
          ))}
          <div style={{borderTop:`1px solid ${C.border}`,marginTop:8,paddingTop:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontSize:13,fontWeight:600,color:C.ink}}>Total: {added.every(a=>a.price===0)?"FREE":`$${added.reduce((s,a)=>s+a.price*a.qty,0).toFixed(2)}`}</div>
            <button onClick={placeOrder} disabled={placingOrder} style={{background:C.teal,color:"#fff",border:"none",padding:"8px 20px",borderRadius:8,fontSize:13,fontWeight:500,cursor:placingOrder?"not-allowed":"pointer",opacity:placingOrder?0.6:1}}>{placingOrder ? "Placing…" : "Place order for shipping"}</button>
          </div>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
        {materials.map(item=>{
          const isAdded=!!added.find(a=>a.id===item.id);
          return (
            <div key={item.id} style={{background:C.white,border:`1px solid ${isAdded?C.teal:C.border}`,borderRadius:12,overflow:"hidden"}}>
              <div style={{background:C.surface,height:52,display:"flex",alignItems:"center",justifyContent:"center",borderBottom:`1px solid ${C.border}`,fontSize:11,fontWeight:500,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.05em"}}>
                {item.category}
              </div>
              <div style={{padding:"12px 14px"}}>
                <div style={{display:"flex",gap:6,marginBottom:6,flexWrap:"wrap"}}>
                  <span style={catColors[item.category]||S.pillGray}>{item.category}</span>
                  <span style={item.price===0?S.pillGreen:S.pillAmber}>{item.price===0?"Free":`$${item.price.toFixed(2)}`}</span>
                </div>
                <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:4}}>{item.name}</div>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:6}}>{item.unit} · {item.stock} available</div>
                <div style={{fontSize:12,color:C.inkMid,marginBottom:10,lineHeight:1.5}}>{item.desc}</div>
                {(()=>{
                  const inCart=added.find(a=>a.id===item.id);
                  return inCart?(
                    <div style={{display:"flex",alignItems:"center",gap:8,justifyContent:"center"}}>
                      <div style={{display:"flex",alignItems:"center",border:`1px solid ${C.teal}`,borderRadius:6,overflow:"hidden"}}>
                        <button onClick={()=>updateQty(item.id,inCart.qty-1)} style={{background:"#E0F4EE",border:"none",padding:"6px 10px",cursor:"pointer",fontSize:14,color:C.teal,fontWeight:600}}>-</button>
                        <span style={{padding:"6px 14px",fontSize:13,fontWeight:600,color:C.teal}}>{inCart.qty}</span>
                        <button onClick={()=>updateQty(item.id,inCart.qty+1)} style={{background:"#E0F4EE",border:"none",padding:"6px 10px",cursor:"pointer",fontSize:14,color:C.teal,fontWeight:600}}>+</button>
                      </div>
                      <button onClick={()=>remove(item.id)} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:6,padding:"6px 10px",cursor:"pointer",fontSize:12,color:C.inkLight}}>Remove</button>
                    </div>
                  ):(
                    <button onClick={()=>addItem(item)} style={{...S.btnPrimary,width:"100%",padding:"8px",fontSize:12}}>Add to order</button>
                  );
                })()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── CUSTOMER TOOL LENDING PAGE ────────────────────────────────────────────────
const CUST_TOOLS = [
  {id:1,name:"OBD-II diagnostic scanner",value:280,minUnitsPerMonth:12,category:"diagnostic",desc:"Reads and clears P0420, P0430, and DPF codes. Demonstrates the exact problem your product solves — on the customer's car, in real time.",benefit:"Show customers their fault codes live. Close more product sales on the spot."},
  {id:2,name:"DPF pressure differential tester",value:180,minUnitsPerMonth:8,category:"diagnostic",desc:"Tests DPF back-pressure and shows blockage percentage. Takes 2 minutes and gives customers a concrete number.",benefit:"Turn a vague complaint into a measurable problem — and a clear product solution."},
  {id:3,name:"Fuel injector flow tester",value:350,minUnitsPerMonth:12,category:"diagnostic",desc:"Measures injector flow rate vs factory spec. Shows exactly how dirty the injectors are before and after treatment.",benefit:"Before/after comparison sells the product better than any brochure."},
];

function CustomerTools() {
  const [applying,setApplying]=useState(null);
  const [submitted,setSubmitted]=useState([]);
  const [form,setForm]=useState({toolId:"",notes:""});

  const submit=()=>{
    setSubmitted(s=>[...s,applying.id]);
    setApplying(null);
    setForm({toolId:"",notes:""});
  };

  return (
    <div style={S.content}>
      <div style={{marginBottom:20}}>
        <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Tool lending program</div>
        <div style={{fontSize:13,color:C.inkLight,marginBottom:10}}>We loan professional diagnostic tools to approved shops — free of charge. All we ask is a monthly minimum purchase of MPC products to keep the tool.</div>
        <div style={{background:C.amberLight,border:`1px solid #FCD34D`,borderRadius:10,padding:"12px 16px",fontSize:13,color:C.amber}}>
          <strong>How it works:</strong> You borrow the tool at no cost. Each month you must purchase the listed minimum quantity of any MPC products. Miss two consecutive months and we collect the tool. Applications reviewed within 2 business days.
        </div>
      </div>

      {applying&&(
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
          <div style={{background:C.white,borderRadius:16,padding:"28px 32px",width:500}}>
            <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:4}}>Apply for tool loan</div>
            <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>{applying.name}</div>
            <div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1D4ED8",marginBottom:16}}>
              By applying you agree to purchase a minimum of <strong>{applying.minUnitsPerMonth} units/month</strong> of any MPC product to keep this tool. Missing 2 consecutive months triggers an automatic recall.
            </div>
            <div style={S.fg}>
              <label style={S.label}>Notes for your rep (optional)</label>
              <textarea style={{...S.input,height:72,resize:"vertical"}} value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="When is a good time for delivery? Any questions about the program?"/>
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <button style={S.btnSecondary} onClick={()=>setApplying(null)}>Cancel</button>
              <button style={S.btnPrimary} onClick={submit}>Submit application</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
        {CUST_TOOLS.map(tool=>{
          const isApplied=submitted.includes(tool.id);
          return (
            <div key={tool.id} style={{background:C.white,border:`1px solid ${isApplied?C.teal:C.border}`,borderRadius:12,padding:"18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:8}}>
                <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{tool.name}</div>
                <span style={S.pillGray}>{tool.category}</span>
              </div>
              <div style={{fontSize:12,color:C.inkMid,marginBottom:10,lineHeight:1.6}}>{tool.desc}</div>
              <div style={{background:C.tealLight,borderRadius:8,padding:"8px 12px",fontSize:12,color:C.teal,marginBottom:12}}>
                {tool.benefit}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
                <div style={{background:C.surface,borderRadius:8,padding:"8px 10px"}}>
                  <div style={{fontSize:11,color:C.inkLight}}>Tool value</div>
                  <div style={{fontSize:14,fontWeight:600,color:C.ink}}>${tool.value}</div>
                </div>
                <div style={{background:C.surface,borderRadius:8,padding:"8px 10px"}}>
                  <div style={{fontSize:11,color:C.inkLight}}>Monthly minimum</div>
                  <div style={{fontSize:14,fontWeight:600,color:C.ink}}>{tool.minUnitsPerMonth} units</div>
                </div>
              </div>
              {isApplied?(
                <div style={{background:C.tealLight,borderRadius:8,padding:"10px",textAlign:"center",fontSize:13,fontWeight:500,color:C.teal}}>
                  Application submitted — your rep will contact you within 2 business days
                </div>
              ):(
                <button style={{...S.btnPrimary,width:"100%"}} onClick={()=>setApplying(tool)}>Apply to borrow this tool</button>
              )}
            </div>
          );
        })}
      </div>

      <div style={{...S.card,marginTop:16}}>
        <div style={S.cardHdr}><span style={S.cardTitle}>Program policy — quick summary</span></div>
        <div style={{padding:"16px 18px"}}>
          {[
            ["Monthly minimum","Purchase the required number of units of any MPC product each calendar month."],
            ["First miss","Warning sent to you and your rep. Rep will reach out within 5 business days."],
            ["Second consecutive miss","Tool is recalled. You may reapply after 12 months."],
            ["Tool condition","Return in working condition. Damage is charged at full replacement value."],
            ["Cancellation","You may return the tool at any time with 5 business days notice — no penalty."],
          ].map(([title,text])=>(
            <div key={title} style={{display:"flex",gap:12,marginBottom:12,paddingBottom:12,borderBottom:`1px solid ${C.border}`}}>
              <div style={{fontSize:12,fontWeight:600,color:C.ink,minWidth:160,flexShrink:0}}>{title}</div>
              <div style={{fontSize:12,color:C.inkMid,lineHeight:1.6}}>{text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// KITS array is imported from ./seeds/catalogSeed at the top of this file.
// The hardcoded array was removed on 2026-04-15. Live kit data lives in
// Supabase (portal_products.kits) and is hydrated by the admin AppShell.
// Product image — renders uploaded imageUrl from admin, falls back to
// SKU/initial placeholder when no image is set or the image fails to load.
function ProductImage({sku, name, color, size=80, imageUrl}) {
  const [failed, setFailed] = useState(false);
  const initial = name ? name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase() : "MP";
  const bg = color || "#0B1F3A";
  if (imageUrl && !failed) {
    return (
      <img
        src={imageUrl}
        alt={name || sku || "product"}
        onError={()=>setFailed(true)}
        style={{width:size,height:size,borderRadius:10,objectFit:"cover",flexShrink:0,background:bg,border:`1px solid ${C.border}`}}
      />
    );
  }
  return (
    <div style={{width:size,height:size,borderRadius:10,background:bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",flexShrink:0}}>
      <div style={{fontSize:size>60?11:9,color:"rgba(255,255,255,0.5)",letterSpacing:"0.06em",marginBottom:2}}>{sku}</div>
      <div style={{fontSize:size>60?18:14,fontWeight:700,color:"#FFFFFF",letterSpacing:"0.02em"}}>{initial}</div>
    </div>
  );
}

// Category color map
const CAT_COLORS = {
  fuel:"#1560BD", emissions:"#0B1F3A", cleaning:"#0D7A5F",
  steering:"#7C3AED", accessories:"#B45309"
};

// ── PRODUCT CATALOG PAGE ──────────────────────────────────────────────────────
function KitDetailModal({kit, onClose, onAddToCart}) {
  const tagColor={blue:{background:C.blueLight,color:"#1D4ED8"},green:{background:C.tealLight,color:C.teal},amber:{background:C.amberLight,color:C.amber}};
  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:20}}>
      <div style={{background:C.white,width:680,borderRadius:16,overflow:"hidden",maxHeight:"90vh",overflowY:"auto"}}>
        {/* Color header */}
        <div style={{background:`linear-gradient(135deg,${kit.color},${kit.color}CC)`,padding:"28px 32px",position:"sticky",top:0,zIndex:1}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:16}}>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontSize:10,fontWeight:600,letterSpacing:"0.12em",color:"rgba(255,255,255,0.55)",textTransform:"uppercase",marginBottom:6}}>{kit.badge} · KIT {kit.sku}</div>
              <div style={{fontSize:24,fontWeight:700,color:"#FFFFFF",marginBottom:6,lineHeight:1.2}}>{kit.name}</div>
              <span style={{background:"rgba(255,255,255,0.15)",color:"#fff",fontSize:11,padding:"4px 12px",borderRadius:8,fontWeight:500}}>{kit.tag}</span>
            </div>
            {kit.imageUrl && (
              <img src={kit.imageUrl} alt={kit.name}
                onError={e=>{e.target.style.display="none";}}
                style={{width:80,height:80,borderRadius:10,objectFit:"cover",flexShrink:0,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.3)"}}/>
            )}
            <button onClick={onClose} style={{background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",width:34,height:34,borderRadius:"50%",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>×</button>
          </div>
        </div>

        <div style={{padding:"24px 28px"}}>
          {/* Description */}
          <div style={{fontSize:14,color:C.inkMid,lineHeight:1.7,marginBottom:22}}>{kit.desc}</div>

          {/* Kit video — admin-optional. Hidden unless videoUrl is set. */}
          {kit.videoUrl && (
            <div style={{marginBottom:22}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
                <span style={{fontSize:13,fontWeight:700,color:C.ink}}>See it in action</span>
              </div>
              <ProductVideo url={kit.videoUrl} title={kit.name} accent={kit.color||"#0B1F3A"}/>
            </div>
          )}

          {/* What's included */}
          <div style={{marginBottom:22}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
              <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
              <span style={{fontSize:13,fontWeight:700,color:C.ink}}>What's included</span>
            </div>
            {kit.items.map((item,i)=>(
              <div key={i} style={{display:"flex",gap:10,alignItems:"center",padding:"10px 14px",background:C.surface,borderRadius:8,marginBottom:6,border:`1px solid ${C.border}`}}>
                <div style={{width:26,height:26,borderRadius:"50%",background:kit.color,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <span style={{color:"#fff",fontSize:12,fontWeight:600}}>{i+1}</span>
                </div>
                <span style={{fontSize:13,color:C.ink,fontWeight:500}}>{item}</span>
              </div>
            ))}
          </div>

          {/* Why pair them */}
          <div style={{background:C.tealLight,border:`1px solid #9FE1CB`,borderRadius:10,padding:"12px 16px",marginBottom:22}}>
            <div style={{fontSize:11,fontWeight:600,color:C.teal,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:4}}>Why this kit works together</div>
            <div style={{fontSize:13,color:C.teal,lineHeight:1.6}}>{kit.highlight}</div>
          </div>

          {/* How it works */}
          {kit.how && (
            <div style={{marginBottom:22}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
                <span style={{fontSize:13,fontWeight:700,color:C.ink}}>How it works</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:kit.how.length>3?"1fr 1fr":"repeat("+kit.how.length+",1fr)",gap:10}}>
                {kit.how.map((step,i)=>(
                  <div key={i} style={{background:C.surface,borderRadius:10,padding:"14px 16px",border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                      <div style={{width:24,height:24,borderRadius:6,background:kit.color+"22",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        <span style={{fontSize:11,fontWeight:700,color:kit.color}}>{i+1}</span>
                      </div>
                      <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",letterSpacing:"0.04em"}}>Step {i+1}</span>
                    </div>
                    <div style={{fontSize:12,color:C.ink,lineHeight:1.55}}>{step}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Key benefits */}
          {kit.benefits && (
            <div style={{marginBottom:22}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
                <span style={{fontSize:13,fontWeight:700,color:C.ink}}>Key benefits</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {kit.benefits.map((b,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"10px 14px",background:C.surface,borderRadius:8,border:`1px solid ${C.border}`}}>
                    <div style={{width:24,height:24,borderRadius:6,background:C.tealLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                      <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M2 8l4 4 8-8" stroke={C.teal} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                    <div style={{fontSize:12,color:C.ink,lineHeight:1.5}}>{b}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Compatible vehicles */}
          {kit.compatible && (
            <div style={{marginBottom:22}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
                <span style={{fontSize:13,fontWeight:700,color:C.ink}}>Compatible vehicles</span>
              </div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {kit.compatible.map(v=>(
                  <div key={v} style={{fontSize:11,padding:"5px 12px",borderRadius:8,border:`1px solid ${C.border}`,color:C.inkMid,background:C.surface,fontWeight:500}}>{v}</div>
                ))}
              </div>
            </div>
          )}

          {/* Sell tips */}
          {kit.tips && (
            <div style={{marginBottom:22}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <div style={{width:3,height:16,background:kit.color,borderRadius:2}}/>
                <span style={{fontSize:13,fontWeight:700,color:C.ink}}>How to sell this to your customers</span>
              </div>
              {kit.tips.map((t,i)=>(
                <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"12px 14px",background:C.surface,borderRadius:8,marginBottom:8,border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:10,fontWeight:600,padding:"3px 8px",borderRadius:6,whiteSpace:"nowrap",marginTop:1,flexShrink:0,...tagColor[t.col]}}>{t.tag}</div>
                  <div style={{fontSize:13,color:C.ink,lineHeight:1.65}}>{t.text}</div>
                </div>
              ))}
            </div>
          )}

          {/* Pricing */}
          <div style={{background:C.surface,borderRadius:12,padding:"16px 18px",marginBottom:20,border:`1px solid ${C.border}`}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,textAlign:"center"}}>
              <div>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>Unit price</div>
                <div style={{fontSize:22,fontWeight:700,color:C.ink}}>${kit.price.toFixed(2)}</div>
              </div>
              <div>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>Case size</div>
                <div style={{fontSize:22,fontWeight:700,color:C.ink}}>{kit.case} units</div>
              </div>
              <div>
                <div style={{fontSize:11,color:C.inkLight,marginBottom:3}}>Case total</div>
                <div style={{fontSize:22,fontWeight:700,color:C.teal}}>${(kit.price*kit.case).toFixed(2)}</div>
              </div>
            </div>
          </div>

          <div style={{display:"flex",gap:10}}>
            <button style={{...S.btnSecondary,flex:1}} onClick={onClose}>Close</button>
            <button style={{...S.btnPrimary,flex:2,fontSize:14,padding:"12px 20px"}} onClick={()=>{onAddToCart({...kit,qty:1,mode:"full",units:kit.case,lineTotal:kit.price*kit.case});onClose();}}>
              Add case to cart — ${(kit.price*kit.case).toFixed(2)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProductCatalog({onSelectProduct, onAddToCart}) {
  const [search, setSearch] = useState("");
  const [activecat, setActiveCat] = useState("all");
  const [selectedKit, setSelectedKit] = useState(null);
  const [activeProducts, setActiveProducts] = useState(SHARED_PRODUCTS.getActive());
  const [activeKits, setActiveKits] = useState(() => SHARED_PRODUCTS.getActiveKits());
  const [viewMode, setViewMode] = useState("grid"); // grid | list
  const [sortBy, setSortBy] = useState("popular"); // popular | price-low | price-high | name | stock
  const [quickViewSku, setQuickViewSku] = useState(null);
  const [addedToCart, setAddedToCart] = useState(null); // flash animation for add-to-cart
  const [hoverSku, setHoverSku] = useState(null);

  useEffect(()=>{
    return SHARED_PRODUCTS.subscribe(({products, kits})=>{
      setActiveProducts(products);
      if(kits.length>0) setActiveKits(kits.filter(k=>k.active!==false));
    });
  },[]);

  // Flash "Added!" feedback
  const handleAddToCart = (item) => {
    onAddToCart(item);
    setAddedToCart(item.sku);
    setTimeout(()=>setAddedToCart(null), 1200);
  };

  const cats = [
    {key:"all", label:"All products", icon:"◉", count: activeProducts.length},
    {key:"kits", label:"Service kits", icon:"⚡", count: activeKits.length},
    {key:"fuel", label:"Fuel & engine", icon:"⛽", count: activeProducts.filter(p=>p.category==="fuel").length},
    {key:"emissions", label:"Emissions & DPF", icon:"🔧", count: activeProducts.filter(p=>p.category==="emissions").length},
    {key:"cleaning", label:"Cleaning", icon:"✦", count: activeProducts.filter(p=>p.category==="cleaning").length},
    {key:"steering", label:"Steering", icon:"⟳", count: activeProducts.filter(p=>p.category==="steering").length},
    {key:"accessories", label:"Accessories", icon:"◆", count: activeProducts.filter(p=>p.category==="accessories").length},
  ];

  const filteredProds = activeProducts.filter(p=> {
    const matchCat = activecat==="all" || activecat==="kits" ? true : p.category===activecat;
    const matchSearch = !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.sku.toLowerCase().includes(search.toLowerCase()) || p.desc?.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  // Sort products
  const sortProducts = (prods) => {
    const sorted = [...prods];
    if(sortBy==="price-low") sorted.sort((a,b)=>a.price-b.price);
    else if(sortBy==="price-high") sorted.sort((a,b)=>b.price-a.price);
    else if(sortBy==="name") sorted.sort((a,b)=>a.name.localeCompare(b.name));
    else if(sortBy==="stock") sorted.sort((a,b)=>b.stock-a.stock);
    return sorted;
  };

  const showKits = activecat==="all" || activecat==="kits";
  const showProds = activecat!=="kits";

  // Get category for a product SKU
  const getCatForSku = (sku) => { const found = activeProducts.find(x=>x.sku===sku); return found?.category || "fuel"; };

  // Quick view product
  const quickViewProduct = quickViewSku ? activeProducts.find(p=>p.sku===quickViewSku) : null;
  const quickViewCat = quickViewProduct ? getCatForSku(quickViewProduct.sku) : null;

  // Stock badge helper
  const StockBadge = ({stock}) => {
    if(stock <= 10) return <span style={{fontSize:9,fontWeight:600,padding:"2px 6px",borderRadius:4,background:C.redLight,color:C.red}}>Low stock · {stock} left</span>;
    if(stock <= 30) return <span style={{fontSize:9,fontWeight:600,padding:"2px 6px",borderRadius:4,background:C.amberLight,color:C.amber}}>{stock} in stock</span>;
    return <span style={{fontSize:9,fontWeight:500,padding:"2px 6px",borderRadius:4,background:C.tealLight,color:C.teal}}>{stock} in stock</span>;
  };

  // Volume savings callout
  const VolumeSavings = ({price}) => (
    <div style={{fontSize:9,color:C.teal,fontWeight:500,marginTop:2}}>
      6+ cases: ${(price*0.90).toFixed(2)} · 20+: ${(price*0.81).toFixed(2)}
    </div>
  );

  return (
    <div style={{padding:"0 24px 24px"}}>
      {selectedKit && <KitDetailModal kit={selectedKit} onClose={()=>setSelectedKit(null)} onAddToCart={handleAddToCart}/>}

      {/* ── HERO BANNER ── */}
      <div style={{background:`linear-gradient(135deg,${C.navy} 0%,#1a3a6b 50%,${C.blue} 100%)`,borderRadius:16,padding:"28px 32px",marginBottom:20,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-30,right:-30,width:200,height:200,borderRadius:"50%",background:"rgba(255,255,255,0.03)"}}/>
        <div style={{position:"absolute",bottom:-50,right:80,width:160,height:160,borderRadius:"50%",background:"rgba(255,255,255,0.02)"}}/>
        <div style={{position:"relative",zIndex:1,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:11,fontWeight:600,letterSpacing:"0.12em",color:"rgba(255,255,255,0.45)",textTransform:"uppercase",marginBottom:6}}>Distributor catalog</div>
            <div style={{fontSize:24,fontWeight:700,color:"#fff",marginBottom:6,lineHeight:1.2}}>Product catalog</div>
            <div style={{fontSize:13,color:"rgba(255,255,255,0.65)",lineHeight:1.5}}>TÜV certified · Nanotechnology formulas · {activeProducts.length} SKUs + {activeKits.length} service kits</div>
          </div>
          <div style={{display:"flex",gap:12,alignItems:"center"}}>
            <div style={{textAlign:"center",padding:"10px 18px",background:"rgba(255,255,255,0.08)",borderRadius:10,backdropFilter:"blur(8px)"}}>
              <div style={{fontSize:20,fontWeight:700,color:"#fff"}}>{activeProducts.length}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.5)"}}>Products</div>
            </div>
            <div style={{textAlign:"center",padding:"10px 18px",background:"rgba(255,255,255,0.08)",borderRadius:10,backdropFilter:"blur(8px)"}}>
              <div style={{fontSize:20,fontWeight:700,color:"#fff"}}>{activeKits.length}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.5)"}}>Kits</div>
            </div>
            <div style={{textAlign:"center",padding:"10px 18px",background:"rgba(13,122,95,0.3)",borderRadius:10,border:"1px solid rgba(13,122,95,0.4)"}}>
              <div style={{fontSize:14,fontWeight:700,color:"#34D399"}}>Up to 19%</div>
              <div style={{fontSize:10,color:"rgba(52,211,153,0.7)"}}>Volume savings</div>
            </div>
          </div>
        </div>
        {/* Search bar in hero */}
        <div style={{position:"relative",marginTop:18,maxWidth:480}}>
          <div style={{position:"absolute",left:14,top:"50%",transform:"translateY(-50%)",color:"rgba(255,255,255,0.4)",fontSize:16}}>⌕</div>
          <input
            style={{width:"100%",padding:"12px 16px 12px 40px",border:"1px solid rgba(255,255,255,0.15)",borderRadius:10,fontSize:13,color:"#fff",background:"rgba(255,255,255,0.08)",outline:"none",boxSizing:"border-box",backdropFilter:"blur(8px)"}}
            placeholder="Search products by name, SKU, or description..."
            value={search}
            onChange={e=>setSearch(e.target.value)}
          />
          {search && <button onClick={()=>setSearch("")} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",width:22,height:22,borderRadius:"50%",fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>}
        </div>
      </div>

      {/* ── TOOLBAR: Categories + View/Sort ── */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20,gap:16,flexWrap:"wrap"}}>
        {/* Category pills */}
        <div style={{display:"flex",gap:6,flexWrap:"wrap",flex:1}}>
          {cats.map(c=>{
            const isActive = activecat===c.key;
            return (
              <button key={c.key} onClick={()=>{setActiveCat(c.key);setSearch("");}}
                style={{padding:"7px 14px",borderRadius:10,border:`1.5px solid ${isActive?(c.key==="kits"?"#B8972A":C.blue):C.border}`,background:isActive?(c.key==="kits"?"linear-gradient(135deg,#B8972A,#D4A730)":C.blue):C.white,color:isActive?"#fff":C.inkMid,fontSize:12,cursor:"pointer",fontWeight:isActive?600:400,display:"flex",alignItems:"center",gap:5,transition:"all 0.2s",boxShadow:isActive?"0 2px 8px rgba(0,0,0,0.15)":"none"}}>
                <span style={{fontSize:11}}>{c.icon}</span>
                {c.label}
                <span style={{fontSize:10,opacity:isActive?0.8:0.5,marginLeft:2}}>({c.count})</span>
              </button>
            );
          })}
        </div>
        {/* View mode + Sort */}
        <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{padding:"6px 10px",border:`1px solid ${C.border}`,borderRadius:8,fontSize:11,color:C.inkMid,background:C.white,cursor:"pointer",outline:"none"}}>
            <option value="popular">Popular</option>
            <option value="price-low">Price: Low → High</option>
            <option value="price-high">Price: High → Low</option>
            <option value="name">Name A–Z</option>
            <option value="stock">Stock level</option>
          </select>
          <div style={{display:"flex",border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden"}}>
            <button onClick={()=>setViewMode("grid")} style={{padding:"6px 10px",background:viewMode==="grid"?C.blue:"transparent",color:viewMode==="grid"?"#fff":C.inkLight,border:"none",cursor:"pointer",fontSize:13}}>▦</button>
            <button onClick={()=>setViewMode("list")} style={{padding:"6px 10px",background:viewMode==="list"?C.blue:"transparent",color:viewMode==="list"?"#fff":C.inkLight,border:"none",cursor:"pointer",fontSize:13,borderLeft:`1px solid ${C.border}`}}>☰</button>
          </div>
        </div>
      </div>

      {/* ── PROMOTED BANNER — rotating deals ── */}
      {!search && activecat==="all" && (
        <div style={{background:`linear-gradient(135deg,#059669 0%,#0D7A5F 100%)`,borderRadius:14,padding:"18px 24px",marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",transition:"transform 0.15s"}}
          onMouseEnter={e=>e.currentTarget.style.transform="scale(1.005)"}
          onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}
          onClick={()=>setSelectedKit(activeKits[0])}
        >
          <div style={{display:"flex",alignItems:"center",gap:16}}>
            <div style={{width:48,height:48,borderRadius:12,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>⚡</div>
            <div>
              <div style={{fontSize:15,fontWeight:700,color:"#fff",marginBottom:2}}>Best seller: {activeKits[0]?.name || "DPF Cleaning Kit"}</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,0.75)"}}>Most popular kit — complete in-shop service solution · ${activeKits[0]?.price?.toFixed(2)}/unit</div>
            </div>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            <span style={{background:"rgba(255,255,255,0.15)",color:"#fff",fontSize:11,padding:"6px 14px",borderRadius:8,fontWeight:600}}>View kit →</span>
            <button style={{background:"#fff",color:C.teal,border:"none",padding:"8px 16px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer"}}
              onClick={e=>{e.stopPropagation();handleAddToCart({...activeKits[0],qty:1,mode:"full",units:activeKits[0].case,lineTotal:activeKits[0].price*activeKits[0].case});}}
            >Add to cart</button>
          </div>
        </div>
      )}

      {/* ── KITS SECTION ── */}
      {showKits && (
        <div style={{marginBottom:32}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
            <div style={{width:4,height:20,background:"linear-gradient(180deg,#B8972A,#D4A730)",borderRadius:2}}/>
            <span style={{fontSize:15,fontWeight:700,color:C.ink}}>Service kits</span>
            <span style={{fontSize:11,color:C.inkLight,background:C.surface,padding:"2px 8px",borderRadius:6}}>Save more with bundles</span>
            <div style={{height:1,flex:1,background:C.border}}/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:16}}>
            {activeKits.map(kit=>(
              <div key={kit.sku} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden",display:"flex",flexDirection:"column",cursor:"pointer",transition:"all 0.2s",position:"relative"}}
                onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 8px 30px rgba(0,0,0,0.12)";e.currentTarget.style.transform="translateY(-2px)";}}
                onMouseLeave={e=>{e.currentTarget.style.boxShadow="none";e.currentTarget.style.transform="translateY(0)";}}
              >
                {kit.tag==="Best seller" && <div style={{position:"absolute",top:12,right:12,background:"#EAB308",color:"#fff",fontSize:9,fontWeight:700,padding:"3px 8px",borderRadius:6,zIndex:1,letterSpacing:"0.04em",textTransform:"uppercase"}}>Best seller</div>}
                {/* Kit header */}
                <div style={{background:`linear-gradient(135deg,${kit.color},${kit.color}CC)`,padding:"18px 20px",display:"flex",gap:14,alignItems:"center"}}
                  onClick={()=>setSelectedKit(kit)}
                >
                  {kit.imageUrl && (
                    <img src={kit.imageUrl} alt={kit.name}
                      onError={e=>{e.target.style.display="none";}}
                      style={{width:54,height:54,borderRadius:8,objectFit:"cover",flexShrink:0,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.3)"}}/>
                  )}
                  <div style={{minWidth:0,flex:1}}>
                    <div style={{fontSize:9,fontWeight:700,letterSpacing:"0.14em",color:"rgba(255,255,255,0.5)",textTransform:"uppercase",marginBottom:5}}>{kit.badge} · KIT {kit.sku}</div>
                    <div style={{fontSize:17,fontWeight:700,color:"#FFFFFF",lineHeight:1.2}}>{kit.name}</div>
                  </div>
                </div>
                <div style={{padding:"16px 20px",flex:1}} onClick={()=>setSelectedKit(kit)}>
                  <div style={{fontSize:12,color:C.inkMid,lineHeight:1.65,marginBottom:12}}>{kit.desc}</div>
                  <div style={{marginBottom:12}}>
                    {kit.items.map((item,i)=>(
                      <div key={i} style={{fontSize:11,color:C.ink,padding:"5px 10px",display:"flex",gap:8,alignItems:"center",background:C.surface,borderRadius:6,marginBottom:4}}>
                        <span style={{color:C.teal,fontWeight:700,fontSize:13}}>✓</span><span style={{fontWeight:500}}>{item}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{background:C.tealLight,borderRadius:8,padding:"8px 12px",fontSize:11,color:C.teal,border:`1px solid rgba(13,122,95,0.15)`}}>{kit.highlight}</div>
                </div>
                <div style={{padding:"12px 20px 16px",borderTop:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <span style={{fontSize:20,fontWeight:700,color:C.ink}}>${kit.price.toFixed(2)}</span>
                    <span style={{fontSize:11,color:C.inkLight,marginLeft:4}}>/ unit</span>
                    <div style={{fontSize:10,color:C.inkLight}}>Case of {kit.case} · ${(kit.price*kit.case).toFixed(2)}/case</div>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <button style={{...S.btnSmall,padding:"7px 12px",borderRadius:8}} onClick={e=>{e.stopPropagation();setSelectedKit(kit);}}>Details</button>
                    <button style={{...S.btnPrimary,fontSize:12,padding:"7px 14px",borderRadius:8,position:"relative",overflow:"hidden"}}
                      onClick={e=>{e.stopPropagation();handleAddToCart({...kit,qty:1,mode:"full",units:kit.case,lineTotal:kit.price*kit.case});}}>
                      {addedToCart===kit.sku ? "✓ Added!" : "Add to cart"}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── INDIVIDUAL PRODUCTS ── */}
      {showProds && (()=>{
        // Group live products by category so the grid shows Supabase prices
        const byCat={};
        activeProducts.forEach(p=>{ const c=p.category||"fuel"; if(!byCat[c]) byCat[c]=[]; byCat[c].push(p); });
        const catOrder=["fuel","emissions","cleaning","steering","accessories"];
        return catOrder.filter(c=>byCat[c]&&byCat[c].length>0).map(cat=>{
        const prods=byCat[cat];
        if(activecat!=="all" && activecat!==cat) return null;
        const filtered = sortProducts(prods.filter(p=>
          !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.sku.toLowerCase().includes(search.toLowerCase()) || p.desc?.toLowerCase().includes(search.toLowerCase())
        ));
        if(filtered.length===0) return null;
        const catColor = CAT_COLORS[cat]||C.blue;
        return (
          <div key={cat} style={{marginBottom:28}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
              <div style={{width:4,height:20,background:catColor,borderRadius:2}}/>
              <span style={{fontSize:15,fontWeight:700,color:C.ink}}>{CAT_LABELS[cat]}</span>
              <span style={{fontSize:11,color:C.inkLight,background:C.surface,padding:"2px 8px",borderRadius:6}}>{filtered.length} products</span>
              <div style={{height:1,flex:1,background:C.border}}/>
            </div>

            {/* GRID VIEW */}
            {viewMode==="grid" && (
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))",gap:14}}>
                {filtered.map(p=>{
                  const isHover = hoverSku===p.sku;
                  const justAdded = addedToCart===p.sku;
                  return (
                    <div key={p.sku} style={{background:C.white,border:`1.5px solid ${isHover?catColor+"66":C.border}`,borderRadius:14,overflow:"hidden",display:"flex",flexDirection:"column",transition:"all 0.2s",position:"relative",transform:isHover?"translateY(-3px)":"none",boxShadow:isHover?"0 8px 28px rgba(0,0,0,0.10)":"0 1px 3px rgba(0,0,0,0.04)"}}
                      onMouseEnter={()=>setHoverSku(p.sku)}
                      onMouseLeave={()=>setHoverSku(null)}
                    >
                      {/* Low stock badge */}
                      {p.stock<=20 && <div style={{position:"absolute",top:10,left:10,zIndex:1}}><StockBadge stock={p.stock}/></div>}
                      {/* Quick view button on hover */}
                      {isHover && <button style={{position:"absolute",top:10,right:10,zIndex:1,background:"rgba(0,0,0,0.6)",color:"#fff",border:"none",padding:"4px 10px",borderRadius:6,fontSize:10,fontWeight:500,cursor:"pointer",backdropFilter:"blur(4px)"}}
                        onClick={e=>{e.stopPropagation();setQuickViewSku(p.sku);}}>Quick view</button>}

                      {/* Product image area */}
                      <div style={{background:`linear-gradient(145deg,${catColor}18,${catColor}06)`,padding:24,display:"flex",justifyContent:"center",alignItems:"center",borderBottom:`1px solid ${C.border}`,minHeight:110,cursor:"pointer",position:"relative"}}
                        onClick={()=>onSelectProduct(p)}
                      >
                        <ProductImage sku={p.sku} name={p.name} color={catColor} size={80} imageUrl={p.imageUrl}/>
                      </div>

                      <div style={{padding:"14px 16px",flex:1,display:"flex",flexDirection:"column"}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                          <span style={{fontSize:10,color:catColor,fontWeight:600,letterSpacing:"0.04em"}}>SKU {p.sku}</span>
                          <StockBadge stock={p.stock}/>
                        </div>
                        <div style={{fontSize:14,fontWeight:700,color:C.ink,marginBottom:5,lineHeight:1.3,cursor:"pointer"}}
                          onClick={()=>onSelectProduct(p)}
                        >{p.name}</div>
                        <div style={{fontSize:11,color:C.inkMid,lineHeight:1.6,marginBottom:12,flex:1,
                          overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>
                          {p.desc}
                        </div>

                        {/* Pricing block */}
                        <div style={{background:C.surface,borderRadius:8,padding:"10px 12px",marginBottom:12,border:`1px solid ${C.border}`}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <div>
                              <span style={{fontSize:20,fontWeight:700,color:C.ink}}>${p.price.toFixed(2)}</span>
                              <span style={{fontSize:10,color:C.inkLight,marginLeft:3}}>/ unit</span>
                            </div>
                            <div style={{textAlign:"right"}}>
                              <div style={{fontSize:11,color:C.inkMid,fontWeight:500}}>Case of {p.case}</div>
                              <div style={{fontSize:12,fontWeight:600,color:catColor}}>${(p.price*p.case).toFixed(2)}/case</div>
                            </div>
                          </div>
                          <VolumeSavings price={p.price}/>
                        </div>

                        {/* Action buttons */}
                        <div style={{display:"flex",gap:8}}>
                          <button style={{...S.btnSmall,flex:1,padding:"8px 10px",borderRadius:8,fontSize:11,fontWeight:500}} onClick={()=>onSelectProduct(p)}>View details</button>
                          <button style={{background:justAdded?C.teal:C.blue,color:"#fff",border:"none",flex:1.3,padding:"8px 10px",borderRadius:8,fontSize:11,fontWeight:600,cursor:"pointer",transition:"all 0.2s"}}
                            onClick={()=>handleAddToCart({...p,qty:1,mode:"full",units:p.case,lineTotal:p.price*p.case})}>
                            {justAdded ? "✓ Added!" : "Add to cart"}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* LIST VIEW */}
            {viewMode==="list" && (
              <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:12,overflow:"hidden"}}>
                {/* Header row */}
                <div style={{display:"grid",gridTemplateColumns:"44px 1fr 110px 80px 90px",gap:8,padding:"10px 14px",borderBottom:`1px solid ${C.border}`,background:C.surface}}>
                  <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}></span>
                  <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}>Product</span>
                  <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}>Price</span>
                  <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}>Case</span>
                  <span style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase"}}></span>
                </div>
                {filtered.map((p,idx)=>{
                  const justAdded = addedToCart===p.sku;
                  return (
                    <div key={p.sku} style={{display:"grid",gridTemplateColumns:"44px 1fr 110px 80px 90px",gap:8,padding:"10px 14px",borderBottom:idx<filtered.length-1?`1px solid ${C.border}`:"none",alignItems:"center",cursor:"pointer",transition:"background 0.15s"}}
                      onMouseEnter={e=>e.currentTarget.style.background=C.surface}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                    >
                      <div onClick={()=>onSelectProduct(p)}>
                        <ProductImage sku={p.sku} name={p.name} color={catColor} size={38} imageUrl={p.imageUrl}/>
                      </div>
                      <div onClick={()=>onSelectProduct(p)} style={{minWidth:0}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                          <span style={{fontSize:12,fontWeight:600,color:C.ink,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1,minWidth:0}}>{p.name}</span>
                          <span style={{flexShrink:0}}><StockBadge stock={p.stock}/></span>
                        </div>
                        <div style={{fontSize:10,color:C.inkLight,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>SKU {p.sku}</div>
                      </div>
                      <div>
                        <div style={{fontSize:14,fontWeight:700,color:C.ink}}>${p.price.toFixed(2)}<span style={{fontSize:10,fontWeight:400,color:C.inkLight}}>/u</span></div>
                        <VolumeSavings price={p.price}/>
                      </div>
                      <div>
                        <div style={{fontSize:11,fontWeight:600,color:C.ink}}>{p.case} units</div>
                        <div style={{fontSize:10,color:catColor}}>${(p.price*p.case).toFixed(2)}</div>
                      </div>
                      <div style={{display:"flex",gap:5}}>
                        <button style={{...S.btnSmall,padding:"6px 8px",borderRadius:6,fontSize:10}} onClick={e=>{e.stopPropagation();setQuickViewSku(p.sku);}}>View</button>
                        <button style={{background:justAdded?C.teal:C.blue,color:"#fff",border:"none",padding:"6px 10px",borderRadius:6,fontSize:10,fontWeight:600,cursor:"pointer",transition:"all 0.2s"}}
                          onClick={e=>{e.stopPropagation();handleAddToCart({...p,qty:1,mode:"full",units:p.case,lineTotal:p.price*p.case});}}>
                          {justAdded ? "✓" : "Add"}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      });})()}

      {/* ── CROSS-SELL FOOTER — only when viewing a category ── */}
      {activecat!=="all" && activecat!=="kits" && !search && (
        <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:14,padding:"20px 24px",marginTop:8}}>
          <div style={{fontSize:14,fontWeight:700,color:C.ink,marginBottom:4}}>Customers who buy {CAT_LABELS[activecat]} also order:</div>
          <div style={{fontSize:12,color:C.inkLight,marginBottom:14}}>Complete your service offering with complementary products</div>
          <div style={{display:"flex",gap:12,overflowX:"auto",paddingBottom:4}}>
            {activeProducts.filter(p=>p.category!==activecat).slice(0,5).map(p=>{
              const pCat = getCatForSku(p.sku);
              return (
                <div key={p.sku} style={{minWidth:180,background:C.surface,border:`1px solid ${C.border}`,borderRadius:10,padding:14,cursor:"pointer",flexShrink:0,transition:"all 0.15s"}}
                  onMouseEnter={e=>{e.currentTarget.style.borderColor=C.blue;e.currentTarget.style.transform="translateY(-2px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.transform="none";}}
                  onClick={()=>onSelectProduct(p)}
                >
                  <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:8}}>
                    <ProductImage sku={p.sku} name={p.name} color={CAT_COLORS[pCat]||C.navy} size={36} imageUrl={p.imageUrl}/>
                    <div>
                      <div style={{fontSize:12,fontWeight:600,color:C.ink}}>{p.name}</div>
                      <div style={{fontSize:10,color:C.inkLight}}>SKU {p.sku}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:14,fontWeight:700,color:C.ink}}>${p.price.toFixed(2)}</span>
                    <button style={{background:C.blue,color:"#fff",border:"none",padding:"4px 10px",borderRadius:6,fontSize:10,fontWeight:500,cursor:"pointer"}}
                      onClick={e=>{e.stopPropagation();handleAddToCart({...p,qty:1,mode:"full",units:p.case,lineTotal:p.price*p.case});}}>+ Add</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── QUICK VIEW MODAL ── */}
      {quickViewProduct && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:20}}
          onClick={()=>setQuickViewSku(null)}
        >
          <div style={{background:C.white,width:640,borderRadius:16,overflow:"hidden",maxHeight:"90vh",overflowY:"auto"}}
            onClick={e=>e.stopPropagation()}
          >
            {/* Header */}
            <div style={{background:`linear-gradient(135deg,${CAT_COLORS[quickViewCat]||C.navy},${CAT_COLORS[quickViewCat]||C.navy}CC)`,padding:"24px 28px",display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:16}}>
              <div style={{minWidth:0,flex:1}}>
                <div style={{fontSize:10,fontWeight:600,letterSpacing:"0.1em",color:"rgba(255,255,255,0.5)",marginBottom:4}}>SKU {quickViewProduct.sku} · {CAT_LABELS[quickViewCat]}</div>
                <div style={{fontSize:22,fontWeight:700,color:"#fff",lineHeight:1.2}}>{quickViewProduct.name}</div>
              </div>
              {quickViewProduct.imageUrl && (
                <img src={quickViewProduct.imageUrl} alt={quickViewProduct.name}
                  onError={e=>{e.target.style.display="none";}}
                  style={{width:72,height:72,borderRadius:10,objectFit:"cover",flexShrink:0,background:"rgba(255,255,255,0.15)",border:"1px solid rgba(255,255,255,0.3)"}}/>
              )}
              <button onClick={()=>setQuickViewSku(null)} style={{background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",width:32,height:32,borderRadius:"50%",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>×</button>
            </div>
            <div style={{padding:"24px 28px"}}>
              <div style={{fontSize:13,color:C.inkMid,lineHeight:1.7,marginBottom:20}}>{quickViewProduct.desc}</div>

              {/* Quick stats */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:20}}>
                <div style={{background:C.surface,borderRadius:10,padding:"12px 14px",textAlign:"center",border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:22,fontWeight:700,color:C.ink}}>${quickViewProduct.price.toFixed(2)}</div>
                  <div style={{fontSize:10,color:C.inkLight}}>Per unit</div>
                </div>
                <div style={{background:C.surface,borderRadius:10,padding:"12px 14px",textAlign:"center",border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:22,fontWeight:700,color:C.ink}}>{quickViewProduct.case}</div>
                  <div style={{fontSize:10,color:C.inkLight}}>Units per case</div>
                </div>
                <div style={{background:C.surface,borderRadius:10,padding:"12px 14px",textAlign:"center",border:`1px solid ${C.border}`}}>
                  <div style={{fontSize:22,fontWeight:700,color:C.teal}}>${(quickViewProduct.price*quickViewProduct.case).toFixed(2)}</div>
                  <div style={{fontSize:10,color:C.inkLight}}>Case total</div>
                </div>
              </div>

              {/* Volume pricing */}
              <div style={{background:C.tealLight,borderRadius:10,padding:"12px 16px",marginBottom:20,border:`1px solid rgba(13,122,95,0.15)`}}>
                <div style={{fontSize:11,fontWeight:600,color:C.teal,marginBottom:8}}>Volume pricing</div>
                <div style={{display:"flex",gap:16}}>
                  {[["1–5 cases",quickViewProduct.price,""],["6–20 cases",quickViewProduct.price*0.90,"10% off"],["20+ cases",quickViewProduct.price*0.81,"19% off"]].map(([label,pr,save])=>(
                    <div key={label} style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:14,fontWeight:700,color:C.ink}}>${pr.toFixed(2)}</div>
                      <div style={{fontSize:10,color:C.inkLight}}>{label}</div>
                      {save && <div style={{fontSize:9,fontWeight:600,color:C.teal,marginTop:1}}>{save}</div>}
                    </div>
                  ))}
                </div>
              </div>

              {/* Key benefits */}
              {quickViewProduct.benefits && (
                <div style={{marginBottom:20}}>
                  <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:8}}>Key benefits</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                    {quickViewProduct.benefits.map((b,i)=>(
                      <div key={i} style={{display:"flex",gap:8,alignItems:"center",padding:"6px 10px",background:C.surface,borderRadius:6,fontSize:11,color:C.ink}}>
                        <span style={{color:C.teal,fontWeight:700}}>✓</span>{b}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Compatible vehicles */}
              {quickViewProduct.compatible && (
                <div style={{marginBottom:24}}>
                  <div style={{fontSize:12,fontWeight:600,color:C.ink,marginBottom:8}}>Compatible with</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                    {quickViewProduct.compatible.map(v=><span key={v} style={{fontSize:10,padding:"3px 10px",borderRadius:6,border:`1px solid ${C.border}`,color:C.inkMid,background:C.surface}}>{v}</span>)}
                  </div>
                </div>
              )}

              {/* Actions */}
              <div style={{display:"flex",gap:10}}>
                <button style={{...S.btnSecondary,flex:1}} onClick={()=>{setQuickViewSku(null);onSelectProduct(quickViewProduct);}}>Full details →</button>
                <button style={{...S.btnPrimary,flex:2,fontSize:14,padding:"12px 20px"}}
                  onClick={()=>{handleAddToCart({...quickViewProduct,qty:1,mode:"full",units:quickViewProduct.case,lineTotal:quickViewProduct.price*quickViewProduct.case});setQuickViewSku(null);}}>
                  Add case to cart — ${(quickViewProduct.price*quickViewProduct.case).toFixed(2)}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── EMPTY STATE ── */}
      {search && filteredProds.length===0 && (
        <div style={{textAlign:"center",padding:"60px 20px",color:C.inkLight}}>
          <div style={{width:64,height:64,borderRadius:"50%",background:C.surface,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px",fontSize:28}}>🔍</div>
          <div style={{fontSize:16,fontWeight:600,color:C.ink,marginBottom:6}}>No products match "{search}"</div>
          <div style={{fontSize:13,color:C.inkLight,marginBottom:16}}>Try a different keyword or browse by category</div>
          <button style={{...S.btnPrimary,padding:"10px 24px"}} onClick={()=>setSearch("")}>Clear search</button>
        </div>
      )}
    </div>
  );
}

// ── PORTAL ────────────────────────────────────────────────────────────────────
function Portal({onLogout, userRole, user}) {
  const [page,setPage]=useState("dashboard");
  const [activeProd,setActiveProd]=useState(PRODUCTS.emissions[1]);
  const [showAdmin,setShowAdmin]=useState(false);
  const [showProfile,setShowProfile]=useState(false);

  // Phase C — material-order sync warning for the customer portal. Populated
  // by CustomerMarketing.placeOrder when the Supabase write to material_orders
  // fails but localStorage succeeded. Amber banner persists until the mount/
  // realtime retry observes the row in Supabase (auto-clear) or the dealer
  // dismisses. Same UX pattern as Phase A/B banners.
  const [materialOrderSyncPendingIds, setMaterialOrderSyncPendingIds] = useState([]);
  const markMaterialOrderSyncPending = (id) => {
    setMaterialOrderSyncPendingIds(prev => prev.includes(id) ? prev : [...prev, id]);
  };

  const [editingProfile,setEditingProfile]=useState(false);
  const [custRepSearchOpen,setCustRepSearchOpen]=useState(false);
  // Lower-cased emails / names of reps whose profile is deleted or paused (from Supabase profiles).
  // Used ONLY to hide them in the rep picker below; SHARED_REP_PROFILES itself is never trimmed.
  const [inactiveRepKeys,setInactiveRepKeys]=useState(()=>({emails:new Set(),names:new Set()}));
  const [custRepSearchQ,setCustRepSearchQ]=useState("");
  const custKey = user?.id || user?.email || "demo_customer";
  const [profileData,setProfileData]=useState(()=>{
    // Priority: 1) shared customer profile store (admin edits), 2) user.profile from Supabase login, 3) demo defaults
    const shared = SHARED_CUSTOMER_PROFILES.get(custKey) || (user?.email && SHARED_CUSTOMER_PROFILES.get(user.email));
    if(shared && (shared.company || shared.contact)) return {
      name:shared.company||"", contact:shared.contact||"", email:shared.email||"", phone:shared.phone||"",
      address:shared.address||"", city:shared.city||"", state:shared.state||"", zip:shared.zip||"", ein:shared.ein||"", tier:shared.tier||"Dealer",
      avatar:"", refCode:shared.refCode||"", rep:shared.rep||""
    };
    if(user?.profile) {
      const p = user.profile;
      const meta = user.user_metadata || {};
      return {
        name: p.company || meta.company || user.name || "",
        contact: p.full_name || meta.full_name || "",
        email: p.email || user.email || "",
        phone: p.phone || meta.phone || "",
        address: p.address || meta.address || "",
        city:"", state:"", zip:"",
        ein: p.ein || meta.ein || "",
        tier: p.tier || meta.tier || "Dealer",
        avatar:"",
        refCode: p.ref_code || meta.ref_code || "",
        rep: p.rep || meta.rep || ""
      };
    }
    // FIX: Only show Apex demo data in demo mode (no user). Real users get their auth metadata or empty fields.
    if(!user) return {name:"Apex Car Care LLC",contact:"John Smith",email:"john@apexcarcare.com",phone:"619-555-0100",address:"1234 Industrial Blvd, Suite 100",city:"San Diego",state:"CA",zip:"92101",ein:"",tier:"Distributor",avatar:"",refCode:"MPC-APEX-7291",rep:"Marcus T."};
    // Real user but profile not loaded yet — use auth metadata as fallback
    const meta = user.user_metadata || {};
    return {name:meta.company||user.name||"",contact:meta.full_name||"",email:user.email||"",phone:meta.phone||"",address:meta.address||"",city:"",state:"",zip:"",ein:meta.ein||"",tier:meta.tier||"Dealer",avatar:"",refCode:meta.ref_code||"",rep:meta.rep||""};
  });

  // Approved payment terms for this customer — set by admin, default to CC-only until admin configures
  const [approvedTerms,setApprovedTerms]=useState(["cc","ach","net30","net60"]);
  // Fetch FRESH profile from Supabase on mount — ensures latest admin edits (rep assignment etc.) are loaded
  const custEmail = user?.email;
  useEffect(()=>{
    if(!user?.id) return;
    getProfile(user.id).then(p=>{
      if(!p) return;
      setProfileData(prev=>{
        const freshCompany = p.company||prev.name;
        const freshContact = p.full_name||prev.contact;
        // Rep: use Supabase value if non-empty, otherwise keep local value (localStorage/shared store may have it even if Supabase doesn't)
        const freshRep = p.rep || prev.rep || "";
        const changed = freshRep!==prev.rep || freshCompany!==prev.name || freshContact!==prev.contact || (p.phone||"")!==prev.phone;
        if(!changed) return prev;
        return {...prev, name:freshCompany, contact:freshContact, phone:p.phone||prev.phone, address:p.address||prev.address, ein:p.ein||prev.ein, tier:p.tier||prev.tier, rep:freshRep, refCode:p.ref_code||prev.refCode};
      });
    }).catch(e=>console.warn("[Portal] getProfile failed:", e?.message||e));
    // Fetch customer assignment (rep + approved terms) from dedicated store
    getCustomerAssignment(user.id).then(assignment=>{
      // Backfill ref code into customer_settings if it wasn't saved there yet. This lets
      // the admin search find pre-existing accounts whose ref code only lives in auth
      // metadata (e.g. accounts that signed up before customer_settings included ref_code).
      const myRefCode = user.user_metadata?.ref_code || assignment?.refCode;
      if(myRefCode && !assignment?.refCode) {
        saveCustomerAssignment(user.id, { refCode: myRefCode }).catch(e=>console.warn("[Portal] refCode backfill failed (RLS blocks customer writes — this is OK):", e?.message||e));
      }
      if(!assignment) { console.warn("[Portal] No customer assignment found — rep will show as 'Not yet assigned'. Check customer_settings table in Supabase for user:", user.id); return; }
      // Apply rep if admin assigned one
      if(assignment.rep) { console.info("[Portal] Rep loaded from customer_settings:", assignment.rep); setProfileData(prev=>prev.rep===assignment.rep?prev:{...prev,rep:assignment.rep}); }
      else { console.info("[Portal] customer_settings row exists but rep field is empty for user:", user.id); }
      // Apply approved terms restriction
      if(Array.isArray(assignment.terms) && assignment.terms.length>0) setApprovedTerms(assignment.terms);
    }).catch(e=>console.warn("[Portal] getCustomerAssignment failed:", e?.message||e));
    // Fetch all approved reps from Supabase — populate SHARED_REP_PROFILES so dropdown shows all reps
    getAllProfiles().then(profiles=>{
      const reps=profiles.filter(p=>(p.role==="rep"||p.tier==="rep")&&p.approved);
      reps.forEach(r=>{
        const repData={name:r.full_name||"—",email:r.email,phone:r.phone||"",territory:r.address||"",refCode:r.ref_code||""};
        SHARED_REP_PROFILES.set(r.id,repData);
        if(r.email) SHARED_REP_PROFILES.set(r.email,repData);
      });
      // Deleted/paused reps are hidden from the picker (display filter only). SHARED_REP_PROFILES is
      // NOT trimmed: it holds avatars / phone / territory that Restore cannot recover.
      try{
        // isLive / supabaseId mark these as loaded profile rows: a rep that is present here and not approved
        // is excluded too. A dealer device usually only receives its own row (profiles RLS), so the set is
        // then empty and the picker behaves exactly as before.
        const asAccts=profiles.map(p=>({id:p.id,isLive:true,supabaseId:p.id,role:p.role,tier:p.tier,status:deriveAccountStatus(p),email:p.email,contact:p.full_name||p.name}));
        setInactiveRepKeys({emails:pickerBlockedRepEmailSet(asAccts),names:pickerBlockedRepNameSet(asAccts)});
      }catch(e){ console.warn("[Portal] inactive rep filter failed:", e?.message||e); }
    }).catch(e=>console.warn("[Portal] getAllProfiles failed:", e?.message||e));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.id]);

  // ── Portal-level portal_orders sync ──────────────────────────────────────
  // Every child page (Dashboard / Orders / Invoices) reads invoices from
  // SHARED_INVOICES via its own subscription. If the dealer lands directly
  // on /invoices (URL bar), none of the sibling pages' syncFromDb has ever
  // run — so SHARED_INVOICES only holds whatever's cached in this browser's
  // localStorage. New rep-placed invoices created on ANOTHER device stay
  // invisible until the dealer happens to visit /orders (which has its own
  // sync). The Dashboard seeing the order but /invoices missing it was the
  // exact symptom reported.
  //
  // Fix: run the sync at the Portal level so every page benefits. Runs on
  // mount, on window focus, and on any Supabase realtime event for
  // portal_orders — so if admin or the rep adds an order on another device,
  // this dealer's open browser picks it up within a second, regardless of
  // which page they're on.
  useEffect(()=>{
    if(!profileData.name && !user?.id) return;
    let mounted = true;
    const myName = profileData.name;
    const myUserId = user?.id || "";
    const portalSyncFromDb = async () => {
      try {
        const fetchStartedAt = Date.now();   // a revert is skipped for adjustments newer than this
        const rows = await getAllPortalOrders();
        if(!mounted || !rows || rows.length === 0) return;
        const mineRows = rows.filter(r => {
          if(myUserId && r.user_id === myUserId) return true;
          if((r.customer||"") === myName) return true;
          return false;
        });
        if(mineRows.length === 0) return;
        const existing = SHARED_INVOICES.getAll();
        const existingById = new Map(existing.map(i => [i.id, i]));
        const existingByOrderId = new Map(existing.filter(i=>i.orderId).map(i => [i.orderId, i]));
        mineRows.forEach(r => {
          const invId   = r.invoice_ref || r.invoice_id || r.order_ref || r.order_id || r.id;
          const orderId = r.order_ref   || r.order_id   || r.id;
          const match   = existingById.get(invId) || existingByOrderId.get(orderId);
          const shippingPatch = {};
          if(r.tracking        != null) shippingPatch.tracking        = r.tracking;
          if(r.carrier         != null) shippingPatch.carrier         = r.carrier;
          if(r.shipped_date    != null) shippingPatch.shippedDate     = r.shipped_date;
          if(r.delivered_date  != null) shippingPatch.deliveredDate   = r.delivered_date;
          if(r.shipping_status != null) shippingPatch.shippingStatus  = r.shipping_status;
          if(r.shipping_notes  != null) shippingPatch.notes           = r.shipping_notes;
          if(match){
            const changed = Object.entries(shippingPatch).some(([k,v]) => match[k] !== v);
            if(changed && Object.keys(shippingPatch).length) {
              SHARED_INVOICES.updateShipping(match.id, shippingPatch);
            }
          } else {
            let items = [];
            try { items = typeof r.items === "string" ? JSON.parse(r.items) : (r.items || []); } catch(e) {}
            SHARED_INVOICES.add({
              id: invId, orderId,
              date: r.created_at ? new Date(r.created_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
              customer: r.customer || myName || "Customer", items,
              userId: r.user_id || "",
              customerEmail: r.customer_email || "",
              total: r.total || 0, status: r.status || "outstanding",
              paymentTerms: r.payment_terms || "", rep: r.rep || "",
              source: r.source || "portal_order", fromDb: true,
              ...shippingPatch,
              // Account discount (0034): {} for a row without one, so older invoices are exactly as before.
              ...invoiceDiscountFields(r),
            });
          }
        });
        // Forward-only cancel propagation (admin void -> dealer device).
        SHARED_INVOICES.applyServerState(mineRows, { allowRevert: true, fetchStartedAt }); // getAllPortalOrders batch: newest per invoice
      } catch(e) { console.warn("[Portal] portal_orders sync failed:", e?.message || e); }
    };
    // Initial sync so invoices are populated before any child page renders.
    portalSyncFromDb();
    // Focus resync — cheap belt-and-suspenders.
    const onFocus = () => { portalSyncFromDb(); };
    window.addEventListener("focus", onFocus);
    // Realtime subscription — admin adding a rep invoice on another device
    // fires a postgres_changes event here and the dealer's open page
    // refreshes within ~1s. Uses the same channel helper the admin banner
    // uses (0011 migration already put portal_orders in supabase_realtime).
    const unsub = subscribePortalOrders(() => { portalSyncFromDb(); });
    return ()=>{
      mounted = false;
      window.removeEventListener("focus", onFocus);
      unsub && unsub();
    };
  },[profileData.name, user?.id]);

  // Phase C — customer-side material_orders hydrate + backfill + subscribe.
  // Pulls this dealer's own material orders (source='customer', user_id=me)
  // from Supabase into SHARED_MATERIAL_ORDERS so the Orders tab's material-
  // rows list stays consistent across devices. Backfills any localStorage-
  // only entries via client_id exact-key dedupe. Never clears localStorage.
  useEffect(() => {
    if (!user?.id) return;
    let mounted = true;
    const myId = user.id;
    const dbRowToOrder = (r) => ({
      id: r.client_id || String(r.id),
      _supabaseRowId: r.id,
      source: r.source || "customer",
      accountName: r.account_name || profileData.name || "",
      userId: r.user_id || myId,
      items: Array.isArray(r.items) ? r.items : [],
      total: Number(r.total) || 0,
      status: r.status || "pending",
      shippedDate: r.shipped_date || null,
      date: r.placed_at ? new Date(r.placed_at).toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"}) : "",
      placedAt: r.placed_at || new Date().toISOString(),
      fromDb: true,
    });
    const syncCustMaterialOrders = async () => {
      try {
        const rows = await listMaterialOrders({ userId: myId });
        if (!mounted) return;
        const existing = SHARED_MATERIAL_ORDERS.getAll();
        const existingIds = new Set(existing.map(o => String(o.id)));
        let added = 0;
        for (const r of rows) {
          const o = dbRowToOrder(r);
          if (existingIds.has(String(o.id))) {
            setMaterialOrderSyncPendingIds(prev => prev.filter(k => String(k) !== String(o.id)));
            continue;
          }
          SHARED_MATERIAL_ORDERS.add(o);
          existingIds.add(String(o.id));
          added++;
        }
        if (added > 0) console.info(`[Portal material_orders hydrate] merged ${added} row(s) from Supabase.`);

        // Backfill — push any localStorage-only source='customer' rows
        // belonging to THIS user that aren't yet in Supabase. Idempotent.
        const local = SHARED_MATERIAL_ORDERS.getAll();
        const supabaseClientIds = new Set((rows || []).map(r => String(r.client_id || "")));
        let synced = 0, inserted = 0, failed = 0;
        for (const o of local) {
          if (!mounted) break;
          if (!o || !o.id) continue;
          if (o.fromDb) continue;
          if (o.source && o.source !== 'customer') continue;
          if (o.userId && String(o.userId) !== String(myId)) continue;
          if (supabaseClientIds.has(String(o.id))) { synced++; continue; }
          const row = await upsertMaterialOrder({
            clientId: String(o.id),
            orderRef: String(o.id),
            source: 'customer',
            accountName: o.accountName || profileData.name || "Customer",
            repName: null,
            repId: null,
            userId: myId,
            items: Array.isArray(o.items) ? o.items : [],
            total: Number(o.total) || 0,
            status: o.status || 'pending',
            placedAt: o.placedAt || new Date().toISOString(),
          });
          if (row) { inserted++; }
          else { failed++; markMaterialOrderSyncPending(String(o.id)); }
        }
        if (inserted > 0 || failed > 0) {
          console.info(`[Portal material_orders backfill] ${synced} already synced, ${inserted} newly inserted, ${failed} failed.`);
        }
      } catch(e) { console.warn("[Portal material_orders] sync failed:", e?.message || e); }
    };
    syncCustMaterialOrders();
    const unsubMO = subscribeMaterialOrders({ userId: myId }, async () => {
      if (!mounted) return;
      await syncCustMaterialOrders();
    });
    return () => { mounted = false; if (typeof unsubMO === "function") unsubMO(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, profileData.name]);

  // Sync profile from shared store (admin edits propagate here in real-time)
  useEffect(()=>{
    const unsub = SHARED_CUSTOMER_PROFILES.subscribe((profiles)=>{
      const updated = profiles[custKey] || (custEmail && profiles[custEmail]);
      if(updated && (updated.company || updated.contact)) {
        setProfileData(prev => {
          // FIX (2026-04-20): rep field used to overwrite prev.rep with an
          // empty string whenever `updated.rep !== undefined`. The auth
          // state-change handler writes the full profile payload on every
          // session refresh — if Supabase profile.rep is null, meta.rep is
          // null, and existingCustomer.rep had previously been cleared by
          // this same bug, the payload carried rep:"" which this subscriber
          // then stamped onto prev.rep, clearing the rep name in the
          // customer's sidebar. Symptom: "Your sales rep" flashes to "Not
          // yet assigned" and comes back on refresh (because refresh
          // re-fetches customer_settings which restores the real rep).
          //
          // Fix: use the same `||` preserve-prev pattern every other field
          // here uses. Empty string means "no new rep to apply"; admin's
          // explicit clear propagates via the dedicated customer_settings
          // path (getCustomerAssignment on next mount), not via this
          // subscription.
          const changed = updated.company!==prev.name || updated.contact!==prev.contact || updated.email!==prev.email || updated.phone!==prev.phone || updated.address!==prev.address || (updated.rep && updated.rep !== prev.rep) || (updated.city||"")!==prev.city || (updated.state||"")!==prev.state || (updated.zip||"")!==prev.zip;
          if(!changed) return prev;
          return { ...prev, name:updated.company||prev.name, contact:updated.contact||prev.contact, email:updated.email||prev.email, phone:updated.phone||prev.phone, address:updated.address||prev.address, city:updated.city||prev.city, state:updated.state||prev.state, zip:updated.zip||prev.zip, ein:updated.ein||prev.ein, tier:updated.tier||prev.tier, rep:updated.rep || prev.rep };
        });
      }
    });
    return unsub;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[custKey, custEmail]);

  // Fire payment reminders 1 day before due date for this customer's unpaid invoices
  useEffect(()=>{
    if(!profileData.name || !profileData.email) return;
    // Same rule as the dealer Invoices page (isInvoiceOfDealer): exact company name, plus an office invoice found by account id.
    const myInvoices = SHARED_INVOICES.getAll().filter(inv=>isInvoiceOfDealer(inv,profileData.name,user?.id||""));
    sendDueTomorrowReminders(myInvoices,()=>profileData.email);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[profileData.name]);

  // Resolve assigned rep info for sidebar display
  const assignedRepInfo = (() => {
    const repName = profileData.rep;
    if(!repName) return null;
    // Look up rep contact info from shared rep profiles store
    const allRepProfiles = SHARED_REP_PROFILES.getAll ? SHARED_REP_PROFILES.getAll() : {};
    const match = Object.values(allRepProfiles).find(r => r.name === repName);
    if(match) return { name:match.name, phone:match.phone||"", email:match.email||"" };
    return { name:repName, phone:"", email:"" };
  })();

  // Dynamic customer discount — synced from admin via SHARED_SETTINGS (persisted in localStorage).
  // FIX: previously fell back to CUSTOMER_DISCOUNT_DEFAULT (=5) whenever stored was 0, which
  // silently applied a 5% discount on every account where admin had NOT configured one.
  // Now: whatever admin wrote (including 0) is the truth. Only undefined/null falls to 0.
  const [customerDiscount, setCustomerDiscount] = useState(()=>{
    const stored = SHARED_SETTINGS.getCustomerDiscount(profileData.name);
    return stored == null ? 0 : stored;
  });
  useEffect(()=>{
    // Hydrate from store on mount
    const stored = SHARED_SETTINGS.getCustomerDiscount(profileData.name);
    if(stored != null) setCustomerDiscount(stored);
    // Subscribe to live admin changes — treat any number (including 0) as authoritative.
    return SHARED_SETTINGS.subscribe(({customerDiscounts})=>{
      const disc = customerDiscounts[profileData.name];
      if(disc !== undefined) setCustomerDiscount(disc == null ? 0 : disc);
    });
  },[profileData.name]);
  const [editForm,setEditForm]=useState({...profileData});
  const saveProfile=()=>{
    setProfileData({...editForm});
    setEditingProfile(false);
    // Build combined address for Supabase (single column) from separate fields
    const fullAddr = [editForm.address, [editForm.city, editForm.state, editForm.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    // Persist to shared store so admin sees changes — include city/state/zip for checkout form
    const payload = { company:editForm.name, contact:editForm.contact, email:editForm.email, phone:editForm.phone, address:fullAddr||editForm.address, city:editForm.city||"", state:editForm.state||"", zip:editForm.zip||"", ein:editForm.ein, tier:editForm.tier, refCode:editForm.refCode, rep:editForm.rep||"" };
    SHARED_CUSTOMER_PROFILES.set(custKey, payload);
    if(user?.email) SHARED_CUSTOMER_PROFILES.set(user.email, payload);
    // Persist to Supabase with retry — ensures rep survives page refresh
    if(user?.id) {
      const dbPayload = { company:editForm.name, full_name:editForm.contact, phone:editForm.phone, address:fullAddr||editForm.address, ein:editForm.ein, tier:editForm.tier, rep:editForm.rep||"" };
      updateProfile(user.id, dbPayload).catch(e=>{
        console.warn("Profile DB sync failed, retrying:",e.message);
        // Retry once after 2 seconds
        setTimeout(()=>{ updateProfile(user.id, dbPayload).catch(e2=>console.warn("Profile DB retry failed:",e2.message)); },2000);
      });
    }
  };
  const [avatarState,setAvatarState]=useState({kind:"idle",msg:""});
  const cancelEditProfile=()=>{setEditForm({...profileData});setEditingProfile(false);setAvatarState({kind:"idle",msg:""});};
  const profileInitials=(profileData.contact||profileData.name||"U").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
  // Previously URL.createObjectURL(file) → blob URL that dies on refresh.
  // Now we upload to Supabase Storage so the URL persists across sessions
  // and devices.
  const handleAvatarUpload=async(e)=>{
    const file=e.target.files?.[0];
    if(!file) return;
    if(!user?.id) { setAvatarState({kind:"error",msg:"Sign in first."}); return; }
    setAvatarState({kind:"uploading",msg:"Uploading…"});
    try {
      const url = await uploadAvatar(file, user.id);
      setEditForm(f=>({...f,avatar:url}));
      setAvatarState({kind:"success",msg:"Uploaded!"});
      setTimeout(()=>setAvatarState({kind:"idle",msg:""}), 1800);
    } catch(err) {
      console.warn("Avatar upload failed:", err?.message);
      setAvatarState({kind:"error",msg: err?.message || "Upload failed. Try again."});
    }
  };
  // Demo mode = no Supabase user (dev bypass); real users start with empty cart
  const isDemo = !user;
  const cartStorageKey = `mpcare_cart_${custKey}`;
  const [cart,setCart]=useState(()=>{
    if(!isDemo) {
      // Restore cart from localStorage for real accounts
      try { const saved=localStorage.getItem(cartStorageKey); if(saved){const parsed=JSON.parse(saved); if(Array.isArray(parsed)&&parsed.length>0) return parsed;} } catch(e){}
      return [];
    }
    return [
      {id:"c1",...PRODUCTS.emissions[0],qty:2,mode:"full",units:PRODUCTS.emissions[0].case*2,lineTotal:PRODUCTS.emissions[0].price*PRODUCTS.emissions[0].case*2},
      {id:"c2",...PRODUCTS.fuel[0],qty:1,mode:"full",units:PRODUCTS.fuel[0].case,lineTotal:PRODUCTS.fuel[0].price*PRODUCTS.fuel[0].case},
    ];
  });
  const [highlightInvoice, setHighlightInvoice] = useState(null);
  // Persist cart to localStorage so it survives page refresh
  useEffect(()=>{
    if(isDemo) return;
    try { localStorage.setItem(cartStorageKey, JSON.stringify(cart)); } catch(e){}
  },[cart,cartStorageKey,isDemo]);
  const addToCart=(p,qty,mode,mixItems)=>{
    // Handle pre-built cart item objects (from ProductCatalog quick-add and KitDetailModal)
    if(p && typeof p === "object" && p.lineTotal !== undefined && qty === undefined) {
      setCart(c=>[...c,{id:`c${Date.now()}`,...p}]);
      setPage("cart");
      return;
    }
    // PR-V2A: variation matrix entry point. mixItems carries an array of
    // {sku, label, price, qty} variation rows from ProductDetail's matrix.
    // Each row with qty > 0 becomes one cart line item, with the parent's
    // product fields spread first and then variation overrides for sku /
    // name / price / stock. The cart line shape stays compatible with the
    // existing renderer because item.name carries the variation label
    // baked in; downstream invoice serialization works without any
    // special-case branches.
    if(mode==="variation-batch") {
      const rows = Array.isArray(mixItems) ? mixItems : [];
      const cs = Math.max(1, Number(p.case) || 1);
      const newItems = rows
        .filter(r => r && Number(r.qty) > 0 && r.sku)
        .map(r => {
          const variationPrice = Number(r.price) || 0;
          const cases = Number(r.qty) || 0;
          const units = cs * cases;
          return {
            id:`c${Date.now()}_${r.sku}_${Math.random().toString(36).slice(2,6)}`,
            ...p,
            sku: r.sku,
            name: r.label ? `${p.name} — ${r.label}` : `${p.name} (${r.sku})`,
            price: variationPrice,
            stock: undefined, // variation stock is per-row, parent stock no longer meaningful here
            parentSku: p.sku,
            variationLabel: r.label || "",
            qty: cases,
            mode: "variation",
            units,
            lineTotal: variationPrice * units,
          };
        });
      if (newItems.length === 0) return;
      setCart(c=>[...c, ...newItems]);
      setPage("cart");
      return;
    }
    const halfCase=Math.ceil(p.case/2);
    let units,lineTotal;
    if(mode==="half"){units=halfCase;lineTotal=p.price*halfCase;}
    else if(mode==="mix"&&mixItems){
      units=mixItems.reduce((s,r)=>s+r.qty,0);
      lineTotal=mixItems.reduce((s,r)=>{const prod=[...SHARED_PRODUCTS.getActive(),...SHARED_PRODUCTS.getActiveKits()].find(x=>x.sku===r.sku);return s+(prod?prod.price*r.qty:0);},0);
    } else {
      const unitPrice=qty>=20?p.price*0.81:qty>=6?p.price*0.90:p.price;
      units=p.case*qty;lineTotal=unitPrice*units;
    }
    setCart(c=>[...c,{id:`c${Date.now()}`,...p,qty,mode,units,lineTotal,mixItems}]);
    setPage("cart");
  };
  // URL routing — sync page state to browser URL (must be before any early returns for hooks rule)
  const crumbDefs=page==="product"?[{label:"Products",pg:"catalog"},{label:activeProd?.name,pg:null}]:page==="checkout"?[{label:"Cart",pg:"cart"},{label:"Checkout",pg:null}]:null;
  const pageTitle={dashboard:"Dashboard",catalog:"Products",product:"Products",orders:"My orders",cart:"Cart",checkout:"Checkout",invoices:"Invoices","cust-training":"Training & demos","cust-marketing":"Marketing materials","cust-tools":"Tool lending","cust-team":"My team & certification"};
  useEffect(()=>{
    if(showAdmin) return; // skip URL sync when admin panel is open
    // Every page gets its own path (including /dashboard) so the URL bar always reflects location.
    const path = "/" + page;
    const qs = window.location.search;
    if(window.location.pathname !== path) window.history.pushState({page}, "", path + qs);
  },[page, showAdmin]);
  useEffect(()=>{
    const onPop = (e) => { if(e.state?.page) setPage(e.state.page); else setPage("dashboard"); };
    window.addEventListener("popstate", onPop);
    const initPath = window.location.pathname.replace(/^\//,"") || "dashboard";
    if(pageTitle[initPath]) setPage(initPath);
    return ()=>window.removeEventListener("popstate", onPop);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  if(showAdmin) return <AdminPanel onExit={()=>setShowAdmin(false)}/>;

  const profileModal = showProfile && (
    <div style={S.modal} onClick={()=>{setShowProfile(false);cancelEditProfile();}}>
      <div style={{...S.modalBox,width:480,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{fontSize:18,fontWeight:600,color:C.ink}}>My Profile</div>
          <button onClick={()=>{setShowProfile(false);cancelEditProfile();}} style={{background:"none",border:"none",fontSize:22,cursor:"pointer",color:C.inkLight}}>X</button>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24,padding:"16px 0",borderBottom:`1px solid ${C.border}`}}>
          {profileData.avatar
            ?<img src={profileData.avatar} alt="" style={{width:56,height:56,borderRadius:"50%",objectFit:"cover",border:`2px solid ${C.border}`}} onError={e=>{e.target.style.display="none"}}/>
            :<div style={{width:56,height:56,borderRadius:"50%",background:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:600,color:C.blue}}>{profileInitials}</div>}
          <div>
            <div style={{fontSize:16,fontWeight:600,color:C.ink}}>{profileData.name}</div>
            <div style={{fontSize:12,color:C.inkMid}}>{profileData.contact}</div>
            <span style={{fontSize:10,fontWeight:500,padding:"2px 8px",borderRadius:8,background:C.tealLight,color:C.teal}}>{profileData.tier}</span>
          </div>
        </div>
        {!editingProfile ? (
          <div>
            <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:8}}>Business information</div>
            {profileData.refCode&&<div style={{background:C.blueLight,borderRadius:8,padding:"10px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div><div style={{fontSize:10,fontWeight:600,color:C.inkLight,textTransform:"uppercase",marginBottom:2}}>Your reference code</div><div style={{fontSize:15,fontWeight:700,fontFamily:"monospace",color:C.blue}}>{profileData.refCode}</div></div>
              <button style={{...S.btnSmall,fontSize:10}} onClick={()=>{navigator.clipboard.writeText(profileData.refCode);alert("Code copied!");}}>Copy</button>
            </div>}
            {[["Company",profileData.name],["Contact person",profileData.contact],["Email",profileData.email],["Phone",profileData.phone],["Address",profileData.address],["City",profileData.city],["State",profileData.state],["ZIP",profileData.zip],["EIN / Tax ID",profileData.ein||"--"],["Account tier",profileData.tier],["Assigned sales rep",profileData.rep||"Not assigned"]].map(([label,value])=>(
              <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                <span style={{fontSize:12,color:C.inkLight,fontWeight:500}}>{label}</span>
                <span style={{fontSize:12,color:C.ink,fontWeight:500}}>{value}</span>
              </div>
            ))}
            <div style={{display:"flex",gap:10,marginTop:20}}>
              <button onClick={()=>{setEditForm({...profileData});setEditingProfile(true);}} style={S.btnPrimary}>Edit Profile</button>
              <button onClick={onLogout} style={{background:C.redLight,color:C.red,border:"none",padding:"10px 20px",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer"}}>Sign Out</button>
            </div>
          </div>
        ) : (
          <div>
            <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:8}}>Profile picture</div>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              {editForm.avatar
                ?<img src={editForm.avatar} alt="" style={{width:56,height:56,borderRadius:"50%",objectFit:"cover",border:`2px solid ${C.border}`}} onError={e=>{e.target.style.display="none"}}/>
                :<div style={{width:56,height:56,borderRadius:"50%",background:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:600,color:C.blue}}>{profileInitials}</div>}
              <div>
                <label style={{...S.btnSmall,cursor:avatarState.kind==="uploading"?"wait":"pointer",display:"inline-block",opacity:avatarState.kind==="uploading"?0.6:1}}>
                  {avatarState.kind==="uploading" ? "Uploading…" : (editForm.avatar ? "Replace photo" : "Upload photo")}
                  <input type="file" accept="image/*" onChange={handleAvatarUpload} style={{display:"none"}} disabled={avatarState.kind==="uploading"}/>
                </label>
                {editForm.avatar&&avatarState.kind!=="uploading"&&<button style={{...S.btnDanger,marginLeft:6}} onClick={()=>setEditForm(f=>({...f,avatar:""}))}>Remove</button>}
                {avatarState.msg && <div style={{fontSize:11,marginTop:5,color:avatarState.kind==="error"?C.red:avatarState.kind==="success"?C.green:C.inkLight}}>{avatarState.msg}</div>}
              </div>
            </div>
            <div style={{fontSize:13,fontWeight:600,color:C.ink,marginBottom:8}}>Business information</div>
            {[["Company name","name"],["Contact person","contact"],["Email","email"],["Phone","phone"],["Address","address"],["City","city"],["State","state"],["ZIP","zip"],["EIN / Tax ID","ein"]].map(([label,key])=>(
              <div key={key} style={S.fg}>
                <label style={S.label}>{label}</label>
                <input style={S.input} value={editForm[key]||""} onChange={e=>setEditForm(f=>({...f,[key]:e.target.value}))}/>
              </div>
            ))}
            {/* Searchable sales rep selector */}
            <div style={{...S.fg,position:"relative"}}>
              <label style={S.label}>Assigned sales rep</label>
              <div style={{position:"relative"}}>
                <input style={S.input} value={custRepSearchOpen?custRepSearchQ:(editForm.rep||"")} placeholder="Search or select your sales rep…"
                  onFocus={()=>{setCustRepSearchOpen(true);setCustRepSearchQ(editForm.rep||"");}}
                  onChange={e=>{setCustRepSearchQ(e.target.value);setCustRepSearchOpen(true);}}
                  onBlur={()=>setTimeout(()=>setCustRepSearchOpen(false),200)}
                />
                {editForm.rep&&!custRepSearchOpen&&<span style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",cursor:"pointer",fontSize:14,color:C.inkLight,padding:"2px 6px"}} onClick={()=>{setEditForm(f=>({...f,rep:""}));setCustRepSearchQ("");setCustRepSearchOpen(false);}}>✕</span>}
              </div>
              {custRepSearchOpen&&(()=>{
                const q=custRepSearchQ.toLowerCase();
                const allRepProfiles=SHARED_REP_PROFILES.getAll?SHARED_REP_PROFILES.getAll():{};
                // Hide soft-deleted reps — admin removed the account but cached profile may still linger.
                let deletedKeys=new Set();
                try { const raw=localStorage.getItem("mpcare_deleted_reps"); if(raw) JSON.parse(raw).forEach(k=>deletedKeys.add(k)); } catch(e){}
                // Build set of demo rep emails so live profiles can REPLACE demo entries
                // when the admin renames a rep (e.g. "Marcus T." → "Narcus Thompson").
                const demoEmails=new Set(ADMIN_REP_DATA.map(r=>(r.email||"").toLowerCase()).filter(Boolean));
                // Collect live profile entries first — they win over demo data
                const liveByEmail={};
                const isInactiveRep=(r)=>!!r && ((r.email && inactiveRepKeys.emails.has(String(r.email).toLowerCase())) || inactiveRepKeys.names.has(String(r.name||"").trim().toLowerCase()));
                Object.values(allRepProfiles).forEach(r=>{
                  if(!r.name || (r.email && deletedKeys.has(r.email)) || isInactiveRep(r)) return;
                  if(r.email) liveByEmail[r.email.toLowerCase()]={name:r.name,email:r.email||"",territory:r.territory||""};
                });
                // Start with demo reps, but replace with live profile if one exists for the same email
                const allReps=ADMIN_REP_DATA.filter(r=>!deletedKeys.has(r.id)&&!deletedKeys.has(r.email)&&!isInactiveRep(r)).map(r=>{
                  const live=r.email && liveByEmail[r.email.toLowerCase()];
                  return live || {name:r.name,email:r.email,territory:r.territory};
                });
                // Add any live profiles not already covered by demo emails
                Object.values(liveByEmail).forEach(r=>{
                  if(!r.email || !demoEmails.has(r.email.toLowerCase())) allReps.push(r);
                });
                // De-dupe by email (preferred) or name
                const seen=new Set();
                const deduped=allReps.filter(r=>{const k=r.email?r.email.toLowerCase():(r.name||"").toLowerCase(); if(seen.has(k))return false; seen.add(k); return true;});
                const filtered=deduped.filter(r=>!q||r.name.toLowerCase().includes(q)||(r.email||"").toLowerCase().includes(q)||(r.territory||"").toLowerCase().includes(q));
                return <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:999,background:"#fff",border:`1px solid ${C.border}`,borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.12)",maxHeight:220,overflowY:"auto",marginTop:2}}>
                  <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",fontSize:13,color:C.inkLight}} onClick={()=>{setEditForm(f=>({...f,rep:""}));setCustRepSearchOpen(false);setCustRepSearchQ("");}}>
                    <em>No rep / Remove</em>
                  </div>
                  {filtered.length===0&&<div style={{padding:"12px",fontSize:12,color:C.inkLight,textAlign:"center"}}>No reps found</div>}
                  {filtered.map((r,i)=><div key={r.name+i} style={{padding:"8px 12px",cursor:"pointer",borderBottom:`1px solid ${C.bg}`,transition:"background 0.1s"}}
                    onMouseEnter={e=>e.currentTarget.style.background=C.blueLight}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                    onClick={()=>{setEditForm(f=>({...f,rep:r.name}));setCustRepSearchOpen(false);setCustRepSearchQ("");}}>
                    <div style={{fontSize:13,fontWeight:500,color:C.ink}}>{r.name}</div>
                    <div style={{fontSize:11,color:C.inkLight}}>{r.email}{r.territory?` · ${r.territory}`:""}</div>
                  </div>)}
                </div>;
              })()}
            </div>
            <div style={{display:"flex",gap:10,marginTop:16}}>
              <button onClick={saveProfile} style={S.btnPrimary}>Save Changes</button>
              <button onClick={cancelEditProfile} style={S.btnSecondary}>Cancel</button>
            </div>
          </div>
        )}
        {/* Login account — self-service auth email change. Shown whether or
            not the profile is being edited so the user can always get here. */}
        <div style={{marginTop:16}}>
          <ChangeLoginEmail user={user}/>
        </div>
      </div>
    </div>
  );

  return (
    <div style={S.app}>
      {profileModal}
      <div style={S.shell}>
        <Sidebar page={page} setPage={setPage} activeProd={activeProd} setActiveProd={setActiveProd} cartCount={cart.length} assignedRep={assignedRepInfo}/>
        <div style={S.main}>
          <div style={{...S.topbar,justifyContent:"space-between"}}>
            <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:C.inkLight}}>
              {crumbDefs?crumbDefs.map((c,i)=><span key={i}>{i>0&&<span style={{margin:"0 4px",opacity:0.4}}>›</span>}<span style={i===crumbDefs.length-1?{color:C.ink,fontWeight:500}:{cursor:"pointer",color:C.blue}} onClick={c.pg?()=>setPage(c.pg):undefined}>{c.label}</span></span>):<span style={{fontSize:15,fontWeight:600,color:C.ink}}>{pageTitle[page]}</span>}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              {userRole==="admin" && <button onClick={()=>setShowAdmin(true)} style={{fontSize:11,padding:"4px 10px",borderRadius:6,border:`1px solid ${C.border}`,background:C.surface,color:C.inkMid,cursor:"pointer"}}>Admin panel →</button>}
              <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:C.inkMid,cursor:"pointer",padding:"4px 10px",borderRadius:8,border:`1px solid transparent`,transition:"all 0.15s"}} onClick={()=>setShowProfile(true)} onMouseEnter={e=>{e.currentTarget.style.background=C.blueLight;e.currentTarget.style.borderColor=C.border;}} onMouseLeave={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor="transparent";}}>
                {profileData.avatar
                  ?<img src={profileData.avatar} alt="" style={{width:28,height:28,borderRadius:"50%",objectFit:"cover"}} onError={e=>{e.target.style.display="none"}}/>
                  :<div style={{width:28,height:28,borderRadius:"50%",background:C.blueLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:600,color:C.blue}}>{profileInitials}</div>}
                <span>{profileData.name}</span>
                <span style={{fontSize:10,fontWeight:500,padding:"2px 8px",borderRadius:8,background:C.tealLight,color:C.teal}}>{profileData.tier}</span>
                <span style={{fontSize:14,color:C.inkLight,marginLeft:2}}>▾</span>
              </div>
            </div>
          </div>
          {materialOrderSyncPendingIds.length > 0 && (
            <div style={{margin:"12px 0", padding:"10px 14px", background:"#FEF3C7", border:"1px solid #F59E0B", borderRadius:8, display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"#92400E"}}>
              <div style={{flex:1}}>
                <strong>{materialOrderSyncPendingIds.length === 1 ? "1 marketing-material order" : `${materialOrderSyncPendingIds.length} marketing-material orders`} placed on this device but cloud sync is pending.</strong>{" "}
                Admin won't see {materialOrderSyncPendingIds.length === 1 ? "it" : "them"} in fulfillment until sync succeeds. Will retry automatically.
              </div>
              <button
                onClick={() => setMaterialOrderSyncPendingIds([])}
                style={{marginLeft:12, background:"transparent", border:"1px solid #F59E0B", color:"#92400E", fontSize:11, padding:"4px 10px", borderRadius:6, cursor:"pointer"}}
              >Dismiss</button>
            </div>
          )}
          {page==="dashboard"        &&<Dashboard setPage={setPage} setActiveProd={setActiveProd} onAddToCart={addToCart} cart={cart} isDemo={isDemo} customerName={profileData.name} creditLimit={profileData.creditLimit||0} customerTier={profileData.tier||""} userId={user?.id||""}/>}
          {page==="catalog"          &&<ProductCatalog onSelectProduct={(p)=>{setActiveProd(p);setPage("product");}} onAddToCart={addToCart}/>}
          {page==="product"          &&<ProductDetail product={activeProd} onAddToCart={addToCart} onSelectProduct={(p)=>{setActiveProd(p);setPage("product");}}/>}
          {page==="orders"           &&<Orders setPage={setPage} isDemo={isDemo} customerName={profileData.name} userId={user?.id||""} onViewInvoice={(invId)=>{setHighlightInvoice(invId);setPage("invoices");}}/>}
          {page==="cart"             &&<Cart cart={cart} setCart={setCart} setPage={setPage}/>}
          {page==="checkout"         &&<Checkout cart={cart} setPage={setPage} setCart={setCart} customerDiscount={customerDiscount} salesRep={profileData.rep||""} customerName={profileData.name} customerEmail={profileData.email||""} repEmail={assignedRepInfo?.email||""} userId={user?.id||""} customerProfile={profileData} approvedTerms={approvedTerms}/>}
          {page==="invoices"         &&<Invoices isDemo={isDemo} customerName={profileData.name} userId={user?.id||""} highlightId={highlightInvoice} onClearHighlight={()=>setHighlightInvoice(null)} customerProfile={profileData} approvedTerms={approvedTerms}/>}
          {page==="cust-training"    &&<CustomerTraining/>}
          {page==="cust-marketing"   &&<CustomerMarketing customerName={profileData.name} userId={user?.id||""} onMaterialOrderSyncPending={markMaterialOrderSyncPending}/>}
          {page==="cust-tools"       &&<CustomerTools/>}
          {/* profile/session passed so certificates print the dealer's real
              company name. ShopCertification reads profile?.company (falls
              back to session?.user?.user_metadata?.company, then "Your
              shop") — profileData here stores the company under `.name`
              (see the "Company" field label above), so it's remapped here
              rather than changing ShopCertification's prop contract. Was
              previously rendered with no props at all, so every dealer's
              printed certificate showed the literal "Your shop". */}
          {page==="cust-team"        &&<ShopCertification profile={{company:profileData.name}} session={{user}}/>}
        </div>
      </div>
    </div>
  );
}

// ── TERMS & CONDITIONS ────────────────────────────────────────────────────────
// Content is admin-editable via Settings tab → "Signup & Terms" card.
// Lives in portalSettings.js (Supabase-synced) with hardcoded fallbacks so
// customers never see blank legal copy during a fresh-deploy hydration race.

function TermsModal({onAccept, onDecline}) {
  const [scrolled, setScrolled] = useState(false);
  const [checked, setChecked] = useState(false);
  const [settings, setSettings] = useState(() => PORTAL_SETTINGS.get());
  // Re-render if admin saves updated terms while this modal is open.
  useEffect(() => PORTAL_SETTINGS.subscribe(setSettings), []);
  const today = new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});

  const handleScroll = (e) => {
    const el = e.target;
    if(el.scrollTop + el.clientHeight >= el.scrollHeight - 50) setScrolled(true);
  };

  const sections = Array.isArray(settings.termsSections) && settings.termsSections.length > 0
    ? settings.termsSections
    : [];

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:3000,padding:20}}>
      <div style={{background:C.white,borderRadius:16,width:"100%",maxWidth:680,maxHeight:"90vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
        {/* Header */}
        <div style={{background:C.navy,padding:"18px 24px",flexShrink:0}}>
          <div style={{fontSize:16,fontWeight:600,color:C.white}}>{settings.termsTitle}</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.6)",marginTop:3}}>Please read the full agreement before creating your account. Effective date: {today}</div>
        </div>

        {/* Scrollable content */}
        <div onScroll={handleScroll} style={{flex:1,overflowY:"auto",padding:"24px 28px"}}>
          <div style={{fontSize:12,color:C.inkMid,lineHeight:1.7,marginBottom:20,padding:"10px 14px",background:C.amberLight,borderRadius:8,border:`1px solid #FCD34D`}}>
            {settings.termsIntroNote}
          </div>
          {sections.map((s,i)=>(
            <div key={(s?.title||"")+i} style={{marginBottom:20}}>
              <div style={{fontSize:13,fontWeight:600,color:C.navy,marginBottom:6}}>{s?.title}</div>
              <div style={{fontSize:12,color:C.inkMid,lineHeight:1.8,whiteSpace:"pre-wrap"}}>{s?.text}</div>
            </div>
          ))}
          {!scrolled && (
            <div style={{textAlign:"center",padding:"12px",fontSize:12,color:C.inkLight,fontStyle:"italic"}}>↓ Scroll to the bottom to accept</div>
          )}
        </div>

        {/* Footer */}
        <div style={{padding:"16px 24px",borderTop:`1px solid ${C.border}`,flexShrink:0,background:C.surface}}>
          <label style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:14,cursor:scrolled?"pointer":"not-allowed",opacity:scrolled?1:0.5}}>
            <input type="checkbox" checked={checked} disabled={!scrolled} onChange={e=>setChecked(e.target.checked)} style={{width:16,height:16,marginTop:2,accentColor:C.blue}}/>
            <span style={{fontSize:12,color:C.inkMid,lineHeight:1.6}}>
              {settings.termsAcceptLine}
            </span>
          </label>
          <div style={{display:"flex",gap:10}}>
            <button onClick={onDecline} style={{...S.btnSecondary,flex:1}}>Decline</button>
            <button onClick={onAccept} disabled={!checked||!scrolled} style={{...S.btnPrimary,flex:1,opacity:checked&&scrolled?1:0.5,cursor:checked&&scrolled?"pointer":"not-allowed"}}>
              I accept — Create my account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── LOGIN PAGE ─────────────────────────────────────────────────────────────────
function LoginPage({onLogin}) {
  // mode: "choose" (portal picker) | "login" | "forgot" (send reset email)
  //       | "reset" (set new password after clicking email link)
  const [mode, setMode] = useState("choose");
  const [portalType, setPortalType] = useState("");
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [error,setError]=useState("");
  // Per-field error flags so inputs can highlight red + show a per-field hint.
  const [fieldErr,setFieldErr]=useState({ email:false, password:false });
  const [loading,setLoading]=useState(false);
  // Forgot-password submit state.
  const [forgotSent,setForgotSent]=useState(false);
  // Reset-flow state — populated when user lands back from the recovery email.
  const [newPw, setNewPw] = useState("");
  const [newPw2, setNewPw2] = useState("");

  // Supabase's recovery email lands here with a token in the URL hash. The
  // auth client picks it up on mount and fires a PASSWORD_RECOVERY event.
  // When we see it, switch to the reset form so the user can set a new one.
  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if(event === "PASSWORD_RECOVERY") {
        setMode("reset"); setError(""); setFieldErr({email:false,password:false});
      }
    });
    // Also respect ?reset=1 query flag as a fallback for single-page-app routing.
    try {
      const qs = new URLSearchParams(window.location.search);
      if(qs.get("reset") === "1") setMode("reset");
    } catch(e) {}
    return () => { try { sub.subscription.unsubscribe(); } catch(e) {} };
  }, []);

  const handleLogin = async () => {
    const miss = { email: !email.trim(), password: !password };
    if(miss.email || miss.password) {
      setFieldErr(miss);
      setError(miss.email && miss.password ? "Enter your email and password." : miss.email ? "Enter your email." : "Enter your password.");
      return;
    }
    setFieldErr({email:false,password:false});
    setLoading(true); setError("");
    try {
      const data = await signIn({ email: email.trim().toLowerCase(), password });
      const profile = await getProfile(data.user.id);
      if(!profile) throw new Error("Account not found.");
      // Suspended accounts (paused or deleted by admin): rejected=true on the
      // profile is the authoritative signal the admin flipped. Show a distinct
      // message so the user doesn't think it's "pending approval".
      const suspended = profile.rejected === true || isBlockedStatus(profile.status);
      if(suspended) {
        // Sign back out so Supabase doesn't leave a half-authenticated session dangling.
        try { await signOut(); } catch(e) {}
        throw new Error("Your account has been suspended. Please contact MotorPower Care.");
      }
      if(!profile.approved) throw new Error("Your account is pending approval. Please contact MotorPower Care.");
      if(portalType==="customer" && profile.role!=="customer") throw new Error("This account is not a customer account.");
      if(portalType==="rep" && profile.role!=="rep") throw new Error("This account is not a sales rep account.");
      if(portalType==="admin" && profile.role!=="admin") throw new Error("This account does not have admin access.");
      const sess = { ...data.user, role: profile.role, name: profile.full_name, profile };
      // Push profile to shared store so all portals see it
      const meta = data.user.user_metadata || {};
      if(profile.role === "rep") {
        SHARED_REP_PROFILES.set(data.user.id, {
          name: profile.full_name || meta.full_name || "",
          email: profile.email || data.user.email || "",
          phone: profile.phone || meta.phone || "",
          territory: profile.address || meta.address || "",
          refCode: profile.ref_code || meta.ref_code || ""
        });
      } else if(profile.role === "customer") {
        // FIX (2026-04-20): only include rep key when we have a non-empty
        // value. Writing rep:"" here fired the subscriber with updated.rep=""
        // which the Portal component's customer-profile merge treated as
        // "clear the rep" → sidebar flipped to "Not yet assigned" until
        // refresh. SHARED_CUSTOMER_PROFILES.set merges on top of existing
        // entry, so omitting the rep key leaves any prior rep untouched.
        const resolvedRep = profile.rep || meta.rep || "";
        const customerPayload = {
          company: profile.company || meta.company || "",
          contact: profile.full_name || meta.full_name || "",
          email: profile.email || data.user.email || "",
          phone: profile.phone || meta.phone || "",
          address: profile.address || meta.address || "",
          ein: profile.ein || meta.ein || "",
          tier: profile.tier || meta.tier || "dealer",
          refCode: profile.ref_code || meta.ref_code || "",
        };
        if (resolvedRep) customerPayload.rep = resolvedRep;
        SHARED_CUSTOMER_PROFILES.set(data.user.id, customerPayload);
      }
      onLogin(sess);
    } catch(err) {
      // Map common Supabase errors to friendlier copy + per-field highlights.
      const raw = err?.message || "";
      if(/invalid.*credentials|invalid.*password|invalid login/i.test(raw)) {
        setFieldErr({email:true,password:true});
        setError("Email or password is incorrect. Try again or reset your password.");
      } else if(/email.*confirm|not confirmed/i.test(raw)) {
        setFieldErr({email:true,password:false});
        setError("This email hasn't been confirmed yet. Check your inbox for the confirmation link.");
      } else if(/too many requests|rate limit/i.test(raw)) {
        setError("Too many login attempts. Wait a minute and try again.");
      } else {
        setError(raw || "Login failed. Please check your credentials.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleForgotSubmit = async () => {
    if(!email.trim()) {
      setFieldErr(f => ({...f, email:true}));
      setError("Enter the email you used to sign up.");
      return;
    }
    setFieldErr({email:false,password:false});
    setLoading(true); setError("");
    try {
      await sendPasswordReset(email.trim().toLowerCase());
      setForgotSent(true);
    } catch(err) {
      setError(err?.message || "Could not send reset email. Try again.");
    } finally { setLoading(false); }
  };

  const handleResetSubmit = async () => {
    if(!newPw || newPw.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if(newPw !== newPw2) {
      setError("Passwords don't match.");
      return;
    }
    setLoading(true); setError("");
    try {
      await updatePassword(newPw);
      // Clean the ?reset=1 off the URL so a refresh doesn't loop the user back.
      try { window.history.replaceState({}, "", window.location.pathname); } catch(e) {}
      // Sign out so the next login attempt uses the new password end-to-end.
      try { await signOut(); } catch(e) {}
      setMode("choose"); setNewPw(""); setNewPw2(""); setError("");
      alert("Password updated. Sign in with your new password.");
    } catch(err) {
      setError(err?.message || "Could not update password.");
    } finally { setLoading(false); }
  };

  const portalOptions = [
    {key:"customer", label:"Customer / Distributor", desc:"Place orders, view invoices, manage your account", icon:"🏪", color:C.blue, bg:C.blueLight},
    {key:"rep",      label:"Sales Rep portal",        desc:"Manage inventory, create invoices, track commission", icon:"💼", color:C.teal, bg:C.tealLight},
    {key:"admin",    label:"Admin panel",              desc:"Full control — accounts, orders, products, team", icon:"⚙️", color:"#5B21B6", bg:"#EDE9FE"},
  ];

  // Step 1 — choose portal type
  if(mode==="choose") return (
    <div style={{minHeight:"100vh",display:"flex",background:`linear-gradient(135deg,#0B1F3A 0%,#12305A 60%,#1a3a6b 100%)`,alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{width:"100%",maxWidth:520}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <img src="/mpc-logo.png" alt="MotorPower Care" style={{width:100,height:"auto",marginBottom:12,objectFit:"contain"}}/>
          <div style={{fontSize:30,fontWeight:700,color:C.white,marginBottom:8}}>Welcome back</div>
          <div style={{fontSize:14,color:"rgba(255,255,255,0.6)"}}>Select your portal to sign in</div>
        </div>
        {portalOptions.map(p=>(
          <div key={p.key} onClick={()=>{setPortalType(p.key);setMode("login");}} style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:12,padding:"16px 20px",marginBottom:10,cursor:"pointer",display:"flex",alignItems:"center",gap:14,transition:"all 0.15s"}}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.12)"}
            onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
          >
            <div style={{width:44,height:44,borderRadius:10,background:p.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{p.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:600,color:C.white,marginBottom:3}}>{p.label}</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,0.5)"}}>{p.desc}</div>
            </div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:18}}>›</div>
          </div>
        ))}
        <div style={{textAlign:"center",marginTop:24,fontSize:13,color:"rgba(255,255,255,0.45)"}}>
          New to wholesale? <span style={{color:"rgba(100,160,255,0.9)",cursor:"pointer",fontWeight:500}} onClick={()=>onLogin({role:"signup",signupFrom:"customer"})}>Apply for an account →</span>
        </div>
      </div>
    </div>
  );

  // Reusable styles that react to field-level error flags.
  const inputBaseStyle = { width:"100%", padding:"10px 12px", border:"1px solid #E2E8F0", borderRadius:8, fontSize:13, outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" };
  const inputErrStyle  = { ...inputBaseStyle, borderColor:"#EF4444", background:"#FEF2F2" };

  // Step 3 — reset password (after clicking the email link)
  if(mode==="reset") return (
    <div style={{minHeight:"100vh",display:"flex",background:`linear-gradient(135deg,#0B1F3A 0%,#12305A 60%,#1a3a6b 100%)`,alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:C.white,borderRadius:16,padding:"36px 40px",width:"100%",maxWidth:420}}>
        <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:6}}>Set a new password</div>
        <div style={{fontSize:12,color:C.inkLight,marginBottom:20}}>Choose a password you'll remember. You'll use it to sign in next time.</div>
        {error&&<div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#B91C1C",marginBottom:14}}>{error}</div>}
        <div style={{marginBottom:14}}>
          <label style={{display:"block",fontSize:12,fontWeight:500,color:"#334155",marginBottom:5}}>New password</label>
          <input style={inputBaseStyle} type="password" value={newPw} onChange={e=>{setNewPw(e.target.value);setError("");}} placeholder="At least 6 characters"/>
        </div>
        <div style={{marginBottom:20}}>
          <label style={{display:"block",fontSize:12,fontWeight:500,color:"#334155",marginBottom:5}}>Confirm new password</label>
          <input style={inputBaseStyle} type="password" value={newPw2} onChange={e=>{setNewPw2(e.target.value);setError("");}} placeholder="Type it again" onKeyDown={e=>e.key==="Enter"&&handleResetSubmit()}/>
        </div>
        <button style={{width:"100%",background:loading?"#94A3B8":C.blue,color:"white",border:"none",padding:"12px",borderRadius:8,fontSize:14,fontWeight:500,cursor:loading?"not-allowed":"pointer"}} onClick={handleResetSubmit} disabled={loading}>{loading?"Updating…":"Update password →"}</button>
      </div>
    </div>
  );

  // Step 2b — forgot password (request reset email)
  if(mode==="forgot") {
    const selected = portalOptions.find(p=>p.key===portalType);
    return (
      <div style={{minHeight:"100vh",display:"flex",background:`linear-gradient(135deg,#0B1F3A 0%,#12305A 60%,#1a3a6b 100%)`,alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{background:C.white,borderRadius:16,padding:"36px 40px",width:"100%",maxWidth:420}}>
          <button onClick={()=>{setMode("login");setError("");setForgotSent(false);setFieldErr({email:false,password:false});}} style={{background:"none",border:"none",color:C.inkLight,fontSize:12,cursor:"pointer",marginBottom:16,padding:0,display:"flex",alignItems:"center",gap:4}}>← Back to sign in</button>
          <div style={{fontSize:18,fontWeight:600,color:C.ink,marginBottom:6}}>Reset your password</div>
          {!forgotSent ? (
            <>
              <div style={{fontSize:12,color:C.inkLight,marginBottom:20}}>Enter the email you used to sign up. We'll email you a secure link to set a new password.</div>
              {error&&<div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#B91C1C",marginBottom:14}}>{error}</div>}
              <div style={{marginBottom:20}}>
                <label style={{display:"block",fontSize:12,fontWeight:500,color:"#334155",marginBottom:5}}>Email</label>
                <input style={fieldErr.email?inputErrStyle:inputBaseStyle} type="email" value={email} onChange={e=>{setEmail(e.target.value);setError("");setFieldErr(f=>({...f,email:false}));}} placeholder="you@company.com" onKeyDown={e=>e.key==="Enter"&&handleForgotSubmit()}/>
              </div>
              <button style={{width:"100%",background:loading?"#94A3B8":selected?.color||C.blue,color:"white",border:"none",padding:"12px",borderRadius:8,fontSize:14,fontWeight:500,cursor:loading?"not-allowed":"pointer"}} onClick={handleForgotSubmit} disabled={loading}>{loading?"Sending…":"Send reset link →"}</button>
            </>
          ) : (
            <div style={{background:"#D1FAE5",border:"1px solid #6EE7B7",borderRadius:10,padding:"14px 16px"}}>
              <div style={{fontSize:13,fontWeight:600,color:"#047857",marginBottom:4}}>Check your email</div>
              <div style={{fontSize:12,color:"#065F46",lineHeight:1.6}}>We sent a password-reset link to <strong>{email}</strong>. Click it to set a new password. The link expires in 1 hour.</div>
              <button style={{marginTop:10,width:"100%",background:C.blue,color:"white",border:"none",padding:"10px",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer"}} onClick={()=>{setMode("login");setForgotSent(false);setError("");}}>Back to sign in</button>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Step 2 — login form
  const selected = portalOptions.find(p=>p.key===portalType);
  return (
    <div style={{minHeight:"100vh",display:"flex",background:`linear-gradient(135deg,#0B1F3A 0%,#12305A 60%,#1a3a6b 100%)`,alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:C.white,borderRadius:16,padding:"36px 40px",width:"100%",maxWidth:420}}>
        <button onClick={()=>{setMode("choose");setError("");setFieldErr({email:false,password:false});}} style={{background:"none",border:"none",color:C.inkLight,fontSize:12,cursor:"pointer",marginBottom:16,padding:0,display:"flex",alignItems:"center",gap:4}}>← Back</button>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
          <div style={{width:40,height:40,borderRadius:10,background:selected?.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{selected?.icon}</div>
          <div>
            <div style={{fontSize:16,fontWeight:600,color:C.ink}}>{selected?.label}</div>
            <div style={{fontSize:12,color:C.inkLight}}>Sign in to your account</div>
          </div>
        </div>
        {error&&<div style={{background:"#FEE2E2",border:"1px solid #FCA5A5",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#B91C1C",marginBottom:14}}>{error}</div>}
        <div style={{marginBottom:14}}>
          <label style={{display:"block",fontSize:12,fontWeight:500,color:"#334155",marginBottom:5}}>Email</label>
          <input style={fieldErr.email?inputErrStyle:inputBaseStyle} value={email} onChange={e=>{setEmail(e.target.value);setError("");setFieldErr(f=>({...f,email:false}));}} placeholder="you@company.com" onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
        </div>
        <div style={{marginBottom:10}}>
          <label style={{display:"block",fontSize:12,fontWeight:500,color:"#334155",marginBottom:5}}>Password</label>
          <input style={fieldErr.password?inputErrStyle:inputBaseStyle} type="password" value={password} onChange={e=>{setPassword(e.target.value);setError("");setFieldErr(f=>({...f,password:false}));}} placeholder="••••••••" onKeyDown={e=>e.key==="Enter"&&handleLogin()}/>
        </div>
        <div style={{textAlign:"right",marginBottom:16}}>
          <span style={{fontSize:12,color:C.blue,cursor:"pointer",fontWeight:500}} onClick={()=>{setMode("forgot");setError("");setForgotSent(false);setFieldErr({email:false,password:false});}}>Forgot password?</span>
        </div>
        <button style={{width:"100%",background:loading?"#94A3B8":selected?.color||C.blue,color:"white",border:"none",padding:"12px",borderRadius:8,fontSize:14,fontWeight:500,cursor:loading?"not-allowed":"pointer"}} onClick={handleLogin} disabled={loading}>{loading?"Signing in...":"Sign in →"}</button>
        {(portalType==="customer"||portalType==="rep")&&(
          <div style={{marginTop:14,textAlign:"center",fontSize:12,color:"#64748B"}}>
            {portalType==="rep"?"Want to join our sales team?":"New to wholesale?"} <span style={{color:C.blue,cursor:"pointer"}} onClick={()=>onLogin({role:"signup",signupFrom:portalType})}>Apply for an account →</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default function App() {
  // Dev bypass: ?dev=customer|rep|admin skips auth for testing
  const devRole = new URLSearchParams(window.location.search).get("dev");
  const [session,setSession]=useState(()=>{
    if(devRole==="customer") return {role:"customer",name:"Dev Customer"};
    if(devRole==="rep") return {role:"rep",name:"Dev Rep"};
    if(devRole==="admin") return {role:"admin",name:"Dev Admin"};
    return null;
  });
  const [loading,setLoading]=useState(devRole?false:true);
  const [showTC, setShowTC] = useState(false);
  const [pendingSignup, setPendingSignup] = useState(false);
  const [signupFrom, setSignupFrom] = useState("customer");

  // Hydrate product + kit catalog from Supabase on app start so every browser /
  // device sees the admin's latest edits (names, prices, image URLs, new SKUs).
  // Supabase is the ONLY source of truth — we do NOT timestamp-gate against
  // localStorage. The old timestamp comparison was buggy: SHARED_PRODUCTS
  // persists an updated `savedAt` every time setProducts runs (including on
  // customer-portal mount from its own cache warm-up), so `localTs` almost
  // always raced ahead of `remoteTs` and Supabase updates were silently skipped
  // on every page load.
  //
  // If Supabase returns empty (brand-new project, admin hasn't seeded yet), we
  // leave SHARED_PRODUCTS alone — the in-memory cache from sharedProducts.js
  // (warmed from localStorage at module load) is the best we can show until
  // the admin does the one-time seed.
  useEffect(() => {
    let mounted = true;
    // Catalog hydrate — extracted to a callable so the realtime listener below
    // can re-hydrate on every admin save. Without the listener, a rep or
    // customer who had their tab open BEFORE admin updated a price would keep
    // seeing the old price until they refreshed, because SHARED_PRODUCTS only
    // reloaded on App mount. The subscription closes that staleness window:
    // any UPDATE/INSERT on portal_products triggers a re-fetch and re-pushes
    // into SHARED_PRODUCTS, which fans out to every subscriber (rep invoice
    // form, customer catalog, admin product editor) on every open device.
    // No write path here — listener-only.
    const hydrateCatalog = () => {
      getPortalProducts().then(remote => {
        if (!mounted || !remote) return;
        if (Array.isArray(remote.products) && remote.products.length > 0) {
          SHARED_PRODUCTS.setProducts(remote.products);
        }
        if (Array.isArray(remote.kits) && remote.kits.length > 0) {
          SHARED_PRODUCTS.setKits(remote.kits);
        }
      }).catch(e => { console.warn("[App] catalog hydration failed:", e?.message || e); });
    };
    hydrateCatalog();
    const unsubPortalProducts = subscribePortalProducts(() => {
      if (mounted) hydrateCatalog();
    });
    // Hydrate portal content (terms, signup copy, tier descriptions) so
    // anonymous signup visitors see admin's latest edits. Fire-and-forget —
    // defaults render until this resolves.
    PORTAL_SETTINGS.hydrate().catch(e => { console.warn("[App] portal settings hydration failed:", e?.message || e); });
    // Hydrate companyInfo localStorage cache from Supabase so rep + customer
    // portal readers (getMpcInfo at top of this file, RepPortal's helper, the
    // AdminPanel state-init) pick up admin's latest company/payment details
    // on every boot — not just the admin's own browser. Per-Decision-2 of
    // PR-A: Supabase wins, any local draft is overwritten on next mount.
    // No-op when Supabase has no companyInfo yet (first deploy) — the
    // existing mpcare_company_info draft stays as-is until admin clicks
    // Save, which then pushes it up.
    getPortalSettings().then(s => {
      if (!mounted) return;
      if (s && s.companyInfo && typeof s.companyInfo === 'object') {
        try { localStorage.setItem("mpcare_company_info", JSON.stringify(s.companyInfo)); }
        catch(e) { console.warn("[App] companyInfo cache mirror failed:", e?.message || e); }
      }
      // Hydrate shipping from Supabase → SHARED_SETTINGS (PR-B). This
      // broadcasts to every reader of SHARED_SETTINGS.getShipping() /
      // .calcShipping() — customer dashboard, customer checkout, admin
      // Settings preview, admin AdminPanel form — and mirrors to the
      // existing mpcare_shared_settings localStorage cache for the next
      // cold boot. Per PR-B Decision-2: Supabase wins over the local
      // shipping draft on every mount; this is the overwrite path.
      // No-op when Supabase has no shipping yet (first deploy) — the
      // localStorage-initialized defaults in SHARED_SETTINGS stay as-is
      // until admin clicks Save, which then pushes them up.
      if (s && s.shipping && typeof s.shipping === 'object') {
        try { SHARED_SETTINGS.setShipping(s.shipping); }
        catch(e) { console.warn("[App] shipping hydrate failed:", e?.message || e); }
      }
    }).catch(e => { console.warn("[App] portal settings hydration failed:", e?.message || e); });
    return () => {
      mounted = false;
      try { if (unsubPortalProducts) unsubPortalProducts(); }
      catch (e) { console.warn("[App] portal_products unsubscribe failed:", e?.message || e); }
    };
  }, []);

  // Hydrate SHARED_REP_CUSTOMERS from Supabase rep_route_customers on App
  // mount, plus subscribe to realtime so admin's Reps tab sees rep adds /
  // edits / removals within seconds. Phase A migration originally landed
  // the rep portal's read of rep_route_customers but missed the admin's
  // read path — admin used to see only this browser's localStorage cache,
  // which was empty for any rep whose route-planner edits happened on a
  // different device (so admin saw "0 customers" for reps who genuinely
  // had 20+).
  //
  // RLS auto-narrows: admin sees every rep's rows; a rep sees their own
  // rows; a customer sees nothing. So the same hydrate / subscribe runs
  // safely for any signed-in user — non-admin callers just see a smaller
  // result. SHARED_REP_CUSTOMERS.set merges incoming over existing
  // localStorage entries, so anything already cached is preserved unless
  // Supabase has fresher data for the same rep.
  //
  // The subscribe path coalesces all event types into a full re-fetch —
  // simpler than diffing single events and rep_route_customers is small.
  useEffect(() => {
    let mounted = true;
    const hydrate = async () => {
      try {
        const rows = await listAllRepRouteCustomers();
        if (!mounted) return;
        const byRep = {};
        (rows || []).forEach(r => {
          const repName = r && r.rep_name ? String(r.rep_name) : "";
          if (!repName) return;
          if (!byRep[repName]) byRep[repName] = { customers: [], prospects: [] };
          const data = (r.customer_data && typeof r.customer_data === 'object') ? r.customer_data : {};
          if (r.is_prospect) byRep[repName].prospects.push(data);
          else               byRep[repName].customers.push(data);
        });
        Object.keys(byRep).forEach(repName => {
          try { SHARED_REP_CUSTOMERS.set(repName, byRep[repName]); }
          catch(e) { console.warn("[App] SHARED_REP_CUSTOMERS.set failed for", repName, ":", e?.message || e); }
        });
      } catch (e) {
        console.warn("[App] rep_route_customers hydrate failed:", e?.message || e);
      }
    };
    hydrate();
    const unsub = subscribeAllRepRouteCustomers(() => {
      if (!mounted) return;
      hydrate();
    });
    return () => {
      mounted = false;
      if (typeof unsub === 'function') unsub();
    };
  }, []);

  // Listen for Supabase auth state changes
  useEffect(()=>{
    if(devRole) return; // skip auth in dev mode
    const { data: { subscription } } = onAuthStateChange(async (sess) => {
      if(sess?.user) {
        try {
          const profile = await getProfile(sess.user.id);
          // Mid-session suspension: if the admin paused/deleted this user while they
          // were signed in, their token is still valid but we must kick them back to
          // the login screen so the LoginPage can surface the "contact MotorPower Care"
          // message on the next sign-in attempt.
          const suspended = profile?.rejected === true || isBlockedStatus(profile?.status);
          if(suspended) {
            try { await signOut(); } catch(e) {}
            setSession(null);
            setLoading(false);
            return;
          }
          if(profile?.approved) {
            setSession({ ...sess.user, role: profile.role, name: profile.full_name, profile });
            // Push profile to shared store on session restore
            const meta = sess.user.user_metadata || {};
            if(profile.role === "rep") {
              SHARED_REP_PROFILES.set(sess.user.id, {
                name: profile.full_name || meta.full_name || "",
                email: profile.email || sess.user.email || "",
                phone: profile.phone || meta.phone || "",
                territory: profile.address || meta.address || "",
                refCode: profile.ref_code || meta.ref_code || ""
              });
            } else if(profile.role === "customer") {
              // IMPORTANT: preserve localStorage rep if Supabase returns empty — admin/dealer may have set it locally
              const existingCustomer = SHARED_CUSTOMER_PROFILES.get(sess.user.id);
              // FIX (2026-04-20): only include rep key when we have a
              // non-empty value. See matching fix in the signIn path above
              // + the subscriber in the Portal component. Writing rep:""
              // from this auth-state-change handler fired the subscriber
              // on every token refresh and cleared the rep in the sidebar.
              const resolvedRepRefresh = profile.rep || meta.rep || existingCustomer?.rep || "";
              const refreshPayload = {
                company: profile.company || meta.company || "",
                contact: profile.full_name || meta.full_name || "",
                email: profile.email || sess.user.email || "",
                phone: profile.phone || meta.phone || "",
                address: profile.address || meta.address || "",
                ein: profile.ein || meta.ein || "",
                tier: profile.tier || meta.tier || "dealer",
                refCode: profile.ref_code || meta.ref_code || "",
              };
              if (resolvedRepRefresh) refreshPayload.rep = resolvedRepRefresh;
              SHARED_CUSTOMER_PROFILES.set(sess.user.id, refreshPayload);
            }
          } else {
            setSession(null);
          }
        } catch {
          setSession(null);
        }
      } else {
        setSession(null);
      }
      setLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  const logout = async () => {
    await signOut();
    setSession(null);
  };

  if(loading) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:"#0B1F3A"}}>
      <div style={{textAlign:"center",color:"white"}}>
        <img src="/mpc-logo.png" alt="MotorPower Care" style={{width:80,height:"auto",marginBottom:8,objectFit:"contain"}}/>
        <div style={{fontSize:16,fontWeight:600}}>MotorPower Care</div>
        <div style={{fontSize:12,opacity:0.6,marginTop:4}}>Loading portal...</div>
      </div>
    </div>
  );

  if(!session && !pendingSignup) return (
    <>
      {showTC && <TermsModal onAccept={()=>{setShowTC(false);setPendingSignup(true);}} onDecline={()=>setShowTC(false)}/>}
      <LoginPage onLogin={(acct)=>{
        if(acct.role==="signup"){ setSignupFrom(acct.signupFrom==="rep"?"rep":"customer"); setShowTC(true); }
        else setSession(acct);
      }}/>
    </>
  );

  if(pendingSignup) return <SignupPage initialRole={signupFrom} onSubmit={()=>{setPendingSignup(false);setSession(null);}}/>;

  if(session?.role==="signup") return <SignupPage initialRole={signupFrom} onSubmit={()=>setSession(null)}/>;

  if(session?.role==="rep") return <RepPortal onExit={logout} onSignOut={logout} user={session}/>;

  if(session?.role==="admin") return <AdminPanel onExit={logout} onLogout={logout} user={session}/>;

  return <Portal onLogout={logout} userRole={session?.role} user={session}/>;
}
